/*! For license information please see main.js.LICENSE.txt */
if (
    ((() => {
        var __webpack_modules__ = {
                248: function (module, exports, __webpack_require__) {
                    var factory;
                    "undefined" != typeof navigator &&
                        ((factory = function () {
                            "use strict";
                            var svgNS = "http://www.w3.org/2000/svg",
                                locationHref = "",
                                _useWebWorker = !1,
                                initialDefaultFrame = -999999,
                                setWebWorker = function (t) {
                                    _useWebWorker = !!t;
                                },
                                getWebWorker = function () {
                                    return _useWebWorker;
                                },
                                setLocationHref = function (t) {
                                    locationHref = t;
                                },
                                getLocationHref = function () {
                                    return locationHref;
                                };
                            function createTag(t) {
                                return document.createElement(t);
                            }
                            function extendPrototype(t, e) {
                                var r,
                                    i,
                                    n = t.length;
                                for (r = 0; r < n; r += 1)
                                    for (var s in (i = t[r].prototype))
                                        Object.prototype.hasOwnProperty.call(i, s) && (e.prototype[s] = i[s]);
                            }
                            function getDescriptor(t, e) {
                                return Object.getOwnPropertyDescriptor(t, e);
                            }
                            function createProxyFunction(t) {
                                function e() {}
                                return (e.prototype = t), e;
                            }
                            var audioControllerFactory = (function () {
                                    function t(t) {
                                        (this.audios = []),
                                            (this.audioFactory = t),
                                            (this._volume = 1),
                                            (this._isMuted = !1);
                                    }
                                    return (
                                        (t.prototype = {
                                            addAudio: function (t) {
                                                this.audios.push(t);
                                            },
                                            pause: function () {
                                                var t,
                                                    e = this.audios.length;
                                                for (t = 0; t < e; t += 1) this.audios[t].pause();
                                            },
                                            resume: function () {
                                                var t,
                                                    e = this.audios.length;
                                                for (t = 0; t < e; t += 1) this.audios[t].resume();
                                            },
                                            setRate: function (t) {
                                                var e,
                                                    r = this.audios.length;
                                                for (e = 0; e < r; e += 1) this.audios[e].setRate(t);
                                            },
                                            createAudio: function (t) {
                                                return this.audioFactory
                                                    ? this.audioFactory(t)
                                                    : window.Howl
                                                      ? new window.Howl({ src: [t] })
                                                      : {
                                                            isPlaying: !1,
                                                            play: function () {
                                                                this.isPlaying = !0;
                                                            },
                                                            seek: function () {
                                                                this.isPlaying = !1;
                                                            },
                                                            playing: function () {},
                                                            rate: function () {},
                                                            setVolume: function () {},
                                                        };
                                            },
                                            setAudioFactory: function (t) {
                                                this.audioFactory = t;
                                            },
                                            setVolume: function (t) {
                                                (this._volume = t), this._updateVolume();
                                            },
                                            mute: function () {
                                                (this._isMuted = !0), this._updateVolume();
                                            },
                                            unmute: function () {
                                                (this._isMuted = !1), this._updateVolume();
                                            },
                                            getVolume: function () {
                                                return this._volume;
                                            },
                                            _updateVolume: function () {
                                                var t,
                                                    e = this.audios.length;
                                                for (t = 0; t < e; t += 1)
                                                    this.audios[t].volume(this._volume * (this._isMuted ? 0 : 1));
                                            },
                                        }),
                                        function () {
                                            return new t();
                                        }
                                    );
                                })(),
                                createTypedArray = (function () {
                                    function t(t, e) {
                                        var r,
                                            i = 0,
                                            n = [];
                                        switch (t) {
                                            case "int16":
                                            case "uint8c":
                                                r = 1;
                                                break;
                                            default:
                                                r = 1.1;
                                        }
                                        for (i = 0; i < e; i += 1) n.push(r);
                                        return n;
                                    }
                                    return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array
                                        ? function (e, r) {
                                              return "float32" === e
                                                  ? new Float32Array(r)
                                                  : "int16" === e
                                                    ? new Int16Array(r)
                                                    : "uint8c" === e
                                                      ? new Uint8ClampedArray(r)
                                                      : t(e, r);
                                          }
                                        : t;
                                })();
                            function createSizedArray(t) {
                                return Array.apply(null, { length: t });
                            }
                            function _typeof$6(t) {
                                return (_typeof$6 =
                                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                        ? function (t) {
                                              return typeof t;
                                          }
                                        : function (t) {
                                              return t &&
                                                  "function" == typeof Symbol &&
                                                  t.constructor === Symbol &&
                                                  t !== Symbol.prototype
                                                  ? "symbol"
                                                  : typeof t;
                                          })(t);
                            }
                            var subframeEnabled = !0,
                                expressionsPlugin = null,
                                expressionsInterfaces = null,
                                idPrefix$1 = "",
                                isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
                                _shouldRoundValues = !1,
                                bmPow = Math.pow,
                                bmSqrt = Math.sqrt,
                                bmFloor = Math.floor,
                                bmMax = Math.max,
                                bmMin = Math.min,
                                BMMath = {};
                            function ProjectInterface$1() {
                                return {};
                            }
                            !(function () {
                                var t,
                                    e = [
                                        "abs",
                                        "acos",
                                        "acosh",
                                        "asin",
                                        "asinh",
                                        "atan",
                                        "atanh",
                                        "atan2",
                                        "ceil",
                                        "cbrt",
                                        "expm1",
                                        "clz32",
                                        "cos",
                                        "cosh",
                                        "exp",
                                        "floor",
                                        "fround",
                                        "hypot",
                                        "imul",
                                        "log",
                                        "log1p",
                                        "log2",
                                        "log10",
                                        "max",
                                        "min",
                                        "pow",
                                        "random",
                                        "round",
                                        "sign",
                                        "sin",
                                        "sinh",
                                        "sqrt",
                                        "tan",
                                        "tanh",
                                        "trunc",
                                        "E",
                                        "LN10",
                                        "LN2",
                                        "LOG10E",
                                        "LOG2E",
                                        "PI",
                                        "SQRT1_2",
                                        "SQRT2",
                                    ],
                                    r = e.length;
                                for (t = 0; t < r; t += 1) BMMath[e[t]] = Math[e[t]];
                            })(),
                                (BMMath.random = Math.random),
                                (BMMath.abs = function (t) {
                                    if ("object" === _typeof$6(t) && t.length) {
                                        var e,
                                            r = createSizedArray(t.length),
                                            i = t.length;
                                        for (e = 0; e < i; e += 1) r[e] = Math.abs(t[e]);
                                        return r;
                                    }
                                    return Math.abs(t);
                                });
                            var defaultCurveSegments = 150,
                                degToRads = Math.PI / 180,
                                roundCorner = 0.5519;
                            function roundValues(t) {
                                _shouldRoundValues = !!t;
                            }
                            function bmRnd(t) {
                                return _shouldRoundValues ? Math.round(t) : t;
                            }
                            function styleDiv(t) {
                                (t.style.position = "absolute"),
                                    (t.style.top = 0),
                                    (t.style.left = 0),
                                    (t.style.display = "block"),
                                    (t.style.transformOrigin = "0 0"),
                                    (t.style.webkitTransformOrigin = "0 0"),
                                    (t.style.backfaceVisibility = "visible"),
                                    (t.style.webkitBackfaceVisibility = "visible"),
                                    (t.style.transformStyle = "preserve-3d"),
                                    (t.style.webkitTransformStyle = "preserve-3d"),
                                    (t.style.mozTransformStyle = "preserve-3d");
                            }
                            function BMEnterFrameEvent(t, e, r, i) {
                                (this.type = t),
                                    (this.currentTime = e),
                                    (this.totalTime = r),
                                    (this.direction = i < 0 ? -1 : 1);
                            }
                            function BMCompleteEvent(t, e) {
                                (this.type = t), (this.direction = e < 0 ? -1 : 1);
                            }
                            function BMCompleteLoopEvent(t, e, r, i) {
                                (this.type = t),
                                    (this.currentLoop = r),
                                    (this.totalLoops = e),
                                    (this.direction = i < 0 ? -1 : 1);
                            }
                            function BMSegmentStartEvent(t, e, r) {
                                (this.type = t), (this.firstFrame = e), (this.totalFrames = r);
                            }
                            function BMDestroyEvent(t, e) {
                                (this.type = t), (this.target = e);
                            }
                            function BMRenderFrameErrorEvent(t, e) {
                                (this.type = "renderFrameError"), (this.nativeError = t), (this.currentTime = e);
                            }
                            function BMConfigErrorEvent(t) {
                                (this.type = "configError"), (this.nativeError = t);
                            }
                            function BMAnimationConfigErrorEvent(t, e) {
                                (this.type = t), (this.nativeError = e);
                            }
                            var createElementID =
                                    ((_count = 0),
                                    function () {
                                        return idPrefix$1 + "__lottie_element_" + (_count += 1);
                                    }),
                                _count;
                            function HSVtoRGB(t, e, r) {
                                var i, n, s, a, o, l, h, p;
                                switch (
                                    ((l = r * (1 - e)),
                                    (h = r * (1 - (o = 6 * t - (a = Math.floor(6 * t))) * e)),
                                    (p = r * (1 - (1 - o) * e)),
                                    a % 6)
                                ) {
                                    case 0:
                                        (i = r), (n = p), (s = l);
                                        break;
                                    case 1:
                                        (i = h), (n = r), (s = l);
                                        break;
                                    case 2:
                                        (i = l), (n = r), (s = p);
                                        break;
                                    case 3:
                                        (i = l), (n = h), (s = r);
                                        break;
                                    case 4:
                                        (i = p), (n = l), (s = r);
                                        break;
                                    case 5:
                                        (i = r), (n = l), (s = h);
                                }
                                return [i, n, s];
                            }
                            function RGBtoHSV(t, e, r) {
                                var i,
                                    n = Math.max(t, e, r),
                                    s = Math.min(t, e, r),
                                    a = n - s,
                                    o = 0 === n ? 0 : a / n,
                                    l = n / 255;
                                switch (n) {
                                    case s:
                                        i = 0;
                                        break;
                                    case t:
                                        (i = e - r + a * (e < r ? 6 : 0)), (i /= 6 * a);
                                        break;
                                    case e:
                                        (i = r - t + 2 * a), (i /= 6 * a);
                                        break;
                                    case r:
                                        (i = t - e + 4 * a), (i /= 6 * a);
                                }
                                return [i, o, l];
                            }
                            function addSaturationToRGB(t, e) {
                                var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
                                return (
                                    (r[1] += e),
                                    r[1] > 1 ? (r[1] = 1) : r[1] <= 0 && (r[1] = 0),
                                    HSVtoRGB(r[0], r[1], r[2])
                                );
                            }
                            function addBrightnessToRGB(t, e) {
                                var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
                                return (
                                    (r[2] += e),
                                    r[2] > 1 ? (r[2] = 1) : r[2] < 0 && (r[2] = 0),
                                    HSVtoRGB(r[0], r[1], r[2])
                                );
                            }
                            function addHueToRGB(t, e) {
                                var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
                                return (
                                    (r[0] += e / 360),
                                    r[0] > 1 ? (r[0] -= 1) : r[0] < 0 && (r[0] += 1),
                                    HSVtoRGB(r[0], r[1], r[2])
                                );
                            }
                            var rgbToHex = (function () {
                                    var t,
                                        e,
                                        r = [];
                                    for (t = 0; t < 256; t += 1)
                                        (e = t.toString(16)), (r[t] = 1 === e.length ? "0" + e : e);
                                    return function (t, e, i) {
                                        return (
                                            t < 0 && (t = 0),
                                            e < 0 && (e = 0),
                                            i < 0 && (i = 0),
                                            "#" + r[t] + r[e] + r[i]
                                        );
                                    };
                                })(),
                                setSubframeEnabled = function (t) {
                                    subframeEnabled = !!t;
                                },
                                getSubframeEnabled = function () {
                                    return subframeEnabled;
                                },
                                setExpressionsPlugin = function (t) {
                                    expressionsPlugin = t;
                                },
                                getExpressionsPlugin = function () {
                                    return expressionsPlugin;
                                },
                                setExpressionInterfaces = function (t) {
                                    expressionsInterfaces = t;
                                },
                                getExpressionInterfaces = function () {
                                    return expressionsInterfaces;
                                },
                                setDefaultCurveSegments = function (t) {
                                    defaultCurveSegments = t;
                                },
                                getDefaultCurveSegments = function () {
                                    return defaultCurveSegments;
                                },
                                setIdPrefix = function (t) {
                                    idPrefix$1 = t;
                                },
                                getIdPrefix = function () {
                                    return idPrefix$1;
                                };
                            function createNS(t) {
                                return document.createElementNS(svgNS, t);
                            }
                            function _typeof$5(t) {
                                return (_typeof$5 =
                                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                        ? function (t) {
                                              return typeof t;
                                          }
                                        : function (t) {
                                              return t &&
                                                  "function" == typeof Symbol &&
                                                  t.constructor === Symbol &&
                                                  t !== Symbol.prototype
                                                  ? "symbol"
                                                  : typeof t;
                                          })(t);
                            }
                            var dataManager = (function () {
                                    var t,
                                        e,
                                        r = 1,
                                        i = [],
                                        n = {
                                            onmessage: function () {},
                                            postMessage: function (e) {
                                                t({ data: e });
                                            },
                                        },
                                        s = {
                                            postMessage: function (t) {
                                                n.onmessage({ data: t });
                                            },
                                        };
                                    function a() {
                                        e ||
                                            ((e = (function (e) {
                                                if (window.Worker && window.Blob && getWebWorker()) {
                                                    var r = new Blob(
                                                            ["var _workerSelf = self; self.onmessage = ", e.toString()],
                                                            { type: "text/javascript" }
                                                        ),
                                                        i = URL.createObjectURL(r);
                                                    return new Worker(i);
                                                }
                                                return (t = e), n;
                                            })(function (t) {
                                                if (
                                                    (s.dataManager ||
                                                        (s.dataManager = (function () {
                                                            function t(n, s) {
                                                                var a,
                                                                    o,
                                                                    l,
                                                                    h,
                                                                    p,
                                                                    c,
                                                                    d,
                                                                    u = n.length;
                                                                for (o = 0; o < u; o += 1)
                                                                    if ("ks" in (a = n[o]) && !a.completed) {
                                                                        if (((a.completed = !0), a.hasMask)) {
                                                                            var f = a.masksProperties;
                                                                            for (h = f.length, l = 0; l < h; l += 1)
                                                                                if (f[l].pt.k.i) i(f[l].pt.k);
                                                                                else
                                                                                    for (
                                                                                        c = f[l].pt.k.length, p = 0;
                                                                                        p < c;
                                                                                        p += 1
                                                                                    )
                                                                                        f[l].pt.k[p].s &&
                                                                                            i(f[l].pt.k[p].s[0]),
                                                                                            f[l].pt.k[p].e &&
                                                                                                i(f[l].pt.k[p].e[0]);
                                                                        }
                                                                        0 === a.ty
                                                                            ? ((a.layers = e(a.refId, s)),
                                                                              t(a.layers, s))
                                                                            : 4 === a.ty
                                                                              ? r(a.shapes)
                                                                              : 5 === a.ty &&
                                                                                0 === (d = a).t.a.length &&
                                                                                d.t.p;
                                                                    }
                                                            }
                                                            function e(t, e) {
                                                                var r = (function (t, e) {
                                                                    for (var r = 0, i = e.length; r < i; ) {
                                                                        if (e[r].id === t) return e[r];
                                                                        r += 1;
                                                                    }
                                                                    return null;
                                                                })(t, e);
                                                                return r
                                                                    ? r.layers.__used
                                                                        ? JSON.parse(JSON.stringify(r.layers))
                                                                        : ((r.layers.__used = !0), r.layers)
                                                                    : null;
                                                            }
                                                            function r(t) {
                                                                var e, n, s;
                                                                for (e = t.length - 1; e >= 0; e -= 1)
                                                                    if ("sh" === t[e].ty)
                                                                        if (t[e].ks.k.i) i(t[e].ks.k);
                                                                        else
                                                                            for (
                                                                                s = t[e].ks.k.length, n = 0;
                                                                                n < s;
                                                                                n += 1
                                                                            )
                                                                                t[e].ks.k[n].s && i(t[e].ks.k[n].s[0]),
                                                                                    t[e].ks.k[n].e &&
                                                                                        i(t[e].ks.k[n].e[0]);
                                                                    else "gr" === t[e].ty && r(t[e].it);
                                                            }
                                                            function i(t) {
                                                                var e,
                                                                    r = t.i.length;
                                                                for (e = 0; e < r; e += 1)
                                                                    (t.i[e][0] += t.v[e][0]),
                                                                        (t.i[e][1] += t.v[e][1]),
                                                                        (t.o[e][0] += t.v[e][0]),
                                                                        (t.o[e][1] += t.v[e][1]);
                                                            }
                                                            function n(t, e) {
                                                                var r = e ? e.split(".") : [100, 100, 100];
                                                                return (
                                                                    t[0] > r[0] ||
                                                                    (!(r[0] > t[0]) &&
                                                                        (t[1] > r[1] ||
                                                                            (!(r[1] > t[1]) &&
                                                                                (t[2] > r[2] ||
                                                                                    (!(r[2] > t[2]) && null)))))
                                                                );
                                                            }
                                                            var s,
                                                                a = (function () {
                                                                    var t = [4, 4, 14];
                                                                    function e(t) {
                                                                        var e,
                                                                            r,
                                                                            i,
                                                                            n = t.length;
                                                                        for (e = 0; e < n; e += 1)
                                                                            5 === t[e].ty &&
                                                                                ((i = (r = t[e]).t.d),
                                                                                (r.t.d = { k: [{ s: i, t: 0 }] }));
                                                                    }
                                                                    return function (r) {
                                                                        if (n(t, r.v) && (e(r.layers), r.assets)) {
                                                                            var i,
                                                                                s = r.assets.length;
                                                                            for (i = 0; i < s; i += 1)
                                                                                r.assets[i].layers &&
                                                                                    e(r.assets[i].layers);
                                                                        }
                                                                    };
                                                                })(),
                                                                o =
                                                                    ((s = [4, 7, 99]),
                                                                    function (t) {
                                                                        if (t.chars && !n(s, t.v)) {
                                                                            var e,
                                                                                i = t.chars.length;
                                                                            for (e = 0; e < i; e += 1) {
                                                                                var a = t.chars[e];
                                                                                a.data &&
                                                                                    a.data.shapes &&
                                                                                    (r(a.data.shapes),
                                                                                    (a.data.ip = 0),
                                                                                    (a.data.op = 99999),
                                                                                    (a.data.st = 0),
                                                                                    (a.data.sr = 1),
                                                                                    (a.data.ks = {
                                                                                        p: { k: [0, 0], a: 0 },
                                                                                        s: { k: [100, 100], a: 0 },
                                                                                        a: { k: [0, 0], a: 0 },
                                                                                        r: { k: 0, a: 0 },
                                                                                        o: { k: 100, a: 0 },
                                                                                    }),
                                                                                    t.chars[e].t ||
                                                                                        (a.data.shapes.push({
                                                                                            ty: "no",
                                                                                        }),
                                                                                        a.data.shapes[0].it.push({
                                                                                            p: { k: [0, 0], a: 0 },
                                                                                            s: { k: [100, 100], a: 0 },
                                                                                            a: { k: [0, 0], a: 0 },
                                                                                            r: { k: 0, a: 0 },
                                                                                            o: { k: 100, a: 0 },
                                                                                            sk: { k: 0, a: 0 },
                                                                                            sa: { k: 0, a: 0 },
                                                                                            ty: "tr",
                                                                                        })));
                                                                            }
                                                                        }
                                                                    }),
                                                                l = (function () {
                                                                    var t = [5, 7, 15];
                                                                    function e(t) {
                                                                        var e,
                                                                            r,
                                                                            i = t.length;
                                                                        for (e = 0; e < i; e += 1)
                                                                            5 === t[e].ty &&
                                                                                ((r = void 0),
                                                                                "number" == typeof (r = t[e].t.p).a &&
                                                                                    (r.a = { a: 0, k: r.a }),
                                                                                "number" == typeof r.p &&
                                                                                    (r.p = { a: 0, k: r.p }),
                                                                                "number" == typeof r.r &&
                                                                                    (r.r = { a: 0, k: r.r }));
                                                                    }
                                                                    return function (r) {
                                                                        if (n(t, r.v) && (e(r.layers), r.assets)) {
                                                                            var i,
                                                                                s = r.assets.length;
                                                                            for (i = 0; i < s; i += 1)
                                                                                r.assets[i].layers &&
                                                                                    e(r.assets[i].layers);
                                                                        }
                                                                    };
                                                                })(),
                                                                h = (function () {
                                                                    var t = [4, 1, 9];
                                                                    function e(t) {
                                                                        var r,
                                                                            i,
                                                                            n,
                                                                            s = t.length;
                                                                        for (r = 0; r < s; r += 1)
                                                                            if ("gr" === t[r].ty) e(t[r].it);
                                                                            else if (
                                                                                "fl" === t[r].ty ||
                                                                                "st" === t[r].ty
                                                                            )
                                                                                if (t[r].c.k && t[r].c.k[0].i)
                                                                                    for (
                                                                                        n = t[r].c.k.length, i = 0;
                                                                                        i < n;
                                                                                        i += 1
                                                                                    )
                                                                                        t[r].c.k[i].s &&
                                                                                            ((t[r].c.k[i].s[0] /= 255),
                                                                                            (t[r].c.k[i].s[1] /= 255),
                                                                                            (t[r].c.k[i].s[2] /= 255),
                                                                                            (t[r].c.k[i].s[3] /= 255)),
                                                                                            t[r].c.k[i].e &&
                                                                                                ((t[r].c.k[i].e[0] /=
                                                                                                    255),
                                                                                                (t[r].c.k[i].e[1] /=
                                                                                                    255),
                                                                                                (t[r].c.k[i].e[2] /=
                                                                                                    255),
                                                                                                (t[r].c.k[i].e[3] /=
                                                                                                    255));
                                                                                else
                                                                                    (t[r].c.k[0] /= 255),
                                                                                        (t[r].c.k[1] /= 255),
                                                                                        (t[r].c.k[2] /= 255),
                                                                                        (t[r].c.k[3] /= 255);
                                                                    }
                                                                    function r(t) {
                                                                        var r,
                                                                            i = t.length;
                                                                        for (r = 0; r < i; r += 1)
                                                                            4 === t[r].ty && e(t[r].shapes);
                                                                    }
                                                                    return function (e) {
                                                                        if (n(t, e.v) && (r(e.layers), e.assets)) {
                                                                            var i,
                                                                                s = e.assets.length;
                                                                            for (i = 0; i < s; i += 1)
                                                                                e.assets[i].layers &&
                                                                                    r(e.assets[i].layers);
                                                                        }
                                                                    };
                                                                })(),
                                                                p = (function () {
                                                                    var t = [4, 4, 18];
                                                                    function e(t) {
                                                                        var r, i, n;
                                                                        for (r = t.length - 1; r >= 0; r -= 1)
                                                                            if ("sh" === t[r].ty)
                                                                                if (t[r].ks.k.i)
                                                                                    t[r].ks.k.c = t[r].closed;
                                                                                else
                                                                                    for (
                                                                                        n = t[r].ks.k.length, i = 0;
                                                                                        i < n;
                                                                                        i += 1
                                                                                    )
                                                                                        t[r].ks.k[i].s &&
                                                                                            (t[r].ks.k[i].s[0].c =
                                                                                                t[r].closed),
                                                                                            t[r].ks.k[i].e &&
                                                                                                (t[r].ks.k[i].e[0].c =
                                                                                                    t[r].closed);
                                                                            else "gr" === t[r].ty && e(t[r].it);
                                                                    }
                                                                    function r(t) {
                                                                        var r,
                                                                            i,
                                                                            n,
                                                                            s,
                                                                            a,
                                                                            o,
                                                                            l = t.length;
                                                                        for (i = 0; i < l; i += 1) {
                                                                            if ((r = t[i]).hasMask) {
                                                                                var h = r.masksProperties;
                                                                                for (s = h.length, n = 0; n < s; n += 1)
                                                                                    if (h[n].pt.k.i)
                                                                                        h[n].pt.k.c = h[n].cl;
                                                                                    else
                                                                                        for (
                                                                                            o = h[n].pt.k.length, a = 0;
                                                                                            a < o;
                                                                                            a += 1
                                                                                        )
                                                                                            h[n].pt.k[a].s &&
                                                                                                (h[n].pt.k[a].s[0].c =
                                                                                                    h[n].cl),
                                                                                                h[n].pt.k[a].e &&
                                                                                                    (h[n].pt.k[
                                                                                                        a
                                                                                                    ].e[0].c = h[n].cl);
                                                                            }
                                                                            4 === r.ty && e(r.shapes);
                                                                        }
                                                                    }
                                                                    return function (e) {
                                                                        if (n(t, e.v) && (r(e.layers), e.assets)) {
                                                                            var i,
                                                                                s = e.assets.length;
                                                                            for (i = 0; i < s; i += 1)
                                                                                e.assets[i].layers &&
                                                                                    r(e.assets[i].layers);
                                                                        }
                                                                    };
                                                                })(),
                                                                c = {
                                                                    completeData: function (r) {
                                                                        r.__complete ||
                                                                            (h(r),
                                                                            a(r),
                                                                            o(r),
                                                                            l(r),
                                                                            p(r),
                                                                            t(r.layers, r.assets),
                                                                            (function (r, i) {
                                                                                if (r) {
                                                                                    var n = 0,
                                                                                        s = r.length;
                                                                                    for (n = 0; n < s; n += 1)
                                                                                        1 === r[n].t &&
                                                                                            ((r[n].data.layers = e(
                                                                                                r[n].data.refId,
                                                                                                i
                                                                                            )),
                                                                                            t(r[n].data.layers, i));
                                                                                }
                                                                            })(r.chars, r.assets),
                                                                            (r.__complete = !0));
                                                                    },
                                                                };
                                                            return (
                                                                (c.checkColors = h),
                                                                (c.checkChars = o),
                                                                (c.checkPathProperties = l),
                                                                (c.checkShapes = p),
                                                                (c.completeLayers = t),
                                                                c
                                                            );
                                                        })()),
                                                    s.assetLoader ||
                                                        (s.assetLoader = (function () {
                                                            function t(t) {
                                                                var e = t.getResponseHeader("content-type");
                                                                return (e &&
                                                                    "json" === t.responseType &&
                                                                    -1 !== e.indexOf("json")) ||
                                                                    (t.response && "object" === _typeof$5(t.response))
                                                                    ? t.response
                                                                    : t.response && "string" == typeof t.response
                                                                      ? JSON.parse(t.response)
                                                                      : t.responseText
                                                                        ? JSON.parse(t.responseText)
                                                                        : null;
                                                            }
                                                            return {
                                                                load: function (e, r, i, n) {
                                                                    var s,
                                                                        a = new XMLHttpRequest();
                                                                    try {
                                                                        a.responseType = "json";
                                                                    } catch (t) {}
                                                                    a.onreadystatechange = function () {
                                                                        if (4 === a.readyState)
                                                                            if (200 === a.status) (s = t(a)), i(s);
                                                                            else
                                                                                try {
                                                                                    (s = t(a)), i(s);
                                                                                } catch (t) {
                                                                                    n && n(t);
                                                                                }
                                                                    };
                                                                    try {
                                                                        a.open(["G", "E", "T"].join(""), e, !0);
                                                                    } catch (t) {
                                                                        a.open(
                                                                            ["G", "E", "T"].join(""),
                                                                            r + "/" + e,
                                                                            !0
                                                                        );
                                                                    }
                                                                    a.send();
                                                                },
                                                            };
                                                        })()),
                                                    "loadAnimation" === t.data.type)
                                                )
                                                    s.assetLoader.load(
                                                        t.data.path,
                                                        t.data.fullPath,
                                                        function (e) {
                                                            s.dataManager.completeData(e),
                                                                s.postMessage({
                                                                    id: t.data.id,
                                                                    payload: e,
                                                                    status: "success",
                                                                });
                                                        },
                                                        function () {
                                                            s.postMessage({ id: t.data.id, status: "error" });
                                                        }
                                                    );
                                                else if ("complete" === t.data.type) {
                                                    var e = t.data.animation;
                                                    s.dataManager.completeData(e),
                                                        s.postMessage({ id: t.data.id, payload: e, status: "success" });
                                                } else
                                                    "loadData" === t.data.type &&
                                                        s.assetLoader.load(
                                                            t.data.path,
                                                            t.data.fullPath,
                                                            function (e) {
                                                                s.postMessage({
                                                                    id: t.data.id,
                                                                    payload: e,
                                                                    status: "success",
                                                                });
                                                            },
                                                            function () {
                                                                s.postMessage({ id: t.data.id, status: "error" });
                                                            }
                                                        );
                                            })).onmessage = function (t) {
                                                var e = t.data,
                                                    r = e.id,
                                                    n = i[r];
                                                (i[r] = null),
                                                    "success" === e.status
                                                        ? n.onComplete(e.payload)
                                                        : n.onError && n.onError();
                                            });
                                    }
                                    function o(t, e) {
                                        var n = "processId_" + (r += 1);
                                        return (i[n] = { onComplete: t, onError: e }), n;
                                    }
                                    return {
                                        loadAnimation: function (t, r, i) {
                                            a();
                                            var n = o(r, i);
                                            e.postMessage({
                                                type: "loadAnimation",
                                                path: t,
                                                fullPath: window.location.origin + window.location.pathname,
                                                id: n,
                                            });
                                        },
                                        loadData: function (t, r, i) {
                                            a();
                                            var n = o(r, i);
                                            e.postMessage({
                                                type: "loadData",
                                                path: t,
                                                fullPath: window.location.origin + window.location.pathname,
                                                id: n,
                                            });
                                        },
                                        completeAnimation: function (t, r, i) {
                                            a();
                                            var n = o(r, i);
                                            e.postMessage({ type: "complete", animation: t, id: n });
                                        },
                                    };
                                })(),
                                ImagePreloader = (function () {
                                    var t = (function () {
                                        var t = createTag("canvas");
                                        (t.width = 1), (t.height = 1);
                                        var e = t.getContext("2d");
                                        return (e.fillStyle = "rgba(0,0,0,0)"), e.fillRect(0, 0, 1, 1), t;
                                    })();
                                    function e() {
                                        (this.loadedAssets += 1),
                                            this.loadedAssets === this.totalImages &&
                                                this.loadedFootagesCount === this.totalFootages &&
                                                this.imagesLoadedCb &&
                                                this.imagesLoadedCb(null);
                                    }
                                    function r() {
                                        (this.loadedFootagesCount += 1),
                                            this.loadedAssets === this.totalImages &&
                                                this.loadedFootagesCount === this.totalFootages &&
                                                this.imagesLoadedCb &&
                                                this.imagesLoadedCb(null);
                                    }
                                    function i(t, e, r) {
                                        var i = "";
                                        if (t.e) i = t.p;
                                        else if (e) {
                                            var n = t.p;
                                            -1 !== n.indexOf("images/") && (n = n.split("/")[1]), (i = e + n);
                                        } else (i = r), (i += t.u ? t.u : ""), (i += t.p);
                                        return i;
                                    }
                                    function n(t) {
                                        var e = 0,
                                            r = setInterval(
                                                function () {
                                                    (t.getBBox().width || e > 500) &&
                                                        (this._imageLoaded(), clearInterval(r)),
                                                        (e += 1);
                                                }.bind(this),
                                                50
                                            );
                                    }
                                    function s(t) {
                                        var e = { assetData: t },
                                            r = i(t, this.assetsPath, this.path);
                                        return (
                                            dataManager.loadData(
                                                r,
                                                function (t) {
                                                    (e.img = t), this._footageLoaded();
                                                }.bind(this),
                                                function () {
                                                    (e.img = {}), this._footageLoaded();
                                                }.bind(this)
                                            ),
                                            e
                                        );
                                    }
                                    function a() {
                                        (this._imageLoaded = e.bind(this)),
                                            (this._footageLoaded = r.bind(this)),
                                            (this.testImageLoaded = n.bind(this)),
                                            (this.createFootageData = s.bind(this)),
                                            (this.assetsPath = ""),
                                            (this.path = ""),
                                            (this.totalImages = 0),
                                            (this.totalFootages = 0),
                                            (this.loadedAssets = 0),
                                            (this.loadedFootagesCount = 0),
                                            (this.imagesLoadedCb = null),
                                            (this.images = []);
                                    }
                                    return (
                                        (a.prototype = {
                                            loadAssets: function (t, e) {
                                                var r;
                                                this.imagesLoadedCb = e;
                                                var i = t.length;
                                                for (r = 0; r < i; r += 1)
                                                    t[r].layers ||
                                                        (t[r].t && "seq" !== t[r].t
                                                            ? 3 === t[r].t &&
                                                              ((this.totalFootages += 1),
                                                              this.images.push(this.createFootageData(t[r])))
                                                            : ((this.totalImages += 1),
                                                              this.images.push(this._createImageData(t[r]))));
                                            },
                                            setAssetsPath: function (t) {
                                                this.assetsPath = t || "";
                                            },
                                            setPath: function (t) {
                                                this.path = t || "";
                                            },
                                            loadedImages: function () {
                                                return this.totalImages === this.loadedAssets;
                                            },
                                            loadedFootages: function () {
                                                return this.totalFootages === this.loadedFootagesCount;
                                            },
                                            destroy: function () {
                                                (this.imagesLoadedCb = null), (this.images.length = 0);
                                            },
                                            getAsset: function (t) {
                                                for (var e = 0, r = this.images.length; e < r; ) {
                                                    if (this.images[e].assetData === t) return this.images[e].img;
                                                    e += 1;
                                                }
                                                return null;
                                            },
                                            createImgData: function (e) {
                                                var r = i(e, this.assetsPath, this.path),
                                                    n = createTag("img");
                                                (n.crossOrigin = "anonymous"),
                                                    n.addEventListener("load", this._imageLoaded, !1),
                                                    n.addEventListener(
                                                        "error",
                                                        function () {
                                                            (s.img = t), this._imageLoaded();
                                                        }.bind(this),
                                                        !1
                                                    ),
                                                    (n.src = r);
                                                var s = { img: n, assetData: e };
                                                return s;
                                            },
                                            createImageData: function (e) {
                                                var r = i(e, this.assetsPath, this.path),
                                                    n = createNS("image");
                                                isSafari
                                                    ? this.testImageLoaded(n)
                                                    : n.addEventListener("load", this._imageLoaded, !1),
                                                    n.addEventListener(
                                                        "error",
                                                        function () {
                                                            (s.img = t), this._imageLoaded();
                                                        }.bind(this),
                                                        !1
                                                    ),
                                                    n.setAttributeNS("http://www.w3.org/1999/xlink", "href", r),
                                                    this._elementHelper.append
                                                        ? this._elementHelper.append(n)
                                                        : this._elementHelper.appendChild(n);
                                                var s = { img: n, assetData: e };
                                                return s;
                                            },
                                            imageLoaded: e,
                                            footageLoaded: r,
                                            setCacheType: function (t, e) {
                                                "svg" === t
                                                    ? ((this._elementHelper = e),
                                                      (this._createImageData = this.createImageData.bind(this)))
                                                    : (this._createImageData = this.createImgData.bind(this));
                                            },
                                        }),
                                        a
                                    );
                                })();
                            function BaseEvent() {}
                            BaseEvent.prototype = {
                                triggerEvent: function (t, e) {
                                    if (this._cbs[t]) for (var r = this._cbs[t], i = 0; i < r.length; i += 1) r[i](e);
                                },
                                addEventListener: function (t, e) {
                                    return (
                                        this._cbs[t] || (this._cbs[t] = []),
                                        this._cbs[t].push(e),
                                        function () {
                                            this.removeEventListener(t, e);
                                        }.bind(this)
                                    );
                                },
                                removeEventListener: function (t, e) {
                                    if (e) {
                                        if (this._cbs[t]) {
                                            for (var r = 0, i = this._cbs[t].length; r < i; )
                                                this._cbs[t][r] === e &&
                                                    (this._cbs[t].splice(r, 1), (r -= 1), (i -= 1)),
                                                    (r += 1);
                                            this._cbs[t].length || (this._cbs[t] = null);
                                        }
                                    } else this._cbs[t] = null;
                                },
                            };
                            var markerParser = (function () {
                                    function t(t) {
                                        for (var e, r = t.split("\r\n"), i = {}, n = 0, s = 0; s < r.length; s += 1)
                                            2 === (e = r[s].split(":")).length && ((i[e[0]] = e[1].trim()), (n += 1));
                                        if (0 === n) throw new Error();
                                        return i;
                                    }
                                    return function (e) {
                                        for (var r = [], i = 0; i < e.length; i += 1) {
                                            var n = e[i],
                                                s = { time: n.tm, duration: n.dr };
                                            try {
                                                s.payload = JSON.parse(e[i].cm);
                                            } catch (r) {
                                                try {
                                                    s.payload = t(e[i].cm);
                                                } catch (t) {
                                                    s.payload = { name: e[i].cm };
                                                }
                                            }
                                            r.push(s);
                                        }
                                        return r;
                                    };
                                })(),
                                ProjectInterface = (function () {
                                    function t(t) {
                                        this.compositions.push(t);
                                    }
                                    return function () {
                                        function e(t) {
                                            for (var e = 0, r = this.compositions.length; e < r; ) {
                                                if (this.compositions[e].data && this.compositions[e].data.nm === t)
                                                    return (
                                                        this.compositions[e].prepareFrame &&
                                                            this.compositions[e].data.xt &&
                                                            this.compositions[e].prepareFrame(this.currentFrame),
                                                        this.compositions[e].compInterface
                                                    );
                                                e += 1;
                                            }
                                            return null;
                                        }
                                        return (
                                            (e.compositions = []), (e.currentFrame = 0), (e.registerComposition = t), e
                                        );
                                    };
                                })(),
                                renderers = {},
                                registerRenderer = function (t, e) {
                                    renderers[t] = e;
                                };
                            function getRenderer(t) {
                                return renderers[t];
                            }
                            function _typeof$4(t) {
                                return (_typeof$4 =
                                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                        ? function (t) {
                                              return typeof t;
                                          }
                                        : function (t) {
                                              return t &&
                                                  "function" == typeof Symbol &&
                                                  t.constructor === Symbol &&
                                                  t !== Symbol.prototype
                                                  ? "symbol"
                                                  : typeof t;
                                          })(t);
                            }
                            var AnimationItem = function () {
                                (this._cbs = []),
                                    (this.name = ""),
                                    (this.path = ""),
                                    (this.isLoaded = !1),
                                    (this.currentFrame = 0),
                                    (this.currentRawFrame = 0),
                                    (this.firstFrame = 0),
                                    (this.totalFrames = 0),
                                    (this.frameRate = 0),
                                    (this.frameMult = 0),
                                    (this.playSpeed = 1),
                                    (this.playDirection = 1),
                                    (this.playCount = 0),
                                    (this.animationData = {}),
                                    (this.assets = []),
                                    (this.isPaused = !0),
                                    (this.autoplay = !1),
                                    (this.loop = !0),
                                    (this.renderer = null),
                                    (this.animationID = createElementID()),
                                    (this.assetsPath = ""),
                                    (this.timeCompleted = 0),
                                    (this.segmentPos = 0),
                                    (this.isSubframeEnabled = getSubframeEnabled()),
                                    (this.segments = []),
                                    (this._idle = !0),
                                    (this._completedLoop = !1),
                                    (this.projectInterface = ProjectInterface()),
                                    (this.imagePreloader = new ImagePreloader()),
                                    (this.audioController = audioControllerFactory()),
                                    (this.markers = []),
                                    (this.configAnimation = this.configAnimation.bind(this)),
                                    (this.onSetupError = this.onSetupError.bind(this)),
                                    (this.onSegmentComplete = this.onSegmentComplete.bind(this)),
                                    (this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0));
                            };
                            extendPrototype([BaseEvent], AnimationItem),
                                (AnimationItem.prototype.setParams = function (t) {
                                    (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
                                    var e = "svg";
                                    t.animType ? (e = t.animType) : t.renderer && (e = t.renderer);
                                    var r = getRenderer(e);
                                    (this.renderer = new r(this, t.rendererSettings)),
                                        this.imagePreloader.setCacheType(e, this.renderer.globalData.defs),
                                        this.renderer.setProjectInterface(this.projectInterface),
                                        (this.animType = e),
                                        "" === t.loop || null === t.loop || void 0 === t.loop || !0 === t.loop
                                            ? (this.loop = !0)
                                            : !1 === t.loop
                                              ? (this.loop = !1)
                                              : (this.loop = parseInt(t.loop, 10)),
                                        (this.autoplay = !("autoplay" in t) || t.autoplay),
                                        (this.name = t.name ? t.name : ""),
                                        (this.autoloadSegments =
                                            !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") ||
                                            t.autoloadSegments),
                                        (this.assetsPath = t.assetsPath),
                                        (this.initialSegment = t.initialSegment),
                                        t.audioFactory && this.audioController.setAudioFactory(t.audioFactory),
                                        t.animationData
                                            ? this.setupAnimation(t.animationData)
                                            : t.path &&
                                              (-1 !== t.path.lastIndexOf("\\")
                                                  ? (this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1))
                                                  : (this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1)),
                                              (this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1)),
                                              (this.fileName = this.fileName.substr(
                                                  0,
                                                  this.fileName.lastIndexOf(".json")
                                              )),
                                              dataManager.loadAnimation(
                                                  t.path,
                                                  this.configAnimation,
                                                  this.onSetupError
                                              ));
                                }),
                                (AnimationItem.prototype.onSetupError = function () {
                                    this.trigger("data_failed");
                                }),
                                (AnimationItem.prototype.setupAnimation = function (t) {
                                    dataManager.completeAnimation(t, this.configAnimation);
                                }),
                                (AnimationItem.prototype.setData = function (t, e) {
                                    e && "object" !== _typeof$4(e) && (e = JSON.parse(e));
                                    var r = { wrapper: t, animationData: e },
                                        i = t.attributes;
                                    (r.path = i.getNamedItem("data-animation-path")
                                        ? i.getNamedItem("data-animation-path").value
                                        : i.getNamedItem("data-bm-path")
                                          ? i.getNamedItem("data-bm-path").value
                                          : i.getNamedItem("bm-path")
                                            ? i.getNamedItem("bm-path").value
                                            : ""),
                                        (r.animType = i.getNamedItem("data-anim-type")
                                            ? i.getNamedItem("data-anim-type").value
                                            : i.getNamedItem("data-bm-type")
                                              ? i.getNamedItem("data-bm-type").value
                                              : i.getNamedItem("bm-type")
                                                ? i.getNamedItem("bm-type").value
                                                : i.getNamedItem("data-bm-renderer")
                                                  ? i.getNamedItem("data-bm-renderer").value
                                                  : i.getNamedItem("bm-renderer")
                                                    ? i.getNamedItem("bm-renderer").value
                                                    : "canvas");
                                    var n = i.getNamedItem("data-anim-loop")
                                        ? i.getNamedItem("data-anim-loop").value
                                        : i.getNamedItem("data-bm-loop")
                                          ? i.getNamedItem("data-bm-loop").value
                                          : i.getNamedItem("bm-loop")
                                            ? i.getNamedItem("bm-loop").value
                                            : "";
                                    "false" === n
                                        ? (r.loop = !1)
                                        : "true" === n
                                          ? (r.loop = !0)
                                          : "" !== n && (r.loop = parseInt(n, 10));
                                    var s = i.getNamedItem("data-anim-autoplay")
                                        ? i.getNamedItem("data-anim-autoplay").value
                                        : i.getNamedItem("data-bm-autoplay")
                                          ? i.getNamedItem("data-bm-autoplay").value
                                          : !i.getNamedItem("bm-autoplay") || i.getNamedItem("bm-autoplay").value;
                                    (r.autoplay = "false" !== s),
                                        (r.name = i.getNamedItem("data-name")
                                            ? i.getNamedItem("data-name").value
                                            : i.getNamedItem("data-bm-name")
                                              ? i.getNamedItem("data-bm-name").value
                                              : i.getNamedItem("bm-name")
                                                ? i.getNamedItem("bm-name").value
                                                : ""),
                                        "false" ===
                                            (i.getNamedItem("data-anim-prerender")
                                                ? i.getNamedItem("data-anim-prerender").value
                                                : i.getNamedItem("data-bm-prerender")
                                                  ? i.getNamedItem("data-bm-prerender").value
                                                  : i.getNamedItem("bm-prerender")
                                                    ? i.getNamedItem("bm-prerender").value
                                                    : "") && (r.prerender = !1),
                                        this.setParams(r);
                                }),
                                (AnimationItem.prototype.includeLayers = function (t) {
                                    t.op > this.animationData.op &&
                                        ((this.animationData.op = t.op),
                                        (this.totalFrames = Math.floor(t.op - this.animationData.ip)));
                                    var e,
                                        r,
                                        i = this.animationData.layers,
                                        n = i.length,
                                        s = t.layers,
                                        a = s.length;
                                    for (r = 0; r < a; r += 1)
                                        for (e = 0; e < n; ) {
                                            if (i[e].id === s[r].id) {
                                                i[e] = s[r];
                                                break;
                                            }
                                            e += 1;
                                        }
                                    if (
                                        ((t.chars || t.fonts) &&
                                            (this.renderer.globalData.fontManager.addChars(t.chars),
                                            this.renderer.globalData.fontManager.addFonts(
                                                t.fonts,
                                                this.renderer.globalData.defs
                                            )),
                                        t.assets)
                                    )
                                        for (n = t.assets.length, e = 0; e < n; e += 1)
                                            this.animationData.assets.push(t.assets[e]);
                                    (this.animationData.__complete = !1),
                                        dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
                                }),
                                (AnimationItem.prototype.onSegmentComplete = function (t) {
                                    this.animationData = t;
                                    var e = getExpressionsPlugin();
                                    e && e.initExpressions(this), this.loadNextSegment();
                                }),
                                (AnimationItem.prototype.loadNextSegment = function () {
                                    var t = this.animationData.segments;
                                    if (!t || 0 === t.length || !this.autoloadSegments)
                                        return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
                                    var e = t.shift();
                                    this.timeCompleted = e.time * this.frameRate;
                                    var r = this.path + this.fileName + "_" + this.segmentPos + ".json";
                                    (this.segmentPos += 1),
                                        dataManager.loadData(
                                            r,
                                            this.includeLayers.bind(this),
                                            function () {
                                                this.trigger("data_failed");
                                            }.bind(this)
                                        );
                                }),
                                (AnimationItem.prototype.loadSegments = function () {
                                    this.animationData.segments || (this.timeCompleted = this.totalFrames),
                                        this.loadNextSegment();
                                }),
                                (AnimationItem.prototype.imagesLoaded = function () {
                                    this.trigger("loaded_images"), this.checkLoaded();
                                }),
                                (AnimationItem.prototype.preloadImages = function () {
                                    this.imagePreloader.setAssetsPath(this.assetsPath),
                                        this.imagePreloader.setPath(this.path),
                                        this.imagePreloader.loadAssets(
                                            this.animationData.assets,
                                            this.imagesLoaded.bind(this)
                                        );
                                }),
                                (AnimationItem.prototype.configAnimation = function (t) {
                                    if (this.renderer)
                                        try {
                                            (this.animationData = t),
                                                this.initialSegment
                                                    ? ((this.totalFrames = Math.floor(
                                                          this.initialSegment[1] - this.initialSegment[0]
                                                      )),
                                                      (this.firstFrame = Math.round(this.initialSegment[0])))
                                                    : ((this.totalFrames = Math.floor(
                                                          this.animationData.op - this.animationData.ip
                                                      )),
                                                      (this.firstFrame = Math.round(this.animationData.ip))),
                                                this.renderer.configAnimation(t),
                                                t.assets || (t.assets = []),
                                                (this.assets = this.animationData.assets),
                                                (this.frameRate = this.animationData.fr),
                                                (this.frameMult = this.animationData.fr / 1e3),
                                                this.renderer.searchExtraCompositions(t.assets),
                                                (this.markers = markerParser(t.markers || [])),
                                                this.trigger("config_ready"),
                                                this.preloadImages(),
                                                this.loadSegments(),
                                                this.updaFrameModifier(),
                                                this.waitForFontsLoaded(),
                                                this.isPaused && this.audioController.pause();
                                        } catch (t) {
                                            this.triggerConfigError(t);
                                        }
                                }),
                                (AnimationItem.prototype.waitForFontsLoaded = function () {
                                    this.renderer &&
                                        (this.renderer.globalData.fontManager.isLoaded
                                            ? this.checkLoaded()
                                            : setTimeout(this.waitForFontsLoaded.bind(this), 20));
                                }),
                                (AnimationItem.prototype.checkLoaded = function () {
                                    if (
                                        !this.isLoaded &&
                                        this.renderer.globalData.fontManager.isLoaded &&
                                        (this.imagePreloader.loadedImages() ||
                                            "canvas" !== this.renderer.rendererType) &&
                                        this.imagePreloader.loadedFootages()
                                    ) {
                                        this.isLoaded = !0;
                                        var t = getExpressionsPlugin();
                                        t && t.initExpressions(this),
                                            this.renderer.initItems(),
                                            setTimeout(
                                                function () {
                                                    this.trigger("DOMLoaded");
                                                }.bind(this),
                                                0
                                            ),
                                            this.gotoFrame(),
                                            this.autoplay && this.play();
                                    }
                                }),
                                (AnimationItem.prototype.resize = function (t, e) {
                                    var r = "number" == typeof t ? t : void 0,
                                        i = "number" == typeof e ? e : void 0;
                                    this.renderer.updateContainerSize(r, i);
                                }),
                                (AnimationItem.prototype.setSubframe = function (t) {
                                    this.isSubframeEnabled = !!t;
                                }),
                                (AnimationItem.prototype.gotoFrame = function () {
                                    (this.currentFrame = this.isSubframeEnabled
                                        ? this.currentRawFrame
                                        : ~~this.currentRawFrame),
                                        this.timeCompleted !== this.totalFrames &&
                                            this.currentFrame > this.timeCompleted &&
                                            (this.currentFrame = this.timeCompleted),
                                        this.trigger("enterFrame"),
                                        this.renderFrame(),
                                        this.trigger("drawnFrame");
                                }),
                                (AnimationItem.prototype.renderFrame = function () {
                                    if (!1 !== this.isLoaded && this.renderer)
                                        try {
                                            this.renderer.renderFrame(this.currentFrame + this.firstFrame);
                                        } catch (t) {
                                            this.triggerRenderFrameError(t);
                                        }
                                }),
                                (AnimationItem.prototype.play = function (t) {
                                    (t && this.name !== t) ||
                                        (!0 === this.isPaused &&
                                            ((this.isPaused = !1),
                                            this.trigger("_pause"),
                                            this.audioController.resume(),
                                            this._idle && ((this._idle = !1), this.trigger("_active"))));
                                }),
                                (AnimationItem.prototype.pause = function (t) {
                                    (t && this.name !== t) ||
                                        (!1 === this.isPaused &&
                                            ((this.isPaused = !0),
                                            this.trigger("_play"),
                                            (this._idle = !0),
                                            this.trigger("_idle"),
                                            this.audioController.pause()));
                                }),
                                (AnimationItem.prototype.togglePause = function (t) {
                                    (t && this.name !== t) || (!0 === this.isPaused ? this.play() : this.pause());
                                }),
                                (AnimationItem.prototype.stop = function (t) {
                                    (t && this.name !== t) ||
                                        (this.pause(),
                                        (this.playCount = 0),
                                        (this._completedLoop = !1),
                                        this.setCurrentRawFrameValue(0));
                                }),
                                (AnimationItem.prototype.getMarkerData = function (t) {
                                    for (var e, r = 0; r < this.markers.length; r += 1)
                                        if ((e = this.markers[r]).payload && e.payload.name === t) return e;
                                    return null;
                                }),
                                (AnimationItem.prototype.goToAndStop = function (t, e, r) {
                                    if (!r || this.name === r) {
                                        var i = Number(t);
                                        if (isNaN(i)) {
                                            var n = this.getMarkerData(t);
                                            n && this.goToAndStop(n.time, !0);
                                        } else
                                            e
                                                ? this.setCurrentRawFrameValue(t)
                                                : this.setCurrentRawFrameValue(t * this.frameModifier);
                                        this.pause();
                                    }
                                }),
                                (AnimationItem.prototype.goToAndPlay = function (t, e, r) {
                                    if (!r || this.name === r) {
                                        var i = Number(t);
                                        if (isNaN(i)) {
                                            var n = this.getMarkerData(t);
                                            n &&
                                                (n.duration
                                                    ? this.playSegments([n.time, n.time + n.duration], !0)
                                                    : this.goToAndStop(n.time, !0));
                                        } else this.goToAndStop(i, e, r);
                                        this.play();
                                    }
                                }),
                                (AnimationItem.prototype.advanceTime = function (t) {
                                    if (!0 !== this.isPaused && !1 !== this.isLoaded) {
                                        var e = this.currentRawFrame + t * this.frameModifier,
                                            r = !1;
                                        e >= this.totalFrames - 1 && this.frameModifier > 0
                                            ? this.loop && this.playCount !== this.loop
                                                ? e >= this.totalFrames
                                                    ? ((this.playCount += 1),
                                                      this.checkSegments(e % this.totalFrames) ||
                                                          (this.setCurrentRawFrameValue(e % this.totalFrames),
                                                          (this._completedLoop = !0),
                                                          this.trigger("loopComplete")))
                                                    : this.setCurrentRawFrameValue(e)
                                                : this.checkSegments(e > this.totalFrames ? e % this.totalFrames : 0) ||
                                                  ((r = !0), (e = this.totalFrames - 1))
                                            : e < 0
                                              ? this.checkSegments(e % this.totalFrames) ||
                                                (!this.loop || (this.playCount-- <= 0 && !0 !== this.loop)
                                                    ? ((r = !0), (e = 0))
                                                    : (this.setCurrentRawFrameValue(
                                                          this.totalFrames + (e % this.totalFrames)
                                                      ),
                                                      this._completedLoop
                                                          ? this.trigger("loopComplete")
                                                          : (this._completedLoop = !0)))
                                              : this.setCurrentRawFrameValue(e),
                                            r &&
                                                (this.setCurrentRawFrameValue(e),
                                                this.pause(),
                                                this.trigger("complete"));
                                    }
                                }),
                                (AnimationItem.prototype.adjustSegment = function (t, e) {
                                    (this.playCount = 0),
                                        t[1] < t[0]
                                            ? (this.frameModifier > 0 &&
                                                  (this.playSpeed < 0
                                                      ? this.setSpeed(-this.playSpeed)
                                                      : this.setDirection(-1)),
                                              (this.totalFrames = t[0] - t[1]),
                                              (this.timeCompleted = this.totalFrames),
                                              (this.firstFrame = t[1]),
                                              this.setCurrentRawFrameValue(this.totalFrames - 0.001 - e))
                                            : t[1] > t[0] &&
                                              (this.frameModifier < 0 &&
                                                  (this.playSpeed < 0
                                                      ? this.setSpeed(-this.playSpeed)
                                                      : this.setDirection(1)),
                                              (this.totalFrames = t[1] - t[0]),
                                              (this.timeCompleted = this.totalFrames),
                                              (this.firstFrame = t[0]),
                                              this.setCurrentRawFrameValue(0.001 + e)),
                                        this.trigger("segmentStart");
                                }),
                                (AnimationItem.prototype.setSegment = function (t, e) {
                                    var r = -1;
                                    this.isPaused &&
                                        (this.currentRawFrame + this.firstFrame < t
                                            ? (r = t)
                                            : this.currentRawFrame + this.firstFrame > e && (r = e - t)),
                                        (this.firstFrame = t),
                                        (this.totalFrames = e - t),
                                        (this.timeCompleted = this.totalFrames),
                                        -1 !== r && this.goToAndStop(r, !0);
                                }),
                                (AnimationItem.prototype.playSegments = function (t, e) {
                                    if ((e && (this.segments.length = 0), "object" === _typeof$4(t[0]))) {
                                        var r,
                                            i = t.length;
                                        for (r = 0; r < i; r += 1) this.segments.push(t[r]);
                                    } else this.segments.push(t);
                                    this.segments.length && e && this.adjustSegment(this.segments.shift(), 0),
                                        this.isPaused && this.play();
                                }),
                                (AnimationItem.prototype.resetSegments = function (t) {
                                    (this.segments.length = 0),
                                        this.segments.push([this.animationData.ip, this.animationData.op]),
                                        t && this.checkSegments(0);
                                }),
                                (AnimationItem.prototype.checkSegments = function (t) {
                                    return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t), !0);
                                }),
                                (AnimationItem.prototype.destroy = function (t) {
                                    (t && this.name !== t) ||
                                        !this.renderer ||
                                        (this.renderer.destroy(),
                                        this.imagePreloader.destroy(),
                                        this.trigger("destroy"),
                                        (this._cbs = null),
                                        (this.onEnterFrame = null),
                                        (this.onLoopComplete = null),
                                        (this.onComplete = null),
                                        (this.onSegmentStart = null),
                                        (this.onDestroy = null),
                                        (this.renderer = null),
                                        (this.renderer = null),
                                        (this.imagePreloader = null),
                                        (this.projectInterface = null));
                                }),
                                (AnimationItem.prototype.setCurrentRawFrameValue = function (t) {
                                    (this.currentRawFrame = t), this.gotoFrame();
                                }),
                                (AnimationItem.prototype.setSpeed = function (t) {
                                    (this.playSpeed = t), this.updaFrameModifier();
                                }),
                                (AnimationItem.prototype.setDirection = function (t) {
                                    (this.playDirection = t < 0 ? -1 : 1), this.updaFrameModifier();
                                }),
                                (AnimationItem.prototype.setVolume = function (t, e) {
                                    (e && this.name !== e) || this.audioController.setVolume(t);
                                }),
                                (AnimationItem.prototype.getVolume = function () {
                                    return this.audioController.getVolume();
                                }),
                                (AnimationItem.prototype.mute = function (t) {
                                    (t && this.name !== t) || this.audioController.mute();
                                }),
                                (AnimationItem.prototype.unmute = function (t) {
                                    (t && this.name !== t) || this.audioController.unmute();
                                }),
                                (AnimationItem.prototype.updaFrameModifier = function () {
                                    (this.frameModifier = this.frameMult * this.playSpeed * this.playDirection),
                                        this.audioController.setRate(this.playSpeed * this.playDirection);
                                }),
                                (AnimationItem.prototype.getPath = function () {
                                    return this.path;
                                }),
                                (AnimationItem.prototype.getAssetsPath = function (t) {
                                    var e = "";
                                    if (t.e) e = t.p;
                                    else if (this.assetsPath) {
                                        var r = t.p;
                                        -1 !== r.indexOf("images/") && (r = r.split("/")[1]), (e = this.assetsPath + r);
                                    } else (e = this.path), (e += t.u ? t.u : ""), (e += t.p);
                                    return e;
                                }),
                                (AnimationItem.prototype.getAssetData = function (t) {
                                    for (var e = 0, r = this.assets.length; e < r; ) {
                                        if (t === this.assets[e].id) return this.assets[e];
                                        e += 1;
                                    }
                                    return null;
                                }),
                                (AnimationItem.prototype.hide = function () {
                                    this.renderer.hide();
                                }),
                                (AnimationItem.prototype.show = function () {
                                    this.renderer.show();
                                }),
                                (AnimationItem.prototype.getDuration = function (t) {
                                    return t ? this.totalFrames : this.totalFrames / this.frameRate;
                                }),
                                (AnimationItem.prototype.updateDocumentData = function (t, e, r) {
                                    try {
                                        this.renderer.getElementByPath(t).updateDocumentData(e, r);
                                    } catch (t) {}
                                }),
                                (AnimationItem.prototype.trigger = function (t) {
                                    if (this._cbs && this._cbs[t])
                                        switch (t) {
                                            case "enterFrame":
                                                this.triggerEvent(
                                                    t,
                                                    new BMEnterFrameEvent(
                                                        t,
                                                        this.currentFrame,
                                                        this.totalFrames,
                                                        this.frameModifier
                                                    )
                                                );
                                                break;
                                            case "drawnFrame":
                                                (this.drawnFrameEvent.currentTime = this.currentFrame),
                                                    (this.drawnFrameEvent.totalTime = this.totalFrames),
                                                    (this.drawnFrameEvent.direction = this.frameModifier),
                                                    this.triggerEvent(t, this.drawnFrameEvent);
                                                break;
                                            case "loopComplete":
                                                this.triggerEvent(
                                                    t,
                                                    new BMCompleteLoopEvent(
                                                        t,
                                                        this.loop,
                                                        this.playCount,
                                                        this.frameMult
                                                    )
                                                );
                                                break;
                                            case "complete":
                                                this.triggerEvent(t, new BMCompleteEvent(t, this.frameMult));
                                                break;
                                            case "segmentStart":
                                                this.triggerEvent(
                                                    t,
                                                    new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)
                                                );
                                                break;
                                            case "destroy":
                                                this.triggerEvent(t, new BMDestroyEvent(t, this));
                                                break;
                                            default:
                                                this.triggerEvent(t);
                                        }
                                    "enterFrame" === t &&
                                        this.onEnterFrame &&
                                        this.onEnterFrame.call(
                                            this,
                                            new BMEnterFrameEvent(
                                                t,
                                                this.currentFrame,
                                                this.totalFrames,
                                                this.frameMult
                                            )
                                        ),
                                        "loopComplete" === t &&
                                            this.onLoopComplete &&
                                            this.onLoopComplete.call(
                                                this,
                                                new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult)
                                            ),
                                        "complete" === t &&
                                            this.onComplete &&
                                            this.onComplete.call(this, new BMCompleteEvent(t, this.frameMult)),
                                        "segmentStart" === t &&
                                            this.onSegmentStart &&
                                            this.onSegmentStart.call(
                                                this,
                                                new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)
                                            ),
                                        "destroy" === t &&
                                            this.onDestroy &&
                                            this.onDestroy.call(this, new BMDestroyEvent(t, this));
                                }),
                                (AnimationItem.prototype.triggerRenderFrameError = function (t) {
                                    var e = new BMRenderFrameErrorEvent(t, this.currentFrame);
                                    this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
                                }),
                                (AnimationItem.prototype.triggerConfigError = function (t) {
                                    var e = new BMConfigErrorEvent(t, this.currentFrame);
                                    this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
                                });
                            var animationManager = (function () {
                                    var t = {},
                                        e = [],
                                        r = 0,
                                        i = 0,
                                        n = 0,
                                        s = !0,
                                        a = !1;
                                    function o(t) {
                                        for (var r = 0, n = t.target; r < i; )
                                            e[r].animation === n &&
                                                (e.splice(r, 1), (r -= 1), (i -= 1), n.isPaused || p()),
                                                (r += 1);
                                    }
                                    function l(t, r) {
                                        if (!t) return null;
                                        for (var n = 0; n < i; ) {
                                            if (e[n].elem === t && null !== e[n].elem) return e[n].animation;
                                            n += 1;
                                        }
                                        var s = new AnimationItem();
                                        return c(s, t), s.setData(t, r), s;
                                    }
                                    function h() {
                                        (n += 1), f();
                                    }
                                    function p() {
                                        n -= 1;
                                    }
                                    function c(t, r) {
                                        t.addEventListener("destroy", o),
                                            t.addEventListener("_active", h),
                                            t.addEventListener("_idle", p),
                                            e.push({ elem: r, animation: t }),
                                            (i += 1);
                                    }
                                    function d(t) {
                                        var o,
                                            l = t - r;
                                        for (o = 0; o < i; o += 1) e[o].animation.advanceTime(l);
                                        (r = t), n && !a ? window.requestAnimationFrame(d) : (s = !0);
                                    }
                                    function u(t) {
                                        (r = t), window.requestAnimationFrame(d);
                                    }
                                    function f() {
                                        !a && n && s && (window.requestAnimationFrame(u), (s = !1));
                                    }
                                    return (
                                        (t.registerAnimation = l),
                                        (t.loadAnimation = function (t) {
                                            var e = new AnimationItem();
                                            return c(e, null), e.setParams(t), e;
                                        }),
                                        (t.setSpeed = function (t, r) {
                                            var n;
                                            for (n = 0; n < i; n += 1) e[n].animation.setSpeed(t, r);
                                        }),
                                        (t.setDirection = function (t, r) {
                                            var n;
                                            for (n = 0; n < i; n += 1) e[n].animation.setDirection(t, r);
                                        }),
                                        (t.play = function (t) {
                                            var r;
                                            for (r = 0; r < i; r += 1) e[r].animation.play(t);
                                        }),
                                        (t.pause = function (t) {
                                            var r;
                                            for (r = 0; r < i; r += 1) e[r].animation.pause(t);
                                        }),
                                        (t.stop = function (t) {
                                            var r;
                                            for (r = 0; r < i; r += 1) e[r].animation.stop(t);
                                        }),
                                        (t.togglePause = function (t) {
                                            var r;
                                            for (r = 0; r < i; r += 1) e[r].animation.togglePause(t);
                                        }),
                                        (t.searchAnimations = function (t, e, r) {
                                            var i,
                                                n = [].concat(
                                                    [].slice.call(document.getElementsByClassName("lottie")),
                                                    [].slice.call(document.getElementsByClassName("bodymovin"))
                                                ),
                                                s = n.length;
                                            for (i = 0; i < s; i += 1)
                                                r && n[i].setAttribute("data-bm-type", r), l(n[i], t);
                                            if (e && 0 === s) {
                                                r || (r = "svg");
                                                var a = document.getElementsByTagName("body")[0];
                                                a.innerText = "";
                                                var o = createTag("div");
                                                (o.style.width = "100%"),
                                                    (o.style.height = "100%"),
                                                    o.setAttribute("data-bm-type", r),
                                                    a.appendChild(o),
                                                    l(o, t);
                                            }
                                        }),
                                        (t.resize = function () {
                                            var t;
                                            for (t = 0; t < i; t += 1) e[t].animation.resize();
                                        }),
                                        (t.goToAndStop = function (t, r, n) {
                                            var s;
                                            for (s = 0; s < i; s += 1) e[s].animation.goToAndStop(t, r, n);
                                        }),
                                        (t.destroy = function (t) {
                                            var r;
                                            for (r = i - 1; r >= 0; r -= 1) e[r].animation.destroy(t);
                                        }),
                                        (t.freeze = function () {
                                            a = !0;
                                        }),
                                        (t.unfreeze = function () {
                                            (a = !1), f();
                                        }),
                                        (t.setVolume = function (t, r) {
                                            var n;
                                            for (n = 0; n < i; n += 1) e[n].animation.setVolume(t, r);
                                        }),
                                        (t.mute = function (t) {
                                            var r;
                                            for (r = 0; r < i; r += 1) e[r].animation.mute(t);
                                        }),
                                        (t.unmute = function (t) {
                                            var r;
                                            for (r = 0; r < i; r += 1) e[r].animation.unmute(t);
                                        }),
                                        (t.getRegisteredAnimations = function () {
                                            var t,
                                                r = e.length,
                                                i = [];
                                            for (t = 0; t < r; t += 1) i.push(e[t].animation);
                                            return i;
                                        }),
                                        t
                                    );
                                })(),
                                BezierFactory = (function () {
                                    var t = {
                                            getBezierEasing: function (t, r, i, n, s) {
                                                var a =
                                                    s || ("bez_" + t + "_" + r + "_" + i + "_" + n).replace(/\./g, "p");
                                                if (e[a]) return e[a];
                                                var o = new h([t, r, i, n]);
                                                return (e[a] = o), o;
                                            },
                                        },
                                        e = {},
                                        r = 0.1,
                                        i = "function" == typeof Float32Array;
                                    function n(t, e) {
                                        return 1 - 3 * e + 3 * t;
                                    }
                                    function s(t, e) {
                                        return 3 * e - 6 * t;
                                    }
                                    function a(t) {
                                        return 3 * t;
                                    }
                                    function o(t, e, r) {
                                        return ((n(e, r) * t + s(e, r)) * t + a(e)) * t;
                                    }
                                    function l(t, e, r) {
                                        return 3 * n(e, r) * t * t + 2 * s(e, r) * t + a(e);
                                    }
                                    function h(t) {
                                        (this._p = t),
                                            (this._mSampleValues = i ? new Float32Array(11) : new Array(11)),
                                            (this._precomputed = !1),
                                            (this.get = this.get.bind(this));
                                    }
                                    return (
                                        (h.prototype = {
                                            get: function (t) {
                                                var e = this._p[0],
                                                    r = this._p[1],
                                                    i = this._p[2],
                                                    n = this._p[3];
                                                return (
                                                    this._precomputed || this._precompute(),
                                                    e === r && i === n
                                                        ? t
                                                        : 0 === t
                                                          ? 0
                                                          : 1 === t
                                                            ? 1
                                                            : o(this._getTForX(t), r, n)
                                                );
                                            },
                                            _precompute: function () {
                                                var t = this._p[0],
                                                    e = this._p[1],
                                                    r = this._p[2],
                                                    i = this._p[3];
                                                (this._precomputed = !0),
                                                    (t === e && r === i) || this._calcSampleValues();
                                            },
                                            _calcSampleValues: function () {
                                                for (var t = this._p[0], e = this._p[2], i = 0; i < 11; ++i)
                                                    this._mSampleValues[i] = o(i * r, t, e);
                                            },
                                            _getTForX: function (t) {
                                                for (
                                                    var e = this._p[0],
                                                        i = this._p[2],
                                                        n = this._mSampleValues,
                                                        s = 0,
                                                        a = 1;
                                                    10 !== a && n[a] <= t;
                                                    ++a
                                                )
                                                    s += r;
                                                var h = s + ((t - n[--a]) / (n[a + 1] - n[a])) * r,
                                                    p = l(h, e, i);
                                                return p >= 0.001
                                                    ? (function (t, e, r, i) {
                                                          for (var n = 0; n < 4; ++n) {
                                                              var s = l(e, r, i);
                                                              if (0 === s) return e;
                                                              e -= (o(e, r, i) - t) / s;
                                                          }
                                                          return e;
                                                      })(t, h, e, i)
                                                    : 0 === p
                                                      ? h
                                                      : (function (t, e, r, i, n) {
                                                            var s,
                                                                a,
                                                                l = 0;
                                                            do {
                                                                (s = o((a = e + (r - e) / 2), i, n) - t) > 0
                                                                    ? (r = a)
                                                                    : (e = a);
                                                            } while (Math.abs(s) > 1e-7 && ++l < 10);
                                                            return a;
                                                        })(t, s, s + r, e, i);
                                            },
                                        }),
                                        t
                                    );
                                })(),
                                pooling = {
                                    double: function (t) {
                                        return t.concat(createSizedArray(t.length));
                                    },
                                },
                                poolFactory = function (t, e, r) {
                                    var i = 0,
                                        n = t,
                                        s = createSizedArray(n);
                                    return {
                                        newElement: function () {
                                            return i ? s[(i -= 1)] : e();
                                        },
                                        release: function (t) {
                                            i === n && ((s = pooling.double(s)), (n *= 2)),
                                                r && r(t),
                                                (s[i] = t),
                                                (i += 1);
                                        },
                                    };
                                },
                                bezierLengthPool = poolFactory(8, function () {
                                    return {
                                        addedLength: 0,
                                        percents: createTypedArray("float32", getDefaultCurveSegments()),
                                        lengths: createTypedArray("float32", getDefaultCurveSegments()),
                                    };
                                }),
                                segmentsLengthPool = poolFactory(
                                    8,
                                    function () {
                                        return { lengths: [], totalLength: 0 };
                                    },
                                    function (t) {
                                        var e,
                                            r = t.lengths.length;
                                        for (e = 0; e < r; e += 1) bezierLengthPool.release(t.lengths[e]);
                                        t.lengths.length = 0;
                                    }
                                );
                            function bezFunction() {
                                var t = Math;
                                function e(t, e, r, i, n, s) {
                                    var a = t * i + e * n + r * s - n * i - s * t - r * e;
                                    return a > -0.001 && a < 0.001;
                                }
                                var r = function (t, e, r, i) {
                                    var n,
                                        s,
                                        a,
                                        o,
                                        l,
                                        h,
                                        p = getDefaultCurveSegments(),
                                        c = 0,
                                        d = [],
                                        u = [],
                                        f = bezierLengthPool.newElement();
                                    for (a = r.length, n = 0; n < p; n += 1) {
                                        for (l = n / (p - 1), h = 0, s = 0; s < a; s += 1)
                                            (o =
                                                bmPow(1 - l, 3) * t[s] +
                                                3 * bmPow(1 - l, 2) * l * r[s] +
                                                3 * (1 - l) * bmPow(l, 2) * i[s] +
                                                bmPow(l, 3) * e[s]),
                                                (d[s] = o),
                                                null !== u[s] && (h += bmPow(d[s] - u[s], 2)),
                                                (u[s] = d[s]);
                                        h && (c += h = bmSqrt(h)), (f.percents[n] = l), (f.lengths[n] = c);
                                    }
                                    return (f.addedLength = c), f;
                                };
                                function i(t) {
                                    (this.segmentLength = 0), (this.points = new Array(t));
                                }
                                function n(t, e) {
                                    (this.partialLength = t), (this.point = e);
                                }
                                var s,
                                    a =
                                        ((s = {}),
                                        function (t, r, a, o) {
                                            var l = (
                                                t[0] +
                                                "_" +
                                                t[1] +
                                                "_" +
                                                r[0] +
                                                "_" +
                                                r[1] +
                                                "_" +
                                                a[0] +
                                                "_" +
                                                a[1] +
                                                "_" +
                                                o[0] +
                                                "_" +
                                                o[1]
                                            ).replace(/\./g, "p");
                                            if (!s[l]) {
                                                var h,
                                                    p,
                                                    c,
                                                    d,
                                                    u,
                                                    f,
                                                    m,
                                                    g = getDefaultCurveSegments(),
                                                    y = 0,
                                                    v = null;
                                                2 === t.length &&
                                                    (t[0] !== r[0] || t[1] !== r[1]) &&
                                                    e(t[0], t[1], r[0], r[1], t[0] + a[0], t[1] + a[1]) &&
                                                    e(t[0], t[1], r[0], r[1], r[0] + o[0], r[1] + o[1]) &&
                                                    (g = 2);
                                                var b = new i(g);
                                                for (c = a.length, h = 0; h < g; h += 1) {
                                                    for (
                                                        m = createSizedArray(c), u = h / (g - 1), f = 0, p = 0;
                                                        p < c;
                                                        p += 1
                                                    )
                                                        (d =
                                                            bmPow(1 - u, 3) * t[p] +
                                                            3 * bmPow(1 - u, 2) * u * (t[p] + a[p]) +
                                                            3 * (1 - u) * bmPow(u, 2) * (r[p] + o[p]) +
                                                            bmPow(u, 3) * r[p]),
                                                            (m[p] = d),
                                                            null !== v && (f += bmPow(m[p] - v[p], 2));
                                                    (y += f = bmSqrt(f)), (b.points[h] = new n(f, m)), (v = m);
                                                }
                                                (b.segmentLength = y), (s[l] = b);
                                            }
                                            return s[l];
                                        });
                                function o(t, e) {
                                    var r = e.percents,
                                        i = e.lengths,
                                        n = r.length,
                                        s = bmFloor((n - 1) * t),
                                        a = t * e.addedLength,
                                        o = 0;
                                    if (s === n - 1 || 0 === s || a === i[s]) return r[s];
                                    for (var l = i[s] > a ? -1 : 1, h = !0; h; )
                                        if (
                                            (i[s] <= a && i[s + 1] > a
                                                ? ((o = (a - i[s]) / (i[s + 1] - i[s])), (h = !1))
                                                : (s += l),
                                            s < 0 || s >= n - 1)
                                        ) {
                                            if (s === n - 1) return r[s];
                                            h = !1;
                                        }
                                    return r[s] + (r[s + 1] - r[s]) * o;
                                }
                                var l = createTypedArray("float32", 8);
                                return {
                                    getSegmentsLength: function (t) {
                                        var e,
                                            i = segmentsLengthPool.newElement(),
                                            n = t.c,
                                            s = t.v,
                                            a = t.o,
                                            o = t.i,
                                            l = t._length,
                                            h = i.lengths,
                                            p = 0;
                                        for (e = 0; e < l - 1; e += 1)
                                            (h[e] = r(s[e], s[e + 1], a[e], o[e + 1])), (p += h[e].addedLength);
                                        return (
                                            n && l && ((h[e] = r(s[e], s[0], a[e], o[0])), (p += h[e].addedLength)),
                                            (i.totalLength = p),
                                            i
                                        );
                                    },
                                    getNewSegment: function (e, r, i, n, s, a, h) {
                                        s < 0 ? (s = 0) : s > 1 && (s = 1);
                                        var p,
                                            c = o(s, h),
                                            d = o((a = a > 1 ? 1 : a), h),
                                            u = e.length,
                                            f = 1 - c,
                                            m = 1 - d,
                                            g = f * f * f,
                                            y = c * f * f * 3,
                                            v = c * c * f * 3,
                                            b = c * c * c,
                                            _ = f * f * m,
                                            x = c * f * m + f * c * m + f * f * d,
                                            S = c * c * m + f * c * d + c * f * d,
                                            E = c * c * d,
                                            w = f * m * m,
                                            P = c * m * m + f * d * m + f * m * d,
                                            T = c * d * m + f * d * d + c * m * d,
                                            C = c * d * d,
                                            A = m * m * m,
                                            k = d * m * m + m * d * m + m * m * d,
                                            M = d * d * m + m * d * d + d * m * d,
                                            D = d * d * d;
                                        for (p = 0; p < u; p += 1)
                                            (l[4 * p] =
                                                t.round(1e3 * (g * e[p] + y * i[p] + v * n[p] + b * r[p])) / 1e3),
                                                (l[4 * p + 1] =
                                                    t.round(1e3 * (_ * e[p] + x * i[p] + S * n[p] + E * r[p])) / 1e3),
                                                (l[4 * p + 2] =
                                                    t.round(1e3 * (w * e[p] + P * i[p] + T * n[p] + C * r[p])) / 1e3),
                                                (l[4 * p + 3] =
                                                    t.round(1e3 * (A * e[p] + k * i[p] + M * n[p] + D * r[p])) / 1e3);
                                        return l;
                                    },
                                    getPointInSegment: function (e, r, i, n, s, a) {
                                        var l = o(s, a),
                                            h = 1 - l;
                                        return [
                                            t.round(
                                                1e3 *
                                                    (h * h * h * e[0] +
                                                        (l * h * h + h * l * h + h * h * l) * i[0] +
                                                        (l * l * h + h * l * l + l * h * l) * n[0] +
                                                        l * l * l * r[0])
                                            ) / 1e3,
                                            t.round(
                                                1e3 *
                                                    (h * h * h * e[1] +
                                                        (l * h * h + h * l * h + h * h * l) * i[1] +
                                                        (l * l * h + h * l * l + l * h * l) * n[1] +
                                                        l * l * l * r[1])
                                            ) / 1e3,
                                        ];
                                    },
                                    buildBezierData: a,
                                    pointOnLine2D: e,
                                    pointOnLine3D: function (r, i, n, s, a, o, l, h, p) {
                                        if (0 === n && 0 === o && 0 === p) return e(r, i, s, a, l, h);
                                        var c,
                                            d = t.sqrt(t.pow(s - r, 2) + t.pow(a - i, 2) + t.pow(o - n, 2)),
                                            u = t.sqrt(t.pow(l - r, 2) + t.pow(h - i, 2) + t.pow(p - n, 2)),
                                            f = t.sqrt(t.pow(l - s, 2) + t.pow(h - a, 2) + t.pow(p - o, 2));
                                        return (
                                            (c =
                                                d > u
                                                    ? d > f
                                                        ? d - u - f
                                                        : f - u - d
                                                    : f > u
                                                      ? f - u - d
                                                      : u - d - f) > -1e-4 && c < 1e-4
                                        );
                                    },
                                };
                            }
                            var bez = bezFunction(),
                                PropertyFactory = (function () {
                                    var t = initialDefaultFrame,
                                        e = Math.abs;
                                    function r(t, e) {
                                        var r,
                                            n = this.offsetTime;
                                        "multidimensional" === this.propType &&
                                            (r = createTypedArray("float32", this.pv.length));
                                        for (
                                            var s,
                                                a,
                                                o,
                                                l,
                                                h,
                                                p,
                                                c,
                                                d,
                                                u,
                                                f = e.lastIndex,
                                                m = f,
                                                g = this.keyframes.length - 1,
                                                y = !0;
                                            y;

                                        ) {
                                            if (
                                                ((s = this.keyframes[m]),
                                                (a = this.keyframes[m + 1]),
                                                m === g - 1 && t >= a.t - n)
                                            ) {
                                                s.h && (s = a), (f = 0);
                                                break;
                                            }
                                            if (a.t - n > t) {
                                                f = m;
                                                break;
                                            }
                                            m < g - 1 ? (m += 1) : ((f = 0), (y = !1));
                                        }
                                        o = this.keyframesMetadata[m] || {};
                                        var v,
                                            b,
                                            _,
                                            x,
                                            S,
                                            E,
                                            w,
                                            P,
                                            T,
                                            C,
                                            A = a.t - n,
                                            k = s.t - n;
                                        if (s.to) {
                                            o.bezierData ||
                                                (o.bezierData = bez.buildBezierData(s.s, a.s || s.e, s.to, s.ti));
                                            var M = o.bezierData;
                                            if (t >= A || t < k) {
                                                var D = t >= A ? M.points.length - 1 : 0;
                                                for (h = M.points[D].point.length, l = 0; l < h; l += 1)
                                                    r[l] = M.points[D].point[l];
                                            } else {
                                                o.__fnct
                                                    ? (u = o.__fnct)
                                                    : ((u = BezierFactory.getBezierEasing(
                                                          s.o.x,
                                                          s.o.y,
                                                          s.i.x,
                                                          s.i.y,
                                                          s.n
                                                      ).get),
                                                      (o.__fnct = u)),
                                                    (p = u((t - k) / (A - k)));
                                                var F,
                                                    I = M.segmentLength * p,
                                                    L =
                                                        e.lastFrame < t && e._lastKeyframeIndex === m
                                                            ? e._lastAddedLength
                                                            : 0;
                                                for (
                                                    d =
                                                        e.lastFrame < t && e._lastKeyframeIndex === m
                                                            ? e._lastPoint
                                                            : 0,
                                                        y = !0,
                                                        c = M.points.length;
                                                    y;

                                                ) {
                                                    if (
                                                        ((L += M.points[d].partialLength),
                                                        0 === I || 0 === p || d === M.points.length - 1)
                                                    ) {
                                                        for (h = M.points[d].point.length, l = 0; l < h; l += 1)
                                                            r[l] = M.points[d].point[l];
                                                        break;
                                                    }
                                                    if (I >= L && I < L + M.points[d + 1].partialLength) {
                                                        for (
                                                            F = (I - L) / M.points[d + 1].partialLength,
                                                                h = M.points[d].point.length,
                                                                l = 0;
                                                            l < h;
                                                            l += 1
                                                        )
                                                            r[l] =
                                                                M.points[d].point[l] +
                                                                (M.points[d + 1].point[l] - M.points[d].point[l]) * F;
                                                        break;
                                                    }
                                                    d < c - 1 ? (d += 1) : (y = !1);
                                                }
                                                (e._lastPoint = d),
                                                    (e._lastAddedLength = L - M.points[d].partialLength),
                                                    (e._lastKeyframeIndex = m);
                                            }
                                        } else {
                                            var B, V, R, O, z;
                                            if (((g = s.s.length), (v = a.s || s.e), this.sh && 1 !== s.h))
                                                t >= A
                                                    ? ((r[0] = v[0]), (r[1] = v[1]), (r[2] = v[2]))
                                                    : t <= k
                                                      ? ((r[0] = s.s[0]), (r[1] = s.s[1]), (r[2] = s.s[2]))
                                                      : ((b = r),
                                                        (x = (_ = (function (t, e, r) {
                                                            var i,
                                                                n,
                                                                s,
                                                                a,
                                                                o,
                                                                l = [],
                                                                h = t[0],
                                                                p = t[1],
                                                                c = t[2],
                                                                d = t[3],
                                                                u = e[0],
                                                                f = e[1],
                                                                m = e[2],
                                                                g = e[3];
                                                            return (
                                                                (n = h * u + p * f + c * m + d * g) < 0 &&
                                                                    ((n = -n), (u = -u), (f = -f), (m = -m), (g = -g)),
                                                                1 - n > 1e-6
                                                                    ? ((i = Math.acos(n)),
                                                                      (s = Math.sin(i)),
                                                                      (a = Math.sin((1 - r) * i) / s),
                                                                      (o = Math.sin(r * i) / s))
                                                                    : ((a = 1 - r), (o = r)),
                                                                (l[0] = a * h + o * u),
                                                                (l[1] = a * p + o * f),
                                                                (l[2] = a * c + o * m),
                                                                (l[3] = a * d + o * g),
                                                                l
                                                            );
                                                        })(i(s.s), i(v), (t - k) / (A - k)))[0]),
                                                        (S = _[1]),
                                                        (E = _[2]),
                                                        (w = _[3]),
                                                        (P = Math.atan2(
                                                            2 * S * w - 2 * x * E,
                                                            1 - 2 * S * S - 2 * E * E
                                                        )),
                                                        (T = Math.asin(2 * x * S + 2 * E * w)),
                                                        (C = Math.atan2(
                                                            2 * x * w - 2 * S * E,
                                                            1 - 2 * x * x - 2 * E * E
                                                        )),
                                                        (b[0] = P / degToRads),
                                                        (b[1] = T / degToRads),
                                                        (b[2] = C / degToRads));
                                            else
                                                for (m = 0; m < g; m += 1)
                                                    1 !== s.h &&
                                                        (t >= A
                                                            ? (p = 1)
                                                            : t < k
                                                              ? (p = 0)
                                                              : (s.o.x.constructor === Array
                                                                    ? (o.__fnct || (o.__fnct = []),
                                                                      o.__fnct[m]
                                                                          ? (u = o.__fnct[m])
                                                                          : ((B =
                                                                                void 0 === s.o.x[m]
                                                                                    ? s.o.x[0]
                                                                                    : s.o.x[m]),
                                                                            (V =
                                                                                void 0 === s.o.y[m]
                                                                                    ? s.o.y[0]
                                                                                    : s.o.y[m]),
                                                                            (R =
                                                                                void 0 === s.i.x[m]
                                                                                    ? s.i.x[0]
                                                                                    : s.i.x[m]),
                                                                            (O =
                                                                                void 0 === s.i.y[m]
                                                                                    ? s.i.y[0]
                                                                                    : s.i.y[m]),
                                                                            (u = BezierFactory.getBezierEasing(
                                                                                B,
                                                                                V,
                                                                                R,
                                                                                O
                                                                            ).get),
                                                                            (o.__fnct[m] = u)))
                                                                    : o.__fnct
                                                                      ? (u = o.__fnct)
                                                                      : ((B = s.o.x),
                                                                        (V = s.o.y),
                                                                        (R = s.i.x),
                                                                        (O = s.i.y),
                                                                        (u = BezierFactory.getBezierEasing(
                                                                            B,
                                                                            V,
                                                                            R,
                                                                            O
                                                                        ).get),
                                                                        (s.keyframeMetadata = u)),
                                                                (p = u((t - k) / (A - k))))),
                                                        (v = a.s || s.e),
                                                        (z = 1 === s.h ? s.s[m] : s.s[m] + (v[m] - s.s[m]) * p),
                                                        "multidimensional" === this.propType ? (r[m] = z) : (r = z);
                                        }
                                        return (e.lastIndex = f), r;
                                    }
                                    function i(t) {
                                        var e = t[0] * degToRads,
                                            r = t[1] * degToRads,
                                            i = t[2] * degToRads,
                                            n = Math.cos(e / 2),
                                            s = Math.cos(r / 2),
                                            a = Math.cos(i / 2),
                                            o = Math.sin(e / 2),
                                            l = Math.sin(r / 2),
                                            h = Math.sin(i / 2);
                                        return [
                                            o * l * a + n * s * h,
                                            o * s * a + n * l * h,
                                            n * l * a - o * s * h,
                                            n * s * a - o * l * h,
                                        ];
                                    }
                                    function n() {
                                        var e = this.comp.renderedFrame - this.offsetTime,
                                            r = this.keyframes[0].t - this.offsetTime,
                                            i = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
                                        if (
                                            !(
                                                e === this._caching.lastFrame ||
                                                (this._caching.lastFrame !== t &&
                                                    ((this._caching.lastFrame >= i && e >= i) ||
                                                        (this._caching.lastFrame < r && e < r)))
                                            )
                                        ) {
                                            this._caching.lastFrame >= e &&
                                                ((this._caching._lastKeyframeIndex = -1),
                                                (this._caching.lastIndex = 0));
                                            var n = this.interpolateValue(e, this._caching);
                                            this.pv = n;
                                        }
                                        return (this._caching.lastFrame = e), this.pv;
                                    }
                                    function s(t) {
                                        var r;
                                        if ("unidimensional" === this.propType)
                                            (r = t * this.mult),
                                                e(this.v - r) > 1e-5 && ((this.v = r), (this._mdf = !0));
                                        else
                                            for (var i = 0, n = this.v.length; i < n; )
                                                (r = t[i] * this.mult),
                                                    e(this.v[i] - r) > 1e-5 && ((this.v[i] = r), (this._mdf = !0)),
                                                    (i += 1);
                                    }
                                    function a() {
                                        if (
                                            this.elem.globalData.frameId !== this.frameId &&
                                            this.effectsSequence.length
                                        )
                                            if (this.lock) this.setVValue(this.pv);
                                            else {
                                                var t;
                                                (this.lock = !0), (this._mdf = this._isFirstFrame);
                                                var e = this.effectsSequence.length,
                                                    r = this.kf ? this.pv : this.data.k;
                                                for (t = 0; t < e; t += 1) r = this.effectsSequence[t](r);
                                                this.setVValue(r),
                                                    (this._isFirstFrame = !1),
                                                    (this.lock = !1),
                                                    (this.frameId = this.elem.globalData.frameId);
                                            }
                                    }
                                    function o(t) {
                                        this.effectsSequence.push(t), this.container.addDynamicProperty(this);
                                    }
                                    function l(t, e, r, i) {
                                        (this.propType = "unidimensional"),
                                            (this.mult = r || 1),
                                            (this.data = e),
                                            (this.v = r ? e.k * r : e.k),
                                            (this.pv = e.k),
                                            (this._mdf = !1),
                                            (this.elem = t),
                                            (this.container = i),
                                            (this.comp = t.comp),
                                            (this.k = !1),
                                            (this.kf = !1),
                                            (this.vel = 0),
                                            (this.effectsSequence = []),
                                            (this._isFirstFrame = !0),
                                            (this.getValue = a),
                                            (this.setVValue = s),
                                            (this.addEffect = o);
                                    }
                                    function h(t, e, r, i) {
                                        var n;
                                        (this.propType = "multidimensional"),
                                            (this.mult = r || 1),
                                            (this.data = e),
                                            (this._mdf = !1),
                                            (this.elem = t),
                                            (this.container = i),
                                            (this.comp = t.comp),
                                            (this.k = !1),
                                            (this.kf = !1),
                                            (this.frameId = -1);
                                        var l = e.k.length;
                                        for (
                                            this.v = createTypedArray("float32", l),
                                                this.pv = createTypedArray("float32", l),
                                                this.vel = createTypedArray("float32", l),
                                                n = 0;
                                            n < l;
                                            n += 1
                                        )
                                            (this.v[n] = e.k[n] * this.mult), (this.pv[n] = e.k[n]);
                                        (this._isFirstFrame = !0),
                                            (this.effectsSequence = []),
                                            (this.getValue = a),
                                            (this.setVValue = s),
                                            (this.addEffect = o);
                                    }
                                    function p(e, i, l, h) {
                                        (this.propType = "unidimensional"),
                                            (this.keyframes = i.k),
                                            (this.keyframesMetadata = []),
                                            (this.offsetTime = e.data.st),
                                            (this.frameId = -1),
                                            (this._caching = {
                                                lastFrame: t,
                                                lastIndex: 0,
                                                value: 0,
                                                _lastKeyframeIndex: -1,
                                            }),
                                            (this.k = !0),
                                            (this.kf = !0),
                                            (this.data = i),
                                            (this.mult = l || 1),
                                            (this.elem = e),
                                            (this.container = h),
                                            (this.comp = e.comp),
                                            (this.v = t),
                                            (this.pv = t),
                                            (this._isFirstFrame = !0),
                                            (this.getValue = a),
                                            (this.setVValue = s),
                                            (this.interpolateValue = r),
                                            (this.effectsSequence = [n.bind(this)]),
                                            (this.addEffect = o);
                                    }
                                    function c(e, i, l, h) {
                                        var p;
                                        this.propType = "multidimensional";
                                        var c,
                                            d,
                                            u,
                                            f,
                                            m = i.k.length;
                                        for (p = 0; p < m - 1; p += 1)
                                            i.k[p].to &&
                                                i.k[p].s &&
                                                i.k[p + 1] &&
                                                i.k[p + 1].s &&
                                                ((c = i.k[p].s),
                                                (d = i.k[p + 1].s),
                                                (u = i.k[p].to),
                                                (f = i.k[p].ti),
                                                ((2 === c.length &&
                                                    (c[0] !== d[0] || c[1] !== d[1]) &&
                                                    bez.pointOnLine2D(
                                                        c[0],
                                                        c[1],
                                                        d[0],
                                                        d[1],
                                                        c[0] + u[0],
                                                        c[1] + u[1]
                                                    ) &&
                                                    bez.pointOnLine2D(
                                                        c[0],
                                                        c[1],
                                                        d[0],
                                                        d[1],
                                                        d[0] + f[0],
                                                        d[1] + f[1]
                                                    )) ||
                                                    (3 === c.length &&
                                                        (c[0] !== d[0] || c[1] !== d[1] || c[2] !== d[2]) &&
                                                        bez.pointOnLine3D(
                                                            c[0],
                                                            c[1],
                                                            c[2],
                                                            d[0],
                                                            d[1],
                                                            d[2],
                                                            c[0] + u[0],
                                                            c[1] + u[1],
                                                            c[2] + u[2]
                                                        ) &&
                                                        bez.pointOnLine3D(
                                                            c[0],
                                                            c[1],
                                                            c[2],
                                                            d[0],
                                                            d[1],
                                                            d[2],
                                                            d[0] + f[0],
                                                            d[1] + f[1],
                                                            d[2] + f[2]
                                                        ))) &&
                                                    ((i.k[p].to = null), (i.k[p].ti = null)),
                                                c[0] === d[0] &&
                                                    c[1] === d[1] &&
                                                    0 === u[0] &&
                                                    0 === u[1] &&
                                                    0 === f[0] &&
                                                    0 === f[1] &&
                                                    (2 === c.length || (c[2] === d[2] && 0 === u[2] && 0 === f[2])) &&
                                                    ((i.k[p].to = null), (i.k[p].ti = null)));
                                        (this.effectsSequence = [n.bind(this)]),
                                            (this.data = i),
                                            (this.keyframes = i.k),
                                            (this.keyframesMetadata = []),
                                            (this.offsetTime = e.data.st),
                                            (this.k = !0),
                                            (this.kf = !0),
                                            (this._isFirstFrame = !0),
                                            (this.mult = l || 1),
                                            (this.elem = e),
                                            (this.container = h),
                                            (this.comp = e.comp),
                                            (this.getValue = a),
                                            (this.setVValue = s),
                                            (this.interpolateValue = r),
                                            (this.frameId = -1);
                                        var g = i.k[0].s.length;
                                        for (
                                            this.v = createTypedArray("float32", g),
                                                this.pv = createTypedArray("float32", g),
                                                p = 0;
                                            p < g;
                                            p += 1
                                        )
                                            (this.v[p] = t), (this.pv[p] = t);
                                        (this._caching = {
                                            lastFrame: t,
                                            lastIndex: 0,
                                            value: createTypedArray("float32", g),
                                        }),
                                            (this.addEffect = o);
                                    }
                                    return {
                                        getProp: function (t, e, r, i, n) {
                                            var s;
                                            if (e.k.length)
                                                if ("number" == typeof e.k[0]) s = new h(t, e, i, n);
                                                else
                                                    switch (r) {
                                                        case 0:
                                                            s = new p(t, e, i, n);
                                                            break;
                                                        case 1:
                                                            s = new c(t, e, i, n);
                                                    }
                                            else s = new l(t, e, i, n);
                                            return s.effectsSequence.length && n.addDynamicProperty(s), s;
                                        },
                                    };
                                })();
                            function DynamicPropertyContainer() {}
                            DynamicPropertyContainer.prototype = {
                                addDynamicProperty: function (t) {
                                    -1 === this.dynamicProperties.indexOf(t) &&
                                        (this.dynamicProperties.push(t),
                                        this.container.addDynamicProperty(this),
                                        (this._isAnimated = !0));
                                },
                                iterateDynamicProperties: function () {
                                    var t;
                                    this._mdf = !1;
                                    var e = this.dynamicProperties.length;
                                    for (t = 0; t < e; t += 1)
                                        this.dynamicProperties[t].getValue(),
                                            this.dynamicProperties[t]._mdf && (this._mdf = !0);
                                },
                                initDynamicPropertyContainer: function (t) {
                                    (this.container = t),
                                        (this.dynamicProperties = []),
                                        (this._mdf = !1),
                                        (this._isAnimated = !1);
                                },
                            };
                            var pointPool = poolFactory(8, function () {
                                return createTypedArray("float32", 2);
                            });
                            function ShapePath() {
                                (this.c = !1),
                                    (this._length = 0),
                                    (this._maxLength = 8),
                                    (this.v = createSizedArray(this._maxLength)),
                                    (this.o = createSizedArray(this._maxLength)),
                                    (this.i = createSizedArray(this._maxLength));
                            }
                            (ShapePath.prototype.setPathData = function (t, e) {
                                (this.c = t), this.setLength(e);
                                for (var r = 0; r < e; )
                                    (this.v[r] = pointPool.newElement()),
                                        (this.o[r] = pointPool.newElement()),
                                        (this.i[r] = pointPool.newElement()),
                                        (r += 1);
                            }),
                                (ShapePath.prototype.setLength = function (t) {
                                    for (; this._maxLength < t; ) this.doubleArrayLength();
                                    this._length = t;
                                }),
                                (ShapePath.prototype.doubleArrayLength = function () {
                                    (this.v = this.v.concat(createSizedArray(this._maxLength))),
                                        (this.i = this.i.concat(createSizedArray(this._maxLength))),
                                        (this.o = this.o.concat(createSizedArray(this._maxLength))),
                                        (this._maxLength *= 2);
                                }),
                                (ShapePath.prototype.setXYAt = function (t, e, r, i, n) {
                                    var s;
                                    switch (
                                        ((this._length = Math.max(this._length, i + 1)),
                                        this._length >= this._maxLength && this.doubleArrayLength(),
                                        r)
                                    ) {
                                        case "v":
                                            s = this.v;
                                            break;
                                        case "i":
                                            s = this.i;
                                            break;
                                        case "o":
                                            s = this.o;
                                            break;
                                        default:
                                            s = [];
                                    }
                                    (!s[i] || (s[i] && !n)) && (s[i] = pointPool.newElement()),
                                        (s[i][0] = t),
                                        (s[i][1] = e);
                                }),
                                (ShapePath.prototype.setTripleAt = function (t, e, r, i, n, s, a, o) {
                                    this.setXYAt(t, e, "v", a, o),
                                        this.setXYAt(r, i, "o", a, o),
                                        this.setXYAt(n, s, "i", a, o);
                                }),
                                (ShapePath.prototype.reverse = function () {
                                    var t = new ShapePath();
                                    t.setPathData(this.c, this._length);
                                    var e = this.v,
                                        r = this.o,
                                        i = this.i,
                                        n = 0;
                                    this.c &&
                                        (t.setTripleAt(e[0][0], e[0][1], i[0][0], i[0][1], r[0][0], r[0][1], 0, !1),
                                        (n = 1));
                                    var s,
                                        a = this._length - 1,
                                        o = this._length;
                                    for (s = n; s < o; s += 1)
                                        t.setTripleAt(e[a][0], e[a][1], i[a][0], i[a][1], r[a][0], r[a][1], s, !1),
                                            (a -= 1);
                                    return t;
                                }),
                                (ShapePath.prototype.length = function () {
                                    return this._length;
                                });
                            var shapePool =
                                    ((factory = poolFactory(
                                        4,
                                        function () {
                                            return new ShapePath();
                                        },
                                        function (t) {
                                            var e,
                                                r = t._length;
                                            for (e = 0; e < r; e += 1)
                                                pointPool.release(t.v[e]),
                                                    pointPool.release(t.i[e]),
                                                    pointPool.release(t.o[e]),
                                                    (t.v[e] = null),
                                                    (t.i[e] = null),
                                                    (t.o[e] = null);
                                            (t._length = 0), (t.c = !1);
                                        }
                                    )),
                                    (factory.clone = function (t) {
                                        var e,
                                            r = factory.newElement(),
                                            i = void 0 === t._length ? t.v.length : t._length;
                                        for (r.setLength(i), r.c = t.c, e = 0; e < i; e += 1)
                                            r.setTripleAt(
                                                t.v[e][0],
                                                t.v[e][1],
                                                t.o[e][0],
                                                t.o[e][1],
                                                t.i[e][0],
                                                t.i[e][1],
                                                e
                                            );
                                        return r;
                                    }),
                                    factory),
                                factory;
                            function ShapeCollection() {
                                (this._length = 0),
                                    (this._maxLength = 4),
                                    (this.shapes = createSizedArray(this._maxLength));
                            }
                            (ShapeCollection.prototype.addShape = function (t) {
                                this._length === this._maxLength &&
                                    ((this.shapes = this.shapes.concat(createSizedArray(this._maxLength))),
                                    (this._maxLength *= 2)),
                                    (this.shapes[this._length] = t),
                                    (this._length += 1);
                            }),
                                (ShapeCollection.prototype.releaseShapes = function () {
                                    var t;
                                    for (t = 0; t < this._length; t += 1) shapePool.release(this.shapes[t]);
                                    this._length = 0;
                                });
                            var shapeCollectionPool =
                                    ((ob = {
                                        newShapeCollection: function () {
                                            return _length ? pool[(_length -= 1)] : new ShapeCollection();
                                        },
                                        release: function (t) {
                                            var e,
                                                r = t._length;
                                            for (e = 0; e < r; e += 1) shapePool.release(t.shapes[e]);
                                            (t._length = 0),
                                                _length === _maxLength &&
                                                    ((pool = pooling.double(pool)), (_maxLength *= 2)),
                                                (pool[_length] = t),
                                                (_length += 1);
                                        },
                                    }),
                                    (_length = 0),
                                    (_maxLength = 4),
                                    (pool = createSizedArray(_maxLength)),
                                    ob),
                                ob,
                                _length,
                                _maxLength,
                                pool,
                                ShapePropertyFactory = (function () {
                                    var t = -999999;
                                    function e(t, e, r) {
                                        var i,
                                            n,
                                            s,
                                            a,
                                            o,
                                            l,
                                            h,
                                            p,
                                            c,
                                            d = r.lastIndex,
                                            u = this.keyframes;
                                        if (t < u[0].t - this.offsetTime) (i = u[0].s[0]), (s = !0), (d = 0);
                                        else if (t >= u[u.length - 1].t - this.offsetTime)
                                            (i = u[u.length - 1].s ? u[u.length - 1].s[0] : u[u.length - 2].e[0]),
                                                (s = !0);
                                        else {
                                            for (
                                                var f, m, g, y = d, v = u.length - 1, b = !0;
                                                b && ((f = u[y]), !((m = u[y + 1]).t - this.offsetTime > t));

                                            )
                                                y < v - 1 ? (y += 1) : (b = !1);
                                            if (((g = this.keyframesMetadata[y] || {}), (d = y), !(s = 1 === f.h))) {
                                                if (t >= m.t - this.offsetTime) p = 1;
                                                else if (t < f.t - this.offsetTime) p = 0;
                                                else {
                                                    var _;
                                                    g.__fnct
                                                        ? (_ = g.__fnct)
                                                        : ((_ = BezierFactory.getBezierEasing(
                                                              f.o.x,
                                                              f.o.y,
                                                              f.i.x,
                                                              f.i.y
                                                          ).get),
                                                          (g.__fnct = _)),
                                                        (p = _(
                                                            (t - (f.t - this.offsetTime)) /
                                                                (m.t - this.offsetTime - (f.t - this.offsetTime))
                                                        ));
                                                }
                                                n = m.s ? m.s[0] : f.e[0];
                                            }
                                            i = f.s[0];
                                        }
                                        for (l = e._length, h = i.i[0].length, r.lastIndex = d, a = 0; a < l; a += 1)
                                            for (o = 0; o < h; o += 1)
                                                (c = s ? i.i[a][o] : i.i[a][o] + (n.i[a][o] - i.i[a][o]) * p),
                                                    (e.i[a][o] = c),
                                                    (c = s ? i.o[a][o] : i.o[a][o] + (n.o[a][o] - i.o[a][o]) * p),
                                                    (e.o[a][o] = c),
                                                    (c = s ? i.v[a][o] : i.v[a][o] + (n.v[a][o] - i.v[a][o]) * p),
                                                    (e.v[a][o] = c);
                                    }
                                    function r() {
                                        var e = this.comp.renderedFrame - this.offsetTime,
                                            r = this.keyframes[0].t - this.offsetTime,
                                            i = this.keyframes[this.keyframes.length - 1].t - this.offsetTime,
                                            n = this._caching.lastFrame;
                                        return (
                                            (n !== t && ((n < r && e < r) || (n > i && e > i))) ||
                                                ((this._caching.lastIndex = n < e ? this._caching.lastIndex : 0),
                                                this.interpolateShape(e, this.pv, this._caching)),
                                            (this._caching.lastFrame = e),
                                            this.pv
                                        );
                                    }
                                    function i() {
                                        this.paths = this.localShapeCollection;
                                    }
                                    function n(t) {
                                        (function (t, e) {
                                            if (t._length !== e._length || t.c !== e.c) return !1;
                                            var r,
                                                i = t._length;
                                            for (r = 0; r < i; r += 1)
                                                if (
                                                    t.v[r][0] !== e.v[r][0] ||
                                                    t.v[r][1] !== e.v[r][1] ||
                                                    t.o[r][0] !== e.o[r][0] ||
                                                    t.o[r][1] !== e.o[r][1] ||
                                                    t.i[r][0] !== e.i[r][0] ||
                                                    t.i[r][1] !== e.i[r][1]
                                                )
                                                    return !1;
                                            return !0;
                                        })(this.v, t) ||
                                            ((this.v = shapePool.clone(t)),
                                            this.localShapeCollection.releaseShapes(),
                                            this.localShapeCollection.addShape(this.v),
                                            (this._mdf = !0),
                                            (this.paths = this.localShapeCollection));
                                    }
                                    function s() {
                                        if (this.elem.globalData.frameId !== this.frameId)
                                            if (this.effectsSequence.length)
                                                if (this.lock) this.setVValue(this.pv);
                                                else {
                                                    var t, e;
                                                    (this.lock = !0),
                                                        (this._mdf = !1),
                                                        (t = this.kf
                                                            ? this.pv
                                                            : this.data.ks
                                                              ? this.data.ks.k
                                                              : this.data.pt.k);
                                                    var r = this.effectsSequence.length;
                                                    for (e = 0; e < r; e += 1) t = this.effectsSequence[e](t);
                                                    this.setVValue(t),
                                                        (this.lock = !1),
                                                        (this.frameId = this.elem.globalData.frameId);
                                                }
                                            else this._mdf = !1;
                                    }
                                    function a(t, e, r) {
                                        (this.propType = "shape"),
                                            (this.comp = t.comp),
                                            (this.container = t),
                                            (this.elem = t),
                                            (this.data = e),
                                            (this.k = !1),
                                            (this.kf = !1),
                                            (this._mdf = !1);
                                        var n = 3 === r ? e.pt.k : e.ks.k;
                                        (this.v = shapePool.clone(n)),
                                            (this.pv = shapePool.clone(this.v)),
                                            (this.localShapeCollection = shapeCollectionPool.newShapeCollection()),
                                            (this.paths = this.localShapeCollection),
                                            this.paths.addShape(this.v),
                                            (this.reset = i),
                                            (this.effectsSequence = []);
                                    }
                                    function o(t) {
                                        this.effectsSequence.push(t), this.container.addDynamicProperty(this);
                                    }
                                    function l(e, n, s) {
                                        (this.propType = "shape"),
                                            (this.comp = e.comp),
                                            (this.elem = e),
                                            (this.container = e),
                                            (this.offsetTime = e.data.st),
                                            (this.keyframes = 3 === s ? n.pt.k : n.ks.k),
                                            (this.keyframesMetadata = []),
                                            (this.k = !0),
                                            (this.kf = !0);
                                        var a = this.keyframes[0].s[0].i.length;
                                        (this.v = shapePool.newElement()),
                                            this.v.setPathData(this.keyframes[0].s[0].c, a),
                                            (this.pv = shapePool.clone(this.v)),
                                            (this.localShapeCollection = shapeCollectionPool.newShapeCollection()),
                                            (this.paths = this.localShapeCollection),
                                            this.paths.addShape(this.v),
                                            (this.lastFrame = t),
                                            (this.reset = i),
                                            (this._caching = { lastFrame: t, lastIndex: 0 }),
                                            (this.effectsSequence = [r.bind(this)]);
                                    }
                                    (a.prototype.interpolateShape = e),
                                        (a.prototype.getValue = s),
                                        (a.prototype.setVValue = n),
                                        (a.prototype.addEffect = o),
                                        (l.prototype.getValue = s),
                                        (l.prototype.interpolateShape = e),
                                        (l.prototype.setVValue = n),
                                        (l.prototype.addEffect = o);
                                    var h = (function () {
                                            var t = roundCorner;
                                            function e(t, e) {
                                                (this.v = shapePool.newElement()),
                                                    this.v.setPathData(!0, 4),
                                                    (this.localShapeCollection =
                                                        shapeCollectionPool.newShapeCollection()),
                                                    (this.paths = this.localShapeCollection),
                                                    this.localShapeCollection.addShape(this.v),
                                                    (this.d = e.d),
                                                    (this.elem = t),
                                                    (this.comp = t.comp),
                                                    (this.frameId = -1),
                                                    this.initDynamicPropertyContainer(t),
                                                    (this.p = PropertyFactory.getProp(t, e.p, 1, 0, this)),
                                                    (this.s = PropertyFactory.getProp(t, e.s, 1, 0, this)),
                                                    this.dynamicProperties.length
                                                        ? (this.k = !0)
                                                        : ((this.k = !1), this.convertEllToPath());
                                            }
                                            return (
                                                (e.prototype = {
                                                    reset: i,
                                                    getValue: function () {
                                                        this.elem.globalData.frameId !== this.frameId &&
                                                            ((this.frameId = this.elem.globalData.frameId),
                                                            this.iterateDynamicProperties(),
                                                            this._mdf && this.convertEllToPath());
                                                    },
                                                    convertEllToPath: function () {
                                                        var e = this.p.v[0],
                                                            r = this.p.v[1],
                                                            i = this.s.v[0] / 2,
                                                            n = this.s.v[1] / 2,
                                                            s = 3 !== this.d,
                                                            a = this.v;
                                                        (a.v[0][0] = e),
                                                            (a.v[0][1] = r - n),
                                                            (a.v[1][0] = s ? e + i : e - i),
                                                            (a.v[1][1] = r),
                                                            (a.v[2][0] = e),
                                                            (a.v[2][1] = r + n),
                                                            (a.v[3][0] = s ? e - i : e + i),
                                                            (a.v[3][1] = r),
                                                            (a.i[0][0] = s ? e - i * t : e + i * t),
                                                            (a.i[0][1] = r - n),
                                                            (a.i[1][0] = s ? e + i : e - i),
                                                            (a.i[1][1] = r - n * t),
                                                            (a.i[2][0] = s ? e + i * t : e - i * t),
                                                            (a.i[2][1] = r + n),
                                                            (a.i[3][0] = s ? e - i : e + i),
                                                            (a.i[3][1] = r + n * t),
                                                            (a.o[0][0] = s ? e + i * t : e - i * t),
                                                            (a.o[0][1] = r - n),
                                                            (a.o[1][0] = s ? e + i : e - i),
                                                            (a.o[1][1] = r + n * t),
                                                            (a.o[2][0] = s ? e - i * t : e + i * t),
                                                            (a.o[2][1] = r + n),
                                                            (a.o[3][0] = s ? e - i : e + i),
                                                            (a.o[3][1] = r - n * t);
                                                    },
                                                }),
                                                extendPrototype([DynamicPropertyContainer], e),
                                                e
                                            );
                                        })(),
                                        p = (function () {
                                            function t(t, e) {
                                                (this.v = shapePool.newElement()),
                                                    this.v.setPathData(!0, 0),
                                                    (this.elem = t),
                                                    (this.comp = t.comp),
                                                    (this.data = e),
                                                    (this.frameId = -1),
                                                    (this.d = e.d),
                                                    this.initDynamicPropertyContainer(t),
                                                    1 === e.sy
                                                        ? ((this.ir = PropertyFactory.getProp(t, e.ir, 0, 0, this)),
                                                          (this.is = PropertyFactory.getProp(t, e.is, 0, 0.01, this)),
                                                          (this.convertToPath = this.convertStarToPath))
                                                        : (this.convertToPath = this.convertPolygonToPath),
                                                    (this.pt = PropertyFactory.getProp(t, e.pt, 0, 0, this)),
                                                    (this.p = PropertyFactory.getProp(t, e.p, 1, 0, this)),
                                                    (this.r = PropertyFactory.getProp(t, e.r, 0, degToRads, this)),
                                                    (this.or = PropertyFactory.getProp(t, e.or, 0, 0, this)),
                                                    (this.os = PropertyFactory.getProp(t, e.os, 0, 0.01, this)),
                                                    (this.localShapeCollection =
                                                        shapeCollectionPool.newShapeCollection()),
                                                    this.localShapeCollection.addShape(this.v),
                                                    (this.paths = this.localShapeCollection),
                                                    this.dynamicProperties.length
                                                        ? (this.k = !0)
                                                        : ((this.k = !1), this.convertToPath());
                                            }
                                            return (
                                                (t.prototype = {
                                                    reset: i,
                                                    getValue: function () {
                                                        this.elem.globalData.frameId !== this.frameId &&
                                                            ((this.frameId = this.elem.globalData.frameId),
                                                            this.iterateDynamicProperties(),
                                                            this._mdf && this.convertToPath());
                                                    },
                                                    convertStarToPath: function () {
                                                        var t,
                                                            e,
                                                            r,
                                                            i,
                                                            n = 2 * Math.floor(this.pt.v),
                                                            s = (2 * Math.PI) / n,
                                                            a = !0,
                                                            o = this.or.v,
                                                            l = this.ir.v,
                                                            h = this.os.v,
                                                            p = this.is.v,
                                                            c = (2 * Math.PI * o) / (2 * n),
                                                            d = (2 * Math.PI * l) / (2 * n),
                                                            u = -Math.PI / 2;
                                                        u += this.r.v;
                                                        var f = 3 === this.data.d ? -1 : 1;
                                                        for (this.v._length = 0, t = 0; t < n; t += 1) {
                                                            (r = a ? h : p), (i = a ? c : d);
                                                            var m = (e = a ? o : l) * Math.cos(u),
                                                                g = e * Math.sin(u),
                                                                y =
                                                                    0 === m && 0 === g
                                                                        ? 0
                                                                        : g / Math.sqrt(m * m + g * g),
                                                                v =
                                                                    0 === m && 0 === g
                                                                        ? 0
                                                                        : -m / Math.sqrt(m * m + g * g);
                                                            (m += +this.p.v[0]),
                                                                (g += +this.p.v[1]),
                                                                this.v.setTripleAt(
                                                                    m,
                                                                    g,
                                                                    m - y * i * r * f,
                                                                    g - v * i * r * f,
                                                                    m + y * i * r * f,
                                                                    g + v * i * r * f,
                                                                    t,
                                                                    !0
                                                                ),
                                                                (a = !a),
                                                                (u += s * f);
                                                        }
                                                    },
                                                    convertPolygonToPath: function () {
                                                        var t,
                                                            e = Math.floor(this.pt.v),
                                                            r = (2 * Math.PI) / e,
                                                            i = this.or.v,
                                                            n = this.os.v,
                                                            s = (2 * Math.PI * i) / (4 * e),
                                                            a = 0.5 * -Math.PI,
                                                            o = 3 === this.data.d ? -1 : 1;
                                                        for (a += this.r.v, this.v._length = 0, t = 0; t < e; t += 1) {
                                                            var l = i * Math.cos(a),
                                                                h = i * Math.sin(a),
                                                                p =
                                                                    0 === l && 0 === h
                                                                        ? 0
                                                                        : h / Math.sqrt(l * l + h * h),
                                                                c =
                                                                    0 === l && 0 === h
                                                                        ? 0
                                                                        : -l / Math.sqrt(l * l + h * h);
                                                            (l += +this.p.v[0]),
                                                                (h += +this.p.v[1]),
                                                                this.v.setTripleAt(
                                                                    l,
                                                                    h,
                                                                    l - p * s * n * o,
                                                                    h - c * s * n * o,
                                                                    l + p * s * n * o,
                                                                    h + c * s * n * o,
                                                                    t,
                                                                    !0
                                                                ),
                                                                (a += r * o);
                                                        }
                                                        (this.paths.length = 0), (this.paths[0] = this.v);
                                                    },
                                                }),
                                                extendPrototype([DynamicPropertyContainer], t),
                                                t
                                            );
                                        })(),
                                        c = (function () {
                                            function t(t, e) {
                                                (this.v = shapePool.newElement()),
                                                    (this.v.c = !0),
                                                    (this.localShapeCollection =
                                                        shapeCollectionPool.newShapeCollection()),
                                                    this.localShapeCollection.addShape(this.v),
                                                    (this.paths = this.localShapeCollection),
                                                    (this.elem = t),
                                                    (this.comp = t.comp),
                                                    (this.frameId = -1),
                                                    (this.d = e.d),
                                                    this.initDynamicPropertyContainer(t),
                                                    (this.p = PropertyFactory.getProp(t, e.p, 1, 0, this)),
                                                    (this.s = PropertyFactory.getProp(t, e.s, 1, 0, this)),
                                                    (this.r = PropertyFactory.getProp(t, e.r, 0, 0, this)),
                                                    this.dynamicProperties.length
                                                        ? (this.k = !0)
                                                        : ((this.k = !1), this.convertRectToPath());
                                            }
                                            return (
                                                (t.prototype = {
                                                    convertRectToPath: function () {
                                                        var t = this.p.v[0],
                                                            e = this.p.v[1],
                                                            r = this.s.v[0] / 2,
                                                            i = this.s.v[1] / 2,
                                                            n = bmMin(r, i, this.r.v),
                                                            s = n * (1 - roundCorner);
                                                        (this.v._length = 0),
                                                            2 === this.d || 1 === this.d
                                                                ? (this.v.setTripleAt(
                                                                      t + r,
                                                                      e - i + n,
                                                                      t + r,
                                                                      e - i + n,
                                                                      t + r,
                                                                      e - i + s,
                                                                      0,
                                                                      !0
                                                                  ),
                                                                  this.v.setTripleAt(
                                                                      t + r,
                                                                      e + i - n,
                                                                      t + r,
                                                                      e + i - s,
                                                                      t + r,
                                                                      e + i - n,
                                                                      1,
                                                                      !0
                                                                  ),
                                                                  0 !== n
                                                                      ? (this.v.setTripleAt(
                                                                            t + r - n,
                                                                            e + i,
                                                                            t + r - n,
                                                                            e + i,
                                                                            t + r - s,
                                                                            e + i,
                                                                            2,
                                                                            !0
                                                                        ),
                                                                        this.v.setTripleAt(
                                                                            t - r + n,
                                                                            e + i,
                                                                            t - r + s,
                                                                            e + i,
                                                                            t - r + n,
                                                                            e + i,
                                                                            3,
                                                                            !0
                                                                        ),
                                                                        this.v.setTripleAt(
                                                                            t - r,
                                                                            e + i - n,
                                                                            t - r,
                                                                            e + i - n,
                                                                            t - r,
                                                                            e + i - s,
                                                                            4,
                                                                            !0
                                                                        ),
                                                                        this.v.setTripleAt(
                                                                            t - r,
                                                                            e - i + n,
                                                                            t - r,
                                                                            e - i + s,
                                                                            t - r,
                                                                            e - i + n,
                                                                            5,
                                                                            !0
                                                                        ),
                                                                        this.v.setTripleAt(
                                                                            t - r + n,
                                                                            e - i,
                                                                            t - r + n,
                                                                            e - i,
                                                                            t - r + s,
                                                                            e - i,
                                                                            6,
                                                                            !0
                                                                        ),
                                                                        this.v.setTripleAt(
                                                                            t + r - n,
                                                                            e - i,
                                                                            t + r - s,
                                                                            e - i,
                                                                            t + r - n,
                                                                            e - i,
                                                                            7,
                                                                            !0
                                                                        ))
                                                                      : (this.v.setTripleAt(
                                                                            t - r,
                                                                            e + i,
                                                                            t - r + s,
                                                                            e + i,
                                                                            t - r,
                                                                            e + i,
                                                                            2
                                                                        ),
                                                                        this.v.setTripleAt(
                                                                            t - r,
                                                                            e - i,
                                                                            t - r,
                                                                            e - i + s,
                                                                            t - r,
                                                                            e - i,
                                                                            3
                                                                        )))
                                                                : (this.v.setTripleAt(
                                                                      t + r,
                                                                      e - i + n,
                                                                      t + r,
                                                                      e - i + s,
                                                                      t + r,
                                                                      e - i + n,
                                                                      0,
                                                                      !0
                                                                  ),
                                                                  0 !== n
                                                                      ? (this.v.setTripleAt(
                                                                            t + r - n,
                                                                            e - i,
                                                                            t + r - n,
                                                                            e - i,
                                                                            t + r - s,
                                                                            e - i,
                                                                            1,
                                                                            !0
                                                                        ),
                                                                        this.v.setTripleAt(
                                                                            t - r + n,
                                                                            e - i,
                                                                            t - r + s,
                                                                            e - i,
                                                                            t - r + n,
                                                                            e - i,
                                                                            2,
                                                                            !0
                                                                        ),
                                                                        this.v.setTripleAt(
                                                                            t - r,
                                                                            e - i + n,
                                                                            t - r,
                                                                            e - i + n,
                                                                            t - r,
                                                                            e - i + s,
                                                                            3,
                                                                            !0
                                                                        ),
                                                                        this.v.setTripleAt(
                                                                            t - r,
                                                                            e + i - n,
                                                                            t - r,
                                                                            e + i - s,
                                                                            t - r,
                                                                            e + i - n,
                                                                            4,
                                                                            !0
                                                                        ),
                                                                        this.v.setTripleAt(
                                                                            t - r + n,
                                                                            e + i,
                                                                            t - r + n,
                                                                            e + i,
                                                                            t - r + s,
                                                                            e + i,
                                                                            5,
                                                                            !0
                                                                        ),
                                                                        this.v.setTripleAt(
                                                                            t + r - n,
                                                                            e + i,
                                                                            t + r - s,
                                                                            e + i,
                                                                            t + r - n,
                                                                            e + i,
                                                                            6,
                                                                            !0
                                                                        ),
                                                                        this.v.setTripleAt(
                                                                            t + r,
                                                                            e + i - n,
                                                                            t + r,
                                                                            e + i - n,
                                                                            t + r,
                                                                            e + i - s,
                                                                            7,
                                                                            !0
                                                                        ))
                                                                      : (this.v.setTripleAt(
                                                                            t - r,
                                                                            e - i,
                                                                            t - r + s,
                                                                            e - i,
                                                                            t - r,
                                                                            e - i,
                                                                            1,
                                                                            !0
                                                                        ),
                                                                        this.v.setTripleAt(
                                                                            t - r,
                                                                            e + i,
                                                                            t - r,
                                                                            e + i - s,
                                                                            t - r,
                                                                            e + i,
                                                                            2,
                                                                            !0
                                                                        ),
                                                                        this.v.setTripleAt(
                                                                            t + r,
                                                                            e + i,
                                                                            t + r - s,
                                                                            e + i,
                                                                            t + r,
                                                                            e + i,
                                                                            3,
                                                                            !0
                                                                        )));
                                                    },
                                                    getValue: function () {
                                                        this.elem.globalData.frameId !== this.frameId &&
                                                            ((this.frameId = this.elem.globalData.frameId),
                                                            this.iterateDynamicProperties(),
                                                            this._mdf && this.convertRectToPath());
                                                    },
                                                    reset: i,
                                                }),
                                                extendPrototype([DynamicPropertyContainer], t),
                                                t
                                            );
                                        })();
                                    return {
                                        getShapeProp: function (t, e, r) {
                                            var i;
                                            return (
                                                3 === r || 4 === r
                                                    ? (i = (3 === r ? e.pt : e.ks).k.length
                                                          ? new l(t, e, r)
                                                          : new a(t, e, r))
                                                    : 5 === r
                                                      ? (i = new c(t, e))
                                                      : 6 === r
                                                        ? (i = new h(t, e))
                                                        : 7 === r && (i = new p(t, e)),
                                                i.k && t.addDynamicProperty(i),
                                                i
                                            );
                                        },
                                        getConstructorFunction: function () {
                                            return a;
                                        },
                                        getKeyframedConstructorFunction: function () {
                                            return l;
                                        },
                                    };
                                })(),
                                Matrix = (function () {
                                    var t = Math.cos,
                                        e = Math.sin,
                                        r = Math.tan,
                                        i = Math.round;
                                    function n() {
                                        return (
                                            (this.props[0] = 1),
                                            (this.props[1] = 0),
                                            (this.props[2] = 0),
                                            (this.props[3] = 0),
                                            (this.props[4] = 0),
                                            (this.props[5] = 1),
                                            (this.props[6] = 0),
                                            (this.props[7] = 0),
                                            (this.props[8] = 0),
                                            (this.props[9] = 0),
                                            (this.props[10] = 1),
                                            (this.props[11] = 0),
                                            (this.props[12] = 0),
                                            (this.props[13] = 0),
                                            (this.props[14] = 0),
                                            (this.props[15] = 1),
                                            this
                                        );
                                    }
                                    function s(r) {
                                        if (0 === r) return this;
                                        var i = t(r),
                                            n = e(r);
                                        return this._t(i, -n, 0, 0, n, i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                                    }
                                    function a(r) {
                                        if (0 === r) return this;
                                        var i = t(r),
                                            n = e(r);
                                        return this._t(1, 0, 0, 0, 0, i, -n, 0, 0, n, i, 0, 0, 0, 0, 1);
                                    }
                                    function o(r) {
                                        if (0 === r) return this;
                                        var i = t(r),
                                            n = e(r);
                                        return this._t(i, 0, n, 0, 0, 1, 0, 0, -n, 0, i, 0, 0, 0, 0, 1);
                                    }
                                    function l(r) {
                                        if (0 === r) return this;
                                        var i = t(r),
                                            n = e(r);
                                        return this._t(i, -n, 0, 0, n, i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                                    }
                                    function h(t, e) {
                                        return this._t(1, e, t, 1, 0, 0);
                                    }
                                    function p(t, e) {
                                        return this.shear(r(t), r(e));
                                    }
                                    function c(i, n) {
                                        var s = t(n),
                                            a = e(n);
                                        return this._t(s, a, 0, 0, -a, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
                                            ._t(1, 0, 0, 0, r(i), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
                                            ._t(s, -a, 0, 0, a, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                                    }
                                    function d(t, e, r) {
                                        return (
                                            r || 0 === r || (r = 1),
                                            1 === t && 1 === e && 1 === r
                                                ? this
                                                : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, r, 0, 0, 0, 0, 1)
                                        );
                                    }
                                    function u(t, e, r, i, n, s, a, o, l, h, p, c, d, u, f, m) {
                                        return (
                                            (this.props[0] = t),
                                            (this.props[1] = e),
                                            (this.props[2] = r),
                                            (this.props[3] = i),
                                            (this.props[4] = n),
                                            (this.props[5] = s),
                                            (this.props[6] = a),
                                            (this.props[7] = o),
                                            (this.props[8] = l),
                                            (this.props[9] = h),
                                            (this.props[10] = p),
                                            (this.props[11] = c),
                                            (this.props[12] = d),
                                            (this.props[13] = u),
                                            (this.props[14] = f),
                                            (this.props[15] = m),
                                            this
                                        );
                                    }
                                    function f(t, e, r) {
                                        return (
                                            (r = r || 0),
                                            0 !== t || 0 !== e || 0 !== r
                                                ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, r, 1)
                                                : this
                                        );
                                    }
                                    function m(t, e, r, i, n, s, a, o, l, h, p, c, d, u, f, m) {
                                        var g = this.props;
                                        if (
                                            1 === t &&
                                            0 === e &&
                                            0 === r &&
                                            0 === i &&
                                            0 === n &&
                                            1 === s &&
                                            0 === a &&
                                            0 === o &&
                                            0 === l &&
                                            0 === h &&
                                            1 === p &&
                                            0 === c
                                        )
                                            return (
                                                (g[12] = g[12] * t + g[15] * d),
                                                (g[13] = g[13] * s + g[15] * u),
                                                (g[14] = g[14] * p + g[15] * f),
                                                (g[15] *= m),
                                                (this._identityCalculated = !1),
                                                this
                                            );
                                        var y = g[0],
                                            v = g[1],
                                            b = g[2],
                                            _ = g[3],
                                            x = g[4],
                                            S = g[5],
                                            E = g[6],
                                            w = g[7],
                                            P = g[8],
                                            T = g[9],
                                            C = g[10],
                                            A = g[11],
                                            k = g[12],
                                            M = g[13],
                                            D = g[14],
                                            F = g[15];
                                        return (
                                            (g[0] = y * t + v * n + b * l + _ * d),
                                            (g[1] = y * e + v * s + b * h + _ * u),
                                            (g[2] = y * r + v * a + b * p + _ * f),
                                            (g[3] = y * i + v * o + b * c + _ * m),
                                            (g[4] = x * t + S * n + E * l + w * d),
                                            (g[5] = x * e + S * s + E * h + w * u),
                                            (g[6] = x * r + S * a + E * p + w * f),
                                            (g[7] = x * i + S * o + E * c + w * m),
                                            (g[8] = P * t + T * n + C * l + A * d),
                                            (g[9] = P * e + T * s + C * h + A * u),
                                            (g[10] = P * r + T * a + C * p + A * f),
                                            (g[11] = P * i + T * o + C * c + A * m),
                                            (g[12] = k * t + M * n + D * l + F * d),
                                            (g[13] = k * e + M * s + D * h + F * u),
                                            (g[14] = k * r + M * a + D * p + F * f),
                                            (g[15] = k * i + M * o + D * c + F * m),
                                            (this._identityCalculated = !1),
                                            this
                                        );
                                    }
                                    function g() {
                                        return (
                                            this._identityCalculated ||
                                                ((this._identity = !(
                                                    1 !== this.props[0] ||
                                                    0 !== this.props[1] ||
                                                    0 !== this.props[2] ||
                                                    0 !== this.props[3] ||
                                                    0 !== this.props[4] ||
                                                    1 !== this.props[5] ||
                                                    0 !== this.props[6] ||
                                                    0 !== this.props[7] ||
                                                    0 !== this.props[8] ||
                                                    0 !== this.props[9] ||
                                                    1 !== this.props[10] ||
                                                    0 !== this.props[11] ||
                                                    0 !== this.props[12] ||
                                                    0 !== this.props[13] ||
                                                    0 !== this.props[14] ||
                                                    1 !== this.props[15]
                                                )),
                                                (this._identityCalculated = !0)),
                                            this._identity
                                        );
                                    }
                                    function y(t) {
                                        for (var e = 0; e < 16; ) {
                                            if (t.props[e] !== this.props[e]) return !1;
                                            e += 1;
                                        }
                                        return !0;
                                    }
                                    function v(t) {
                                        var e;
                                        for (e = 0; e < 16; e += 1) t.props[e] = this.props[e];
                                        return t;
                                    }
                                    function b(t) {
                                        var e;
                                        for (e = 0; e < 16; e += 1) this.props[e] = t[e];
                                    }
                                    function _(t, e, r) {
                                        return {
                                            x:
                                                t * this.props[0] +
                                                e * this.props[4] +
                                                r * this.props[8] +
                                                this.props[12],
                                            y:
                                                t * this.props[1] +
                                                e * this.props[5] +
                                                r * this.props[9] +
                                                this.props[13],
                                            z:
                                                t * this.props[2] +
                                                e * this.props[6] +
                                                r * this.props[10] +
                                                this.props[14],
                                        };
                                    }
                                    function x(t, e, r) {
                                        return (
                                            t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12]
                                        );
                                    }
                                    function S(t, e, r) {
                                        return (
                                            t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13]
                                        );
                                    }
                                    function E(t, e, r) {
                                        return (
                                            t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14]
                                        );
                                    }
                                    function w() {
                                        var t = this.props[0] * this.props[5] - this.props[1] * this.props[4],
                                            e = this.props[5] / t,
                                            r = -this.props[1] / t,
                                            i = -this.props[4] / t,
                                            n = this.props[0] / t,
                                            s = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t,
                                            a = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t,
                                            o = new Matrix();
                                        return (
                                            (o.props[0] = e),
                                            (o.props[1] = r),
                                            (o.props[4] = i),
                                            (o.props[5] = n),
                                            (o.props[12] = s),
                                            (o.props[13] = a),
                                            o
                                        );
                                    }
                                    function P(t) {
                                        return this.getInverseMatrix().applyToPointArray(t[0], t[1], t[2] || 0);
                                    }
                                    function T(t) {
                                        var e,
                                            r = t.length,
                                            i = [];
                                        for (e = 0; e < r; e += 1) i[e] = P(t[e]);
                                        return i;
                                    }
                                    function C(t, e, r) {
                                        var i = createTypedArray("float32", 6);
                                        if (this.isIdentity())
                                            (i[0] = t[0]),
                                                (i[1] = t[1]),
                                                (i[2] = e[0]),
                                                (i[3] = e[1]),
                                                (i[4] = r[0]),
                                                (i[5] = r[1]);
                                        else {
                                            var n = this.props[0],
                                                s = this.props[1],
                                                a = this.props[4],
                                                o = this.props[5],
                                                l = this.props[12],
                                                h = this.props[13];
                                            (i[0] = t[0] * n + t[1] * a + l),
                                                (i[1] = t[0] * s + t[1] * o + h),
                                                (i[2] = e[0] * n + e[1] * a + l),
                                                (i[3] = e[0] * s + e[1] * o + h),
                                                (i[4] = r[0] * n + r[1] * a + l),
                                                (i[5] = r[0] * s + r[1] * o + h);
                                        }
                                        return i;
                                    }
                                    function A(t, e, r) {
                                        return this.isIdentity()
                                            ? [t, e, r]
                                            : [
                                                  t * this.props[0] +
                                                      e * this.props[4] +
                                                      r * this.props[8] +
                                                      this.props[12],
                                                  t * this.props[1] +
                                                      e * this.props[5] +
                                                      r * this.props[9] +
                                                      this.props[13],
                                                  t * this.props[2] +
                                                      e * this.props[6] +
                                                      r * this.props[10] +
                                                      this.props[14],
                                              ];
                                    }
                                    function k(t, e) {
                                        if (this.isIdentity()) return t + "," + e;
                                        var r = this.props;
                                        return (
                                            Math.round(100 * (t * r[0] + e * r[4] + r[12])) / 100 +
                                            "," +
                                            Math.round(100 * (t * r[1] + e * r[5] + r[13])) / 100
                                        );
                                    }
                                    function M() {
                                        for (var t = 0, e = this.props, r = "matrix3d("; t < 16; )
                                            (r += i(1e4 * e[t]) / 1e4), (r += 15 === t ? ")" : ","), (t += 1);
                                        return r;
                                    }
                                    function D(t) {
                                        return (t < 1e-6 && t > 0) || (t > -1e-6 && t < 0) ? i(1e4 * t) / 1e4 : t;
                                    }
                                    function F() {
                                        var t = this.props;
                                        return (
                                            "matrix(" +
                                            D(t[0]) +
                                            "," +
                                            D(t[1]) +
                                            "," +
                                            D(t[4]) +
                                            "," +
                                            D(t[5]) +
                                            "," +
                                            D(t[12]) +
                                            "," +
                                            D(t[13]) +
                                            ")"
                                        );
                                    }
                                    return function () {
                                        (this.reset = n),
                                            (this.rotate = s),
                                            (this.rotateX = a),
                                            (this.rotateY = o),
                                            (this.rotateZ = l),
                                            (this.skew = p),
                                            (this.skewFromAxis = c),
                                            (this.shear = h),
                                            (this.scale = d),
                                            (this.setTransform = u),
                                            (this.translate = f),
                                            (this.transform = m),
                                            (this.applyToPoint = _),
                                            (this.applyToX = x),
                                            (this.applyToY = S),
                                            (this.applyToZ = E),
                                            (this.applyToPointArray = A),
                                            (this.applyToTriplePoints = C),
                                            (this.applyToPointStringified = k),
                                            (this.toCSS = M),
                                            (this.to2dCSS = F),
                                            (this.clone = v),
                                            (this.cloneFromProps = b),
                                            (this.equals = y),
                                            (this.inversePoints = T),
                                            (this.inversePoint = P),
                                            (this.getInverseMatrix = w),
                                            (this._t = this.transform),
                                            (this.isIdentity = g),
                                            (this._identity = !0),
                                            (this._identityCalculated = !1),
                                            (this.props = createTypedArray("float32", 16)),
                                            this.reset();
                                    };
                                })();
                            function _typeof$3(t) {
                                return (_typeof$3 =
                                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                        ? function (t) {
                                              return typeof t;
                                          }
                                        : function (t) {
                                              return t &&
                                                  "function" == typeof Symbol &&
                                                  t.constructor === Symbol &&
                                                  t !== Symbol.prototype
                                                  ? "symbol"
                                                  : typeof t;
                                          })(t);
                            }
                            var lottie = {},
                                standalone = "__[STANDALONE]__",
                                animationData = "__[ANIMATIONDATA]__",
                                renderer = "";
                            function setLocation(t) {
                                setLocationHref(t);
                            }
                            function searchAnimations() {
                                !0 === standalone
                                    ? animationManager.searchAnimations(animationData, standalone, renderer)
                                    : animationManager.searchAnimations();
                            }
                            function setSubframeRendering(t) {
                                setSubframeEnabled(t);
                            }
                            function setPrefix(t) {
                                setIdPrefix(t);
                            }
                            function loadAnimation(t) {
                                return (
                                    !0 === standalone && (t.animationData = JSON.parse(animationData)),
                                    animationManager.loadAnimation(t)
                                );
                            }
                            function setQuality(t) {
                                if ("string" == typeof t)
                                    switch (t) {
                                        case "high":
                                            setDefaultCurveSegments(200);
                                            break;
                                        default:
                                        case "medium":
                                            setDefaultCurveSegments(50);
                                            break;
                                        case "low":
                                            setDefaultCurveSegments(10);
                                    }
                                else !isNaN(t) && t > 1 && setDefaultCurveSegments(t);
                                getDefaultCurveSegments() >= 50 ? roundValues(!1) : roundValues(!0);
                            }
                            function inBrowser() {
                                return "undefined" != typeof navigator;
                            }
                            function installPlugin(t, e) {
                                "expressions" === t && setExpressionsPlugin(e);
                            }
                            function getFactory(t) {
                                switch (t) {
                                    case "propertyFactory":
                                        return PropertyFactory;
                                    case "shapePropertyFactory":
                                        return ShapePropertyFactory;
                                    case "matrix":
                                        return Matrix;
                                    default:
                                        return null;
                                }
                            }
                            function checkReady() {
                                "complete" === document.readyState &&
                                    (clearInterval(readyStateCheckInterval), searchAnimations());
                            }
                            function getQueryVariable(t) {
                                for (var e = queryString.split("&"), r = 0; r < e.length; r += 1) {
                                    var i = e[r].split("=");
                                    if (decodeURIComponent(i[0]) == t) return decodeURIComponent(i[1]);
                                }
                                return null;
                            }
                            (lottie.play = animationManager.play),
                                (lottie.pause = animationManager.pause),
                                (lottie.setLocationHref = setLocation),
                                (lottie.togglePause = animationManager.togglePause),
                                (lottie.setSpeed = animationManager.setSpeed),
                                (lottie.setDirection = animationManager.setDirection),
                                (lottie.stop = animationManager.stop),
                                (lottie.searchAnimations = searchAnimations),
                                (lottie.registerAnimation = animationManager.registerAnimation),
                                (lottie.loadAnimation = loadAnimation),
                                (lottie.setSubframeRendering = setSubframeRendering),
                                (lottie.resize = animationManager.resize),
                                (lottie.goToAndStop = animationManager.goToAndStop),
                                (lottie.destroy = animationManager.destroy),
                                (lottie.setQuality = setQuality),
                                (lottie.inBrowser = inBrowser),
                                (lottie.installPlugin = installPlugin),
                                (lottie.freeze = animationManager.freeze),
                                (lottie.unfreeze = animationManager.unfreeze),
                                (lottie.setVolume = animationManager.setVolume),
                                (lottie.mute = animationManager.mute),
                                (lottie.unmute = animationManager.unmute),
                                (lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations),
                                (lottie.useWebWorker = setWebWorker),
                                (lottie.setIDPrefix = setPrefix),
                                (lottie.__getFactory = getFactory),
                                (lottie.version = "5.10.1");
                            var queryString = "";
                            if (standalone) {
                                var scripts = document.getElementsByTagName("script"),
                                    index = scripts.length - 1,
                                    myScript = scripts[index] || { src: "" };
                                (queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : ""),
                                    (renderer = getQueryVariable("renderer"));
                            }
                            var readyStateCheckInterval = setInterval(checkReady, 100);
                            try {
                                "object" === _typeof$3(exports) ||
                                    __webpack_require__.amdO ||
                                    (window.bodymovin = lottie);
                            } catch (t) {}
                            var ShapeModifiers =
                                    ((t = {}),
                                    (e = {}),
                                    (t.registerModifier = function (t, r) {
                                        e[t] || (e[t] = r);
                                    }),
                                    (t.getModifier = function (t, r, i) {
                                        return new e[t](r, i);
                                    }),
                                    t),
                                t,
                                e;
                            function ShapeModifier() {}
                            function TrimModifier() {}
                            function PuckerAndBloatModifier() {}
                            (ShapeModifier.prototype.initModifierProperties = function () {}),
                                (ShapeModifier.prototype.addShapeToModifier = function () {}),
                                (ShapeModifier.prototype.addShape = function (t) {
                                    if (!this.closed) {
                                        t.sh.container.addDynamicProperty(t.sh);
                                        var e = {
                                            shape: t.sh,
                                            data: t,
                                            localShapeCollection: shapeCollectionPool.newShapeCollection(),
                                        };
                                        this.shapes.push(e),
                                            this.addShapeToModifier(e),
                                            this._isAnimated && t.setAsAnimated();
                                    }
                                }),
                                (ShapeModifier.prototype.init = function (t, e) {
                                    (this.shapes = []),
                                        (this.elem = t),
                                        this.initDynamicPropertyContainer(t),
                                        this.initModifierProperties(t, e),
                                        (this.frameId = initialDefaultFrame),
                                        (this.closed = !1),
                                        (this.k = !1),
                                        this.dynamicProperties.length ? (this.k = !0) : this.getValue(!0);
                                }),
                                (ShapeModifier.prototype.processKeys = function () {
                                    this.elem.globalData.frameId !== this.frameId &&
                                        ((this.frameId = this.elem.globalData.frameId),
                                        this.iterateDynamicProperties());
                                }),
                                extendPrototype([DynamicPropertyContainer], ShapeModifier),
                                extendPrototype([ShapeModifier], TrimModifier),
                                (TrimModifier.prototype.initModifierProperties = function (t, e) {
                                    (this.s = PropertyFactory.getProp(t, e.s, 0, 0.01, this)),
                                        (this.e = PropertyFactory.getProp(t, e.e, 0, 0.01, this)),
                                        (this.o = PropertyFactory.getProp(t, e.o, 0, 0, this)),
                                        (this.sValue = 0),
                                        (this.eValue = 0),
                                        (this.getValue = this.processKeys),
                                        (this.m = e.m),
                                        (this._isAnimated =
                                            !!this.s.effectsSequence.length ||
                                            !!this.e.effectsSequence.length ||
                                            !!this.o.effectsSequence.length);
                                }),
                                (TrimModifier.prototype.addShapeToModifier = function (t) {
                                    t.pathsData = [];
                                }),
                                (TrimModifier.prototype.calculateShapeEdges = function (t, e, r, i, n) {
                                    var s = [];
                                    e <= 1
                                        ? s.push({ s: t, e: e })
                                        : t >= 1
                                          ? s.push({ s: t - 1, e: e - 1 })
                                          : (s.push({ s: t, e: 1 }), s.push({ s: 0, e: e - 1 }));
                                    var a,
                                        o,
                                        l = [],
                                        h = s.length;
                                    for (a = 0; a < h; a += 1) {
                                        var p, c;
                                        (o = s[a]).e * n < i ||
                                            o.s * n > i + r ||
                                            ((p = o.s * n <= i ? 0 : (o.s * n - i) / r),
                                            (c = o.e * n >= i + r ? 1 : (o.e * n - i) / r),
                                            l.push([p, c]));
                                    }
                                    return l.length || l.push([0, 0]), l;
                                }),
                                (TrimModifier.prototype.releasePathsData = function (t) {
                                    var e,
                                        r = t.length;
                                    for (e = 0; e < r; e += 1) segmentsLengthPool.release(t[e]);
                                    return (t.length = 0), t;
                                }),
                                (TrimModifier.prototype.processShapes = function (t) {
                                    var e, r, i, n;
                                    if (this._mdf || t) {
                                        var s = (this.o.v % 360) / 360;
                                        if (
                                            (s < 0 && (s += 1),
                                            (e = this.s.v > 1 ? 1 + s : this.s.v < 0 ? 0 + s : this.s.v + s) >
                                                (r = this.e.v > 1 ? 1 + s : this.e.v < 0 ? 0 + s : this.e.v + s))
                                        ) {
                                            var a = e;
                                            (e = r), (r = a);
                                        }
                                        (e = 1e-4 * Math.round(1e4 * e)),
                                            (r = 1e-4 * Math.round(1e4 * r)),
                                            (this.sValue = e),
                                            (this.eValue = r);
                                    } else (e = this.sValue), (r = this.eValue);
                                    var o,
                                        l,
                                        h,
                                        p,
                                        c,
                                        d = this.shapes.length,
                                        u = 0;
                                    if (r === e)
                                        for (n = 0; n < d; n += 1)
                                            this.shapes[n].localShapeCollection.releaseShapes(),
                                                (this.shapes[n].shape._mdf = !0),
                                                (this.shapes[n].shape.paths = this.shapes[n].localShapeCollection),
                                                this._mdf && (this.shapes[n].pathsData.length = 0);
                                    else if ((1 === r && 0 === e) || (0 === r && 1 === e)) {
                                        if (this._mdf)
                                            for (n = 0; n < d; n += 1)
                                                (this.shapes[n].pathsData.length = 0), (this.shapes[n].shape._mdf = !0);
                                    } else {
                                        var f,
                                            m,
                                            g = [];
                                        for (n = 0; n < d; n += 1)
                                            if ((f = this.shapes[n]).shape._mdf || this._mdf || t || 2 === this.m) {
                                                if (
                                                    ((l = (i = f.shape.paths)._length),
                                                    (c = 0),
                                                    !f.shape._mdf && f.pathsData.length)
                                                )
                                                    c = f.totalShapeLength;
                                                else {
                                                    for (h = this.releasePathsData(f.pathsData), o = 0; o < l; o += 1)
                                                        (p = bez.getSegmentsLength(i.shapes[o])),
                                                            h.push(p),
                                                            (c += p.totalLength);
                                                    (f.totalShapeLength = c), (f.pathsData = h);
                                                }
                                                (u += c), (f.shape._mdf = !0);
                                            } else f.shape.paths = f.localShapeCollection;
                                        var y,
                                            v = e,
                                            b = r,
                                            _ = 0;
                                        for (n = d - 1; n >= 0; n -= 1)
                                            if ((f = this.shapes[n]).shape._mdf) {
                                                for (
                                                    (m = f.localShapeCollection).releaseShapes(),
                                                        2 === this.m && d > 1
                                                            ? ((y = this.calculateShapeEdges(
                                                                  e,
                                                                  r,
                                                                  f.totalShapeLength,
                                                                  _,
                                                                  u
                                                              )),
                                                              (_ += f.totalShapeLength))
                                                            : (y = [[v, b]]),
                                                        l = y.length,
                                                        o = 0;
                                                    o < l;
                                                    o += 1
                                                ) {
                                                    (v = y[o][0]),
                                                        (b = y[o][1]),
                                                        (g.length = 0),
                                                        b <= 1
                                                            ? g.push({
                                                                  s: f.totalShapeLength * v,
                                                                  e: f.totalShapeLength * b,
                                                              })
                                                            : v >= 1
                                                              ? g.push({
                                                                    s: f.totalShapeLength * (v - 1),
                                                                    e: f.totalShapeLength * (b - 1),
                                                                })
                                                              : (g.push({
                                                                    s: f.totalShapeLength * v,
                                                                    e: f.totalShapeLength,
                                                                }),
                                                                g.push({ s: 0, e: f.totalShapeLength * (b - 1) }));
                                                    var x = this.addShapes(f, g[0]);
                                                    if (g[0].s !== g[0].e) {
                                                        if (g.length > 1)
                                                            if (f.shape.paths.shapes[f.shape.paths._length - 1].c) {
                                                                var S = x.pop();
                                                                this.addPaths(x, m), (x = this.addShapes(f, g[1], S));
                                                            } else this.addPaths(x, m), (x = this.addShapes(f, g[1]));
                                                        this.addPaths(x, m);
                                                    }
                                                }
                                                f.shape.paths = m;
                                            }
                                    }
                                }),
                                (TrimModifier.prototype.addPaths = function (t, e) {
                                    var r,
                                        i = t.length;
                                    for (r = 0; r < i; r += 1) e.addShape(t[r]);
                                }),
                                (TrimModifier.prototype.addSegment = function (t, e, r, i, n, s, a) {
                                    n.setXYAt(e[0], e[1], "o", s),
                                        n.setXYAt(r[0], r[1], "i", s + 1),
                                        a && n.setXYAt(t[0], t[1], "v", s),
                                        n.setXYAt(i[0], i[1], "v", s + 1);
                                }),
                                (TrimModifier.prototype.addSegmentFromArray = function (t, e, r, i) {
                                    e.setXYAt(t[1], t[5], "o", r),
                                        e.setXYAt(t[2], t[6], "i", r + 1),
                                        i && e.setXYAt(t[0], t[4], "v", r),
                                        e.setXYAt(t[3], t[7], "v", r + 1);
                                }),
                                (TrimModifier.prototype.addShapes = function (t, e, r) {
                                    var i,
                                        n,
                                        s,
                                        a,
                                        o,
                                        l,
                                        h,
                                        p,
                                        c = t.pathsData,
                                        d = t.shape.paths.shapes,
                                        u = t.shape.paths._length,
                                        f = 0,
                                        m = [],
                                        g = !0;
                                    for (
                                        r
                                            ? ((o = r._length), (p = r._length))
                                            : ((r = shapePool.newElement()), (o = 0), (p = 0)),
                                            m.push(r),
                                            i = 0;
                                        i < u;
                                        i += 1
                                    ) {
                                        for (
                                            l = c[i].lengths, r.c = d[i].c, s = d[i].c ? l.length : l.length + 1, n = 1;
                                            n < s;
                                            n += 1
                                        )
                                            if (f + (a = l[n - 1]).addedLength < e.s) (f += a.addedLength), (r.c = !1);
                                            else {
                                                if (f > e.e) {
                                                    r.c = !1;
                                                    break;
                                                }
                                                e.s <= f && e.e >= f + a.addedLength
                                                    ? (this.addSegment(
                                                          d[i].v[n - 1],
                                                          d[i].o[n - 1],
                                                          d[i].i[n],
                                                          d[i].v[n],
                                                          r,
                                                          o,
                                                          g
                                                      ),
                                                      (g = !1))
                                                    : ((h = bez.getNewSegment(
                                                          d[i].v[n - 1],
                                                          d[i].v[n],
                                                          d[i].o[n - 1],
                                                          d[i].i[n],
                                                          (e.s - f) / a.addedLength,
                                                          (e.e - f) / a.addedLength,
                                                          l[n - 1]
                                                      )),
                                                      this.addSegmentFromArray(h, r, o, g),
                                                      (g = !1),
                                                      (r.c = !1)),
                                                    (f += a.addedLength),
                                                    (o += 1);
                                            }
                                        if (d[i].c && l.length) {
                                            if (((a = l[n - 1]), f <= e.e)) {
                                                var y = l[n - 1].addedLength;
                                                e.s <= f && e.e >= f + y
                                                    ? (this.addSegment(
                                                          d[i].v[n - 1],
                                                          d[i].o[n - 1],
                                                          d[i].i[0],
                                                          d[i].v[0],
                                                          r,
                                                          o,
                                                          g
                                                      ),
                                                      (g = !1))
                                                    : ((h = bez.getNewSegment(
                                                          d[i].v[n - 1],
                                                          d[i].v[0],
                                                          d[i].o[n - 1],
                                                          d[i].i[0],
                                                          (e.s - f) / y,
                                                          (e.e - f) / y,
                                                          l[n - 1]
                                                      )),
                                                      this.addSegmentFromArray(h, r, o, g),
                                                      (g = !1),
                                                      (r.c = !1));
                                            } else r.c = !1;
                                            (f += a.addedLength), (o += 1);
                                        }
                                        if (
                                            (r._length &&
                                                (r.setXYAt(r.v[p][0], r.v[p][1], "i", p),
                                                r.setXYAt(
                                                    r.v[r._length - 1][0],
                                                    r.v[r._length - 1][1],
                                                    "o",
                                                    r._length - 1
                                                )),
                                            f > e.e)
                                        )
                                            break;
                                        i < u - 1 && ((r = shapePool.newElement()), (g = !0), m.push(r), (o = 0));
                                    }
                                    return m;
                                }),
                                extendPrototype([ShapeModifier], PuckerAndBloatModifier),
                                (PuckerAndBloatModifier.prototype.initModifierProperties = function (t, e) {
                                    (this.getValue = this.processKeys),
                                        (this.amount = PropertyFactory.getProp(t, e.a, 0, null, this)),
                                        (this._isAnimated = !!this.amount.effectsSequence.length);
                                }),
                                (PuckerAndBloatModifier.prototype.processPath = function (t, e) {
                                    var r = e / 100,
                                        i = [0, 0],
                                        n = t._length,
                                        s = 0;
                                    for (s = 0; s < n; s += 1) (i[0] += t.v[s][0]), (i[1] += t.v[s][1]);
                                    (i[0] /= n), (i[1] /= n);
                                    var a,
                                        o,
                                        l,
                                        h,
                                        p,
                                        c,
                                        d = shapePool.newElement();
                                    for (d.c = t.c, s = 0; s < n; s += 1)
                                        (a = t.v[s][0] + (i[0] - t.v[s][0]) * r),
                                            (o = t.v[s][1] + (i[1] - t.v[s][1]) * r),
                                            (l = t.o[s][0] + (i[0] - t.o[s][0]) * -r),
                                            (h = t.o[s][1] + (i[1] - t.o[s][1]) * -r),
                                            (p = t.i[s][0] + (i[0] - t.i[s][0]) * -r),
                                            (c = t.i[s][1] + (i[1] - t.i[s][1]) * -r),
                                            d.setTripleAt(a, o, l, h, p, c, s);
                                    return d;
                                }),
                                (PuckerAndBloatModifier.prototype.processShapes = function (t) {
                                    var e,
                                        r,
                                        i,
                                        n,
                                        s,
                                        a,
                                        o = this.shapes.length,
                                        l = this.amount.v;
                                    if (0 !== l)
                                        for (r = 0; r < o; r += 1) {
                                            if (
                                                ((a = (s = this.shapes[r]).localShapeCollection),
                                                s.shape._mdf || this._mdf || t)
                                            )
                                                for (
                                                    a.releaseShapes(),
                                                        s.shape._mdf = !0,
                                                        e = s.shape.paths.shapes,
                                                        n = s.shape.paths._length,
                                                        i = 0;
                                                    i < n;
                                                    i += 1
                                                )
                                                    a.addShape(this.processPath(e[i], l));
                                            s.shape.paths = s.localShapeCollection;
                                        }
                                    this.dynamicProperties.length || (this._mdf = !1);
                                });
                            var TransformPropertyFactory = (function () {
                                var t = [0, 0];
                                function e(t, e, r) {
                                    if (
                                        ((this.elem = t),
                                        (this.frameId = -1),
                                        (this.propType = "transform"),
                                        (this.data = e),
                                        (this.v = new Matrix()),
                                        (this.pre = new Matrix()),
                                        (this.appliedTransformations = 0),
                                        this.initDynamicPropertyContainer(r || t),
                                        e.p && e.p.s
                                            ? ((this.px = PropertyFactory.getProp(t, e.p.x, 0, 0, this)),
                                              (this.py = PropertyFactory.getProp(t, e.p.y, 0, 0, this)),
                                              e.p.z && (this.pz = PropertyFactory.getProp(t, e.p.z, 0, 0, this)))
                                            : (this.p = PropertyFactory.getProp(
                                                  t,
                                                  e.p || { k: [0, 0, 0] },
                                                  1,
                                                  0,
                                                  this
                                              )),
                                        e.rx)
                                    ) {
                                        if (
                                            ((this.rx = PropertyFactory.getProp(t, e.rx, 0, degToRads, this)),
                                            (this.ry = PropertyFactory.getProp(t, e.ry, 0, degToRads, this)),
                                            (this.rz = PropertyFactory.getProp(t, e.rz, 0, degToRads, this)),
                                            e.or.k[0].ti)
                                        ) {
                                            var i,
                                                n = e.or.k.length;
                                            for (i = 0; i < n; i += 1) (e.or.k[i].to = null), (e.or.k[i].ti = null);
                                        }
                                        (this.or = PropertyFactory.getProp(t, e.or, 1, degToRads, this)),
                                            (this.or.sh = !0);
                                    } else this.r = PropertyFactory.getProp(t, e.r || { k: 0 }, 0, degToRads, this);
                                    e.sk &&
                                        ((this.sk = PropertyFactory.getProp(t, e.sk, 0, degToRads, this)),
                                        (this.sa = PropertyFactory.getProp(t, e.sa, 0, degToRads, this))),
                                        (this.a = PropertyFactory.getProp(t, e.a || { k: [0, 0, 0] }, 1, 0, this)),
                                        (this.s = PropertyFactory.getProp(
                                            t,
                                            e.s || { k: [100, 100, 100] },
                                            1,
                                            0.01,
                                            this
                                        )),
                                        e.o
                                            ? (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, t))
                                            : (this.o = { _mdf: !1, v: 1 }),
                                        (this._isDirty = !0),
                                        this.dynamicProperties.length || this.getValue(!0);
                                }
                                return (
                                    (e.prototype = {
                                        applyToMatrix: function (t) {
                                            var e = this._mdf;
                                            this.iterateDynamicProperties(),
                                                (this._mdf = this._mdf || e),
                                                this.a && t.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                                                this.s && t.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                                                this.sk && t.skewFromAxis(-this.sk.v, this.sa.v),
                                                this.r
                                                    ? t.rotate(-this.r.v)
                                                    : t
                                                          .rotateZ(-this.rz.v)
                                                          .rotateY(this.ry.v)
                                                          .rotateX(this.rx.v)
                                                          .rotateZ(-this.or.v[2])
                                                          .rotateY(this.or.v[1])
                                                          .rotateX(this.or.v[0]),
                                                this.data.p.s
                                                    ? this.data.p.z
                                                        ? t.translate(this.px.v, this.py.v, -this.pz.v)
                                                        : t.translate(this.px.v, this.py.v, 0)
                                                    : t.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                                        },
                                        getValue: function (e) {
                                            if (this.elem.globalData.frameId !== this.frameId) {
                                                if (
                                                    (this._isDirty && (this.precalculateMatrix(), (this._isDirty = !1)),
                                                    this.iterateDynamicProperties(),
                                                    this._mdf || e)
                                                ) {
                                                    var r;
                                                    if (
                                                        (this.v.cloneFromProps(this.pre.props),
                                                        this.appliedTransformations < 1 &&
                                                            this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                                                        this.appliedTransformations < 2 &&
                                                            this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                                                        this.sk &&
                                                            this.appliedTransformations < 3 &&
                                                            this.v.skewFromAxis(-this.sk.v, this.sa.v),
                                                        this.r && this.appliedTransformations < 4
                                                            ? this.v.rotate(-this.r.v)
                                                            : !this.r &&
                                                              this.appliedTransformations < 4 &&
                                                              this.v
                                                                  .rotateZ(-this.rz.v)
                                                                  .rotateY(this.ry.v)
                                                                  .rotateX(this.rx.v)
                                                                  .rotateZ(-this.or.v[2])
                                                                  .rotateY(this.or.v[1])
                                                                  .rotateX(this.or.v[0]),
                                                        this.autoOriented)
                                                    ) {
                                                        var i, n;
                                                        if (
                                                            ((r = this.elem.globalData.frameRate),
                                                            this.p && this.p.keyframes && this.p.getValueAtTime)
                                                        )
                                                            this.p._caching.lastFrame + this.p.offsetTime <=
                                                            this.p.keyframes[0].t
                                                                ? ((i = this.p.getValueAtTime(
                                                                      (this.p.keyframes[0].t + 0.01) / r,
                                                                      0
                                                                  )),
                                                                  (n = this.p.getValueAtTime(
                                                                      this.p.keyframes[0].t / r,
                                                                      0
                                                                  )))
                                                                : this.p._caching.lastFrame + this.p.offsetTime >=
                                                                    this.p.keyframes[this.p.keyframes.length - 1].t
                                                                  ? ((i = this.p.getValueAtTime(
                                                                        this.p.keyframes[this.p.keyframes.length - 1]
                                                                            .t / r,
                                                                        0
                                                                    )),
                                                                    (n = this.p.getValueAtTime(
                                                                        (this.p.keyframes[this.p.keyframes.length - 1]
                                                                            .t -
                                                                            0.05) /
                                                                            r,
                                                                        0
                                                                    )))
                                                                  : ((i = this.p.pv),
                                                                    (n = this.p.getValueAtTime(
                                                                        (this.p._caching.lastFrame +
                                                                            this.p.offsetTime -
                                                                            0.01) /
                                                                            r,
                                                                        this.p.offsetTime
                                                                    )));
                                                        else if (
                                                            this.px &&
                                                            this.px.keyframes &&
                                                            this.py.keyframes &&
                                                            this.px.getValueAtTime &&
                                                            this.py.getValueAtTime
                                                        ) {
                                                            (i = []), (n = []);
                                                            var s = this.px,
                                                                a = this.py;
                                                            s._caching.lastFrame + s.offsetTime <= s.keyframes[0].t
                                                                ? ((i[0] = s.getValueAtTime(
                                                                      (s.keyframes[0].t + 0.01) / r,
                                                                      0
                                                                  )),
                                                                  (i[1] = a.getValueAtTime(
                                                                      (a.keyframes[0].t + 0.01) / r,
                                                                      0
                                                                  )),
                                                                  (n[0] = s.getValueAtTime(s.keyframes[0].t / r, 0)),
                                                                  (n[1] = a.getValueAtTime(a.keyframes[0].t / r, 0)))
                                                                : s._caching.lastFrame + s.offsetTime >=
                                                                    s.keyframes[s.keyframes.length - 1].t
                                                                  ? ((i[0] = s.getValueAtTime(
                                                                        s.keyframes[s.keyframes.length - 1].t / r,
                                                                        0
                                                                    )),
                                                                    (i[1] = a.getValueAtTime(
                                                                        a.keyframes[a.keyframes.length - 1].t / r,
                                                                        0
                                                                    )),
                                                                    (n[0] = s.getValueAtTime(
                                                                        (s.keyframes[s.keyframes.length - 1].t - 0.01) /
                                                                            r,
                                                                        0
                                                                    )),
                                                                    (n[1] = a.getValueAtTime(
                                                                        (a.keyframes[a.keyframes.length - 1].t - 0.01) /
                                                                            r,
                                                                        0
                                                                    )))
                                                                  : ((i = [s.pv, a.pv]),
                                                                    (n[0] = s.getValueAtTime(
                                                                        (s._caching.lastFrame + s.offsetTime - 0.01) /
                                                                            r,
                                                                        s.offsetTime
                                                                    )),
                                                                    (n[1] = a.getValueAtTime(
                                                                        (a._caching.lastFrame + a.offsetTime - 0.01) /
                                                                            r,
                                                                        a.offsetTime
                                                                    )));
                                                        } else i = n = t;
                                                        this.v.rotate(-Math.atan2(i[1] - n[1], i[0] - n[0]));
                                                    }
                                                    this.data.p && this.data.p.s
                                                        ? this.data.p.z
                                                            ? this.v.translate(this.px.v, this.py.v, -this.pz.v)
                                                            : this.v.translate(this.px.v, this.py.v, 0)
                                                        : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                                                }
                                                this.frameId = this.elem.globalData.frameId;
                                            }
                                        },
                                        precalculateMatrix: function () {
                                            if (
                                                !this.a.k &&
                                                (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                                                (this.appliedTransformations = 1),
                                                !this.s.effectsSequence.length)
                                            ) {
                                                if (
                                                    (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                                                    (this.appliedTransformations = 2),
                                                    this.sk)
                                                ) {
                                                    if (
                                                        this.sk.effectsSequence.length ||
                                                        this.sa.effectsSequence.length
                                                    )
                                                        return;
                                                    this.pre.skewFromAxis(-this.sk.v, this.sa.v),
                                                        (this.appliedTransformations = 3);
                                                }
                                                this.r
                                                    ? this.r.effectsSequence.length ||
                                                      (this.pre.rotate(-this.r.v), (this.appliedTransformations = 4))
                                                    : this.rz.effectsSequence.length ||
                                                      this.ry.effectsSequence.length ||
                                                      this.rx.effectsSequence.length ||
                                                      this.or.effectsSequence.length ||
                                                      (this.pre
                                                          .rotateZ(-this.rz.v)
                                                          .rotateY(this.ry.v)
                                                          .rotateX(this.rx.v)
                                                          .rotateZ(-this.or.v[2])
                                                          .rotateY(this.or.v[1])
                                                          .rotateX(this.or.v[0]),
                                                      (this.appliedTransformations = 4));
                                            }
                                        },
                                        autoOrient: function () {},
                                    }),
                                    extendPrototype([DynamicPropertyContainer], e),
                                    (e.prototype.addDynamicProperty = function (t) {
                                        this._addDynamicProperty(t),
                                            this.elem.addDynamicProperty(t),
                                            (this._isDirty = !0);
                                    }),
                                    (e.prototype._addDynamicProperty =
                                        DynamicPropertyContainer.prototype.addDynamicProperty),
                                    {
                                        getTransformProperty: function (t, r, i) {
                                            return new e(t, r, i);
                                        },
                                    }
                                );
                            })();
                            function RepeaterModifier() {}
                            function RoundCornersModifier() {}
                            function floatEqual(t, e) {
                                return 1e5 * Math.abs(t - e) <= Math.min(Math.abs(t), Math.abs(e));
                            }
                            function floatZero(t) {
                                return Math.abs(t) <= 1e-5;
                            }
                            function lerp(t, e, r) {
                                return t * (1 - r) + e * r;
                            }
                            function lerpPoint(t, e, r) {
                                return [lerp(t[0], e[0], r), lerp(t[1], e[1], r)];
                            }
                            function quadRoots(t, e, r) {
                                if (0 === t) return [];
                                var i = e * e - 4 * t * r;
                                if (i < 0) return [];
                                var n = -e / (2 * t);
                                if (0 === i) return [n];
                                var s = Math.sqrt(i) / (2 * t);
                                return [n - s, n + s];
                            }
                            function polynomialCoefficients(t, e, r, i) {
                                return [3 * e - t - 3 * r + i, 3 * t - 6 * e + 3 * r, -3 * t + 3 * e, t];
                            }
                            function singlePoint(t) {
                                return new PolynomialBezier(t, t, t, t, !1);
                            }
                            function PolynomialBezier(t, e, r, i, n) {
                                n && pointEqual(t, e) && (e = lerpPoint(t, i, 1 / 3)),
                                    n && pointEqual(r, i) && (r = lerpPoint(t, i, 2 / 3));
                                var s = polynomialCoefficients(t[0], e[0], r[0], i[0]),
                                    a = polynomialCoefficients(t[1], e[1], r[1], i[1]);
                                (this.a = [s[0], a[0]]),
                                    (this.b = [s[1], a[1]]),
                                    (this.c = [s[2], a[2]]),
                                    (this.d = [s[3], a[3]]),
                                    (this.points = [t, e, r, i]);
                            }
                            function extrema(t, e) {
                                var r = t.points[0][e],
                                    i = t.points[t.points.length - 1][e];
                                if (r > i) {
                                    var n = i;
                                    (i = r), (r = n);
                                }
                                for (var s = quadRoots(3 * t.a[e], 2 * t.b[e], t.c[e]), a = 0; a < s.length; a += 1)
                                    if (s[a] > 0 && s[a] < 1) {
                                        var o = t.point(s[a])[e];
                                        o < r ? (r = o) : o > i && (i = o);
                                    }
                                return { min: r, max: i };
                            }
                            function intersectData(t, e, r) {
                                var i = t.boundingBox();
                                return {
                                    cx: i.cx,
                                    cy: i.cy,
                                    width: i.width,
                                    height: i.height,
                                    bez: t,
                                    t: (e + r) / 2,
                                    t1: e,
                                    t2: r,
                                };
                            }
                            function splitData(t) {
                                var e = t.bez.split(0.5);
                                return [intersectData(e[0], t.t1, t.t), intersectData(e[1], t.t, t.t2)];
                            }
                            function boxIntersect(t, e) {
                                return (
                                    2 * Math.abs(t.cx - e.cx) < t.width + e.width &&
                                    2 * Math.abs(t.cy - e.cy) < t.height + e.height
                                );
                            }
                            function intersectsImpl(t, e, r, i, n, s) {
                                if (boxIntersect(t, e))
                                    if (r >= s || (t.width <= i && t.height <= i && e.width <= i && e.height <= i))
                                        n.push([t.t, e.t]);
                                    else {
                                        var a = splitData(t),
                                            o = splitData(e);
                                        intersectsImpl(a[0], o[0], r + 1, i, n, s),
                                            intersectsImpl(a[0], o[1], r + 1, i, n, s),
                                            intersectsImpl(a[1], o[0], r + 1, i, n, s),
                                            intersectsImpl(a[1], o[1], r + 1, i, n, s);
                                    }
                            }
                            function crossProduct(t, e) {
                                return [
                                    t[1] * e[2] - t[2] * e[1],
                                    t[2] * e[0] - t[0] * e[2],
                                    t[0] * e[1] - t[1] * e[0],
                                ];
                            }
                            function lineIntersection(t, e, r, i) {
                                var n = [t[0], t[1], 1],
                                    s = [e[0], e[1], 1],
                                    a = [r[0], r[1], 1],
                                    o = [i[0], i[1], 1],
                                    l = crossProduct(crossProduct(n, s), crossProduct(a, o));
                                return floatZero(l[2]) ? null : [l[0] / l[2], l[1] / l[2]];
                            }
                            function polarOffset(t, e, r) {
                                return [t[0] + Math.cos(e) * r, t[1] - Math.sin(e) * r];
                            }
                            function pointDistance(t, e) {
                                return Math.hypot(t[0] - e[0], t[1] - e[1]);
                            }
                            function pointEqual(t, e) {
                                return floatEqual(t[0], e[0]) && floatEqual(t[1], e[1]);
                            }
                            function ZigZagModifier() {}
                            function setPoint(t, e, r, i, n, s, a) {
                                var o = r - Math.PI / 2,
                                    l = r + Math.PI / 2,
                                    h = e[0] + Math.cos(r) * i * n,
                                    p = e[1] - Math.sin(r) * i * n;
                                t.setTripleAt(
                                    h,
                                    p,
                                    h + Math.cos(o) * s,
                                    p - Math.sin(o) * s,
                                    h + Math.cos(l) * a,
                                    p - Math.sin(l) * a,
                                    t.length()
                                );
                            }
                            function getPerpendicularVector(t, e) {
                                var r = [e[0] - t[0], e[1] - t[1]],
                                    i = 0.5 * -Math.PI;
                                return [
                                    Math.cos(i) * r[0] - Math.sin(i) * r[1],
                                    Math.sin(i) * r[0] + Math.cos(i) * r[1],
                                ];
                            }
                            function getProjectingAngle(t, e) {
                                var r = 0 === e ? t.length() - 1 : e - 1,
                                    i = (e + 1) % t.length(),
                                    n = getPerpendicularVector(t.v[r], t.v[i]);
                                return Math.atan2(0, 1) - Math.atan2(n[1], n[0]);
                            }
                            function zigZagCorner(t, e, r, i, n, s, a) {
                                var o = getProjectingAngle(e, r),
                                    l = e.v[r % e._length],
                                    h = e.v[0 === r ? e._length - 1 : r - 1],
                                    p = e.v[(r + 1) % e._length],
                                    c = 2 === s ? Math.sqrt(Math.pow(l[0] - h[0], 2) + Math.pow(l[1] - h[1], 2)) : 0,
                                    d = 2 === s ? Math.sqrt(Math.pow(l[0] - p[0], 2) + Math.pow(l[1] - p[1], 2)) : 0;
                                setPoint(t, e.v[r % e._length], o, a, i, d / (2 * (n + 1)), c / (2 * (n + 1)), s);
                            }
                            function zigZagSegment(t, e, r, i, n, s) {
                                for (var a = 0; a < i; a += 1) {
                                    var o = (a + 1) / (i + 1),
                                        l =
                                            2 === n
                                                ? Math.sqrt(
                                                      Math.pow(e.points[3][0] - e.points[0][0], 2) +
                                                          Math.pow(e.points[3][1] - e.points[0][1], 2)
                                                  )
                                                : 0,
                                        h = e.normalAngle(o);
                                    setPoint(t, e.point(o), h, s, r, l / (2 * (i + 1)), l / (2 * (i + 1)), n), (s = -s);
                                }
                                return s;
                            }
                            function linearOffset(t, e, r) {
                                var i = Math.atan2(e[0] - t[0], e[1] - t[1]);
                                return [polarOffset(t, i, r), polarOffset(e, i, r)];
                            }
                            function offsetSegment(t, e) {
                                var r, i, n, s, a, o, l;
                                (r = (l = linearOffset(t.points[0], t.points[1], e))[0]),
                                    (i = l[1]),
                                    (n = (l = linearOffset(t.points[1], t.points[2], e))[0]),
                                    (s = l[1]),
                                    (a = (l = linearOffset(t.points[2], t.points[3], e))[0]),
                                    (o = l[1]);
                                var h = lineIntersection(r, i, n, s);
                                null === h && (h = i);
                                var p = lineIntersection(a, o, n, s);
                                return null === p && (p = a), new PolynomialBezier(r, h, p, o);
                            }
                            function joinLines(t, e, r, i, n) {
                                var s = e.points[3],
                                    a = r.points[0];
                                if (3 === i) return s;
                                if (pointEqual(s, a)) return s;
                                if (2 === i) {
                                    var o = -e.tangentAngle(1),
                                        l = -r.tangentAngle(0) + Math.PI,
                                        h = lineIntersection(
                                            s,
                                            polarOffset(s, o + Math.PI / 2, 100),
                                            a,
                                            polarOffset(a, o + Math.PI / 2, 100)
                                        ),
                                        p = h ? pointDistance(h, s) : pointDistance(s, a) / 2,
                                        c = polarOffset(s, o, 2 * p * roundCorner);
                                    return (
                                        t.setXYAt(c[0], c[1], "o", t.length() - 1),
                                        (c = polarOffset(a, l, 2 * p * roundCorner)),
                                        t.setTripleAt(a[0], a[1], a[0], a[1], c[0], c[1], t.length()),
                                        a
                                    );
                                }
                                var d = lineIntersection(
                                    pointEqual(s, e.points[2]) ? e.points[0] : e.points[2],
                                    s,
                                    a,
                                    pointEqual(a, r.points[1]) ? r.points[3] : r.points[1]
                                );
                                return d && pointDistance(d, s) < n
                                    ? (t.setTripleAt(d[0], d[1], d[0], d[1], d[0], d[1], t.length()), d)
                                    : s;
                            }
                            function getIntersection(t, e) {
                                var r = t.intersections(e);
                                return r.length && floatEqual(r[0][0], 1) && r.shift(), r.length ? r[0] : null;
                            }
                            function pruneSegmentIntersection(t, e) {
                                var r = t.slice(),
                                    i = e.slice(),
                                    n = getIntersection(t[t.length - 1], e[0]);
                                return (
                                    n &&
                                        ((r[t.length - 1] = t[t.length - 1].split(n[0])[0]),
                                        (i[0] = e[0].split(n[1])[1])),
                                    t.length > 1 && e.length > 1 && (n = getIntersection(t[0], e[e.length - 1]))
                                        ? [[t[0].split(n[0])[0]], [e[e.length - 1].split(n[1])[1]]]
                                        : [r, i]
                                );
                            }
                            function pruneIntersections(t) {
                                for (var e, r = 1; r < t.length; r += 1)
                                    (e = pruneSegmentIntersection(t[r - 1], t[r])), (t[r - 1] = e[0]), (t[r] = e[1]);
                                return (
                                    t.length > 1 &&
                                        ((e = pruneSegmentIntersection(t[t.length - 1], t[0])),
                                        (t[t.length - 1] = e[0]),
                                        (t[0] = e[1])),
                                    t
                                );
                            }
                            function offsetSegmentSplit(t, e) {
                                var r,
                                    i,
                                    n,
                                    s,
                                    a = t.inflectionPoints();
                                if (0 === a.length) return [offsetSegment(t, e)];
                                if (1 === a.length || floatEqual(a[1], 1))
                                    return (
                                        (r = (n = t.split(a[0]))[0]),
                                        (i = n[1]),
                                        [offsetSegment(r, e), offsetSegment(i, e)]
                                    );
                                r = (n = t.split(a[0]))[0];
                                var o = (a[1] - a[0]) / (1 - a[0]);
                                return (
                                    (s = (n = n[1].split(o))[0]),
                                    (i = n[1]),
                                    [offsetSegment(r, e), offsetSegment(s, e), offsetSegment(i, e)]
                                );
                            }
                            function OffsetPathModifier() {}
                            function getFontProperties(t) {
                                for (
                                    var e = t.fStyle ? t.fStyle.split(" ") : [],
                                        r = "normal",
                                        i = "normal",
                                        n = e.length,
                                        s = 0;
                                    s < n;
                                    s += 1
                                )
                                    switch (e[s].toLowerCase()) {
                                        case "italic":
                                            i = "italic";
                                            break;
                                        case "bold":
                                            r = "700";
                                            break;
                                        case "black":
                                            r = "900";
                                            break;
                                        case "medium":
                                            r = "500";
                                            break;
                                        case "regular":
                                        case "normal":
                                            r = "400";
                                            break;
                                        case "light":
                                        case "thin":
                                            r = "200";
                                    }
                                return { style: i, weight: t.fWeight || r };
                            }
                            extendPrototype([ShapeModifier], RepeaterModifier),
                                (RepeaterModifier.prototype.initModifierProperties = function (t, e) {
                                    (this.getValue = this.processKeys),
                                        (this.c = PropertyFactory.getProp(t, e.c, 0, null, this)),
                                        (this.o = PropertyFactory.getProp(t, e.o, 0, null, this)),
                                        (this.tr = TransformPropertyFactory.getTransformProperty(t, e.tr, this)),
                                        (this.so = PropertyFactory.getProp(t, e.tr.so, 0, 0.01, this)),
                                        (this.eo = PropertyFactory.getProp(t, e.tr.eo, 0, 0.01, this)),
                                        (this.data = e),
                                        this.dynamicProperties.length || this.getValue(!0),
                                        (this._isAnimated = !!this.dynamicProperties.length),
                                        (this.pMatrix = new Matrix()),
                                        (this.rMatrix = new Matrix()),
                                        (this.sMatrix = new Matrix()),
                                        (this.tMatrix = new Matrix()),
                                        (this.matrix = new Matrix());
                                }),
                                (RepeaterModifier.prototype.applyTransforms = function (t, e, r, i, n, s) {
                                    var a = s ? -1 : 1,
                                        o = i.s.v[0] + (1 - i.s.v[0]) * (1 - n),
                                        l = i.s.v[1] + (1 - i.s.v[1]) * (1 - n);
                                    t.translate(i.p.v[0] * a * n, i.p.v[1] * a * n, i.p.v[2]),
                                        e.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]),
                                        e.rotate(-i.r.v * a * n),
                                        e.translate(i.a.v[0], i.a.v[1], i.a.v[2]),
                                        r.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]),
                                        r.scale(s ? 1 / o : o, s ? 1 / l : l),
                                        r.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
                                }),
                                (RepeaterModifier.prototype.init = function (t, e, r, i) {
                                    for (
                                        this.elem = t,
                                            this.arr = e,
                                            this.pos = r,
                                            this.elemsData = i,
                                            this._currentCopies = 0,
                                            this._elements = [],
                                            this._groups = [],
                                            this.frameId = -1,
                                            this.initDynamicPropertyContainer(t),
                                            this.initModifierProperties(t, e[r]);
                                        r > 0;

                                    )
                                        (r -= 1), this._elements.unshift(e[r]);
                                    this.dynamicProperties.length ? (this.k = !0) : this.getValue(!0);
                                }),
                                (RepeaterModifier.prototype.resetElements = function (t) {
                                    var e,
                                        r = t.length;
                                    for (e = 0; e < r; e += 1)
                                        (t[e]._processed = !1), "gr" === t[e].ty && this.resetElements(t[e].it);
                                }),
                                (RepeaterModifier.prototype.cloneElements = function (t) {
                                    var e = JSON.parse(JSON.stringify(t));
                                    return this.resetElements(e), e;
                                }),
                                (RepeaterModifier.prototype.changeGroupRender = function (t, e) {
                                    var r,
                                        i = t.length;
                                    for (r = 0; r < i; r += 1)
                                        (t[r]._render = e), "gr" === t[r].ty && this.changeGroupRender(t[r].it, e);
                                }),
                                (RepeaterModifier.prototype.processShapes = function (t) {
                                    var e,
                                        r,
                                        i,
                                        n,
                                        s,
                                        a = !1;
                                    if (this._mdf || t) {
                                        var o,
                                            l = Math.ceil(this.c.v);
                                        if (this._groups.length < l) {
                                            for (; this._groups.length < l; ) {
                                                var h = { it: this.cloneElements(this._elements), ty: "gr" };
                                                h.it.push({
                                                    a: { a: 0, ix: 1, k: [0, 0] },
                                                    nm: "Transform",
                                                    o: { a: 0, ix: 7, k: 100 },
                                                    p: { a: 0, ix: 2, k: [0, 0] },
                                                    r: {
                                                        a: 1,
                                                        ix: 6,
                                                        k: [
                                                            { s: 0, e: 0, t: 0 },
                                                            { s: 0, e: 0, t: 1 },
                                                        ],
                                                    },
                                                    s: { a: 0, ix: 3, k: [100, 100] },
                                                    sa: { a: 0, ix: 5, k: 0 },
                                                    sk: { a: 0, ix: 4, k: 0 },
                                                    ty: "tr",
                                                }),
                                                    this.arr.splice(0, 0, h),
                                                    this._groups.splice(0, 0, h),
                                                    (this._currentCopies += 1);
                                            }
                                            this.elem.reloadShapes(), (a = !0);
                                        }
                                        for (s = 0, i = 0; i <= this._groups.length - 1; i += 1) {
                                            if (
                                                ((o = s < l),
                                                (this._groups[i]._render = o),
                                                this.changeGroupRender(this._groups[i].it, o),
                                                !o)
                                            ) {
                                                var p = this.elemsData[i].it,
                                                    c = p[p.length - 1];
                                                0 !== c.transform.op.v
                                                    ? ((c.transform.op._mdf = !0), (c.transform.op.v = 0))
                                                    : (c.transform.op._mdf = !1);
                                            }
                                            s += 1;
                                        }
                                        this._currentCopies = l;
                                        var d = this.o.v,
                                            u = d % 1,
                                            f = d > 0 ? Math.floor(d) : Math.ceil(d),
                                            m = this.pMatrix.props,
                                            g = this.rMatrix.props,
                                            y = this.sMatrix.props;
                                        this.pMatrix.reset(),
                                            this.rMatrix.reset(),
                                            this.sMatrix.reset(),
                                            this.tMatrix.reset(),
                                            this.matrix.reset();
                                        var v,
                                            b,
                                            _ = 0;
                                        if (d > 0) {
                                            for (; _ < f; )
                                                this.applyTransforms(
                                                    this.pMatrix,
                                                    this.rMatrix,
                                                    this.sMatrix,
                                                    this.tr,
                                                    1,
                                                    !1
                                                ),
                                                    (_ += 1);
                                            u &&
                                                (this.applyTransforms(
                                                    this.pMatrix,
                                                    this.rMatrix,
                                                    this.sMatrix,
                                                    this.tr,
                                                    u,
                                                    !1
                                                ),
                                                (_ += u));
                                        } else if (d < 0) {
                                            for (; _ > f; )
                                                this.applyTransforms(
                                                    this.pMatrix,
                                                    this.rMatrix,
                                                    this.sMatrix,
                                                    this.tr,
                                                    1,
                                                    !0
                                                ),
                                                    (_ -= 1);
                                            u &&
                                                (this.applyTransforms(
                                                    this.pMatrix,
                                                    this.rMatrix,
                                                    this.sMatrix,
                                                    this.tr,
                                                    -u,
                                                    !0
                                                ),
                                                (_ -= u));
                                        }
                                        for (
                                            i = 1 === this.data.m ? 0 : this._currentCopies - 1,
                                                n = 1 === this.data.m ? 1 : -1,
                                                s = this._currentCopies;
                                            s;

                                        ) {
                                            if (
                                                ((b = (r = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v
                                                    .props).length),
                                                (e[e.length - 1].transform.mProps._mdf = !0),
                                                (e[e.length - 1].transform.op._mdf = !0),
                                                (e[e.length - 1].transform.op.v =
                                                    1 === this._currentCopies
                                                        ? this.so.v
                                                        : this.so.v +
                                                          (this.eo.v - this.so.v) * (i / (this._currentCopies - 1))),
                                                0 !== _)
                                            ) {
                                                for (
                                                    ((0 !== i && 1 === n) ||
                                                        (i !== this._currentCopies - 1 && -1 === n)) &&
                                                        this.applyTransforms(
                                                            this.pMatrix,
                                                            this.rMatrix,
                                                            this.sMatrix,
                                                            this.tr,
                                                            1,
                                                            !1
                                                        ),
                                                        this.matrix.transform(
                                                            g[0],
                                                            g[1],
                                                            g[2],
                                                            g[3],
                                                            g[4],
                                                            g[5],
                                                            g[6],
                                                            g[7],
                                                            g[8],
                                                            g[9],
                                                            g[10],
                                                            g[11],
                                                            g[12],
                                                            g[13],
                                                            g[14],
                                                            g[15]
                                                        ),
                                                        this.matrix.transform(
                                                            y[0],
                                                            y[1],
                                                            y[2],
                                                            y[3],
                                                            y[4],
                                                            y[5],
                                                            y[6],
                                                            y[7],
                                                            y[8],
                                                            y[9],
                                                            y[10],
                                                            y[11],
                                                            y[12],
                                                            y[13],
                                                            y[14],
                                                            y[15]
                                                        ),
                                                        this.matrix.transform(
                                                            m[0],
                                                            m[1],
                                                            m[2],
                                                            m[3],
                                                            m[4],
                                                            m[5],
                                                            m[6],
                                                            m[7],
                                                            m[8],
                                                            m[9],
                                                            m[10],
                                                            m[11],
                                                            m[12],
                                                            m[13],
                                                            m[14],
                                                            m[15]
                                                        ),
                                                        v = 0;
                                                    v < b;
                                                    v += 1
                                                )
                                                    r[v] = this.matrix.props[v];
                                                this.matrix.reset();
                                            } else
                                                for (this.matrix.reset(), v = 0; v < b; v += 1)
                                                    r[v] = this.matrix.props[v];
                                            (_ += 1), (s -= 1), (i += n);
                                        }
                                    } else
                                        for (s = this._currentCopies, i = 0, n = 1; s; )
                                            (r = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v.props),
                                                (e[e.length - 1].transform.mProps._mdf = !1),
                                                (e[e.length - 1].transform.op._mdf = !1),
                                                (s -= 1),
                                                (i += n);
                                    return a;
                                }),
                                (RepeaterModifier.prototype.addShape = function () {}),
                                extendPrototype([ShapeModifier], RoundCornersModifier),
                                (RoundCornersModifier.prototype.initModifierProperties = function (t, e) {
                                    (this.getValue = this.processKeys),
                                        (this.rd = PropertyFactory.getProp(t, e.r, 0, null, this)),
                                        (this._isAnimated = !!this.rd.effectsSequence.length);
                                }),
                                (RoundCornersModifier.prototype.processPath = function (t, e) {
                                    var r,
                                        i = shapePool.newElement();
                                    i.c = t.c;
                                    var n,
                                        s,
                                        a,
                                        o,
                                        l,
                                        h,
                                        p,
                                        c,
                                        d,
                                        u,
                                        f,
                                        m,
                                        g = t._length,
                                        y = 0;
                                    for (r = 0; r < g; r += 1)
                                        (n = t.v[r]),
                                            (a = t.o[r]),
                                            (s = t.i[r]),
                                            n[0] === a[0] && n[1] === a[1] && n[0] === s[0] && n[1] === s[1]
                                                ? (0 !== r && r !== g - 1) || t.c
                                                    ? ((o = 0 === r ? t.v[g - 1] : t.v[r - 1]),
                                                      (h = (l = Math.sqrt(
                                                          Math.pow(n[0] - o[0], 2) + Math.pow(n[1] - o[1], 2)
                                                      ))
                                                          ? Math.min(l / 2, e) / l
                                                          : 0),
                                                      (p = f = n[0] + (o[0] - n[0]) * h),
                                                      (c = m = n[1] - (n[1] - o[1]) * h),
                                                      (d = p - (p - n[0]) * roundCorner),
                                                      (u = c - (c - n[1]) * roundCorner),
                                                      i.setTripleAt(p, c, d, u, f, m, y),
                                                      (y += 1),
                                                      (o = r === g - 1 ? t.v[0] : t.v[r + 1]),
                                                      (h = (l = Math.sqrt(
                                                          Math.pow(n[0] - o[0], 2) + Math.pow(n[1] - o[1], 2)
                                                      ))
                                                          ? Math.min(l / 2, e) / l
                                                          : 0),
                                                      (p = d = n[0] + (o[0] - n[0]) * h),
                                                      (c = u = n[1] + (o[1] - n[1]) * h),
                                                      (f = p - (p - n[0]) * roundCorner),
                                                      (m = c - (c - n[1]) * roundCorner),
                                                      i.setTripleAt(p, c, d, u, f, m, y),
                                                      (y += 1))
                                                    : (i.setTripleAt(n[0], n[1], a[0], a[1], s[0], s[1], y), (y += 1))
                                                : (i.setTripleAt(
                                                      t.v[r][0],
                                                      t.v[r][1],
                                                      t.o[r][0],
                                                      t.o[r][1],
                                                      t.i[r][0],
                                                      t.i[r][1],
                                                      y
                                                  ),
                                                  (y += 1));
                                    return i;
                                }),
                                (RoundCornersModifier.prototype.processShapes = function (t) {
                                    var e,
                                        r,
                                        i,
                                        n,
                                        s,
                                        a,
                                        o = this.shapes.length,
                                        l = this.rd.v;
                                    if (0 !== l)
                                        for (r = 0; r < o; r += 1) {
                                            if (
                                                ((a = (s = this.shapes[r]).localShapeCollection),
                                                s.shape._mdf || this._mdf || t)
                                            )
                                                for (
                                                    a.releaseShapes(),
                                                        s.shape._mdf = !0,
                                                        e = s.shape.paths.shapes,
                                                        n = s.shape.paths._length,
                                                        i = 0;
                                                    i < n;
                                                    i += 1
                                                )
                                                    a.addShape(this.processPath(e[i], l));
                                            s.shape.paths = s.localShapeCollection;
                                        }
                                    this.dynamicProperties.length || (this._mdf = !1);
                                }),
                                (PolynomialBezier.prototype.point = function (t) {
                                    return [
                                        ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
                                        ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1],
                                    ];
                                }),
                                (PolynomialBezier.prototype.derivative = function (t) {
                                    return [
                                        (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
                                        (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1],
                                    ];
                                }),
                                (PolynomialBezier.prototype.tangentAngle = function (t) {
                                    var e = this.derivative(t);
                                    return Math.atan2(e[1], e[0]);
                                }),
                                (PolynomialBezier.prototype.normalAngle = function (t) {
                                    var e = this.derivative(t);
                                    return Math.atan2(e[0], e[1]);
                                }),
                                (PolynomialBezier.prototype.inflectionPoints = function () {
                                    var t = this.a[1] * this.b[0] - this.a[0] * this.b[1];
                                    if (floatZero(t)) return [];
                                    var e = (-0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1])) / t,
                                        r = e * e - ((1 / 3) * (this.b[1] * this.c[0] - this.b[0] * this.c[1])) / t;
                                    if (r < 0) return [];
                                    var i = Math.sqrt(r);
                                    return floatZero(i)
                                        ? i > 0 && i < 1
                                            ? [e]
                                            : []
                                        : [e - i, e + i].filter(function (t) {
                                              return t > 0 && t < 1;
                                          });
                                }),
                                (PolynomialBezier.prototype.split = function (t) {
                                    if (t <= 0) return [singlePoint(this.points[0]), this];
                                    if (t >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
                                    var e = lerpPoint(this.points[0], this.points[1], t),
                                        r = lerpPoint(this.points[1], this.points[2], t),
                                        i = lerpPoint(this.points[2], this.points[3], t),
                                        n = lerpPoint(e, r, t),
                                        s = lerpPoint(r, i, t),
                                        a = lerpPoint(n, s, t);
                                    return [
                                        new PolynomialBezier(this.points[0], e, n, a, !0),
                                        new PolynomialBezier(a, s, i, this.points[3], !0),
                                    ];
                                }),
                                (PolynomialBezier.prototype.bounds = function () {
                                    return { x: extrema(this, 0), y: extrema(this, 1) };
                                }),
                                (PolynomialBezier.prototype.boundingBox = function () {
                                    var t = this.bounds();
                                    return {
                                        left: t.x.min,
                                        right: t.x.max,
                                        top: t.y.min,
                                        bottom: t.y.max,
                                        width: t.x.max - t.x.min,
                                        height: t.y.max - t.y.min,
                                        cx: (t.x.max + t.x.min) / 2,
                                        cy: (t.y.max + t.y.min) / 2,
                                    };
                                }),
                                (PolynomialBezier.prototype.intersections = function (t, e, r) {
                                    void 0 === e && (e = 2), void 0 === r && (r = 7);
                                    var i = [];
                                    return (
                                        intersectsImpl(intersectData(this, 0, 1), intersectData(t, 0, 1), 0, e, i, r), i
                                    );
                                }),
                                (PolynomialBezier.shapeSegment = function (t, e) {
                                    var r = (e + 1) % t.length();
                                    return new PolynomialBezier(t.v[e], t.o[e], t.i[r], t.v[r], !0);
                                }),
                                (PolynomialBezier.shapeSegmentInverted = function (t, e) {
                                    var r = (e + 1) % t.length();
                                    return new PolynomialBezier(t.v[r], t.i[r], t.o[e], t.v[e], !0);
                                }),
                                extendPrototype([ShapeModifier], ZigZagModifier),
                                (ZigZagModifier.prototype.initModifierProperties = function (t, e) {
                                    (this.getValue = this.processKeys),
                                        (this.amplitude = PropertyFactory.getProp(t, e.s, 0, null, this)),
                                        (this.frequency = PropertyFactory.getProp(t, e.r, 0, null, this)),
                                        (this.pointsType = PropertyFactory.getProp(t, e.pt, 0, null, this)),
                                        (this._isAnimated =
                                            0 !== this.amplitude.effectsSequence.length ||
                                            0 !== this.frequency.effectsSequence.length ||
                                            0 !== this.pointsType.effectsSequence.length);
                                }),
                                (ZigZagModifier.prototype.processPath = function (t, e, r, i) {
                                    var n = t._length,
                                        s = shapePool.newElement();
                                    if (((s.c = t.c), t.c || (n -= 1), 0 === n)) return s;
                                    var a = -1,
                                        o = PolynomialBezier.shapeSegment(t, 0);
                                    zigZagCorner(s, t, 0, e, r, i, a);
                                    for (var l = 0; l < n; l += 1)
                                        (a = zigZagSegment(s, o, e, r, i, -a)),
                                            (o =
                                                l !== n - 1 || t.c
                                                    ? PolynomialBezier.shapeSegment(t, (l + 1) % n)
                                                    : null),
                                            zigZagCorner(s, t, l + 1, e, r, i, a);
                                    return s;
                                }),
                                (ZigZagModifier.prototype.processShapes = function (t) {
                                    var e,
                                        r,
                                        i,
                                        n,
                                        s,
                                        a,
                                        o = this.shapes.length,
                                        l = this.amplitude.v,
                                        h = Math.max(0, Math.round(this.frequency.v)),
                                        p = this.pointsType.v;
                                    if (0 !== l)
                                        for (r = 0; r < o; r += 1) {
                                            if (
                                                ((a = (s = this.shapes[r]).localShapeCollection),
                                                s.shape._mdf || this._mdf || t)
                                            )
                                                for (
                                                    a.releaseShapes(),
                                                        s.shape._mdf = !0,
                                                        e = s.shape.paths.shapes,
                                                        n = s.shape.paths._length,
                                                        i = 0;
                                                    i < n;
                                                    i += 1
                                                )
                                                    a.addShape(this.processPath(e[i], l, h, p));
                                            s.shape.paths = s.localShapeCollection;
                                        }
                                    this.dynamicProperties.length || (this._mdf = !1);
                                }),
                                extendPrototype([ShapeModifier], OffsetPathModifier),
                                (OffsetPathModifier.prototype.initModifierProperties = function (t, e) {
                                    (this.getValue = this.processKeys),
                                        (this.amount = PropertyFactory.getProp(t, e.a, 0, null, this)),
                                        (this.miterLimit = PropertyFactory.getProp(t, e.ml, 0, null, this)),
                                        (this.lineJoin = e.lj),
                                        (this._isAnimated = 0 !== this.amount.effectsSequence.length);
                                }),
                                (OffsetPathModifier.prototype.processPath = function (t, e, r, i) {
                                    var n = shapePool.newElement();
                                    n.c = t.c;
                                    var s,
                                        a,
                                        o,
                                        l = t.length();
                                    t.c || (l -= 1);
                                    var h = [];
                                    for (s = 0; s < l; s += 1)
                                        (o = PolynomialBezier.shapeSegment(t, s)), h.push(offsetSegmentSplit(o, e));
                                    if (!t.c)
                                        for (s = l - 1; s >= 0; s -= 1)
                                            (o = PolynomialBezier.shapeSegmentInverted(t, s)),
                                                h.push(offsetSegmentSplit(o, e));
                                    h = pruneIntersections(h);
                                    var p = null,
                                        c = null;
                                    for (s = 0; s < h.length; s += 1) {
                                        var d = h[s];
                                        for (
                                            c && (p = joinLines(n, c, d[0], r, i)), c = d[d.length - 1], a = 0;
                                            a < d.length;
                                            a += 1
                                        )
                                            (o = d[a]),
                                                p && pointEqual(o.points[0], p)
                                                    ? n.setXYAt(o.points[1][0], o.points[1][1], "o", n.length() - 1)
                                                    : n.setTripleAt(
                                                          o.points[0][0],
                                                          o.points[0][1],
                                                          o.points[1][0],
                                                          o.points[1][1],
                                                          o.points[0][0],
                                                          o.points[0][1],
                                                          n.length()
                                                      ),
                                                n.setTripleAt(
                                                    o.points[3][0],
                                                    o.points[3][1],
                                                    o.points[3][0],
                                                    o.points[3][1],
                                                    o.points[2][0],
                                                    o.points[2][1],
                                                    n.length()
                                                ),
                                                (p = o.points[3]);
                                    }
                                    return h.length && joinLines(n, c, h[0][0], r, i), n;
                                }),
                                (OffsetPathModifier.prototype.processShapes = function (t) {
                                    var e,
                                        r,
                                        i,
                                        n,
                                        s,
                                        a,
                                        o = this.shapes.length,
                                        l = this.amount.v,
                                        h = this.miterLimit.v,
                                        p = this.lineJoin;
                                    if (0 !== l)
                                        for (r = 0; r < o; r += 1) {
                                            if (
                                                ((a = (s = this.shapes[r]).localShapeCollection),
                                                s.shape._mdf || this._mdf || t)
                                            )
                                                for (
                                                    a.releaseShapes(),
                                                        s.shape._mdf = !0,
                                                        e = s.shape.paths.shapes,
                                                        n = s.shape.paths._length,
                                                        i = 0;
                                                    i < n;
                                                    i += 1
                                                )
                                                    a.addShape(this.processPath(e[i], l, p, h));
                                            s.shape.paths = s.localShapeCollection;
                                        }
                                    this.dynamicProperties.length || (this._mdf = !1);
                                });
                            var FontManager = (function () {
                                var t = { w: 0, size: 0, shapes: [], data: { shapes: [] } },
                                    e = [];
                                e = e.concat([
                                    2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371,
                                    2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388,
                                    2389, 2390, 2391, 2402, 2403,
                                ]);
                                var r = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"],
                                    i = [65039, 8205];
                                function n(t, e) {
                                    var r = createTag("span");
                                    r.setAttribute("aria-hidden", !0), (r.style.fontFamily = e);
                                    var i = createTag("span");
                                    (i.innerText = "giItT1WQy@!-/#"),
                                        (r.style.position = "absolute"),
                                        (r.style.left = "-10000px"),
                                        (r.style.top = "-10000px"),
                                        (r.style.fontSize = "300px"),
                                        (r.style.fontVariant = "normal"),
                                        (r.style.fontStyle = "normal"),
                                        (r.style.fontWeight = "normal"),
                                        (r.style.letterSpacing = "0"),
                                        r.appendChild(i),
                                        document.body.appendChild(r);
                                    var n = i.offsetWidth;
                                    return (
                                        (i.style.fontFamily =
                                            (function (t) {
                                                var e,
                                                    r = t.split(","),
                                                    i = r.length,
                                                    n = [];
                                                for (e = 0; e < i; e += 1)
                                                    "sans-serif" !== r[e] && "monospace" !== r[e] && n.push(r[e]);
                                                return n.join(",");
                                            })(t) +
                                            ", " +
                                            e),
                                        { node: i, w: n, parent: r }
                                    );
                                }
                                function s(t, e) {
                                    var r,
                                        i = document.body && e ? "svg" : "canvas",
                                        n = getFontProperties(t);
                                    if ("svg" === i) {
                                        var s = createNS("text");
                                        (s.style.fontSize = "100px"),
                                            s.setAttribute("font-family", t.fFamily),
                                            s.setAttribute("font-style", n.style),
                                            s.setAttribute("font-weight", n.weight),
                                            (s.textContent = "1"),
                                            t.fClass
                                                ? ((s.style.fontFamily = "inherit"), s.setAttribute("class", t.fClass))
                                                : (s.style.fontFamily = t.fFamily),
                                            e.appendChild(s),
                                            (r = s);
                                    } else {
                                        var a = new OffscreenCanvas(500, 500).getContext("2d");
                                        (a.font = n.style + " " + n.weight + " 100px " + t.fFamily), (r = a);
                                    }
                                    return {
                                        measureText: function (t) {
                                            return "svg" === i
                                                ? ((r.textContent = t), r.getComputedTextLength())
                                                : r.measureText(t).width;
                                        },
                                    };
                                }
                                var a = function () {
                                    (this.fonts = []),
                                        (this.chars = null),
                                        (this.typekitLoaded = 0),
                                        (this.isLoaded = !1),
                                        (this._warned = !1),
                                        (this.initTime = Date.now()),
                                        (this.setIsLoadedBinded = this.setIsLoaded.bind(this)),
                                        (this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this));
                                };
                                return (
                                    (a.isModifier = function (t, e) {
                                        var i = t.toString(16) + e.toString(16);
                                        return -1 !== r.indexOf(i);
                                    }),
                                    (a.isZeroWidthJoiner = function (t, e) {
                                        return e ? t === i[0] && e === i[1] : t === i[1];
                                    }),
                                    (a.isCombinedCharacter = function (t) {
                                        return -1 !== e.indexOf(t);
                                    }),
                                    (a.prototype = {
                                        addChars: function (t) {
                                            if (t) {
                                                var e;
                                                this.chars || (this.chars = []);
                                                var r,
                                                    i,
                                                    n = t.length,
                                                    s = this.chars.length;
                                                for (e = 0; e < n; e += 1) {
                                                    for (r = 0, i = !1; r < s; )
                                                        this.chars[r].style === t[e].style &&
                                                            this.chars[r].fFamily === t[e].fFamily &&
                                                            this.chars[r].ch === t[e].ch &&
                                                            (i = !0),
                                                            (r += 1);
                                                    i || (this.chars.push(t[e]), (s += 1));
                                                }
                                            }
                                        },
                                        addFonts: function (t, e) {
                                            if (t) {
                                                if (this.chars) return (this.isLoaded = !0), void (this.fonts = t.list);
                                                if (!document.body)
                                                    return (
                                                        (this.isLoaded = !0),
                                                        t.list.forEach(function (t) {
                                                            (t.helper = s(t)), (t.cache = {});
                                                        }),
                                                        void (this.fonts = t.list)
                                                    );
                                                var r,
                                                    i = t.list,
                                                    a = i.length,
                                                    o = a;
                                                for (r = 0; r < a; r += 1) {
                                                    var l,
                                                        h,
                                                        p = !0;
                                                    if (
                                                        ((i[r].loaded = !1),
                                                        (i[r].monoCase = n(i[r].fFamily, "monospace")),
                                                        (i[r].sansCase = n(i[r].fFamily, "sans-serif")),
                                                        i[r].fPath)
                                                    ) {
                                                        if ("p" === i[r].fOrigin || 3 === i[r].origin) {
                                                            if (
                                                                ((l = document.querySelectorAll(
                                                                    'style[f-forigin="p"][f-family="' +
                                                                        i[r].fFamily +
                                                                        '"], style[f-origin="3"][f-family="' +
                                                                        i[r].fFamily +
                                                                        '"]'
                                                                )).length > 0 && (p = !1),
                                                                p)
                                                            ) {
                                                                var c = createTag("style");
                                                                c.setAttribute("f-forigin", i[r].fOrigin),
                                                                    c.setAttribute("f-origin", i[r].origin),
                                                                    c.setAttribute("f-family", i[r].fFamily),
                                                                    (c.type = "text/css"),
                                                                    (c.innerText =
                                                                        "@font-face {font-family: " +
                                                                        i[r].fFamily +
                                                                        "; font-style: normal; src: url('" +
                                                                        i[r].fPath +
                                                                        "');}"),
                                                                    e.appendChild(c);
                                                            }
                                                        } else if ("g" === i[r].fOrigin || 1 === i[r].origin) {
                                                            for (
                                                                l = document.querySelectorAll(
                                                                    'link[f-forigin="g"], link[f-origin="1"]'
                                                                ),
                                                                    h = 0;
                                                                h < l.length;
                                                                h += 1
                                                            )
                                                                -1 !== l[h].href.indexOf(i[r].fPath) && (p = !1);
                                                            if (p) {
                                                                var d = createTag("link");
                                                                d.setAttribute("f-forigin", i[r].fOrigin),
                                                                    d.setAttribute("f-origin", i[r].origin),
                                                                    (d.type = "text/css"),
                                                                    (d.rel = "stylesheet"),
                                                                    (d.href = i[r].fPath),
                                                                    document.body.appendChild(d);
                                                            }
                                                        } else if ("t" === i[r].fOrigin || 2 === i[r].origin) {
                                                            for (
                                                                l = document.querySelectorAll(
                                                                    'script[f-forigin="t"], script[f-origin="2"]'
                                                                ),
                                                                    h = 0;
                                                                h < l.length;
                                                                h += 1
                                                            )
                                                                i[r].fPath === l[h].src && (p = !1);
                                                            if (p) {
                                                                var u = createTag("link");
                                                                u.setAttribute("f-forigin", i[r].fOrigin),
                                                                    u.setAttribute("f-origin", i[r].origin),
                                                                    u.setAttribute("rel", "stylesheet"),
                                                                    u.setAttribute("href", i[r].fPath),
                                                                    e.appendChild(u);
                                                            }
                                                        }
                                                    } else (i[r].loaded = !0), (o -= 1);
                                                    (i[r].helper = s(i[r], e)),
                                                        (i[r].cache = {}),
                                                        this.fonts.push(i[r]);
                                                }
                                                0 === o
                                                    ? (this.isLoaded = !0)
                                                    : setTimeout(this.checkLoadedFonts.bind(this), 100);
                                            } else this.isLoaded = !0;
                                        },
                                        getCharData: function (e, r, i) {
                                            for (var n = 0, s = this.chars.length; n < s; ) {
                                                if (
                                                    this.chars[n].ch === e &&
                                                    this.chars[n].style === r &&
                                                    this.chars[n].fFamily === i
                                                )
                                                    return this.chars[n];
                                                n += 1;
                                            }
                                            return (
                                                (("string" == typeof e && 13 !== e.charCodeAt(0)) || !e) &&
                                                    console &&
                                                    console.warn &&
                                                    !this._warned &&
                                                    ((this._warned = !0),
                                                    console.warn(
                                                        "Missing character from exported characters list: ",
                                                        e,
                                                        r,
                                                        i
                                                    )),
                                                t
                                            );
                                        },
                                        getFontByName: function (t) {
                                            for (var e = 0, r = this.fonts.length; e < r; ) {
                                                if (this.fonts[e].fName === t) return this.fonts[e];
                                                e += 1;
                                            }
                                            return this.fonts[0];
                                        },
                                        measureText: function (t, e, r) {
                                            var i = this.getFontByName(e),
                                                n = t.charCodeAt(0);
                                            if (!i.cache[n + 1]) {
                                                var s = i.helper;
                                                if (" " === t) {
                                                    var a = s.measureText("|" + t + "|"),
                                                        o = s.measureText("||");
                                                    i.cache[n + 1] = (a - o) / 100;
                                                } else i.cache[n + 1] = s.measureText(t) / 100;
                                            }
                                            return i.cache[n + 1] * r;
                                        },
                                        checkLoadedFonts: function () {
                                            var t,
                                                e,
                                                r,
                                                i = this.fonts.length,
                                                n = i;
                                            for (t = 0; t < i; t += 1)
                                                this.fonts[t].loaded
                                                    ? (n -= 1)
                                                    : "n" === this.fonts[t].fOrigin || 0 === this.fonts[t].origin
                                                      ? (this.fonts[t].loaded = !0)
                                                      : ((e = this.fonts[t].monoCase.node),
                                                        (r = this.fonts[t].monoCase.w),
                                                        e.offsetWidth !== r
                                                            ? ((n -= 1), (this.fonts[t].loaded = !0))
                                                            : ((e = this.fonts[t].sansCase.node),
                                                              (r = this.fonts[t].sansCase.w),
                                                              e.offsetWidth !== r &&
                                                                  ((n -= 1), (this.fonts[t].loaded = !0))),
                                                        this.fonts[t].loaded &&
                                                            (this.fonts[t].sansCase.parent.parentNode.removeChild(
                                                                this.fonts[t].sansCase.parent
                                                            ),
                                                            this.fonts[t].monoCase.parent.parentNode.removeChild(
                                                                this.fonts[t].monoCase.parent
                                                            )));
                                            0 !== n && Date.now() - this.initTime < 5e3
                                                ? setTimeout(this.checkLoadedFontsBinded, 20)
                                                : setTimeout(this.setIsLoadedBinded, 10);
                                        },
                                        setIsLoaded: function () {
                                            this.isLoaded = !0;
                                        },
                                    }),
                                    a
                                );
                            })();
                            function RenderableElement() {}
                            RenderableElement.prototype = {
                                initRenderable: function () {
                                    (this.isInRange = !1),
                                        (this.hidden = !1),
                                        (this.isTransparent = !1),
                                        (this.renderableComponents = []);
                                },
                                addRenderableComponent: function (t) {
                                    -1 === this.renderableComponents.indexOf(t) && this.renderableComponents.push(t);
                                },
                                removeRenderableComponent: function (t) {
                                    -1 !== this.renderableComponents.indexOf(t) &&
                                        this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
                                },
                                prepareRenderableFrame: function (t) {
                                    this.checkLayerLimits(t);
                                },
                                checkTransparency: function () {
                                    this.finalTransform.mProp.o.v <= 0
                                        ? !this.isTransparent &&
                                          this.globalData.renderConfig.hideOnTransparent &&
                                          ((this.isTransparent = !0), this.hide())
                                        : this.isTransparent && ((this.isTransparent = !1), this.show());
                                },
                                checkLayerLimits: function (t) {
                                    this.data.ip - this.data.st <= t && this.data.op - this.data.st > t
                                        ? !0 !== this.isInRange &&
                                          ((this.globalData._mdf = !0),
                                          (this._mdf = !0),
                                          (this.isInRange = !0),
                                          this.show())
                                        : !1 !== this.isInRange &&
                                          ((this.globalData._mdf = !0), (this.isInRange = !1), this.hide());
                                },
                                renderRenderable: function () {
                                    var t,
                                        e = this.renderableComponents.length;
                                    for (t = 0; t < e; t += 1)
                                        this.renderableComponents[t].renderFrame(this._isFirstFrame);
                                },
                                sourceRectAtTime: function () {
                                    return { top: 0, left: 0, width: 100, height: 100 };
                                },
                                getLayerSize: function () {
                                    return 5 === this.data.ty
                                        ? { w: this.data.textData.width, h: this.data.textData.height }
                                        : { w: this.data.width, h: this.data.height };
                                },
                            };
                            var getBlendMode =
                                    ((blendModeEnums = {
                                        0: "source-over",
                                        1: "multiply",
                                        2: "screen",
                                        3: "overlay",
                                        4: "darken",
                                        5: "lighten",
                                        6: "color-dodge",
                                        7: "color-burn",
                                        8: "hard-light",
                                        9: "soft-light",
                                        10: "difference",
                                        11: "exclusion",
                                        12: "hue",
                                        13: "saturation",
                                        14: "color",
                                        15: "luminosity",
                                    }),
                                    function (t) {
                                        return blendModeEnums[t] || "";
                                    }),
                                blendModeEnums;
                            function SliderEffect(t, e, r) {
                                this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
                            }
                            function AngleEffect(t, e, r) {
                                this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
                            }
                            function ColorEffect(t, e, r) {
                                this.p = PropertyFactory.getProp(e, t.v, 1, 0, r);
                            }
                            function PointEffect(t, e, r) {
                                this.p = PropertyFactory.getProp(e, t.v, 1, 0, r);
                            }
                            function LayerIndexEffect(t, e, r) {
                                this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
                            }
                            function MaskIndexEffect(t, e, r) {
                                this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
                            }
                            function CheckboxEffect(t, e, r) {
                                this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
                            }
                            function NoValueEffect() {
                                this.p = {};
                            }
                            function EffectsManager(t, e) {
                                var r,
                                    i = t.ef || [];
                                this.effectElements = [];
                                var n,
                                    s = i.length;
                                for (r = 0; r < s; r += 1) (n = new GroupEffect(i[r], e)), this.effectElements.push(n);
                            }
                            function GroupEffect(t, e) {
                                this.init(t, e);
                            }
                            function BaseElement() {}
                            function FrameElement() {}
                            function FootageElement(t, e, r) {
                                this.initFrame(),
                                    this.initRenderable(),
                                    (this.assetData = e.getAssetData(t.refId)),
                                    (this.footageData = e.imageLoader.getAsset(this.assetData)),
                                    this.initBaseData(t, e, r);
                            }
                            function AudioElement(t, e, r) {
                                this.initFrame(),
                                    this.initRenderable(),
                                    (this.assetData = e.getAssetData(t.refId)),
                                    this.initBaseData(t, e, r),
                                    (this._isPlaying = !1),
                                    (this._canPlay = !1);
                                var i = this.globalData.getAssetsPath(this.assetData);
                                (this.audio = this.globalData.audioController.createAudio(i)),
                                    (this._currentTime = 0),
                                    this.globalData.audioController.addAudio(this),
                                    (this._volumeMultiplier = 1),
                                    (this._volume = 1),
                                    (this._previousVolume = null),
                                    (this.tm = t.tm
                                        ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this)
                                        : { _placeholder: !0 }),
                                    (this.lv = PropertyFactory.getProp(
                                        this,
                                        t.au && t.au.lv ? t.au.lv : { k: [100] },
                                        1,
                                        0.01,
                                        this
                                    ));
                            }
                            function BaseRenderer() {}
                            function TransformElement() {}
                            function MaskElement(t, e, r) {
                                (this.data = t),
                                    (this.element = e),
                                    (this.globalData = r),
                                    (this.storedData = []),
                                    (this.masksProperties = this.data.masksProperties || []),
                                    (this.maskElement = null);
                                var i,
                                    n,
                                    s = this.globalData.defs,
                                    a = this.masksProperties ? this.masksProperties.length : 0;
                                (this.viewData = createSizedArray(a)), (this.solidPath = "");
                                var o,
                                    l,
                                    h,
                                    p,
                                    c,
                                    d,
                                    u = this.masksProperties,
                                    f = 0,
                                    m = [],
                                    g = createElementID(),
                                    y = "clipPath",
                                    v = "clip-path";
                                for (i = 0; i < a; i += 1)
                                    if (
                                        ((("a" !== u[i].mode && "n" !== u[i].mode) ||
                                            u[i].inv ||
                                            100 !== u[i].o.k ||
                                            u[i].o.x) &&
                                            ((y = "mask"), (v = "mask")),
                                        ("s" !== u[i].mode && "i" !== u[i].mode) || 0 !== f
                                            ? (h = null)
                                            : ((h = createNS("rect")).setAttribute("fill", "#ffffff"),
                                              h.setAttribute("width", this.element.comp.data.w || 0),
                                              h.setAttribute("height", this.element.comp.data.h || 0),
                                              m.push(h)),
                                        (n = createNS("path")),
                                        "n" === u[i].mode)
                                    )
                                        (this.viewData[i] = {
                                            op: PropertyFactory.getProp(this.element, u[i].o, 0, 0.01, this.element),
                                            prop: ShapePropertyFactory.getShapeProp(this.element, u[i], 3),
                                            elem: n,
                                            lastPath: "",
                                        }),
                                            s.appendChild(n);
                                    else {
                                        var b;
                                        if (
                                            ((f += 1),
                                            n.setAttribute("fill", "s" === u[i].mode ? "#000000" : "#ffffff"),
                                            n.setAttribute("clip-rule", "nonzero"),
                                            0 !== u[i].x.k
                                                ? ((y = "mask"),
                                                  (v = "mask"),
                                                  (d = PropertyFactory.getProp(
                                                      this.element,
                                                      u[i].x,
                                                      0,
                                                      null,
                                                      this.element
                                                  )),
                                                  (b = createElementID()),
                                                  (p = createNS("filter")).setAttribute("id", b),
                                                  (c = createNS("feMorphology")).setAttribute("operator", "erode"),
                                                  c.setAttribute("in", "SourceGraphic"),
                                                  c.setAttribute("radius", "0"),
                                                  p.appendChild(c),
                                                  s.appendChild(p),
                                                  n.setAttribute("stroke", "s" === u[i].mode ? "#000000" : "#ffffff"))
                                                : ((c = null), (d = null)),
                                            (this.storedData[i] = {
                                                elem: n,
                                                x: d,
                                                expan: c,
                                                lastPath: "",
                                                lastOperator: "",
                                                filterId: b,
                                                lastRadius: 0,
                                            }),
                                            "i" === u[i].mode)
                                        ) {
                                            l = m.length;
                                            var _ = createNS("g");
                                            for (o = 0; o < l; o += 1) _.appendChild(m[o]);
                                            var x = createNS("mask");
                                            x.setAttribute("mask-type", "alpha"),
                                                x.setAttribute("id", g + "_" + f),
                                                x.appendChild(n),
                                                s.appendChild(x),
                                                _.setAttribute(
                                                    "mask",
                                                    "url(" + getLocationHref() + "#" + g + "_" + f + ")"
                                                ),
                                                (m.length = 0),
                                                m.push(_);
                                        } else m.push(n);
                                        u[i].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()),
                                            (this.viewData[i] = {
                                                elem: n,
                                                lastPath: "",
                                                op: PropertyFactory.getProp(
                                                    this.element,
                                                    u[i].o,
                                                    0,
                                                    0.01,
                                                    this.element
                                                ),
                                                prop: ShapePropertyFactory.getShapeProp(this.element, u[i], 3),
                                                invRect: h,
                                            }),
                                            this.viewData[i].prop.k ||
                                                this.drawPath(u[i], this.viewData[i].prop.v, this.viewData[i]);
                                    }
                                for (this.maskElement = createNS(y), a = m.length, i = 0; i < a; i += 1)
                                    this.maskElement.appendChild(m[i]);
                                f > 0 &&
                                    (this.maskElement.setAttribute("id", g),
                                    this.element.maskedElement.setAttribute(
                                        v,
                                        "url(" + getLocationHref() + "#" + g + ")"
                                    ),
                                    s.appendChild(this.maskElement)),
                                    this.viewData.length && this.element.addRenderableComponent(this);
                            }
                            extendPrototype([DynamicPropertyContainer], GroupEffect),
                                (GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties),
                                (GroupEffect.prototype.init = function (t, e) {
                                    var r;
                                    (this.data = t), (this.effectElements = []), this.initDynamicPropertyContainer(e);
                                    var i,
                                        n = this.data.ef.length,
                                        s = this.data.ef;
                                    for (r = 0; r < n; r += 1) {
                                        switch (((i = null), s[r].ty)) {
                                            case 0:
                                                i = new SliderEffect(s[r], e, this);
                                                break;
                                            case 1:
                                                i = new AngleEffect(s[r], e, this);
                                                break;
                                            case 2:
                                                i = new ColorEffect(s[r], e, this);
                                                break;
                                            case 3:
                                                i = new PointEffect(s[r], e, this);
                                                break;
                                            case 4:
                                            case 7:
                                                i = new CheckboxEffect(s[r], e, this);
                                                break;
                                            case 10:
                                                i = new LayerIndexEffect(s[r], e, this);
                                                break;
                                            case 11:
                                                i = new MaskIndexEffect(s[r], e, this);
                                                break;
                                            case 5:
                                                i = new EffectsManager(s[r], e, this);
                                                break;
                                            default:
                                                i = new NoValueEffect(s[r], e, this);
                                        }
                                        i && this.effectElements.push(i);
                                    }
                                }),
                                (BaseElement.prototype = {
                                    checkMasks: function () {
                                        if (!this.data.hasMask) return !1;
                                        for (var t = 0, e = this.data.masksProperties.length; t < e; ) {
                                            if (
                                                "n" !== this.data.masksProperties[t].mode &&
                                                !1 !== this.data.masksProperties[t].cl
                                            )
                                                return !0;
                                            t += 1;
                                        }
                                        return !1;
                                    },
                                    initExpressions: function () {
                                        var t = getExpressionInterfaces();
                                        if (t) {
                                            var e = t("layer"),
                                                r = t("effects"),
                                                i = t("shape"),
                                                n = t("text"),
                                                s = t("comp");
                                            (this.layerInterface = e(this)),
                                                this.data.hasMask &&
                                                    this.maskManager &&
                                                    this.layerInterface.registerMaskInterface(this.maskManager);
                                            var a = r.createEffectsInterface(this, this.layerInterface);
                                            this.layerInterface.registerEffectsInterface(a),
                                                0 === this.data.ty || this.data.xt
                                                    ? (this.compInterface = s(this))
                                                    : 4 === this.data.ty
                                                      ? ((this.layerInterface.shapeInterface = i(
                                                            this.shapesData,
                                                            this.itemsData,
                                                            this.layerInterface
                                                        )),
                                                        (this.layerInterface.content =
                                                            this.layerInterface.shapeInterface))
                                                      : 5 === this.data.ty &&
                                                        ((this.layerInterface.textInterface = n(this)),
                                                        (this.layerInterface.text = this.layerInterface.textInterface));
                                        }
                                    },
                                    setBlendMode: function () {
                                        var t = getBlendMode(this.data.bm);
                                        (this.baseElement || this.layerElement).style["mix-blend-mode"] = t;
                                    },
                                    initBaseData: function (t, e, r) {
                                        (this.globalData = e),
                                            (this.comp = r),
                                            (this.data = t),
                                            (this.layerId = createElementID()),
                                            this.data.sr || (this.data.sr = 1),
                                            (this.effectsManager = new EffectsManager(
                                                this.data,
                                                this,
                                                this.dynamicProperties
                                            ));
                                    },
                                    getType: function () {
                                        return this.type;
                                    },
                                    sourceRectAtTime: function () {},
                                }),
                                (FrameElement.prototype = {
                                    initFrame: function () {
                                        (this._isFirstFrame = !1), (this.dynamicProperties = []), (this._mdf = !1);
                                    },
                                    prepareProperties: function (t, e) {
                                        var r,
                                            i = this.dynamicProperties.length;
                                        for (r = 0; r < i; r += 1)
                                            (e ||
                                                (this._isParent &&
                                                    "transform" === this.dynamicProperties[r].propType)) &&
                                                (this.dynamicProperties[r].getValue(),
                                                this.dynamicProperties[r]._mdf &&
                                                    ((this.globalData._mdf = !0), (this._mdf = !0)));
                                    },
                                    addDynamicProperty: function (t) {
                                        -1 === this.dynamicProperties.indexOf(t) && this.dynamicProperties.push(t);
                                    },
                                }),
                                (FootageElement.prototype.prepareFrame = function () {}),
                                extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement),
                                (FootageElement.prototype.getBaseElement = function () {
                                    return null;
                                }),
                                (FootageElement.prototype.renderFrame = function () {}),
                                (FootageElement.prototype.destroy = function () {}),
                                (FootageElement.prototype.initExpressions = function () {
                                    var t = getExpressionInterfaces();
                                    if (t) {
                                        var e = t("footage");
                                        this.layerInterface = e(this);
                                    }
                                }),
                                (FootageElement.prototype.getFootageData = function () {
                                    return this.footageData;
                                }),
                                (AudioElement.prototype.prepareFrame = function (t) {
                                    if (
                                        (this.prepareRenderableFrame(t, !0),
                                        this.prepareProperties(t, !0),
                                        this.tm._placeholder)
                                    )
                                        this._currentTime = t / this.data.sr;
                                    else {
                                        var e = this.tm.v;
                                        this._currentTime = e;
                                    }
                                    this._volume = this.lv.v[0];
                                    var r = this._volume * this._volumeMultiplier;
                                    this._previousVolume !== r && ((this._previousVolume = r), this.audio.volume(r));
                                }),
                                extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement),
                                (AudioElement.prototype.renderFrame = function () {
                                    this.isInRange &&
                                        this._canPlay &&
                                        (this._isPlaying
                                            ? (!this.audio.playing() ||
                                                  Math.abs(
                                                      this._currentTime / this.globalData.frameRate - this.audio.seek()
                                                  ) > 0.1) &&
                                              this.audio.seek(this._currentTime / this.globalData.frameRate)
                                            : (this.audio.play(),
                                              this.audio.seek(this._currentTime / this.globalData.frameRate),
                                              (this._isPlaying = !0)));
                                }),
                                (AudioElement.prototype.show = function () {}),
                                (AudioElement.prototype.hide = function () {
                                    this.audio.pause(), (this._isPlaying = !1);
                                }),
                                (AudioElement.prototype.pause = function () {
                                    this.audio.pause(), (this._isPlaying = !1), (this._canPlay = !1);
                                }),
                                (AudioElement.prototype.resume = function () {
                                    this._canPlay = !0;
                                }),
                                (AudioElement.prototype.setRate = function (t) {
                                    this.audio.rate(t);
                                }),
                                (AudioElement.prototype.volume = function (t) {
                                    (this._volumeMultiplier = t),
                                        (this._previousVolume = t * this._volume),
                                        this.audio.volume(this._previousVolume);
                                }),
                                (AudioElement.prototype.getBaseElement = function () {
                                    return null;
                                }),
                                (AudioElement.prototype.destroy = function () {}),
                                (AudioElement.prototype.sourceRectAtTime = function () {}),
                                (AudioElement.prototype.initExpressions = function () {}),
                                (BaseRenderer.prototype.checkLayers = function (t) {
                                    var e,
                                        r,
                                        i = this.layers.length;
                                    for (this.completeLayers = !0, e = i - 1; e >= 0; e -= 1)
                                        this.elements[e] ||
                                            ((r = this.layers[e]).ip - r.st <= t - this.layers[e].st &&
                                                r.op - r.st > t - this.layers[e].st &&
                                                this.buildItem(e)),
                                            (this.completeLayers = !!this.elements[e] && this.completeLayers);
                                    this.checkPendingElements();
                                }),
                                (BaseRenderer.prototype.createItem = function (t) {
                                    switch (t.ty) {
                                        case 2:
                                            return this.createImage(t);
                                        case 0:
                                            return this.createComp(t);
                                        case 1:
                                            return this.createSolid(t);
                                        case 3:
                                        default:
                                            return this.createNull(t);
                                        case 4:
                                            return this.createShape(t);
                                        case 5:
                                            return this.createText(t);
                                        case 6:
                                            return this.createAudio(t);
                                        case 13:
                                            return this.createCamera(t);
                                        case 15:
                                            return this.createFootage(t);
                                    }
                                }),
                                (BaseRenderer.prototype.createCamera = function () {
                                    throw new Error("You're using a 3d camera. Try the html renderer.");
                                }),
                                (BaseRenderer.prototype.createAudio = function (t) {
                                    return new AudioElement(t, this.globalData, this);
                                }),
                                (BaseRenderer.prototype.createFootage = function (t) {
                                    return new FootageElement(t, this.globalData, this);
                                }),
                                (BaseRenderer.prototype.buildAllItems = function () {
                                    var t,
                                        e = this.layers.length;
                                    for (t = 0; t < e; t += 1) this.buildItem(t);
                                    this.checkPendingElements();
                                }),
                                (BaseRenderer.prototype.includeLayers = function (t) {
                                    var e;
                                    this.completeLayers = !1;
                                    var r,
                                        i = t.length,
                                        n = this.layers.length;
                                    for (e = 0; e < i; e += 1)
                                        for (r = 0; r < n; ) {
                                            if (this.layers[r].id === t[e].id) {
                                                this.layers[r] = t[e];
                                                break;
                                            }
                                            r += 1;
                                        }
                                }),
                                (BaseRenderer.prototype.setProjectInterface = function (t) {
                                    this.globalData.projectInterface = t;
                                }),
                                (BaseRenderer.prototype.initItems = function () {
                                    this.globalData.progressiveLoad || this.buildAllItems();
                                }),
                                (BaseRenderer.prototype.buildElementParenting = function (t, e, r) {
                                    for (var i = this.elements, n = this.layers, s = 0, a = n.length; s < a; )
                                        n[s].ind == e &&
                                            (i[s] && !0 !== i[s]
                                                ? (r.push(i[s]),
                                                  i[s].setAsParent(),
                                                  void 0 !== n[s].parent
                                                      ? this.buildElementParenting(t, n[s].parent, r)
                                                      : t.setHierarchy(r))
                                                : (this.buildItem(s), this.addPendingElement(t))),
                                            (s += 1);
                                }),
                                (BaseRenderer.prototype.addPendingElement = function (t) {
                                    this.pendingElements.push(t);
                                }),
                                (BaseRenderer.prototype.searchExtraCompositions = function (t) {
                                    var e,
                                        r = t.length;
                                    for (e = 0; e < r; e += 1)
                                        if (t[e].xt) {
                                            var i = this.createComp(t[e]);
                                            i.initExpressions(),
                                                this.globalData.projectInterface.registerComposition(i);
                                        }
                                }),
                                (BaseRenderer.prototype.getElementByPath = function (t) {
                                    var e,
                                        r = t.shift();
                                    if ("number" == typeof r) e = this.elements[r];
                                    else {
                                        var i,
                                            n = this.elements.length;
                                        for (i = 0; i < n; i += 1)
                                            if (this.elements[i].data.nm === r) {
                                                e = this.elements[i];
                                                break;
                                            }
                                    }
                                    return 0 === t.length ? e : e.getElementByPath(t);
                                }),
                                (BaseRenderer.prototype.setupGlobalData = function (t, e) {
                                    (this.globalData.fontManager = new FontManager()),
                                        this.globalData.fontManager.addChars(t.chars),
                                        this.globalData.fontManager.addFonts(t.fonts, e),
                                        (this.globalData.getAssetData = this.animationItem.getAssetData.bind(
                                            this.animationItem
                                        )),
                                        (this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(
                                            this.animationItem
                                        )),
                                        (this.globalData.imageLoader = this.animationItem.imagePreloader),
                                        (this.globalData.audioController = this.animationItem.audioController),
                                        (this.globalData.frameId = 0),
                                        (this.globalData.frameRate = t.fr),
                                        (this.globalData.nm = t.nm),
                                        (this.globalData.compSize = { w: t.w, h: t.h });
                                }),
                                (TransformElement.prototype = {
                                    initTransform: function () {
                                        (this.finalTransform = {
                                            mProp: this.data.ks
                                                ? TransformPropertyFactory.getTransformProperty(
                                                      this,
                                                      this.data.ks,
                                                      this
                                                  )
                                                : { o: 0 },
                                            _matMdf: !1,
                                            _opMdf: !1,
                                            mat: new Matrix(),
                                        }),
                                            this.data.ao && (this.finalTransform.mProp.autoOriented = !0),
                                            this.data.ty;
                                    },
                                    renderTransform: function () {
                                        if (
                                            ((this.finalTransform._opMdf =
                                                this.finalTransform.mProp.o._mdf || this._isFirstFrame),
                                            (this.finalTransform._matMdf =
                                                this.finalTransform.mProp._mdf || this._isFirstFrame),
                                            this.hierarchy)
                                        ) {
                                            var t,
                                                e = this.finalTransform.mat,
                                                r = 0,
                                                i = this.hierarchy.length;
                                            if (!this.finalTransform._matMdf)
                                                for (; r < i; ) {
                                                    if (this.hierarchy[r].finalTransform.mProp._mdf) {
                                                        this.finalTransform._matMdf = !0;
                                                        break;
                                                    }
                                                    r += 1;
                                                }
                                            if (this.finalTransform._matMdf)
                                                for (
                                                    t = this.finalTransform.mProp.v.props, e.cloneFromProps(t), r = 0;
                                                    r < i;
                                                    r += 1
                                                )
                                                    (t = this.hierarchy[r].finalTransform.mProp.v.props),
                                                        e.transform(
                                                            t[0],
                                                            t[1],
                                                            t[2],
                                                            t[3],
                                                            t[4],
                                                            t[5],
                                                            t[6],
                                                            t[7],
                                                            t[8],
                                                            t[9],
                                                            t[10],
                                                            t[11],
                                                            t[12],
                                                            t[13],
                                                            t[14],
                                                            t[15]
                                                        );
                                        }
                                    },
                                    globalToLocal: function (t) {
                                        var e = [];
                                        e.push(this.finalTransform);
                                        for (var r, i = !0, n = this.comp; i; )
                                            n.finalTransform
                                                ? (n.data.hasMask && e.splice(0, 0, n.finalTransform), (n = n.comp))
                                                : (i = !1);
                                        var s,
                                            a = e.length;
                                        for (r = 0; r < a; r += 1)
                                            (s = e[r].mat.applyToPointArray(0, 0, 0)),
                                                (t = [t[0] - s[0], t[1] - s[1], 0]);
                                        return t;
                                    },
                                    mHelper: new Matrix(),
                                }),
                                (MaskElement.prototype.getMaskProperty = function (t) {
                                    return this.viewData[t].prop;
                                }),
                                (MaskElement.prototype.renderFrame = function (t) {
                                    var e,
                                        r = this.element.finalTransform.mat,
                                        i = this.masksProperties.length;
                                    for (e = 0; e < i; e += 1)
                                        if (
                                            ((this.viewData[e].prop._mdf || t) &&
                                                this.drawPath(
                                                    this.masksProperties[e],
                                                    this.viewData[e].prop.v,
                                                    this.viewData[e]
                                                ),
                                            (this.viewData[e].op._mdf || t) &&
                                                this.viewData[e].elem.setAttribute(
                                                    "fill-opacity",
                                                    this.viewData[e].op.v
                                                ),
                                            "n" !== this.masksProperties[e].mode &&
                                                (this.viewData[e].invRect &&
                                                    (this.element.finalTransform.mProp._mdf || t) &&
                                                    this.viewData[e].invRect.setAttribute(
                                                        "transform",
                                                        r.getInverseMatrix().to2dCSS()
                                                    ),
                                                this.storedData[e].x && (this.storedData[e].x._mdf || t)))
                                        ) {
                                            var n = this.storedData[e].expan;
                                            this.storedData[e].x.v < 0
                                                ? ("erode" !== this.storedData[e].lastOperator &&
                                                      ((this.storedData[e].lastOperator = "erode"),
                                                      this.storedData[e].elem.setAttribute(
                                                          "filter",
                                                          "url(" +
                                                              getLocationHref() +
                                                              "#" +
                                                              this.storedData[e].filterId +
                                                              ")"
                                                      )),
                                                  n.setAttribute("radius", -this.storedData[e].x.v))
                                                : ("dilate" !== this.storedData[e].lastOperator &&
                                                      ((this.storedData[e].lastOperator = "dilate"),
                                                      this.storedData[e].elem.setAttribute("filter", null)),
                                                  this.storedData[e].elem.setAttribute(
                                                      "stroke-width",
                                                      2 * this.storedData[e].x.v
                                                  ));
                                        }
                                }),
                                (MaskElement.prototype.getMaskelement = function () {
                                    return this.maskElement;
                                }),
                                (MaskElement.prototype.createLayerSolidPath = function () {
                                    var t = "M0,0 ";
                                    return (
                                        (t += " h" + this.globalData.compSize.w),
                                        (t += " v" + this.globalData.compSize.h),
                                        (t += " h-" + this.globalData.compSize.w) +
                                            " v-" +
                                            this.globalData.compSize.h +
                                            " "
                                    );
                                }),
                                (MaskElement.prototype.drawPath = function (t, e, r) {
                                    var i,
                                        n,
                                        s = " M" + e.v[0][0] + "," + e.v[0][1];
                                    for (n = e._length, i = 1; i < n; i += 1)
                                        s +=
                                            " C" +
                                            e.o[i - 1][0] +
                                            "," +
                                            e.o[i - 1][1] +
                                            " " +
                                            e.i[i][0] +
                                            "," +
                                            e.i[i][1] +
                                            " " +
                                            e.v[i][0] +
                                            "," +
                                            e.v[i][1];
                                    if (
                                        (e.c &&
                                            n > 1 &&
                                            (s +=
                                                " C" +
                                                e.o[i - 1][0] +
                                                "," +
                                                e.o[i - 1][1] +
                                                " " +
                                                e.i[0][0] +
                                                "," +
                                                e.i[0][1] +
                                                " " +
                                                e.v[0][0] +
                                                "," +
                                                e.v[0][1]),
                                        r.lastPath !== s)
                                    ) {
                                        var a = "";
                                        r.elem &&
                                            (e.c && (a = t.inv ? this.solidPath + s : s), r.elem.setAttribute("d", a)),
                                            (r.lastPath = s);
                                    }
                                }),
                                (MaskElement.prototype.destroy = function () {
                                    (this.element = null),
                                        (this.globalData = null),
                                        (this.maskElement = null),
                                        (this.data = null),
                                        (this.masksProperties = null);
                                });
                            var filtersFactory = {
                                    createFilter: function (t, e) {
                                        var r = createNS("filter");
                                        return (
                                            r.setAttribute("id", t),
                                            !0 !== e &&
                                                (r.setAttribute("filterUnits", "objectBoundingBox"),
                                                r.setAttribute("x", "0%"),
                                                r.setAttribute("y", "0%"),
                                                r.setAttribute("width", "100%"),
                                                r.setAttribute("height", "100%")),
                                            r
                                        );
                                    },
                                    createAlphaToLuminanceFilter: function () {
                                        var t = createNS("feColorMatrix");
                                        return (
                                            t.setAttribute("type", "matrix"),
                                            t.setAttribute("color-interpolation-filters", "sRGB"),
                                            t.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"),
                                            t
                                        );
                                    },
                                },
                                featureSupport = (function () {
                                    var t = { maskType: !0 };
                                    return (
                                        (/MSIE 10/i.test(navigator.userAgent) ||
                                            /MSIE 9/i.test(navigator.userAgent) ||
                                            /rv:11.0/i.test(navigator.userAgent) ||
                                            /Edge\/\d./i.test(navigator.userAgent)) &&
                                            (t.maskType = !1),
                                        t
                                    );
                                })(),
                                registeredEffects = {},
                                idPrefix = "filter_result_";
                            function SVGEffects(t) {
                                var e,
                                    r,
                                    i = "SourceGraphic",
                                    n = t.data.ef ? t.data.ef.length : 0,
                                    s = createElementID(),
                                    a = filtersFactory.createFilter(s, !0),
                                    o = 0;
                                for (this.filters = [], e = 0; e < n; e += 1) {
                                    r = null;
                                    var l = t.data.ef[e].ty;
                                    registeredEffects[l] &&
                                        ((r = new (0, registeredEffects[l].effect)(
                                            a,
                                            t.effectsManager.effectElements[e],
                                            t,
                                            idPrefix + o,
                                            i
                                        )),
                                        (i = idPrefix + o),
                                        registeredEffects[l].countsAsEffect && (o += 1)),
                                        r && this.filters.push(r);
                                }
                                o &&
                                    (t.globalData.defs.appendChild(a),
                                    t.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + s + ")")),
                                    this.filters.length && t.addRenderableComponent(this);
                            }
                            function registerEffect(t, e, r) {
                                registeredEffects[t] = { effect: e, countsAsEffect: r };
                            }
                            function SVGBaseElement() {}
                            function HierarchyElement() {}
                            function RenderableDOMElement() {}
                            function IImageElement(t, e, r) {
                                (this.assetData = e.getAssetData(t.refId)),
                                    this.initElement(t, e, r),
                                    (this.sourceRect = {
                                        top: 0,
                                        left: 0,
                                        width: this.assetData.w,
                                        height: this.assetData.h,
                                    });
                            }
                            function ProcessedElement(t, e) {
                                (this.elem = t), (this.pos = e);
                            }
                            function IShapeElement() {}
                            (SVGEffects.prototype.renderFrame = function (t) {
                                var e,
                                    r = this.filters.length;
                                for (e = 0; e < r; e += 1) this.filters[e].renderFrame(t);
                            }),
                                (SVGBaseElement.prototype = {
                                    initRendererElement: function () {
                                        this.layerElement = createNS("g");
                                    },
                                    createContainerElements: function () {
                                        (this.matteElement = createNS("g")),
                                            (this.transformedElement = this.layerElement),
                                            (this.maskedElement = this.layerElement),
                                            (this._sizeChanged = !1);
                                        var t = null;
                                        if (this.data.td) {
                                            this.matteMasks = {};
                                            var e = createNS("g");
                                            e.setAttribute("id", this.layerId),
                                                e.appendChild(this.layerElement),
                                                (t = e),
                                                this.globalData.defs.appendChild(e);
                                        } else
                                            this.data.tt
                                                ? (this.matteElement.appendChild(this.layerElement),
                                                  (t = this.matteElement),
                                                  (this.baseElement = this.matteElement))
                                                : (this.baseElement = this.layerElement);
                                        if (
                                            (this.data.ln && this.layerElement.setAttribute("id", this.data.ln),
                                            this.data.cl && this.layerElement.setAttribute("class", this.data.cl),
                                            0 === this.data.ty && !this.data.hd)
                                        ) {
                                            var r = createNS("clipPath"),
                                                i = createNS("path");
                                            i.setAttribute(
                                                "d",
                                                "M0,0 L" +
                                                    this.data.w +
                                                    ",0 L" +
                                                    this.data.w +
                                                    "," +
                                                    this.data.h +
                                                    " L0," +
                                                    this.data.h +
                                                    "z"
                                            );
                                            var n = createElementID();
                                            if (
                                                (r.setAttribute("id", n),
                                                r.appendChild(i),
                                                this.globalData.defs.appendChild(r),
                                                this.checkMasks())
                                            ) {
                                                var s = createNS("g");
                                                s.setAttribute("clip-path", "url(" + getLocationHref() + "#" + n + ")"),
                                                    s.appendChild(this.layerElement),
                                                    (this.transformedElement = s),
                                                    t
                                                        ? t.appendChild(this.transformedElement)
                                                        : (this.baseElement = this.transformedElement);
                                            } else
                                                this.layerElement.setAttribute(
                                                    "clip-path",
                                                    "url(" + getLocationHref() + "#" + n + ")"
                                                );
                                        }
                                        0 !== this.data.bm && this.setBlendMode();
                                    },
                                    renderElement: function () {
                                        this.finalTransform._matMdf &&
                                            this.transformedElement.setAttribute(
                                                "transform",
                                                this.finalTransform.mat.to2dCSS()
                                            ),
                                            this.finalTransform._opMdf &&
                                                this.transformedElement.setAttribute(
                                                    "opacity",
                                                    this.finalTransform.mProp.o.v
                                                );
                                    },
                                    destroyBaseElement: function () {
                                        (this.layerElement = null),
                                            (this.matteElement = null),
                                            this.maskManager.destroy();
                                    },
                                    getBaseElement: function () {
                                        return this.data.hd ? null : this.baseElement;
                                    },
                                    createRenderableComponents: function () {
                                        (this.maskManager = new MaskElement(this.data, this, this.globalData)),
                                            (this.renderableEffectsManager = new SVGEffects(this));
                                    },
                                    getMatte: function (t) {
                                        if (!this.matteMasks[t]) {
                                            var e,
                                                r,
                                                i,
                                                n,
                                                s = this.layerId + "_" + t;
                                            if (1 === t || 3 === t) {
                                                var a = createNS("mask");
                                                a.setAttribute("id", s),
                                                    a.setAttribute("mask-type", 3 === t ? "luminance" : "alpha"),
                                                    (i = createNS("use")).setAttributeNS(
                                                        "http://www.w3.org/1999/xlink",
                                                        "href",
                                                        "#" + this.layerId
                                                    ),
                                                    a.appendChild(i),
                                                    this.globalData.defs.appendChild(a),
                                                    featureSupport.maskType ||
                                                        1 !== t ||
                                                        (a.setAttribute("mask-type", "luminance"),
                                                        (e = createElementID()),
                                                        (r = filtersFactory.createFilter(e)),
                                                        this.globalData.defs.appendChild(r),
                                                        r.appendChild(filtersFactory.createAlphaToLuminanceFilter()),
                                                        (n = createNS("g")).appendChild(i),
                                                        a.appendChild(n),
                                                        n.setAttribute(
                                                            "filter",
                                                            "url(" + getLocationHref() + "#" + e + ")"
                                                        ));
                                            } else if (2 === t) {
                                                var o = createNS("mask");
                                                o.setAttribute("id", s), o.setAttribute("mask-type", "alpha");
                                                var l = createNS("g");
                                                o.appendChild(l),
                                                    (e = createElementID()),
                                                    (r = filtersFactory.createFilter(e));
                                                var h = createNS("feComponentTransfer");
                                                h.setAttribute("in", "SourceGraphic"), r.appendChild(h);
                                                var p = createNS("feFuncA");
                                                p.setAttribute("type", "table"),
                                                    p.setAttribute("tableValues", "1.0 0.0"),
                                                    h.appendChild(p),
                                                    this.globalData.defs.appendChild(r);
                                                var c = createNS("rect");
                                                c.setAttribute("width", this.comp.data.w),
                                                    c.setAttribute("height", this.comp.data.h),
                                                    c.setAttribute("x", "0"),
                                                    c.setAttribute("y", "0"),
                                                    c.setAttribute("fill", "#ffffff"),
                                                    c.setAttribute("opacity", "0"),
                                                    l.setAttribute(
                                                        "filter",
                                                        "url(" + getLocationHref() + "#" + e + ")"
                                                    ),
                                                    l.appendChild(c),
                                                    (i = createNS("use")).setAttributeNS(
                                                        "http://www.w3.org/1999/xlink",
                                                        "href",
                                                        "#" + this.layerId
                                                    ),
                                                    l.appendChild(i),
                                                    featureSupport.maskType ||
                                                        (o.setAttribute("mask-type", "luminance"),
                                                        r.appendChild(filtersFactory.createAlphaToLuminanceFilter()),
                                                        (n = createNS("g")),
                                                        l.appendChild(c),
                                                        n.appendChild(this.layerElement),
                                                        l.appendChild(n)),
                                                    this.globalData.defs.appendChild(o);
                                            }
                                            this.matteMasks[t] = s;
                                        }
                                        return this.matteMasks[t];
                                    },
                                    setMatte: function (t) {
                                        this.matteElement &&
                                            this.matteElement.setAttribute(
                                                "mask",
                                                "url(" + getLocationHref() + "#" + t + ")"
                                            );
                                    },
                                }),
                                (HierarchyElement.prototype = {
                                    initHierarchy: function () {
                                        (this.hierarchy = []), (this._isParent = !1), this.checkParenting();
                                    },
                                    setHierarchy: function (t) {
                                        this.hierarchy = t;
                                    },
                                    setAsParent: function () {
                                        this._isParent = !0;
                                    },
                                    checkParenting: function () {
                                        void 0 !== this.data.parent &&
                                            this.comp.buildElementParenting(this, this.data.parent, []);
                                    },
                                }),
                                extendPrototype(
                                    [
                                        RenderableElement,
                                        createProxyFunction({
                                            initElement: function (t, e, r) {
                                                this.initFrame(),
                                                    this.initBaseData(t, e, r),
                                                    this.initTransform(t, e, r),
                                                    this.initHierarchy(),
                                                    this.initRenderable(),
                                                    this.initRendererElement(),
                                                    this.createContainerElements(),
                                                    this.createRenderableComponents(),
                                                    this.createContent(),
                                                    this.hide();
                                            },
                                            hide: function () {
                                                this.hidden ||
                                                    (this.isInRange && !this.isTransparent) ||
                                                    (((this.baseElement || this.layerElement).style.display = "none"),
                                                    (this.hidden = !0));
                                            },
                                            show: function () {
                                                this.isInRange &&
                                                    !this.isTransparent &&
                                                    (this.data.hd ||
                                                        ((this.baseElement || this.layerElement).style.display =
                                                            "block"),
                                                    (this.hidden = !1),
                                                    (this._isFirstFrame = !0));
                                            },
                                            renderFrame: function () {
                                                this.data.hd ||
                                                    this.hidden ||
                                                    (this.renderTransform(),
                                                    this.renderRenderable(),
                                                    this.renderElement(),
                                                    this.renderInnerContent(),
                                                    this._isFirstFrame && (this._isFirstFrame = !1));
                                            },
                                            renderInnerContent: function () {},
                                            prepareFrame: function (t) {
                                                (this._mdf = !1),
                                                    this.prepareRenderableFrame(t),
                                                    this.prepareProperties(t, this.isInRange),
                                                    this.checkTransparency();
                                            },
                                            destroy: function () {
                                                (this.innerElem = null), this.destroyBaseElement();
                                            },
                                        }),
                                    ],
                                    RenderableDOMElement
                                ),
                                extendPrototype(
                                    [
                                        BaseElement,
                                        TransformElement,
                                        SVGBaseElement,
                                        HierarchyElement,
                                        FrameElement,
                                        RenderableDOMElement,
                                    ],
                                    IImageElement
                                ),
                                (IImageElement.prototype.createContent = function () {
                                    var t = this.globalData.getAssetsPath(this.assetData);
                                    (this.innerElem = createNS("image")),
                                        this.innerElem.setAttribute("width", this.assetData.w + "px"),
                                        this.innerElem.setAttribute("height", this.assetData.h + "px"),
                                        this.innerElem.setAttribute(
                                            "preserveAspectRatio",
                                            this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio
                                        ),
                                        this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t),
                                        this.layerElement.appendChild(this.innerElem);
                                }),
                                (IImageElement.prototype.sourceRectAtTime = function () {
                                    return this.sourceRect;
                                }),
                                (IShapeElement.prototype = {
                                    addShapeToModifiers: function (t) {
                                        var e,
                                            r = this.shapeModifiers.length;
                                        for (e = 0; e < r; e += 1) this.shapeModifiers[e].addShape(t);
                                    },
                                    isShapeInAnimatedModifiers: function (t) {
                                        for (var e = this.shapeModifiers.length; 0 < e; )
                                            if (this.shapeModifiers[0].isAnimatedWithShape(t)) return !0;
                                        return !1;
                                    },
                                    renderModifiers: function () {
                                        if (this.shapeModifiers.length) {
                                            var t,
                                                e = this.shapes.length;
                                            for (t = 0; t < e; t += 1) this.shapes[t].sh.reset();
                                            for (
                                                t = (e = this.shapeModifiers.length) - 1;
                                                t >= 0 && !this.shapeModifiers[t].processShapes(this._isFirstFrame);
                                                t -= 1
                                            );
                                        }
                                    },
                                    searchProcessedElement: function (t) {
                                        for (var e = this.processedElements, r = 0, i = e.length; r < i; ) {
                                            if (e[r].elem === t) return e[r].pos;
                                            r += 1;
                                        }
                                        return 0;
                                    },
                                    addProcessedElement: function (t, e) {
                                        for (var r = this.processedElements, i = r.length; i; )
                                            if (r[(i -= 1)].elem === t) return void (r[i].pos = e);
                                        r.push(new ProcessedElement(t, e));
                                    },
                                    prepareFrame: function (t) {
                                        this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
                                    },
                                });
                            var lineCapEnum = { 1: "butt", 2: "round", 3: "square" },
                                lineJoinEnum = { 1: "miter", 2: "round", 3: "bevel" };
                            function SVGShapeData(t, e, r) {
                                (this.caches = []),
                                    (this.styles = []),
                                    (this.transformers = t),
                                    (this.lStr = ""),
                                    (this.sh = r),
                                    (this.lvl = e),
                                    (this._isAnimated = !!r.k);
                                for (var i = 0, n = t.length; i < n; ) {
                                    if (t[i].mProps.dynamicProperties.length) {
                                        this._isAnimated = !0;
                                        break;
                                    }
                                    i += 1;
                                }
                            }
                            function SVGStyleData(t, e) {
                                (this.data = t),
                                    (this.type = t.ty),
                                    (this.d = ""),
                                    (this.lvl = e),
                                    (this._mdf = !1),
                                    (this.closed = !0 === t.hd),
                                    (this.pElem = createNS("path")),
                                    (this.msElem = null);
                            }
                            function DashProperty(t, e, r, i) {
                                var n;
                                (this.elem = t),
                                    (this.frameId = -1),
                                    (this.dataProps = createSizedArray(e.length)),
                                    (this.renderer = r),
                                    (this.k = !1),
                                    (this.dashStr = ""),
                                    (this.dashArray = createTypedArray("float32", e.length ? e.length - 1 : 0)),
                                    (this.dashoffset = createTypedArray("float32", 1)),
                                    this.initDynamicPropertyContainer(i);
                                var s,
                                    a = e.length || 0;
                                for (n = 0; n < a; n += 1)
                                    (s = PropertyFactory.getProp(t, e[n].v, 0, 0, this)),
                                        (this.k = s.k || this.k),
                                        (this.dataProps[n] = { n: e[n].n, p: s });
                                this.k || this.getValue(!0), (this._isAnimated = this.k);
                            }
                            function SVGStrokeStyleData(t, e, r) {
                                this.initDynamicPropertyContainer(t),
                                    (this.getValue = this.iterateDynamicProperties),
                                    (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, this)),
                                    (this.w = PropertyFactory.getProp(t, e.w, 0, null, this)),
                                    (this.d = new DashProperty(t, e.d || {}, "svg", this)),
                                    (this.c = PropertyFactory.getProp(t, e.c, 1, 255, this)),
                                    (this.style = r),
                                    (this._isAnimated = !!this._isAnimated);
                            }
                            function SVGFillStyleData(t, e, r) {
                                this.initDynamicPropertyContainer(t),
                                    (this.getValue = this.iterateDynamicProperties),
                                    (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, this)),
                                    (this.c = PropertyFactory.getProp(t, e.c, 1, 255, this)),
                                    (this.style = r);
                            }
                            function SVGNoStyleData(t, e, r) {
                                this.initDynamicPropertyContainer(t),
                                    (this.getValue = this.iterateDynamicProperties),
                                    (this.style = r);
                            }
                            function GradientProperty(t, e, r) {
                                (this.data = e), (this.c = createTypedArray("uint8c", 4 * e.p));
                                var i = e.k.k[0].s ? e.k.k[0].s.length - 4 * e.p : e.k.k.length - 4 * e.p;
                                (this.o = createTypedArray("float32", i)),
                                    (this._cmdf = !1),
                                    (this._omdf = !1),
                                    (this._collapsable = this.checkCollapsable()),
                                    (this._hasOpacity = i),
                                    this.initDynamicPropertyContainer(r),
                                    (this.prop = PropertyFactory.getProp(t, e.k, 1, null, this)),
                                    (this.k = this.prop.k),
                                    this.getValue(!0);
                            }
                            function SVGGradientFillStyleData(t, e, r) {
                                this.initDynamicPropertyContainer(t),
                                    (this.getValue = this.iterateDynamicProperties),
                                    this.initGradientData(t, e, r);
                            }
                            function SVGGradientStrokeStyleData(t, e, r) {
                                this.initDynamicPropertyContainer(t),
                                    (this.getValue = this.iterateDynamicProperties),
                                    (this.w = PropertyFactory.getProp(t, e.w, 0, null, this)),
                                    (this.d = new DashProperty(t, e.d || {}, "svg", this)),
                                    this.initGradientData(t, e, r),
                                    (this._isAnimated = !!this._isAnimated);
                            }
                            function ShapeGroupData() {
                                (this.it = []), (this.prevViewData = []), (this.gr = createNS("g"));
                            }
                            function SVGTransformData(t, e, r) {
                                (this.transform = { mProps: t, op: e, container: r }),
                                    (this.elements = []),
                                    (this._isAnimated =
                                        this.transform.mProps.dynamicProperties.length ||
                                        this.transform.op.effectsSequence.length);
                            }
                            (SVGShapeData.prototype.setAsAnimated = function () {
                                this._isAnimated = !0;
                            }),
                                (SVGStyleData.prototype.reset = function () {
                                    (this.d = ""), (this._mdf = !1);
                                }),
                                (DashProperty.prototype.getValue = function (t) {
                                    if (
                                        (this.elem.globalData.frameId !== this.frameId || t) &&
                                        ((this.frameId = this.elem.globalData.frameId),
                                        this.iterateDynamicProperties(),
                                        (this._mdf = this._mdf || t),
                                        this._mdf)
                                    ) {
                                        var e = 0,
                                            r = this.dataProps.length;
                                        for ("svg" === this.renderer && (this.dashStr = ""), e = 0; e < r; e += 1)
                                            "o" !== this.dataProps[e].n
                                                ? "svg" === this.renderer
                                                    ? (this.dashStr += " " + this.dataProps[e].p.v)
                                                    : (this.dashArray[e] = this.dataProps[e].p.v)
                                                : (this.dashoffset[0] = this.dataProps[e].p.v);
                                    }
                                }),
                                extendPrototype([DynamicPropertyContainer], DashProperty),
                                extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData),
                                extendPrototype([DynamicPropertyContainer], SVGFillStyleData),
                                extendPrototype([DynamicPropertyContainer], SVGNoStyleData),
                                (GradientProperty.prototype.comparePoints = function (t, e) {
                                    for (var r = 0, i = this.o.length / 2; r < i; ) {
                                        if (Math.abs(t[4 * r] - t[4 * e + 2 * r]) > 0.01) return !1;
                                        r += 1;
                                    }
                                    return !0;
                                }),
                                (GradientProperty.prototype.checkCollapsable = function () {
                                    if (this.o.length / 2 != this.c.length / 4) return !1;
                                    if (this.data.k.k[0].s)
                                        for (var t = 0, e = this.data.k.k.length; t < e; ) {
                                            if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
                                            t += 1;
                                        }
                                    else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
                                    return !0;
                                }),
                                (GradientProperty.prototype.getValue = function (t) {
                                    if (
                                        (this.prop.getValue(),
                                        (this._mdf = !1),
                                        (this._cmdf = !1),
                                        (this._omdf = !1),
                                        this.prop._mdf || t)
                                    ) {
                                        var e,
                                            r,
                                            i,
                                            n = 4 * this.data.p;
                                        for (e = 0; e < n; e += 1)
                                            (r = e % 4 == 0 ? 100 : 255),
                                                (i = Math.round(this.prop.v[e] * r)),
                                                this.c[e] !== i && ((this.c[e] = i), (this._cmdf = !t));
                                        if (this.o.length)
                                            for (n = this.prop.v.length, e = 4 * this.data.p; e < n; e += 1)
                                                (r = e % 2 == 0 ? 100 : 1),
                                                    (i =
                                                        e % 2 == 0 ? Math.round(100 * this.prop.v[e]) : this.prop.v[e]),
                                                    this.o[e - 4 * this.data.p] !== i &&
                                                        ((this.o[e - 4 * this.data.p] = i), (this._omdf = !t));
                                        this._mdf = !t;
                                    }
                                }),
                                extendPrototype([DynamicPropertyContainer], GradientProperty),
                                (SVGGradientFillStyleData.prototype.initGradientData = function (t, e, r) {
                                    (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, this)),
                                        (this.s = PropertyFactory.getProp(t, e.s, 1, null, this)),
                                        (this.e = PropertyFactory.getProp(t, e.e, 1, null, this)),
                                        (this.h = PropertyFactory.getProp(t, e.h || { k: 0 }, 0, 0.01, this)),
                                        (this.a = PropertyFactory.getProp(t, e.a || { k: 0 }, 0, degToRads, this)),
                                        (this.g = new GradientProperty(t, e.g, this)),
                                        (this.style = r),
                                        (this.stops = []),
                                        this.setGradientData(r.pElem, e),
                                        this.setGradientOpacity(e, r),
                                        (this._isAnimated = !!this._isAnimated);
                                }),
                                (SVGGradientFillStyleData.prototype.setGradientData = function (t, e) {
                                    var r = createElementID(),
                                        i = createNS(1 === e.t ? "linearGradient" : "radialGradient");
                                    i.setAttribute("id", r),
                                        i.setAttribute("spreadMethod", "pad"),
                                        i.setAttribute("gradientUnits", "userSpaceOnUse");
                                    var n,
                                        s,
                                        a,
                                        o = [];
                                    for (a = 4 * e.g.p, s = 0; s < a; s += 4)
                                        (n = createNS("stop")), i.appendChild(n), o.push(n);
                                    t.setAttribute(
                                        "gf" === e.ty ? "fill" : "stroke",
                                        "url(" + getLocationHref() + "#" + r + ")"
                                    ),
                                        (this.gf = i),
                                        (this.cst = o);
                                }),
                                (SVGGradientFillStyleData.prototype.setGradientOpacity = function (t, e) {
                                    if (this.g._hasOpacity && !this.g._collapsable) {
                                        var r,
                                            i,
                                            n,
                                            s = createNS("mask"),
                                            a = createNS("path");
                                        s.appendChild(a);
                                        var o = createElementID(),
                                            l = createElementID();
                                        s.setAttribute("id", l);
                                        var h = createNS(1 === t.t ? "linearGradient" : "radialGradient");
                                        h.setAttribute("id", o),
                                            h.setAttribute("spreadMethod", "pad"),
                                            h.setAttribute("gradientUnits", "userSpaceOnUse"),
                                            (n = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length);
                                        var p = this.stops;
                                        for (i = 4 * t.g.p; i < n; i += 2)
                                            (r = createNS("stop")).setAttribute("stop-color", "rgb(255,255,255)"),
                                                h.appendChild(r),
                                                p.push(r);
                                        a.setAttribute(
                                            "gf" === t.ty ? "fill" : "stroke",
                                            "url(" + getLocationHref() + "#" + o + ")"
                                        ),
                                            "gs" === t.ty &&
                                                (a.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]),
                                                a.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]),
                                                1 === t.lj && a.setAttribute("stroke-miterlimit", t.ml)),
                                            (this.of = h),
                                            (this.ms = s),
                                            (this.ost = p),
                                            (this.maskId = l),
                                            (e.msElem = a);
                                    }
                                }),
                                extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData),
                                extendPrototype(
                                    [SVGGradientFillStyleData, DynamicPropertyContainer],
                                    SVGGradientStrokeStyleData
                                );
                            var buildShapeString = function (t, e, r, i) {
                                    if (0 === e) return "";
                                    var n,
                                        s = t.o,
                                        a = t.i,
                                        o = t.v,
                                        l = " M" + i.applyToPointStringified(o[0][0], o[0][1]);
                                    for (n = 1; n < e; n += 1)
                                        l +=
                                            " C" +
                                            i.applyToPointStringified(s[n - 1][0], s[n - 1][1]) +
                                            " " +
                                            i.applyToPointStringified(a[n][0], a[n][1]) +
                                            " " +
                                            i.applyToPointStringified(o[n][0], o[n][1]);
                                    return (
                                        r &&
                                            e &&
                                            ((l +=
                                                " C" +
                                                i.applyToPointStringified(s[n - 1][0], s[n - 1][1]) +
                                                " " +
                                                i.applyToPointStringified(a[0][0], a[0][1]) +
                                                " " +
                                                i.applyToPointStringified(o[0][0], o[0][1])),
                                            (l += "z")),
                                        l
                                    );
                                },
                                SVGElementsRenderer = (function () {
                                    var t = new Matrix(),
                                        e = new Matrix();
                                    function r(t, e, r) {
                                        (r || e.transform.op._mdf) &&
                                            e.transform.container.setAttribute("opacity", e.transform.op.v),
                                            (r || e.transform.mProps._mdf) &&
                                                e.transform.container.setAttribute(
                                                    "transform",
                                                    e.transform.mProps.v.to2dCSS()
                                                );
                                    }
                                    function i() {}
                                    function n(r, i, n) {
                                        var s,
                                            a,
                                            o,
                                            l,
                                            h,
                                            p,
                                            c,
                                            d,
                                            u,
                                            f,
                                            m,
                                            g = i.styles.length,
                                            y = i.lvl;
                                        for (p = 0; p < g; p += 1) {
                                            if (((l = i.sh._mdf || n), i.styles[p].lvl < y)) {
                                                for (
                                                    d = e.reset(),
                                                        f = y - i.styles[p].lvl,
                                                        m = i.transformers.length - 1;
                                                    !l && f > 0;

                                                )
                                                    (l = i.transformers[m].mProps._mdf || l), (f -= 1), (m -= 1);
                                                if (l)
                                                    for (
                                                        f = y - i.styles[p].lvl, m = i.transformers.length - 1;
                                                        f > 0;

                                                    )
                                                        (u = i.transformers[m].mProps.v.props),
                                                            d.transform(
                                                                u[0],
                                                                u[1],
                                                                u[2],
                                                                u[3],
                                                                u[4],
                                                                u[5],
                                                                u[6],
                                                                u[7],
                                                                u[8],
                                                                u[9],
                                                                u[10],
                                                                u[11],
                                                                u[12],
                                                                u[13],
                                                                u[14],
                                                                u[15]
                                                            ),
                                                            (f -= 1),
                                                            (m -= 1);
                                            } else d = t;
                                            if (((a = (c = i.sh.paths)._length), l)) {
                                                for (o = "", s = 0; s < a; s += 1)
                                                    (h = c.shapes[s]) &&
                                                        h._length &&
                                                        (o += buildShapeString(h, h._length, h.c, d));
                                                i.caches[p] = o;
                                            } else o = i.caches[p];
                                            (i.styles[p].d += !0 === r.hd ? "" : o),
                                                (i.styles[p]._mdf = l || i.styles[p]._mdf);
                                        }
                                    }
                                    function s(t, e, r) {
                                        var i = e.style;
                                        (e.c._mdf || r) &&
                                            i.pElem.setAttribute(
                                                "fill",
                                                "rgb(" +
                                                    bmFloor(e.c.v[0]) +
                                                    "," +
                                                    bmFloor(e.c.v[1]) +
                                                    "," +
                                                    bmFloor(e.c.v[2]) +
                                                    ")"
                                            ),
                                            (e.o._mdf || r) && i.pElem.setAttribute("fill-opacity", e.o.v);
                                    }
                                    function a(t, e, r) {
                                        o(t, e, r), l(0, e, r);
                                    }
                                    function o(t, e, r) {
                                        var i,
                                            n,
                                            s,
                                            a,
                                            o,
                                            l = e.gf,
                                            h = e.g._hasOpacity,
                                            p = e.s.v,
                                            c = e.e.v;
                                        if (e.o._mdf || r) {
                                            var d = "gf" === t.ty ? "fill-opacity" : "stroke-opacity";
                                            e.style.pElem.setAttribute(d, e.o.v);
                                        }
                                        if (e.s._mdf || r) {
                                            var u = 1 === t.t ? "x1" : "cx",
                                                f = "x1" === u ? "y1" : "cy";
                                            l.setAttribute(u, p[0]),
                                                l.setAttribute(f, p[1]),
                                                h &&
                                                    !e.g._collapsable &&
                                                    (e.of.setAttribute(u, p[0]), e.of.setAttribute(f, p[1]));
                                        }
                                        if (e.g._cmdf || r) {
                                            i = e.cst;
                                            var m = e.g.c;
                                            for (s = i.length, n = 0; n < s; n += 1)
                                                (a = i[n]).setAttribute("offset", m[4 * n] + "%"),
                                                    a.setAttribute(
                                                        "stop-color",
                                                        "rgb(" +
                                                            m[4 * n + 1] +
                                                            "," +
                                                            m[4 * n + 2] +
                                                            "," +
                                                            m[4 * n + 3] +
                                                            ")"
                                                    );
                                        }
                                        if (h && (e.g._omdf || r)) {
                                            var g = e.g.o;
                                            for (
                                                s = (i = e.g._collapsable ? e.cst : e.ost).length, n = 0;
                                                n < s;
                                                n += 1
                                            )
                                                (a = i[n]),
                                                    e.g._collapsable || a.setAttribute("offset", g[2 * n] + "%"),
                                                    a.setAttribute("stop-opacity", g[2 * n + 1]);
                                        }
                                        if (1 === t.t)
                                            (e.e._mdf || r) &&
                                                (l.setAttribute("x2", c[0]),
                                                l.setAttribute("y2", c[1]),
                                                h &&
                                                    !e.g._collapsable &&
                                                    (e.of.setAttribute("x2", c[0]), e.of.setAttribute("y2", c[1])));
                                        else if (
                                            ((e.s._mdf || e.e._mdf || r) &&
                                                ((o = Math.sqrt(Math.pow(p[0] - c[0], 2) + Math.pow(p[1] - c[1], 2))),
                                                l.setAttribute("r", o),
                                                h && !e.g._collapsable && e.of.setAttribute("r", o)),
                                            e.e._mdf || e.h._mdf || e.a._mdf || r)
                                        ) {
                                            o || (o = Math.sqrt(Math.pow(p[0] - c[0], 2) + Math.pow(p[1] - c[1], 2)));
                                            var y = Math.atan2(c[1] - p[1], c[0] - p[0]),
                                                v = e.h.v;
                                            v >= 1 ? (v = 0.99) : v <= -1 && (v = -0.99);
                                            var b = o * v,
                                                _ = Math.cos(y + e.a.v) * b + p[0],
                                                x = Math.sin(y + e.a.v) * b + p[1];
                                            l.setAttribute("fx", _),
                                                l.setAttribute("fy", x),
                                                h &&
                                                    !e.g._collapsable &&
                                                    (e.of.setAttribute("fx", _), e.of.setAttribute("fy", x));
                                        }
                                    }
                                    function l(t, e, r) {
                                        var i = e.style,
                                            n = e.d;
                                        n &&
                                            (n._mdf || r) &&
                                            n.dashStr &&
                                            (i.pElem.setAttribute("stroke-dasharray", n.dashStr),
                                            i.pElem.setAttribute("stroke-dashoffset", n.dashoffset[0])),
                                            e.c &&
                                                (e.c._mdf || r) &&
                                                i.pElem.setAttribute(
                                                    "stroke",
                                                    "rgb(" +
                                                        bmFloor(e.c.v[0]) +
                                                        "," +
                                                        bmFloor(e.c.v[1]) +
                                                        "," +
                                                        bmFloor(e.c.v[2]) +
                                                        ")"
                                                ),
                                            (e.o._mdf || r) && i.pElem.setAttribute("stroke-opacity", e.o.v),
                                            (e.w._mdf || r) &&
                                                (i.pElem.setAttribute("stroke-width", e.w.v),
                                                i.msElem && i.msElem.setAttribute("stroke-width", e.w.v));
                                    }
                                    return {
                                        createRenderFunction: function (t) {
                                            switch (t.ty) {
                                                case "fl":
                                                    return s;
                                                case "gf":
                                                    return o;
                                                case "gs":
                                                    return a;
                                                case "st":
                                                    return l;
                                                case "sh":
                                                case "el":
                                                case "rc":
                                                case "sr":
                                                    return n;
                                                case "tr":
                                                    return r;
                                                case "no":
                                                    return i;
                                                default:
                                                    return null;
                                            }
                                        },
                                    };
                                })();
                            function SVGShapeElement(t, e, r) {
                                (this.shapes = []),
                                    (this.shapesData = t.shapes),
                                    (this.stylesList = []),
                                    (this.shapeModifiers = []),
                                    (this.itemsData = []),
                                    (this.processedElements = []),
                                    (this.animatedContents = []),
                                    this.initElement(t, e, r),
                                    (this.prevViewData = []);
                            }
                            function LetterProps(t, e, r, i, n, s) {
                                (this.o = t),
                                    (this.sw = e),
                                    (this.sc = r),
                                    (this.fc = i),
                                    (this.m = n),
                                    (this.p = s),
                                    (this._mdf = { o: !0, sw: !!e, sc: !!r, fc: !!i, m: !0, p: !0 });
                            }
                            function TextProperty(t, e) {
                                (this._frameId = initialDefaultFrame),
                                    (this.pv = ""),
                                    (this.v = ""),
                                    (this.kf = !1),
                                    (this._isFirstFrame = !0),
                                    (this._mdf = !1),
                                    (this.data = e),
                                    (this.elem = t),
                                    (this.comp = this.elem.comp),
                                    (this.keysIndex = 0),
                                    (this.canResize = !1),
                                    (this.minimumFontSize = 1),
                                    (this.effectsSequence = []),
                                    (this.currentData = {
                                        ascent: 0,
                                        boxWidth: this.defaultBoxWidth,
                                        f: "",
                                        fStyle: "",
                                        fWeight: "",
                                        fc: "",
                                        j: "",
                                        justifyOffset: "",
                                        l: [],
                                        lh: 0,
                                        lineWidths: [],
                                        ls: "",
                                        of: "",
                                        s: "",
                                        sc: "",
                                        sw: 0,
                                        t: 0,
                                        tr: 0,
                                        sz: 0,
                                        ps: null,
                                        fillColorAnim: !1,
                                        strokeColorAnim: !1,
                                        strokeWidthAnim: !1,
                                        yOffset: 0,
                                        finalSize: 0,
                                        finalText: [],
                                        finalLineHeight: 0,
                                        __complete: !1,
                                    }),
                                    this.copyData(this.currentData, this.data.d.k[0].s),
                                    this.searchProperty() || this.completeTextData(this.currentData);
                            }
                            extendPrototype(
                                [
                                    BaseElement,
                                    TransformElement,
                                    SVGBaseElement,
                                    IShapeElement,
                                    HierarchyElement,
                                    FrameElement,
                                    RenderableDOMElement,
                                ],
                                SVGShapeElement
                            ),
                                (SVGShapeElement.prototype.initSecondaryElement = function () {}),
                                (SVGShapeElement.prototype.identityMatrix = new Matrix()),
                                (SVGShapeElement.prototype.buildExpressionInterface = function () {}),
                                (SVGShapeElement.prototype.createContent = function () {
                                    this.searchShapes(
                                        this.shapesData,
                                        this.itemsData,
                                        this.prevViewData,
                                        this.layerElement,
                                        0,
                                        [],
                                        !0
                                    ),
                                        this.filterUniqueShapes();
                                }),
                                (SVGShapeElement.prototype.filterUniqueShapes = function () {
                                    var t,
                                        e,
                                        r,
                                        i,
                                        n = this.shapes.length,
                                        s = this.stylesList.length,
                                        a = [],
                                        o = !1;
                                    for (r = 0; r < s; r += 1) {
                                        for (i = this.stylesList[r], o = !1, a.length = 0, t = 0; t < n; t += 1)
                                            -1 !== (e = this.shapes[t]).styles.indexOf(i) &&
                                                (a.push(e), (o = e._isAnimated || o));
                                        a.length > 1 && o && this.setShapesAsAnimated(a);
                                    }
                                }),
                                (SVGShapeElement.prototype.setShapesAsAnimated = function (t) {
                                    var e,
                                        r = t.length;
                                    for (e = 0; e < r; e += 1) t[e].setAsAnimated();
                                }),
                                (SVGShapeElement.prototype.createStyleElement = function (t, e) {
                                    var r,
                                        i = new SVGStyleData(t, e),
                                        n = i.pElem;
                                    return (
                                        "st" === t.ty
                                            ? (r = new SVGStrokeStyleData(this, t, i))
                                            : "fl" === t.ty
                                              ? (r = new SVGFillStyleData(this, t, i))
                                              : "gf" === t.ty || "gs" === t.ty
                                                ? ((r = new (
                                                      "gf" === t.ty
                                                          ? SVGGradientFillStyleData
                                                          : SVGGradientStrokeStyleData
                                                  )(this, t, i)),
                                                  this.globalData.defs.appendChild(r.gf),
                                                  r.maskId &&
                                                      (this.globalData.defs.appendChild(r.ms),
                                                      this.globalData.defs.appendChild(r.of),
                                                      n.setAttribute(
                                                          "mask",
                                                          "url(" + getLocationHref() + "#" + r.maskId + ")"
                                                      )))
                                                : "no" === t.ty && (r = new SVGNoStyleData(this, t, i)),
                                        ("st" !== t.ty && "gs" !== t.ty) ||
                                            (n.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]),
                                            n.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]),
                                            n.setAttribute("fill-opacity", "0"),
                                            1 === t.lj && n.setAttribute("stroke-miterlimit", t.ml)),
                                        2 === t.r && n.setAttribute("fill-rule", "evenodd"),
                                        t.ln && n.setAttribute("id", t.ln),
                                        t.cl && n.setAttribute("class", t.cl),
                                        t.bm && (n.style["mix-blend-mode"] = getBlendMode(t.bm)),
                                        this.stylesList.push(i),
                                        this.addToAnimatedContents(t, r),
                                        r
                                    );
                                }),
                                (SVGShapeElement.prototype.createGroupElement = function (t) {
                                    var e = new ShapeGroupData();
                                    return (
                                        t.ln && e.gr.setAttribute("id", t.ln),
                                        t.cl && e.gr.setAttribute("class", t.cl),
                                        t.bm && (e.gr.style["mix-blend-mode"] = getBlendMode(t.bm)),
                                        e
                                    );
                                }),
                                (SVGShapeElement.prototype.createTransformElement = function (t, e) {
                                    var r = TransformPropertyFactory.getTransformProperty(this, t, this),
                                        i = new SVGTransformData(r, r.o, e);
                                    return this.addToAnimatedContents(t, i), i;
                                }),
                                (SVGShapeElement.prototype.createShapeElement = function (t, e, r) {
                                    var i = 4;
                                    "rc" === t.ty ? (i = 5) : "el" === t.ty ? (i = 6) : "sr" === t.ty && (i = 7);
                                    var n = new SVGShapeData(e, r, ShapePropertyFactory.getShapeProp(this, t, i, this));
                                    return (
                                        this.shapes.push(n),
                                        this.addShapeToModifiers(n),
                                        this.addToAnimatedContents(t, n),
                                        n
                                    );
                                }),
                                (SVGShapeElement.prototype.addToAnimatedContents = function (t, e) {
                                    for (var r = 0, i = this.animatedContents.length; r < i; ) {
                                        if (this.animatedContents[r].element === e) return;
                                        r += 1;
                                    }
                                    this.animatedContents.push({
                                        fn: SVGElementsRenderer.createRenderFunction(t),
                                        element: e,
                                        data: t,
                                    });
                                }),
                                (SVGShapeElement.prototype.setElementStyles = function (t) {
                                    var e,
                                        r = t.styles,
                                        i = this.stylesList.length;
                                    for (e = 0; e < i; e += 1) this.stylesList[e].closed || r.push(this.stylesList[e]);
                                }),
                                (SVGShapeElement.prototype.reloadShapes = function () {
                                    var t;
                                    this._isFirstFrame = !0;
                                    var e = this.itemsData.length;
                                    for (t = 0; t < e; t += 1) this.prevViewData[t] = this.itemsData[t];
                                    for (
                                        this.searchShapes(
                                            this.shapesData,
                                            this.itemsData,
                                            this.prevViewData,
                                            this.layerElement,
                                            0,
                                            [],
                                            !0
                                        ),
                                            this.filterUniqueShapes(),
                                            e = this.dynamicProperties.length,
                                            t = 0;
                                        t < e;
                                        t += 1
                                    )
                                        this.dynamicProperties[t].getValue();
                                    this.renderModifiers();
                                }),
                                (SVGShapeElement.prototype.searchShapes = function (t, e, r, i, n, s, a) {
                                    var o,
                                        l,
                                        h,
                                        p,
                                        c,
                                        d,
                                        u = [].concat(s),
                                        f = t.length - 1,
                                        m = [],
                                        g = [];
                                    for (o = f; o >= 0; o -= 1) {
                                        if (
                                            ((d = this.searchProcessedElement(t[o]))
                                                ? (e[o] = r[d - 1])
                                                : (t[o]._render = a),
                                            "fl" === t[o].ty ||
                                                "st" === t[o].ty ||
                                                "gf" === t[o].ty ||
                                                "gs" === t[o].ty ||
                                                "no" === t[o].ty)
                                        )
                                            d ? (e[o].style.closed = !1) : (e[o] = this.createStyleElement(t[o], n)),
                                                t[o]._render &&
                                                    e[o].style.pElem.parentNode !== i &&
                                                    i.appendChild(e[o].style.pElem),
                                                m.push(e[o].style);
                                        else if ("gr" === t[o].ty) {
                                            if (d)
                                                for (h = e[o].it.length, l = 0; l < h; l += 1)
                                                    e[o].prevViewData[l] = e[o].it[l];
                                            else e[o] = this.createGroupElement(t[o]);
                                            this.searchShapes(
                                                t[o].it,
                                                e[o].it,
                                                e[o].prevViewData,
                                                e[o].gr,
                                                n + 1,
                                                u,
                                                a
                                            ),
                                                t[o]._render && e[o].gr.parentNode !== i && i.appendChild(e[o].gr);
                                        } else
                                            "tr" === t[o].ty
                                                ? (d || (e[o] = this.createTransformElement(t[o], i)),
                                                  (p = e[o].transform),
                                                  u.push(p))
                                                : "sh" === t[o].ty ||
                                                    "rc" === t[o].ty ||
                                                    "el" === t[o].ty ||
                                                    "sr" === t[o].ty
                                                  ? (d || (e[o] = this.createShapeElement(t[o], u, n)),
                                                    this.setElementStyles(e[o]))
                                                  : "tm" === t[o].ty ||
                                                      "rd" === t[o].ty ||
                                                      "ms" === t[o].ty ||
                                                      "pb" === t[o].ty ||
                                                      "zz" === t[o].ty ||
                                                      "op" === t[o].ty
                                                    ? (d
                                                          ? ((c = e[o]).closed = !1)
                                                          : ((c = ShapeModifiers.getModifier(t[o].ty)).init(this, t[o]),
                                                            (e[o] = c),
                                                            this.shapeModifiers.push(c)),
                                                      g.push(c))
                                                    : "rp" === t[o].ty &&
                                                      (d
                                                          ? ((c = e[o]).closed = !0)
                                                          : ((c = ShapeModifiers.getModifier(t[o].ty)),
                                                            (e[o] = c),
                                                            c.init(this, t, o, e),
                                                            this.shapeModifiers.push(c),
                                                            (a = !1)),
                                                      g.push(c));
                                        this.addProcessedElement(t[o], o + 1);
                                    }
                                    for (f = m.length, o = 0; o < f; o += 1) m[o].closed = !0;
                                    for (f = g.length, o = 0; o < f; o += 1) g[o].closed = !0;
                                }),
                                (SVGShapeElement.prototype.renderInnerContent = function () {
                                    var t;
                                    this.renderModifiers();
                                    var e = this.stylesList.length;
                                    for (t = 0; t < e; t += 1) this.stylesList[t].reset();
                                    for (this.renderShape(), t = 0; t < e; t += 1)
                                        (this.stylesList[t]._mdf || this._isFirstFrame) &&
                                            (this.stylesList[t].msElem &&
                                                (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d),
                                                (this.stylesList[t].d = "M0 0" + this.stylesList[t].d)),
                                            this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"));
                                }),
                                (SVGShapeElement.prototype.renderShape = function () {
                                    var t,
                                        e,
                                        r = this.animatedContents.length;
                                    for (t = 0; t < r; t += 1)
                                        (e = this.animatedContents[t]),
                                            (this._isFirstFrame || e.element._isAnimated) &&
                                                !0 !== e.data &&
                                                e.fn(e.data, e.element, this._isFirstFrame);
                                }),
                                (SVGShapeElement.prototype.destroy = function () {
                                    this.destroyBaseElement(), (this.shapesData = null), (this.itemsData = null);
                                }),
                                (LetterProps.prototype.update = function (t, e, r, i, n, s) {
                                    (this._mdf.o = !1),
                                        (this._mdf.sw = !1),
                                        (this._mdf.sc = !1),
                                        (this._mdf.fc = !1),
                                        (this._mdf.m = !1),
                                        (this._mdf.p = !1);
                                    var a = !1;
                                    return (
                                        this.o !== t && ((this.o = t), (this._mdf.o = !0), (a = !0)),
                                        this.sw !== e && ((this.sw = e), (this._mdf.sw = !0), (a = !0)),
                                        this.sc !== r && ((this.sc = r), (this._mdf.sc = !0), (a = !0)),
                                        this.fc !== i && ((this.fc = i), (this._mdf.fc = !0), (a = !0)),
                                        this.m !== n && ((this.m = n), (this._mdf.m = !0), (a = !0)),
                                        !s.length ||
                                            (this.p[0] === s[0] &&
                                                this.p[1] === s[1] &&
                                                this.p[4] === s[4] &&
                                                this.p[5] === s[5] &&
                                                this.p[12] === s[12] &&
                                                this.p[13] === s[13]) ||
                                            ((this.p = s), (this._mdf.p = !0), (a = !0)),
                                        a
                                    );
                                }),
                                (TextProperty.prototype.defaultBoxWidth = [0, 0]),
                                (TextProperty.prototype.copyData = function (t, e) {
                                    for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
                                    return t;
                                }),
                                (TextProperty.prototype.setCurrentData = function (t) {
                                    t.__complete || this.completeTextData(t),
                                        (this.currentData = t),
                                        (this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth),
                                        (this._mdf = !0);
                                }),
                                (TextProperty.prototype.searchProperty = function () {
                                    return this.searchKeyframes();
                                }),
                                (TextProperty.prototype.searchKeyframes = function () {
                                    return (
                                        (this.kf = this.data.d.k.length > 1),
                                        this.kf && this.addEffect(this.getKeyframeValue.bind(this)),
                                        this.kf
                                    );
                                }),
                                (TextProperty.prototype.addEffect = function (t) {
                                    this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
                                }),
                                (TextProperty.prototype.getValue = function (t) {
                                    if (
                                        (this.elem.globalData.frameId !== this.frameId &&
                                            this.effectsSequence.length) ||
                                        t
                                    ) {
                                        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
                                        var e = this.currentData,
                                            r = this.keysIndex;
                                        if (this.lock) this.setCurrentData(this.currentData);
                                        else {
                                            var i;
                                            (this.lock = !0), (this._mdf = !1);
                                            var n = this.effectsSequence.length,
                                                s = t || this.data.d.k[this.keysIndex].s;
                                            for (i = 0; i < n; i += 1)
                                                s =
                                                    r !== this.keysIndex
                                                        ? this.effectsSequence[i](s, s.t)
                                                        : this.effectsSequence[i](this.currentData, s.t);
                                            e !== s && this.setCurrentData(s),
                                                (this.v = this.currentData),
                                                (this.pv = this.v),
                                                (this.lock = !1),
                                                (this.frameId = this.elem.globalData.frameId);
                                        }
                                    }
                                }),
                                (TextProperty.prototype.getKeyframeValue = function () {
                                    for (
                                        var t = this.data.d.k, e = this.elem.comp.renderedFrame, r = 0, i = t.length;
                                        r <= i - 1 && !(r === i - 1 || t[r + 1].t > e);

                                    )
                                        r += 1;
                                    return (
                                        this.keysIndex !== r && (this.keysIndex = r), this.data.d.k[this.keysIndex].s
                                    );
                                }),
                                (TextProperty.prototype.buildFinalText = function (t) {
                                    for (var e, r, i = [], n = 0, s = t.length, a = !1; n < s; )
                                        (e = t.charCodeAt(n)),
                                            FontManager.isCombinedCharacter(e)
                                                ? (i[i.length - 1] += t.charAt(n))
                                                : e >= 55296 && e <= 56319
                                                  ? (r = t.charCodeAt(n + 1)) >= 56320 && r <= 57343
                                                      ? (a || FontManager.isModifier(e, r)
                                                            ? ((i[i.length - 1] += t.substr(n, 2)), (a = !1))
                                                            : i.push(t.substr(n, 2)),
                                                        (n += 1))
                                                      : i.push(t.charAt(n))
                                                  : e > 56319
                                                    ? ((r = t.charCodeAt(n + 1)),
                                                      FontManager.isZeroWidthJoiner(e, r)
                                                          ? ((a = !0), (i[i.length - 1] += t.substr(n, 2)), (n += 1))
                                                          : i.push(t.charAt(n)))
                                                    : FontManager.isZeroWidthJoiner(e)
                                                      ? ((i[i.length - 1] += t.charAt(n)), (a = !0))
                                                      : i.push(t.charAt(n)),
                                            (n += 1);
                                    return i;
                                }),
                                (TextProperty.prototype.completeTextData = function (t) {
                                    t.__complete = !0;
                                    var e,
                                        r,
                                        i,
                                        n,
                                        s,
                                        a,
                                        o,
                                        l = this.elem.globalData.fontManager,
                                        h = this.data,
                                        p = [],
                                        c = 0,
                                        d = h.m.g,
                                        u = 0,
                                        f = 0,
                                        m = 0,
                                        g = [],
                                        y = 0,
                                        v = 0,
                                        b = l.getFontByName(t.f),
                                        _ = 0,
                                        x = getFontProperties(b);
                                    (t.fWeight = x.weight),
                                        (t.fStyle = x.style),
                                        (t.finalSize = t.s),
                                        (t.finalText = this.buildFinalText(t.t)),
                                        (r = t.finalText.length),
                                        (t.finalLineHeight = t.lh);
                                    var S,
                                        E = (t.tr / 1e3) * t.finalSize;
                                    if (t.sz)
                                        for (var w, P, T = !0, C = t.sz[0], A = t.sz[1]; T; ) {
                                            (w = 0),
                                                (y = 0),
                                                (r = (P = this.buildFinalText(t.t)).length),
                                                (E = (t.tr / 1e3) * t.finalSize);
                                            var k = -1;
                                            for (e = 0; e < r; e += 1)
                                                (S = P[e].charCodeAt(0)),
                                                    (i = !1),
                                                    " " === P[e]
                                                        ? (k = e)
                                                        : (13 !== S && 3 !== S) ||
                                                          ((y = 0),
                                                          (i = !0),
                                                          (w += t.finalLineHeight || 1.2 * t.finalSize)),
                                                    l.chars
                                                        ? ((o = l.getCharData(P[e], b.fStyle, b.fFamily)),
                                                          (_ = i ? 0 : (o.w * t.finalSize) / 100))
                                                        : (_ = l.measureText(P[e], t.f, t.finalSize)),
                                                    y + _ > C && " " !== P[e]
                                                        ? (-1 === k ? (r += 1) : (e = k),
                                                          (w += t.finalLineHeight || 1.2 * t.finalSize),
                                                          P.splice(e, k === e ? 1 : 0, "\r"),
                                                          (k = -1),
                                                          (y = 0))
                                                        : ((y += _), (y += E));
                                            (w += (b.ascent * t.finalSize) / 100),
                                                this.canResize && t.finalSize > this.minimumFontSize && A < w
                                                    ? ((t.finalSize -= 1),
                                                      (t.finalLineHeight = (t.finalSize * t.lh) / t.s))
                                                    : ((t.finalText = P), (r = t.finalText.length), (T = !1));
                                        }
                                    (y = -E), (_ = 0);
                                    var M,
                                        D = 0;
                                    for (e = 0; e < r; e += 1)
                                        if (
                                            ((i = !1),
                                            13 === (S = (M = t.finalText[e]).charCodeAt(0)) || 3 === S
                                                ? ((D = 0),
                                                  g.push(y),
                                                  (v = y > v ? y : v),
                                                  (y = -2 * E),
                                                  (n = ""),
                                                  (i = !0),
                                                  (m += 1))
                                                : (n = M),
                                            l.chars
                                                ? ((o = l.getCharData(M, b.fStyle, l.getFontByName(t.f).fFamily)),
                                                  (_ = i ? 0 : (o.w * t.finalSize) / 100))
                                                : (_ = l.measureText(n, t.f, t.finalSize)),
                                            " " === M ? (D += _ + E) : ((y += _ + E + D), (D = 0)),
                                            p.push({
                                                l: _,
                                                an: _,
                                                add: u,
                                                n: i,
                                                anIndexes: [],
                                                val: n,
                                                line: m,
                                                animatorJustifyOffset: 0,
                                            }),
                                            2 == d)
                                        ) {
                                            if (((u += _), "" === n || " " === n || e === r - 1)) {
                                                for (("" !== n && " " !== n) || (u -= _); f <= e; )
                                                    (p[f].an = u), (p[f].ind = c), (p[f].extra = _), (f += 1);
                                                (c += 1), (u = 0);
                                            }
                                        } else if (3 == d) {
                                            if (((u += _), "" === n || e === r - 1)) {
                                                for ("" === n && (u -= _); f <= e; )
                                                    (p[f].an = u), (p[f].ind = c), (p[f].extra = _), (f += 1);
                                                (u = 0), (c += 1);
                                            }
                                        } else (p[c].ind = c), (p[c].extra = 0), (c += 1);
                                    if (((t.l = p), (v = y > v ? y : v), g.push(y), t.sz))
                                        (t.boxWidth = t.sz[0]), (t.justifyOffset = 0);
                                    else
                                        switch (((t.boxWidth = v), t.j)) {
                                            case 1:
                                                t.justifyOffset = -t.boxWidth;
                                                break;
                                            case 2:
                                                t.justifyOffset = -t.boxWidth / 2;
                                                break;
                                            default:
                                                t.justifyOffset = 0;
                                        }
                                    t.lineWidths = g;
                                    var F,
                                        I,
                                        L,
                                        B,
                                        V = h.a;
                                    a = V.length;
                                    var R = [];
                                    for (s = 0; s < a; s += 1) {
                                        for (
                                            (F = V[s]).a.sc && (t.strokeColorAnim = !0),
                                                F.a.sw && (t.strokeWidthAnim = !0),
                                                (F.a.fc || F.a.fh || F.a.fs || F.a.fb) && (t.fillColorAnim = !0),
                                                B = 0,
                                                L = F.s.b,
                                                e = 0;
                                            e < r;
                                            e += 1
                                        )
                                            ((I = p[e]).anIndexes[s] = B),
                                                ((1 == L && "" !== I.val) ||
                                                    (2 == L && "" !== I.val && " " !== I.val) ||
                                                    (3 == L && (I.n || " " == I.val || e == r - 1)) ||
                                                    (4 == L && (I.n || e == r - 1))) &&
                                                    (1 === F.s.rn && R.push(B), (B += 1));
                                        h.a[s].s.totalChars = B;
                                        var O,
                                            z = -1;
                                        if (1 === F.s.rn)
                                            for (e = 0; e < r; e += 1)
                                                z != (I = p[e]).anIndexes[s] &&
                                                    ((z = I.anIndexes[s]),
                                                    (O = R.splice(Math.floor(Math.random() * R.length), 1)[0])),
                                                    (I.anIndexes[s] = O);
                                    }
                                    (t.yOffset = t.finalLineHeight || 1.2 * t.finalSize),
                                        (t.ls = t.ls || 0),
                                        (t.ascent = (b.ascent * t.finalSize) / 100);
                                }),
                                (TextProperty.prototype.updateDocumentData = function (t, e) {
                                    e = void 0 === e ? this.keysIndex : e;
                                    var r = this.copyData({}, this.data.d.k[e].s);
                                    (r = this.copyData(r, t)),
                                        (this.data.d.k[e].s = r),
                                        this.recalculate(e),
                                        this.elem.addDynamicProperty(this);
                                }),
                                (TextProperty.prototype.recalculate = function (t) {
                                    var e = this.data.d.k[t].s;
                                    (e.__complete = !1),
                                        (this.keysIndex = 0),
                                        (this._isFirstFrame = !0),
                                        this.getValue(e);
                                }),
                                (TextProperty.prototype.canResizeFont = function (t) {
                                    (this.canResize = t),
                                        this.recalculate(this.keysIndex),
                                        this.elem.addDynamicProperty(this);
                                }),
                                (TextProperty.prototype.setMinimumFontSize = function (t) {
                                    (this.minimumFontSize = Math.floor(t) || 1),
                                        this.recalculate(this.keysIndex),
                                        this.elem.addDynamicProperty(this);
                                });
                            var TextSelectorProp = (function () {
                                var t = Math.max,
                                    e = Math.min,
                                    r = Math.floor;
                                function i(t, e) {
                                    (this._currentTextLength = -1),
                                        (this.k = !1),
                                        (this.data = e),
                                        (this.elem = t),
                                        (this.comp = t.comp),
                                        (this.finalS = 0),
                                        (this.finalE = 0),
                                        this.initDynamicPropertyContainer(t),
                                        (this.s = PropertyFactory.getProp(t, e.s || { k: 0 }, 0, 0, this)),
                                        (this.e = "e" in e ? PropertyFactory.getProp(t, e.e, 0, 0, this) : { v: 100 }),
                                        (this.o = PropertyFactory.getProp(t, e.o || { k: 0 }, 0, 0, this)),
                                        (this.xe = PropertyFactory.getProp(t, e.xe || { k: 0 }, 0, 0, this)),
                                        (this.ne = PropertyFactory.getProp(t, e.ne || { k: 0 }, 0, 0, this)),
                                        (this.sm = PropertyFactory.getProp(t, e.sm || { k: 100 }, 0, 0, this)),
                                        (this.a = PropertyFactory.getProp(t, e.a, 0, 0.01, this)),
                                        this.dynamicProperties.length || this.getValue();
                                }
                                return (
                                    (i.prototype = {
                                        getMult: function (i) {
                                            this._currentTextLength !== this.elem.textProperty.currentData.l.length &&
                                                this.getValue();
                                            var n = 0,
                                                s = 0,
                                                a = 1,
                                                o = 1;
                                            this.ne.v > 0 ? (n = this.ne.v / 100) : (s = -this.ne.v / 100),
                                                this.xe.v > 0 ? (a = 1 - this.xe.v / 100) : (o = 1 + this.xe.v / 100);
                                            var l = BezierFactory.getBezierEasing(n, s, a, o).get,
                                                h = 0,
                                                p = this.finalS,
                                                c = this.finalE,
                                                d = this.data.sh;
                                            if (2 === d)
                                                h = l(
                                                    (h =
                                                        c === p
                                                            ? i >= c
                                                                ? 1
                                                                : 0
                                                            : t(0, e(0.5 / (c - p) + (i - p) / (c - p), 1)))
                                                );
                                            else if (3 === d)
                                                h = l(
                                                    (h =
                                                        c === p
                                                            ? i >= c
                                                                ? 0
                                                                : 1
                                                            : 1 - t(0, e(0.5 / (c - p) + (i - p) / (c - p), 1)))
                                                );
                                            else if (4 === d)
                                                c === p
                                                    ? (h = 0)
                                                    : (h = t(0, e(0.5 / (c - p) + (i - p) / (c - p), 1))) < 0.5
                                                      ? (h *= 2)
                                                      : (h = 1 - 2 * (h - 0.5)),
                                                    (h = l(h));
                                            else if (5 === d) {
                                                if (c === p) h = 0;
                                                else {
                                                    var u = c - p,
                                                        f = -u / 2 + (i = e(t(0, i + 0.5 - p), c - p)),
                                                        m = u / 2;
                                                    h = Math.sqrt(1 - (f * f) / (m * m));
                                                }
                                                h = l(h);
                                            } else
                                                6 === d
                                                    ? (c === p
                                                          ? (h = 0)
                                                          : ((i = e(t(0, i + 0.5 - p), c - p)),
                                                            (h =
                                                                (1 + Math.cos(Math.PI + (2 * Math.PI * i) / (c - p))) /
                                                                2)),
                                                      (h = l(h)))
                                                    : (i >= r(p) &&
                                                          (h = t(0, e(i - p < 0 ? e(c, 1) - (p - i) : c - i, 1))),
                                                      (h = l(h)));
                                            if (100 !== this.sm.v) {
                                                var g = 0.01 * this.sm.v;
                                                0 === g && (g = 1e-8);
                                                var y = 0.5 - 0.5 * g;
                                                h < y ? (h = 0) : (h = (h - y) / g) > 1 && (h = 1);
                                            }
                                            return h * this.a.v;
                                        },
                                        getValue: function (t) {
                                            this.iterateDynamicProperties(),
                                                (this._mdf = t || this._mdf),
                                                (this._currentTextLength =
                                                    this.elem.textProperty.currentData.l.length || 0),
                                                t && 2 === this.data.r && (this.e.v = this._currentTextLength);
                                            var e = 2 === this.data.r ? 1 : 100 / this.data.totalChars,
                                                r = this.o.v / e,
                                                i = this.s.v / e + r,
                                                n = this.e.v / e + r;
                                            if (i > n) {
                                                var s = i;
                                                (i = n), (n = s);
                                            }
                                            (this.finalS = i), (this.finalE = n);
                                        },
                                    }),
                                    extendPrototype([DynamicPropertyContainer], i),
                                    {
                                        getTextSelectorProp: function (t, e, r) {
                                            return new i(t, e, r);
                                        },
                                    }
                                );
                            })();
                            function TextAnimatorDataProperty(t, e, r) {
                                var i = { propType: !1 },
                                    n = PropertyFactory.getProp,
                                    s = e.a;
                                (this.a = {
                                    r: s.r ? n(t, s.r, 0, degToRads, r) : i,
                                    rx: s.rx ? n(t, s.rx, 0, degToRads, r) : i,
                                    ry: s.ry ? n(t, s.ry, 0, degToRads, r) : i,
                                    sk: s.sk ? n(t, s.sk, 0, degToRads, r) : i,
                                    sa: s.sa ? n(t, s.sa, 0, degToRads, r) : i,
                                    s: s.s ? n(t, s.s, 1, 0.01, r) : i,
                                    a: s.a ? n(t, s.a, 1, 0, r) : i,
                                    o: s.o ? n(t, s.o, 0, 0.01, r) : i,
                                    p: s.p ? n(t, s.p, 1, 0, r) : i,
                                    sw: s.sw ? n(t, s.sw, 0, 0, r) : i,
                                    sc: s.sc ? n(t, s.sc, 1, 0, r) : i,
                                    fc: s.fc ? n(t, s.fc, 1, 0, r) : i,
                                    fh: s.fh ? n(t, s.fh, 0, 0, r) : i,
                                    fs: s.fs ? n(t, s.fs, 0, 0.01, r) : i,
                                    fb: s.fb ? n(t, s.fb, 0, 0.01, r) : i,
                                    t: s.t ? n(t, s.t, 0, 0, r) : i,
                                }),
                                    (this.s = TextSelectorProp.getTextSelectorProp(t, e.s, r)),
                                    (this.s.t = e.s.t);
                            }
                            function TextAnimatorProperty(t, e, r) {
                                (this._isFirstFrame = !0),
                                    (this._hasMaskedPath = !1),
                                    (this._frameId = -1),
                                    (this._textData = t),
                                    (this._renderType = e),
                                    (this._elem = r),
                                    (this._animatorsData = createSizedArray(this._textData.a.length)),
                                    (this._pathData = {}),
                                    (this._moreOptions = { alignment: {} }),
                                    (this.renderedLetters = []),
                                    (this.lettersChangedFlag = !1),
                                    this.initDynamicPropertyContainer(r);
                            }
                            function ITextElement() {}
                            (TextAnimatorProperty.prototype.searchProperties = function () {
                                var t,
                                    e,
                                    r = this._textData.a.length,
                                    i = PropertyFactory.getProp;
                                for (t = 0; t < r; t += 1)
                                    (e = this._textData.a[t]),
                                        (this._animatorsData[t] = new TextAnimatorDataProperty(this._elem, e, this));
                                this._textData.p && "m" in this._textData.p
                                    ? ((this._pathData = {
                                          a: i(this._elem, this._textData.p.a, 0, 0, this),
                                          f: i(this._elem, this._textData.p.f, 0, 0, this),
                                          l: i(this._elem, this._textData.p.l, 0, 0, this),
                                          r: i(this._elem, this._textData.p.r, 0, 0, this),
                                          p: i(this._elem, this._textData.p.p, 0, 0, this),
                                          m: this._elem.maskManager.getMaskProperty(this._textData.p.m),
                                      }),
                                      (this._hasMaskedPath = !0))
                                    : (this._hasMaskedPath = !1),
                                    (this._moreOptions.alignment = i(this._elem, this._textData.m.a, 1, 0, this));
                            }),
                                (TextAnimatorProperty.prototype.getMeasures = function (t, e) {
                                    if (
                                        ((this.lettersChangedFlag = e),
                                        this._mdf ||
                                            this._isFirstFrame ||
                                            e ||
                                            (this._hasMaskedPath && this._pathData.m._mdf))
                                    ) {
                                        this._isFirstFrame = !1;
                                        var r,
                                            i,
                                            n,
                                            s,
                                            a,
                                            o,
                                            l,
                                            h,
                                            p,
                                            c,
                                            d,
                                            u,
                                            f,
                                            m,
                                            g,
                                            y,
                                            v,
                                            b,
                                            _,
                                            x = this._moreOptions.alignment.v,
                                            S = this._animatorsData,
                                            E = this._textData,
                                            w = this.mHelper,
                                            P = this._renderType,
                                            T = this.renderedLetters.length,
                                            C = t.l;
                                        if (this._hasMaskedPath) {
                                            if (((_ = this._pathData.m), !this._pathData.n || this._pathData._mdf)) {
                                                var A,
                                                    k = _.v;
                                                for (
                                                    this._pathData.r.v && (k = k.reverse()),
                                                        a = { tLength: 0, segments: [] },
                                                        s = k._length - 1,
                                                        y = 0,
                                                        n = 0;
                                                    n < s;
                                                    n += 1
                                                )
                                                    (A = bez.buildBezierData(
                                                        k.v[n],
                                                        k.v[n + 1],
                                                        [k.o[n][0] - k.v[n][0], k.o[n][1] - k.v[n][1]],
                                                        [k.i[n + 1][0] - k.v[n + 1][0], k.i[n + 1][1] - k.v[n + 1][1]]
                                                    )),
                                                        (a.tLength += A.segmentLength),
                                                        a.segments.push(A),
                                                        (y += A.segmentLength);
                                                (n = s),
                                                    _.v.c &&
                                                        ((A = bez.buildBezierData(
                                                            k.v[n],
                                                            k.v[0],
                                                            [k.o[n][0] - k.v[n][0], k.o[n][1] - k.v[n][1]],
                                                            [k.i[0][0] - k.v[0][0], k.i[0][1] - k.v[0][1]]
                                                        )),
                                                        (a.tLength += A.segmentLength),
                                                        a.segments.push(A),
                                                        (y += A.segmentLength)),
                                                    (this._pathData.pi = a);
                                            }
                                            if (
                                                ((a = this._pathData.pi),
                                                (o = this._pathData.f.v),
                                                (d = 0),
                                                (c = 1),
                                                (h = 0),
                                                (p = !0),
                                                (m = a.segments),
                                                o < 0 && _.v.c)
                                            )
                                                for (
                                                    a.tLength < Math.abs(o) && (o = -Math.abs(o) % a.tLength),
                                                        c = (f = m[(d = m.length - 1)].points).length - 1;
                                                    o < 0;

                                                )
                                                    (o += f[c].partialLength),
                                                        (c -= 1) < 0 && (c = (f = m[(d -= 1)].points).length - 1);
                                            (u = (f = m[d].points)[c - 1]), (g = (l = f[c]).partialLength);
                                        }
                                        (s = C.length), (r = 0), (i = 0);
                                        var M,
                                            D,
                                            F,
                                            I,
                                            L,
                                            B = 1.2 * t.finalSize * 0.714,
                                            V = !0;
                                        F = S.length;
                                        var R,
                                            O,
                                            z,
                                            G,
                                            N,
                                            q,
                                            H,
                                            $,
                                            j,
                                            W,
                                            Y,
                                            X,
                                            U = -1,
                                            Z = o,
                                            K = d,
                                            J = c,
                                            Q = -1,
                                            tt = "",
                                            et = this.defaultPropsArray;
                                        if (2 === t.j || 1 === t.j) {
                                            var rt = 0,
                                                it = 0,
                                                nt = 2 === t.j ? -0.5 : -1,
                                                st = 0,
                                                at = !0;
                                            for (n = 0; n < s; n += 1)
                                                if (C[n].n) {
                                                    for (rt && (rt += it); st < n; )
                                                        (C[st].animatorJustifyOffset = rt), (st += 1);
                                                    (rt = 0), (at = !0);
                                                } else {
                                                    for (D = 0; D < F; D += 1)
                                                        (M = S[D].a).t.propType &&
                                                            (at && 2 === t.j && (it += M.t.v * nt),
                                                            (L = S[D].s.getMult(C[n].anIndexes[D], E.a[D].s.totalChars))
                                                                .length
                                                                ? (rt += M.t.v * L[0] * nt)
                                                                : (rt += M.t.v * L * nt));
                                                    at = !1;
                                                }
                                            for (rt && (rt += it); st < n; )
                                                (C[st].animatorJustifyOffset = rt), (st += 1);
                                        }
                                        for (n = 0; n < s; n += 1) {
                                            if ((w.reset(), (G = 1), C[n].n))
                                                (r = 0),
                                                    (i += t.yOffset),
                                                    (i += V ? 1 : 0),
                                                    (o = Z),
                                                    (V = !1),
                                                    this._hasMaskedPath &&
                                                        ((c = J),
                                                        (u = (f = m[(d = K)].points)[c - 1]),
                                                        (g = (l = f[c]).partialLength),
                                                        (h = 0)),
                                                    (tt = ""),
                                                    (Y = ""),
                                                    (j = ""),
                                                    (X = ""),
                                                    (et = this.defaultPropsArray);
                                            else {
                                                if (this._hasMaskedPath) {
                                                    if (Q !== C[n].line) {
                                                        switch (t.j) {
                                                            case 1:
                                                                o += y - t.lineWidths[C[n].line];
                                                                break;
                                                            case 2:
                                                                o += (y - t.lineWidths[C[n].line]) / 2;
                                                        }
                                                        Q = C[n].line;
                                                    }
                                                    U !== C[n].ind &&
                                                        (C[U] && (o += C[U].extra), (o += C[n].an / 2), (U = C[n].ind)),
                                                        (o += x[0] * C[n].an * 0.005);
                                                    var ot = 0;
                                                    for (D = 0; D < F; D += 1)
                                                        (M = S[D].a).p.propType &&
                                                            ((L = S[D].s.getMult(
                                                                C[n].anIndexes[D],
                                                                E.a[D].s.totalChars
                                                            )).length
                                                                ? (ot += M.p.v[0] * L[0])
                                                                : (ot += M.p.v[0] * L)),
                                                            M.a.propType &&
                                                                ((L = S[D].s.getMult(
                                                                    C[n].anIndexes[D],
                                                                    E.a[D].s.totalChars
                                                                )).length
                                                                    ? (ot += M.a.v[0] * L[0])
                                                                    : (ot += M.a.v[0] * L));
                                                    for (
                                                        p = !0,
                                                            this._pathData.a.v &&
                                                                ((o =
                                                                    0.5 * C[0].an +
                                                                    ((y -
                                                                        this._pathData.f.v -
                                                                        0.5 * C[0].an -
                                                                        0.5 * C[C.length - 1].an) *
                                                                        U) /
                                                                        (s - 1)),
                                                                (o += this._pathData.f.v));
                                                        p;

                                                    )
                                                        h + g >= o + ot || !f
                                                            ? ((v = (o + ot - h) / l.partialLength),
                                                              (O = u.point[0] + (l.point[0] - u.point[0]) * v),
                                                              (z = u.point[1] + (l.point[1] - u.point[1]) * v),
                                                              w.translate(-x[0] * C[n].an * 0.005, -x[1] * B * 0.01),
                                                              (p = !1))
                                                            : f &&
                                                              ((h += l.partialLength),
                                                              (c += 1) >= f.length &&
                                                                  ((c = 0),
                                                                  m[(d += 1)]
                                                                      ? (f = m[d].points)
                                                                      : _.v.c
                                                                        ? ((c = 0), (f = m[(d = 0)].points))
                                                                        : ((h -= l.partialLength), (f = null))),
                                                              f && ((u = l), (g = (l = f[c]).partialLength)));
                                                    (R = C[n].an / 2 - C[n].add), w.translate(-R, 0, 0);
                                                } else
                                                    (R = C[n].an / 2 - C[n].add),
                                                        w.translate(-R, 0, 0),
                                                        w.translate(-x[0] * C[n].an * 0.005, -x[1] * B * 0.01, 0);
                                                for (D = 0; D < F; D += 1)
                                                    (M = S[D].a).t.propType &&
                                                        ((L = S[D].s.getMult(C[n].anIndexes[D], E.a[D].s.totalChars)),
                                                        (0 === r && 0 === t.j) ||
                                                            (this._hasMaskedPath
                                                                ? L.length
                                                                    ? (o += M.t.v * L[0])
                                                                    : (o += M.t.v * L)
                                                                : L.length
                                                                  ? (r += M.t.v * L[0])
                                                                  : (r += M.t.v * L)));
                                                for (
                                                    t.strokeWidthAnim && (q = t.sw || 0),
                                                        t.strokeColorAnim &&
                                                            (N = t.sc ? [t.sc[0], t.sc[1], t.sc[2]] : [0, 0, 0]),
                                                        t.fillColorAnim && t.fc && (H = [t.fc[0], t.fc[1], t.fc[2]]),
                                                        D = 0;
                                                    D < F;
                                                    D += 1
                                                )
                                                    (M = S[D].a).a.propType &&
                                                        ((L = S[D].s.getMult(C[n].anIndexes[D], E.a[D].s.totalChars))
                                                            .length
                                                            ? w.translate(
                                                                  -M.a.v[0] * L[0],
                                                                  -M.a.v[1] * L[1],
                                                                  M.a.v[2] * L[2]
                                                              )
                                                            : w.translate(-M.a.v[0] * L, -M.a.v[1] * L, M.a.v[2] * L));
                                                for (D = 0; D < F; D += 1)
                                                    (M = S[D].a).s.propType &&
                                                        ((L = S[D].s.getMult(C[n].anIndexes[D], E.a[D].s.totalChars))
                                                            .length
                                                            ? w.scale(
                                                                  1 + (M.s.v[0] - 1) * L[0],
                                                                  1 + (M.s.v[1] - 1) * L[1],
                                                                  1
                                                              )
                                                            : w.scale(
                                                                  1 + (M.s.v[0] - 1) * L,
                                                                  1 + (M.s.v[1] - 1) * L,
                                                                  1
                                                              ));
                                                for (D = 0; D < F; D += 1) {
                                                    if (
                                                        ((M = S[D].a),
                                                        (L = S[D].s.getMult(C[n].anIndexes[D], E.a[D].s.totalChars)),
                                                        M.sk.propType &&
                                                            (L.length
                                                                ? w.skewFromAxis(-M.sk.v * L[0], M.sa.v * L[1])
                                                                : w.skewFromAxis(-M.sk.v * L, M.sa.v * L)),
                                                        M.r.propType &&
                                                            (L.length
                                                                ? w.rotateZ(-M.r.v * L[2])
                                                                : w.rotateZ(-M.r.v * L)),
                                                        M.ry.propType &&
                                                            (L.length
                                                                ? w.rotateY(M.ry.v * L[1])
                                                                : w.rotateY(M.ry.v * L)),
                                                        M.rx.propType &&
                                                            (L.length
                                                                ? w.rotateX(M.rx.v * L[0])
                                                                : w.rotateX(M.rx.v * L)),
                                                        M.o.propType &&
                                                            (L.length
                                                                ? (G += (M.o.v * L[0] - G) * L[0])
                                                                : (G += (M.o.v * L - G) * L)),
                                                        t.strokeWidthAnim &&
                                                            M.sw.propType &&
                                                            (L.length ? (q += M.sw.v * L[0]) : (q += M.sw.v * L)),
                                                        t.strokeColorAnim && M.sc.propType)
                                                    )
                                                        for ($ = 0; $ < 3; $ += 1)
                                                            L.length
                                                                ? (N[$] += (M.sc.v[$] - N[$]) * L[0])
                                                                : (N[$] += (M.sc.v[$] - N[$]) * L);
                                                    if (t.fillColorAnim && t.fc) {
                                                        if (M.fc.propType)
                                                            for ($ = 0; $ < 3; $ += 1)
                                                                L.length
                                                                    ? (H[$] += (M.fc.v[$] - H[$]) * L[0])
                                                                    : (H[$] += (M.fc.v[$] - H[$]) * L);
                                                        M.fh.propType &&
                                                            (H = L.length
                                                                ? addHueToRGB(H, M.fh.v * L[0])
                                                                : addHueToRGB(H, M.fh.v * L)),
                                                            M.fs.propType &&
                                                                (H = L.length
                                                                    ? addSaturationToRGB(H, M.fs.v * L[0])
                                                                    : addSaturationToRGB(H, M.fs.v * L)),
                                                            M.fb.propType &&
                                                                (H = L.length
                                                                    ? addBrightnessToRGB(H, M.fb.v * L[0])
                                                                    : addBrightnessToRGB(H, M.fb.v * L));
                                                    }
                                                }
                                                for (D = 0; D < F; D += 1)
                                                    (M = S[D].a).p.propType &&
                                                        ((L = S[D].s.getMult(C[n].anIndexes[D], E.a[D].s.totalChars)),
                                                        this._hasMaskedPath
                                                            ? L.length
                                                                ? w.translate(0, M.p.v[1] * L[0], -M.p.v[2] * L[1])
                                                                : w.translate(0, M.p.v[1] * L, -M.p.v[2] * L)
                                                            : L.length
                                                              ? w.translate(
                                                                    M.p.v[0] * L[0],
                                                                    M.p.v[1] * L[1],
                                                                    -M.p.v[2] * L[2]
                                                                )
                                                              : w.translate(M.p.v[0] * L, M.p.v[1] * L, -M.p.v[2] * L));
                                                if (
                                                    (t.strokeWidthAnim && (j = q < 0 ? 0 : q),
                                                    t.strokeColorAnim &&
                                                        (W =
                                                            "rgb(" +
                                                            Math.round(255 * N[0]) +
                                                            "," +
                                                            Math.round(255 * N[1]) +
                                                            "," +
                                                            Math.round(255 * N[2]) +
                                                            ")"),
                                                    t.fillColorAnim &&
                                                        t.fc &&
                                                        (Y =
                                                            "rgb(" +
                                                            Math.round(255 * H[0]) +
                                                            "," +
                                                            Math.round(255 * H[1]) +
                                                            "," +
                                                            Math.round(255 * H[2]) +
                                                            ")"),
                                                    this._hasMaskedPath)
                                                ) {
                                                    if (
                                                        (w.translate(0, -t.ls),
                                                        w.translate(0, x[1] * B * 0.01 + i, 0),
                                                        this._pathData.p.v)
                                                    ) {
                                                        b = (l.point[1] - u.point[1]) / (l.point[0] - u.point[0]);
                                                        var lt = (180 * Math.atan(b)) / Math.PI;
                                                        l.point[0] < u.point[0] && (lt += 180),
                                                            w.rotate((-lt * Math.PI) / 180);
                                                    }
                                                    w.translate(O, z, 0),
                                                        (o -= x[0] * C[n].an * 0.005),
                                                        C[n + 1] &&
                                                            U !== C[n + 1].ind &&
                                                            ((o += C[n].an / 2), (o += 0.001 * t.tr * t.finalSize));
                                                } else {
                                                    switch (
                                                        (w.translate(r, i, 0),
                                                        t.ps && w.translate(t.ps[0], t.ps[1] + t.ascent, 0),
                                                        t.j)
                                                    ) {
                                                        case 1:
                                                            w.translate(
                                                                C[n].animatorJustifyOffset +
                                                                    t.justifyOffset +
                                                                    (t.boxWidth - t.lineWidths[C[n].line]),
                                                                0,
                                                                0
                                                            );
                                                            break;
                                                        case 2:
                                                            w.translate(
                                                                C[n].animatorJustifyOffset +
                                                                    t.justifyOffset +
                                                                    (t.boxWidth - t.lineWidths[C[n].line]) / 2,
                                                                0,
                                                                0
                                                            );
                                                    }
                                                    w.translate(0, -t.ls),
                                                        w.translate(R, 0, 0),
                                                        w.translate(x[0] * C[n].an * 0.005, x[1] * B * 0.01, 0),
                                                        (r += C[n].l + 0.001 * t.tr * t.finalSize);
                                                }
                                                "html" === P
                                                    ? (tt = w.toCSS())
                                                    : "svg" === P
                                                      ? (tt = w.to2dCSS())
                                                      : (et = [
                                                            w.props[0],
                                                            w.props[1],
                                                            w.props[2],
                                                            w.props[3],
                                                            w.props[4],
                                                            w.props[5],
                                                            w.props[6],
                                                            w.props[7],
                                                            w.props[8],
                                                            w.props[9],
                                                            w.props[10],
                                                            w.props[11],
                                                            w.props[12],
                                                            w.props[13],
                                                            w.props[14],
                                                            w.props[15],
                                                        ]),
                                                    (X = G);
                                            }
                                            T <= n
                                                ? ((I = new LetterProps(X, j, W, Y, tt, et)),
                                                  this.renderedLetters.push(I),
                                                  (T += 1),
                                                  (this.lettersChangedFlag = !0))
                                                : ((I = this.renderedLetters[n]),
                                                  (this.lettersChangedFlag =
                                                      I.update(X, j, W, Y, tt, et) || this.lettersChangedFlag));
                                        }
                                    }
                                }),
                                (TextAnimatorProperty.prototype.getValue = function () {
                                    this._elem.globalData.frameId !== this._frameId &&
                                        ((this._frameId = this._elem.globalData.frameId),
                                        this.iterateDynamicProperties());
                                }),
                                (TextAnimatorProperty.prototype.mHelper = new Matrix()),
                                (TextAnimatorProperty.prototype.defaultPropsArray = []),
                                extendPrototype([DynamicPropertyContainer], TextAnimatorProperty),
                                (ITextElement.prototype.initElement = function (t, e, r) {
                                    (this.lettersChangedFlag = !0),
                                        this.initFrame(),
                                        this.initBaseData(t, e, r),
                                        (this.textProperty = new TextProperty(this, t.t, this.dynamicProperties)),
                                        (this.textAnimator = new TextAnimatorProperty(t.t, this.renderType, this)),
                                        this.initTransform(t, e, r),
                                        this.initHierarchy(),
                                        this.initRenderable(),
                                        this.initRendererElement(),
                                        this.createContainerElements(),
                                        this.createRenderableComponents(),
                                        this.createContent(),
                                        this.hide(),
                                        this.textAnimator.searchProperties(this.dynamicProperties);
                                }),
                                (ITextElement.prototype.prepareFrame = function (t) {
                                    (this._mdf = !1),
                                        this.prepareRenderableFrame(t),
                                        this.prepareProperties(t, this.isInRange),
                                        (this.textProperty._mdf || this.textProperty._isFirstFrame) &&
                                            (this.buildNewText(),
                                            (this.textProperty._isFirstFrame = !1),
                                            (this.textProperty._mdf = !1));
                                }),
                                (ITextElement.prototype.createPathShape = function (t, e) {
                                    var r,
                                        i,
                                        n = e.length,
                                        s = "";
                                    for (r = 0; r < n; r += 1)
                                        "sh" === e[r].ty &&
                                            ((i = e[r].ks.k), (s += buildShapeString(i, i.i.length, !0, t)));
                                    return s;
                                }),
                                (ITextElement.prototype.updateDocumentData = function (t, e) {
                                    this.textProperty.updateDocumentData(t, e);
                                }),
                                (ITextElement.prototype.canResizeFont = function (t) {
                                    this.textProperty.canResizeFont(t);
                                }),
                                (ITextElement.prototype.setMinimumFontSize = function (t) {
                                    this.textProperty.setMinimumFontSize(t);
                                }),
                                (ITextElement.prototype.applyTextPropertiesToMatrix = function (t, e, r, i, n) {
                                    switch (
                                        (t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0),
                                        e.translate(0, -t.ls, 0),
                                        t.j)
                                    ) {
                                        case 1:
                                            e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]), 0, 0);
                                            break;
                                        case 2:
                                            e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]) / 2, 0, 0);
                                    }
                                    e.translate(i, n, 0);
                                }),
                                (ITextElement.prototype.buildColor = function (t) {
                                    return (
                                        "rgb(" +
                                        Math.round(255 * t[0]) +
                                        "," +
                                        Math.round(255 * t[1]) +
                                        "," +
                                        Math.round(255 * t[2]) +
                                        ")"
                                    );
                                }),
                                (ITextElement.prototype.emptyProp = new LetterProps()),
                                (ITextElement.prototype.destroy = function () {});
                            var emptyShapeData = { shapes: [] };
                            function SVGTextLottieElement(t, e, r) {
                                (this.textSpans = []), (this.renderType = "svg"), this.initElement(t, e, r);
                            }
                            function ISolidElement(t, e, r) {
                                this.initElement(t, e, r);
                            }
                            function NullElement(t, e, r) {
                                this.initFrame(),
                                    this.initBaseData(t, e, r),
                                    this.initFrame(),
                                    this.initTransform(t, e, r),
                                    this.initHierarchy();
                            }
                            function SVGRendererBase() {}
                            function ICompElement() {}
                            function SVGCompElement(t, e, r) {
                                (this.layers = t.layers),
                                    (this.supports3d = !0),
                                    (this.completeLayers = !1),
                                    (this.pendingElements = []),
                                    (this.elements = this.layers ? createSizedArray(this.layers.length) : []),
                                    this.initElement(t, e, r),
                                    (this.tm = t.tm
                                        ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this)
                                        : { _placeholder: !0 });
                            }
                            function SVGRenderer(t, e) {
                                (this.animationItem = t),
                                    (this.layers = null),
                                    (this.renderedFrame = -1),
                                    (this.svgElement = createNS("svg"));
                                var r = "";
                                if (e && e.title) {
                                    var i = createNS("title"),
                                        n = createElementID();
                                    i.setAttribute("id", n),
                                        (i.textContent = e.title),
                                        this.svgElement.appendChild(i),
                                        (r += n);
                                }
                                if (e && e.description) {
                                    var s = createNS("desc"),
                                        a = createElementID();
                                    s.setAttribute("id", a),
                                        (s.textContent = e.description),
                                        this.svgElement.appendChild(s),
                                        (r += " " + a);
                                }
                                r && this.svgElement.setAttribute("aria-labelledby", r);
                                var o = createNS("defs");
                                this.svgElement.appendChild(o);
                                var l = createNS("g");
                                this.svgElement.appendChild(l),
                                    (this.layerElement = l),
                                    (this.renderConfig = {
                                        preserveAspectRatio: (e && e.preserveAspectRatio) || "xMidYMid meet",
                                        imagePreserveAspectRatio: (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
                                        contentVisibility: (e && e.contentVisibility) || "visible",
                                        progressiveLoad: (e && e.progressiveLoad) || !1,
                                        hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                                        viewBoxOnly: (e && e.viewBoxOnly) || !1,
                                        viewBoxSize: (e && e.viewBoxSize) || !1,
                                        className: (e && e.className) || "",
                                        id: (e && e.id) || "",
                                        focusable: e && e.focusable,
                                        filterSize: {
                                            width: (e && e.filterSize && e.filterSize.width) || "100%",
                                            height: (e && e.filterSize && e.filterSize.height) || "100%",
                                            x: (e && e.filterSize && e.filterSize.x) || "0%",
                                            y: (e && e.filterSize && e.filterSize.y) || "0%",
                                        },
                                        width: e && e.width,
                                        height: e && e.height,
                                        runExpressions: !e || void 0 === e.runExpressions || e.runExpressions,
                                    }),
                                    (this.globalData = {
                                        _mdf: !1,
                                        frameNum: -1,
                                        defs: o,
                                        renderConfig: this.renderConfig,
                                    }),
                                    (this.elements = []),
                                    (this.pendingElements = []),
                                    (this.destroyed = !1),
                                    (this.rendererType = "svg");
                            }
                            function CVContextData() {
                                var t;
                                for (
                                    this.saved = [],
                                        this.cArrPos = 0,
                                        this.cTr = new Matrix(),
                                        this.cO = 1,
                                        this.savedOp = createTypedArray("float32", 15),
                                        t = 0;
                                    t < 15;
                                    t += 1
                                )
                                    this.saved[t] = createTypedArray("float32", 16);
                                this._length = 15;
                            }
                            function ShapeTransformManager() {
                                (this.sequences = {}), (this.sequenceList = []), (this.transform_key_count = 0);
                            }
                            function CVEffects() {}
                            function CVMaskElement(t, e) {
                                var r;
                                (this.data = t),
                                    (this.element = e),
                                    (this.masksProperties = this.data.masksProperties || []),
                                    (this.viewData = createSizedArray(this.masksProperties.length));
                                var i = this.masksProperties.length,
                                    n = !1;
                                for (r = 0; r < i; r += 1)
                                    "n" !== this.masksProperties[r].mode && (n = !0),
                                        (this.viewData[r] = ShapePropertyFactory.getShapeProp(
                                            this.element,
                                            this.masksProperties[r],
                                            3
                                        ));
                                (this.hasMasks = n), n && this.element.addRenderableComponent(this);
                            }
                            function CVBaseElement() {}
                            function CVShapeData(t, e, r, i) {
                                (this.styledShapes = []), (this.tr = [0, 0, 0, 0, 0, 0]);
                                var n,
                                    s = 4;
                                "rc" === e.ty ? (s = 5) : "el" === e.ty ? (s = 6) : "sr" === e.ty && (s = 7),
                                    (this.sh = ShapePropertyFactory.getShapeProp(t, e, s, t));
                                var a,
                                    o = r.length;
                                for (n = 0; n < o; n += 1)
                                    r[n].closed ||
                                        ((a = { transforms: i.addTransformSequence(r[n].transforms), trNodes: [] }),
                                        this.styledShapes.push(a),
                                        r[n].elements.push(a));
                            }
                            function CVShapeElement(t, e, r) {
                                (this.shapes = []),
                                    (this.shapesData = t.shapes),
                                    (this.stylesList = []),
                                    (this.itemsData = []),
                                    (this.prevViewData = []),
                                    (this.shapeModifiers = []),
                                    (this.processedElements = []),
                                    (this.transformsManager = new ShapeTransformManager()),
                                    this.initElement(t, e, r);
                            }
                            function CVTextElement(t, e, r) {
                                (this.textSpans = []),
                                    (this.yOffset = 0),
                                    (this.fillColorAnim = !1),
                                    (this.strokeColorAnim = !1),
                                    (this.strokeWidthAnim = !1),
                                    (this.stroke = !1),
                                    (this.fill = !1),
                                    (this.justifyOffset = 0),
                                    (this.currentRender = null),
                                    (this.renderType = "canvas"),
                                    (this.values = {
                                        fill: "rgba(0,0,0,0)",
                                        stroke: "rgba(0,0,0,0)",
                                        sWidth: 0,
                                        fValue: "",
                                    }),
                                    this.initElement(t, e, r);
                            }
                            function CVImageElement(t, e, r) {
                                (this.assetData = e.getAssetData(t.refId)),
                                    (this.img = e.imageLoader.getAsset(this.assetData)),
                                    this.initElement(t, e, r);
                            }
                            function CVSolidElement(t, e, r) {
                                this.initElement(t, e, r);
                            }
                            function CanvasRendererBase(t, e) {
                                (this.animationItem = t),
                                    (this.renderConfig = {
                                        clearCanvas: !e || void 0 === e.clearCanvas || e.clearCanvas,
                                        context: (e && e.context) || null,
                                        progressiveLoad: (e && e.progressiveLoad) || !1,
                                        preserveAspectRatio: (e && e.preserveAspectRatio) || "xMidYMid meet",
                                        imagePreserveAspectRatio: (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
                                        contentVisibility: (e && e.contentVisibility) || "visible",
                                        className: (e && e.className) || "",
                                        id: (e && e.id) || "",
                                    }),
                                    (this.renderConfig.dpr = (e && e.dpr) || 1),
                                    this.animationItem.wrapper &&
                                        (this.renderConfig.dpr = (e && e.dpr) || window.devicePixelRatio || 1),
                                    (this.renderedFrame = -1),
                                    (this.globalData = {
                                        frameNum: -1,
                                        _mdf: !1,
                                        renderConfig: this.renderConfig,
                                        currentGlobalAlpha: -1,
                                    }),
                                    (this.contextData = new CVContextData()),
                                    (this.elements = []),
                                    (this.pendingElements = []),
                                    (this.transformMat = new Matrix()),
                                    (this.completeLayers = !1),
                                    (this.rendererType = "canvas");
                            }
                            function CVCompElement(t, e, r) {
                                (this.completeLayers = !1),
                                    (this.layers = t.layers),
                                    (this.pendingElements = []),
                                    (this.elements = createSizedArray(this.layers.length)),
                                    this.initElement(t, e, r),
                                    (this.tm = t.tm
                                        ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this)
                                        : { _placeholder: !0 });
                            }
                            function CanvasRenderer(t, e) {
                                (this.animationItem = t),
                                    (this.renderConfig = {
                                        clearCanvas: !e || void 0 === e.clearCanvas || e.clearCanvas,
                                        context: (e && e.context) || null,
                                        progressiveLoad: (e && e.progressiveLoad) || !1,
                                        preserveAspectRatio: (e && e.preserveAspectRatio) || "xMidYMid meet",
                                        imagePreserveAspectRatio: (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
                                        contentVisibility: (e && e.contentVisibility) || "visible",
                                        className: (e && e.className) || "",
                                        id: (e && e.id) || "",
                                        runExpressions: !e || void 0 === e.runExpressions || e.runExpressions,
                                    }),
                                    (this.renderConfig.dpr = (e && e.dpr) || 1),
                                    this.animationItem.wrapper &&
                                        (this.renderConfig.dpr = (e && e.dpr) || window.devicePixelRatio || 1),
                                    (this.renderedFrame = -1),
                                    (this.globalData = {
                                        frameNum: -1,
                                        _mdf: !1,
                                        renderConfig: this.renderConfig,
                                        currentGlobalAlpha: -1,
                                    }),
                                    (this.contextData = new CVContextData()),
                                    (this.elements = []),
                                    (this.pendingElements = []),
                                    (this.transformMat = new Matrix()),
                                    (this.completeLayers = !1),
                                    (this.rendererType = "canvas");
                            }
                            function HBaseElement() {}
                            function HSolidElement(t, e, r) {
                                this.initElement(t, e, r);
                            }
                            function HShapeElement(t, e, r) {
                                (this.shapes = []),
                                    (this.shapesData = t.shapes),
                                    (this.stylesList = []),
                                    (this.shapeModifiers = []),
                                    (this.itemsData = []),
                                    (this.processedElements = []),
                                    (this.animatedContents = []),
                                    (this.shapesContainer = createNS("g")),
                                    this.initElement(t, e, r),
                                    (this.prevViewData = []),
                                    (this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 });
                            }
                            function HTextElement(t, e, r) {
                                (this.textSpans = []),
                                    (this.textPaths = []),
                                    (this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 }),
                                    (this.renderType = "svg"),
                                    (this.isMasked = !1),
                                    this.initElement(t, e, r);
                            }
                            function HCameraElement(t, e, r) {
                                this.initFrame(), this.initBaseData(t, e, r), this.initHierarchy();
                                var i = PropertyFactory.getProp;
                                if (
                                    ((this.pe = i(this, t.pe, 0, 0, this)),
                                    t.ks.p.s
                                        ? ((this.px = i(this, t.ks.p.x, 1, 0, this)),
                                          (this.py = i(this, t.ks.p.y, 1, 0, this)),
                                          (this.pz = i(this, t.ks.p.z, 1, 0, this)))
                                        : (this.p = i(this, t.ks.p, 1, 0, this)),
                                    t.ks.a && (this.a = i(this, t.ks.a, 1, 0, this)),
                                    t.ks.or.k.length && t.ks.or.k[0].to)
                                ) {
                                    var n,
                                        s = t.ks.or.k.length;
                                    for (n = 0; n < s; n += 1) (t.ks.or.k[n].to = null), (t.ks.or.k[n].ti = null);
                                }
                                (this.or = i(this, t.ks.or, 1, degToRads, this)),
                                    (this.or.sh = !0),
                                    (this.rx = i(this, t.ks.rx, 0, degToRads, this)),
                                    (this.ry = i(this, t.ks.ry, 0, degToRads, this)),
                                    (this.rz = i(this, t.ks.rz, 0, degToRads, this)),
                                    (this.mat = new Matrix()),
                                    (this._prevMat = new Matrix()),
                                    (this._isFirstFrame = !0),
                                    (this.finalTransform = { mProp: this });
                            }
                            function HImageElement(t, e, r) {
                                (this.assetData = e.getAssetData(t.refId)), this.initElement(t, e, r);
                            }
                            function HybridRendererBase(t, e) {
                                (this.animationItem = t),
                                    (this.layers = null),
                                    (this.renderedFrame = -1),
                                    (this.renderConfig = {
                                        className: (e && e.className) || "",
                                        imagePreserveAspectRatio: (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
                                        hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                                        filterSize: {
                                            width: (e && e.filterSize && e.filterSize.width) || "400%",
                                            height: (e && e.filterSize && e.filterSize.height) || "400%",
                                            x: (e && e.filterSize && e.filterSize.x) || "-100%",
                                            y: (e && e.filterSize && e.filterSize.y) || "-100%",
                                        },
                                    }),
                                    (this.globalData = { _mdf: !1, frameNum: -1, renderConfig: this.renderConfig }),
                                    (this.pendingElements = []),
                                    (this.elements = []),
                                    (this.threeDElements = []),
                                    (this.destroyed = !1),
                                    (this.camera = null),
                                    (this.supports3d = !0),
                                    (this.rendererType = "html");
                            }
                            function HCompElement(t, e, r) {
                                (this.layers = t.layers),
                                    (this.supports3d = !t.hasMask),
                                    (this.completeLayers = !1),
                                    (this.pendingElements = []),
                                    (this.elements = this.layers ? createSizedArray(this.layers.length) : []),
                                    this.initElement(t, e, r),
                                    (this.tm = t.tm
                                        ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this)
                                        : { _placeholder: !0 });
                            }
                            function HybridRenderer(t, e) {
                                (this.animationItem = t),
                                    (this.layers = null),
                                    (this.renderedFrame = -1),
                                    (this.renderConfig = {
                                        className: (e && e.className) || "",
                                        imagePreserveAspectRatio: (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
                                        hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                                        filterSize: {
                                            width: (e && e.filterSize && e.filterSize.width) || "400%",
                                            height: (e && e.filterSize && e.filterSize.height) || "400%",
                                            x: (e && e.filterSize && e.filterSize.x) || "-100%",
                                            y: (e && e.filterSize && e.filterSize.y) || "-100%",
                                        },
                                        runExpressions: !e || void 0 === e.runExpressions || e.runExpressions,
                                    }),
                                    (this.globalData = { _mdf: !1, frameNum: -1, renderConfig: this.renderConfig }),
                                    (this.pendingElements = []),
                                    (this.elements = []),
                                    (this.threeDElements = []),
                                    (this.destroyed = !1),
                                    (this.camera = null),
                                    (this.supports3d = !0),
                                    (this.rendererType = "html");
                            }
                            extendPrototype(
                                [
                                    BaseElement,
                                    TransformElement,
                                    SVGBaseElement,
                                    HierarchyElement,
                                    FrameElement,
                                    RenderableDOMElement,
                                    ITextElement,
                                ],
                                SVGTextLottieElement
                            ),
                                (SVGTextLottieElement.prototype.createContent = function () {
                                    this.data.singleShape &&
                                        !this.globalData.fontManager.chars &&
                                        (this.textContainer = createNS("text"));
                                }),
                                (SVGTextLottieElement.prototype.buildTextContents = function (t) {
                                    for (var e = 0, r = t.length, i = [], n = ""; e < r; )
                                        t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3)
                                            ? (i.push(n), (n = ""))
                                            : (n += t[e]),
                                            (e += 1);
                                    return i.push(n), i;
                                }),
                                (SVGTextLottieElement.prototype.buildShapeData = function (t, e) {
                                    if (t.shapes && t.shapes.length) {
                                        var r = t.shapes[0];
                                        if (r.it) {
                                            var i = r.it[r.it.length - 1];
                                            i.s && ((i.s.k[0] = e), (i.s.k[1] = e));
                                        }
                                    }
                                    return t;
                                }),
                                (SVGTextLottieElement.prototype.buildNewText = function () {
                                    var t, e;
                                    this.addDynamicProperty(this);
                                    var r = this.textProperty.currentData;
                                    (this.renderedLetters = createSizedArray(r ? r.l.length : 0)),
                                        r.fc
                                            ? this.layerElement.setAttribute("fill", this.buildColor(r.fc))
                                            : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"),
                                        r.sc &&
                                            (this.layerElement.setAttribute("stroke", this.buildColor(r.sc)),
                                            this.layerElement.setAttribute("stroke-width", r.sw)),
                                        this.layerElement.setAttribute("font-size", r.finalSize);
                                    var i = this.globalData.fontManager.getFontByName(r.f);
                                    if (i.fClass) this.layerElement.setAttribute("class", i.fClass);
                                    else {
                                        this.layerElement.setAttribute("font-family", i.fFamily);
                                        var n = r.fWeight,
                                            s = r.fStyle;
                                        this.layerElement.setAttribute("font-style", s),
                                            this.layerElement.setAttribute("font-weight", n);
                                    }
                                    this.layerElement.setAttribute("aria-label", r.t);
                                    var a,
                                        o = r.l || [],
                                        l = !!this.globalData.fontManager.chars;
                                    e = o.length;
                                    var h = this.mHelper,
                                        p = this.data.singleShape,
                                        c = 0,
                                        d = 0,
                                        u = !0,
                                        f = 0.001 * r.tr * r.finalSize;
                                    if (!p || l || r.sz) {
                                        var m,
                                            g = this.textSpans.length;
                                        for (t = 0; t < e; t += 1) {
                                            if (
                                                (this.textSpans[t] ||
                                                    (this.textSpans[t] = { span: null, childSpan: null, glyph: null }),
                                                !l || !p || 0 === t)
                                            ) {
                                                if (
                                                    ((a = g > t ? this.textSpans[t].span : createNS(l ? "g" : "text")),
                                                    g <= t)
                                                ) {
                                                    if (
                                                        (a.setAttribute("stroke-linecap", "butt"),
                                                        a.setAttribute("stroke-linejoin", "round"),
                                                        a.setAttribute("stroke-miterlimit", "4"),
                                                        (this.textSpans[t].span = a),
                                                        l)
                                                    ) {
                                                        var y = createNS("g");
                                                        a.appendChild(y), (this.textSpans[t].childSpan = y);
                                                    }
                                                    (this.textSpans[t].span = a), this.layerElement.appendChild(a);
                                                }
                                                a.style.display = "inherit";
                                            }
                                            if (
                                                (h.reset(),
                                                p &&
                                                    (o[t].n && ((c = -f), (d += r.yOffset), (d += u ? 1 : 0), (u = !1)),
                                                    this.applyTextPropertiesToMatrix(r, h, o[t].line, c, d),
                                                    (c += o[t].l || 0),
                                                    (c += f)),
                                                l)
                                            ) {
                                                var v;
                                                if (
                                                    1 ===
                                                    (m = this.globalData.fontManager.getCharData(
                                                        r.finalText[t],
                                                        i.fStyle,
                                                        this.globalData.fontManager.getFontByName(r.f).fFamily
                                                    )).t
                                                )
                                                    v = new SVGCompElement(m.data, this.globalData, this);
                                                else {
                                                    var b = emptyShapeData;
                                                    m.data &&
                                                        m.data.shapes &&
                                                        (b = this.buildShapeData(m.data, r.finalSize)),
                                                        (v = new SVGShapeElement(b, this.globalData, this));
                                                }
                                                if (this.textSpans[t].glyph) {
                                                    var _ = this.textSpans[t].glyph;
                                                    this.textSpans[t].childSpan.removeChild(_.layerElement),
                                                        _.destroy();
                                                }
                                                (this.textSpans[t].glyph = v),
                                                    (v._debug = !0),
                                                    v.prepareFrame(0),
                                                    v.renderFrame(),
                                                    this.textSpans[t].childSpan.appendChild(v.layerElement),
                                                    1 === m.t &&
                                                        this.textSpans[t].childSpan.setAttribute(
                                                            "transform",
                                                            "scale(" + r.finalSize / 100 + "," + r.finalSize / 100 + ")"
                                                        );
                                            } else
                                                p &&
                                                    a.setAttribute(
                                                        "transform",
                                                        "translate(" + h.props[12] + "," + h.props[13] + ")"
                                                    ),
                                                    (a.textContent = o[t].val),
                                                    a.setAttributeNS(
                                                        "http://www.w3.org/XML/1998/namespace",
                                                        "xml:space",
                                                        "preserve"
                                                    );
                                        }
                                        p && a && a.setAttribute("d", "");
                                    } else {
                                        var x = this.textContainer,
                                            S = "start";
                                        switch (r.j) {
                                            case 1:
                                                S = "end";
                                                break;
                                            case 2:
                                                S = "middle";
                                                break;
                                            default:
                                                S = "start";
                                        }
                                        x.setAttribute("text-anchor", S), x.setAttribute("letter-spacing", f);
                                        var E = this.buildTextContents(r.finalText);
                                        for (e = E.length, d = r.ps ? r.ps[1] + r.ascent : 0, t = 0; t < e; t += 1)
                                            ((a = this.textSpans[t].span || createNS("tspan")).textContent = E[t]),
                                                a.setAttribute("x", 0),
                                                a.setAttribute("y", d),
                                                (a.style.display = "inherit"),
                                                x.appendChild(a),
                                                this.textSpans[t] || (this.textSpans[t] = { span: null, glyph: null }),
                                                (this.textSpans[t].span = a),
                                                (d += r.finalLineHeight);
                                        this.layerElement.appendChild(x);
                                    }
                                    for (; t < this.textSpans.length; )
                                        (this.textSpans[t].span.style.display = "none"), (t += 1);
                                    this._sizeChanged = !0;
                                }),
                                (SVGTextLottieElement.prototype.sourceRectAtTime = function () {
                                    if (
                                        (this.prepareFrame(this.comp.renderedFrame - this.data.st),
                                        this.renderInnerContent(),
                                        this._sizeChanged)
                                    ) {
                                        this._sizeChanged = !1;
                                        var t = this.layerElement.getBBox();
                                        this.bbox = { top: t.y, left: t.x, width: t.width, height: t.height };
                                    }
                                    return this.bbox;
                                }),
                                (SVGTextLottieElement.prototype.getValue = function () {
                                    var t,
                                        e,
                                        r = this.textSpans.length;
                                    for (this.renderedFrame = this.comp.renderedFrame, t = 0; t < r; t += 1)
                                        (e = this.textSpans[t].glyph) &&
                                            (e.prepareFrame(this.comp.renderedFrame - this.data.st),
                                            e._mdf && (this._mdf = !0));
                                }),
                                (SVGTextLottieElement.prototype.renderInnerContent = function () {
                                    if (
                                        (!this.data.singleShape || this._mdf) &&
                                        (this.textAnimator.getMeasures(
                                            this.textProperty.currentData,
                                            this.lettersChangedFlag
                                        ),
                                        this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)
                                    ) {
                                        var t, e;
                                        this._sizeChanged = !0;
                                        var r,
                                            i,
                                            n,
                                            s = this.textAnimator.renderedLetters,
                                            a = this.textProperty.currentData.l;
                                        for (e = a.length, t = 0; t < e; t += 1)
                                            a[t].n ||
                                                ((r = s[t]),
                                                (i = this.textSpans[t].span),
                                                (n = this.textSpans[t].glyph) && n.renderFrame(),
                                                r._mdf.m && i.setAttribute("transform", r.m),
                                                r._mdf.o && i.setAttribute("opacity", r.o),
                                                r._mdf.sw && i.setAttribute("stroke-width", r.sw),
                                                r._mdf.sc && i.setAttribute("stroke", r.sc),
                                                r._mdf.fc && i.setAttribute("fill", r.fc));
                                    }
                                }),
                                extendPrototype([IImageElement], ISolidElement),
                                (ISolidElement.prototype.createContent = function () {
                                    var t = createNS("rect");
                                    t.setAttribute("width", this.data.sw),
                                        t.setAttribute("height", this.data.sh),
                                        t.setAttribute("fill", this.data.sc),
                                        this.layerElement.appendChild(t);
                                }),
                                (NullElement.prototype.prepareFrame = function (t) {
                                    this.prepareProperties(t, !0);
                                }),
                                (NullElement.prototype.renderFrame = function () {}),
                                (NullElement.prototype.getBaseElement = function () {
                                    return null;
                                }),
                                (NullElement.prototype.destroy = function () {}),
                                (NullElement.prototype.sourceRectAtTime = function () {}),
                                (NullElement.prototype.hide = function () {}),
                                extendPrototype(
                                    [BaseElement, TransformElement, HierarchyElement, FrameElement],
                                    NullElement
                                ),
                                extendPrototype([BaseRenderer], SVGRendererBase),
                                (SVGRendererBase.prototype.createNull = function (t) {
                                    return new NullElement(t, this.globalData, this);
                                }),
                                (SVGRendererBase.prototype.createShape = function (t) {
                                    return new SVGShapeElement(t, this.globalData, this);
                                }),
                                (SVGRendererBase.prototype.createText = function (t) {
                                    return new SVGTextLottieElement(t, this.globalData, this);
                                }),
                                (SVGRendererBase.prototype.createImage = function (t) {
                                    return new IImageElement(t, this.globalData, this);
                                }),
                                (SVGRendererBase.prototype.createSolid = function (t) {
                                    return new ISolidElement(t, this.globalData, this);
                                }),
                                (SVGRendererBase.prototype.configAnimation = function (t) {
                                    this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"),
                                        this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"),
                                        this.renderConfig.viewBoxSize
                                            ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize)
                                            : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h),
                                        this.renderConfig.viewBoxOnly ||
                                            (this.svgElement.setAttribute("width", t.w),
                                            this.svgElement.setAttribute("height", t.h),
                                            (this.svgElement.style.width = "100%"),
                                            (this.svgElement.style.height = "100%"),
                                            (this.svgElement.style.transform = "translate3d(0,0,0)"),
                                            (this.svgElement.style.contentVisibility =
                                                this.renderConfig.contentVisibility)),
                                        this.renderConfig.width &&
                                            this.svgElement.setAttribute("width", this.renderConfig.width),
                                        this.renderConfig.height &&
                                            this.svgElement.setAttribute("height", this.renderConfig.height),
                                        this.renderConfig.className &&
                                            this.svgElement.setAttribute("class", this.renderConfig.className),
                                        this.renderConfig.id &&
                                            this.svgElement.setAttribute("id", this.renderConfig.id),
                                        void 0 !== this.renderConfig.focusable &&
                                            this.svgElement.setAttribute("focusable", this.renderConfig.focusable),
                                        this.svgElement.setAttribute(
                                            "preserveAspectRatio",
                                            this.renderConfig.preserveAspectRatio
                                        ),
                                        this.animationItem.wrapper.appendChild(this.svgElement);
                                    var e = this.globalData.defs;
                                    this.setupGlobalData(t, e),
                                        (this.globalData.progressiveLoad = this.renderConfig.progressiveLoad),
                                        (this.data = t);
                                    var r = createNS("clipPath"),
                                        i = createNS("rect");
                                    i.setAttribute("width", t.w),
                                        i.setAttribute("height", t.h),
                                        i.setAttribute("x", 0),
                                        i.setAttribute("y", 0);
                                    var n = createElementID();
                                    r.setAttribute("id", n),
                                        r.appendChild(i),
                                        this.layerElement.setAttribute(
                                            "clip-path",
                                            "url(" + getLocationHref() + "#" + n + ")"
                                        ),
                                        e.appendChild(r),
                                        (this.layers = t.layers),
                                        (this.elements = createSizedArray(t.layers.length));
                                }),
                                (SVGRendererBase.prototype.destroy = function () {
                                    var t;
                                    this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""),
                                        (this.layerElement = null),
                                        (this.globalData.defs = null);
                                    var e = this.layers ? this.layers.length : 0;
                                    for (t = 0; t < e; t += 1) this.elements[t] && this.elements[t].destroy();
                                    (this.elements.length = 0), (this.destroyed = !0), (this.animationItem = null);
                                }),
                                (SVGRendererBase.prototype.updateContainerSize = function () {}),
                                (SVGRendererBase.prototype.findIndexByInd = function (t) {
                                    var e = 0,
                                        r = this.layers.length;
                                    for (e = 0; e < r; e += 1) if (this.layers[e].ind === t) return e;
                                    return -1;
                                }),
                                (SVGRendererBase.prototype.buildItem = function (t) {
                                    var e = this.elements;
                                    if (!e[t] && 99 !== this.layers[t].ty) {
                                        e[t] = !0;
                                        var r = this.createItem(this.layers[t]);
                                        if (
                                            ((e[t] = r),
                                            getExpressionsPlugin() &&
                                                (0 === this.layers[t].ty &&
                                                    this.globalData.projectInterface.registerComposition(r),
                                                r.initExpressions()),
                                            this.appendElementInPos(r, t),
                                            this.layers[t].tt)
                                        ) {
                                            var i =
                                                "tp" in this.layers[t] ? this.findIndexByInd(this.layers[t].tp) : t - 1;
                                            if (-1 === i) return;
                                            if (this.elements[i] && !0 !== this.elements[i]) {
                                                var n = e[i].getMatte(this.layers[t].tt);
                                                r.setMatte(n);
                                            } else this.buildItem(i), this.addPendingElement(r);
                                        }
                                    }
                                }),
                                (SVGRendererBase.prototype.checkPendingElements = function () {
                                    for (; this.pendingElements.length; ) {
                                        var t = this.pendingElements.pop();
                                        if ((t.checkParenting(), t.data.tt))
                                            for (var e = 0, r = this.elements.length; e < r; ) {
                                                if (this.elements[e] === t) {
                                                    var i = "tp" in t.data ? this.findIndexByInd(t.data.tp) : e - 1,
                                                        n = this.elements[i].getMatte(this.layers[e].tt);
                                                    t.setMatte(n);
                                                    break;
                                                }
                                                e += 1;
                                            }
                                    }
                                }),
                                (SVGRendererBase.prototype.renderFrame = function (t) {
                                    if (this.renderedFrame !== t && !this.destroyed) {
                                        var e;
                                        null === t ? (t = this.renderedFrame) : (this.renderedFrame = t),
                                            (this.globalData.frameNum = t),
                                            (this.globalData.frameId += 1),
                                            (this.globalData.projectInterface.currentFrame = t),
                                            (this.globalData._mdf = !1);
                                        var r = this.layers.length;
                                        for (this.completeLayers || this.checkLayers(t), e = r - 1; e >= 0; e -= 1)
                                            (this.completeLayers || this.elements[e]) &&
                                                this.elements[e].prepareFrame(t - this.layers[e].st);
                                        if (this.globalData._mdf)
                                            for (e = 0; e < r; e += 1)
                                                (this.completeLayers || this.elements[e]) &&
                                                    this.elements[e].renderFrame();
                                    }
                                }),
                                (SVGRendererBase.prototype.appendElementInPos = function (t, e) {
                                    var r = t.getBaseElement();
                                    if (r) {
                                        for (var i, n = 0; n < e; )
                                            this.elements[n] &&
                                                !0 !== this.elements[n] &&
                                                this.elements[n].getBaseElement() &&
                                                (i = this.elements[n].getBaseElement()),
                                                (n += 1);
                                        i ? this.layerElement.insertBefore(r, i) : this.layerElement.appendChild(r);
                                    }
                                }),
                                (SVGRendererBase.prototype.hide = function () {
                                    this.layerElement.style.display = "none";
                                }),
                                (SVGRendererBase.prototype.show = function () {
                                    this.layerElement.style.display = "block";
                                }),
                                extendPrototype(
                                    [
                                        BaseElement,
                                        TransformElement,
                                        HierarchyElement,
                                        FrameElement,
                                        RenderableDOMElement,
                                    ],
                                    ICompElement
                                ),
                                (ICompElement.prototype.initElement = function (t, e, r) {
                                    this.initFrame(),
                                        this.initBaseData(t, e, r),
                                        this.initTransform(t, e, r),
                                        this.initRenderable(),
                                        this.initHierarchy(),
                                        this.initRendererElement(),
                                        this.createContainerElements(),
                                        this.createRenderableComponents(),
                                        (!this.data.xt && e.progressiveLoad) || this.buildAllItems(),
                                        this.hide();
                                }),
                                (ICompElement.prototype.prepareFrame = function (t) {
                                    if (
                                        ((this._mdf = !1),
                                        this.prepareRenderableFrame(t),
                                        this.prepareProperties(t, this.isInRange),
                                        this.isInRange || this.data.xt)
                                    ) {
                                        if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;
                                        else {
                                            var e = this.tm.v;
                                            e === this.data.op && (e = this.data.op - 1), (this.renderedFrame = e);
                                        }
                                        var r,
                                            i = this.elements.length;
                                        for (
                                            this.completeLayers || this.checkLayers(this.renderedFrame), r = i - 1;
                                            r >= 0;
                                            r -= 1
                                        )
                                            (this.completeLayers || this.elements[r]) &&
                                                (this.elements[r].prepareFrame(this.renderedFrame - this.layers[r].st),
                                                this.elements[r]._mdf && (this._mdf = !0));
                                    }
                                }),
                                (ICompElement.prototype.renderInnerContent = function () {
                                    var t,
                                        e = this.layers.length;
                                    for (t = 0; t < e; t += 1)
                                        (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
                                }),
                                (ICompElement.prototype.setElements = function (t) {
                                    this.elements = t;
                                }),
                                (ICompElement.prototype.getElements = function () {
                                    return this.elements;
                                }),
                                (ICompElement.prototype.destroyElements = function () {
                                    var t,
                                        e = this.layers.length;
                                    for (t = 0; t < e; t += 1) this.elements[t] && this.elements[t].destroy();
                                }),
                                (ICompElement.prototype.destroy = function () {
                                    this.destroyElements(), this.destroyBaseElement();
                                }),
                                extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement),
                                (SVGCompElement.prototype.createComp = function (t) {
                                    return new SVGCompElement(t, this.globalData, this);
                                }),
                                extendPrototype([SVGRendererBase], SVGRenderer),
                                (SVGRenderer.prototype.createComp = function (t) {
                                    return new SVGCompElement(t, this.globalData, this);
                                }),
                                (CVContextData.prototype.duplicate = function () {
                                    var t = 2 * this._length,
                                        e = this.savedOp;
                                    (this.savedOp = createTypedArray("float32", t)), this.savedOp.set(e);
                                    var r = 0;
                                    for (r = this._length; r < t; r += 1)
                                        this.saved[r] = createTypedArray("float32", 16);
                                    this._length = t;
                                }),
                                (CVContextData.prototype.reset = function () {
                                    (this.cArrPos = 0), this.cTr.reset(), (this.cO = 1);
                                }),
                                (ShapeTransformManager.prototype = {
                                    addTransformSequence: function (t) {
                                        var e,
                                            r = t.length,
                                            i = "_";
                                        for (e = 0; e < r; e += 1) i += t[e].transform.key + "_";
                                        var n = this.sequences[i];
                                        return (
                                            n ||
                                                ((n = {
                                                    transforms: [].concat(t),
                                                    finalTransform: new Matrix(),
                                                    _mdf: !1,
                                                }),
                                                (this.sequences[i] = n),
                                                this.sequenceList.push(n)),
                                            n
                                        );
                                    },
                                    processSequence: function (t, e) {
                                        for (var r, i = 0, n = t.transforms.length, s = e; i < n && !e; ) {
                                            if (t.transforms[i].transform.mProps._mdf) {
                                                s = !0;
                                                break;
                                            }
                                            i += 1;
                                        }
                                        if (s)
                                            for (t.finalTransform.reset(), i = n - 1; i >= 0; i -= 1)
                                                (r = t.transforms[i].transform.mProps.v.props),
                                                    t.finalTransform.transform(
                                                        r[0],
                                                        r[1],
                                                        r[2],
                                                        r[3],
                                                        r[4],
                                                        r[5],
                                                        r[6],
                                                        r[7],
                                                        r[8],
                                                        r[9],
                                                        r[10],
                                                        r[11],
                                                        r[12],
                                                        r[13],
                                                        r[14],
                                                        r[15]
                                                    );
                                        t._mdf = s;
                                    },
                                    processSequences: function (t) {
                                        var e,
                                            r = this.sequenceList.length;
                                        for (e = 0; e < r; e += 1) this.processSequence(this.sequenceList[e], t);
                                    },
                                    getNewKey: function () {
                                        return (this.transform_key_count += 1), "_" + this.transform_key_count;
                                    },
                                }),
                                (CVEffects.prototype.renderFrame = function () {}),
                                (CVMaskElement.prototype.renderFrame = function () {
                                    if (this.hasMasks) {
                                        var t,
                                            e,
                                            r,
                                            i,
                                            n = this.element.finalTransform.mat,
                                            s = this.element.canvasContext,
                                            a = this.masksProperties.length;
                                        for (s.beginPath(), t = 0; t < a; t += 1)
                                            if ("n" !== this.masksProperties[t].mode) {
                                                var o;
                                                this.masksProperties[t].inv &&
                                                    (s.moveTo(0, 0),
                                                    s.lineTo(this.element.globalData.compSize.w, 0),
                                                    s.lineTo(
                                                        this.element.globalData.compSize.w,
                                                        this.element.globalData.compSize.h
                                                    ),
                                                    s.lineTo(0, this.element.globalData.compSize.h),
                                                    s.lineTo(0, 0)),
                                                    (i = this.viewData[t].v),
                                                    (e = n.applyToPointArray(i.v[0][0], i.v[0][1], 0)),
                                                    s.moveTo(e[0], e[1]);
                                                var l = i._length;
                                                for (o = 1; o < l; o += 1)
                                                    (r = n.applyToTriplePoints(i.o[o - 1], i.i[o], i.v[o])),
                                                        s.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
                                                (r = n.applyToTriplePoints(i.o[o - 1], i.i[0], i.v[0])),
                                                    s.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
                                            }
                                        this.element.globalData.renderer.save(!0), s.clip();
                                    }
                                }),
                                (CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty),
                                (CVMaskElement.prototype.destroy = function () {
                                    this.element = null;
                                }),
                                (CVBaseElement.prototype = {
                                    createElements: function () {},
                                    initRendererElement: function () {},
                                    createContainerElements: function () {
                                        (this.canvasContext = this.globalData.canvasContext),
                                            (this.renderableEffectsManager = new CVEffects(this));
                                    },
                                    createContent: function () {},
                                    setBlendMode: function () {
                                        var t = this.globalData;
                                        if (t.blendMode !== this.data.bm) {
                                            t.blendMode = this.data.bm;
                                            var e = getBlendMode(this.data.bm);
                                            t.canvasContext.globalCompositeOperation = e;
                                        }
                                    },
                                    createRenderableComponents: function () {
                                        this.maskManager = new CVMaskElement(this.data, this);
                                    },
                                    hideElement: function () {
                                        this.hidden || (this.isInRange && !this.isTransparent) || (this.hidden = !0);
                                    },
                                    showElement: function () {
                                        this.isInRange &&
                                            !this.isTransparent &&
                                            ((this.hidden = !1),
                                            (this._isFirstFrame = !0),
                                            (this.maskManager._isFirstFrame = !0));
                                    },
                                    renderFrame: function () {
                                        if (!this.hidden && !this.data.hd) {
                                            this.renderTransform(), this.renderRenderable(), this.setBlendMode();
                                            var t = 0 === this.data.ty;
                                            this.globalData.renderer.save(t),
                                                this.globalData.renderer.ctxTransform(this.finalTransform.mat.props),
                                                this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v),
                                                this.renderInnerContent(),
                                                this.globalData.renderer.restore(t),
                                                this.maskManager.hasMasks && this.globalData.renderer.restore(!0),
                                                this._isFirstFrame && (this._isFirstFrame = !1);
                                        }
                                    },
                                    destroy: function () {
                                        (this.canvasContext = null),
                                            (this.data = null),
                                            (this.globalData = null),
                                            this.maskManager.destroy();
                                    },
                                    mHelper: new Matrix(),
                                }),
                                (CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement),
                                (CVBaseElement.prototype.show = CVBaseElement.prototype.showElement),
                                (CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated),
                                extendPrototype(
                                    [
                                        BaseElement,
                                        TransformElement,
                                        CVBaseElement,
                                        IShapeElement,
                                        HierarchyElement,
                                        FrameElement,
                                        RenderableElement,
                                    ],
                                    CVShapeElement
                                ),
                                (CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement),
                                (CVShapeElement.prototype.transformHelper = { opacity: 1, _opMdf: !1 }),
                                (CVShapeElement.prototype.dashResetter = []),
                                (CVShapeElement.prototype.createContent = function () {
                                    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
                                }),
                                (CVShapeElement.prototype.createStyleElement = function (t, e) {
                                    var r = {
                                            data: t,
                                            type: t.ty,
                                            preTransforms: this.transformsManager.addTransformSequence(e),
                                            transforms: [],
                                            elements: [],
                                            closed: !0 === t.hd,
                                        },
                                        i = {};
                                    if (
                                        ("fl" === t.ty || "st" === t.ty
                                            ? ((i.c = PropertyFactory.getProp(this, t.c, 1, 255, this)),
                                              i.c.k ||
                                                  (r.co =
                                                      "rgb(" +
                                                      bmFloor(i.c.v[0]) +
                                                      "," +
                                                      bmFloor(i.c.v[1]) +
                                                      "," +
                                                      bmFloor(i.c.v[2]) +
                                                      ")"))
                                            : ("gf" !== t.ty && "gs" !== t.ty) ||
                                              ((i.s = PropertyFactory.getProp(this, t.s, 1, null, this)),
                                              (i.e = PropertyFactory.getProp(this, t.e, 1, null, this)),
                                              (i.h = PropertyFactory.getProp(this, t.h || { k: 0 }, 0, 0.01, this)),
                                              (i.a = PropertyFactory.getProp(
                                                  this,
                                                  t.a || { k: 0 },
                                                  0,
                                                  degToRads,
                                                  this
                                              )),
                                              (i.g = new GradientProperty(this, t.g, this))),
                                        (i.o = PropertyFactory.getProp(this, t.o, 0, 0.01, this)),
                                        "st" === t.ty || "gs" === t.ty)
                                    ) {
                                        if (
                                            ((r.lc = lineCapEnum[t.lc || 2]),
                                            (r.lj = lineJoinEnum[t.lj || 2]),
                                            1 == t.lj && (r.ml = t.ml),
                                            (i.w = PropertyFactory.getProp(this, t.w, 0, null, this)),
                                            i.w.k || (r.wi = i.w.v),
                                            t.d)
                                        ) {
                                            var n = new DashProperty(this, t.d, "canvas", this);
                                            (i.d = n), i.d.k || ((r.da = i.d.dashArray), (r.do = i.d.dashoffset[0]));
                                        }
                                    } else r.r = 2 === t.r ? "evenodd" : "nonzero";
                                    return this.stylesList.push(r), (i.style = r), i;
                                }),
                                (CVShapeElement.prototype.createGroupElement = function () {
                                    return { it: [], prevViewData: [] };
                                }),
                                (CVShapeElement.prototype.createTransformElement = function (t) {
                                    return {
                                        transform: {
                                            opacity: 1,
                                            _opMdf: !1,
                                            key: this.transformsManager.getNewKey(),
                                            op: PropertyFactory.getProp(this, t.o, 0, 0.01, this),
                                            mProps: TransformPropertyFactory.getTransformProperty(this, t, this),
                                        },
                                    };
                                }),
                                (CVShapeElement.prototype.createShapeElement = function (t) {
                                    var e = new CVShapeData(this, t, this.stylesList, this.transformsManager);
                                    return this.shapes.push(e), this.addShapeToModifiers(e), e;
                                }),
                                (CVShapeElement.prototype.reloadShapes = function () {
                                    var t;
                                    this._isFirstFrame = !0;
                                    var e = this.itemsData.length;
                                    for (t = 0; t < e; t += 1) this.prevViewData[t] = this.itemsData[t];
                                    for (
                                        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []),
                                            e = this.dynamicProperties.length,
                                            t = 0;
                                        t < e;
                                        t += 1
                                    )
                                        this.dynamicProperties[t].getValue();
                                    this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
                                }),
                                (CVShapeElement.prototype.addTransformToStyleList = function (t) {
                                    var e,
                                        r = this.stylesList.length;
                                    for (e = 0; e < r; e += 1)
                                        this.stylesList[e].closed || this.stylesList[e].transforms.push(t);
                                }),
                                (CVShapeElement.prototype.removeTransformFromStyleList = function () {
                                    var t,
                                        e = this.stylesList.length;
                                    for (t = 0; t < e; t += 1)
                                        this.stylesList[t].closed || this.stylesList[t].transforms.pop();
                                }),
                                (CVShapeElement.prototype.closeStyles = function (t) {
                                    var e,
                                        r = t.length;
                                    for (e = 0; e < r; e += 1) t[e].closed = !0;
                                }),
                                (CVShapeElement.prototype.searchShapes = function (t, e, r, i, n) {
                                    var s,
                                        a,
                                        o,
                                        l,
                                        h,
                                        p,
                                        c = t.length - 1,
                                        d = [],
                                        u = [],
                                        f = [].concat(n);
                                    for (s = c; s >= 0; s -= 1) {
                                        if (
                                            ((l = this.searchProcessedElement(t[s]))
                                                ? (e[s] = r[l - 1])
                                                : (t[s]._shouldRender = i),
                                            "fl" === t[s].ty ||
                                                "st" === t[s].ty ||
                                                "gf" === t[s].ty ||
                                                "gs" === t[s].ty)
                                        )
                                            l ? (e[s].style.closed = !1) : (e[s] = this.createStyleElement(t[s], f)),
                                                d.push(e[s].style);
                                        else if ("gr" === t[s].ty) {
                                            if (l)
                                                for (o = e[s].it.length, a = 0; a < o; a += 1)
                                                    e[s].prevViewData[a] = e[s].it[a];
                                            else e[s] = this.createGroupElement(t[s]);
                                            this.searchShapes(t[s].it, e[s].it, e[s].prevViewData, i, f);
                                        } else
                                            "tr" === t[s].ty
                                                ? (l || ((p = this.createTransformElement(t[s])), (e[s] = p)),
                                                  f.push(e[s]),
                                                  this.addTransformToStyleList(e[s]))
                                                : "sh" === t[s].ty ||
                                                    "rc" === t[s].ty ||
                                                    "el" === t[s].ty ||
                                                    "sr" === t[s].ty
                                                  ? l || (e[s] = this.createShapeElement(t[s]))
                                                  : "tm" === t[s].ty ||
                                                      "rd" === t[s].ty ||
                                                      "pb" === t[s].ty ||
                                                      "zz" === t[s].ty ||
                                                      "op" === t[s].ty
                                                    ? (l
                                                          ? ((h = e[s]).closed = !1)
                                                          : ((h = ShapeModifiers.getModifier(t[s].ty)).init(this, t[s]),
                                                            (e[s] = h),
                                                            this.shapeModifiers.push(h)),
                                                      u.push(h))
                                                    : "rp" === t[s].ty &&
                                                      (l
                                                          ? ((h = e[s]).closed = !0)
                                                          : ((h = ShapeModifiers.getModifier(t[s].ty)),
                                                            (e[s] = h),
                                                            h.init(this, t, s, e),
                                                            this.shapeModifiers.push(h),
                                                            (i = !1)),
                                                      u.push(h));
                                        this.addProcessedElement(t[s], s + 1);
                                    }
                                    for (
                                        this.removeTransformFromStyleList(), this.closeStyles(d), c = u.length, s = 0;
                                        s < c;
                                        s += 1
                                    )
                                        u[s].closed = !0;
                                }),
                                (CVShapeElement.prototype.renderInnerContent = function () {
                                    (this.transformHelper.opacity = 1),
                                        (this.transformHelper._opMdf = !1),
                                        this.renderModifiers(),
                                        this.transformsManager.processSequences(this._isFirstFrame),
                                        this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
                                }),
                                (CVShapeElement.prototype.renderShapeTransform = function (t, e) {
                                    (t._opMdf || e.op._mdf || this._isFirstFrame) &&
                                        ((e.opacity = t.opacity), (e.opacity *= e.op.v), (e._opMdf = !0));
                                }),
                                (CVShapeElement.prototype.drawLayer = function () {
                                    var t,
                                        e,
                                        r,
                                        i,
                                        n,
                                        s,
                                        a,
                                        o,
                                        l,
                                        h = this.stylesList.length,
                                        p = this.globalData.renderer,
                                        c = this.globalData.canvasContext;
                                    for (t = 0; t < h; t += 1)
                                        if (
                                            (("st" !== (o = (l = this.stylesList[t]).type) && "gs" !== o) ||
                                                0 !== l.wi) &&
                                            l.data._shouldRender &&
                                            0 !== l.coOp &&
                                            0 !== this.globalData.currentGlobalAlpha
                                        ) {
                                            for (
                                                p.save(),
                                                    s = l.elements,
                                                    "st" === o || "gs" === o
                                                        ? ((c.strokeStyle = "st" === o ? l.co : l.grd),
                                                          (c.lineWidth = l.wi),
                                                          (c.lineCap = l.lc),
                                                          (c.lineJoin = l.lj),
                                                          (c.miterLimit = l.ml || 0))
                                                        : (c.fillStyle = "fl" === o ? l.co : l.grd),
                                                    p.ctxOpacity(l.coOp),
                                                    "st" !== o && "gs" !== o && c.beginPath(),
                                                    p.ctxTransform(l.preTransforms.finalTransform.props),
                                                    r = s.length,
                                                    e = 0;
                                                e < r;
                                                e += 1
                                            ) {
                                                for (
                                                    ("st" !== o && "gs" !== o) ||
                                                        (c.beginPath(),
                                                        l.da && (c.setLineDash(l.da), (c.lineDashOffset = l.do))),
                                                        n = (a = s[e].trNodes).length,
                                                        i = 0;
                                                    i < n;
                                                    i += 1
                                                )
                                                    "m" === a[i].t
                                                        ? c.moveTo(a[i].p[0], a[i].p[1])
                                                        : "c" === a[i].t
                                                          ? c.bezierCurveTo(
                                                                a[i].pts[0],
                                                                a[i].pts[1],
                                                                a[i].pts[2],
                                                                a[i].pts[3],
                                                                a[i].pts[4],
                                                                a[i].pts[5]
                                                            )
                                                          : c.closePath();
                                                ("st" !== o && "gs" !== o) ||
                                                    (c.stroke(), l.da && c.setLineDash(this.dashResetter));
                                            }
                                            "st" !== o && "gs" !== o && c.fill(l.r), p.restore();
                                        }
                                }),
                                (CVShapeElement.prototype.renderShape = function (t, e, r, i) {
                                    var n, s;
                                    for (s = t, n = e.length - 1; n >= 0; n -= 1)
                                        "tr" === e[n].ty
                                            ? ((s = r[n].transform), this.renderShapeTransform(t, s))
                                            : "sh" === e[n].ty ||
                                                "el" === e[n].ty ||
                                                "rc" === e[n].ty ||
                                                "sr" === e[n].ty
                                              ? this.renderPath(e[n], r[n])
                                              : "fl" === e[n].ty
                                                ? this.renderFill(e[n], r[n], s)
                                                : "st" === e[n].ty
                                                  ? this.renderStroke(e[n], r[n], s)
                                                  : "gf" === e[n].ty || "gs" === e[n].ty
                                                    ? this.renderGradientFill(e[n], r[n], s)
                                                    : "gr" === e[n].ty
                                                      ? this.renderShape(s, e[n].it, r[n].it)
                                                      : e[n].ty;
                                    i && this.drawLayer();
                                }),
                                (CVShapeElement.prototype.renderStyledShape = function (t, e) {
                                    if (this._isFirstFrame || e._mdf || t.transforms._mdf) {
                                        var r,
                                            i,
                                            n,
                                            s = t.trNodes,
                                            a = e.paths,
                                            o = a._length;
                                        s.length = 0;
                                        var l = t.transforms.finalTransform;
                                        for (n = 0; n < o; n += 1) {
                                            var h = a.shapes[n];
                                            if (h && h.v) {
                                                for (i = h._length, r = 1; r < i; r += 1)
                                                    1 === r &&
                                                        s.push({
                                                            t: "m",
                                                            p: l.applyToPointArray(h.v[0][0], h.v[0][1], 0),
                                                        }),
                                                        s.push({
                                                            t: "c",
                                                            pts: l.applyToTriplePoints(h.o[r - 1], h.i[r], h.v[r]),
                                                        });
                                                1 === i &&
                                                    s.push({ t: "m", p: l.applyToPointArray(h.v[0][0], h.v[0][1], 0) }),
                                                    h.c &&
                                                        i &&
                                                        (s.push({
                                                            t: "c",
                                                            pts: l.applyToTriplePoints(h.o[r - 1], h.i[0], h.v[0]),
                                                        }),
                                                        s.push({ t: "z" }));
                                            }
                                        }
                                        t.trNodes = s;
                                    }
                                }),
                                (CVShapeElement.prototype.renderPath = function (t, e) {
                                    if (!0 !== t.hd && t._shouldRender) {
                                        var r,
                                            i = e.styledShapes.length;
                                        for (r = 0; r < i; r += 1) this.renderStyledShape(e.styledShapes[r], e.sh);
                                    }
                                }),
                                (CVShapeElement.prototype.renderFill = function (t, e, r) {
                                    var i = e.style;
                                    (e.c._mdf || this._isFirstFrame) &&
                                        (i.co =
                                            "rgb(" +
                                            bmFloor(e.c.v[0]) +
                                            "," +
                                            bmFloor(e.c.v[1]) +
                                            "," +
                                            bmFloor(e.c.v[2]) +
                                            ")"),
                                        (e.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = e.o.v * r.opacity);
                                }),
                                (CVShapeElement.prototype.renderGradientFill = function (t, e, r) {
                                    var i,
                                        n = e.style;
                                    if (
                                        !n.grd ||
                                        e.g._mdf ||
                                        e.s._mdf ||
                                        e.e._mdf ||
                                        (1 !== t.t && (e.h._mdf || e.a._mdf))
                                    ) {
                                        var s,
                                            a = this.globalData.canvasContext,
                                            o = e.s.v,
                                            l = e.e.v;
                                        if (1 === t.t) i = a.createLinearGradient(o[0], o[1], l[0], l[1]);
                                        else {
                                            var h = Math.sqrt(Math.pow(o[0] - l[0], 2) + Math.pow(o[1] - l[1], 2)),
                                                p = Math.atan2(l[1] - o[1], l[0] - o[0]),
                                                c = e.h.v;
                                            c >= 1 ? (c = 0.99) : c <= -1 && (c = -0.99);
                                            var d = h * c,
                                                u = Math.cos(p + e.a.v) * d + o[0],
                                                f = Math.sin(p + e.a.v) * d + o[1];
                                            i = a.createRadialGradient(u, f, 0, o[0], o[1], h);
                                        }
                                        var m = t.g.p,
                                            g = e.g.c,
                                            y = 1;
                                        for (s = 0; s < m; s += 1)
                                            e.g._hasOpacity && e.g._collapsable && (y = e.g.o[2 * s + 1]),
                                                i.addColorStop(
                                                    g[4 * s] / 100,
                                                    "rgba(" +
                                                        g[4 * s + 1] +
                                                        "," +
                                                        g[4 * s + 2] +
                                                        "," +
                                                        g[4 * s + 3] +
                                                        "," +
                                                        y +
                                                        ")"
                                                );
                                        n.grd = i;
                                    }
                                    n.coOp = e.o.v * r.opacity;
                                }),
                                (CVShapeElement.prototype.renderStroke = function (t, e, r) {
                                    var i = e.style,
                                        n = e.d;
                                    n &&
                                        (n._mdf || this._isFirstFrame) &&
                                        ((i.da = n.dashArray), (i.do = n.dashoffset[0])),
                                        (e.c._mdf || this._isFirstFrame) &&
                                            (i.co =
                                                "rgb(" +
                                                bmFloor(e.c.v[0]) +
                                                "," +
                                                bmFloor(e.c.v[1]) +
                                                "," +
                                                bmFloor(e.c.v[2]) +
                                                ")"),
                                        (e.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = e.o.v * r.opacity),
                                        (e.w._mdf || this._isFirstFrame) && (i.wi = e.w.v);
                                }),
                                (CVShapeElement.prototype.destroy = function () {
                                    (this.shapesData = null),
                                        (this.globalData = null),
                                        (this.canvasContext = null),
                                        (this.stylesList.length = 0),
                                        (this.itemsData.length = 0);
                                }),
                                extendPrototype(
                                    [
                                        BaseElement,
                                        TransformElement,
                                        CVBaseElement,
                                        HierarchyElement,
                                        FrameElement,
                                        RenderableElement,
                                        ITextElement,
                                    ],
                                    CVTextElement
                                ),
                                (CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d")),
                                (CVTextElement.prototype.buildNewText = function () {
                                    var t = this.textProperty.currentData;
                                    this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
                                    var e = !1;
                                    t.fc
                                        ? ((e = !0), (this.values.fill = this.buildColor(t.fc)))
                                        : (this.values.fill = "rgba(0,0,0,0)"),
                                        (this.fill = e);
                                    var r = !1;
                                    t.sc &&
                                        ((r = !0),
                                        (this.values.stroke = this.buildColor(t.sc)),
                                        (this.values.sWidth = t.sw));
                                    var i,
                                        n,
                                        s,
                                        a,
                                        o,
                                        l,
                                        h,
                                        p,
                                        c,
                                        d,
                                        u,
                                        f,
                                        m = this.globalData.fontManager.getFontByName(t.f),
                                        g = t.l,
                                        y = this.mHelper;
                                    (this.stroke = r),
                                        (this.values.fValue =
                                            t.finalSize +
                                            "px " +
                                            this.globalData.fontManager.getFontByName(t.f).fFamily),
                                        (n = t.finalText.length);
                                    var v = this.data.singleShape,
                                        b = 0.001 * t.tr * t.finalSize,
                                        _ = 0,
                                        x = 0,
                                        S = !0,
                                        E = 0;
                                    for (i = 0; i < n; i += 1) {
                                        (a =
                                            ((s = this.globalData.fontManager.getCharData(
                                                t.finalText[i],
                                                m.fStyle,
                                                this.globalData.fontManager.getFontByName(t.f).fFamily
                                            )) &&
                                                s.data) ||
                                            {}),
                                            y.reset(),
                                            v && g[i].n && ((_ = -b), (x += t.yOffset), (x += S ? 1 : 0), (S = !1)),
                                            (c = (h = a.shapes ? a.shapes[0].it : []).length),
                                            y.scale(t.finalSize / 100, t.finalSize / 100),
                                            v && this.applyTextPropertiesToMatrix(t, y, g[i].line, _, x),
                                            (u = createSizedArray(c - 1));
                                        var w = 0;
                                        for (p = 0; p < c; p += 1)
                                            if ("sh" === h[p].ty) {
                                                for (
                                                    l = h[p].ks.k.i.length, d = h[p].ks.k, f = [], o = 1;
                                                    o < l;
                                                    o += 1
                                                )
                                                    1 === o &&
                                                        f.push(
                                                            y.applyToX(d.v[0][0], d.v[0][1], 0),
                                                            y.applyToY(d.v[0][0], d.v[0][1], 0)
                                                        ),
                                                        f.push(
                                                            y.applyToX(d.o[o - 1][0], d.o[o - 1][1], 0),
                                                            y.applyToY(d.o[o - 1][0], d.o[o - 1][1], 0),
                                                            y.applyToX(d.i[o][0], d.i[o][1], 0),
                                                            y.applyToY(d.i[o][0], d.i[o][1], 0),
                                                            y.applyToX(d.v[o][0], d.v[o][1], 0),
                                                            y.applyToY(d.v[o][0], d.v[o][1], 0)
                                                        );
                                                f.push(
                                                    y.applyToX(d.o[o - 1][0], d.o[o - 1][1], 0),
                                                    y.applyToY(d.o[o - 1][0], d.o[o - 1][1], 0),
                                                    y.applyToX(d.i[0][0], d.i[0][1], 0),
                                                    y.applyToY(d.i[0][0], d.i[0][1], 0),
                                                    y.applyToX(d.v[0][0], d.v[0][1], 0),
                                                    y.applyToY(d.v[0][0], d.v[0][1], 0)
                                                ),
                                                    (u[w] = f),
                                                    (w += 1);
                                            }
                                        v && ((_ += g[i].l), (_ += b)),
                                            this.textSpans[E]
                                                ? (this.textSpans[E].elem = u)
                                                : (this.textSpans[E] = { elem: u }),
                                            (E += 1);
                                    }
                                }),
                                (CVTextElement.prototype.renderInnerContent = function () {
                                    var t,
                                        e,
                                        r,
                                        i,
                                        n,
                                        s,
                                        a = this.canvasContext;
                                    (a.font = this.values.fValue),
                                        (a.lineCap = "butt"),
                                        (a.lineJoin = "miter"),
                                        (a.miterLimit = 4),
                                        this.data.singleShape ||
                                            this.textAnimator.getMeasures(
                                                this.textProperty.currentData,
                                                this.lettersChangedFlag
                                            );
                                    var o,
                                        l = this.textAnimator.renderedLetters,
                                        h = this.textProperty.currentData.l;
                                    e = h.length;
                                    var p,
                                        c,
                                        d = null,
                                        u = null,
                                        f = null;
                                    for (t = 0; t < e; t += 1)
                                        if (!h[t].n) {
                                            if (
                                                ((o = l[t]) &&
                                                    (this.globalData.renderer.save(),
                                                    this.globalData.renderer.ctxTransform(o.p),
                                                    this.globalData.renderer.ctxOpacity(o.o)),
                                                this.fill)
                                            ) {
                                                for (
                                                    o && o.fc
                                                        ? d !== o.fc && ((d = o.fc), (a.fillStyle = o.fc))
                                                        : d !== this.values.fill &&
                                                          ((d = this.values.fill), (a.fillStyle = this.values.fill)),
                                                        i = (p = this.textSpans[t].elem).length,
                                                        this.globalData.canvasContext.beginPath(),
                                                        r = 0;
                                                    r < i;
                                                    r += 1
                                                )
                                                    for (
                                                        s = (c = p[r]).length,
                                                            this.globalData.canvasContext.moveTo(c[0], c[1]),
                                                            n = 2;
                                                        n < s;
                                                        n += 6
                                                    )
                                                        this.globalData.canvasContext.bezierCurveTo(
                                                            c[n],
                                                            c[n + 1],
                                                            c[n + 2],
                                                            c[n + 3],
                                                            c[n + 4],
                                                            c[n + 5]
                                                        );
                                                this.globalData.canvasContext.closePath(),
                                                    this.globalData.canvasContext.fill();
                                            }
                                            if (this.stroke) {
                                                for (
                                                    o && o.sw
                                                        ? f !== o.sw && ((f = o.sw), (a.lineWidth = o.sw))
                                                        : f !== this.values.sWidth &&
                                                          ((f = this.values.sWidth),
                                                          (a.lineWidth = this.values.sWidth)),
                                                        o && o.sc
                                                            ? u !== o.sc && ((u = o.sc), (a.strokeStyle = o.sc))
                                                            : u !== this.values.stroke &&
                                                              ((u = this.values.stroke),
                                                              (a.strokeStyle = this.values.stroke)),
                                                        i = (p = this.textSpans[t].elem).length,
                                                        this.globalData.canvasContext.beginPath(),
                                                        r = 0;
                                                    r < i;
                                                    r += 1
                                                )
                                                    for (
                                                        s = (c = p[r]).length,
                                                            this.globalData.canvasContext.moveTo(c[0], c[1]),
                                                            n = 2;
                                                        n < s;
                                                        n += 6
                                                    )
                                                        this.globalData.canvasContext.bezierCurveTo(
                                                            c[n],
                                                            c[n + 1],
                                                            c[n + 2],
                                                            c[n + 3],
                                                            c[n + 4],
                                                            c[n + 5]
                                                        );
                                                this.globalData.canvasContext.closePath(),
                                                    this.globalData.canvasContext.stroke();
                                            }
                                            o && this.globalData.renderer.restore();
                                        }
                                }),
                                extendPrototype(
                                    [
                                        BaseElement,
                                        TransformElement,
                                        CVBaseElement,
                                        HierarchyElement,
                                        FrameElement,
                                        RenderableElement,
                                    ],
                                    CVImageElement
                                ),
                                (CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement),
                                (CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame),
                                (CVImageElement.prototype.createContent = function () {
                                    if (
                                        this.img.width &&
                                        (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)
                                    ) {
                                        var t = createTag("canvas");
                                        (t.width = this.assetData.w), (t.height = this.assetData.h);
                                        var e,
                                            r,
                                            i = t.getContext("2d"),
                                            n = this.img.width,
                                            s = this.img.height,
                                            a = n / s,
                                            o = this.assetData.w / this.assetData.h,
                                            l =
                                                this.assetData.pr ||
                                                this.globalData.renderConfig.imagePreserveAspectRatio;
                                        (a > o && "xMidYMid slice" === l) || (a < o && "xMidYMid slice" !== l)
                                            ? (e = (r = s) * o)
                                            : (r = (e = n) / o),
                                            i.drawImage(
                                                this.img,
                                                (n - e) / 2,
                                                (s - r) / 2,
                                                e,
                                                r,
                                                0,
                                                0,
                                                this.assetData.w,
                                                this.assetData.h
                                            ),
                                            (this.img = t);
                                    }
                                }),
                                (CVImageElement.prototype.renderInnerContent = function () {
                                    this.canvasContext.drawImage(this.img, 0, 0);
                                }),
                                (CVImageElement.prototype.destroy = function () {
                                    this.img = null;
                                }),
                                extendPrototype(
                                    [
                                        BaseElement,
                                        TransformElement,
                                        CVBaseElement,
                                        HierarchyElement,
                                        FrameElement,
                                        RenderableElement,
                                    ],
                                    CVSolidElement
                                ),
                                (CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement),
                                (CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame),
                                (CVSolidElement.prototype.renderInnerContent = function () {
                                    var t = this.canvasContext;
                                    (t.fillStyle = this.data.sc), t.fillRect(0, 0, this.data.sw, this.data.sh);
                                }),
                                extendPrototype([BaseRenderer], CanvasRendererBase),
                                (CanvasRendererBase.prototype.createShape = function (t) {
                                    return new CVShapeElement(t, this.globalData, this);
                                }),
                                (CanvasRendererBase.prototype.createText = function (t) {
                                    return new CVTextElement(t, this.globalData, this);
                                }),
                                (CanvasRendererBase.prototype.createImage = function (t) {
                                    return new CVImageElement(t, this.globalData, this);
                                }),
                                (CanvasRendererBase.prototype.createSolid = function (t) {
                                    return new CVSolidElement(t, this.globalData, this);
                                }),
                                (CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull),
                                (CanvasRendererBase.prototype.ctxTransform = function (t) {
                                    if (
                                        1 !== t[0] ||
                                        0 !== t[1] ||
                                        0 !== t[4] ||
                                        1 !== t[5] ||
                                        0 !== t[12] ||
                                        0 !== t[13]
                                    )
                                        if (this.renderConfig.clearCanvas) {
                                            this.transformMat.cloneFromProps(t);
                                            var e = this.contextData.cTr.props;
                                            this.transformMat.transform(
                                                e[0],
                                                e[1],
                                                e[2],
                                                e[3],
                                                e[4],
                                                e[5],
                                                e[6],
                                                e[7],
                                                e[8],
                                                e[9],
                                                e[10],
                                                e[11],
                                                e[12],
                                                e[13],
                                                e[14],
                                                e[15]
                                            ),
                                                this.contextData.cTr.cloneFromProps(this.transformMat.props);
                                            var r = this.contextData.cTr.props;
                                            this.canvasContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]);
                                        } else this.canvasContext.transform(t[0], t[1], t[4], t[5], t[12], t[13]);
                                }),
                                (CanvasRendererBase.prototype.ctxOpacity = function (t) {
                                    if (!this.renderConfig.clearCanvas)
                                        return (
                                            (this.canvasContext.globalAlpha *= t < 0 ? 0 : t),
                                            void (this.globalData.currentGlobalAlpha = this.contextData.cO)
                                        );
                                    (this.contextData.cO *= t < 0 ? 0 : t),
                                        this.globalData.currentGlobalAlpha !== this.contextData.cO &&
                                            ((this.canvasContext.globalAlpha = this.contextData.cO),
                                            (this.globalData.currentGlobalAlpha = this.contextData.cO));
                                }),
                                (CanvasRendererBase.prototype.reset = function () {
                                    this.renderConfig.clearCanvas
                                        ? this.contextData.reset()
                                        : this.canvasContext.restore();
                                }),
                                (CanvasRendererBase.prototype.save = function (t) {
                                    if (this.renderConfig.clearCanvas) {
                                        t && this.canvasContext.save();
                                        var e,
                                            r = this.contextData.cTr.props;
                                        this.contextData._length <= this.contextData.cArrPos &&
                                            this.contextData.duplicate();
                                        var i = this.contextData.saved[this.contextData.cArrPos];
                                        for (e = 0; e < 16; e += 1) i[e] = r[e];
                                        (this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO),
                                            (this.contextData.cArrPos += 1);
                                    } else this.canvasContext.save();
                                }),
                                (CanvasRendererBase.prototype.restore = function (t) {
                                    if (this.renderConfig.clearCanvas) {
                                        t &&
                                            (this.canvasContext.restore(), (this.globalData.blendMode = "source-over")),
                                            (this.contextData.cArrPos -= 1);
                                        var e,
                                            r = this.contextData.saved[this.contextData.cArrPos],
                                            i = this.contextData.cTr.props;
                                        for (e = 0; e < 16; e += 1) i[e] = r[e];
                                        this.canvasContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]),
                                            (r = this.contextData.savedOp[this.contextData.cArrPos]),
                                            (this.contextData.cO = r),
                                            this.globalData.currentGlobalAlpha !== r &&
                                                ((this.canvasContext.globalAlpha = r),
                                                (this.globalData.currentGlobalAlpha = r));
                                    } else this.canvasContext.restore();
                                }),
                                (CanvasRendererBase.prototype.configAnimation = function (t) {
                                    if (this.animationItem.wrapper) {
                                        this.animationItem.container = createTag("canvas");
                                        var e = this.animationItem.container.style;
                                        (e.width = "100%"), (e.height = "100%");
                                        var r = "0px 0px 0px";
                                        (e.transformOrigin = r),
                                            (e.mozTransformOrigin = r),
                                            (e.webkitTransformOrigin = r),
                                            (e["-webkit-transform"] = r),
                                            (e.contentVisibility = this.renderConfig.contentVisibility),
                                            this.animationItem.wrapper.appendChild(this.animationItem.container),
                                            (this.canvasContext = this.animationItem.container.getContext("2d")),
                                            this.renderConfig.className &&
                                                this.animationItem.container.setAttribute(
                                                    "class",
                                                    this.renderConfig.className
                                                ),
                                            this.renderConfig.id &&
                                                this.animationItem.container.setAttribute("id", this.renderConfig.id);
                                    } else this.canvasContext = this.renderConfig.context;
                                    (this.data = t),
                                        (this.layers = t.layers),
                                        (this.transformCanvas = { w: t.w, h: t.h, sx: 0, sy: 0, tx: 0, ty: 0 }),
                                        this.setupGlobalData(t, document.body),
                                        (this.globalData.canvasContext = this.canvasContext),
                                        (this.globalData.renderer = this),
                                        (this.globalData.isDashed = !1),
                                        (this.globalData.progressiveLoad = this.renderConfig.progressiveLoad),
                                        (this.globalData.transformCanvas = this.transformCanvas),
                                        (this.elements = createSizedArray(t.layers.length)),
                                        this.updateContainerSize();
                                }),
                                (CanvasRendererBase.prototype.updateContainerSize = function (t, e) {
                                    var r, i, n, s;
                                    if (
                                        (this.reset(),
                                        t
                                            ? ((r = t),
                                              (i = e),
                                              (this.canvasContext.canvas.width = r),
                                              (this.canvasContext.canvas.height = i))
                                            : (this.animationItem.wrapper && this.animationItem.container
                                                  ? ((r = this.animationItem.wrapper.offsetWidth),
                                                    (i = this.animationItem.wrapper.offsetHeight))
                                                  : ((r = this.canvasContext.canvas.width),
                                                    (i = this.canvasContext.canvas.height)),
                                              (this.canvasContext.canvas.width = r * this.renderConfig.dpr),
                                              (this.canvasContext.canvas.height = i * this.renderConfig.dpr)),
                                        -1 !== this.renderConfig.preserveAspectRatio.indexOf("meet") ||
                                            -1 !== this.renderConfig.preserveAspectRatio.indexOf("slice"))
                                    ) {
                                        var a = this.renderConfig.preserveAspectRatio.split(" "),
                                            o = a[1] || "meet",
                                            l = a[0] || "xMidYMid",
                                            h = l.substr(0, 4),
                                            p = l.substr(4);
                                        (n = r / i),
                                            ((s = this.transformCanvas.w / this.transformCanvas.h) > n &&
                                                "meet" === o) ||
                                            (s < n && "slice" === o)
                                                ? ((this.transformCanvas.sx =
                                                      r / (this.transformCanvas.w / this.renderConfig.dpr)),
                                                  (this.transformCanvas.sy =
                                                      r / (this.transformCanvas.w / this.renderConfig.dpr)))
                                                : ((this.transformCanvas.sx =
                                                      i / (this.transformCanvas.h / this.renderConfig.dpr)),
                                                  (this.transformCanvas.sy =
                                                      i / (this.transformCanvas.h / this.renderConfig.dpr))),
                                            (this.transformCanvas.tx =
                                                "xMid" === h && ((s < n && "meet" === o) || (s > n && "slice" === o))
                                                    ? ((r - this.transformCanvas.w * (i / this.transformCanvas.h)) /
                                                          2) *
                                                      this.renderConfig.dpr
                                                    : "xMax" === h &&
                                                        ((s < n && "meet" === o) || (s > n && "slice" === o))
                                                      ? (r - this.transformCanvas.w * (i / this.transformCanvas.h)) *
                                                        this.renderConfig.dpr
                                                      : 0),
                                            (this.transformCanvas.ty =
                                                "YMid" === p && ((s > n && "meet" === o) || (s < n && "slice" === o))
                                                    ? ((i - this.transformCanvas.h * (r / this.transformCanvas.w)) /
                                                          2) *
                                                      this.renderConfig.dpr
                                                    : "YMax" === p &&
                                                        ((s > n && "meet" === o) || (s < n && "slice" === o))
                                                      ? (i - this.transformCanvas.h * (r / this.transformCanvas.w)) *
                                                        this.renderConfig.dpr
                                                      : 0);
                                    } else
                                        "none" === this.renderConfig.preserveAspectRatio
                                            ? ((this.transformCanvas.sx =
                                                  r / (this.transformCanvas.w / this.renderConfig.dpr)),
                                              (this.transformCanvas.sy =
                                                  i / (this.transformCanvas.h / this.renderConfig.dpr)),
                                              (this.transformCanvas.tx = 0),
                                              (this.transformCanvas.ty = 0))
                                            : ((this.transformCanvas.sx = this.renderConfig.dpr),
                                              (this.transformCanvas.sy = this.renderConfig.dpr),
                                              (this.transformCanvas.tx = 0),
                                              (this.transformCanvas.ty = 0));
                                    (this.transformCanvas.props = [
                                        this.transformCanvas.sx,
                                        0,
                                        0,
                                        0,
                                        0,
                                        this.transformCanvas.sy,
                                        0,
                                        0,
                                        0,
                                        0,
                                        1,
                                        0,
                                        this.transformCanvas.tx,
                                        this.transformCanvas.ty,
                                        0,
                                        1,
                                    ]),
                                        this.ctxTransform(this.transformCanvas.props),
                                        this.canvasContext.beginPath(),
                                        this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h),
                                        this.canvasContext.closePath(),
                                        this.canvasContext.clip(),
                                        this.renderFrame(this.renderedFrame, !0);
                                }),
                                (CanvasRendererBase.prototype.destroy = function () {
                                    var t;
                                    for (
                                        this.renderConfig.clearCanvas &&
                                            this.animationItem.wrapper &&
                                            (this.animationItem.wrapper.innerText = ""),
                                            t = (this.layers ? this.layers.length : 0) - 1;
                                        t >= 0;
                                        t -= 1
                                    )
                                        this.elements[t] && this.elements[t].destroy();
                                    (this.elements.length = 0),
                                        (this.globalData.canvasContext = null),
                                        (this.animationItem.container = null),
                                        (this.destroyed = !0);
                                }),
                                (CanvasRendererBase.prototype.renderFrame = function (t, e) {
                                    if (
                                        (this.renderedFrame !== t || !0 !== this.renderConfig.clearCanvas || e) &&
                                        !this.destroyed &&
                                        -1 !== t
                                    ) {
                                        var r;
                                        (this.renderedFrame = t),
                                            (this.globalData.frameNum = t - this.animationItem._isFirstFrame),
                                            (this.globalData.frameId += 1),
                                            (this.globalData._mdf = !this.renderConfig.clearCanvas || e),
                                            (this.globalData.projectInterface.currentFrame = t);
                                        var i = this.layers.length;
                                        for (this.completeLayers || this.checkLayers(t), r = 0; r < i; r += 1)
                                            (this.completeLayers || this.elements[r]) &&
                                                this.elements[r].prepareFrame(t - this.layers[r].st);
                                        if (this.globalData._mdf) {
                                            for (
                                                !0 === this.renderConfig.clearCanvas
                                                    ? this.canvasContext.clearRect(
                                                          0,
                                                          0,
                                                          this.transformCanvas.w,
                                                          this.transformCanvas.h
                                                      )
                                                    : this.save(),
                                                    r = i - 1;
                                                r >= 0;
                                                r -= 1
                                            )
                                                (this.completeLayers || this.elements[r]) &&
                                                    this.elements[r].renderFrame();
                                            !0 !== this.renderConfig.clearCanvas && this.restore();
                                        }
                                    }
                                }),
                                (CanvasRendererBase.prototype.buildItem = function (t) {
                                    var e = this.elements;
                                    if (!e[t] && 99 !== this.layers[t].ty) {
                                        var r = this.createItem(this.layers[t], this, this.globalData);
                                        (e[t] = r), r.initExpressions();
                                    }
                                }),
                                (CanvasRendererBase.prototype.checkPendingElements = function () {
                                    for (; this.pendingElements.length; ) this.pendingElements.pop().checkParenting();
                                }),
                                (CanvasRendererBase.prototype.hide = function () {
                                    this.animationItem.container.style.display = "none";
                                }),
                                (CanvasRendererBase.prototype.show = function () {
                                    this.animationItem.container.style.display = "block";
                                }),
                                extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement),
                                (CVCompElement.prototype.renderInnerContent = function () {
                                    var t,
                                        e = this.canvasContext;
                                    for (
                                        e.beginPath(),
                                            e.moveTo(0, 0),
                                            e.lineTo(this.data.w, 0),
                                            e.lineTo(this.data.w, this.data.h),
                                            e.lineTo(0, this.data.h),
                                            e.lineTo(0, 0),
                                            e.clip(),
                                            t = this.layers.length - 1;
                                        t >= 0;
                                        t -= 1
                                    )
                                        (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
                                }),
                                (CVCompElement.prototype.destroy = function () {
                                    var t;
                                    for (t = this.layers.length - 1; t >= 0; t -= 1)
                                        this.elements[t] && this.elements[t].destroy();
                                    (this.layers = null), (this.elements = null);
                                }),
                                (CVCompElement.prototype.createComp = function (t) {
                                    return new CVCompElement(t, this.globalData, this);
                                }),
                                extendPrototype([CanvasRendererBase], CanvasRenderer),
                                (CanvasRenderer.prototype.createComp = function (t) {
                                    return new CVCompElement(t, this.globalData, this);
                                }),
                                (HBaseElement.prototype = {
                                    checkBlendMode: function () {},
                                    initRendererElement: function () {
                                        (this.baseElement = createTag(this.data.tg || "div")),
                                            this.data.hasMask
                                                ? ((this.svgElement = createNS("svg")),
                                                  (this.layerElement = createNS("g")),
                                                  (this.maskedElement = this.layerElement),
                                                  this.svgElement.appendChild(this.layerElement),
                                                  this.baseElement.appendChild(this.svgElement))
                                                : (this.layerElement = this.baseElement),
                                            styleDiv(this.baseElement);
                                    },
                                    createContainerElements: function () {
                                        (this.renderableEffectsManager = new CVEffects(this)),
                                            (this.transformedElement = this.baseElement),
                                            (this.maskedElement = this.layerElement),
                                            this.data.ln && this.layerElement.setAttribute("id", this.data.ln),
                                            this.data.cl && this.layerElement.setAttribute("class", this.data.cl),
                                            0 !== this.data.bm && this.setBlendMode();
                                    },
                                    renderElement: function () {
                                        var t = this.transformedElement ? this.transformedElement.style : {};
                                        if (this.finalTransform._matMdf) {
                                            var e = this.finalTransform.mat.toCSS();
                                            (t.transform = e), (t.webkitTransform = e);
                                        }
                                        this.finalTransform._opMdf && (t.opacity = this.finalTransform.mProp.o.v);
                                    },
                                    renderFrame: function () {
                                        this.data.hd ||
                                            this.hidden ||
                                            (this.renderTransform(),
                                            this.renderRenderable(),
                                            this.renderElement(),
                                            this.renderInnerContent(),
                                            this._isFirstFrame && (this._isFirstFrame = !1));
                                    },
                                    destroy: function () {
                                        (this.layerElement = null),
                                            (this.transformedElement = null),
                                            this.matteElement && (this.matteElement = null),
                                            this.maskManager && (this.maskManager.destroy(), (this.maskManager = null));
                                    },
                                    createRenderableComponents: function () {
                                        this.maskManager = new MaskElement(this.data, this, this.globalData);
                                    },
                                    addEffects: function () {},
                                    setMatte: function () {},
                                }),
                                (HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement),
                                (HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy),
                                (HBaseElement.prototype.buildElementParenting =
                                    BaseRenderer.prototype.buildElementParenting),
                                extendPrototype(
                                    [
                                        BaseElement,
                                        TransformElement,
                                        HBaseElement,
                                        HierarchyElement,
                                        FrameElement,
                                        RenderableDOMElement,
                                    ],
                                    HSolidElement
                                ),
                                (HSolidElement.prototype.createContent = function () {
                                    var t;
                                    this.data.hasMask
                                        ? ((t = createNS("rect")).setAttribute("width", this.data.sw),
                                          t.setAttribute("height", this.data.sh),
                                          t.setAttribute("fill", this.data.sc),
                                          this.svgElement.setAttribute("width", this.data.sw),
                                          this.svgElement.setAttribute("height", this.data.sh))
                                        : (((t = createTag("div")).style.width = this.data.sw + "px"),
                                          (t.style.height = this.data.sh + "px"),
                                          (t.style.backgroundColor = this.data.sc)),
                                        this.layerElement.appendChild(t);
                                }),
                                extendPrototype(
                                    [
                                        BaseElement,
                                        TransformElement,
                                        HSolidElement,
                                        SVGShapeElement,
                                        HBaseElement,
                                        HierarchyElement,
                                        FrameElement,
                                        RenderableElement,
                                    ],
                                    HShapeElement
                                ),
                                (HShapeElement.prototype._renderShapeFrame =
                                    HShapeElement.prototype.renderInnerContent),
                                (HShapeElement.prototype.createContent = function () {
                                    var t;
                                    if (((this.baseElement.style.fontSize = 0), this.data.hasMask))
                                        this.layerElement.appendChild(this.shapesContainer), (t = this.svgElement);
                                    else {
                                        t = createNS("svg");
                                        var e = this.comp.data ? this.comp.data : this.globalData.compSize;
                                        t.setAttribute("width", e.w),
                                            t.setAttribute("height", e.h),
                                            t.appendChild(this.shapesContainer),
                                            this.layerElement.appendChild(t);
                                    }
                                    this.searchShapes(
                                        this.shapesData,
                                        this.itemsData,
                                        this.prevViewData,
                                        this.shapesContainer,
                                        0,
                                        [],
                                        !0
                                    ),
                                        this.filterUniqueShapes(),
                                        (this.shapeCont = t);
                                }),
                                (HShapeElement.prototype.getTransformedPoint = function (t, e) {
                                    var r,
                                        i = t.length;
                                    for (r = 0; r < i; r += 1) e = t[r].mProps.v.applyToPointArray(e[0], e[1], 0);
                                    return e;
                                }),
                                (HShapeElement.prototype.calculateShapeBoundingBox = function (t, e) {
                                    var r,
                                        i,
                                        n,
                                        s,
                                        a,
                                        o = t.sh.v,
                                        l = t.transformers,
                                        h = o._length;
                                    if (!(h <= 1)) {
                                        for (r = 0; r < h - 1; r += 1)
                                            (i = this.getTransformedPoint(l, o.v[r])),
                                                (n = this.getTransformedPoint(l, o.o[r])),
                                                (s = this.getTransformedPoint(l, o.i[r + 1])),
                                                (a = this.getTransformedPoint(l, o.v[r + 1])),
                                                this.checkBounds(i, n, s, a, e);
                                        o.c &&
                                            ((i = this.getTransformedPoint(l, o.v[r])),
                                            (n = this.getTransformedPoint(l, o.o[r])),
                                            (s = this.getTransformedPoint(l, o.i[0])),
                                            (a = this.getTransformedPoint(l, o.v[0])),
                                            this.checkBounds(i, n, s, a, e));
                                    }
                                }),
                                (HShapeElement.prototype.checkBounds = function (t, e, r, i, n) {
                                    this.getBoundsOfCurve(t, e, r, i);
                                    var s = this.shapeBoundingBox;
                                    (n.x = bmMin(s.left, n.x)),
                                        (n.xMax = bmMax(s.right, n.xMax)),
                                        (n.y = bmMin(s.top, n.y)),
                                        (n.yMax = bmMax(s.bottom, n.yMax));
                                }),
                                (HShapeElement.prototype.shapeBoundingBox = { left: 0, right: 0, top: 0, bottom: 0 }),
                                (HShapeElement.prototype.tempBoundingBox = {
                                    x: 0,
                                    xMax: 0,
                                    y: 0,
                                    yMax: 0,
                                    width: 0,
                                    height: 0,
                                }),
                                (HShapeElement.prototype.getBoundsOfCurve = function (t, e, r, i) {
                                    for (
                                        var n,
                                            s,
                                            a,
                                            o,
                                            l,
                                            h,
                                            p,
                                            c = [
                                                [t[0], i[0]],
                                                [t[1], i[1]],
                                            ],
                                            d = 0;
                                        d < 2;
                                        ++d
                                    )
                                        (s = 6 * t[d] - 12 * e[d] + 6 * r[d]),
                                            (n = -3 * t[d] + 9 * e[d] - 9 * r[d] + 3 * i[d]),
                                            (a = 3 * e[d] - 3 * t[d]),
                                            (s |= 0),
                                            (a |= 0),
                                            (0 == (n |= 0) && 0 === s) ||
                                                (0 === n
                                                    ? (o = -a / s) > 0 &&
                                                      o < 1 &&
                                                      c[d].push(this.calculateF(o, t, e, r, i, d))
                                                    : (l = s * s - 4 * a * n) >= 0 &&
                                                      ((h = (-s + bmSqrt(l)) / (2 * n)) > 0 &&
                                                          h < 1 &&
                                                          c[d].push(this.calculateF(h, t, e, r, i, d)),
                                                      (p = (-s - bmSqrt(l)) / (2 * n)) > 0 &&
                                                          p < 1 &&
                                                          c[d].push(this.calculateF(p, t, e, r, i, d))));
                                    (this.shapeBoundingBox.left = bmMin.apply(null, c[0])),
                                        (this.shapeBoundingBox.top = bmMin.apply(null, c[1])),
                                        (this.shapeBoundingBox.right = bmMax.apply(null, c[0])),
                                        (this.shapeBoundingBox.bottom = bmMax.apply(null, c[1]));
                                }),
                                (HShapeElement.prototype.calculateF = function (t, e, r, i, n, s) {
                                    return (
                                        bmPow(1 - t, 3) * e[s] +
                                        3 * bmPow(1 - t, 2) * t * r[s] +
                                        3 * (1 - t) * bmPow(t, 2) * i[s] +
                                        bmPow(t, 3) * n[s]
                                    );
                                }),
                                (HShapeElement.prototype.calculateBoundingBox = function (t, e) {
                                    var r,
                                        i = t.length;
                                    for (r = 0; r < i; r += 1)
                                        t[r] && t[r].sh
                                            ? this.calculateShapeBoundingBox(t[r], e)
                                            : t[r] && t[r].it
                                              ? this.calculateBoundingBox(t[r].it, e)
                                              : t[r] && t[r].style && t[r].w && this.expandStrokeBoundingBox(t[r].w, e);
                                }),
                                (HShapeElement.prototype.expandStrokeBoundingBox = function (t, e) {
                                    var r = 0;
                                    if (t.keyframes) {
                                        for (var i = 0; i < t.keyframes.length; i += 1) {
                                            var n = t.keyframes[i].s;
                                            n > r && (r = n);
                                        }
                                        r *= t.mult;
                                    } else r = t.v * t.mult;
                                    (e.x -= r), (e.xMax += r), (e.y -= r), (e.yMax += r);
                                }),
                                (HShapeElement.prototype.currentBoxContains = function (t) {
                                    return (
                                        this.currentBBox.x <= t.x &&
                                        this.currentBBox.y <= t.y &&
                                        this.currentBBox.width + this.currentBBox.x >= t.x + t.width &&
                                        this.currentBBox.height + this.currentBBox.y >= t.y + t.height
                                    );
                                }),
                                (HShapeElement.prototype.renderInnerContent = function () {
                                    if ((this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf))) {
                                        var t = this.tempBoundingBox,
                                            e = 999999;
                                        if (
                                            ((t.x = e),
                                            (t.xMax = -e),
                                            (t.y = e),
                                            (t.yMax = -e),
                                            this.calculateBoundingBox(this.itemsData, t),
                                            (t.width = t.xMax < t.x ? 0 : t.xMax - t.x),
                                            (t.height = t.yMax < t.y ? 0 : t.yMax - t.y),
                                            this.currentBoxContains(t))
                                        )
                                            return;
                                        var r = !1;
                                        if (
                                            (this.currentBBox.w !== t.width &&
                                                ((this.currentBBox.w = t.width),
                                                this.shapeCont.setAttribute("width", t.width),
                                                (r = !0)),
                                            this.currentBBox.h !== t.height &&
                                                ((this.currentBBox.h = t.height),
                                                this.shapeCont.setAttribute("height", t.height),
                                                (r = !0)),
                                            r || this.currentBBox.x !== t.x || this.currentBBox.y !== t.y)
                                        ) {
                                            (this.currentBBox.w = t.width),
                                                (this.currentBBox.h = t.height),
                                                (this.currentBBox.x = t.x),
                                                (this.currentBBox.y = t.y),
                                                this.shapeCont.setAttribute(
                                                    "viewBox",
                                                    this.currentBBox.x +
                                                        " " +
                                                        this.currentBBox.y +
                                                        " " +
                                                        this.currentBBox.w +
                                                        " " +
                                                        this.currentBBox.h
                                                );
                                            var i = this.shapeCont.style,
                                                n =
                                                    "translate(" +
                                                    this.currentBBox.x +
                                                    "px," +
                                                    this.currentBBox.y +
                                                    "px)";
                                            (i.transform = n), (i.webkitTransform = n);
                                        }
                                    }
                                }),
                                extendPrototype(
                                    [
                                        BaseElement,
                                        TransformElement,
                                        HBaseElement,
                                        HierarchyElement,
                                        FrameElement,
                                        RenderableDOMElement,
                                        ITextElement,
                                    ],
                                    HTextElement
                                ),
                                (HTextElement.prototype.createContent = function () {
                                    if (((this.isMasked = this.checkMasks()), this.isMasked)) {
                                        (this.renderType = "svg"),
                                            (this.compW = this.comp.data.w),
                                            (this.compH = this.comp.data.h),
                                            this.svgElement.setAttribute("width", this.compW),
                                            this.svgElement.setAttribute("height", this.compH);
                                        var t = createNS("g");
                                        this.maskedElement.appendChild(t), (this.innerElem = t);
                                    } else (this.renderType = "html"), (this.innerElem = this.layerElement);
                                    this.checkParenting();
                                }),
                                (HTextElement.prototype.buildNewText = function () {
                                    var t = this.textProperty.currentData;
                                    this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
                                    var e = this.innerElem.style,
                                        r = t.fc ? this.buildColor(t.fc) : "rgba(0,0,0,0)";
                                    (e.fill = r),
                                        (e.color = r),
                                        t.sc && ((e.stroke = this.buildColor(t.sc)), (e.strokeWidth = t.sw + "px"));
                                    var i,
                                        n,
                                        s = this.globalData.fontManager.getFontByName(t.f);
                                    if (!this.globalData.fontManager.chars)
                                        if (
                                            ((e.fontSize = t.finalSize + "px"),
                                            (e.lineHeight = t.finalSize + "px"),
                                            s.fClass)
                                        )
                                            this.innerElem.className = s.fClass;
                                        else {
                                            e.fontFamily = s.fFamily;
                                            var a = t.fWeight,
                                                o = t.fStyle;
                                            (e.fontStyle = o), (e.fontWeight = a);
                                        }
                                    var l,
                                        h,
                                        p,
                                        c = t.l;
                                    n = c.length;
                                    var d,
                                        u = this.mHelper,
                                        f = "",
                                        m = 0;
                                    for (i = 0; i < n; i += 1) {
                                        if (
                                            (this.globalData.fontManager.chars
                                                ? (this.textPaths[m]
                                                      ? (l = this.textPaths[m])
                                                      : ((l = createNS("path")).setAttribute(
                                                            "stroke-linecap",
                                                            lineCapEnum[1]
                                                        ),
                                                        l.setAttribute("stroke-linejoin", lineJoinEnum[2]),
                                                        l.setAttribute("stroke-miterlimit", "4")),
                                                  this.isMasked ||
                                                      (this.textSpans[m]
                                                          ? (p = (h = this.textSpans[m]).children[0])
                                                          : (((h = createTag("div")).style.lineHeight = 0),
                                                            (p = createNS("svg")).appendChild(l),
                                                            styleDiv(h))))
                                                : this.isMasked
                                                  ? (l = this.textPaths[m] ? this.textPaths[m] : createNS("text"))
                                                  : this.textSpans[m]
                                                    ? ((h = this.textSpans[m]), (l = this.textPaths[m]))
                                                    : (styleDiv((h = createTag("span"))),
                                                      styleDiv((l = createTag("span"))),
                                                      h.appendChild(l)),
                                            this.globalData.fontManager.chars)
                                        ) {
                                            var g,
                                                y = this.globalData.fontManager.getCharData(
                                                    t.finalText[i],
                                                    s.fStyle,
                                                    this.globalData.fontManager.getFontByName(t.f).fFamily
                                                );
                                            if (
                                                ((g = y ? y.data : null),
                                                u.reset(),
                                                g &&
                                                    g.shapes &&
                                                    g.shapes.length &&
                                                    ((d = g.shapes[0].it),
                                                    u.scale(t.finalSize / 100, t.finalSize / 100),
                                                    (f = this.createPathShape(u, d)),
                                                    l.setAttribute("d", f)),
                                                this.isMasked)
                                            )
                                                this.innerElem.appendChild(l);
                                            else {
                                                if ((this.innerElem.appendChild(h), g && g.shapes)) {
                                                    document.body.appendChild(p);
                                                    var v = p.getBBox();
                                                    p.setAttribute("width", v.width + 2),
                                                        p.setAttribute("height", v.height + 2),
                                                        p.setAttribute(
                                                            "viewBox",
                                                            v.x -
                                                                1 +
                                                                " " +
                                                                (v.y - 1) +
                                                                " " +
                                                                (v.width + 2) +
                                                                " " +
                                                                (v.height + 2)
                                                        );
                                                    var b = p.style,
                                                        _ = "translate(" + (v.x - 1) + "px," + (v.y - 1) + "px)";
                                                    (b.transform = _),
                                                        (b.webkitTransform = _),
                                                        (c[i].yOffset = v.y - 1);
                                                } else p.setAttribute("width", 1), p.setAttribute("height", 1);
                                                h.appendChild(p);
                                            }
                                        } else if (
                                            ((l.textContent = c[i].val),
                                            l.setAttributeNS(
                                                "http://www.w3.org/XML/1998/namespace",
                                                "xml:space",
                                                "preserve"
                                            ),
                                            this.isMasked)
                                        )
                                            this.innerElem.appendChild(l);
                                        else {
                                            this.innerElem.appendChild(h);
                                            var x = l.style,
                                                S = "translate3d(0," + -t.finalSize / 1.2 + "px,0)";
                                            (x.transform = S), (x.webkitTransform = S);
                                        }
                                        this.isMasked ? (this.textSpans[m] = l) : (this.textSpans[m] = h),
                                            (this.textSpans[m].style.display = "block"),
                                            (this.textPaths[m] = l),
                                            (m += 1);
                                    }
                                    for (; m < this.textSpans.length; )
                                        (this.textSpans[m].style.display = "none"), (m += 1);
                                }),
                                (HTextElement.prototype.renderInnerContent = function () {
                                    var t;
                                    if (this.data.singleShape) {
                                        if (!this._isFirstFrame && !this.lettersChangedFlag) return;
                                        if (this.isMasked && this.finalTransform._matMdf) {
                                            this.svgElement.setAttribute(
                                                "viewBox",
                                                -this.finalTransform.mProp.p.v[0] +
                                                    " " +
                                                    -this.finalTransform.mProp.p.v[1] +
                                                    " " +
                                                    this.compW +
                                                    " " +
                                                    this.compH
                                            ),
                                                (t = this.svgElement.style);
                                            var e =
                                                "translate(" +
                                                -this.finalTransform.mProp.p.v[0] +
                                                "px," +
                                                -this.finalTransform.mProp.p.v[1] +
                                                "px)";
                                            (t.transform = e), (t.webkitTransform = e);
                                        }
                                    }
                                    if (
                                        (this.textAnimator.getMeasures(
                                            this.textProperty.currentData,
                                            this.lettersChangedFlag
                                        ),
                                        this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)
                                    ) {
                                        var r,
                                            i,
                                            n,
                                            s,
                                            a,
                                            o = 0,
                                            l = this.textAnimator.renderedLetters,
                                            h = this.textProperty.currentData.l;
                                        for (i = h.length, r = 0; r < i; r += 1)
                                            h[r].n
                                                ? (o += 1)
                                                : ((s = this.textSpans[r]),
                                                  (a = this.textPaths[r]),
                                                  (n = l[o]),
                                                  (o += 1),
                                                  n._mdf.m &&
                                                      (this.isMasked
                                                          ? s.setAttribute("transform", n.m)
                                                          : ((s.style.webkitTransform = n.m),
                                                            (s.style.transform = n.m))),
                                                  (s.style.opacity = n.o),
                                                  n.sw && n._mdf.sw && a.setAttribute("stroke-width", n.sw),
                                                  n.sc && n._mdf.sc && a.setAttribute("stroke", n.sc),
                                                  n.fc &&
                                                      n._mdf.fc &&
                                                      (a.setAttribute("fill", n.fc), (a.style.color = n.fc)));
                                        if (
                                            this.innerElem.getBBox &&
                                            !this.hidden &&
                                            (this._isFirstFrame || this._mdf)
                                        ) {
                                            var p = this.innerElem.getBBox();
                                            if (
                                                (this.currentBBox.w !== p.width &&
                                                    ((this.currentBBox.w = p.width),
                                                    this.svgElement.setAttribute("width", p.width)),
                                                this.currentBBox.h !== p.height &&
                                                    ((this.currentBBox.h = p.height),
                                                    this.svgElement.setAttribute("height", p.height)),
                                                this.currentBBox.w !== p.width + 2 ||
                                                    this.currentBBox.h !== p.height + 2 ||
                                                    this.currentBBox.x !== p.x - 1 ||
                                                    this.currentBBox.y !== p.y - 1)
                                            ) {
                                                (this.currentBBox.w = p.width + 2),
                                                    (this.currentBBox.h = p.height + 2),
                                                    (this.currentBBox.x = p.x - 1),
                                                    (this.currentBBox.y = p.y - 1),
                                                    this.svgElement.setAttribute(
                                                        "viewBox",
                                                        this.currentBBox.x +
                                                            " " +
                                                            this.currentBBox.y +
                                                            " " +
                                                            this.currentBBox.w +
                                                            " " +
                                                            this.currentBBox.h
                                                    ),
                                                    (t = this.svgElement.style);
                                                var c =
                                                    "translate(" +
                                                    this.currentBBox.x +
                                                    "px," +
                                                    this.currentBBox.y +
                                                    "px)";
                                                (t.transform = c), (t.webkitTransform = c);
                                            }
                                        }
                                    }
                                }),
                                extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement),
                                (HCameraElement.prototype.setup = function () {
                                    var t,
                                        e,
                                        r,
                                        i,
                                        n = this.comp.threeDElements.length;
                                    for (t = 0; t < n; t += 1)
                                        if ("3d" === (e = this.comp.threeDElements[t]).type) {
                                            (r = e.perspectiveElem.style), (i = e.container.style);
                                            var s = this.pe.v + "px",
                                                a = "0px 0px 0px",
                                                o = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                                            (r.perspective = s),
                                                (r.webkitPerspective = s),
                                                (i.transformOrigin = a),
                                                (i.mozTransformOrigin = a),
                                                (i.webkitTransformOrigin = a),
                                                (r.transform = o),
                                                (r.webkitTransform = o);
                                        }
                                }),
                                (HCameraElement.prototype.createElements = function () {}),
                                (HCameraElement.prototype.hide = function () {}),
                                (HCameraElement.prototype.renderFrame = function () {
                                    var t,
                                        e,
                                        r = this._isFirstFrame;
                                    if (this.hierarchy)
                                        for (e = this.hierarchy.length, t = 0; t < e; t += 1)
                                            r = this.hierarchy[t].finalTransform.mProp._mdf || r;
                                    if (
                                        r ||
                                        this.pe._mdf ||
                                        (this.p && this.p._mdf) ||
                                        (this.px && (this.px._mdf || this.py._mdf || this.pz._mdf)) ||
                                        this.rx._mdf ||
                                        this.ry._mdf ||
                                        this.rz._mdf ||
                                        this.or._mdf ||
                                        (this.a && this.a._mdf)
                                    ) {
                                        if ((this.mat.reset(), this.hierarchy))
                                            for (t = e = this.hierarchy.length - 1; t >= 0; t -= 1) {
                                                var i = this.hierarchy[t].finalTransform.mProp;
                                                this.mat.translate(-i.p.v[0], -i.p.v[1], i.p.v[2]),
                                                    this.mat.rotateX(-i.or.v[0]).rotateY(-i.or.v[1]).rotateZ(i.or.v[2]),
                                                    this.mat.rotateX(-i.rx.v).rotateY(-i.ry.v).rotateZ(i.rz.v),
                                                    this.mat.scale(1 / i.s.v[0], 1 / i.s.v[1], 1 / i.s.v[2]),
                                                    this.mat.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
                                            }
                                        if (
                                            (this.p
                                                ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2])
                                                : this.mat.translate(-this.px.v, -this.py.v, this.pz.v),
                                            this.a)
                                        ) {
                                            var n;
                                            n = this.p
                                                ? [
                                                      this.p.v[0] - this.a.v[0],
                                                      this.p.v[1] - this.a.v[1],
                                                      this.p.v[2] - this.a.v[2],
                                                  ]
                                                : [
                                                      this.px.v - this.a.v[0],
                                                      this.py.v - this.a.v[1],
                                                      this.pz.v - this.a.v[2],
                                                  ];
                                            var s = Math.sqrt(
                                                    Math.pow(n[0], 2) + Math.pow(n[1], 2) + Math.pow(n[2], 2)
                                                ),
                                                a = [n[0] / s, n[1] / s, n[2] / s],
                                                o = Math.sqrt(a[2] * a[2] + a[0] * a[0]),
                                                l = Math.atan2(a[1], o),
                                                h = Math.atan2(a[0], -a[2]);
                                            this.mat.rotateY(h).rotateX(-l);
                                        }
                                        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v),
                                            this.mat
                                                .rotateX(-this.or.v[0])
                                                .rotateY(-this.or.v[1])
                                                .rotateZ(this.or.v[2]),
                                            this.mat.translate(
                                                this.globalData.compSize.w / 2,
                                                this.globalData.compSize.h / 2,
                                                0
                                            ),
                                            this.mat.translate(0, 0, this.pe.v);
                                        var p = !this._prevMat.equals(this.mat);
                                        if ((p || this.pe._mdf) && this.comp.threeDElements) {
                                            var c, d, u;
                                            for (e = this.comp.threeDElements.length, t = 0; t < e; t += 1)
                                                if ("3d" === (c = this.comp.threeDElements[t]).type) {
                                                    if (p) {
                                                        var f = this.mat.toCSS();
                                                        ((u = c.container.style).transform = f),
                                                            (u.webkitTransform = f);
                                                    }
                                                    this.pe._mdf &&
                                                        (((d = c.perspectiveElem.style).perspective = this.pe.v + "px"),
                                                        (d.webkitPerspective = this.pe.v + "px"));
                                                }
                                            this.mat.clone(this._prevMat);
                                        }
                                    }
                                    this._isFirstFrame = !1;
                                }),
                                (HCameraElement.prototype.prepareFrame = function (t) {
                                    this.prepareProperties(t, !0);
                                }),
                                (HCameraElement.prototype.destroy = function () {}),
                                (HCameraElement.prototype.getBaseElement = function () {
                                    return null;
                                }),
                                extendPrototype(
                                    [
                                        BaseElement,
                                        TransformElement,
                                        HBaseElement,
                                        HSolidElement,
                                        HierarchyElement,
                                        FrameElement,
                                        RenderableElement,
                                    ],
                                    HImageElement
                                ),
                                (HImageElement.prototype.createContent = function () {
                                    var t = this.globalData.getAssetsPath(this.assetData),
                                        e = new Image();
                                    this.data.hasMask
                                        ? ((this.imageElem = createNS("image")),
                                          this.imageElem.setAttribute("width", this.assetData.w + "px"),
                                          this.imageElem.setAttribute("height", this.assetData.h + "px"),
                                          this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t),
                                          this.layerElement.appendChild(this.imageElem),
                                          this.baseElement.setAttribute("width", this.assetData.w),
                                          this.baseElement.setAttribute("height", this.assetData.h))
                                        : this.layerElement.appendChild(e),
                                        (e.crossOrigin = "anonymous"),
                                        (e.src = t),
                                        this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
                                }),
                                extendPrototype([BaseRenderer], HybridRendererBase),
                                (HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem),
                                (HybridRendererBase.prototype.checkPendingElements = function () {
                                    for (; this.pendingElements.length; ) this.pendingElements.pop().checkParenting();
                                }),
                                (HybridRendererBase.prototype.appendElementInPos = function (t, e) {
                                    var r = t.getBaseElement();
                                    if (r) {
                                        var i = this.layers[e];
                                        if (i.ddd && this.supports3d) this.addTo3dContainer(r, e);
                                        else if (this.threeDElements) this.addTo3dContainer(r, e);
                                        else {
                                            for (var n, s, a = 0; a < e; )
                                                this.elements[a] &&
                                                    !0 !== this.elements[a] &&
                                                    this.elements[a].getBaseElement &&
                                                    ((s = this.elements[a]),
                                                    (n =
                                                        (this.layers[a].ddd
                                                            ? this.getThreeDContainerByPos(a)
                                                            : s.getBaseElement()) || n)),
                                                    (a += 1);
                                            n
                                                ? (i.ddd && this.supports3d) || this.layerElement.insertBefore(r, n)
                                                : (i.ddd && this.supports3d) || this.layerElement.appendChild(r);
                                        }
                                    }
                                }),
                                (HybridRendererBase.prototype.createShape = function (t) {
                                    return this.supports3d
                                        ? new HShapeElement(t, this.globalData, this)
                                        : new SVGShapeElement(t, this.globalData, this);
                                }),
                                (HybridRendererBase.prototype.createText = function (t) {
                                    return this.supports3d
                                        ? new HTextElement(t, this.globalData, this)
                                        : new SVGTextLottieElement(t, this.globalData, this);
                                }),
                                (HybridRendererBase.prototype.createCamera = function (t) {
                                    return (this.camera = new HCameraElement(t, this.globalData, this)), this.camera;
                                }),
                                (HybridRendererBase.prototype.createImage = function (t) {
                                    return this.supports3d
                                        ? new HImageElement(t, this.globalData, this)
                                        : new IImageElement(t, this.globalData, this);
                                }),
                                (HybridRendererBase.prototype.createSolid = function (t) {
                                    return this.supports3d
                                        ? new HSolidElement(t, this.globalData, this)
                                        : new ISolidElement(t, this.globalData, this);
                                }),
                                (HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull),
                                (HybridRendererBase.prototype.getThreeDContainerByPos = function (t) {
                                    for (var e = 0, r = this.threeDElements.length; e < r; ) {
                                        if (this.threeDElements[e].startPos <= t && this.threeDElements[e].endPos >= t)
                                            return this.threeDElements[e].perspectiveElem;
                                        e += 1;
                                    }
                                    return null;
                                }),
                                (HybridRendererBase.prototype.createThreeDContainer = function (t, e) {
                                    var r,
                                        i,
                                        n = createTag("div");
                                    styleDiv(n);
                                    var s = createTag("div");
                                    if ((styleDiv(s), "3d" === e)) {
                                        ((r = n.style).width = this.globalData.compSize.w + "px"),
                                            (r.height = this.globalData.compSize.h + "px");
                                        var a = "50% 50%";
                                        (r.webkitTransformOrigin = a),
                                            (r.mozTransformOrigin = a),
                                            (r.transformOrigin = a);
                                        var o = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                                        ((i = s.style).transform = o), (i.webkitTransform = o);
                                    }
                                    n.appendChild(s);
                                    var l = { container: s, perspectiveElem: n, startPos: t, endPos: t, type: e };
                                    return this.threeDElements.push(l), l;
                                }),
                                (HybridRendererBase.prototype.build3dContainers = function () {
                                    var t,
                                        e,
                                        r = this.layers.length,
                                        i = "";
                                    for (t = 0; t < r; t += 1)
                                        this.layers[t].ddd && 3 !== this.layers[t].ty
                                            ? ("3d" !== i && ((i = "3d"), (e = this.createThreeDContainer(t, "3d"))),
                                              (e.endPos = Math.max(e.endPos, t)))
                                            : ("2d" !== i && ((i = "2d"), (e = this.createThreeDContainer(t, "2d"))),
                                              (e.endPos = Math.max(e.endPos, t)));
                                    for (t = (r = this.threeDElements.length) - 1; t >= 0; t -= 1)
                                        this.resizerElem.appendChild(this.threeDElements[t].perspectiveElem);
                                }),
                                (HybridRendererBase.prototype.addTo3dContainer = function (t, e) {
                                    for (var r = 0, i = this.threeDElements.length; r < i; ) {
                                        if (e <= this.threeDElements[r].endPos) {
                                            for (var n, s = this.threeDElements[r].startPos; s < e; )
                                                this.elements[s] &&
                                                    this.elements[s].getBaseElement &&
                                                    (n = this.elements[s].getBaseElement()),
                                                    (s += 1);
                                            n
                                                ? this.threeDElements[r].container.insertBefore(t, n)
                                                : this.threeDElements[r].container.appendChild(t);
                                            break;
                                        }
                                        r += 1;
                                    }
                                }),
                                (HybridRendererBase.prototype.configAnimation = function (t) {
                                    var e = createTag("div"),
                                        r = this.animationItem.wrapper,
                                        i = e.style;
                                    (i.width = t.w + "px"),
                                        (i.height = t.h + "px"),
                                        (this.resizerElem = e),
                                        styleDiv(e),
                                        (i.transformStyle = "flat"),
                                        (i.mozTransformStyle = "flat"),
                                        (i.webkitTransformStyle = "flat"),
                                        this.renderConfig.className &&
                                            e.setAttribute("class", this.renderConfig.className),
                                        r.appendChild(e),
                                        (i.overflow = "hidden");
                                    var n = createNS("svg");
                                    n.setAttribute("width", "1"),
                                        n.setAttribute("height", "1"),
                                        styleDiv(n),
                                        this.resizerElem.appendChild(n);
                                    var s = createNS("defs");
                                    n.appendChild(s),
                                        (this.data = t),
                                        this.setupGlobalData(t, n),
                                        (this.globalData.defs = s),
                                        (this.layers = t.layers),
                                        (this.layerElement = this.resizerElem),
                                        this.build3dContainers(),
                                        this.updateContainerSize();
                                }),
                                (HybridRendererBase.prototype.destroy = function () {
                                    var t;
                                    this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""),
                                        (this.animationItem.container = null),
                                        (this.globalData.defs = null);
                                    var e = this.layers ? this.layers.length : 0;
                                    for (t = 0; t < e; t += 1) this.elements[t].destroy();
                                    (this.elements.length = 0), (this.destroyed = !0), (this.animationItem = null);
                                }),
                                (HybridRendererBase.prototype.updateContainerSize = function () {
                                    var t,
                                        e,
                                        r,
                                        i,
                                        n = this.animationItem.wrapper.offsetWidth,
                                        s = this.animationItem.wrapper.offsetHeight,
                                        a = n / s;
                                    this.globalData.compSize.w / this.globalData.compSize.h > a
                                        ? ((t = n / this.globalData.compSize.w),
                                          (e = n / this.globalData.compSize.w),
                                          (r = 0),
                                          (i = (s - this.globalData.compSize.h * (n / this.globalData.compSize.w)) / 2))
                                        : ((t = s / this.globalData.compSize.h),
                                          (e = s / this.globalData.compSize.h),
                                          (r = (n - this.globalData.compSize.w * (s / this.globalData.compSize.h)) / 2),
                                          (i = 0));
                                    var o = this.resizerElem.style;
                                    (o.webkitTransform =
                                        "matrix3d(" + t + ",0,0,0,0," + e + ",0,0,0,0,1,0," + r + "," + i + ",0,1)"),
                                        (o.transform = o.webkitTransform);
                                }),
                                (HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame),
                                (HybridRendererBase.prototype.hide = function () {
                                    this.resizerElem.style.display = "none";
                                }),
                                (HybridRendererBase.prototype.show = function () {
                                    this.resizerElem.style.display = "block";
                                }),
                                (HybridRendererBase.prototype.initItems = function () {
                                    if ((this.buildAllItems(), this.camera)) this.camera.setup();
                                    else {
                                        var t,
                                            e = this.globalData.compSize.w,
                                            r = this.globalData.compSize.h,
                                            i = this.threeDElements.length;
                                        for (t = 0; t < i; t += 1) {
                                            var n = this.threeDElements[t].perspectiveElem.style;
                                            (n.webkitPerspective = Math.sqrt(Math.pow(e, 2) + Math.pow(r, 2)) + "px"),
                                                (n.perspective = n.webkitPerspective);
                                        }
                                    }
                                }),
                                (HybridRendererBase.prototype.searchExtraCompositions = function (t) {
                                    var e,
                                        r = t.length,
                                        i = createTag("div");
                                    for (e = 0; e < r; e += 1)
                                        if (t[e].xt) {
                                            var n = this.createComp(t[e], i, this.globalData.comp, null);
                                            n.initExpressions(),
                                                this.globalData.projectInterface.registerComposition(n);
                                        }
                                }),
                                extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement),
                                (HCompElement.prototype._createBaseContainerElements =
                                    HCompElement.prototype.createContainerElements),
                                (HCompElement.prototype.createContainerElements = function () {
                                    this._createBaseContainerElements(),
                                        this.data.hasMask
                                            ? (this.svgElement.setAttribute("width", this.data.w),
                                              this.svgElement.setAttribute("height", this.data.h),
                                              (this.transformedElement = this.baseElement))
                                            : (this.transformedElement = this.layerElement);
                                }),
                                (HCompElement.prototype.addTo3dContainer = function (t, e) {
                                    for (var r, i = 0; i < e; )
                                        this.elements[i] &&
                                            this.elements[i].getBaseElement &&
                                            (r = this.elements[i].getBaseElement()),
                                            (i += 1);
                                    r ? this.layerElement.insertBefore(t, r) : this.layerElement.appendChild(t);
                                }),
                                (HCompElement.prototype.createComp = function (t) {
                                    return this.supports3d
                                        ? new HCompElement(t, this.globalData, this)
                                        : new SVGCompElement(t, this.globalData, this);
                                }),
                                extendPrototype([HybridRendererBase], HybridRenderer),
                                (HybridRenderer.prototype.createComp = function (t) {
                                    return this.supports3d
                                        ? new HCompElement(t, this.globalData, this)
                                        : new SVGCompElement(t, this.globalData, this);
                                });
                            var CompExpressionInterface = function (t) {
                                    function e(e) {
                                        for (var r = 0, i = t.layers.length; r < i; ) {
                                            if (t.layers[r].nm === e || t.layers[r].ind === e)
                                                return t.elements[r].layerInterface;
                                            r += 1;
                                        }
                                        return null;
                                    }
                                    return (
                                        Object.defineProperty(e, "_name", { value: t.data.nm }),
                                        (e.layer = e),
                                        (e.pixelAspect = 1),
                                        (e.height = t.data.h || t.globalData.compSize.h),
                                        (e.width = t.data.w || t.globalData.compSize.w),
                                        (e.pixelAspect = 1),
                                        (e.frameDuration = 1 / t.globalData.frameRate),
                                        (e.displayStartTime = 0),
                                        (e.numLayers = t.layers.length),
                                        e
                                    );
                                },
                                Expressions = {
                                    initExpressions: function (t) {
                                        var e = 0,
                                            r = [];
                                        (t.renderer.compInterface = CompExpressionInterface(t.renderer)),
                                            t.renderer.globalData.projectInterface.registerComposition(t.renderer),
                                            (t.renderer.globalData.pushExpression = function () {
                                                e += 1;
                                            }),
                                            (t.renderer.globalData.popExpression = function () {
                                                0 == (e -= 1) &&
                                                    (function () {
                                                        var t,
                                                            e = r.length;
                                                        for (t = 0; t < e; t += 1) r[t].release();
                                                        r.length = 0;
                                                    })();
                                            }),
                                            (t.renderer.globalData.registerExpressionProperty = function (t) {
                                                -1 === r.indexOf(t) && r.push(t);
                                            });
                                    },
                                },
                                MaskManagerInterface = (function () {
                                    function t(t, e) {
                                        (this._mask = t), (this._data = e);
                                    }
                                    return (
                                        Object.defineProperty(t.prototype, "maskPath", {
                                            get: function () {
                                                return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
                                            },
                                        }),
                                        Object.defineProperty(t.prototype, "maskOpacity", {
                                            get: function () {
                                                return (
                                                    this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v
                                                );
                                            },
                                        }),
                                        function (e) {
                                            var r,
                                                i = createSizedArray(e.viewData.length),
                                                n = e.viewData.length;
                                            for (r = 0; r < n; r += 1)
                                                i[r] = new t(e.viewData[r], e.masksProperties[r]);
                                            return function (t) {
                                                for (r = 0; r < n; ) {
                                                    if (e.masksProperties[r].nm === t) return i[r];
                                                    r += 1;
                                                }
                                                return null;
                                            };
                                        }
                                    );
                                })(),
                                ExpressionPropertyInterface = (function () {
                                    var t = { pv: 0, v: 0, mult: 1 },
                                        e = { pv: [0, 0, 0], v: [0, 0, 0], mult: 1 };
                                    function r(t, e, r) {
                                        Object.defineProperty(t, "velocity", {
                                            get: function () {
                                                return e.getVelocityAtTime(e.comp.currentFrame);
                                            },
                                        }),
                                            (t.numKeys = e.keyframes ? e.keyframes.length : 0),
                                            (t.key = function (i) {
                                                if (!t.numKeys) return 0;
                                                var n;
                                                n =
                                                    "s" in e.keyframes[i - 1]
                                                        ? e.keyframes[i - 1].s
                                                        : "e" in e.keyframes[i - 2]
                                                          ? e.keyframes[i - 2].e
                                                          : e.keyframes[i - 2].s;
                                                var s = "unidimensional" === r ? new Number(n) : Object.assign({}, n);
                                                return (
                                                    (s.time = e.keyframes[i - 1].t / e.elem.comp.globalData.frameRate),
                                                    (s.value = "unidimensional" === r ? n[0] : n),
                                                    s
                                                );
                                            }),
                                            (t.valueAtTime = e.getValueAtTime),
                                            (t.speedAtTime = e.getSpeedAtTime),
                                            (t.velocityAtTime = e.getVelocityAtTime),
                                            (t.propertyGroup = e.propertyGroup);
                                    }
                                    function i() {
                                        return t;
                                    }
                                    return function (n) {
                                        return n
                                            ? "unidimensional" === n.propType
                                                ? (function (e) {
                                                      (e && "pv" in e) || (e = t);
                                                      var i = 1 / e.mult,
                                                          n = e.pv * i,
                                                          s = new Number(n);
                                                      return (
                                                          (s.value = n),
                                                          r(s, e, "unidimensional"),
                                                          function () {
                                                              return (
                                                                  e.k && e.getValue(),
                                                                  (n = e.v * i),
                                                                  s.value !== n &&
                                                                      (((s = new Number(n)).value = n),
                                                                      r(s, e, "unidimensional")),
                                                                  s
                                                              );
                                                          }
                                                      );
                                                  })(n)
                                                : (function (t) {
                                                      (t && "pv" in t) || (t = e);
                                                      var i = 1 / t.mult,
                                                          n = (t.data && t.data.l) || t.pv.length,
                                                          s = createTypedArray("float32", n),
                                                          a = createTypedArray("float32", n);
                                                      return (
                                                          (s.value = a),
                                                          r(s, t, "multidimensional"),
                                                          function () {
                                                              t.k && t.getValue();
                                                              for (var e = 0; e < n; e += 1)
                                                                  (a[e] = t.v[e] * i), (s[e] = a[e]);
                                                              return s;
                                                          }
                                                      );
                                                  })(n)
                                            : i;
                                    };
                                })(),
                                TransformExpressionInterface = function (t) {
                                    function e(t) {
                                        switch (t) {
                                            case "scale":
                                            case "Scale":
                                            case "ADBE Scale":
                                            case 6:
                                                return e.scale;
                                            case "rotation":
                                            case "Rotation":
                                            case "ADBE Rotation":
                                            case "ADBE Rotate Z":
                                            case 10:
                                                return e.rotation;
                                            case "ADBE Rotate X":
                                                return e.xRotation;
                                            case "ADBE Rotate Y":
                                                return e.yRotation;
                                            case "position":
                                            case "Position":
                                            case "ADBE Position":
                                            case 2:
                                                return e.position;
                                            case "ADBE Position_0":
                                                return e.xPosition;
                                            case "ADBE Position_1":
                                                return e.yPosition;
                                            case "ADBE Position_2":
                                                return e.zPosition;
                                            case "anchorPoint":
                                            case "AnchorPoint":
                                            case "Anchor Point":
                                            case "ADBE AnchorPoint":
                                            case 1:
                                                return e.anchorPoint;
                                            case "opacity":
                                            case "Opacity":
                                            case 11:
                                                return e.opacity;
                                            default:
                                                return null;
                                        }
                                    }
                                    var r, i, n, s;
                                    return (
                                        Object.defineProperty(e, "rotation", {
                                            get: ExpressionPropertyInterface(t.r || t.rz),
                                        }),
                                        Object.defineProperty(e, "zRotation", {
                                            get: ExpressionPropertyInterface(t.rz || t.r),
                                        }),
                                        Object.defineProperty(e, "xRotation", {
                                            get: ExpressionPropertyInterface(t.rx),
                                        }),
                                        Object.defineProperty(e, "yRotation", {
                                            get: ExpressionPropertyInterface(t.ry),
                                        }),
                                        Object.defineProperty(e, "scale", { get: ExpressionPropertyInterface(t.s) }),
                                        t.p
                                            ? (s = ExpressionPropertyInterface(t.p))
                                            : ((r = ExpressionPropertyInterface(t.px)),
                                              (i = ExpressionPropertyInterface(t.py)),
                                              t.pz && (n = ExpressionPropertyInterface(t.pz))),
                                        Object.defineProperty(e, "position", {
                                            get: function () {
                                                return t.p ? s() : [r(), i(), n ? n() : 0];
                                            },
                                        }),
                                        Object.defineProperty(e, "xPosition", {
                                            get: ExpressionPropertyInterface(t.px),
                                        }),
                                        Object.defineProperty(e, "yPosition", {
                                            get: ExpressionPropertyInterface(t.py),
                                        }),
                                        Object.defineProperty(e, "zPosition", {
                                            get: ExpressionPropertyInterface(t.pz),
                                        }),
                                        Object.defineProperty(e, "anchorPoint", {
                                            get: ExpressionPropertyInterface(t.a),
                                        }),
                                        Object.defineProperty(e, "opacity", { get: ExpressionPropertyInterface(t.o) }),
                                        Object.defineProperty(e, "skew", { get: ExpressionPropertyInterface(t.sk) }),
                                        Object.defineProperty(e, "skewAxis", {
                                            get: ExpressionPropertyInterface(t.sa),
                                        }),
                                        Object.defineProperty(e, "orientation", {
                                            get: ExpressionPropertyInterface(t.or),
                                        }),
                                        e
                                    );
                                },
                                LayerExpressionInterface = (function () {
                                    function t(t) {
                                        var e = new Matrix();
                                        return (
                                            void 0 !== t
                                                ? this._elem.finalTransform.mProp.getValueAtTime(t).clone(e)
                                                : this._elem.finalTransform.mProp.applyToMatrix(e),
                                            e
                                        );
                                    }
                                    function e(t, e) {
                                        var r = this.getMatrix(e);
                                        return (
                                            (r.props[12] = 0),
                                            (r.props[13] = 0),
                                            (r.props[14] = 0),
                                            this.applyPoint(r, t)
                                        );
                                    }
                                    function r(t, e) {
                                        var r = this.getMatrix(e);
                                        return this.applyPoint(r, t);
                                    }
                                    function i(t, e) {
                                        var r = this.getMatrix(e);
                                        return (
                                            (r.props[12] = 0),
                                            (r.props[13] = 0),
                                            (r.props[14] = 0),
                                            this.invertPoint(r, t)
                                        );
                                    }
                                    function n(t, e) {
                                        var r = this.getMatrix(e);
                                        return this.invertPoint(r, t);
                                    }
                                    function s(t, e) {
                                        if (this._elem.hierarchy && this._elem.hierarchy.length) {
                                            var r,
                                                i = this._elem.hierarchy.length;
                                            for (r = 0; r < i; r += 1)
                                                this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(t);
                                        }
                                        return t.applyToPointArray(e[0], e[1], e[2] || 0);
                                    }
                                    function a(t, e) {
                                        if (this._elem.hierarchy && this._elem.hierarchy.length) {
                                            var r,
                                                i = this._elem.hierarchy.length;
                                            for (r = 0; r < i; r += 1)
                                                this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(t);
                                        }
                                        return t.inversePoint(e);
                                    }
                                    function o(t) {
                                        var e = new Matrix();
                                        if (
                                            (e.reset(),
                                            this._elem.finalTransform.mProp.applyToMatrix(e),
                                            this._elem.hierarchy && this._elem.hierarchy.length)
                                        ) {
                                            var r,
                                                i = this._elem.hierarchy.length;
                                            for (r = 0; r < i; r += 1)
                                                this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(e);
                                            return e.inversePoint(t);
                                        }
                                        return e.inversePoint(t);
                                    }
                                    function l() {
                                        return [1, 1, 1, 1];
                                    }
                                    return function (h) {
                                        var p;
                                        function c(t) {
                                            switch (t) {
                                                case "ADBE Root Vectors Group":
                                                case "Contents":
                                                case 2:
                                                    return c.shapeInterface;
                                                case 1:
                                                case 6:
                                                case "Transform":
                                                case "transform":
                                                case "ADBE Transform Group":
                                                    return p;
                                                case 4:
                                                case "ADBE Effect Parade":
                                                case "effects":
                                                case "Effects":
                                                    return c.effect;
                                                case "ADBE Text Properties":
                                                    return c.textInterface;
                                                default:
                                                    return null;
                                            }
                                        }
                                        (c.getMatrix = t),
                                            (c.invertPoint = a),
                                            (c.applyPoint = s),
                                            (c.toWorld = r),
                                            (c.toWorldVec = e),
                                            (c.fromWorld = n),
                                            (c.fromWorldVec = i),
                                            (c.toComp = r),
                                            (c.fromComp = o),
                                            (c.sampleImage = l),
                                            (c.sourceRectAtTime = h.sourceRectAtTime.bind(h)),
                                            (c._elem = h);
                                        var d = getDescriptor(
                                            (p = TransformExpressionInterface(h.finalTransform.mProp)),
                                            "anchorPoint"
                                        );
                                        return (
                                            Object.defineProperties(c, {
                                                hasParent: {
                                                    get: function () {
                                                        return h.hierarchy.length;
                                                    },
                                                },
                                                parent: {
                                                    get: function () {
                                                        return h.hierarchy[0].layerInterface;
                                                    },
                                                },
                                                rotation: getDescriptor(p, "rotation"),
                                                scale: getDescriptor(p, "scale"),
                                                position: getDescriptor(p, "position"),
                                                opacity: getDescriptor(p, "opacity"),
                                                anchorPoint: d,
                                                anchor_point: d,
                                                transform: {
                                                    get: function () {
                                                        return p;
                                                    },
                                                },
                                                active: {
                                                    get: function () {
                                                        return h.isInRange;
                                                    },
                                                },
                                            }),
                                            (c.startTime = h.data.st),
                                            (c.index = h.data.ind),
                                            (c.source = h.data.refId),
                                            (c.height = 0 === h.data.ty ? h.data.h : 100),
                                            (c.width = 0 === h.data.ty ? h.data.w : 100),
                                            (c.inPoint = h.data.ip / h.comp.globalData.frameRate),
                                            (c.outPoint = h.data.op / h.comp.globalData.frameRate),
                                            (c._name = h.data.nm),
                                            (c.registerMaskInterface = function (t) {
                                                c.mask = new MaskManagerInterface(t, h);
                                            }),
                                            (c.registerEffectsInterface = function (t) {
                                                c.effect = t;
                                            }),
                                            c
                                        );
                                    };
                                })(),
                                propertyGroupFactory = function (t, e) {
                                    return function (r) {
                                        return (r = void 0 === r ? 1 : r) <= 0 ? t : e(r - 1);
                                    };
                                },
                                PropertyInterface = function (t, e) {
                                    var r = { _name: t };
                                    return function (t) {
                                        return (t = void 0 === t ? 1 : t) <= 0 ? r : e(t - 1);
                                    };
                                },
                                EffectsExpressionInterface = (function () {
                                    function t(r, i, n, s) {
                                        function a(t) {
                                            for (var e = r.ef, i = 0, n = e.length; i < n; ) {
                                                if (t === e[i].nm || t === e[i].mn || t === e[i].ix)
                                                    return 5 === e[i].ty ? h[i] : h[i]();
                                                i += 1;
                                            }
                                            throw new Error();
                                        }
                                        var o,
                                            l = propertyGroupFactory(a, n),
                                            h = [],
                                            p = r.ef.length;
                                        for (o = 0; o < p; o += 1)
                                            5 === r.ef[o].ty
                                                ? h.push(
                                                      t(
                                                          r.ef[o],
                                                          i.effectElements[o],
                                                          i.effectElements[o].propertyGroup,
                                                          s
                                                      )
                                                  )
                                                : h.push(e(i.effectElements[o], r.ef[o].ty, s, l));
                                        return (
                                            "ADBE Color Control" === r.mn &&
                                                Object.defineProperty(a, "color", {
                                                    get: function () {
                                                        return h[0]();
                                                    },
                                                }),
                                            Object.defineProperties(a, {
                                                numProperties: {
                                                    get: function () {
                                                        return r.np;
                                                    },
                                                },
                                                _name: { value: r.nm },
                                                propertyGroup: { value: l },
                                            }),
                                            (a.enabled = 0 !== r.en),
                                            (a.active = a.enabled),
                                            a
                                        );
                                    }
                                    function e(t, e, r, i) {
                                        var n = ExpressionPropertyInterface(t.p);
                                        return (
                                            t.p.setGroupProperty && t.p.setGroupProperty(PropertyInterface("", i)),
                                            function () {
                                                return 10 === e ? r.comp.compInterface(t.p.v) : n();
                                            }
                                        );
                                    }
                                    return {
                                        createEffectsInterface: function (e, r) {
                                            if (e.effectsManager) {
                                                var i,
                                                    n = [],
                                                    s = e.data.ef,
                                                    a = e.effectsManager.effectElements.length;
                                                for (i = 0; i < a; i += 1)
                                                    n.push(t(s[i], e.effectsManager.effectElements[i], r, e));
                                                var o = e.data.ef || [],
                                                    l = function (t) {
                                                        for (i = 0, a = o.length; i < a; ) {
                                                            if (t === o[i].nm || t === o[i].mn || t === o[i].ix)
                                                                return n[i];
                                                            i += 1;
                                                        }
                                                        return null;
                                                    };
                                                return (
                                                    Object.defineProperty(l, "numProperties", {
                                                        get: function () {
                                                            return o.length;
                                                        },
                                                    }),
                                                    l
                                                );
                                            }
                                            return null;
                                        },
                                    };
                                })(),
                                ShapePathInterface = function (t, e, r) {
                                    var i = e.sh;
                                    function n(t) {
                                        return "Shape" === t ||
                                            "shape" === t ||
                                            "Path" === t ||
                                            "path" === t ||
                                            "ADBE Vector Shape" === t ||
                                            2 === t
                                            ? n.path
                                            : null;
                                    }
                                    var s = propertyGroupFactory(n, r);
                                    return (
                                        i.setGroupProperty(PropertyInterface("Path", s)),
                                        Object.defineProperties(n, {
                                            path: {
                                                get: function () {
                                                    return i.k && i.getValue(), i;
                                                },
                                            },
                                            shape: {
                                                get: function () {
                                                    return i.k && i.getValue(), i;
                                                },
                                            },
                                            _name: { value: t.nm },
                                            ix: { value: t.ix },
                                            propertyIndex: { value: t.ix },
                                            mn: { value: t.mn },
                                            propertyGroup: { value: r },
                                        }),
                                        n
                                    );
                                },
                                ShapeExpressionInterface = (function () {
                                    function t(t, a, d) {
                                        var u,
                                            f = [],
                                            m = t ? t.length : 0;
                                        for (u = 0; u < m; u += 1)
                                            "gr" === t[u].ty
                                                ? f.push(e(t[u], a[u], d))
                                                : "fl" === t[u].ty
                                                  ? f.push(r(t[u], a[u], d))
                                                  : "st" === t[u].ty
                                                    ? f.push(n(t[u], a[u], d))
                                                    : "tm" === t[u].ty
                                                      ? f.push(s(t[u], a[u], d))
                                                      : "tr" === t[u].ty ||
                                                        ("el" === t[u].ty
                                                            ? f.push(o(t[u], a[u], d))
                                                            : "sr" === t[u].ty
                                                              ? f.push(l(t[u], a[u], d))
                                                              : "sh" === t[u].ty
                                                                ? f.push(ShapePathInterface(t[u], a[u], d))
                                                                : "rc" === t[u].ty
                                                                  ? f.push(h(t[u], a[u], d))
                                                                  : "rd" === t[u].ty
                                                                    ? f.push(p(t[u], a[u], d))
                                                                    : "rp" === t[u].ty
                                                                      ? f.push(c(t[u], a[u], d))
                                                                      : "gf" === t[u].ty
                                                                        ? f.push(i(t[u], a[u], d))
                                                                        : f.push(
                                                                              (t[u],
                                                                              a[u],
                                                                              function () {
                                                                                  return null;
                                                                              })
                                                                          ));
                                        return f;
                                    }
                                    function e(e, r, i) {
                                        var n = function (t) {
                                            switch (t) {
                                                case "ADBE Vectors Group":
                                                case "Contents":
                                                case 2:
                                                    return n.content;
                                                default:
                                                    return n.transform;
                                            }
                                        };
                                        n.propertyGroup = propertyGroupFactory(n, i);
                                        var s = (function (e, r, i) {
                                                var n,
                                                    s = function (t) {
                                                        for (var e = 0, r = n.length; e < r; ) {
                                                            if (
                                                                n[e]._name === t ||
                                                                n[e].mn === t ||
                                                                n[e].propertyIndex === t ||
                                                                n[e].ix === t ||
                                                                n[e].ind === t
                                                            )
                                                                return n[e];
                                                            e += 1;
                                                        }
                                                        return "number" == typeof t ? n[t - 1] : null;
                                                    };
                                                (s.propertyGroup = propertyGroupFactory(s, i)),
                                                    (n = t(e.it, r.it, s.propertyGroup)),
                                                    (s.numProperties = n.length);
                                                var o = a(
                                                    e.it[e.it.length - 1],
                                                    r.it[r.it.length - 1],
                                                    s.propertyGroup
                                                );
                                                return (
                                                    (s.transform = o), (s.propertyIndex = e.cix), (s._name = e.nm), s
                                                );
                                            })(e, r, n.propertyGroup),
                                            o = a(e.it[e.it.length - 1], r.it[r.it.length - 1], n.propertyGroup);
                                        return (
                                            (n.content = s),
                                            (n.transform = o),
                                            Object.defineProperty(n, "_name", {
                                                get: function () {
                                                    return e.nm;
                                                },
                                            }),
                                            (n.numProperties = e.np),
                                            (n.propertyIndex = e.ix),
                                            (n.nm = e.nm),
                                            (n.mn = e.mn),
                                            n
                                        );
                                    }
                                    function r(t, e, r) {
                                        function i(t) {
                                            return "Color" === t || "color" === t
                                                ? i.color
                                                : "Opacity" === t || "opacity" === t
                                                  ? i.opacity
                                                  : null;
                                        }
                                        return (
                                            Object.defineProperties(i, {
                                                color: { get: ExpressionPropertyInterface(e.c) },
                                                opacity: { get: ExpressionPropertyInterface(e.o) },
                                                _name: { value: t.nm },
                                                mn: { value: t.mn },
                                            }),
                                            e.c.setGroupProperty(PropertyInterface("Color", r)),
                                            e.o.setGroupProperty(PropertyInterface("Opacity", r)),
                                            i
                                        );
                                    }
                                    function i(t, e, r) {
                                        function i(t) {
                                            return "Start Point" === t || "start point" === t
                                                ? i.startPoint
                                                : "End Point" === t || "end point" === t
                                                  ? i.endPoint
                                                  : "Opacity" === t || "opacity" === t
                                                    ? i.opacity
                                                    : null;
                                        }
                                        return (
                                            Object.defineProperties(i, {
                                                startPoint: { get: ExpressionPropertyInterface(e.s) },
                                                endPoint: { get: ExpressionPropertyInterface(e.e) },
                                                opacity: { get: ExpressionPropertyInterface(e.o) },
                                                type: {
                                                    get: function () {
                                                        return "a";
                                                    },
                                                },
                                                _name: { value: t.nm },
                                                mn: { value: t.mn },
                                            }),
                                            e.s.setGroupProperty(PropertyInterface("Start Point", r)),
                                            e.e.setGroupProperty(PropertyInterface("End Point", r)),
                                            e.o.setGroupProperty(PropertyInterface("Opacity", r)),
                                            i
                                        );
                                    }
                                    function n(t, e, r) {
                                        var i,
                                            n = propertyGroupFactory(h, r),
                                            s = propertyGroupFactory(l, n);
                                        function a(r) {
                                            Object.defineProperty(l, t.d[r].nm, {
                                                get: ExpressionPropertyInterface(e.d.dataProps[r].p),
                                            });
                                        }
                                        var o = t.d ? t.d.length : 0,
                                            l = {};
                                        for (i = 0; i < o; i += 1) a(i), e.d.dataProps[i].p.setGroupProperty(s);
                                        function h(t) {
                                            return "Color" === t || "color" === t
                                                ? h.color
                                                : "Opacity" === t || "opacity" === t
                                                  ? h.opacity
                                                  : "Stroke Width" === t || "stroke width" === t
                                                    ? h.strokeWidth
                                                    : null;
                                        }
                                        return (
                                            Object.defineProperties(h, {
                                                color: { get: ExpressionPropertyInterface(e.c) },
                                                opacity: { get: ExpressionPropertyInterface(e.o) },
                                                strokeWidth: { get: ExpressionPropertyInterface(e.w) },
                                                dash: {
                                                    get: function () {
                                                        return l;
                                                    },
                                                },
                                                _name: { value: t.nm },
                                                mn: { value: t.mn },
                                            }),
                                            e.c.setGroupProperty(PropertyInterface("Color", n)),
                                            e.o.setGroupProperty(PropertyInterface("Opacity", n)),
                                            e.w.setGroupProperty(PropertyInterface("Stroke Width", n)),
                                            h
                                        );
                                    }
                                    function s(t, e, r) {
                                        function i(e) {
                                            return e === t.e.ix || "End" === e || "end" === e
                                                ? i.end
                                                : e === t.s.ix
                                                  ? i.start
                                                  : e === t.o.ix
                                                    ? i.offset
                                                    : null;
                                        }
                                        var n = propertyGroupFactory(i, r);
                                        return (
                                            (i.propertyIndex = t.ix),
                                            e.s.setGroupProperty(PropertyInterface("Start", n)),
                                            e.e.setGroupProperty(PropertyInterface("End", n)),
                                            e.o.setGroupProperty(PropertyInterface("Offset", n)),
                                            (i.propertyIndex = t.ix),
                                            (i.propertyGroup = r),
                                            Object.defineProperties(i, {
                                                start: { get: ExpressionPropertyInterface(e.s) },
                                                end: { get: ExpressionPropertyInterface(e.e) },
                                                offset: { get: ExpressionPropertyInterface(e.o) },
                                                _name: { value: t.nm },
                                            }),
                                            (i.mn = t.mn),
                                            i
                                        );
                                    }
                                    function a(t, e, r) {
                                        function i(e) {
                                            return t.a.ix === e || "Anchor Point" === e
                                                ? i.anchorPoint
                                                : t.o.ix === e || "Opacity" === e
                                                  ? i.opacity
                                                  : t.p.ix === e || "Position" === e
                                                    ? i.position
                                                    : t.r.ix === e || "Rotation" === e || "ADBE Vector Rotation" === e
                                                      ? i.rotation
                                                      : t.s.ix === e || "Scale" === e
                                                        ? i.scale
                                                        : (t.sk && t.sk.ix === e) || "Skew" === e
                                                          ? i.skew
                                                          : (t.sa && t.sa.ix === e) || "Skew Axis" === e
                                                            ? i.skewAxis
                                                            : null;
                                        }
                                        var n = propertyGroupFactory(i, r);
                                        return (
                                            e.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", n)),
                                            e.transform.mProps.p.setGroupProperty(PropertyInterface("Position", n)),
                                            e.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", n)),
                                            e.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", n)),
                                            e.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", n)),
                                            e.transform.mProps.sk &&
                                                (e.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", n)),
                                                e.transform.mProps.sa.setGroupProperty(
                                                    PropertyInterface("Skew Angle", n)
                                                )),
                                            e.transform.op.setGroupProperty(PropertyInterface("Opacity", n)),
                                            Object.defineProperties(i, {
                                                opacity: { get: ExpressionPropertyInterface(e.transform.mProps.o) },
                                                position: { get: ExpressionPropertyInterface(e.transform.mProps.p) },
                                                anchorPoint: { get: ExpressionPropertyInterface(e.transform.mProps.a) },
                                                scale: { get: ExpressionPropertyInterface(e.transform.mProps.s) },
                                                rotation: { get: ExpressionPropertyInterface(e.transform.mProps.r) },
                                                skew: { get: ExpressionPropertyInterface(e.transform.mProps.sk) },
                                                skewAxis: { get: ExpressionPropertyInterface(e.transform.mProps.sa) },
                                                _name: { value: t.nm },
                                            }),
                                            (i.ty = "tr"),
                                            (i.mn = t.mn),
                                            (i.propertyGroup = r),
                                            i
                                        );
                                    }
                                    function o(t, e, r) {
                                        function i(e) {
                                            return t.p.ix === e ? i.position : t.s.ix === e ? i.size : null;
                                        }
                                        var n = propertyGroupFactory(i, r);
                                        i.propertyIndex = t.ix;
                                        var s = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                                        return (
                                            s.s.setGroupProperty(PropertyInterface("Size", n)),
                                            s.p.setGroupProperty(PropertyInterface("Position", n)),
                                            Object.defineProperties(i, {
                                                size: { get: ExpressionPropertyInterface(s.s) },
                                                position: { get: ExpressionPropertyInterface(s.p) },
                                                _name: { value: t.nm },
                                            }),
                                            (i.mn = t.mn),
                                            i
                                        );
                                    }
                                    function l(t, e, r) {
                                        function i(e) {
                                            return t.p.ix === e
                                                ? i.position
                                                : t.r.ix === e
                                                  ? i.rotation
                                                  : t.pt.ix === e
                                                    ? i.points
                                                    : t.or.ix === e || "ADBE Vector Star Outer Radius" === e
                                                      ? i.outerRadius
                                                      : t.os.ix === e
                                                        ? i.outerRoundness
                                                        : !t.ir ||
                                                            (t.ir.ix !== e && "ADBE Vector Star Inner Radius" !== e)
                                                          ? t.is && t.is.ix === e
                                                              ? i.innerRoundness
                                                              : null
                                                          : i.innerRadius;
                                        }
                                        var n = propertyGroupFactory(i, r),
                                            s = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                                        return (
                                            (i.propertyIndex = t.ix),
                                            s.or.setGroupProperty(PropertyInterface("Outer Radius", n)),
                                            s.os.setGroupProperty(PropertyInterface("Outer Roundness", n)),
                                            s.pt.setGroupProperty(PropertyInterface("Points", n)),
                                            s.p.setGroupProperty(PropertyInterface("Position", n)),
                                            s.r.setGroupProperty(PropertyInterface("Rotation", n)),
                                            t.ir &&
                                                (s.ir.setGroupProperty(PropertyInterface("Inner Radius", n)),
                                                s.is.setGroupProperty(PropertyInterface("Inner Roundness", n))),
                                            Object.defineProperties(i, {
                                                position: { get: ExpressionPropertyInterface(s.p) },
                                                rotation: { get: ExpressionPropertyInterface(s.r) },
                                                points: { get: ExpressionPropertyInterface(s.pt) },
                                                outerRadius: { get: ExpressionPropertyInterface(s.or) },
                                                outerRoundness: { get: ExpressionPropertyInterface(s.os) },
                                                innerRadius: { get: ExpressionPropertyInterface(s.ir) },
                                                innerRoundness: { get: ExpressionPropertyInterface(s.is) },
                                                _name: { value: t.nm },
                                            }),
                                            (i.mn = t.mn),
                                            i
                                        );
                                    }
                                    function h(t, e, r) {
                                        function i(e) {
                                            return t.p.ix === e
                                                ? i.position
                                                : t.r.ix === e
                                                  ? i.roundness
                                                  : t.s.ix === e || "Size" === e || "ADBE Vector Rect Size" === e
                                                    ? i.size
                                                    : null;
                                        }
                                        var n = propertyGroupFactory(i, r),
                                            s = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                                        return (
                                            (i.propertyIndex = t.ix),
                                            s.p.setGroupProperty(PropertyInterface("Position", n)),
                                            s.s.setGroupProperty(PropertyInterface("Size", n)),
                                            s.r.setGroupProperty(PropertyInterface("Rotation", n)),
                                            Object.defineProperties(i, {
                                                position: { get: ExpressionPropertyInterface(s.p) },
                                                roundness: { get: ExpressionPropertyInterface(s.r) },
                                                size: { get: ExpressionPropertyInterface(s.s) },
                                                _name: { value: t.nm },
                                            }),
                                            (i.mn = t.mn),
                                            i
                                        );
                                    }
                                    function p(t, e, r) {
                                        function i(e) {
                                            return t.r.ix === e || "Round Corners 1" === e ? i.radius : null;
                                        }
                                        var n = propertyGroupFactory(i, r),
                                            s = e;
                                        return (
                                            (i.propertyIndex = t.ix),
                                            s.rd.setGroupProperty(PropertyInterface("Radius", n)),
                                            Object.defineProperties(i, {
                                                radius: { get: ExpressionPropertyInterface(s.rd) },
                                                _name: { value: t.nm },
                                            }),
                                            (i.mn = t.mn),
                                            i
                                        );
                                    }
                                    function c(t, e, r) {
                                        function i(e) {
                                            return t.c.ix === e || "Copies" === e
                                                ? i.copies
                                                : t.o.ix === e || "Offset" === e
                                                  ? i.offset
                                                  : null;
                                        }
                                        var n = propertyGroupFactory(i, r),
                                            s = e;
                                        return (
                                            (i.propertyIndex = t.ix),
                                            s.c.setGroupProperty(PropertyInterface("Copies", n)),
                                            s.o.setGroupProperty(PropertyInterface("Offset", n)),
                                            Object.defineProperties(i, {
                                                copies: { get: ExpressionPropertyInterface(s.c) },
                                                offset: { get: ExpressionPropertyInterface(s.o) },
                                                _name: { value: t.nm },
                                            }),
                                            (i.mn = t.mn),
                                            i
                                        );
                                    }
                                    return function (e, r, i) {
                                        var n;
                                        function s(t) {
                                            if ("number" == typeof t)
                                                return 0 === (t = void 0 === t ? 1 : t) ? i : n[t - 1];
                                            for (var e = 0, r = n.length; e < r; ) {
                                                if (n[e]._name === t) return n[e];
                                                e += 1;
                                            }
                                            return null;
                                        }
                                        return (
                                            (s.propertyGroup = propertyGroupFactory(s, function () {
                                                return i;
                                            })),
                                            (n = t(e, r, s.propertyGroup)),
                                            (s.numProperties = n.length),
                                            (s._name = "Contents"),
                                            s
                                        );
                                    };
                                })(),
                                TextExpressionInterface = function (t) {
                                    var e, r;
                                    function i(t) {
                                        return "ADBE Text Document" === t ? i.sourceText : null;
                                    }
                                    return (
                                        Object.defineProperty(i, "sourceText", {
                                            get: function () {
                                                t.textProperty.getValue();
                                                var i = t.textProperty.currentData.t;
                                                return (
                                                    i !== e &&
                                                        ((t.textProperty.currentData.t = e),
                                                        ((r = new String(i)).value = i || new String(i))),
                                                    r
                                                );
                                            },
                                        }),
                                        i
                                    );
                                };
                            function _typeof$2(t) {
                                return (_typeof$2 =
                                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                        ? function (t) {
                                              return typeof t;
                                          }
                                        : function (t) {
                                              return t &&
                                                  "function" == typeof Symbol &&
                                                  t.constructor === Symbol &&
                                                  t !== Symbol.prototype
                                                  ? "symbol"
                                                  : typeof t;
                                          })(t);
                            }
                            var FootageInterface =
                                    ((dataInterfaceFactory = function (t) {
                                        function e(t) {
                                            return "Outline" === t ? e.outlineInterface() : null;
                                        }
                                        return (
                                            (e._name = "Outline"),
                                            (e.outlineInterface = (function (t) {
                                                var e = "",
                                                    r = t.getFootageData();
                                                function i(t) {
                                                    if (r[t])
                                                        return (e = t), "object" === _typeof$2((r = r[t])) ? i : r;
                                                    var n = t.indexOf(e);
                                                    if (-1 !== n) {
                                                        var s = parseInt(t.substr(n + e.length), 10);
                                                        return "object" === _typeof$2((r = r[s])) ? i : r;
                                                    }
                                                    return "";
                                                }
                                                return function () {
                                                    return (e = ""), (r = t.getFootageData()), i;
                                                };
                                            })(t)),
                                            e
                                        );
                                    }),
                                    function (t) {
                                        function e(t) {
                                            return "Data" === t ? e.dataInterface : null;
                                        }
                                        return (e._name = "Data"), (e.dataInterface = dataInterfaceFactory(t)), e;
                                    }),
                                dataInterfaceFactory,
                                interfaces = {
                                    layer: LayerExpressionInterface,
                                    effects: EffectsExpressionInterface,
                                    comp: CompExpressionInterface,
                                    shape: ShapeExpressionInterface,
                                    text: TextExpressionInterface,
                                    footage: FootageInterface,
                                };
                            function getInterface(t) {
                                return interfaces[t] || null;
                            }
                            function _typeof$1(t) {
                                return (_typeof$1 =
                                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                        ? function (t) {
                                              return typeof t;
                                          }
                                        : function (t) {
                                              return t &&
                                                  "function" == typeof Symbol &&
                                                  t.constructor === Symbol &&
                                                  t !== Symbol.prototype
                                                  ? "symbol"
                                                  : typeof t;
                                          })(t);
                            }
                            function seedRandom(t, e) {
                                var r = this,
                                    i = 256,
                                    n = e.pow(i, 6),
                                    s = e.pow(2, 52),
                                    a = 2 * s,
                                    o = 255;
                                function l(t) {
                                    var e,
                                        r = t.length,
                                        n = this,
                                        s = 0,
                                        a = (n.i = n.j = 0),
                                        l = (n.S = []);
                                    for (r || (t = [r++]); s < i; ) l[s] = s++;
                                    for (s = 0; s < i; s++)
                                        (l[s] = l[(a = o & (a + t[s % r] + (e = l[s])))]), (l[a] = e);
                                    n.g = function (t) {
                                        for (var e, r = 0, s = n.i, a = n.j, l = n.S; t--; )
                                            (e = l[(s = o & (s + 1))]),
                                                (r = r * i + l[o & ((l[s] = l[(a = o & (a + e))]) + (l[a] = e))]);
                                        return (n.i = s), (n.j = a), r;
                                    };
                                }
                                function h(t, e) {
                                    return (e.i = t.i), (e.j = t.j), (e.S = t.S.slice()), e;
                                }
                                function p(t, e) {
                                    var r,
                                        i = [],
                                        n = _typeof$1(t);
                                    if (e && "object" == n)
                                        for (r in t)
                                            try {
                                                i.push(p(t[r], e - 1));
                                            } catch (t) {}
                                    return i.length ? i : "string" == n ? t : t + "\0";
                                }
                                function c(t, e) {
                                    for (var r, i = t + "", n = 0; n < i.length; )
                                        e[o & n] = o & ((r ^= 19 * e[o & n]) + i.charCodeAt(n++));
                                    return d(e);
                                }
                                function d(t) {
                                    return String.fromCharCode.apply(0, t);
                                }
                                (e.seedrandom = function (o, u, f) {
                                    var m = [],
                                        g = c(
                                            p(
                                                (u = !0 === u ? { entropy: !0 } : u || {}).entropy
                                                    ? [o, d(t)]
                                                    : null === o
                                                      ? (function () {
                                                            try {
                                                                var e = new Uint8Array(i);
                                                                return (
                                                                    (r.crypto || r.msCrypto).getRandomValues(e), d(e)
                                                                );
                                                            } catch (e) {
                                                                var n = r.navigator,
                                                                    s = n && n.plugins;
                                                                return [+new Date(), r, s, r.screen, d(t)];
                                                            }
                                                        })()
                                                      : o,
                                                3
                                            ),
                                            m
                                        ),
                                        y = new l(m),
                                        v = function () {
                                            for (var t = y.g(6), e = n, r = 0; t < s; )
                                                (t = (t + r) * i), (e *= i), (r = y.g(1));
                                            for (; t >= a; ) (t /= 2), (e /= 2), (r >>>= 1);
                                            return (t + r) / e;
                                        };
                                    return (
                                        (v.int32 = function () {
                                            return 0 | y.g(4);
                                        }),
                                        (v.quick = function () {
                                            return y.g(4) / 4294967296;
                                        }),
                                        (v.double = v),
                                        c(d(y.S), t),
                                        (
                                            u.pass ||
                                            f ||
                                            function (t, r, i, n) {
                                                return (
                                                    n &&
                                                        (n.S && h(n, y),
                                                        (t.state = function () {
                                                            return h(y, {});
                                                        })),
                                                    i ? ((e.random = t), r) : t
                                                );
                                            }
                                        )(v, g, "global" in u ? u.global : this == e, u.state)
                                    );
                                }),
                                    c(e.random(), t);
                            }
                            function initialize$2(t) {
                                seedRandom([], t);
                            }
                            var propTypes = { SHAPE: "shape" };
                            function _typeof(t) {
                                return (_typeof =
                                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                        ? function (t) {
                                              return typeof t;
                                          }
                                        : function (t) {
                                              return t &&
                                                  "function" == typeof Symbol &&
                                                  t.constructor === Symbol &&
                                                  t !== Symbol.prototype
                                                  ? "symbol"
                                                  : typeof t;
                                          })(t);
                            }
                            var ExpressionManager = (function () {
                                    var ob = {},
                                        Math = BMMath,
                                        window = null,
                                        document = null,
                                        XMLHttpRequest = null,
                                        fetch = null,
                                        frames = null;
                                    function $bm_isInstanceOfArray(t) {
                                        return t.constructor === Array || t.constructor === Float32Array;
                                    }
                                    function isNumerable(t, e) {
                                        return (
                                            "number" === t || "boolean" === t || "string" === t || e instanceof Number
                                        );
                                    }
                                    function $bm_neg(t) {
                                        var e = _typeof(t);
                                        if ("number" === e || "boolean" === e || t instanceof Number) return -t;
                                        if ($bm_isInstanceOfArray(t)) {
                                            var r,
                                                i = t.length,
                                                n = [];
                                            for (r = 0; r < i; r += 1) n[r] = -t[r];
                                            return n;
                                        }
                                        return t.propType ? t.v : -t;
                                    }
                                    initialize$2(BMMath);
                                    var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get,
                                        easeOutBez = BezierFactory.getBezierEasing(
                                            0.167,
                                            0.167,
                                            0.667,
                                            1,
                                            "easeOut"
                                        ).get,
                                        easeInOutBez = BezierFactory.getBezierEasing(
                                            0.33,
                                            0,
                                            0.667,
                                            1,
                                            "easeInOut"
                                        ).get;
                                    function sum(t, e) {
                                        var r = _typeof(t),
                                            i = _typeof(e);
                                        if ("string" === r || "string" === i) return t + e;
                                        if (isNumerable(r, t) && isNumerable(i, e)) return t + e;
                                        if ($bm_isInstanceOfArray(t) && isNumerable(i, e))
                                            return ((t = t.slice(0))[0] += e), t;
                                        if (isNumerable(r, t) && $bm_isInstanceOfArray(e))
                                            return ((e = e.slice(0))[0] = t + e[0]), e;
                                        if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                                            for (var n = 0, s = t.length, a = e.length, o = []; n < s || n < a; )
                                                ("number" == typeof t[n] || t[n] instanceof Number) &&
                                                ("number" == typeof e[n] || e[n] instanceof Number)
                                                    ? (o[n] = t[n] + e[n])
                                                    : (o[n] = void 0 === e[n] ? t[n] : t[n] || e[n]),
                                                    (n += 1);
                                            return o;
                                        }
                                        return 0;
                                    }
                                    var add = sum;
                                    function sub(t, e) {
                                        var r = _typeof(t),
                                            i = _typeof(e);
                                        if (isNumerable(r, t) && isNumerable(i, e))
                                            return (
                                                "string" === r && (t = parseInt(t, 10)),
                                                "string" === i && (e = parseInt(e, 10)),
                                                t - e
                                            );
                                        if ($bm_isInstanceOfArray(t) && isNumerable(i, e))
                                            return ((t = t.slice(0))[0] -= e), t;
                                        if (isNumerable(r, t) && $bm_isInstanceOfArray(e))
                                            return ((e = e.slice(0))[0] = t - e[0]), e;
                                        if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                                            for (var n = 0, s = t.length, a = e.length, o = []; n < s || n < a; )
                                                ("number" == typeof t[n] || t[n] instanceof Number) &&
                                                ("number" == typeof e[n] || e[n] instanceof Number)
                                                    ? (o[n] = t[n] - e[n])
                                                    : (o[n] = void 0 === e[n] ? t[n] : t[n] || e[n]),
                                                    (n += 1);
                                            return o;
                                        }
                                        return 0;
                                    }
                                    function mul(t, e) {
                                        var r,
                                            i,
                                            n,
                                            s = _typeof(t),
                                            a = _typeof(e);
                                        if (isNumerable(s, t) && isNumerable(a, e)) return t * e;
                                        if ($bm_isInstanceOfArray(t) && isNumerable(a, e)) {
                                            for (n = t.length, r = createTypedArray("float32", n), i = 0; i < n; i += 1)
                                                r[i] = t[i] * e;
                                            return r;
                                        }
                                        if (isNumerable(s, t) && $bm_isInstanceOfArray(e)) {
                                            for (n = e.length, r = createTypedArray("float32", n), i = 0; i < n; i += 1)
                                                r[i] = t * e[i];
                                            return r;
                                        }
                                        return 0;
                                    }
                                    function div(t, e) {
                                        var r,
                                            i,
                                            n,
                                            s = _typeof(t),
                                            a = _typeof(e);
                                        if (isNumerable(s, t) && isNumerable(a, e)) return t / e;
                                        if ($bm_isInstanceOfArray(t) && isNumerable(a, e)) {
                                            for (n = t.length, r = createTypedArray("float32", n), i = 0; i < n; i += 1)
                                                r[i] = t[i] / e;
                                            return r;
                                        }
                                        if (isNumerable(s, t) && $bm_isInstanceOfArray(e)) {
                                            for (n = e.length, r = createTypedArray("float32", n), i = 0; i < n; i += 1)
                                                r[i] = t / e[i];
                                            return r;
                                        }
                                        return 0;
                                    }
                                    function mod(t, e) {
                                        return (
                                            "string" == typeof t && (t = parseInt(t, 10)),
                                            "string" == typeof e && (e = parseInt(e, 10)),
                                            t % e
                                        );
                                    }
                                    var $bm_sum = sum,
                                        $bm_sub = sub,
                                        $bm_mul = mul,
                                        $bm_div = div,
                                        $bm_mod = mod;
                                    function clamp(t, e, r) {
                                        if (e > r) {
                                            var i = r;
                                            (r = e), (e = i);
                                        }
                                        return Math.min(Math.max(t, e), r);
                                    }
                                    function radiansToDegrees(t) {
                                        return t / degToRads;
                                    }
                                    var radians_to_degrees = radiansToDegrees;
                                    function degreesToRadians(t) {
                                        return t * degToRads;
                                    }
                                    var degrees_to_radians = radiansToDegrees,
                                        helperLengthArray = [0, 0, 0, 0, 0, 0];
                                    function length(t, e) {
                                        if ("number" == typeof t || t instanceof Number)
                                            return (e = e || 0), Math.abs(t - e);
                                        var r;
                                        e || (e = helperLengthArray);
                                        var i = Math.min(t.length, e.length),
                                            n = 0;
                                        for (r = 0; r < i; r += 1) n += Math.pow(e[r] - t[r], 2);
                                        return Math.sqrt(n);
                                    }
                                    function normalize(t) {
                                        return div(t, length(t));
                                    }
                                    function rgbToHsl(t) {
                                        var e,
                                            r,
                                            i = t[0],
                                            n = t[1],
                                            s = t[2],
                                            a = Math.max(i, n, s),
                                            o = Math.min(i, n, s),
                                            l = (a + o) / 2;
                                        if (a === o) (e = 0), (r = 0);
                                        else {
                                            var h = a - o;
                                            switch (((r = l > 0.5 ? h / (2 - a - o) : h / (a + o)), a)) {
                                                case i:
                                                    e = (n - s) / h + (n < s ? 6 : 0);
                                                    break;
                                                case n:
                                                    e = (s - i) / h + 2;
                                                    break;
                                                case s:
                                                    e = (i - n) / h + 4;
                                            }
                                            e /= 6;
                                        }
                                        return [e, r, l, t[3]];
                                    }
                                    function hue2rgb(t, e, r) {
                                        return (
                                            r < 0 && (r += 1),
                                            r > 1 && (r -= 1),
                                            r < 1 / 6
                                                ? t + 6 * (e - t) * r
                                                : r < 0.5
                                                  ? e
                                                  : r < 2 / 3
                                                    ? t + (e - t) * (2 / 3 - r) * 6
                                                    : t
                                        );
                                    }
                                    function hslToRgb(t) {
                                        var e,
                                            r,
                                            i,
                                            n = t[0],
                                            s = t[1],
                                            a = t[2];
                                        if (0 === s) (e = a), (i = a), (r = a);
                                        else {
                                            var o = a < 0.5 ? a * (1 + s) : a + s - a * s,
                                                l = 2 * a - o;
                                            (e = hue2rgb(l, o, n + 1 / 3)),
                                                (r = hue2rgb(l, o, n)),
                                                (i = hue2rgb(l, o, n - 1 / 3));
                                        }
                                        return [e, r, i, t[3]];
                                    }
                                    function linear(t, e, r, i, n) {
                                        if (
                                            ((void 0 !== i && void 0 !== n) || ((i = e), (n = r), (e = 0), (r = 1)),
                                            r < e)
                                        ) {
                                            var s = r;
                                            (r = e), (e = s);
                                        }
                                        if (t <= e) return i;
                                        if (t >= r) return n;
                                        var a,
                                            o = r === e ? 0 : (t - e) / (r - e);
                                        if (!i.length) return i + (n - i) * o;
                                        var l = i.length,
                                            h = createTypedArray("float32", l);
                                        for (a = 0; a < l; a += 1) h[a] = i[a] + (n[a] - i[a]) * o;
                                        return h;
                                    }
                                    function random(t, e) {
                                        if (
                                            (void 0 === e &&
                                                (void 0 === t ? ((t = 0), (e = 1)) : ((e = t), (t = void 0))),
                                            e.length)
                                        ) {
                                            var r,
                                                i = e.length;
                                            t || (t = createTypedArray("float32", i));
                                            var n = createTypedArray("float32", i),
                                                s = BMMath.random();
                                            for (r = 0; r < i; r += 1) n[r] = t[r] + s * (e[r] - t[r]);
                                            return n;
                                        }
                                        return void 0 === t && (t = 0), t + BMMath.random() * (e - t);
                                    }
                                    function createPath(t, e, r, i) {
                                        var n,
                                            s = t.length,
                                            a = shapePool.newElement();
                                        a.setPathData(!!i, s);
                                        var o,
                                            l,
                                            h = [0, 0];
                                        for (n = 0; n < s; n += 1)
                                            (o = e && e[n] ? e[n] : h),
                                                (l = r && r[n] ? r[n] : h),
                                                a.setTripleAt(
                                                    t[n][0],
                                                    t[n][1],
                                                    l[0] + t[n][0],
                                                    l[1] + t[n][1],
                                                    o[0] + t[n][0],
                                                    o[1] + t[n][1],
                                                    n,
                                                    !0
                                                );
                                        return a;
                                    }
                                    function initiateExpression(elem, data, property) {
                                        function noOp(t) {
                                            return t;
                                        }
                                        if (!elem.globalData.renderConfig.runExpressions) return noOp;
                                        var val = data.x,
                                            needsVelocity = /velocity(?![\w\d])/.test(val),
                                            _needsRandom = -1 !== val.indexOf("random"),
                                            elemType = elem.data.ty,
                                            transform,
                                            $bm_transform,
                                            content,
                                            effect,
                                            thisProperty = property;
                                        (thisProperty.valueAtTime = thisProperty.getValueAtTime),
                                            Object.defineProperty(thisProperty, "value", {
                                                get: function () {
                                                    return thisProperty.v;
                                                },
                                            }),
                                            (elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate),
                                            (elem.comp.displayStartTime = 0);
                                        var inPoint = elem.data.ip / elem.comp.globalData.frameRate,
                                            outPoint = elem.data.op / elem.comp.globalData.frameRate,
                                            width = elem.data.sw ? elem.data.sw : 0,
                                            height = elem.data.sh ? elem.data.sh : 0,
                                            name = elem.data.nm,
                                            loopIn,
                                            loop_in,
                                            loopOut,
                                            loop_out,
                                            smooth,
                                            toWorld,
                                            fromWorld,
                                            fromComp,
                                            toComp,
                                            fromCompToSurface,
                                            position,
                                            rotation,
                                            anchorPoint,
                                            scale,
                                            thisLayer,
                                            thisComp,
                                            mask,
                                            valueAtTime,
                                            velocityAtTime,
                                            scoped_bm_rt,
                                            expression_function = eval(
                                                "[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]"
                                            )[0],
                                            numKeys = property.kf ? data.k.length : 0,
                                            active = !this.data || !0 !== this.data.hd,
                                            wiggle = function (t, e) {
                                                var r,
                                                    i,
                                                    n = this.pv.length ? this.pv.length : 1,
                                                    s = createTypedArray("float32", n),
                                                    a = Math.floor(5 * time);
                                                for (r = 0, i = 0; r < a; ) {
                                                    for (i = 0; i < n; i += 1) s[i] += -e + 2 * e * BMMath.random();
                                                    r += 1;
                                                }
                                                var o = 5 * time,
                                                    l = o - Math.floor(o),
                                                    h = createTypedArray("float32", n);
                                                if (n > 1) {
                                                    for (i = 0; i < n; i += 1)
                                                        h[i] = this.pv[i] + s[i] + (-e + 2 * e * BMMath.random()) * l;
                                                    return h;
                                                }
                                                return this.pv + s[0] + (-e + 2 * e * BMMath.random()) * l;
                                            }.bind(this);
                                        function loopInDuration(t, e) {
                                            return loopIn(t, e, !0);
                                        }
                                        function loopOutDuration(t, e) {
                                            return loopOut(t, e, !0);
                                        }
                                        thisProperty.loopIn &&
                                            ((loopIn = thisProperty.loopIn.bind(thisProperty)), (loop_in = loopIn)),
                                            thisProperty.loopOut &&
                                                ((loopOut = thisProperty.loopOut.bind(thisProperty)),
                                                (loop_out = loopOut)),
                                            thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty)),
                                            this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)),
                                            this.getVelocityAtTime &&
                                                (velocityAtTime = this.getVelocityAtTime.bind(this));
                                        var comp = elem.comp.globalData.projectInterface.bind(
                                                elem.comp.globalData.projectInterface
                                            ),
                                            time,
                                            velocity,
                                            value,
                                            text,
                                            textIndex,
                                            textTotal,
                                            selectorValue;
                                        function lookAt(t, e) {
                                            var r = [e[0] - t[0], e[1] - t[1], e[2] - t[2]],
                                                i = Math.atan2(r[0], Math.sqrt(r[1] * r[1] + r[2] * r[2])) / degToRads;
                                            return [-Math.atan2(r[1], r[2]) / degToRads, i, 0];
                                        }
                                        function easeOut(t, e, r, i, n) {
                                            return applyEase(easeOutBez, t, e, r, i, n);
                                        }
                                        function easeIn(t, e, r, i, n) {
                                            return applyEase(easeInBez, t, e, r, i, n);
                                        }
                                        function ease(t, e, r, i, n) {
                                            return applyEase(easeInOutBez, t, e, r, i, n);
                                        }
                                        function applyEase(t, e, r, i, n, s) {
                                            void 0 === n ? ((n = r), (s = i)) : (e = (e - r) / (i - r)),
                                                e > 1 ? (e = 1) : e < 0 && (e = 0);
                                            var a = t(e);
                                            if ($bm_isInstanceOfArray(n)) {
                                                var o,
                                                    l = n.length,
                                                    h = createTypedArray("float32", l);
                                                for (o = 0; o < l; o += 1) h[o] = (s[o] - n[o]) * a + n[o];
                                                return h;
                                            }
                                            return (s - n) * a + n;
                                        }
                                        function nearestKey(t) {
                                            var e,
                                                r,
                                                i,
                                                n = data.k.length;
                                            if (data.k.length && "number" != typeof data.k[0])
                                                if (((r = -1), (t *= elem.comp.globalData.frameRate) < data.k[0].t))
                                                    (r = 1), (i = data.k[0].t);
                                                else {
                                                    for (e = 0; e < n - 1; e += 1) {
                                                        if (t === data.k[e].t) {
                                                            (r = e + 1), (i = data.k[e].t);
                                                            break;
                                                        }
                                                        if (t > data.k[e].t && t < data.k[e + 1].t) {
                                                            t - data.k[e].t > data.k[e + 1].t - t
                                                                ? ((r = e + 2), (i = data.k[e + 1].t))
                                                                : ((r = e + 1), (i = data.k[e].t));
                                                            break;
                                                        }
                                                    }
                                                    -1 === r && ((r = e + 1), (i = data.k[e].t));
                                                }
                                            else (r = 0), (i = 0);
                                            var s = {};
                                            return (s.index = r), (s.time = i / elem.comp.globalData.frameRate), s;
                                        }
                                        function key(t) {
                                            var e, r, i;
                                            if (!data.k.length || "number" == typeof data.k[0])
                                                throw new Error("The property has no keyframe at index " + t);
                                            (t -= 1),
                                                (e = { time: data.k[t].t / elem.comp.globalData.frameRate, value: [] });
                                            var n = Object.prototype.hasOwnProperty.call(data.k[t], "s")
                                                ? data.k[t].s
                                                : data.k[t - 1].e;
                                            for (i = n.length, r = 0; r < i; r += 1) (e[r] = n[r]), (e.value[r] = n[r]);
                                            return e;
                                        }
                                        function framesToTime(t, e) {
                                            return e || (e = elem.comp.globalData.frameRate), t / e;
                                        }
                                        function timeToFrames(t, e) {
                                            return (
                                                t || 0 === t || (t = time),
                                                e || (e = elem.comp.globalData.frameRate),
                                                t * e
                                            );
                                        }
                                        function seedRandom(t) {
                                            BMMath.seedrandom(randSeed + t);
                                        }
                                        function sourceRectAtTime() {
                                            return elem.sourceRectAtTime();
                                        }
                                        function substring(t, e) {
                                            return "string" == typeof value
                                                ? void 0 === e
                                                    ? value.substring(t)
                                                    : value.substring(t, e)
                                                : "";
                                        }
                                        function substr(t, e) {
                                            return "string" == typeof value
                                                ? void 0 === e
                                                    ? value.substr(t)
                                                    : value.substr(t, e)
                                                : "";
                                        }
                                        function posterizeTime(t) {
                                            (time = 0 === t ? 0 : Math.floor(time * t) / t),
                                                (value = valueAtTime(time));
                                        }
                                        var index = elem.data.ind,
                                            hasParent = !(!elem.hierarchy || !elem.hierarchy.length),
                                            parent,
                                            randSeed = Math.floor(1e6 * Math.random()),
                                            globalData = elem.globalData;
                                        function executeExpression(t) {
                                            return (
                                                (value = t),
                                                this.frameExpressionId === elem.globalData.frameId &&
                                                "textSelector" !== this.propType
                                                    ? value
                                                    : ("textSelector" === this.propType &&
                                                          ((textIndex = this.textIndex),
                                                          (textTotal = this.textTotal),
                                                          (selectorValue = this.selectorValue)),
                                                      thisLayer ||
                                                          ((text = elem.layerInterface.text),
                                                          (thisLayer = elem.layerInterface),
                                                          (thisComp = elem.comp.compInterface),
                                                          (toWorld = thisLayer.toWorld.bind(thisLayer)),
                                                          (fromWorld = thisLayer.fromWorld.bind(thisLayer)),
                                                          (fromComp = thisLayer.fromComp.bind(thisLayer)),
                                                          (toComp = thisLayer.toComp.bind(thisLayer)),
                                                          (mask = thisLayer.mask
                                                              ? thisLayer.mask.bind(thisLayer)
                                                              : null),
                                                          (fromCompToSurface = fromComp)),
                                                      transform ||
                                                          ((transform = elem.layerInterface("ADBE Transform Group")),
                                                          ($bm_transform = transform),
                                                          transform && (anchorPoint = transform.anchorPoint)),
                                                      4 !== elemType ||
                                                          content ||
                                                          (content = thisLayer("ADBE Root Vectors Group")),
                                                      effect || (effect = thisLayer(4)),
                                                      (hasParent = !(!elem.hierarchy || !elem.hierarchy.length)) &&
                                                          !parent &&
                                                          (parent = elem.hierarchy[0].layerInterface),
                                                      (time = this.comp.renderedFrame / this.comp.globalData.frameRate),
                                                      _needsRandom && seedRandom(randSeed + time),
                                                      needsVelocity && (velocity = velocityAtTime(time)),
                                                      expression_function(),
                                                      (this.frameExpressionId = elem.globalData.frameId),
                                                      (scoped_bm_rt =
                                                          scoped_bm_rt.propType === propTypes.SHAPE
                                                              ? scoped_bm_rt.v
                                                              : scoped_bm_rt))
                                            );
                                        }
                                        return (
                                            (executeExpression.__preventDeadCodeRemoval = [
                                                $bm_transform,
                                                anchorPoint,
                                                time,
                                                velocity,
                                                inPoint,
                                                outPoint,
                                                width,
                                                height,
                                                name,
                                                loop_in,
                                                loop_out,
                                                smooth,
                                                toComp,
                                                fromCompToSurface,
                                                toWorld,
                                                fromWorld,
                                                mask,
                                                position,
                                                rotation,
                                                scale,
                                                thisComp,
                                                numKeys,
                                                active,
                                                wiggle,
                                                loopInDuration,
                                                loopOutDuration,
                                                comp,
                                                lookAt,
                                                easeOut,
                                                easeIn,
                                                ease,
                                                nearestKey,
                                                key,
                                                text,
                                                textIndex,
                                                textTotal,
                                                selectorValue,
                                                framesToTime,
                                                timeToFrames,
                                                sourceRectAtTime,
                                                substring,
                                                substr,
                                                posterizeTime,
                                                index,
                                                globalData,
                                            ]),
                                            executeExpression
                                        );
                                    }
                                    return (
                                        (ob.initiateExpression = initiateExpression),
                                        (ob.__preventDeadCodeRemoval = [
                                            window,
                                            document,
                                            XMLHttpRequest,
                                            fetch,
                                            frames,
                                            $bm_neg,
                                            add,
                                            $bm_sum,
                                            $bm_sub,
                                            $bm_mul,
                                            $bm_div,
                                            $bm_mod,
                                            clamp,
                                            radians_to_degrees,
                                            degreesToRadians,
                                            degrees_to_radians,
                                            normalize,
                                            rgbToHsl,
                                            hslToRgb,
                                            linear,
                                            random,
                                            createPath,
                                        ]),
                                        ob
                                    );
                                })(),
                                expressionHelpers = {
                                    searchExpressions: function (t, e, r) {
                                        e.x &&
                                            ((r.k = !0),
                                            (r.x = !0),
                                            (r.initiateExpression = ExpressionManager.initiateExpression),
                                            r.effectsSequence.push(r.initiateExpression(t, e, r).bind(r)));
                                    },
                                    getSpeedAtTime: function (t) {
                                        var e = this.getValueAtTime(t),
                                            r = this.getValueAtTime(t + -0.01),
                                            i = 0;
                                        if (e.length) {
                                            var n;
                                            for (n = 0; n < e.length; n += 1) i += Math.pow(r[n] - e[n], 2);
                                            i = 100 * Math.sqrt(i);
                                        } else i = 0;
                                        return i;
                                    },
                                    getVelocityAtTime: function (t) {
                                        if (void 0 !== this.vel) return this.vel;
                                        var e,
                                            r,
                                            i = -0.001,
                                            n = this.getValueAtTime(t),
                                            s = this.getValueAtTime(t + i);
                                        if (n.length)
                                            for (e = createTypedArray("float32", n.length), r = 0; r < n.length; r += 1)
                                                e[r] = (s[r] - n[r]) / i;
                                        else e = (s - n) / i;
                                        return e;
                                    },
                                    getValueAtTime: function (t) {
                                        return (
                                            (t *= this.elem.globalData.frameRate),
                                            (t -= this.offsetTime) !== this._cachingAtTime.lastFrame &&
                                                ((this._cachingAtTime.lastIndex =
                                                    this._cachingAtTime.lastFrame < t
                                                        ? this._cachingAtTime.lastIndex
                                                        : 0),
                                                (this._cachingAtTime.value = this.interpolateValue(
                                                    t,
                                                    this._cachingAtTime
                                                )),
                                                (this._cachingAtTime.lastFrame = t)),
                                            this._cachingAtTime.value
                                        );
                                    },
                                    getStaticValueAtTime: function () {
                                        return this.pv;
                                    },
                                    setGroupProperty: function (t) {
                                        this.propertyGroup = t;
                                    },
                                };
                            function addPropertyDecorator() {
                                function t(t, e, r) {
                                    if (!this.k || !this.keyframes) return this.pv;
                                    t = t ? t.toLowerCase() : "";
                                    var i,
                                        n,
                                        s,
                                        a,
                                        o,
                                        l = this.comp.renderedFrame,
                                        h = this.keyframes,
                                        p = h[h.length - 1].t;
                                    if (l <= p) return this.pv;
                                    if (
                                        (r
                                            ? (n =
                                                  p -
                                                  (i = e
                                                      ? Math.abs(p - this.elem.comp.globalData.frameRate * e)
                                                      : Math.max(0, p - this.elem.data.ip)))
                                            : ((!e || e > h.length - 1) && (e = h.length - 1),
                                              (i = p - (n = h[h.length - 1 - e].t))),
                                        "pingpong" === t)
                                    ) {
                                        if (Math.floor((l - n) / i) % 2 != 0)
                                            return this.getValueAtTime(
                                                (i - ((l - n) % i) + n) / this.comp.globalData.frameRate,
                                                0
                                            );
                                    } else {
                                        if ("offset" === t) {
                                            var c = this.getValueAtTime(n / this.comp.globalData.frameRate, 0),
                                                d = this.getValueAtTime(p / this.comp.globalData.frameRate, 0),
                                                u = this.getValueAtTime(
                                                    (((l - n) % i) + n) / this.comp.globalData.frameRate,
                                                    0
                                                ),
                                                f = Math.floor((l - n) / i);
                                            if (this.pv.length) {
                                                for (a = (o = new Array(c.length)).length, s = 0; s < a; s += 1)
                                                    o[s] = (d[s] - c[s]) * f + u[s];
                                                return o;
                                            }
                                            return (d - c) * f + u;
                                        }
                                        if ("continue" === t) {
                                            var m = this.getValueAtTime(p / this.comp.globalData.frameRate, 0),
                                                g = this.getValueAtTime(
                                                    (p - 0.001) / this.comp.globalData.frameRate,
                                                    0
                                                );
                                            if (this.pv.length) {
                                                for (a = (o = new Array(m.length)).length, s = 0; s < a; s += 1)
                                                    o[s] =
                                                        m[s] +
                                                        ((m[s] - g[s]) * ((l - p) / this.comp.globalData.frameRate)) /
                                                            5e-4;
                                                return o;
                                            }
                                            return m + ((l - p) / 0.001) * (m - g);
                                        }
                                    }
                                    return this.getValueAtTime((((l - n) % i) + n) / this.comp.globalData.frameRate, 0);
                                }
                                function e(t, e, r) {
                                    if (!this.k) return this.pv;
                                    t = t ? t.toLowerCase() : "";
                                    var i,
                                        n,
                                        s,
                                        a,
                                        o,
                                        l = this.comp.renderedFrame,
                                        h = this.keyframes,
                                        p = h[0].t;
                                    if (l >= p) return this.pv;
                                    if (
                                        (r
                                            ? (n =
                                                  p +
                                                  (i = e
                                                      ? Math.abs(this.elem.comp.globalData.frameRate * e)
                                                      : Math.max(0, this.elem.data.op - p)))
                                            : ((!e || e > h.length - 1) && (e = h.length - 1), (i = (n = h[e].t) - p)),
                                        "pingpong" === t)
                                    ) {
                                        if (Math.floor((p - l) / i) % 2 == 0)
                                            return this.getValueAtTime(
                                                (((p - l) % i) + p) / this.comp.globalData.frameRate,
                                                0
                                            );
                                    } else {
                                        if ("offset" === t) {
                                            var c = this.getValueAtTime(p / this.comp.globalData.frameRate, 0),
                                                d = this.getValueAtTime(n / this.comp.globalData.frameRate, 0),
                                                u = this.getValueAtTime(
                                                    (i - ((p - l) % i) + p) / this.comp.globalData.frameRate,
                                                    0
                                                ),
                                                f = Math.floor((p - l) / i) + 1;
                                            if (this.pv.length) {
                                                for (a = (o = new Array(c.length)).length, s = 0; s < a; s += 1)
                                                    o[s] = u[s] - (d[s] - c[s]) * f;
                                                return o;
                                            }
                                            return u - (d - c) * f;
                                        }
                                        if ("continue" === t) {
                                            var m = this.getValueAtTime(p / this.comp.globalData.frameRate, 0),
                                                g = this.getValueAtTime(
                                                    (p + 0.001) / this.comp.globalData.frameRate,
                                                    0
                                                );
                                            if (this.pv.length) {
                                                for (a = (o = new Array(m.length)).length, s = 0; s < a; s += 1)
                                                    o[s] = m[s] + ((m[s] - g[s]) * (p - l)) / 0.001;
                                                return o;
                                            }
                                            return m + ((m - g) * (p - l)) / 0.001;
                                        }
                                    }
                                    return this.getValueAtTime(
                                        (i - (((p - l) % i) + p)) / this.comp.globalData.frameRate,
                                        0
                                    );
                                }
                                function r(t, e) {
                                    if (!this.k) return this.pv;
                                    if (((t = 0.5 * (t || 0.4)), (e = Math.floor(e || 5)) <= 1)) return this.pv;
                                    var r,
                                        i,
                                        n = this.comp.renderedFrame / this.comp.globalData.frameRate,
                                        s = n - t,
                                        a = e > 1 ? (n + t - s) / (e - 1) : 1,
                                        o = 0,
                                        l = 0;
                                    for (
                                        r = this.pv.length ? createTypedArray("float32", this.pv.length) : 0;
                                        o < e;

                                    ) {
                                        if (((i = this.getValueAtTime(s + o * a)), this.pv.length))
                                            for (l = 0; l < this.pv.length; l += 1) r[l] += i[l];
                                        else r += i;
                                        o += 1;
                                    }
                                    if (this.pv.length) for (l = 0; l < this.pv.length; l += 1) r[l] /= e;
                                    else r /= e;
                                    return r;
                                }
                                function i(t) {
                                    this._transformCachingAtTime ||
                                        (this._transformCachingAtTime = { v: new Matrix() });
                                    var e = this._transformCachingAtTime.v;
                                    if ((e.cloneFromProps(this.pre.props), this.appliedTransformations < 1)) {
                                        var r = this.a.getValueAtTime(t);
                                        e.translate(-r[0] * this.a.mult, -r[1] * this.a.mult, r[2] * this.a.mult);
                                    }
                                    if (this.appliedTransformations < 2) {
                                        var i = this.s.getValueAtTime(t);
                                        e.scale(i[0] * this.s.mult, i[1] * this.s.mult, i[2] * this.s.mult);
                                    }
                                    if (this.sk && this.appliedTransformations < 3) {
                                        var n = this.sk.getValueAtTime(t),
                                            s = this.sa.getValueAtTime(t);
                                        e.skewFromAxis(-n * this.sk.mult, s * this.sa.mult);
                                    }
                                    if (this.r && this.appliedTransformations < 4) {
                                        var a = this.r.getValueAtTime(t);
                                        e.rotate(-a * this.r.mult);
                                    } else if (!this.r && this.appliedTransformations < 4) {
                                        var o = this.rz.getValueAtTime(t),
                                            l = this.ry.getValueAtTime(t),
                                            h = this.rx.getValueAtTime(t),
                                            p = this.or.getValueAtTime(t);
                                        e.rotateZ(-o * this.rz.mult)
                                            .rotateY(l * this.ry.mult)
                                            .rotateX(h * this.rx.mult)
                                            .rotateZ(-p[2] * this.or.mult)
                                            .rotateY(p[1] * this.or.mult)
                                            .rotateX(p[0] * this.or.mult);
                                    }
                                    if (this.data.p && this.data.p.s) {
                                        var c = this.px.getValueAtTime(t),
                                            d = this.py.getValueAtTime(t);
                                        if (this.data.p.z) {
                                            var u = this.pz.getValueAtTime(t);
                                            e.translate(c * this.px.mult, d * this.py.mult, -u * this.pz.mult);
                                        } else e.translate(c * this.px.mult, d * this.py.mult, 0);
                                    } else {
                                        var f = this.p.getValueAtTime(t);
                                        e.translate(f[0] * this.p.mult, f[1] * this.p.mult, -f[2] * this.p.mult);
                                    }
                                    return e;
                                }
                                function n() {
                                    return this.v.clone(new Matrix());
                                }
                                var s = TransformPropertyFactory.getTransformProperty;
                                TransformPropertyFactory.getTransformProperty = function (t, e, r) {
                                    var a = s(t, e, r);
                                    return (
                                        a.dynamicProperties.length
                                            ? (a.getValueAtTime = i.bind(a))
                                            : (a.getValueAtTime = n.bind(a)),
                                        (a.setGroupProperty = expressionHelpers.setGroupProperty),
                                        a
                                    );
                                };
                                var a = PropertyFactory.getProp;
                                PropertyFactory.getProp = function (i, n, s, o, l) {
                                    var h = a(i, n, s, o, l);
                                    h.kf
                                        ? (h.getValueAtTime = expressionHelpers.getValueAtTime.bind(h))
                                        : (h.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(h)),
                                        (h.setGroupProperty = expressionHelpers.setGroupProperty),
                                        (h.loopOut = t),
                                        (h.loopIn = e),
                                        (h.smooth = r),
                                        (h.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(h)),
                                        (h.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(h)),
                                        (h.numKeys = 1 === n.a ? n.k.length : 0),
                                        (h.propertyIndex = n.ix);
                                    var p = 0;
                                    return (
                                        0 !== s &&
                                            (p = createTypedArray("float32", 1 === n.a ? n.k[0].s.length : n.k.length)),
                                        (h._cachingAtTime = { lastFrame: initialDefaultFrame, lastIndex: 0, value: p }),
                                        expressionHelpers.searchExpressions(i, n, h),
                                        h.k && l.addDynamicProperty(h),
                                        h
                                    );
                                };
                                var o = ShapePropertyFactory.getConstructorFunction(),
                                    l = ShapePropertyFactory.getKeyframedConstructorFunction();
                                function h() {}
                                (h.prototype = {
                                    vertices: function (t, e) {
                                        this.k && this.getValue();
                                        var r,
                                            i = this.v;
                                        void 0 !== e && (i = this.getValueAtTime(e, 0));
                                        var n = i._length,
                                            s = i[t],
                                            a = i.v,
                                            o = createSizedArray(n);
                                        for (r = 0; r < n; r += 1)
                                            o[r] =
                                                "i" === t || "o" === t
                                                    ? [s[r][0] - a[r][0], s[r][1] - a[r][1]]
                                                    : [s[r][0], s[r][1]];
                                        return o;
                                    },
                                    points: function (t) {
                                        return this.vertices("v", t);
                                    },
                                    inTangents: function (t) {
                                        return this.vertices("i", t);
                                    },
                                    outTangents: function (t) {
                                        return this.vertices("o", t);
                                    },
                                    isClosed: function () {
                                        return this.v.c;
                                    },
                                    pointOnPath: function (t, e) {
                                        var r = this.v;
                                        void 0 !== e && (r = this.getValueAtTime(e, 0)),
                                            this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(r));
                                        for (
                                            var i,
                                                n = this._segmentsLength,
                                                s = n.lengths,
                                                a = n.totalLength * t,
                                                o = 0,
                                                l = s.length,
                                                h = 0;
                                            o < l;

                                        ) {
                                            if (h + s[o].addedLength > a) {
                                                var p = o,
                                                    c = r.c && o === l - 1 ? 0 : o + 1,
                                                    d = (a - h) / s[o].addedLength;
                                                i = bez.getPointInSegment(r.v[p], r.v[c], r.o[p], r.i[c], d, s[o]);
                                                break;
                                            }
                                            (h += s[o].addedLength), (o += 1);
                                        }
                                        return (
                                            i ||
                                                (i = r.c
                                                    ? [r.v[0][0], r.v[0][1]]
                                                    : [r.v[r._length - 1][0], r.v[r._length - 1][1]]),
                                            i
                                        );
                                    },
                                    vectorOnPath: function (t, e, r) {
                                        1 == t ? (t = this.v.c) : 0 == t && (t = 0.999);
                                        var i = this.pointOnPath(t, e),
                                            n = this.pointOnPath(t + 0.001, e),
                                            s = n[0] - i[0],
                                            a = n[1] - i[1],
                                            o = Math.sqrt(Math.pow(s, 2) + Math.pow(a, 2));
                                        return 0 === o ? [0, 0] : "tangent" === r ? [s / o, a / o] : [-a / o, s / o];
                                    },
                                    tangentOnPath: function (t, e) {
                                        return this.vectorOnPath(t, e, "tangent");
                                    },
                                    normalOnPath: function (t, e) {
                                        return this.vectorOnPath(t, e, "normal");
                                    },
                                    setGroupProperty: expressionHelpers.setGroupProperty,
                                    getValueAtTime: expressionHelpers.getStaticValueAtTime,
                                }),
                                    extendPrototype([h], o),
                                    extendPrototype([h], l),
                                    (l.prototype.getValueAtTime = function (t) {
                                        return (
                                            this._cachingAtTime ||
                                                (this._cachingAtTime = {
                                                    shapeValue: shapePool.clone(this.pv),
                                                    lastIndex: 0,
                                                    lastTime: initialDefaultFrame,
                                                }),
                                            (t *= this.elem.globalData.frameRate),
                                            (t -= this.offsetTime) !== this._cachingAtTime.lastTime &&
                                                ((this._cachingAtTime.lastIndex =
                                                    this._cachingAtTime.lastTime < t ? this._caching.lastIndex : 0),
                                                (this._cachingAtTime.lastTime = t),
                                                this.interpolateShape(
                                                    t,
                                                    this._cachingAtTime.shapeValue,
                                                    this._cachingAtTime
                                                )),
                                            this._cachingAtTime.shapeValue
                                        );
                                    }),
                                    (l.prototype.initiateExpression = ExpressionManager.initiateExpression);
                                var p = ShapePropertyFactory.getShapeProp;
                                ShapePropertyFactory.getShapeProp = function (t, e, r, i, n) {
                                    var s = p(t, e, r, i, n);
                                    return (
                                        (s.propertyIndex = e.ix),
                                        (s.lock = !1),
                                        3 === r
                                            ? expressionHelpers.searchExpressions(t, e.pt, s)
                                            : 4 === r && expressionHelpers.searchExpressions(t, e.ks, s),
                                        s.k && t.addDynamicProperty(s),
                                        s
                                    );
                                };
                            }
                            function initialize$1() {
                                addPropertyDecorator();
                            }
                            function addDecorator() {
                                (TextProperty.prototype.getExpressionValue = function (t, e) {
                                    var r = this.calculateExpression(e);
                                    if (t.t !== r) {
                                        var i = {};
                                        return this.copyData(i, t), (i.t = r.toString()), (i.__complete = !1), i;
                                    }
                                    return t;
                                }),
                                    (TextProperty.prototype.searchProperty = function () {
                                        var t = this.searchKeyframes(),
                                            e = this.searchExpressions();
                                        return (this.kf = t || e), this.kf;
                                    }),
                                    (TextProperty.prototype.searchExpressions = function () {
                                        return this.data.d.x
                                            ? ((this.calculateExpression = ExpressionManager.initiateExpression.bind(
                                                  this
                                              )(this.elem, this.data.d, this)),
                                              this.addEffect(this.getExpressionValue.bind(this)),
                                              !0)
                                            : null;
                                    });
                            }
                            function initialize() {
                                addDecorator();
                            }
                            function SVGComposableEffect() {}
                            function SVGTintFilter(t, e, r, i, n) {
                                this.filterManager = e;
                                var s = createNS("feColorMatrix");
                                s.setAttribute("type", "matrix"),
                                    s.setAttribute("color-interpolation-filters", "linearRGB"),
                                    s.setAttribute(
                                        "values",
                                        "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"
                                    ),
                                    s.setAttribute("result", i + "_tint_1"),
                                    t.appendChild(s),
                                    (s = createNS("feColorMatrix")).setAttribute("type", "matrix"),
                                    s.setAttribute("color-interpolation-filters", "sRGB"),
                                    s.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"),
                                    s.setAttribute("result", i + "_tint_2"),
                                    t.appendChild(s),
                                    (this.matrixFilter = s);
                                var a = this.createMergeNode(i, [n, i + "_tint_1", i + "_tint_2"]);
                                t.appendChild(a);
                            }
                            function SVGFillFilter(t, e, r, i) {
                                this.filterManager = e;
                                var n = createNS("feColorMatrix");
                                n.setAttribute("type", "matrix"),
                                    n.setAttribute("color-interpolation-filters", "sRGB"),
                                    n.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"),
                                    n.setAttribute("result", i),
                                    t.appendChild(n),
                                    (this.matrixFilter = n);
                            }
                            function SVGStrokeEffect(t, e, r) {
                                (this.initialized = !1), (this.filterManager = e), (this.elem = r), (this.paths = []);
                            }
                            function SVGTritoneFilter(t, e, r, i) {
                                this.filterManager = e;
                                var n = createNS("feColorMatrix");
                                n.setAttribute("type", "matrix"),
                                    n.setAttribute("color-interpolation-filters", "linearRGB"),
                                    n.setAttribute(
                                        "values",
                                        "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"
                                    ),
                                    t.appendChild(n);
                                var s = createNS("feComponentTransfer");
                                s.setAttribute("color-interpolation-filters", "sRGB"),
                                    s.setAttribute("result", i),
                                    (this.matrixFilter = s);
                                var a = createNS("feFuncR");
                                a.setAttribute("type", "table"), s.appendChild(a), (this.feFuncR = a);
                                var o = createNS("feFuncG");
                                o.setAttribute("type", "table"), s.appendChild(o), (this.feFuncG = o);
                                var l = createNS("feFuncB");
                                l.setAttribute("type", "table"), s.appendChild(l), (this.feFuncB = l), t.appendChild(s);
                            }
                            function SVGProLevelsFilter(t, e, r, i) {
                                this.filterManager = e;
                                var n = this.filterManager.effectElements,
                                    s = createNS("feComponentTransfer");
                                (n[10].p.k ||
                                    0 !== n[10].p.v ||
                                    n[11].p.k ||
                                    1 !== n[11].p.v ||
                                    n[12].p.k ||
                                    1 !== n[12].p.v ||
                                    n[13].p.k ||
                                    0 !== n[13].p.v ||
                                    n[14].p.k ||
                                    1 !== n[14].p.v) &&
                                    (this.feFuncR = this.createFeFunc("feFuncR", s)),
                                    (n[17].p.k ||
                                        0 !== n[17].p.v ||
                                        n[18].p.k ||
                                        1 !== n[18].p.v ||
                                        n[19].p.k ||
                                        1 !== n[19].p.v ||
                                        n[20].p.k ||
                                        0 !== n[20].p.v ||
                                        n[21].p.k ||
                                        1 !== n[21].p.v) &&
                                        (this.feFuncG = this.createFeFunc("feFuncG", s)),
                                    (n[24].p.k ||
                                        0 !== n[24].p.v ||
                                        n[25].p.k ||
                                        1 !== n[25].p.v ||
                                        n[26].p.k ||
                                        1 !== n[26].p.v ||
                                        n[27].p.k ||
                                        0 !== n[27].p.v ||
                                        n[28].p.k ||
                                        1 !== n[28].p.v) &&
                                        (this.feFuncB = this.createFeFunc("feFuncB", s)),
                                    (n[31].p.k ||
                                        0 !== n[31].p.v ||
                                        n[32].p.k ||
                                        1 !== n[32].p.v ||
                                        n[33].p.k ||
                                        1 !== n[33].p.v ||
                                        n[34].p.k ||
                                        0 !== n[34].p.v ||
                                        n[35].p.k ||
                                        1 !== n[35].p.v) &&
                                        (this.feFuncA = this.createFeFunc("feFuncA", s)),
                                    (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) &&
                                        (s.setAttribute("color-interpolation-filters", "sRGB"), t.appendChild(s)),
                                    (n[3].p.k ||
                                        0 !== n[3].p.v ||
                                        n[4].p.k ||
                                        1 !== n[4].p.v ||
                                        n[5].p.k ||
                                        1 !== n[5].p.v ||
                                        n[6].p.k ||
                                        0 !== n[6].p.v ||
                                        n[7].p.k ||
                                        1 !== n[7].p.v) &&
                                        ((s = createNS("feComponentTransfer")).setAttribute(
                                            "color-interpolation-filters",
                                            "sRGB"
                                        ),
                                        s.setAttribute("result", i),
                                        t.appendChild(s),
                                        (this.feFuncRComposed = this.createFeFunc("feFuncR", s)),
                                        (this.feFuncGComposed = this.createFeFunc("feFuncG", s)),
                                        (this.feFuncBComposed = this.createFeFunc("feFuncB", s)));
                            }
                            function SVGDropShadowEffect(t, e, r, i, n) {
                                var s = e.container.globalData.renderConfig.filterSize,
                                    a = e.data.fs || s;
                                t.setAttribute("x", a.x || s.x),
                                    t.setAttribute("y", a.y || s.y),
                                    t.setAttribute("width", a.width || s.width),
                                    t.setAttribute("height", a.height || s.height),
                                    (this.filterManager = e);
                                var o = createNS("feGaussianBlur");
                                o.setAttribute("in", "SourceAlpha"),
                                    o.setAttribute("result", i + "_drop_shadow_1"),
                                    o.setAttribute("stdDeviation", "0"),
                                    (this.feGaussianBlur = o),
                                    t.appendChild(o);
                                var l = createNS("feOffset");
                                l.setAttribute("dx", "25"),
                                    l.setAttribute("dy", "0"),
                                    l.setAttribute("in", i + "_drop_shadow_1"),
                                    l.setAttribute("result", i + "_drop_shadow_2"),
                                    (this.feOffset = l),
                                    t.appendChild(l);
                                var h = createNS("feFlood");
                                h.setAttribute("flood-color", "#00ff00"),
                                    h.setAttribute("flood-opacity", "1"),
                                    h.setAttribute("result", i + "_drop_shadow_3"),
                                    (this.feFlood = h),
                                    t.appendChild(h);
                                var p = createNS("feComposite");
                                p.setAttribute("in", i + "_drop_shadow_3"),
                                    p.setAttribute("in2", i + "_drop_shadow_2"),
                                    p.setAttribute("operator", "in"),
                                    p.setAttribute("result", i + "_drop_shadow_4"),
                                    t.appendChild(p);
                                var c = this.createMergeNode(i, [i + "_drop_shadow_4", n]);
                                t.appendChild(c);
                            }
                            (SVGComposableEffect.prototype = {
                                createMergeNode: function (t, e) {
                                    var r,
                                        i,
                                        n = createNS("feMerge");
                                    for (n.setAttribute("result", t), i = 0; i < e.length; i += 1)
                                        (r = createNS("feMergeNode")).setAttribute("in", e[i]),
                                            n.appendChild(r),
                                            n.appendChild(r);
                                    return n;
                                },
                            }),
                                extendPrototype([SVGComposableEffect], SVGTintFilter),
                                (SVGTintFilter.prototype.renderFrame = function (t) {
                                    if (t || this.filterManager._mdf) {
                                        var e = this.filterManager.effectElements[0].p.v,
                                            r = this.filterManager.effectElements[1].p.v,
                                            i = this.filterManager.effectElements[2].p.v / 100;
                                        this.matrixFilter.setAttribute(
                                            "values",
                                            r[0] -
                                                e[0] +
                                                " 0 0 0 " +
                                                e[0] +
                                                " " +
                                                (r[1] - e[1]) +
                                                " 0 0 0 " +
                                                e[1] +
                                                " " +
                                                (r[2] - e[2]) +
                                                " 0 0 0 " +
                                                e[2] +
                                                " 0 0 0 " +
                                                i +
                                                " 0"
                                        );
                                    }
                                }),
                                (SVGFillFilter.prototype.renderFrame = function (t) {
                                    if (t || this.filterManager._mdf) {
                                        var e = this.filterManager.effectElements[2].p.v,
                                            r = this.filterManager.effectElements[6].p.v;
                                        this.matrixFilter.setAttribute(
                                            "values",
                                            "0 0 0 0 " +
                                                e[0] +
                                                " 0 0 0 0 " +
                                                e[1] +
                                                " 0 0 0 0 " +
                                                e[2] +
                                                " 0 0 0 " +
                                                r +
                                                " 0"
                                        );
                                    }
                                }),
                                (SVGStrokeEffect.prototype.initialize = function () {
                                    var t,
                                        e,
                                        r,
                                        i,
                                        n = this.elem.layerElement.children || this.elem.layerElement.childNodes;
                                    for (
                                        1 === this.filterManager.effectElements[1].p.v
                                            ? ((i = this.elem.maskManager.masksProperties.length), (r = 0))
                                            : (i = 1 + (r = this.filterManager.effectElements[0].p.v - 1)),
                                            (e = createNS("g")).setAttribute("fill", "none"),
                                            e.setAttribute("stroke-linecap", "round"),
                                            e.setAttribute("stroke-dashoffset", 1);
                                        r < i;
                                        r += 1
                                    )
                                        (t = createNS("path")), e.appendChild(t), this.paths.push({ p: t, m: r });
                                    if (3 === this.filterManager.effectElements[10].p.v) {
                                        var s = createNS("mask"),
                                            a = createElementID();
                                        s.setAttribute("id", a),
                                            s.setAttribute("mask-type", "alpha"),
                                            s.appendChild(e),
                                            this.elem.globalData.defs.appendChild(s);
                                        var o = createNS("g");
                                        for (o.setAttribute("mask", "url(" + getLocationHref() + "#" + a + ")"); n[0]; )
                                            o.appendChild(n[0]);
                                        this.elem.layerElement.appendChild(o),
                                            (this.masker = s),
                                            e.setAttribute("stroke", "#fff");
                                    } else if (
                                        1 === this.filterManager.effectElements[10].p.v ||
                                        2 === this.filterManager.effectElements[10].p.v
                                    ) {
                                        if (2 === this.filterManager.effectElements[10].p.v)
                                            for (
                                                n =
                                                    this.elem.layerElement.children ||
                                                    this.elem.layerElement.childNodes;
                                                n.length;

                                            )
                                                this.elem.layerElement.removeChild(n[0]);
                                        this.elem.layerElement.appendChild(e),
                                            this.elem.layerElement.removeAttribute("mask"),
                                            e.setAttribute("stroke", "#fff");
                                    }
                                    (this.initialized = !0), (this.pathMasker = e);
                                }),
                                (SVGStrokeEffect.prototype.renderFrame = function (t) {
                                    var e;
                                    this.initialized || this.initialize();
                                    var r,
                                        i,
                                        n = this.paths.length;
                                    for (e = 0; e < n; e += 1)
                                        if (
                                            -1 !== this.paths[e].m &&
                                            ((r = this.elem.maskManager.viewData[this.paths[e].m]),
                                            (i = this.paths[e].p),
                                            (t || this.filterManager._mdf || r.prop._mdf) &&
                                                i.setAttribute("d", r.lastPath),
                                            t ||
                                                this.filterManager.effectElements[9].p._mdf ||
                                                this.filterManager.effectElements[4].p._mdf ||
                                                this.filterManager.effectElements[7].p._mdf ||
                                                this.filterManager.effectElements[8].p._mdf ||
                                                r.prop._mdf)
                                        ) {
                                            var s;
                                            if (
                                                0 !== this.filterManager.effectElements[7].p.v ||
                                                100 !== this.filterManager.effectElements[8].p.v
                                            ) {
                                                var a =
                                                        0.01 *
                                                        Math.min(
                                                            this.filterManager.effectElements[7].p.v,
                                                            this.filterManager.effectElements[8].p.v
                                                        ),
                                                    o =
                                                        0.01 *
                                                        Math.max(
                                                            this.filterManager.effectElements[7].p.v,
                                                            this.filterManager.effectElements[8].p.v
                                                        ),
                                                    l = i.getTotalLength();
                                                s = "0 0 0 " + l * a + " ";
                                                var h,
                                                    p = l * (o - a),
                                                    c =
                                                        1 +
                                                        2 *
                                                            this.filterManager.effectElements[4].p.v *
                                                            this.filterManager.effectElements[9].p.v *
                                                            0.01,
                                                    d = Math.floor(p / c);
                                                for (h = 0; h < d; h += 1)
                                                    s +=
                                                        "1 " +
                                                        2 *
                                                            this.filterManager.effectElements[4].p.v *
                                                            this.filterManager.effectElements[9].p.v *
                                                            0.01 +
                                                        " ";
                                                s += "0 " + 10 * l + " 0 0";
                                            } else
                                                s =
                                                    "1 " +
                                                    2 *
                                                        this.filterManager.effectElements[4].p.v *
                                                        this.filterManager.effectElements[9].p.v *
                                                        0.01;
                                            i.setAttribute("stroke-dasharray", s);
                                        }
                                    if (
                                        ((t || this.filterManager.effectElements[4].p._mdf) &&
                                            this.pathMasker.setAttribute(
                                                "stroke-width",
                                                2 * this.filterManager.effectElements[4].p.v
                                            ),
                                        (t || this.filterManager.effectElements[6].p._mdf) &&
                                            this.pathMasker.setAttribute(
                                                "opacity",
                                                this.filterManager.effectElements[6].p.v
                                            ),
                                        (1 === this.filterManager.effectElements[10].p.v ||
                                            2 === this.filterManager.effectElements[10].p.v) &&
                                            (t || this.filterManager.effectElements[3].p._mdf))
                                    ) {
                                        var u = this.filterManager.effectElements[3].p.v;
                                        this.pathMasker.setAttribute(
                                            "stroke",
                                            "rgb(" +
                                                bmFloor(255 * u[0]) +
                                                "," +
                                                bmFloor(255 * u[1]) +
                                                "," +
                                                bmFloor(255 * u[2]) +
                                                ")"
                                        );
                                    }
                                }),
                                (SVGTritoneFilter.prototype.renderFrame = function (t) {
                                    if (t || this.filterManager._mdf) {
                                        var e = this.filterManager.effectElements[0].p.v,
                                            r = this.filterManager.effectElements[1].p.v,
                                            i = this.filterManager.effectElements[2].p.v,
                                            n = i[0] + " " + r[0] + " " + e[0],
                                            s = i[1] + " " + r[1] + " " + e[1],
                                            a = i[2] + " " + r[2] + " " + e[2];
                                        this.feFuncR.setAttribute("tableValues", n),
                                            this.feFuncG.setAttribute("tableValues", s),
                                            this.feFuncB.setAttribute("tableValues", a);
                                    }
                                }),
                                (SVGProLevelsFilter.prototype.createFeFunc = function (t, e) {
                                    var r = createNS(t);
                                    return r.setAttribute("type", "table"), e.appendChild(r), r;
                                }),
                                (SVGProLevelsFilter.prototype.getTableValue = function (t, e, r, i, n) {
                                    for (
                                        var s,
                                            a,
                                            o = 0,
                                            l = Math.min(t, e),
                                            h = Math.max(t, e),
                                            p = Array.call(null, { length: 256 }),
                                            c = 0,
                                            d = n - i,
                                            u = e - t;
                                        o <= 256;

                                    )
                                        (a =
                                            (s = o / 256) <= l
                                                ? u < 0
                                                    ? n
                                                    : i
                                                : s >= h
                                                  ? u < 0
                                                      ? i
                                                      : n
                                                  : i + d * Math.pow((s - t) / u, 1 / r)),
                                            (p[c] = a),
                                            (c += 1),
                                            (o += 256 / 255);
                                    return p.join(" ");
                                }),
                                (SVGProLevelsFilter.prototype.renderFrame = function (t) {
                                    if (t || this.filterManager._mdf) {
                                        var e,
                                            r = this.filterManager.effectElements;
                                        this.feFuncRComposed &&
                                            (t ||
                                                r[3].p._mdf ||
                                                r[4].p._mdf ||
                                                r[5].p._mdf ||
                                                r[6].p._mdf ||
                                                r[7].p._mdf) &&
                                            ((e = this.getTableValue(r[3].p.v, r[4].p.v, r[5].p.v, r[6].p.v, r[7].p.v)),
                                            this.feFuncRComposed.setAttribute("tableValues", e),
                                            this.feFuncGComposed.setAttribute("tableValues", e),
                                            this.feFuncBComposed.setAttribute("tableValues", e)),
                                            this.feFuncR &&
                                                (t ||
                                                    r[10].p._mdf ||
                                                    r[11].p._mdf ||
                                                    r[12].p._mdf ||
                                                    r[13].p._mdf ||
                                                    r[14].p._mdf) &&
                                                ((e = this.getTableValue(
                                                    r[10].p.v,
                                                    r[11].p.v,
                                                    r[12].p.v,
                                                    r[13].p.v,
                                                    r[14].p.v
                                                )),
                                                this.feFuncR.setAttribute("tableValues", e)),
                                            this.feFuncG &&
                                                (t ||
                                                    r[17].p._mdf ||
                                                    r[18].p._mdf ||
                                                    r[19].p._mdf ||
                                                    r[20].p._mdf ||
                                                    r[21].p._mdf) &&
                                                ((e = this.getTableValue(
                                                    r[17].p.v,
                                                    r[18].p.v,
                                                    r[19].p.v,
                                                    r[20].p.v,
                                                    r[21].p.v
                                                )),
                                                this.feFuncG.setAttribute("tableValues", e)),
                                            this.feFuncB &&
                                                (t ||
                                                    r[24].p._mdf ||
                                                    r[25].p._mdf ||
                                                    r[26].p._mdf ||
                                                    r[27].p._mdf ||
                                                    r[28].p._mdf) &&
                                                ((e = this.getTableValue(
                                                    r[24].p.v,
                                                    r[25].p.v,
                                                    r[26].p.v,
                                                    r[27].p.v,
                                                    r[28].p.v
                                                )),
                                                this.feFuncB.setAttribute("tableValues", e)),
                                            this.feFuncA &&
                                                (t ||
                                                    r[31].p._mdf ||
                                                    r[32].p._mdf ||
                                                    r[33].p._mdf ||
                                                    r[34].p._mdf ||
                                                    r[35].p._mdf) &&
                                                ((e = this.getTableValue(
                                                    r[31].p.v,
                                                    r[32].p.v,
                                                    r[33].p.v,
                                                    r[34].p.v,
                                                    r[35].p.v
                                                )),
                                                this.feFuncA.setAttribute("tableValues", e));
                                    }
                                }),
                                extendPrototype([SVGComposableEffect], SVGDropShadowEffect),
                                (SVGDropShadowEffect.prototype.renderFrame = function (t) {
                                    if (t || this.filterManager._mdf) {
                                        if (
                                            ((t || this.filterManager.effectElements[4].p._mdf) &&
                                                this.feGaussianBlur.setAttribute(
                                                    "stdDeviation",
                                                    this.filterManager.effectElements[4].p.v / 4
                                                ),
                                            t || this.filterManager.effectElements[0].p._mdf)
                                        ) {
                                            var e = this.filterManager.effectElements[0].p.v;
                                            this.feFlood.setAttribute(
                                                "flood-color",
                                                rgbToHex(
                                                    Math.round(255 * e[0]),
                                                    Math.round(255 * e[1]),
                                                    Math.round(255 * e[2])
                                                )
                                            );
                                        }
                                        if (
                                            ((t || this.filterManager.effectElements[1].p._mdf) &&
                                                this.feFlood.setAttribute(
                                                    "flood-opacity",
                                                    this.filterManager.effectElements[1].p.v / 255
                                                ),
                                            t ||
                                                this.filterManager.effectElements[2].p._mdf ||
                                                this.filterManager.effectElements[3].p._mdf)
                                        ) {
                                            var r = this.filterManager.effectElements[3].p.v,
                                                i = (this.filterManager.effectElements[2].p.v - 90) * degToRads,
                                                n = r * Math.cos(i),
                                                s = r * Math.sin(i);
                                            this.feOffset.setAttribute("dx", n), this.feOffset.setAttribute("dy", s);
                                        }
                                    }
                                });
                            var _svgMatteSymbols = [];
                            function SVGMatte3Effect(t, e, r) {
                                (this.initialized = !1),
                                    (this.filterManager = e),
                                    (this.filterElem = t),
                                    (this.elem = r),
                                    (r.matteElement = createNS("g")),
                                    r.matteElement.appendChild(r.layerElement),
                                    r.matteElement.appendChild(r.transformedElement),
                                    (r.baseElement = r.matteElement);
                            }
                            function SVGGaussianBlurEffect(t, e, r, i) {
                                t.setAttribute("x", "-100%"),
                                    t.setAttribute("y", "-100%"),
                                    t.setAttribute("width", "300%"),
                                    t.setAttribute("height", "300%"),
                                    (this.filterManager = e);
                                var n = createNS("feGaussianBlur");
                                n.setAttribute("result", i), t.appendChild(n), (this.feGaussianBlur = n);
                            }
                            return (
                                (SVGMatte3Effect.prototype.findSymbol = function (t) {
                                    for (var e = 0, r = _svgMatteSymbols.length; e < r; ) {
                                        if (_svgMatteSymbols[e] === t) return _svgMatteSymbols[e];
                                        e += 1;
                                    }
                                    return null;
                                }),
                                (SVGMatte3Effect.prototype.replaceInParent = function (t, e) {
                                    var r = t.layerElement.parentNode;
                                    if (r) {
                                        for (
                                            var i, n = r.children, s = 0, a = n.length;
                                            s < a && n[s] !== t.layerElement;

                                        )
                                            s += 1;
                                        s <= a - 2 && (i = n[s + 1]);
                                        var o = createNS("use");
                                        o.setAttribute("href", "#" + e), i ? r.insertBefore(o, i) : r.appendChild(o);
                                    }
                                }),
                                (SVGMatte3Effect.prototype.setElementAsMask = function (t, e) {
                                    if (!this.findSymbol(e)) {
                                        var r = createElementID(),
                                            i = createNS("mask");
                                        i.setAttribute("id", e.layerId),
                                            i.setAttribute("mask-type", "alpha"),
                                            _svgMatteSymbols.push(e);
                                        var n = t.globalData.defs;
                                        n.appendChild(i);
                                        var s = createNS("symbol");
                                        s.setAttribute("id", r),
                                            this.replaceInParent(e, r),
                                            s.appendChild(e.layerElement),
                                            n.appendChild(s);
                                        var a = createNS("use");
                                        a.setAttribute("href", "#" + r), i.appendChild(a), (e.data.hd = !1), e.show();
                                    }
                                    t.setMatte(e.layerId);
                                }),
                                (SVGMatte3Effect.prototype.initialize = function () {
                                    for (
                                        var t = this.filterManager.effectElements[0].p.v,
                                            e = this.elem.comp.elements,
                                            r = 0,
                                            i = e.length;
                                        r < i;

                                    )
                                        e[r] && e[r].data.ind === t && this.setElementAsMask(this.elem, e[r]), (r += 1);
                                    this.initialized = !0;
                                }),
                                (SVGMatte3Effect.prototype.renderFrame = function () {
                                    this.initialized || this.initialize();
                                }),
                                (SVGGaussianBlurEffect.prototype.renderFrame = function (t) {
                                    if (t || this.filterManager._mdf) {
                                        var e = 0.3 * this.filterManager.effectElements[0].p.v,
                                            r = this.filterManager.effectElements[1].p.v,
                                            i = 3 == r ? 0 : e,
                                            n = 2 == r ? 0 : e;
                                        this.feGaussianBlur.setAttribute("stdDeviation", i + " " + n);
                                        var s = 1 == this.filterManager.effectElements[2].p.v ? "wrap" : "duplicate";
                                        this.feGaussianBlur.setAttribute("edgeMode", s);
                                    }
                                }),
                                registerRenderer("canvas", CanvasRenderer),
                                registerRenderer("html", HybridRenderer),
                                registerRenderer("svg", SVGRenderer),
                                ShapeModifiers.registerModifier("tm", TrimModifier),
                                ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier),
                                ShapeModifiers.registerModifier("rp", RepeaterModifier),
                                ShapeModifiers.registerModifier("rd", RoundCornersModifier),
                                ShapeModifiers.registerModifier("zz", ZigZagModifier),
                                ShapeModifiers.registerModifier("op", OffsetPathModifier),
                                setExpressionsPlugin(Expressions),
                                setExpressionInterfaces(getInterface),
                                initialize$1(),
                                initialize(),
                                registerEffect(20, SVGTintFilter, !0),
                                registerEffect(21, SVGFillFilter, !0),
                                registerEffect(22, SVGStrokeEffect, !1),
                                registerEffect(23, SVGTritoneFilter, !0),
                                registerEffect(24, SVGProLevelsFilter, !0),
                                registerEffect(25, SVGDropShadowEffect, !0),
                                registerEffect(28, SVGMatte3Effect, !1),
                                registerEffect(29, SVGGaussianBlurEffect, !0),
                                lottie
                            );
                        }),
                        (module.exports = factory()));
                },
            },
            __webpack_module_cache__ = {};
        function __webpack_require__(t) {
            var e = __webpack_module_cache__[t];
            if (void 0 !== e) return e.exports;
            var r = (__webpack_module_cache__[t] = { exports: {} });
            return __webpack_modules__[t].call(r.exports, r, r.exports, __webpack_require__), r.exports;
        }
        (__webpack_require__.amdO = {}),
            (__webpack_require__.n = (t) => {
                var e = t && t.__esModule ? () => t.default : () => t;
                return __webpack_require__.d(e, { a: e }), e;
            }),
            (__webpack_require__.d = (t, e) => {
                for (var r in e)
                    __webpack_require__.o(e, r) &&
                        !__webpack_require__.o(t, r) &&
                        Object.defineProperty(t, r, { enumerable: !0, get: e[r] });
            }),
            (__webpack_require__.g = (function () {
                if ("object" == typeof globalThis) return globalThis;
                try {
                    return this || new Function("return this")();
                } catch (t) {
                    if ("object" == typeof window) return window;
                }
            })()),
            (__webpack_require__.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e));
        var __webpack_exports__ = {};
        (() => {
            "use strict";
            function t(t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            }
            function e(t, e) {
                (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), (t.__proto__ = e);
            }
            var r,
                i,
                n,
                s,
                a,
                o,
                l,
                h,
                p,
                c,
                d,
                u,
                f,
                m,
                g,
                y = { autoSleep: 120, force3D: "auto", nullTargetWarn: 1, units: { lineHeight: "" } },
                v = { duration: 0.5, overwrite: !1, delay: 0 },
                b = 1e8,
                _ = 1e-8,
                x = 2 * Math.PI,
                S = x / 4,
                E = 0,
                w = Math.sqrt,
                P = Math.cos,
                T = Math.sin,
                C = function (t) {
                    return "string" == typeof t;
                },
                A = function (t) {
                    return "function" == typeof t;
                },
                k = function (t) {
                    return "number" == typeof t;
                },
                M = function (t) {
                    return void 0 === t;
                },
                D = function (t) {
                    return "object" == typeof t;
                },
                F = function (t) {
                    return !1 !== t;
                },
                I = function () {
                    return "undefined" != typeof window;
                },
                L = function (t) {
                    return A(t) || C(t);
                },
                B = ("function" == typeof ArrayBuffer && ArrayBuffer.isView) || function () {},
                V = Array.isArray,
                R = /(?:-?\.?\d|\.)+/gi,
                O = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
                z = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
                G = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
                N = /[+-]=-?[.\d]+/,
                q = /[^,'"\[\]\s]+/gi,
                H = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
                $ = {},
                j = {},
                W = function (t) {
                    return (j = xt(t, $)) && vr;
                },
                Y = function (t, e) {
                    return console.warn("Invalid property", t, "set to", e, "Missing plugin? gsap.registerPlugin()");
                },
                X = function (t, e) {
                    return !e && console.warn(t);
                },
                U = function (t, e) {
                    return (t && ($[t] = e) && j && (j[t] = e)) || $;
                },
                Z = function () {
                    return 0;
                },
                K = { suppressEvents: !0, isStart: !0, kill: !1 },
                J = { suppressEvents: !0, kill: !1 },
                Q = { suppressEvents: !0 },
                tt = {},
                et = [],
                rt = {},
                it = {},
                nt = {},
                st = 30,
                at = [],
                ot = "",
                lt = function (t) {
                    var e,
                        r,
                        i = t[0];
                    if ((D(i) || A(i) || (t = [t]), !(e = (i._gsap || {}).harness))) {
                        for (r = at.length; r-- && !at[r].targetTest(i); );
                        e = at[r];
                    }
                    for (r = t.length; r--; )
                        (t[r] && (t[r]._gsap || (t[r]._gsap = new Ie(t[r], e)))) || t.splice(r, 1);
                    return t;
                },
                ht = function (t) {
                    return t._gsap || lt(Jt(t))[0]._gsap;
                },
                pt = function (t, e, r) {
                    return (r = t[e]) && A(r) ? t[e]() : (M(r) && t.getAttribute && t.getAttribute(e)) || r;
                },
                ct = function (t, e) {
                    return (t = t.split(",")).forEach(e) || t;
                },
                dt = function (t) {
                    return Math.round(1e5 * t) / 1e5 || 0;
                },
                ut = function (t) {
                    return Math.round(1e7 * t) / 1e7 || 0;
                },
                ft = function (t, e) {
                    var r = e.charAt(0),
                        i = parseFloat(e.substr(2));
                    return (t = parseFloat(t)), "+" === r ? t + i : "-" === r ? t - i : "*" === r ? t * i : t / i;
                },
                mt = function (t, e) {
                    for (var r = e.length, i = 0; t.indexOf(e[i]) < 0 && ++i < r; );
                    return i < r;
                },
                gt = function () {
                    var t,
                        e,
                        r = et.length,
                        i = et.slice(0);
                    for (rt = {}, et.length = 0, t = 0; t < r; t++)
                        (e = i[t]) && e._lazy && (e.render(e._lazy[0], e._lazy[1], !0)._lazy = 0);
                },
                yt = function (t, e, r, n) {
                    et.length && !i && gt(),
                        t.render(e, r, n || (i && e < 0 && (t._initted || t._startAt))),
                        et.length && !i && gt();
                },
                vt = function (t) {
                    var e = parseFloat(t);
                    return (e || 0 === e) && (t + "").match(q).length < 2 ? e : C(t) ? t.trim() : t;
                },
                bt = function (t) {
                    return t;
                },
                _t = function (t, e) {
                    for (var r in e) r in t || (t[r] = e[r]);
                    return t;
                },
                xt = function (t, e) {
                    for (var r in e) t[r] = e[r];
                    return t;
                },
                St = function t(e, r) {
                    for (var i in r)
                        "__proto__" !== i &&
                            "constructor" !== i &&
                            "prototype" !== i &&
                            (e[i] = D(r[i]) ? t(e[i] || (e[i] = {}), r[i]) : r[i]);
                    return e;
                },
                Et = function (t, e) {
                    var r,
                        i = {};
                    for (r in t) r in e || (i[r] = t[r]);
                    return i;
                },
                wt = function (t) {
                    var e,
                        r = t.parent || s,
                        i = t.keyframes
                            ? ((e = V(t.keyframes)),
                              function (t, r) {
                                  for (var i in r) i in t || ("duration" === i && e) || "ease" === i || (t[i] = r[i]);
                              })
                            : _t;
                    if (F(t.inherit)) for (; r; ) i(t, r.vars.defaults), (r = r.parent || r._dp);
                    return t;
                },
                Pt = function (t, e, r, i, n) {
                    void 0 === r && (r = "_first"), void 0 === i && (i = "_last");
                    var s,
                        a = t[i];
                    if (n) for (s = e[n]; a && a[n] > s; ) a = a._prev;
                    return (
                        a ? ((e._next = a._next), (a._next = e)) : ((e._next = t[r]), (t[r] = e)),
                        e._next ? (e._next._prev = e) : (t[i] = e),
                        (e._prev = a),
                        (e.parent = e._dp = t),
                        e
                    );
                },
                Tt = function (t, e, r, i) {
                    void 0 === r && (r = "_first"), void 0 === i && (i = "_last");
                    var n = e._prev,
                        s = e._next;
                    n ? (n._next = s) : t[r] === e && (t[r] = s),
                        s ? (s._prev = n) : t[i] === e && (t[i] = n),
                        (e._next = e._prev = e.parent = null);
                },
                Ct = function (t, e) {
                    t.parent && (!e || t.parent.autoRemoveChildren) && t.parent.remove(t), (t._act = 0);
                },
                At = function (t, e) {
                    if (t && (!e || e._end > t._dur || e._start < 0))
                        for (var r = t; r; ) (r._dirty = 1), (r = r.parent);
                    return t;
                },
                kt = function (t, e, r, n) {
                    return (
                        t._startAt &&
                        (i
                            ? t._startAt.revert(J)
                            : (t.vars.immediateRender && !t.vars.autoRevert) || t._startAt.render(e, !0, n))
                    );
                },
                Mt = function t(e) {
                    return !e || (e._ts && t(e.parent));
                },
                Dt = function (t) {
                    return t._repeat ? Ft(t._tTime, (t = t.duration() + t._rDelay)) * t : 0;
                },
                Ft = function (t, e) {
                    var r = Math.floor((t /= e));
                    return t && r === t ? r - 1 : r;
                },
                It = function (t, e) {
                    return (t - e._start) * e._ts + (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur);
                },
                Lt = function (t) {
                    return (t._end = ut(t._start + (t._tDur / Math.abs(t._ts || t._rts || _) || 0)));
                },
                Bt = function (t, e) {
                    var r = t._dp;
                    return (
                        r &&
                            r.smoothChildTiming &&
                            t._ts &&
                            ((t._start = ut(
                                r._time -
                                    (t._ts > 0 ? e / t._ts : ((t._dirty ? t.totalDuration() : t._tDur) - e) / -t._ts)
                            )),
                            Lt(t),
                            r._dirty || At(r, t)),
                        t
                    );
                },
                Vt = function (t, e) {
                    var r;
                    if (
                        ((e._time || (e._initted && !e._dur)) &&
                            ((r = It(t.rawTime(), e)),
                            (!e._dur || Xt(0, e.totalDuration(), r) - e._tTime > _) && e.render(r, !0)),
                        At(t, e)._dp && t._initted && t._time >= t._dur && t._ts)
                    ) {
                        if (t._dur < t.duration())
                            for (r = t; r._dp; ) r.rawTime() >= 0 && r.totalTime(r._tTime), (r = r._dp);
                        t._zTime = -1e-8;
                    }
                },
                Rt = function (t, e, r, i) {
                    return (
                        e.parent && Ct(e),
                        (e._start = ut((k(r) ? r : r || t !== s ? jt(t, r, e) : t._time) + e._delay)),
                        (e._end = ut(e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0))),
                        Pt(t, e, "_first", "_last", t._sort ? "_start" : 0),
                        Nt(e) || (t._recent = e),
                        i || Vt(t, e),
                        t._ts < 0 && Bt(t, t._tTime),
                        t
                    );
                },
                Ot = function (t, e) {
                    return ($.ScrollTrigger || Y("scrollTrigger", e)) && $.ScrollTrigger.create(e, t);
                },
                zt = function (t, e, r, n, s) {
                    return (
                        Ne(t, e, s),
                        t._initted
                            ? !r &&
                              t._pt &&
                              !i &&
                              ((t._dur && !1 !== t.vars.lazy) || (!t._dur && t.vars.lazy)) &&
                              p !== _e.frame
                                ? (et.push(t), (t._lazy = [s, n]), 1)
                                : void 0
                            : 1
                    );
                },
                Gt = function t(e) {
                    var r = e.parent;
                    return r && r._ts && r._initted && !r._lock && (r.rawTime() < 0 || t(r));
                },
                Nt = function (t) {
                    var e = t.data;
                    return "isFromStart" === e || "isStart" === e;
                },
                qt = function (t, e, r, i) {
                    var n = t._repeat,
                        s = ut(e) || 0,
                        a = t._tTime / t._tDur;
                    return (
                        a && !i && (t._time *= s / t._dur),
                        (t._dur = s),
                        (t._tDur = n ? (n < 0 ? 1e10 : ut(s * (n + 1) + t._rDelay * n)) : s),
                        a > 0 && !i && Bt(t, (t._tTime = t._tDur * a)),
                        t.parent && Lt(t),
                        r || At(t.parent, t),
                        t
                    );
                },
                Ht = function (t) {
                    return t instanceof Be ? At(t) : qt(t, t._dur);
                },
                $t = { _start: 0, endTime: Z, totalDuration: Z },
                jt = function t(e, r, i) {
                    var n,
                        s,
                        a,
                        o = e.labels,
                        l = e._recent || $t,
                        h = e.duration() >= b ? l.endTime(!1) : e._dur;
                    return C(r) && (isNaN(r) || r in o)
                        ? ((s = r.charAt(0)),
                          (a = "%" === r.substr(-1)),
                          (n = r.indexOf("=")),
                          "<" === s || ">" === s
                              ? (n >= 0 && (r = r.replace(/=/, "")),
                                ("<" === s ? l._start : l.endTime(l._repeat >= 0)) +
                                    (parseFloat(r.substr(1)) || 0) * (a ? (n < 0 ? l : i).totalDuration() / 100 : 1))
                              : n < 0
                                ? (r in o || (o[r] = h), o[r])
                                : ((s = parseFloat(r.charAt(n - 1) + r.substr(n + 1))),
                                  a && i && (s = (s / 100) * (V(i) ? i[0] : i).totalDuration()),
                                  n > 1 ? t(e, r.substr(0, n - 1), i) + s : h + s))
                        : null == r
                          ? h
                          : +r;
                },
                Wt = function (t, e, r) {
                    var i,
                        n,
                        s = k(e[1]),
                        a = (s ? 2 : 1) + (t < 2 ? 0 : 1),
                        o = e[a];
                    if ((s && (o.duration = e[1]), (o.parent = r), t)) {
                        for (i = o, n = r; n && !("immediateRender" in i); )
                            (i = n.vars.defaults || {}), (n = F(n.vars.inherit) && n.parent);
                        (o.immediateRender = F(i.immediateRender)),
                            t < 2 ? (o.runBackwards = 1) : (o.startAt = e[a - 1]);
                    }
                    return new We(e[0], o, e[a + 1]);
                },
                Yt = function (t, e) {
                    return t || 0 === t ? e(t) : e;
                },
                Xt = function (t, e, r) {
                    return r < t ? t : r > e ? e : r;
                },
                Ut = function (t, e) {
                    return C(t) && (e = H.exec(t)) ? e[1] : "";
                },
                Zt = [].slice,
                Kt = function (t, e) {
                    return (
                        t &&
                        D(t) &&
                        "length" in t &&
                        ((!e && !t.length) || (t.length - 1 in t && D(t[0]))) &&
                        !t.nodeType &&
                        t !== a
                    );
                },
                Jt = function (t, e, r) {
                    return n && !e && n.selector
                        ? n.selector(t)
                        : !C(t) || r || (!o && xe())
                          ? V(t)
                              ? (function (t, e, r) {
                                    return (
                                        void 0 === r && (r = []),
                                        t.forEach(function (t) {
                                            var i;
                                            return (C(t) && !e) || Kt(t, 1) ? (i = r).push.apply(i, Jt(t)) : r.push(t);
                                        }) || r
                                    );
                                })(t, r)
                              : Kt(t)
                                ? Zt.call(t, 0)
                                : t
                                  ? [t]
                                  : []
                          : Zt.call((e || l).querySelectorAll(t), 0);
                },
                Qt = function (t) {
                    return (
                        (t = Jt(t)[0] || X("Invalid scope") || {}),
                        function (e) {
                            var r = t.current || t.nativeElement || t;
                            return Jt(
                                e,
                                r.querySelectorAll ? r : r === t ? X("Invalid scope") || l.createElement("div") : t
                            );
                        }
                    );
                },
                te = function (t) {
                    return t.sort(function () {
                        return 0.5 - Math.random();
                    });
                },
                ee = function (t) {
                    if (A(t)) return t;
                    var e = D(t) ? t : { each: t },
                        r = Ae(e.ease),
                        i = e.from || 0,
                        n = parseFloat(e.base) || 0,
                        s = {},
                        a = i > 0 && i < 1,
                        o = isNaN(i) || a,
                        l = e.axis,
                        h = i,
                        p = i;
                    return (
                        C(i)
                            ? (h = p = { center: 0.5, edges: 0.5, end: 1 }[i] || 0)
                            : !a && o && ((h = i[0]), (p = i[1])),
                        function (t, a, c) {
                            var d,
                                u,
                                f,
                                m,
                                g,
                                y,
                                v,
                                _,
                                x,
                                S = (c || e).length,
                                E = s[S];
                            if (!E) {
                                if (!(x = "auto" === e.grid ? 0 : (e.grid || [1, b])[1])) {
                                    for (v = -b; v < (v = c[x++].getBoundingClientRect().left) && x < S; );
                                    x--;
                                }
                                for (
                                    E = s[S] = [],
                                        d = o ? Math.min(x, S) * h - 0.5 : i % x,
                                        u = x === b ? 0 : o ? (S * p) / x - 0.5 : (i / x) | 0,
                                        v = 0,
                                        _ = b,
                                        y = 0;
                                    y < S;
                                    y++
                                )
                                    (f = (y % x) - d),
                                        (m = u - ((y / x) | 0)),
                                        (E[y] = g = l ? Math.abs("y" === l ? m : f) : w(f * f + m * m)),
                                        g > v && (v = g),
                                        g < _ && (_ = g);
                                "random" === i && te(E),
                                    (E.max = v - _),
                                    (E.min = _),
                                    (E.v = S =
                                        (parseFloat(e.amount) ||
                                            parseFloat(e.each) *
                                                (x > S ? S - 1 : l ? ("y" === l ? S / x : x) : Math.max(x, S / x)) ||
                                            0) * ("edges" === i ? -1 : 1)),
                                    (E.b = S < 0 ? n - S : n),
                                    (E.u = Ut(e.amount || e.each) || 0),
                                    (r = r && S < 0 ? Te(r) : r);
                            }
                            return (S = (E[t] - E.min) / E.max || 0), ut(E.b + (r ? r(S) : S) * E.v) + E.u;
                        }
                    );
                },
                re = function (t) {
                    var e = Math.pow(10, ((t + "").split(".")[1] || "").length);
                    return function (r) {
                        var i = ut(Math.round(parseFloat(r) / t) * t * e);
                        return (i - (i % 1)) / e + (k(r) ? 0 : Ut(r));
                    };
                },
                ie = function (t, e) {
                    var r,
                        i,
                        n = V(t);
                    return (
                        !n &&
                            D(t) &&
                            ((r = n = t.radius || b),
                            t.values ? ((t = Jt(t.values)), (i = !k(t[0])) && (r *= r)) : (t = re(t.increment))),
                        Yt(
                            e,
                            n
                                ? A(t)
                                    ? function (e) {
                                          return (i = t(e)), Math.abs(i - e) <= r ? i : e;
                                      }
                                    : function (e) {
                                          for (
                                              var n,
                                                  s,
                                                  a = parseFloat(i ? e.x : e),
                                                  o = parseFloat(i ? e.y : 0),
                                                  l = b,
                                                  h = 0,
                                                  p = t.length;
                                              p--;

                                          )
                                              (n = i
                                                  ? (n = t[p].x - a) * n + (s = t[p].y - o) * s
                                                  : Math.abs(t[p] - a)) < l && ((l = n), (h = p));
                                          return (h = !r || l <= r ? t[h] : e), i || h === e || k(e) ? h : h + Ut(e);
                                      }
                                : re(t)
                        )
                    );
                },
                ne = function (t, e, r, i) {
                    return Yt(V(t) ? !e : !0 === r ? !!(r = 0) : !i, function () {
                        return V(t)
                            ? t[~~(Math.random() * t.length)]
                            : (r = r || 1e-5) &&
                                  (i = r < 1 ? Math.pow(10, (r + "").length - 2) : 1) &&
                                  Math.floor(Math.round((t - r / 2 + Math.random() * (e - t + 0.99 * r)) / r) * r * i) /
                                      i;
                    });
                },
                se = function (t, e, r) {
                    return Yt(r, function (r) {
                        return t[~~e(r)];
                    });
                },
                ae = function (t) {
                    for (var e, r, i, n, s = 0, a = ""; ~(e = t.indexOf("random(", s)); )
                        (i = t.indexOf(")", e)),
                            (n = "[" === t.charAt(e + 7)),
                            (r = t.substr(e + 7, i - e - 7).match(n ? q : R)),
                            (a += t.substr(s, e - s) + ne(n ? r : +r[0], n ? 0 : +r[1], +r[2] || 1e-5)),
                            (s = i + 1);
                    return a + t.substr(s, t.length - s);
                },
                oe = function (t, e, r, i, n) {
                    var s = e - t,
                        a = i - r;
                    return Yt(n, function (e) {
                        return r + (((e - t) / s) * a || 0);
                    });
                },
                le = function (t, e, r) {
                    var i,
                        n,
                        s,
                        a = t.labels,
                        o = b;
                    for (i in a) (n = a[i] - e) < 0 == !!r && n && o > (n = Math.abs(n)) && ((s = i), (o = n));
                    return s;
                },
                he = function (t, e, r) {
                    var i,
                        s,
                        a,
                        o = t.vars,
                        l = o[e],
                        h = n,
                        p = t._ctx;
                    if (l)
                        return (
                            (i = o[e + "Params"]),
                            (s = o.callbackScope || t),
                            r && et.length && gt(),
                            p && (n = p),
                            (a = i ? l.apply(s, i) : l.call(s)),
                            (n = h),
                            a
                        );
                },
                pe = function (t) {
                    return (
                        Ct(t), t.scrollTrigger && t.scrollTrigger.kill(!!i), t.progress() < 1 && he(t, "onInterrupt"), t
                    );
                },
                ce = 255,
                de = {
                    aqua: [0, ce, ce],
                    lime: [0, ce, 0],
                    silver: [192, 192, 192],
                    black: [0, 0, 0],
                    maroon: [128, 0, 0],
                    teal: [0, 128, 128],
                    blue: [0, 0, ce],
                    navy: [0, 0, 128],
                    white: [ce, ce, ce],
                    olive: [128, 128, 0],
                    yellow: [ce, ce, 0],
                    orange: [ce, 165, 0],
                    gray: [128, 128, 128],
                    purple: [128, 0, 128],
                    green: [0, 128, 0],
                    red: [ce, 0, 0],
                    pink: [ce, 192, 203],
                    cyan: [0, ce, ce],
                    transparent: [ce, ce, ce, 0],
                },
                ue = function (t, e, r) {
                    return (
                        ((6 * (t += t < 0 ? 1 : t > 1 ? -1 : 0) < 1
                            ? e + (r - e) * t * 6
                            : t < 0.5
                              ? r
                              : 3 * t < 2
                                ? e + (r - e) * (2 / 3 - t) * 6
                                : e) *
                            ce +
                            0.5) |
                        0
                    );
                },
                fe = function (t, e, r) {
                    var i,
                        n,
                        s,
                        a,
                        o,
                        l,
                        h,
                        p,
                        c,
                        d,
                        u = t ? (k(t) ? [t >> 16, (t >> 8) & ce, t & ce] : 0) : de.black;
                    if (!u) {
                        if (("," === t.substr(-1) && (t = t.substr(0, t.length - 1)), de[t])) u = de[t];
                        else if ("#" === t.charAt(0)) {
                            if (
                                (t.length < 6 &&
                                    ((i = t.charAt(1)),
                                    (n = t.charAt(2)),
                                    (s = t.charAt(3)),
                                    (t =
                                        "#" +
                                        i +
                                        i +
                                        n +
                                        n +
                                        s +
                                        s +
                                        (5 === t.length ? t.charAt(4) + t.charAt(4) : ""))),
                                9 === t.length)
                            )
                                return [
                                    (u = parseInt(t.substr(1, 6), 16)) >> 16,
                                    (u >> 8) & ce,
                                    u & ce,
                                    parseInt(t.substr(7), 16) / 255,
                                ];
                            u = [(t = parseInt(t.substr(1), 16)) >> 16, (t >> 8) & ce, t & ce];
                        } else if ("hsl" === t.substr(0, 3))
                            if (((u = d = t.match(R)), e)) {
                                if (~t.indexOf("=")) return (u = t.match(O)), r && u.length < 4 && (u[3] = 1), u;
                            } else
                                (a = (+u[0] % 360) / 360),
                                    (o = +u[1] / 100),
                                    (i = 2 * (l = +u[2] / 100) - (n = l <= 0.5 ? l * (o + 1) : l + o - l * o)),
                                    u.length > 3 && (u[3] *= 1),
                                    (u[0] = ue(a + 1 / 3, i, n)),
                                    (u[1] = ue(a, i, n)),
                                    (u[2] = ue(a - 1 / 3, i, n));
                        else u = t.match(R) || de.transparent;
                        u = u.map(Number);
                    }
                    return (
                        e &&
                            !d &&
                            ((i = u[0] / ce),
                            (n = u[1] / ce),
                            (s = u[2] / ce),
                            (l = ((h = Math.max(i, n, s)) + (p = Math.min(i, n, s))) / 2),
                            h === p
                                ? (a = o = 0)
                                : ((c = h - p),
                                  (o = l > 0.5 ? c / (2 - h - p) : c / (h + p)),
                                  (a =
                                      h === i
                                          ? (n - s) / c + (n < s ? 6 : 0)
                                          : h === n
                                            ? (s - i) / c + 2
                                            : (i - n) / c + 4),
                                  (a *= 60)),
                            (u[0] = ~~(a + 0.5)),
                            (u[1] = ~~(100 * o + 0.5)),
                            (u[2] = ~~(100 * l + 0.5))),
                        r && u.length < 4 && (u[3] = 1),
                        u
                    );
                },
                me = function (t) {
                    var e = [],
                        r = [],
                        i = -1;
                    return (
                        t.split(ye).forEach(function (t) {
                            var n = t.match(z) || [];
                            e.push.apply(e, n), r.push((i += n.length + 1));
                        }),
                        (e.c = r),
                        e
                    );
                },
                ge = function (t, e, r) {
                    var i,
                        n,
                        s,
                        a,
                        o = "",
                        l = (t + o).match(ye),
                        h = e ? "hsla(" : "rgba(",
                        p = 0;
                    if (!l) return t;
                    if (
                        ((l = l.map(function (t) {
                            return (
                                (t = fe(t, e, 1)) &&
                                h + (e ? t[0] + "," + t[1] + "%," + t[2] + "%," + t[3] : t.join(",")) + ")"
                            );
                        })),
                        r && ((s = me(t)), (i = r.c).join(o) !== s.c.join(o)))
                    )
                        for (a = (n = t.replace(ye, "1").split(z)).length - 1; p < a; p++)
                            o +=
                                n[p] +
                                (~i.indexOf(p)
                                    ? l.shift() || h + "0,0,0,0)"
                                    : (s.length ? s : l.length ? l : r).shift());
                    if (!n) for (a = (n = t.split(ye)).length - 1; p < a; p++) o += n[p] + l[p];
                    return o + n[a];
                },
                ye = (function () {
                    var t,
                        e = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
                    for (t in de) e += "|" + t + "\\b";
                    return new RegExp(e + ")", "gi");
                })(),
                ve = /hsl[a]?\(/,
                be = function (t) {
                    var e,
                        r = t.join(" ");
                    if (((ye.lastIndex = 0), ye.test(r)))
                        return (e = ve.test(r)), (t[1] = ge(t[1], e)), (t[0] = ge(t[0], e, me(t[1]))), !0;
                },
                _e = (function () {
                    var t,
                        e,
                        r,
                        i,
                        n,
                        s,
                        p = Date.now,
                        c = 500,
                        u = 33,
                        f = p(),
                        m = f,
                        g = 1e3 / 240,
                        y = g,
                        v = [],
                        b = function r(a) {
                            var o,
                                l,
                                h,
                                d,
                                b = p() - m,
                                _ = !0 === a;
                            if (
                                (b > c && (f += b - u),
                                ((o = (h = (m += b) - f) - y) > 0 || _) &&
                                    ((d = ++i.frame),
                                    (n = h - 1e3 * i.time),
                                    (i.time = h /= 1e3),
                                    (y += o + (o >= g ? 4 : g - o)),
                                    (l = 1)),
                                _ || (t = e(r)),
                                l)
                            )
                                for (s = 0; s < v.length; s++) v[s](h, n, d, a);
                        };
                    return (i = {
                        time: 0,
                        frame: 0,
                        tick: function () {
                            b(!0);
                        },
                        deltaRatio: function (t) {
                            return n / (1e3 / (t || 60));
                        },
                        wake: function () {
                            h &&
                                (!o &&
                                    I() &&
                                    ((a = o = window),
                                    (l = a.document || {}),
                                    ($.gsap = vr),
                                    (a.gsapVersions || (a.gsapVersions = [])).push(vr.version),
                                    W(j || a.GreenSockGlobals || (!a.gsap && a) || {}),
                                    (r = a.requestAnimationFrame)),
                                t && i.sleep(),
                                (e =
                                    r ||
                                    function (t) {
                                        return setTimeout(t, (y - 1e3 * i.time + 1) | 0);
                                    }),
                                (d = 1),
                                b(2));
                        },
                        sleep: function () {
                            (r ? a.cancelAnimationFrame : clearTimeout)(t), (d = 0), (e = Z);
                        },
                        lagSmoothing: function (t, e) {
                            (c = t || 1 / 0), (u = Math.min(e || 33, c));
                        },
                        fps: function (t) {
                            (g = 1e3 / (t || 240)), (y = 1e3 * i.time + g);
                        },
                        add: function (t, e, r) {
                            var n = e
                                ? function (e, r, s, a) {
                                      t(e, r, s, a), i.remove(n);
                                  }
                                : t;
                            return i.remove(t), v[r ? "unshift" : "push"](n), xe(), n;
                        },
                        remove: function (t, e) {
                            ~(e = v.indexOf(t)) && v.splice(e, 1) && s >= e && s--;
                        },
                        _listeners: v,
                    });
                })(),
                xe = function () {
                    return !d && _e.wake();
                },
                Se = {},
                Ee = /^[\d.\-M][\d.\-,\s]/,
                we = /["']/g,
                Pe = function (t) {
                    for (
                        var e, r, i, n = {}, s = t.substr(1, t.length - 3).split(":"), a = s[0], o = 1, l = s.length;
                        o < l;
                        o++
                    )
                        (r = s[o]),
                            (e = o !== l - 1 ? r.lastIndexOf(",") : r.length),
                            (i = r.substr(0, e)),
                            (n[a] = isNaN(i) ? i.replace(we, "").trim() : +i),
                            (a = r.substr(e + 1).trim());
                    return n;
                },
                Te = function (t) {
                    return function (e) {
                        return 1 - t(1 - e);
                    };
                },
                Ce = function t(e, r) {
                    for (var i, n = e._first; n; )
                        n instanceof Be
                            ? t(n, r)
                            : !n.vars.yoyoEase ||
                              (n._yoyo && n._repeat) ||
                              n._yoyo === r ||
                              (n.timeline
                                  ? t(n.timeline, r)
                                  : ((i = n._ease), (n._ease = n._yEase), (n._yEase = i), (n._yoyo = r))),
                            (n = n._next);
                },
                Ae = function (t, e) {
                    return (
                        (t &&
                            (A(t)
                                ? t
                                : Se[t] ||
                                  (function (t) {
                                      var e,
                                          r,
                                          i,
                                          n,
                                          s = (t + "").split("("),
                                          a = Se[s[0]];
                                      return a && s.length > 1 && a.config
                                          ? a.config.apply(
                                                null,
                                                ~t.indexOf("{")
                                                    ? [Pe(s[1])]
                                                    : ((e = t),
                                                      (r = e.indexOf("(") + 1),
                                                      (i = e.indexOf(")")),
                                                      (n = e.indexOf("(", r)),
                                                      e.substring(r, ~n && n < i ? e.indexOf(")", i + 1) : i))
                                                          .split(",")
                                                          .map(vt)
                                            )
                                          : Se._CE && Ee.test(t)
                                            ? Se._CE("", t)
                                            : a;
                                  })(t))) ||
                        e
                    );
                },
                ke = function (t, e, r, i) {
                    void 0 === r &&
                        (r = function (t) {
                            return 1 - e(1 - t);
                        }),
                        void 0 === i &&
                            (i = function (t) {
                                return t < 0.5 ? e(2 * t) / 2 : 1 - e(2 * (1 - t)) / 2;
                            });
                    var n,
                        s = { easeIn: e, easeOut: r, easeInOut: i };
                    return (
                        ct(t, function (t) {
                            for (var e in ((Se[t] = $[t] = s), (Se[(n = t.toLowerCase())] = r), s))
                                Se[n + ("easeIn" === e ? ".in" : "easeOut" === e ? ".out" : ".inOut")] = Se[
                                    t + "." + e
                                ] = s[e];
                        }),
                        s
                    );
                },
                Me = function (t) {
                    return function (e) {
                        return e < 0.5 ? (1 - t(1 - 2 * e)) / 2 : 0.5 + t(2 * (e - 0.5)) / 2;
                    };
                },
                De = function t(e, r, i) {
                    var n = r >= 1 ? r : 1,
                        s = (i || (e ? 0.3 : 0.45)) / (r < 1 ? r : 1),
                        a = (s / x) * (Math.asin(1 / n) || 0),
                        o = function (t) {
                            return 1 === t ? 1 : n * Math.pow(2, -10 * t) * T((t - a) * s) + 1;
                        },
                        l =
                            "out" === e
                                ? o
                                : "in" === e
                                  ? function (t) {
                                        return 1 - o(1 - t);
                                    }
                                  : Me(o);
                    return (
                        (s = x / s),
                        (l.config = function (r, i) {
                            return t(e, r, i);
                        }),
                        l
                    );
                },
                Fe = function t(e, r) {
                    void 0 === r && (r = 1.70158);
                    var i = function (t) {
                            return t ? --t * t * ((r + 1) * t + r) + 1 : 0;
                        },
                        n =
                            "out" === e
                                ? i
                                : "in" === e
                                  ? function (t) {
                                        return 1 - i(1 - t);
                                    }
                                  : Me(i);
                    return (
                        (n.config = function (r) {
                            return t(e, r);
                        }),
                        n
                    );
                };
            ct("Linear,Quad,Cubic,Quart,Quint,Strong", function (t, e) {
                var r = e < 5 ? e + 1 : e;
                ke(
                    t + ",Power" + (r - 1),
                    e
                        ? function (t) {
                              return Math.pow(t, r);
                          }
                        : function (t) {
                              return t;
                          },
                    function (t) {
                        return 1 - Math.pow(1 - t, r);
                    },
                    function (t) {
                        return t < 0.5 ? Math.pow(2 * t, r) / 2 : 1 - Math.pow(2 * (1 - t), r) / 2;
                    }
                );
            }),
                (Se.Linear.easeNone = Se.none = Se.Linear.easeIn),
                ke("Elastic", De("in"), De("out"), De()),
                (u = 7.5625),
                (m = 1 / (f = 2.75)),
                ke(
                    "Bounce",
                    function (t) {
                        return 1 - g(1 - t);
                    },
                    (g = function (t) {
                        return t < m
                            ? u * t * t
                            : t < 0.7272727272727273
                              ? u * Math.pow(t - 1.5 / f, 2) + 0.75
                              : t < 0.9090909090909092
                                ? u * (t -= 2.25 / f) * t + 0.9375
                                : u * Math.pow(t - 2.625 / f, 2) + 0.984375;
                    })
                ),
                ke("Expo", function (t) {
                    return t ? Math.pow(2, 10 * (t - 1)) : 0;
                }),
                ke("Circ", function (t) {
                    return -(w(1 - t * t) - 1);
                }),
                ke("Sine", function (t) {
                    return 1 === t ? 1 : 1 - P(t * S);
                }),
                ke("Back", Fe("in"), Fe("out"), Fe()),
                (Se.SteppedEase =
                    Se.steps =
                    $.SteppedEase =
                        {
                            config: function (t, e) {
                                void 0 === t && (t = 1);
                                var r = 1 / t,
                                    i = t + (e ? 0 : 1),
                                    n = e ? 1 : 0;
                                return function (t) {
                                    return (((i * Xt(0, 0.99999999, t)) | 0) + n) * r;
                                };
                            },
                        }),
                (v.ease = Se["quad.out"]),
                ct("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (t) {
                    return (ot += t + "," + t + "Params,");
                });
            var Ie = function (t, e) {
                    (this.id = E++),
                        (t._gsap = this),
                        (this.target = t),
                        (this.harness = e),
                        (this.get = e ? e.get : pt),
                        (this.set = e ? e.getSetter : Ke);
                },
                Le = (function () {
                    function t(t) {
                        (this.vars = t),
                            (this._delay = +t.delay || 0),
                            (this._repeat = t.repeat === 1 / 0 ? -2 : t.repeat || 0) &&
                                ((this._rDelay = t.repeatDelay || 0), (this._yoyo = !!t.yoyo || !!t.yoyoEase)),
                            (this._ts = 1),
                            qt(this, +t.duration, 1, 1),
                            (this.data = t.data),
                            n && ((this._ctx = n), n.data.push(this)),
                            d || _e.wake();
                    }
                    var e = t.prototype;
                    return (
                        (e.delay = function (t) {
                            return t || 0 === t
                                ? (this.parent &&
                                      this.parent.smoothChildTiming &&
                                      this.startTime(this._start + t - this._delay),
                                  (this._delay = t),
                                  this)
                                : this._delay;
                        }),
                        (e.duration = function (t) {
                            return arguments.length
                                ? this.totalDuration(this._repeat > 0 ? t + (t + this._rDelay) * this._repeat : t)
                                : this.totalDuration() && this._dur;
                        }),
                        (e.totalDuration = function (t) {
                            return arguments.length
                                ? ((this._dirty = 0),
                                  qt(
                                      this,
                                      this._repeat < 0 ? t : (t - this._repeat * this._rDelay) / (this._repeat + 1)
                                  ))
                                : this._tDur;
                        }),
                        (e.totalTime = function (t, e) {
                            if ((xe(), !arguments.length)) return this._tTime;
                            var r = this._dp;
                            if (r && r.smoothChildTiming && this._ts) {
                                for (Bt(this, t), !r._dp || r.parent || Vt(r, this); r && r.parent; )
                                    r.parent._time !==
                                        r._start +
                                            (r._ts >= 0 ? r._tTime / r._ts : (r.totalDuration() - r._tTime) / -r._ts) &&
                                        r.totalTime(r._tTime, !0),
                                        (r = r.parent);
                                !this.parent &&
                                    this._dp.autoRemoveChildren &&
                                    ((this._ts > 0 && t < this._tDur) ||
                                        (this._ts < 0 && t > 0) ||
                                        (!this._tDur && !t)) &&
                                    Rt(this._dp, this, this._start - this._delay);
                            }
                            return (
                                (this._tTime !== t ||
                                    (!this._dur && !e) ||
                                    (this._initted && Math.abs(this._zTime) === _) ||
                                    (!t && !this._initted && (this.add || this._ptLookup))) &&
                                    (this._ts || (this._pTime = t), yt(this, t, e)),
                                this
                            );
                        }),
                        (e.time = function (t, e) {
                            return arguments.length
                                ? this.totalTime(
                                      Math.min(this.totalDuration(), t + Dt(this)) % (this._dur + this._rDelay) ||
                                          (t ? this._dur : 0),
                                      e
                                  )
                                : this._time;
                        }),
                        (e.totalProgress = function (t, e) {
                            return arguments.length
                                ? this.totalTime(this.totalDuration() * t, e)
                                : this.totalDuration()
                                  ? Math.min(1, this._tTime / this._tDur)
                                  : this.ratio;
                        }),
                        (e.progress = function (t, e) {
                            return arguments.length
                                ? this.totalTime(
                                      this.duration() * (!this._yoyo || 1 & this.iteration() ? t : 1 - t) + Dt(this),
                                      e
                                  )
                                : this.duration()
                                  ? Math.min(1, this._time / this._dur)
                                  : this.ratio;
                        }),
                        (e.iteration = function (t, e) {
                            var r = this.duration() + this._rDelay;
                            return arguments.length
                                ? this.totalTime(this._time + (t - 1) * r, e)
                                : this._repeat
                                  ? Ft(this._tTime, r) + 1
                                  : 1;
                        }),
                        (e.timeScale = function (t) {
                            if (!arguments.length) return -1e-8 === this._rts ? 0 : this._rts;
                            if (this._rts === t) return this;
                            var e = this.parent && this._ts ? It(this.parent._time, this) : this._tTime;
                            return (
                                (this._rts = +t || 0),
                                (this._ts = this._ps || -1e-8 === t ? 0 : this._rts),
                                this.totalTime(Xt(-this._delay, this._tDur, e), !0),
                                Lt(this),
                                (function (t) {
                                    for (var e = t.parent; e && e.parent; )
                                        (e._dirty = 1), e.totalDuration(), (e = e.parent);
                                    return t;
                                })(this)
                            );
                        }),
                        (e.paused = function (t) {
                            return arguments.length
                                ? (this._ps !== t &&
                                      ((this._ps = t),
                                      t
                                          ? ((this._pTime = this._tTime || Math.max(-this._delay, this.rawTime())),
                                            (this._ts = this._act = 0))
                                          : (xe(),
                                            (this._ts = this._rts),
                                            this.totalTime(
                                                this.parent && !this.parent.smoothChildTiming
                                                    ? this.rawTime()
                                                    : this._tTime || this._pTime,
                                                1 === this.progress() &&
                                                    Math.abs(this._zTime) !== _ &&
                                                    (this._tTime -= _)
                                            ))),
                                  this)
                                : this._ps;
                        }),
                        (e.startTime = function (t) {
                            if (arguments.length) {
                                this._start = t;
                                var e = this.parent || this._dp;
                                return e && (e._sort || !this.parent) && Rt(e, this, t - this._delay), this;
                            }
                            return this._start;
                        }),
                        (e.endTime = function (t) {
                            return (
                                this._start + (F(t) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1)
                            );
                        }),
                        (e.rawTime = function (t) {
                            var e = this.parent || this._dp;
                            return e
                                ? t && (!this._ts || (this._repeat && this._time && this.totalProgress() < 1))
                                    ? this._tTime % (this._dur + this._rDelay)
                                    : this._ts
                                      ? It(e.rawTime(t), this)
                                      : this._tTime
                                : this._tTime;
                        }),
                        (e.revert = function (t) {
                            void 0 === t && (t = Q);
                            var e = i;
                            return (
                                (i = t),
                                (this._initted || this._startAt) &&
                                    (this.timeline && this.timeline.revert(t), this.totalTime(-0.01, t.suppressEvents)),
                                "nested" !== this.data && !1 !== t.kill && this.kill(),
                                (i = e),
                                this
                            );
                        }),
                        (e.globalTime = function (t) {
                            for (var e = this, r = arguments.length ? t : e.rawTime(); e; )
                                (r = e._start + r / (e._ts || 1)), (e = e._dp);
                            return !this.parent && this._sat
                                ? this._sat.vars.immediateRender
                                    ? -1
                                    : this._sat.globalTime(t)
                                : r;
                        }),
                        (e.repeat = function (t) {
                            return arguments.length
                                ? ((this._repeat = t === 1 / 0 ? -2 : t), Ht(this))
                                : -2 === this._repeat
                                  ? 1 / 0
                                  : this._repeat;
                        }),
                        (e.repeatDelay = function (t) {
                            if (arguments.length) {
                                var e = this._time;
                                return (this._rDelay = t), Ht(this), e ? this.time(e) : this;
                            }
                            return this._rDelay;
                        }),
                        (e.yoyo = function (t) {
                            return arguments.length ? ((this._yoyo = t), this) : this._yoyo;
                        }),
                        (e.seek = function (t, e) {
                            return this.totalTime(jt(this, t), F(e));
                        }),
                        (e.restart = function (t, e) {
                            return this.play().totalTime(t ? -this._delay : 0, F(e));
                        }),
                        (e.play = function (t, e) {
                            return null != t && this.seek(t, e), this.reversed(!1).paused(!1);
                        }),
                        (e.reverse = function (t, e) {
                            return null != t && this.seek(t || this.totalDuration(), e), this.reversed(!0).paused(!1);
                        }),
                        (e.pause = function (t, e) {
                            return null != t && this.seek(t, e), this.paused(!0);
                        }),
                        (e.resume = function () {
                            return this.paused(!1);
                        }),
                        (e.reversed = function (t) {
                            return arguments.length
                                ? (!!t !== this.reversed() && this.timeScale(-this._rts || (t ? -1e-8 : 0)), this)
                                : this._rts < 0;
                        }),
                        (e.invalidate = function () {
                            return (this._initted = this._act = 0), (this._zTime = -1e-8), this;
                        }),
                        (e.isActive = function () {
                            var t,
                                e = this.parent || this._dp,
                                r = this._start;
                            return !(
                                e &&
                                !(
                                    this._ts &&
                                    this._initted &&
                                    e.isActive() &&
                                    (t = e.rawTime(!0)) >= r &&
                                    t < this.endTime(!0) - _
                                )
                            );
                        }),
                        (e.eventCallback = function (t, e, r) {
                            var i = this.vars;
                            return arguments.length > 1
                                ? (e
                                      ? ((i[t] = e),
                                        r && (i[t + "Params"] = r),
                                        "onUpdate" === t && (this._onUpdate = e))
                                      : delete i[t],
                                  this)
                                : i[t];
                        }),
                        (e.then = function (t) {
                            var e = this;
                            return new Promise(function (r) {
                                var i = A(t) ? t : bt,
                                    n = function () {
                                        var t = e.then;
                                        (e.then = null),
                                            A(i) && (i = i(e)) && (i.then || i === e) && (e.then = t),
                                            r(i),
                                            (e.then = t);
                                    };
                                (e._initted && 1 === e.totalProgress() && e._ts >= 0) || (!e._tTime && e._ts < 0)
                                    ? n()
                                    : (e._prom = n);
                            });
                        }),
                        (e.kill = function () {
                            pe(this);
                        }),
                        t
                    );
                })();
            _t(Le.prototype, {
                _time: 0,
                _start: 0,
                _end: 0,
                _tTime: 0,
                _tDur: 0,
                _dirty: 0,
                _repeat: 0,
                _yoyo: !1,
                parent: null,
                _initted: !1,
                _rDelay: 0,
                _ts: 1,
                _dp: 0,
                ratio: 0,
                _zTime: -1e-8,
                _prom: 0,
                _ps: !1,
                _rts: 1,
            });
            var Be = (function (r) {
                function n(e, i) {
                    var n;
                    return (
                        void 0 === e && (e = {}),
                        ((n = r.call(this, e) || this).labels = {}),
                        (n.smoothChildTiming = !!e.smoothChildTiming),
                        (n.autoRemoveChildren = !!e.autoRemoveChildren),
                        (n._sort = F(e.sortChildren)),
                        s && Rt(e.parent || s, t(n), i),
                        e.reversed && n.reverse(),
                        e.paused && n.paused(!0),
                        e.scrollTrigger && Ot(t(n), e.scrollTrigger),
                        n
                    );
                }
                e(n, r);
                var a = n.prototype;
                return (
                    (a.to = function (t, e, r) {
                        return Wt(0, arguments, this), this;
                    }),
                    (a.from = function (t, e, r) {
                        return Wt(1, arguments, this), this;
                    }),
                    (a.fromTo = function (t, e, r, i) {
                        return Wt(2, arguments, this), this;
                    }),
                    (a.set = function (t, e, r) {
                        return (
                            (e.duration = 0),
                            (e.parent = this),
                            wt(e).repeatDelay || (e.repeat = 0),
                            (e.immediateRender = !!e.immediateRender),
                            new We(t, e, jt(this, r), 1),
                            this
                        );
                    }),
                    (a.call = function (t, e, r) {
                        return Rt(this, We.delayedCall(0, t, e), r);
                    }),
                    (a.staggerTo = function (t, e, r, i, n, s, a) {
                        return (
                            (r.duration = e),
                            (r.stagger = r.stagger || i),
                            (r.onComplete = s),
                            (r.onCompleteParams = a),
                            (r.parent = this),
                            new We(t, r, jt(this, n)),
                            this
                        );
                    }),
                    (a.staggerFrom = function (t, e, r, i, n, s, a) {
                        return (
                            (r.runBackwards = 1),
                            (wt(r).immediateRender = F(r.immediateRender)),
                            this.staggerTo(t, e, r, i, n, s, a)
                        );
                    }),
                    (a.staggerFromTo = function (t, e, r, i, n, s, a, o) {
                        return (
                            (i.startAt = r),
                            (wt(i).immediateRender = F(i.immediateRender)),
                            this.staggerTo(t, e, i, n, s, a, o)
                        );
                    }),
                    (a.render = function (t, e, r) {
                        var n,
                            a,
                            o,
                            l,
                            h,
                            p,
                            c,
                            d,
                            u,
                            f,
                            m,
                            g,
                            y = this._time,
                            v = this._dirty ? this.totalDuration() : this._tDur,
                            b = this._dur,
                            x = t <= 0 ? 0 : ut(t),
                            S = this._zTime < 0 != t < 0 && (this._initted || !b);
                        if ((this !== s && x > v && t >= 0 && (x = v), x !== this._tTime || r || S)) {
                            if (
                                (y !== this._time && b && ((x += this._time - y), (t += this._time - y)),
                                (n = x),
                                (u = this._start),
                                (p = !(d = this._ts)),
                                S && (b || (y = this._zTime), (t || !e) && (this._zTime = t)),
                                this._repeat)
                            ) {
                                if (((m = this._yoyo), (h = b + this._rDelay), this._repeat < -1 && t < 0))
                                    return this.totalTime(100 * h + t, e, r);
                                if (
                                    ((n = ut(x % h)),
                                    x === v
                                        ? ((l = this._repeat), (n = b))
                                        : ((l = ~~(x / h)) && l === x / h && ((n = b), l--), n > b && (n = b)),
                                    (f = Ft(this._tTime, h)),
                                    !y && this._tTime && f !== l && (f = l),
                                    m && 1 & l && ((n = b - n), (g = 1)),
                                    l !== f && !this._lock)
                                ) {
                                    var E = m && 1 & f,
                                        w = E === (m && 1 & l);
                                    if (
                                        (l < f && (E = !E),
                                        (y = E ? 0 : b),
                                        (this._lock = 1),
                                        (this.render(y || (g ? 0 : ut(l * h)), e, !b)._lock = 0),
                                        (this._tTime = x),
                                        !e && this.parent && he(this, "onRepeat"),
                                        this.vars.repeatRefresh && !g && (this.invalidate()._lock = 1),
                                        (y && y !== this._time) ||
                                            p !== !this._ts ||
                                            (this.vars.onRepeat && !this.parent && !this._act))
                                    )
                                        return this;
                                    if (
                                        ((b = this._dur),
                                        (v = this._tDur),
                                        w &&
                                            ((this._lock = 2),
                                            (y = E ? b : -1e-4),
                                            this.render(y, !0),
                                            this.vars.repeatRefresh && !g && this.invalidate()),
                                        (this._lock = 0),
                                        !this._ts && !p)
                                    )
                                        return this;
                                    Ce(this, g);
                                }
                            }
                            if (
                                (this._hasPause &&
                                    !this._forcing &&
                                    this._lock < 2 &&
                                    (c = (function (t, e, r) {
                                        var i;
                                        if (r > e)
                                            for (i = t._first; i && i._start <= r; ) {
                                                if ("isPause" === i.data && i._start > e) return i;
                                                i = i._next;
                                            }
                                        else
                                            for (i = t._last; i && i._start >= r; ) {
                                                if ("isPause" === i.data && i._start < e) return i;
                                                i = i._prev;
                                            }
                                    })(this, ut(y), ut(n))) &&
                                    (x -= n - (n = c._start)),
                                (this._tTime = x),
                                (this._time = n),
                                (this._act = !d),
                                this._initted ||
                                    ((this._onUpdate = this.vars.onUpdate),
                                    (this._initted = 1),
                                    (this._zTime = t),
                                    (y = 0)),
                                !y && n && !e && (he(this, "onStart"), this._tTime !== x))
                            )
                                return this;
                            if (n >= y && t >= 0)
                                for (a = this._first; a; ) {
                                    if (((o = a._next), (a._act || n >= a._start) && a._ts && c !== a)) {
                                        if (a.parent !== this) return this.render(t, e, r);
                                        if (
                                            (a.render(
                                                a._ts > 0
                                                    ? (n - a._start) * a._ts
                                                    : (a._dirty ? a.totalDuration() : a._tDur) + (n - a._start) * a._ts,
                                                e,
                                                r
                                            ),
                                            n !== this._time || (!this._ts && !p))
                                        ) {
                                            (c = 0), o && (x += this._zTime = -1e-8);
                                            break;
                                        }
                                    }
                                    a = o;
                                }
                            else {
                                a = this._last;
                                for (var P = t < 0 ? t : n; a; ) {
                                    if (((o = a._prev), (a._act || P <= a._end) && a._ts && c !== a)) {
                                        if (a.parent !== this) return this.render(t, e, r);
                                        if (
                                            (a.render(
                                                a._ts > 0
                                                    ? (P - a._start) * a._ts
                                                    : (a._dirty ? a.totalDuration() : a._tDur) + (P - a._start) * a._ts,
                                                e,
                                                r || (i && (a._initted || a._startAt))
                                            ),
                                            n !== this._time || (!this._ts && !p))
                                        ) {
                                            (c = 0), o && (x += this._zTime = P ? -1e-8 : _);
                                            break;
                                        }
                                    }
                                    a = o;
                                }
                            }
                            if (
                                c &&
                                !e &&
                                (this.pause(), (c.render(n >= y ? 0 : -1e-8)._zTime = n >= y ? 1 : -1), this._ts)
                            )
                                return (this._start = u), Lt(this), this.render(t, e, r);
                            this._onUpdate && !e && he(this, "onUpdate", !0),
                                ((x === v && this._tTime >= this.totalDuration()) || (!x && y)) &&
                                    ((u !== this._start && Math.abs(d) === Math.abs(this._ts)) ||
                                        this._lock ||
                                        ((t || !b) &&
                                            ((x === v && this._ts > 0) || (!x && this._ts < 0)) &&
                                            Ct(this, 1),
                                        e ||
                                            (t < 0 && !y) ||
                                            (!x && !y && v) ||
                                            (he(this, x === v && t >= 0 ? "onComplete" : "onReverseComplete", !0),
                                            this._prom && !(x < v && this.timeScale() > 0) && this._prom())));
                        }
                        return this;
                    }),
                    (a.add = function (t, e) {
                        var r = this;
                        if ((k(e) || (e = jt(this, e, t)), !(t instanceof Le))) {
                            if (V(t))
                                return (
                                    t.forEach(function (t) {
                                        return r.add(t, e);
                                    }),
                                    this
                                );
                            if (C(t)) return this.addLabel(t, e);
                            if (!A(t)) return this;
                            t = We.delayedCall(0, t);
                        }
                        return this !== t ? Rt(this, t, e) : this;
                    }),
                    (a.getChildren = function (t, e, r, i) {
                        void 0 === t && (t = !0),
                            void 0 === e && (e = !0),
                            void 0 === r && (r = !0),
                            void 0 === i && (i = -b);
                        for (var n = [], s = this._first; s; )
                            s._start >= i &&
                                (s instanceof We
                                    ? e && n.push(s)
                                    : (r && n.push(s), t && n.push.apply(n, s.getChildren(!0, e, r)))),
                                (s = s._next);
                        return n;
                    }),
                    (a.getById = function (t) {
                        for (var e = this.getChildren(1, 1, 1), r = e.length; r--; )
                            if (e[r].vars.id === t) return e[r];
                    }),
                    (a.remove = function (t) {
                        return C(t)
                            ? this.removeLabel(t)
                            : A(t)
                              ? this.killTweensOf(t)
                              : (Tt(this, t), t === this._recent && (this._recent = this._last), At(this));
                    }),
                    (a.totalTime = function (t, e) {
                        return arguments.length
                            ? ((this._forcing = 1),
                              !this._dp &&
                                  this._ts &&
                                  (this._start = ut(
                                      _e.time - (this._ts > 0 ? t / this._ts : (this.totalDuration() - t) / -this._ts)
                                  )),
                              r.prototype.totalTime.call(this, t, e),
                              (this._forcing = 0),
                              this)
                            : this._tTime;
                    }),
                    (a.addLabel = function (t, e) {
                        return (this.labels[t] = jt(this, e)), this;
                    }),
                    (a.removeLabel = function (t) {
                        return delete this.labels[t], this;
                    }),
                    (a.addPause = function (t, e, r) {
                        var i = We.delayedCall(0, e || Z, r);
                        return (i.data = "isPause"), (this._hasPause = 1), Rt(this, i, jt(this, t));
                    }),
                    (a.removePause = function (t) {
                        var e = this._first;
                        for (t = jt(this, t); e; ) e._start === t && "isPause" === e.data && Ct(e), (e = e._next);
                    }),
                    (a.killTweensOf = function (t, e, r) {
                        for (var i = this.getTweensOf(t, r), n = i.length; n--; ) Ve !== i[n] && i[n].kill(t, e);
                        return this;
                    }),
                    (a.getTweensOf = function (t, e) {
                        for (var r, i = [], n = Jt(t), s = this._first, a = k(e); s; )
                            s instanceof We
                                ? mt(s._targets, n) &&
                                  (a
                                      ? (!Ve || (s._initted && s._ts)) &&
                                        s.globalTime(0) <= e &&
                                        s.globalTime(s.totalDuration()) > e
                                      : !e || s.isActive()) &&
                                  i.push(s)
                                : (r = s.getTweensOf(n, e)).length && i.push.apply(i, r),
                                (s = s._next);
                        return i;
                    }),
                    (a.tweenTo = function (t, e) {
                        e = e || {};
                        var r,
                            i = this,
                            n = jt(i, t),
                            s = e,
                            a = s.startAt,
                            o = s.onStart,
                            l = s.onStartParams,
                            h = s.immediateRender,
                            p = We.to(
                                i,
                                _t(
                                    {
                                        ease: e.ease || "none",
                                        lazy: !1,
                                        immediateRender: !1,
                                        time: n,
                                        overwrite: "auto",
                                        duration:
                                            e.duration ||
                                            Math.abs((n - (a && "time" in a ? a.time : i._time)) / i.timeScale()) ||
                                            _,
                                        onStart: function () {
                                            if ((i.pause(), !r)) {
                                                var t =
                                                    e.duration ||
                                                    Math.abs(
                                                        (n - (a && "time" in a ? a.time : i._time)) / i.timeScale()
                                                    );
                                                p._dur !== t && qt(p, t, 0, 1).render(p._time, !0, !0), (r = 1);
                                            }
                                            o && o.apply(p, l || []);
                                        },
                                    },
                                    e
                                )
                            );
                        return h ? p.render(0) : p;
                    }),
                    (a.tweenFromTo = function (t, e, r) {
                        return this.tweenTo(e, _t({ startAt: { time: jt(this, t) } }, r));
                    }),
                    (a.recent = function () {
                        return this._recent;
                    }),
                    (a.nextLabel = function (t) {
                        return void 0 === t && (t = this._time), le(this, jt(this, t));
                    }),
                    (a.previousLabel = function (t) {
                        return void 0 === t && (t = this._time), le(this, jt(this, t), 1);
                    }),
                    (a.currentLabel = function (t) {
                        return arguments.length ? this.seek(t, !0) : this.previousLabel(this._time + _);
                    }),
                    (a.shiftChildren = function (t, e, r) {
                        void 0 === r && (r = 0);
                        for (var i, n = this._first, s = this.labels; n; )
                            n._start >= r && ((n._start += t), (n._end += t)), (n = n._next);
                        if (e) for (i in s) s[i] >= r && (s[i] += t);
                        return At(this);
                    }),
                    (a.invalidate = function (t) {
                        var e = this._first;
                        for (this._lock = 0; e; ) e.invalidate(t), (e = e._next);
                        return r.prototype.invalidate.call(this, t);
                    }),
                    (a.clear = function (t) {
                        void 0 === t && (t = !0);
                        for (var e, r = this._first; r; ) (e = r._next), this.remove(r), (r = e);
                        return (
                            this._dp && (this._time = this._tTime = this._pTime = 0), t && (this.labels = {}), At(this)
                        );
                    }),
                    (a.totalDuration = function (t) {
                        var e,
                            r,
                            i,
                            n = 0,
                            a = this,
                            o = a._last,
                            l = b;
                        if (arguments.length)
                            return a.timeScale(
                                (a._repeat < 0 ? a.duration() : a.totalDuration()) / (a.reversed() ? -t : t)
                            );
                        if (a._dirty) {
                            for (i = a.parent; o; )
                                (e = o._prev),
                                    o._dirty && o.totalDuration(),
                                    (r = o._start) > l && a._sort && o._ts && !a._lock
                                        ? ((a._lock = 1), (Rt(a, o, r - o._delay, 1)._lock = 0))
                                        : (l = r),
                                    r < 0 &&
                                        o._ts &&
                                        ((n -= r),
                                        ((!i && !a._dp) || (i && i.smoothChildTiming)) &&
                                            ((a._start += r / a._ts), (a._time -= r), (a._tTime -= r)),
                                        a.shiftChildren(-r, !1, -1 / 0),
                                        (l = 0)),
                                    o._end > n && o._ts && (n = o._end),
                                    (o = e);
                            qt(a, a === s && a._time > n ? a._time : n, 1, 1), (a._dirty = 0);
                        }
                        return a._tDur;
                    }),
                    (n.updateRoot = function (t) {
                        if ((s._ts && (yt(s, It(t, s)), (p = _e.frame)), _e.frame >= st)) {
                            st += y.autoSleep || 120;
                            var e = s._first;
                            if ((!e || !e._ts) && y.autoSleep && _e._listeners.length < 2) {
                                for (; e && !e._ts; ) e = e._next;
                                e || _e.sleep();
                            }
                        }
                    }),
                    n
                );
            })(Le);
            _t(Be.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
            var Ve,
                Re,
                Oe = function (t, e, r, i, n, s, a) {
                    var o,
                        l,
                        h,
                        p,
                        c,
                        d,
                        u,
                        f,
                        m = new ar(this._pt, t, e, 0, 1, tr, null, n),
                        g = 0,
                        y = 0;
                    for (
                        m.b = r,
                            m.e = i,
                            r += "",
                            (u = ~(i += "").indexOf("random(")) && (i = ae(i)),
                            s && (s((f = [r, i]), t, e), (r = f[0]), (i = f[1])),
                            l = r.match(G) || [];
                        (o = G.exec(i));

                    )
                        (p = o[0]),
                            (c = i.substring(g, o.index)),
                            h ? (h = (h + 1) % 5) : "rgba(" === c.substr(-5) && (h = 1),
                            p !== l[y++] &&
                                ((d = parseFloat(l[y - 1]) || 0),
                                (m._pt = {
                                    _next: m._pt,
                                    p: c || 1 === y ? c : ",",
                                    s: d,
                                    c: "=" === p.charAt(1) ? ft(d, p) - d : parseFloat(p) - d,
                                    m: h && h < 4 ? Math.round : 0,
                                }),
                                (g = G.lastIndex));
                    return (
                        (m.c = g < i.length ? i.substring(g, i.length) : ""),
                        (m.fp = a),
                        (N.test(i) || u) && (m.e = 0),
                        (this._pt = m),
                        m
                    );
                },
                ze = function (t, e, r, i, n, s, a, o, l, h) {
                    A(i) && (i = i(n || 0, t, s));
                    var p,
                        c = t[e],
                        d =
                            "get" !== r
                                ? r
                                : A(c)
                                  ? l
                                      ? t[e.indexOf("set") || !A(t["get" + e.substr(3)]) ? e : "get" + e.substr(3)](l)
                                      : t[e]()
                                  : c,
                        u = A(c) ? (l ? Ue : Xe) : Ye;
                    if (
                        (C(i) &&
                            (~i.indexOf("random(") && (i = ae(i)),
                            "=" === i.charAt(1) && ((p = ft(d, i) + (Ut(d) || 0)) || 0 === p) && (i = p)),
                        !h || d !== i || Re)
                    )
                        return isNaN(d * i) || "" === i
                            ? (!c && !(e in t) && Y(e, i), Oe.call(this, t, e, d, i, u, o || y.stringFilter, l))
                            : ((p = new ar(
                                  this._pt,
                                  t,
                                  e,
                                  +d || 0,
                                  i - (d || 0),
                                  "boolean" == typeof c ? Qe : Je,
                                  0,
                                  u
                              )),
                              l && (p.fp = l),
                              a && p.modifier(a, this, t),
                              (this._pt = p));
                },
                Ge = function (t, e, r, i, n, s) {
                    var a, o, l, h;
                    if (
                        it[t] &&
                        !1 !==
                            (a = new it[t]()).init(
                                n,
                                a.rawVars
                                    ? e[t]
                                    : (function (t, e, r, i, n) {
                                          if (
                                              (A(t) && (t = He(t, n, e, r, i)),
                                              !D(t) || (t.style && t.nodeType) || V(t) || B(t))
                                          )
                                              return C(t) ? He(t, n, e, r, i) : t;
                                          var s,
                                              a = {};
                                          for (s in t) a[s] = He(t[s], n, e, r, i);
                                          return a;
                                      })(e[t], i, n, s, r),
                                r,
                                i,
                                s
                            ) &&
                        ((r._pt = o = new ar(r._pt, n, t, 0, 1, a.render, a, 0, a.priority)), r !== c)
                    )
                        for (l = r._ptLookup[r._targets.indexOf(n)], h = a._props.length; h--; ) l[a._props[h]] = o;
                    return a;
                },
                Ne = function t(e, n, a) {
                    var o,
                        l,
                        h,
                        p,
                        c,
                        d,
                        u,
                        f,
                        m,
                        g,
                        y,
                        x,
                        S,
                        E = e.vars,
                        w = E.ease,
                        P = E.startAt,
                        T = E.immediateRender,
                        C = E.lazy,
                        A = E.onUpdate,
                        k = E.onUpdateParams,
                        M = E.callbackScope,
                        D = E.runBackwards,
                        I = E.yoyoEase,
                        L = E.keyframes,
                        B = E.autoRevert,
                        V = e._dur,
                        R = e._startAt,
                        O = e._targets,
                        z = e.parent,
                        G = z && "nested" === z.data ? z.vars.targets : O,
                        N = "auto" === e._overwrite && !r,
                        q = e.timeline;
                    if (
                        (q && (!L || !w) && (w = "none"),
                        (e._ease = Ae(w, v.ease)),
                        (e._yEase = I ? Te(Ae(!0 === I ? w : I, v.ease)) : 0),
                        I && e._yoyo && !e._repeat && ((I = e._yEase), (e._yEase = e._ease), (e._ease = I)),
                        (e._from = !q && !!E.runBackwards),
                        !q || (L && !E.stagger))
                    ) {
                        if (
                            ((x = (f = O[0] ? ht(O[0]).harness : 0) && E[f.prop]),
                            (o = Et(E, tt)),
                            R &&
                                (R._zTime < 0 && R.progress(1),
                                n < 0 && D && T && !B ? R.render(-1, !0) : R.revert(D && V ? J : K),
                                (R._lazy = 0)),
                            P)
                        ) {
                            if (
                                (Ct(
                                    (e._startAt = We.set(
                                        O,
                                        _t(
                                            {
                                                data: "isStart",
                                                overwrite: !1,
                                                parent: z,
                                                immediateRender: !0,
                                                lazy: !R && F(C),
                                                startAt: null,
                                                delay: 0,
                                                onUpdate: A,
                                                onUpdateParams: k,
                                                callbackScope: M,
                                                stagger: 0,
                                            },
                                            P
                                        )
                                    ))
                                ),
                                (e._startAt._dp = 0),
                                (e._startAt._sat = e),
                                n < 0 && (i || (!T && !B)) && e._startAt.revert(J),
                                T && V && n <= 0 && a <= 0)
                            )
                                return void (n && (e._zTime = n));
                        } else if (D && V && !R)
                            if (
                                (n && (T = !1),
                                (h = _t(
                                    {
                                        overwrite: !1,
                                        data: "isFromStart",
                                        lazy: T && !R && F(C),
                                        immediateRender: T,
                                        stagger: 0,
                                        parent: z,
                                    },
                                    o
                                )),
                                x && (h[f.prop] = x),
                                Ct((e._startAt = We.set(O, h))),
                                (e._startAt._dp = 0),
                                (e._startAt._sat = e),
                                n < 0 && (i ? e._startAt.revert(J) : e._startAt.render(-1, !0)),
                                (e._zTime = n),
                                T)
                            ) {
                                if (!n) return;
                            } else t(e._startAt, _, _);
                        for (e._pt = e._ptCache = 0, C = (V && F(C)) || (C && !V), l = 0; l < O.length; l++) {
                            if (
                                ((u = (c = O[l])._gsap || lt(O)[l]._gsap),
                                (e._ptLookup[l] = g = {}),
                                rt[u.id] && et.length && gt(),
                                (y = G === O ? l : G.indexOf(c)),
                                f &&
                                    !1 !== (m = new f()).init(c, x || o, e, y, G) &&
                                    ((e._pt = p = new ar(e._pt, c, m.name, 0, 1, m.render, m, 0, m.priority)),
                                    m._props.forEach(function (t) {
                                        g[t] = p;
                                    }),
                                    m.priority && (d = 1)),
                                !f || x)
                            )
                                for (h in o)
                                    it[h] && (m = Ge(h, o, e, y, c, G))
                                        ? m.priority && (d = 1)
                                        : (g[h] = p = ze.call(e, c, h, "get", o[h], y, G, 0, E.stringFilter));
                            e._op && e._op[l] && e.kill(c, e._op[l]),
                                N &&
                                    e._pt &&
                                    ((Ve = e), s.killTweensOf(c, g, e.globalTime(n)), (S = !e.parent), (Ve = 0)),
                                e._pt && C && (rt[u.id] = 1);
                        }
                        d && sr(e), e._onInit && e._onInit(e);
                    }
                    (e._onUpdate = A), (e._initted = (!e._op || e._pt) && !S), L && n <= 0 && q.render(b, !0, !0);
                },
                qe = function (t, e, r, i) {
                    var n,
                        s,
                        a = e.ease || i || "power1.inOut";
                    if (V(e))
                        (s = r[t] || (r[t] = [])),
                            e.forEach(function (t, r) {
                                return s.push({ t: (r / (e.length - 1)) * 100, v: t, e: a });
                            });
                    else
                        for (n in e)
                            (s = r[n] || (r[n] = [])), "ease" === n || s.push({ t: parseFloat(t), v: e[n], e: a });
                },
                He = function (t, e, r, i, n) {
                    return A(t) ? t.call(e, r, i, n) : C(t) && ~t.indexOf("random(") ? ae(t) : t;
                },
                $e = ot + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
                je = {};
            ct($e + ",id,stagger,delay,duration,paused,scrollTrigger", function (t) {
                return (je[t] = 1);
            });
            var We = (function (n) {
                function a(e, i, a, o) {
                    var l;
                    "number" == typeof i && ((a.duration = i), (i = a), (a = null));
                    var h,
                        p,
                        c,
                        d,
                        u,
                        f,
                        m,
                        g,
                        v = (l = n.call(this, o ? i : wt(i)) || this).vars,
                        b = v.duration,
                        _ = v.delay,
                        x = v.immediateRender,
                        S = v.stagger,
                        E = v.overwrite,
                        w = v.keyframes,
                        P = v.defaults,
                        T = v.scrollTrigger,
                        C = v.yoyoEase,
                        A = i.parent || s,
                        M = (V(e) || B(e) ? k(e[0]) : "length" in i) ? [e] : Jt(e);
                    if (
                        ((l._targets = M.length
                            ? lt(M)
                            : X("GSAP target " + e + " not found. https://greensock.com", !y.nullTargetWarn) || []),
                        (l._ptLookup = []),
                        (l._overwrite = E),
                        w || S || L(b) || L(_))
                    ) {
                        if (
                            ((i = l.vars),
                            (h = l.timeline =
                                new Be({
                                    data: "nested",
                                    defaults: P || {},
                                    targets: A && "nested" === A.data ? A.vars.targets : M,
                                })).kill(),
                            (h.parent = h._dp = t(l)),
                            (h._start = 0),
                            S || L(b) || L(_))
                        ) {
                            if (((d = M.length), (m = S && ee(S)), D(S)))
                                for (u in S) ~$e.indexOf(u) && (g || (g = {}), (g[u] = S[u]));
                            for (p = 0; p < d; p++)
                                ((c = Et(i, je)).stagger = 0),
                                    C && (c.yoyoEase = C),
                                    g && xt(c, g),
                                    (f = M[p]),
                                    (c.duration = +He(b, t(l), p, f, M)),
                                    (c.delay = (+He(_, t(l), p, f, M) || 0) - l._delay),
                                    !S &&
                                        1 === d &&
                                        c.delay &&
                                        ((l._delay = _ = c.delay), (l._start += _), (c.delay = 0)),
                                    h.to(f, c, m ? m(p, f, M) : 0),
                                    (h._ease = Se.none);
                            h.duration() ? (b = _ = 0) : (l.timeline = 0);
                        } else if (w) {
                            wt(_t(h.vars.defaults, { ease: "none" })), (h._ease = Ae(w.ease || i.ease || "none"));
                            var I,
                                R,
                                O,
                                z = 0;
                            if (V(w))
                                w.forEach(function (t) {
                                    return h.to(M, t, ">");
                                }),
                                    h.duration();
                            else {
                                for (u in ((c = {}), w)) "ease" === u || "easeEach" === u || qe(u, w[u], c, w.easeEach);
                                for (u in c)
                                    for (
                                        I = c[u].sort(function (t, e) {
                                            return t.t - e.t;
                                        }),
                                            z = 0,
                                            p = 0;
                                        p < I.length;
                                        p++
                                    )
                                        ((O = {
                                            ease: (R = I[p]).e,
                                            duration: ((R.t - (p ? I[p - 1].t : 0)) / 100) * b,
                                        })[u] = R.v),
                                            h.to(M, O, z),
                                            (z += O.duration);
                                h.duration() < b && h.to({}, { duration: b - h.duration() });
                            }
                        }
                        b || l.duration((b = h.duration()));
                    } else l.timeline = 0;
                    return (
                        !0 !== E || r || ((Ve = t(l)), s.killTweensOf(M), (Ve = 0)),
                        Rt(A, t(l), a),
                        i.reversed && l.reverse(),
                        i.paused && l.paused(!0),
                        (x || (!b && !w && l._start === ut(A._time) && F(x) && Mt(t(l)) && "nested" !== A.data)) &&
                            ((l._tTime = -1e-8), l.render(Math.max(0, -_) || 0)),
                        T && Ot(t(l), T),
                        l
                    );
                }
                e(a, n);
                var o = a.prototype;
                return (
                    (o.render = function (t, e, r) {
                        var n,
                            s,
                            a,
                            o,
                            l,
                            h,
                            p,
                            c,
                            d,
                            u = this._time,
                            f = this._tDur,
                            m = this._dur,
                            g = t < 0,
                            y = t > f - _ && !g ? f : t < _ ? 0 : t;
                        if (m) {
                            if (
                                y !== this._tTime ||
                                !t ||
                                r ||
                                (!this._initted && this._tTime) ||
                                (this._startAt && this._zTime < 0 !== g)
                            ) {
                                if (((n = y), (c = this.timeline), this._repeat)) {
                                    if (((o = m + this._rDelay), this._repeat < -1 && g))
                                        return this.totalTime(100 * o + t, e, r);
                                    if (
                                        ((n = ut(y % o)),
                                        y === f
                                            ? ((a = this._repeat), (n = m))
                                            : ((a = ~~(y / o)) && a === y / o && ((n = m), a--), n > m && (n = m)),
                                        (h = this._yoyo && 1 & a) && ((d = this._yEase), (n = m - n)),
                                        (l = Ft(this._tTime, o)),
                                        n === u && !r && this._initted)
                                    )
                                        return (this._tTime = y), this;
                                    a !== l &&
                                        (c && this._yEase && Ce(c, h),
                                        !this.vars.repeatRefresh ||
                                            h ||
                                            this._lock ||
                                            ((this._lock = r = 1),
                                            (this.render(ut(o * a), !0).invalidate()._lock = 0)));
                                }
                                if (!this._initted) {
                                    if (zt(this, g ? t : n, r, e, y)) return (this._tTime = 0), this;
                                    if (u !== this._time) return this;
                                    if (m !== this._dur) return this.render(t, e, r);
                                }
                                if (
                                    ((this._tTime = y),
                                    (this._time = n),
                                    !this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
                                    (this.ratio = p = (d || this._ease)(n / m)),
                                    this._from && (this.ratio = p = 1 - p),
                                    n && !u && !e && (he(this, "onStart"), this._tTime !== y))
                                )
                                    return this;
                                for (s = this._pt; s; ) s.r(p, s.d), (s = s._next);
                                (c && c.render(t < 0 ? t : !n && h ? -1e-8 : c._dur * c._ease(n / this._dur), e, r)) ||
                                    (this._startAt && (this._zTime = t)),
                                    this._onUpdate && !e && (g && kt(this, t, 0, r), he(this, "onUpdate")),
                                    this._repeat &&
                                        a !== l &&
                                        this.vars.onRepeat &&
                                        !e &&
                                        this.parent &&
                                        he(this, "onRepeat"),
                                    (y !== this._tDur && y) ||
                                        this._tTime !== y ||
                                        (g && !this._onUpdate && kt(this, t, 0, !0),
                                        (t || !m) &&
                                            ((y === this._tDur && this._ts > 0) || (!y && this._ts < 0)) &&
                                            Ct(this, 1),
                                        e ||
                                            (g && !u) ||
                                            !(y || u || h) ||
                                            (he(this, y === f ? "onComplete" : "onReverseComplete", !0),
                                            this._prom && !(y < f && this.timeScale() > 0) && this._prom()));
                            }
                        } else
                            !(function (t, e, r, n) {
                                var s,
                                    a,
                                    o,
                                    l = t.ratio,
                                    h =
                                        e < 0 ||
                                        (!e &&
                                            ((!t._start && Gt(t) && (t._initted || !Nt(t))) ||
                                                ((t._ts < 0 || t._dp._ts < 0) && !Nt(t))))
                                            ? 0
                                            : 1,
                                    p = t._rDelay,
                                    c = 0;
                                if (
                                    (p &&
                                        t._repeat &&
                                        ((c = Xt(0, t._tDur, e)),
                                        (a = Ft(c, p)),
                                        t._yoyo && 1 & a && (h = 1 - h),
                                        a !== Ft(t._tTime, p) &&
                                            ((l = 1 - h), t.vars.repeatRefresh && t._initted && t.invalidate())),
                                    h !== l || i || n || t._zTime === _ || (!e && t._zTime))
                                ) {
                                    if (!t._initted && zt(t, e, n, r, c)) return;
                                    for (
                                        o = t._zTime,
                                            t._zTime = e || (r ? _ : 0),
                                            r || (r = e && !o),
                                            t.ratio = h,
                                            t._from && (h = 1 - h),
                                            t._time = 0,
                                            t._tTime = c,
                                            s = t._pt;
                                        s;

                                    )
                                        s.r(h, s.d), (s = s._next);
                                    e < 0 && kt(t, e, 0, !0),
                                        t._onUpdate && !r && he(t, "onUpdate"),
                                        c && t._repeat && !r && t.parent && he(t, "onRepeat"),
                                        (e >= t._tDur || e < 0) &&
                                            t.ratio === h &&
                                            (h && Ct(t, 1),
                                            r ||
                                                i ||
                                                (he(t, h ? "onComplete" : "onReverseComplete", !0),
                                                t._prom && t._prom()));
                                } else t._zTime || (t._zTime = e);
                            })(this, t, e, r);
                        return this;
                    }),
                    (o.targets = function () {
                        return this._targets;
                    }),
                    (o.invalidate = function (t) {
                        return (
                            (!t || !this.vars.runBackwards) && (this._startAt = 0),
                            (this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0),
                            (this._ptLookup = []),
                            this.timeline && this.timeline.invalidate(t),
                            n.prototype.invalidate.call(this, t)
                        );
                    }),
                    (o.resetTo = function (t, e, r, i) {
                        d || _e.wake(), this._ts || this.play();
                        var n = Math.min(this._dur, (this._dp._time - this._start) * this._ts);
                        return (
                            this._initted || Ne(this, n),
                            (function (t, e, r, i, n, s, a) {
                                var o,
                                    l,
                                    h,
                                    p,
                                    c = ((t._pt && t._ptCache) || (t._ptCache = {}))[e];
                                if (!c)
                                    for (c = t._ptCache[e] = [], h = t._ptLookup, p = t._targets.length; p--; ) {
                                        if ((o = h[p][e]) && o.d && o.d._pt)
                                            for (o = o.d._pt; o && o.p !== e && o.fp !== e; ) o = o._next;
                                        if (!o) return (Re = 1), (t.vars[e] = "+=0"), Ne(t, a), (Re = 0), 1;
                                        c.push(o);
                                    }
                                for (p = c.length; p--; )
                                    ((o = (l = c[p])._pt || l).s = (!i && 0 !== i) || n ? o.s + (i || 0) + s * o.c : i),
                                        (o.c = r - o.s),
                                        l.e && (l.e = dt(r) + Ut(l.e)),
                                        l.b && (l.b = o.s + Ut(l.b));
                            })(this, t, e, r, i, this._ease(n / this._dur), n)
                                ? this.resetTo(t, e, r, i)
                                : (Bt(this, 0),
                                  this.parent || Pt(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0),
                                  this.render(0))
                        );
                    }),
                    (o.kill = function (t, e) {
                        if ((void 0 === e && (e = "all"), !(t || (e && "all" !== e))))
                            return (this._lazy = this._pt = 0), this.parent ? pe(this) : this;
                        if (this.timeline) {
                            var r = this.timeline.totalDuration();
                            return (
                                this.timeline.killTweensOf(t, e, Ve && !0 !== Ve.vars.overwrite)._first || pe(this),
                                this.parent &&
                                    r !== this.timeline.totalDuration() &&
                                    qt(this, (this._dur * this.timeline._tDur) / r, 0, 1),
                                this
                            );
                        }
                        var i,
                            n,
                            s,
                            a,
                            o,
                            l,
                            h,
                            p = this._targets,
                            c = t ? Jt(t) : p,
                            d = this._ptLookup,
                            u = this._pt;
                        if (
                            (!e || "all" === e) &&
                            (function (t, e) {
                                for (var r = t.length, i = r === e.length; i && r-- && t[r] === e[r]; );
                                return r < 0;
                            })(p, c)
                        )
                            return "all" === e && (this._pt = 0), pe(this);
                        for (
                            i = this._op = this._op || [],
                                "all" !== e &&
                                    (C(e) &&
                                        ((o = {}),
                                        ct(e, function (t) {
                                            return (o[t] = 1);
                                        }),
                                        (e = o)),
                                    (e = (function (t, e) {
                                        var r,
                                            i,
                                            n,
                                            s,
                                            a = t[0] ? ht(t[0]).harness : 0,
                                            o = a && a.aliases;
                                        if (!o) return e;
                                        for (i in ((r = xt({}, e)), o))
                                            if ((i in r)) for (n = (s = o[i].split(",")).length; n--; ) r[s[n]] = r[i];
                                        return r;
                                    })(p, e))),
                                h = p.length;
                            h--;

                        )
                            if (~c.indexOf(p[h]))
                                for (o in ((n = d[h]),
                                "all" === e ? ((i[h] = e), (a = n), (s = {})) : ((s = i[h] = i[h] || {}), (a = e)),
                                a))
                                    (l = n && n[o]) &&
                                        (("kill" in l.d && !0 !== l.d.kill(o)) || Tt(this, l, "_pt"), delete n[o]),
                                        "all" !== s && (s[o] = 1);
                        return this._initted && !this._pt && u && pe(this), this;
                    }),
                    (a.to = function (t, e) {
                        return new a(t, e, arguments[2]);
                    }),
                    (a.from = function (t, e) {
                        return Wt(1, arguments);
                    }),
                    (a.delayedCall = function (t, e, r, i) {
                        return new a(e, 0, {
                            immediateRender: !1,
                            lazy: !1,
                            overwrite: !1,
                            delay: t,
                            onComplete: e,
                            onReverseComplete: e,
                            onCompleteParams: r,
                            onReverseCompleteParams: r,
                            callbackScope: i,
                        });
                    }),
                    (a.fromTo = function (t, e, r) {
                        return Wt(2, arguments);
                    }),
                    (a.set = function (t, e) {
                        return (e.duration = 0), e.repeatDelay || (e.repeat = 0), new a(t, e);
                    }),
                    (a.killTweensOf = function (t, e, r) {
                        return s.killTweensOf(t, e, r);
                    }),
                    a
                );
            })(Le);
            _t(We.prototype, { _targets: [], _lazy: 0, _startAt: 0, _op: 0, _onInit: 0 }),
                ct("staggerTo,staggerFrom,staggerFromTo", function (t) {
                    We[t] = function () {
                        var e = new Be(),
                            r = Zt.call(arguments, 0);
                        return r.splice("staggerFromTo" === t ? 5 : 4, 0, 0), e[t].apply(e, r);
                    };
                });
            var Ye = function (t, e, r) {
                    return (t[e] = r);
                },
                Xe = function (t, e, r) {
                    return t[e](r);
                },
                Ue = function (t, e, r, i) {
                    return t[e](i.fp, r);
                },
                Ze = function (t, e, r) {
                    return t.setAttribute(e, r);
                },
                Ke = function (t, e) {
                    return A(t[e]) ? Xe : M(t[e]) && t.setAttribute ? Ze : Ye;
                },
                Je = function (t, e) {
                    return e.set(e.t, e.p, Math.round(1e6 * (e.s + e.c * t)) / 1e6, e);
                },
                Qe = function (t, e) {
                    return e.set(e.t, e.p, !!(e.s + e.c * t), e);
                },
                tr = function (t, e) {
                    var r = e._pt,
                        i = "";
                    if (!t && e.b) i = e.b;
                    else if (1 === t && e.e) i = e.e;
                    else {
                        for (; r; )
                            (i = r.p + (r.m ? r.m(r.s + r.c * t) : Math.round(1e4 * (r.s + r.c * t)) / 1e4) + i),
                                (r = r._next);
                        i += e.c;
                    }
                    e.set(e.t, e.p, i, e);
                },
                er = function (t, e) {
                    for (var r = e._pt; r; ) r.r(t, r.d), (r = r._next);
                },
                rr = function (t, e, r, i) {
                    for (var n, s = this._pt; s; ) (n = s._next), s.p === i && s.modifier(t, e, r), (s = n);
                },
                ir = function (t) {
                    for (var e, r, i = this._pt; i; )
                        (r = i._next),
                            (i.p === t && !i.op) || i.op === t ? Tt(this, i, "_pt") : i.dep || (e = 1),
                            (i = r);
                    return !e;
                },
                nr = function (t, e, r, i) {
                    i.mSet(t, e, i.m.call(i.tween, r, i.mt), i);
                },
                sr = function (t) {
                    for (var e, r, i, n, s = t._pt; s; ) {
                        for (e = s._next, r = i; r && r.pr > s.pr; ) r = r._next;
                        (s._prev = r ? r._prev : n) ? (s._prev._next = s) : (i = s),
                            (s._next = r) ? (r._prev = s) : (n = s),
                            (s = e);
                    }
                    t._pt = i;
                },
                ar = (function () {
                    function t(t, e, r, i, n, s, a, o, l) {
                        (this.t = e),
                            (this.s = i),
                            (this.c = n),
                            (this.p = r),
                            (this.r = s || Je),
                            (this.d = a || this),
                            (this.set = o || Ye),
                            (this.pr = l || 0),
                            (this._next = t),
                            t && (t._prev = this);
                    }
                    return (
                        (t.prototype.modifier = function (t, e, r) {
                            (this.mSet = this.mSet || this.set),
                                (this.set = nr),
                                (this.m = t),
                                (this.mt = r),
                                (this.tween = e);
                        }),
                        t
                    );
                })();
            ct(
                ot +
                    "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",
                function (t) {
                    return (tt[t] = 1);
                }
            ),
                ($.TweenMax = $.TweenLite = We),
                ($.TimelineLite = $.TimelineMax = Be),
                (s = new Be({
                    sortChildren: !1,
                    defaults: v,
                    autoRemoveChildren: !0,
                    id: "root",
                    smoothChildTiming: !0,
                })),
                (y.stringFilter = be);
            var or = [],
                lr = {},
                hr = [],
                pr = 0,
                cr = function (t) {
                    return (lr[t] || hr).map(function (t) {
                        return t();
                    });
                },
                dr = function () {
                    var t = Date.now(),
                        e = [];
                    t - pr > 2 &&
                        (cr("matchMediaInit"),
                        or.forEach(function (t) {
                            var r,
                                i,
                                n,
                                s,
                                o = t.queries,
                                l = t.conditions;
                            for (i in o)
                                (r = a.matchMedia(o[i]).matches) && (n = 1), r !== l[i] && ((l[i] = r), (s = 1));
                            s && (t.revert(), n && e.push(t));
                        }),
                        cr("matchMediaRevert"),
                        e.forEach(function (t) {
                            return t.onMatch(t);
                        }),
                        (pr = t),
                        cr("matchMedia"));
                },
                ur = (function () {
                    function t(t, e) {
                        (this.selector = e && Qt(e)),
                            (this.data = []),
                            (this._r = []),
                            (this.isReverted = !1),
                            t && this.add(t);
                    }
                    var e = t.prototype;
                    return (
                        (e.add = function (t, e, r) {
                            A(t) && ((r = e), (e = t), (t = A));
                            var i = this,
                                s = function () {
                                    var t,
                                        s = n,
                                        a = i.selector;
                                    return (
                                        s && s !== i && s.data.push(i),
                                        r && (i.selector = Qt(r)),
                                        (n = i),
                                        (t = e.apply(i, arguments)),
                                        A(t) && i._r.push(t),
                                        (n = s),
                                        (i.selector = a),
                                        (i.isReverted = !1),
                                        t
                                    );
                                };
                            return (i.last = s), t === A ? s(i) : t ? (i[t] = s) : s;
                        }),
                        (e.ignore = function (t) {
                            var e = n;
                            (n = null), t(this), (n = e);
                        }),
                        (e.getTweens = function () {
                            var e = [];
                            return (
                                this.data.forEach(function (r) {
                                    return r instanceof t
                                        ? e.push.apply(e, r.getTweens())
                                        : r instanceof We && !(r.parent && "nested" === r.parent.data) && e.push(r);
                                }),
                                e
                            );
                        }),
                        (e.clear = function () {
                            this._r.length = this.data.length = 0;
                        }),
                        (e.kill = function (t, e) {
                            var r = this;
                            if (t) {
                                var i = this.getTweens();
                                this.data.forEach(function (t) {
                                    "isFlip" === t.data &&
                                        (t.revert(),
                                        t.getChildren(!0, !0, !1).forEach(function (t) {
                                            return i.splice(i.indexOf(t), 1);
                                        }));
                                }),
                                    i
                                        .map(function (t) {
                                            return { g: t.globalTime(0), t: t };
                                        })
                                        .sort(function (t, e) {
                                            return e.g - t.g || -1;
                                        })
                                        .forEach(function (e) {
                                            return e.t.revert(t);
                                        }),
                                    this.data.forEach(function (e) {
                                        return !(e instanceof Le) && e.revert && e.revert(t);
                                    }),
                                    this._r.forEach(function (e) {
                                        return e(t, r);
                                    }),
                                    (this.isReverted = !0);
                            } else
                                this.data.forEach(function (t) {
                                    return t.kill && t.kill();
                                });
                            if ((this.clear(), e)) {
                                var n = or.indexOf(this);
                                ~n && or.splice(n, 1);
                            }
                        }),
                        (e.revert = function (t) {
                            this.kill(t || {});
                        }),
                        t
                    );
                })(),
                fr = (function () {
                    function t(t) {
                        (this.contexts = []), (this.scope = t);
                    }
                    var e = t.prototype;
                    return (
                        (e.add = function (t, e, r) {
                            D(t) || (t = { matches: t });
                            var i,
                                n,
                                s,
                                o = new ur(0, r || this.scope),
                                l = (o.conditions = {});
                            for (n in (this.contexts.push(o), (e = o.add("onMatch", e)), (o.queries = t), t))
                                "all" === n
                                    ? (s = 1)
                                    : (i = a.matchMedia(t[n])) &&
                                      (or.indexOf(o) < 0 && or.push(o),
                                      (l[n] = i.matches) && (s = 1),
                                      i.addListener ? i.addListener(dr) : i.addEventListener("change", dr));
                            return s && e(o), this;
                        }),
                        (e.revert = function (t) {
                            this.kill(t || {});
                        }),
                        (e.kill = function (t) {
                            this.contexts.forEach(function (e) {
                                return e.kill(t, !0);
                            });
                        }),
                        t
                    );
                })(),
                mr = {
                    registerPlugin: function () {
                        for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) e[r] = arguments[r];
                        e.forEach(function (t) {
                            return (function (t) {
                                var e = (t = (!t.name && t.default) || t).name,
                                    r = A(t),
                                    i =
                                        e && !r && t.init
                                            ? function () {
                                                  this._props = [];
                                              }
                                            : t,
                                    n = { init: Z, render: er, add: ze, kill: ir, modifier: rr, rawVars: 0 },
                                    s = { targetTest: 0, get: 0, getSetter: Ke, aliases: {}, register: 0 };
                                if ((xe(), t !== i)) {
                                    if (it[e]) return;
                                    _t(i, _t(Et(t, n), s)),
                                        xt(i.prototype, xt(n, Et(t, s))),
                                        (it[(i.prop = e)] = i),
                                        t.targetTest && (at.push(i), (tt[e] = 1)),
                                        (e =
                                            ("css" === e ? "CSS" : e.charAt(0).toUpperCase() + e.substr(1)) + "Plugin");
                                }
                                U(e, i), t.register && t.register(vr, i, ar);
                            })(t);
                        });
                    },
                    timeline: function (t) {
                        return new Be(t);
                    },
                    getTweensOf: function (t, e) {
                        return s.getTweensOf(t, e);
                    },
                    getProperty: function (t, e, r, i) {
                        C(t) && (t = Jt(t)[0]);
                        var n = ht(t || {}).get,
                            s = r ? bt : vt;
                        return (
                            "native" === r && (r = ""),
                            t
                                ? e
                                    ? s(((it[e] && it[e].get) || n)(t, e, r, i))
                                    : function (e, r, i) {
                                          return s(((it[e] && it[e].get) || n)(t, e, r, i));
                                      }
                                : t
                        );
                    },
                    quickSetter: function (t, e, r) {
                        if ((t = Jt(t)).length > 1) {
                            var i = t.map(function (t) {
                                    return vr.quickSetter(t, e, r);
                                }),
                                n = i.length;
                            return function (t) {
                                for (var e = n; e--; ) i[e](t);
                            };
                        }
                        t = t[0] || {};
                        var s = it[e],
                            a = ht(t),
                            o = (a.harness && (a.harness.aliases || {})[e]) || e,
                            l = s
                                ? function (e) {
                                      var i = new s();
                                      (c._pt = 0),
                                          i.init(t, r ? e + r : e, c, 0, [t]),
                                          i.render(1, i),
                                          c._pt && er(1, c);
                                  }
                                : a.set(t, o);
                        return s
                            ? l
                            : function (e) {
                                  return l(t, o, r ? e + r : e, a, 1);
                              };
                    },
                    quickTo: function (t, e, r) {
                        var i,
                            n = vr.to(t, xt((((i = {})[e] = "+=0.1"), (i.paused = !0), i), r || {})),
                            s = function (t, r, i) {
                                return n.resetTo(e, t, r, i);
                            };
                        return (s.tween = n), s;
                    },
                    isTweening: function (t) {
                        return s.getTweensOf(t, !0).length > 0;
                    },
                    defaults: function (t) {
                        return t && t.ease && (t.ease = Ae(t.ease, v.ease)), St(v, t || {});
                    },
                    config: function (t) {
                        return St(y, t || {});
                    },
                    registerEffect: function (t) {
                        var e = t.name,
                            r = t.effect,
                            i = t.plugins,
                            n = t.defaults,
                            s = t.extendTimeline;
                        (i || "").split(",").forEach(function (t) {
                            return t && !it[t] && !$[t] && X(e + " effect requires " + t + " plugin.");
                        }),
                            (nt[e] = function (t, e, i) {
                                return r(Jt(t), _t(e || {}, n), i);
                            }),
                            s &&
                                (Be.prototype[e] = function (t, r, i) {
                                    return this.add(nt[e](t, D(r) ? r : (i = r) && {}, this), i);
                                });
                    },
                    registerEase: function (t, e) {
                        Se[t] = Ae(e);
                    },
                    parseEase: function (t, e) {
                        return arguments.length ? Ae(t, e) : Se;
                    },
                    getById: function (t) {
                        return s.getById(t);
                    },
                    exportRoot: function (t, e) {
                        void 0 === t && (t = {});
                        var r,
                            i,
                            n = new Be(t);
                        for (
                            n.smoothChildTiming = F(t.smoothChildTiming),
                                s.remove(n),
                                n._dp = 0,
                                n._time = n._tTime = s._time,
                                r = s._first;
                            r;

                        )
                            (i = r._next),
                                (!e && !r._dur && r instanceof We && r.vars.onComplete === r._targets[0]) ||
                                    Rt(n, r, r._start - r._delay),
                                (r = i);
                        return Rt(s, n, 0), n;
                    },
                    context: function (t, e) {
                        return t ? new ur(t, e) : n;
                    },
                    matchMedia: function (t) {
                        return new fr(t);
                    },
                    matchMediaRefresh: function () {
                        return (
                            or.forEach(function (t) {
                                var e,
                                    r,
                                    i = t.conditions;
                                for (r in i) i[r] && ((i[r] = !1), (e = 1));
                                e && t.revert();
                            }) || dr()
                        );
                    },
                    addEventListener: function (t, e) {
                        var r = lr[t] || (lr[t] = []);
                        ~r.indexOf(e) || r.push(e);
                    },
                    removeEventListener: function (t, e) {
                        var r = lr[t],
                            i = r && r.indexOf(e);
                        i >= 0 && r.splice(i, 1);
                    },
                    utils: {
                        wrap: function t(e, r, i) {
                            var n = r - e;
                            return V(e)
                                ? se(e, t(0, e.length), r)
                                : Yt(i, function (t) {
                                      return ((n + ((t - e) % n)) % n) + e;
                                  });
                        },
                        wrapYoyo: function t(e, r, i) {
                            var n = r - e,
                                s = 2 * n;
                            return V(e)
                                ? se(e, t(0, e.length - 1), r)
                                : Yt(i, function (t) {
                                      return e + ((t = (s + ((t - e) % s)) % s || 0) > n ? s - t : t);
                                  });
                        },
                        distribute: ee,
                        random: ne,
                        snap: ie,
                        normalize: function (t, e, r) {
                            return oe(t, e, 0, 1, r);
                        },
                        getUnit: Ut,
                        clamp: function (t, e, r) {
                            return Yt(r, function (r) {
                                return Xt(t, e, r);
                            });
                        },
                        splitColor: fe,
                        toArray: Jt,
                        selector: Qt,
                        mapRange: oe,
                        pipe: function () {
                            for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) e[r] = arguments[r];
                            return function (t) {
                                return e.reduce(function (t, e) {
                                    return e(t);
                                }, t);
                            };
                        },
                        unitize: function (t, e) {
                            return function (r) {
                                return t(parseFloat(r)) + (e || Ut(r));
                            };
                        },
                        interpolate: function t(e, r, i, n) {
                            var s = isNaN(e + r)
                                ? 0
                                : function (t) {
                                      return (1 - t) * e + t * r;
                                  };
                            if (!s) {
                                var a,
                                    o,
                                    l,
                                    h,
                                    p,
                                    c = C(e),
                                    d = {};
                                if ((!0 === i && (n = 1) && (i = null), c)) (e = { p: e }), (r = { p: r });
                                else if (V(e) && !V(r)) {
                                    for (l = [], h = e.length, p = h - 2, o = 1; o < h; o++) l.push(t(e[o - 1], e[o]));
                                    h--,
                                        (s = function (t) {
                                            t *= h;
                                            var e = Math.min(p, ~~t);
                                            return l[e](t - e);
                                        }),
                                        (i = r);
                                } else n || (e = xt(V(e) ? [] : {}, e));
                                if (!l) {
                                    for (a in r) ze.call(d, e, a, "get", r[a]);
                                    s = function (t) {
                                        return er(t, d) || (c ? e.p : e);
                                    };
                                }
                            }
                            return Yt(i, s);
                        },
                        shuffle: te,
                    },
                    install: W,
                    effects: nt,
                    ticker: _e,
                    updateRoot: Be.updateRoot,
                    plugins: it,
                    globalTimeline: s,
                    core: {
                        PropTween: ar,
                        globals: U,
                        Tween: We,
                        Timeline: Be,
                        Animation: Le,
                        getCache: ht,
                        _removeLinkedListItem: Tt,
                        reverting: function () {
                            return i;
                        },
                        context: function (t) {
                            return t && n && (n.data.push(t), (t._ctx = n)), n;
                        },
                        suppressOverwrites: function (t) {
                            return (r = t);
                        },
                    },
                };
            ct("to,from,fromTo,delayedCall,set,killTweensOf", function (t) {
                return (mr[t] = We[t]);
            }),
                _e.add(Be.updateRoot),
                (c = mr.to({}, { duration: 0 }));
            var gr = function (t, e) {
                    for (var r = t._pt; r && r.p !== e && r.op !== e && r.fp !== e; ) r = r._next;
                    return r;
                },
                yr = function (t, e) {
                    return {
                        name: t,
                        rawVars: 1,
                        init: function (t, r, i) {
                            i._onInit = function (t) {
                                var i, n;
                                if (
                                    (C(r) &&
                                        ((i = {}),
                                        ct(r, function (t) {
                                            return (i[t] = 1);
                                        }),
                                        (r = i)),
                                    e)
                                ) {
                                    for (n in ((i = {}), r)) i[n] = e(r[n]);
                                    r = i;
                                }
                                !(function (t, e) {
                                    var r,
                                        i,
                                        n,
                                        s = t._targets;
                                    for (r in e)
                                        for (i = s.length; i--; )
                                            (n = t._ptLookup[i][r]) &&
                                                (n = n.d) &&
                                                (n._pt && (n = gr(n, r)),
                                                n && n.modifier && n.modifier(e[r], t, s[i], r));
                                })(t, r);
                            };
                        },
                    };
                },
                vr =
                    mr.registerPlugin(
                        {
                            name: "attr",
                            init: function (t, e, r, i, n) {
                                var s, a, o;
                                for (s in ((this.tween = r), e))
                                    (o = t.getAttribute(s) || ""),
                                        ((a = this.add(t, "setAttribute", (o || 0) + "", e[s], i, n, 0, 0, s)).op = s),
                                        (a.b = o),
                                        this._props.push(s);
                            },
                            render: function (t, e) {
                                for (var r = e._pt; r; ) i ? r.set(r.t, r.p, r.b, r) : r.r(t, r.d), (r = r._next);
                            },
                        },
                        {
                            name: "endArray",
                            init: function (t, e) {
                                for (var r = e.length; r--; ) this.add(t, r, t[r] || 0, e[r], 0, 0, 0, 0, 0, 1);
                            },
                        },
                        yr("roundProps", re),
                        yr("modifiers"),
                        yr("snap", ie)
                    ) || mr;
            (We.version = Be.version = vr.version = "3.11.4"),
                (h = 1),
                I() && xe(),
                Se.Power0,
                Se.Power1,
                Se.Power2,
                Se.Power3,
                Se.Power4,
                Se.Linear,
                Se.Quad,
                Se.Cubic,
                Se.Quart,
                Se.Quint,
                Se.Strong,
                Se.Elastic,
                Se.Back,
                Se.SteppedEase,
                Se.Bounce,
                Se.Sine,
                Se.Expo,
                Se.Circ;
            var br,
                _r,
                xr,
                Sr,
                Er,
                wr,
                Pr,
                Tr,
                Cr = {},
                Ar = 180 / Math.PI,
                kr = Math.PI / 180,
                Mr = Math.atan2,
                Dr = /([A-Z])/g,
                Fr = /(left|right|width|margin|padding|x)/i,
                Ir = /[\s,\(]\S/,
                Lr = { autoAlpha: "opacity,visibility", scale: "scaleX,scaleY", alpha: "opacity" },
                Br = function (t, e) {
                    return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e);
                },
                Vr = function (t, e) {
                    return e.set(e.t, e.p, 1 === t ? e.e : Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e);
                },
                Rr = function (t, e) {
                    return e.set(e.t, e.p, t ? Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u : e.b, e);
                },
                Or = function (t, e) {
                    var r = e.s + e.c * t;
                    e.set(e.t, e.p, ~~(r + (r < 0 ? -0.5 : 0.5)) + e.u, e);
                },
                zr = function (t, e) {
                    return e.set(e.t, e.p, t ? e.e : e.b, e);
                },
                Gr = function (t, e) {
                    return e.set(e.t, e.p, 1 !== t ? e.b : e.e, e);
                },
                Nr = function (t, e, r) {
                    return (t.style[e] = r);
                },
                qr = function (t, e, r) {
                    return t.style.setProperty(e, r);
                },
                Hr = function (t, e, r) {
                    return (t._gsap[e] = r);
                },
                $r = function (t, e, r) {
                    return (t._gsap.scaleX = t._gsap.scaleY = r);
                },
                jr = function (t, e, r, i, n) {
                    var s = t._gsap;
                    (s.scaleX = s.scaleY = r), s.renderTransform(n, s);
                },
                Wr = function (t, e, r, i, n) {
                    var s = t._gsap;
                    (s[e] = r), s.renderTransform(n, s);
                },
                Yr = "transform",
                Xr = Yr + "Origin",
                Ur = function (t, e) {
                    var r = this,
                        i = this.target,
                        n = i.style;
                    if (t in Cr) {
                        if (
                            ((this.tfm = this.tfm || {}),
                            "transform" !== t &&
                                (~(t = Lr[t] || t).indexOf(",")
                                    ? t.split(",").forEach(function (t) {
                                          return (r.tfm[t] = ui(i, t));
                                      })
                                    : (this.tfm[t] = i._gsap.x ? i._gsap[t] : ui(i, t))),
                            this.props.indexOf(Yr) >= 0)
                        )
                            return;
                        i._gsap.svg && ((this.svgo = i.getAttribute("data-svg-origin")), this.props.push(Xr, e, "")),
                            (t = Yr);
                    }
                    (n || e) && this.props.push(t, e, n[t]);
                },
                Zr = function (t) {
                    t.translate &&
                        (t.removeProperty("translate"), t.removeProperty("scale"), t.removeProperty("rotate"));
                },
                Kr = function () {
                    var t,
                        e,
                        r = this.props,
                        i = this.target,
                        n = i.style,
                        s = i._gsap;
                    for (t = 0; t < r.length; t += 3)
                        r[t + 1]
                            ? (i[r[t]] = r[t + 2])
                            : r[t + 2]
                              ? (n[r[t]] = r[t + 2])
                              : n.removeProperty(r[t].replace(Dr, "-$1").toLowerCase());
                    if (this.tfm) {
                        for (e in this.tfm) s[e] = this.tfm[e];
                        s.svg && (s.renderTransform(), i.setAttribute("data-svg-origin", this.svgo || "")),
                            !(t = Pr()) || t.isStart || n[Yr] || (Zr(n), (s.uncache = 1));
                    }
                },
                Jr = function (t, e) {
                    var r = { target: t, props: [], revert: Kr, save: Ur };
                    return (
                        e &&
                            e.split(",").forEach(function (t) {
                                return r.save(t);
                            }),
                        r
                    );
                },
                Qr = function (t, e) {
                    var r = _r.createElementNS
                        ? _r.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t)
                        : _r.createElement(t);
                    return r.style ? r : _r.createElement(t);
                },
                ti = function t(e, r, i) {
                    var n = getComputedStyle(e);
                    return (
                        n[r] ||
                        n.getPropertyValue(r.replace(Dr, "-$1").toLowerCase()) ||
                        n.getPropertyValue(r) ||
                        (!i && t(e, ri(r) || r, 1)) ||
                        ""
                    );
                },
                ei = "O,Moz,ms,Ms,Webkit".split(","),
                ri = function (t, e, r) {
                    var i = (e || Er).style,
                        n = 5;
                    if (t in i && !r) return t;
                    for (t = t.charAt(0).toUpperCase() + t.substr(1); n-- && !(ei[n] + t in i); );
                    return n < 0 ? null : (3 === n ? "ms" : n >= 0 ? ei[n] : "") + t;
                },
                ii = function () {
                    "undefined" != typeof window &&
                        window.document &&
                        ((br = window),
                        (_r = br.document),
                        (xr = _r.documentElement),
                        (Er = Qr("div") || { style: {} }),
                        Qr("div"),
                        (Yr = ri(Yr)),
                        (Xr = Yr + "Origin"),
                        (Er.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"),
                        (Tr = !!ri("perspective")),
                        (Pr = vr.core.reverting),
                        (Sr = 1));
                },
                ni = function t(e) {
                    var r,
                        i = Qr(
                            "svg",
                            (this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) ||
                                "http://www.w3.org/2000/svg"
                        ),
                        n = this.parentNode,
                        s = this.nextSibling,
                        a = this.style.cssText;
                    if ((xr.appendChild(i), i.appendChild(this), (this.style.display = "block"), e))
                        try {
                            (r = this.getBBox()), (this._gsapBBox = this.getBBox), (this.getBBox = t);
                        } catch (t) {}
                    else this._gsapBBox && (r = this._gsapBBox());
                    return (
                        n && (s ? n.insertBefore(this, s) : n.appendChild(this)),
                        xr.removeChild(i),
                        (this.style.cssText = a),
                        r
                    );
                },
                si = function (t, e) {
                    for (var r = e.length; r--; ) if (t.hasAttribute(e[r])) return t.getAttribute(e[r]);
                },
                ai = function (t) {
                    var e;
                    try {
                        e = t.getBBox();
                    } catch (r) {
                        e = ni.call(t, !0);
                    }
                    return (
                        (e && (e.width || e.height)) || t.getBBox === ni || (e = ni.call(t, !0)),
                        !e || e.width || e.x || e.y
                            ? e
                            : {
                                  x: +si(t, ["x", "cx", "x1"]) || 0,
                                  y: +si(t, ["y", "cy", "y1"]) || 0,
                                  width: 0,
                                  height: 0,
                              }
                    );
                },
                oi = function (t) {
                    return !(!t.getCTM || (t.parentNode && !t.ownerSVGElement) || !ai(t));
                },
                li = function (t, e) {
                    if (e) {
                        var r = t.style;
                        e in Cr && e !== Xr && (e = Yr),
                            r.removeProperty
                                ? (("ms" !== e.substr(0, 2) && "webkit" !== e.substr(0, 6)) || (e = "-" + e),
                                  r.removeProperty(e.replace(Dr, "-$1").toLowerCase()))
                                : r.removeAttribute(e);
                    }
                },
                hi = function (t, e, r, i, n, s) {
                    var a = new ar(t._pt, e, r, 0, 1, s ? Gr : zr);
                    return (t._pt = a), (a.b = i), (a.e = n), t._props.push(r), a;
                },
                pi = { deg: 1, rad: 1, turn: 1 },
                ci = { grid: 1, flex: 1 },
                di = function t(e, r, i, n) {
                    var s,
                        a,
                        o,
                        l,
                        h = parseFloat(i) || 0,
                        p = (i + "").trim().substr((h + "").length) || "px",
                        c = Er.style,
                        d = Fr.test(r),
                        u = "svg" === e.tagName.toLowerCase(),
                        f = (u ? "client" : "offset") + (d ? "Width" : "Height"),
                        m = 100,
                        g = "px" === n,
                        y = "%" === n;
                    return n === p || !h || pi[n] || pi[p]
                        ? h
                        : ("px" !== p && !g && (h = t(e, r, i, "px")),
                          (l = e.getCTM && oi(e)),
                          (!y && "%" !== p) || (!Cr[r] && !~r.indexOf("adius"))
                              ? ((c[d ? "width" : "height"] = m + (g ? p : n)),
                                (a = ~r.indexOf("adius") || ("em" === n && e.appendChild && !u) ? e : e.parentNode),
                                l && (a = (e.ownerSVGElement || {}).parentNode),
                                (a && a !== _r && a.appendChild) || (a = _r.body),
                                (o = a._gsap) && y && o.width && d && o.time === _e.time && !o.uncache
                                    ? dt((h / o.width) * m)
                                    : ((y || "%" === p) && !ci[ti(a, "display")] && (c.position = ti(e, "position")),
                                      a === e && (c.position = "static"),
                                      a.appendChild(Er),
                                      (s = Er[f]),
                                      a.removeChild(Er),
                                      (c.position = "absolute"),
                                      d && y && (((o = ht(a)).time = _e.time), (o.width = a[f])),
                                      dt(g ? (s * h) / m : s && h ? (m / s) * h : 0)))
                              : ((s = l ? e.getBBox()[d ? "width" : "height"] : e[f]),
                                dt(y ? (h / s) * m : (h / 100) * s)));
                },
                ui = function (t, e, r, i) {
                    var n;
                    return (
                        Sr || ii(),
                        e in Lr && "transform" !== e && ~(e = Lr[e]).indexOf(",") && (e = e.split(",")[0]),
                        Cr[e] && "transform" !== e
                            ? ((n = wi(t, i)),
                              (n =
                                  "transformOrigin" !== e
                                      ? n[e]
                                      : n.svg
                                        ? n.origin
                                        : Pi(ti(t, Xr)) + " " + n.zOrigin + "px"))
                            : (!(n = t.style[e]) || "auto" === n || i || ~(n + "").indexOf("calc(")) &&
                              (n = (yi[e] && yi[e](t, e, r)) || ti(t, e) || pt(t, e) || ("opacity" === e ? 1 : 0)),
                        r && !~(n + "").trim().indexOf(" ") ? di(t, e, n, r) + r : n
                    );
                },
                fi = function (t, e, r, i) {
                    if (!r || "none" === r) {
                        var n = ri(e, t, 1),
                            s = n && ti(t, n, 1);
                        s && s !== r ? ((e = n), (r = s)) : "borderColor" === e && (r = ti(t, "borderTopColor"));
                    }
                    var a,
                        o,
                        l,
                        h,
                        p,
                        c,
                        d,
                        u,
                        f,
                        m,
                        g,
                        v = new ar(this._pt, t.style, e, 0, 1, tr),
                        b = 0,
                        _ = 0;
                    if (
                        ((v.b = r),
                        (v.e = i),
                        (r += ""),
                        "auto" == (i += "") && ((t.style[e] = i), (i = ti(t, e) || i), (t.style[e] = r)),
                        be((a = [r, i])),
                        (i = a[1]),
                        (l = (r = a[0]).match(z) || []),
                        (i.match(z) || []).length)
                    ) {
                        for (; (o = z.exec(i)); )
                            (d = o[0]),
                                (f = i.substring(b, o.index)),
                                p
                                    ? (p = (p + 1) % 5)
                                    : ("rgba(" !== f.substr(-5) && "hsla(" !== f.substr(-5)) || (p = 1),
                                d !== (c = l[_++] || "") &&
                                    ((h = parseFloat(c) || 0),
                                    (g = c.substr((h + "").length)),
                                    "=" === d.charAt(1) && (d = ft(h, d) + g),
                                    (u = parseFloat(d)),
                                    (m = d.substr((u + "").length)),
                                    (b = z.lastIndex - m.length),
                                    m || ((m = m || y.units[e] || g), b === i.length && ((i += m), (v.e += m))),
                                    g !== m && (h = di(t, e, c, m) || 0),
                                    (v._pt = {
                                        _next: v._pt,
                                        p: f || 1 === _ ? f : ",",
                                        s: h,
                                        c: u - h,
                                        m: (p && p < 4) || "zIndex" === e ? Math.round : 0,
                                    }));
                        v.c = b < i.length ? i.substring(b, i.length) : "";
                    } else v.r = "display" === e && "none" === i ? Gr : zr;
                    return N.test(i) && (v.e = 0), (this._pt = v), v;
                },
                mi = { top: "0%", bottom: "100%", left: "0%", right: "100%", center: "50%" },
                gi = function (t, e) {
                    if (e.tween && e.tween._time === e.tween._dur) {
                        var r,
                            i,
                            n,
                            s = e.t,
                            a = s.style,
                            o = e.u,
                            l = s._gsap;
                        if ("all" === o || !0 === o) (a.cssText = ""), (i = 1);
                        else
                            for (n = (o = o.split(",")).length; --n > -1; )
                                (r = o[n]), Cr[r] && ((i = 1), (r = "transformOrigin" === r ? Xr : Yr)), li(s, r);
                        i &&
                            (li(s, Yr),
                            l && (l.svg && s.removeAttribute("transform"), wi(s, 1), (l.uncache = 1), Zr(a)));
                    }
                },
                yi = {
                    clearProps: function (t, e, r, i, n) {
                        if ("isFromStart" !== n.data) {
                            var s = (t._pt = new ar(t._pt, e, r, 0, 0, gi));
                            return (s.u = i), (s.pr = -10), (s.tween = n), t._props.push(r), 1;
                        }
                    },
                },
                vi = [1, 0, 0, 1, 0, 0],
                bi = {},
                _i = function (t) {
                    return "matrix(1, 0, 0, 1, 0, 0)" === t || "none" === t || !t;
                },
                xi = function (t) {
                    var e = ti(t, Yr);
                    return _i(e) ? vi : e.substr(7).match(O).map(dt);
                },
                Si = function (t, e) {
                    var r,
                        i,
                        n,
                        s,
                        a = t._gsap || ht(t),
                        o = t.style,
                        l = xi(t);
                    return a.svg && t.getAttribute("transform")
                        ? "1,0,0,1,0,0" ===
                          (l = [(n = t.transform.baseVal.consolidate().matrix).a, n.b, n.c, n.d, n.e, n.f]).join(",")
                            ? vi
                            : l
                        : (l !== vi ||
                              t.offsetParent ||
                              t === xr ||
                              a.svg ||
                              ((n = o.display),
                              (o.display = "block"),
                              ((r = t.parentNode) && t.offsetParent) ||
                                  ((s = 1), (i = t.nextElementSibling), xr.appendChild(t)),
                              (l = xi(t)),
                              n ? (o.display = n) : li(t, "display"),
                              s && (i ? r.insertBefore(t, i) : r ? r.appendChild(t) : xr.removeChild(t))),
                          e && l.length > 6 ? [l[0], l[1], l[4], l[5], l[12], l[13]] : l);
                },
                Ei = function (t, e, r, i, n, s) {
                    var a,
                        o,
                        l,
                        h = t._gsap,
                        p = n || Si(t, !0),
                        c = h.xOrigin || 0,
                        d = h.yOrigin || 0,
                        u = h.xOffset || 0,
                        f = h.yOffset || 0,
                        m = p[0],
                        g = p[1],
                        y = p[2],
                        v = p[3],
                        b = p[4],
                        _ = p[5],
                        x = e.split(" "),
                        S = parseFloat(x[0]) || 0,
                        E = parseFloat(x[1]) || 0;
                    r
                        ? p !== vi &&
                          (o = m * v - g * y) &&
                          ((l = S * (-g / o) + E * (m / o) - (m * _ - g * b) / o),
                          (S = S * (v / o) + E * (-y / o) + (y * _ - v * b) / o),
                          (E = l))
                        : ((S = (a = ai(t)).x + (~x[0].indexOf("%") ? (S / 100) * a.width : S)),
                          (E = a.y + (~(x[1] || x[0]).indexOf("%") ? (E / 100) * a.height : E))),
                        i || (!1 !== i && h.smooth)
                            ? ((b = S - c),
                              (_ = E - d),
                              (h.xOffset = u + (b * m + _ * y) - b),
                              (h.yOffset = f + (b * g + _ * v) - _))
                            : (h.xOffset = h.yOffset = 0),
                        (h.xOrigin = S),
                        (h.yOrigin = E),
                        (h.smooth = !!i),
                        (h.origin = e),
                        (h.originIsAbsolute = !!r),
                        (t.style[Xr] = "0px 0px"),
                        s &&
                            (hi(s, h, "xOrigin", c, S),
                            hi(s, h, "yOrigin", d, E),
                            hi(s, h, "xOffset", u, h.xOffset),
                            hi(s, h, "yOffset", f, h.yOffset)),
                        t.setAttribute("data-svg-origin", S + " " + E);
                },
                wi = function (t, e) {
                    var r = t._gsap || new Ie(t);
                    if ("x" in r && !e && !r.uncache) return r;
                    var i,
                        n,
                        s,
                        a,
                        o,
                        l,
                        h,
                        p,
                        c,
                        d,
                        u,
                        f,
                        m,
                        g,
                        v,
                        b,
                        _,
                        x,
                        S,
                        E,
                        w,
                        P,
                        T,
                        C,
                        A,
                        k,
                        M,
                        D,
                        F,
                        I,
                        L,
                        B,
                        V = t.style,
                        R = r.scaleX < 0,
                        O = "px",
                        z = "deg",
                        G = getComputedStyle(t),
                        N = ti(t, Xr) || "0";
                    return (
                        (i = n = s = l = h = p = c = d = u = 0),
                        (a = o = 1),
                        (r.svg = !(!t.getCTM || !oi(t))),
                        G.translate &&
                            (("none" === G.translate && "none" === G.scale && "none" === G.rotate) ||
                                (V[Yr] =
                                    ("none" !== G.translate
                                        ? "translate3d(" +
                                          (G.translate + " 0 0").split(" ").slice(0, 3).join(", ") +
                                          ") "
                                        : "") +
                                    ("none" !== G.rotate ? "rotate(" + G.rotate + ") " : "") +
                                    ("none" !== G.scale ? "scale(" + G.scale.split(" ").join(",") + ") " : "") +
                                    ("none" !== G[Yr] ? G[Yr] : "")),
                            (V.scale = V.rotate = V.translate = "none")),
                        (g = Si(t, r.svg)),
                        r.svg &&
                            (r.uncache
                                ? ((A = t.getBBox()),
                                  (N = r.xOrigin - A.x + "px " + (r.yOrigin - A.y) + "px"),
                                  (C = ""))
                                : (C = !e && t.getAttribute("data-svg-origin")),
                            Ei(t, C || N, !!C || r.originIsAbsolute, !1 !== r.smooth, g)),
                        (f = r.xOrigin || 0),
                        (m = r.yOrigin || 0),
                        g !== vi &&
                            ((x = g[0]),
                            (S = g[1]),
                            (E = g[2]),
                            (w = g[3]),
                            (i = P = g[4]),
                            (n = T = g[5]),
                            6 === g.length
                                ? ((a = Math.sqrt(x * x + S * S)),
                                  (o = Math.sqrt(w * w + E * E)),
                                  (l = x || S ? Mr(S, x) * Ar : 0),
                                  (c = E || w ? Mr(E, w) * Ar + l : 0) && (o *= Math.abs(Math.cos(c * kr))),
                                  r.svg && ((i -= f - (f * x + m * E)), (n -= m - (f * S + m * w))))
                                : ((B = g[6]),
                                  (I = g[7]),
                                  (M = g[8]),
                                  (D = g[9]),
                                  (F = g[10]),
                                  (L = g[11]),
                                  (i = g[12]),
                                  (n = g[13]),
                                  (s = g[14]),
                                  (h = (v = Mr(B, F)) * Ar),
                                  v &&
                                      ((C = P * (b = Math.cos(-v)) + M * (_ = Math.sin(-v))),
                                      (A = T * b + D * _),
                                      (k = B * b + F * _),
                                      (M = P * -_ + M * b),
                                      (D = T * -_ + D * b),
                                      (F = B * -_ + F * b),
                                      (L = I * -_ + L * b),
                                      (P = C),
                                      (T = A),
                                      (B = k)),
                                  (p = (v = Mr(-E, F)) * Ar),
                                  v &&
                                      ((b = Math.cos(-v)),
                                      (L = w * (_ = Math.sin(-v)) + L * b),
                                      (x = C = x * b - M * _),
                                      (S = A = S * b - D * _),
                                      (E = k = E * b - F * _)),
                                  (l = (v = Mr(S, x)) * Ar),
                                  v &&
                                      ((C = x * (b = Math.cos(v)) + S * (_ = Math.sin(v))),
                                      (A = P * b + T * _),
                                      (S = S * b - x * _),
                                      (T = T * b - P * _),
                                      (x = C),
                                      (P = A)),
                                  h && Math.abs(h) + Math.abs(l) > 359.9 && ((h = l = 0), (p = 180 - p)),
                                  (a = dt(Math.sqrt(x * x + S * S + E * E))),
                                  (o = dt(Math.sqrt(T * T + B * B))),
                                  (v = Mr(P, T)),
                                  (c = Math.abs(v) > 2e-4 ? v * Ar : 0),
                                  (u = L ? 1 / (L < 0 ? -L : L) : 0)),
                            r.svg &&
                                ((C = t.getAttribute("transform")),
                                (r.forceCSS = t.setAttribute("transform", "") || !_i(ti(t, Yr))),
                                C && t.setAttribute("transform", C))),
                        Math.abs(c) > 90 &&
                            Math.abs(c) < 270 &&
                            (R
                                ? ((a *= -1), (c += l <= 0 ? 180 : -180), (l += l <= 0 ? 180 : -180))
                                : ((o *= -1), (c += c <= 0 ? 180 : -180))),
                        (e = e || r.uncache),
                        (r.x =
                            i -
                            ((r.xPercent =
                                i &&
                                ((!e && r.xPercent) || (Math.round(t.offsetWidth / 2) === Math.round(-i) ? -50 : 0)))
                                ? (t.offsetWidth * r.xPercent) / 100
                                : 0) +
                            O),
                        (r.y =
                            n -
                            ((r.yPercent =
                                n &&
                                ((!e && r.yPercent) || (Math.round(t.offsetHeight / 2) === Math.round(-n) ? -50 : 0)))
                                ? (t.offsetHeight * r.yPercent) / 100
                                : 0) +
                            O),
                        (r.z = s + O),
                        (r.scaleX = dt(a)),
                        (r.scaleY = dt(o)),
                        (r.rotation = dt(l) + z),
                        (r.rotationX = dt(h) + z),
                        (r.rotationY = dt(p) + z),
                        (r.skewX = c + z),
                        (r.skewY = d + z),
                        (r.transformPerspective = u + O),
                        (r.zOrigin = parseFloat(N.split(" ")[2]) || 0) && (V[Xr] = Pi(N)),
                        (r.xOffset = r.yOffset = 0),
                        (r.force3D = y.force3D),
                        (r.renderTransform = r.svg ? Fi : Tr ? Di : Ci),
                        (r.uncache = 0),
                        r
                    );
                },
                Pi = function (t) {
                    return (t = t.split(" "))[0] + " " + t[1];
                },
                Ti = function (t, e, r) {
                    var i = Ut(e);
                    return dt(parseFloat(e) + parseFloat(di(t, "x", r + "px", i))) + i;
                },
                Ci = function (t, e) {
                    (e.z = "0px"), (e.rotationY = e.rotationX = "0deg"), (e.force3D = 0), Di(t, e);
                },
                Ai = "0deg",
                ki = "0px",
                Mi = ") ",
                Di = function (t, e) {
                    var r = e || this,
                        i = r.xPercent,
                        n = r.yPercent,
                        s = r.x,
                        a = r.y,
                        o = r.z,
                        l = r.rotation,
                        h = r.rotationY,
                        p = r.rotationX,
                        c = r.skewX,
                        d = r.skewY,
                        u = r.scaleX,
                        f = r.scaleY,
                        m = r.transformPerspective,
                        g = r.force3D,
                        y = r.target,
                        v = r.zOrigin,
                        b = "",
                        _ = ("auto" === g && t && 1 !== t) || !0 === g;
                    if (v && (p !== Ai || h !== Ai)) {
                        var x,
                            S = parseFloat(h) * kr,
                            E = Math.sin(S),
                            w = Math.cos(S);
                        (S = parseFloat(p) * kr),
                            (x = Math.cos(S)),
                            (s = Ti(y, s, E * x * -v)),
                            (a = Ti(y, a, -Math.sin(S) * -v)),
                            (o = Ti(y, o, w * x * -v + v));
                    }
                    m !== ki && (b += "perspective(" + m + Mi),
                        (i || n) && (b += "translate(" + i + "%, " + n + "%) "),
                        (_ || s !== ki || a !== ki || o !== ki) &&
                            (b +=
                                o !== ki || _
                                    ? "translate3d(" + s + ", " + a + ", " + o + ") "
                                    : "translate(" + s + ", " + a + Mi),
                        l !== Ai && (b += "rotate(" + l + Mi),
                        h !== Ai && (b += "rotateY(" + h + Mi),
                        p !== Ai && (b += "rotateX(" + p + Mi),
                        (c === Ai && d === Ai) || (b += "skew(" + c + ", " + d + Mi),
                        (1 === u && 1 === f) || (b += "scale(" + u + ", " + f + Mi),
                        (y.style[Yr] = b || "translate(0, 0)");
                },
                Fi = function (t, e) {
                    var r,
                        i,
                        n,
                        s,
                        a,
                        o = e || this,
                        l = o.xPercent,
                        h = o.yPercent,
                        p = o.x,
                        c = o.y,
                        d = o.rotation,
                        u = o.skewX,
                        f = o.skewY,
                        m = o.scaleX,
                        g = o.scaleY,
                        y = o.target,
                        v = o.xOrigin,
                        b = o.yOrigin,
                        _ = o.xOffset,
                        x = o.yOffset,
                        S = o.forceCSS,
                        E = parseFloat(p),
                        w = parseFloat(c);
                    (d = parseFloat(d)),
                        (u = parseFloat(u)),
                        (f = parseFloat(f)) && ((u += f = parseFloat(f)), (d += f)),
                        d || u
                            ? ((d *= kr),
                              (u *= kr),
                              (r = Math.cos(d) * m),
                              (i = Math.sin(d) * m),
                              (n = Math.sin(d - u) * -g),
                              (s = Math.cos(d - u) * g),
                              u &&
                                  ((f *= kr),
                                  (a = Math.tan(u - f)),
                                  (n *= a = Math.sqrt(1 + a * a)),
                                  (s *= a),
                                  f && ((a = Math.tan(f)), (r *= a = Math.sqrt(1 + a * a)), (i *= a))),
                              (r = dt(r)),
                              (i = dt(i)),
                              (n = dt(n)),
                              (s = dt(s)))
                            : ((r = m), (s = g), (i = n = 0)),
                        ((E && !~(p + "").indexOf("px")) || (w && !~(c + "").indexOf("px"))) &&
                            ((E = di(y, "x", p, "px")), (w = di(y, "y", c, "px"))),
                        (v || b || _ || x) &&
                            ((E = dt(E + v - (v * r + b * n) + _)), (w = dt(w + b - (v * i + b * s) + x))),
                        (l || h) &&
                            ((a = y.getBBox()), (E = dt(E + (l / 100) * a.width)), (w = dt(w + (h / 100) * a.height))),
                        (a = "matrix(" + r + "," + i + "," + n + "," + s + "," + E + "," + w + ")"),
                        y.setAttribute("transform", a),
                        S && (y.style[Yr] = a);
                },
                Ii = function (t, e, r, i, n) {
                    var s,
                        a,
                        o = 360,
                        l = C(n),
                        h = parseFloat(n) * (l && ~n.indexOf("rad") ? Ar : 1) - i,
                        p = i + h + "deg";
                    return (
                        l &&
                            ("short" === (s = n.split("_")[1]) && (h %= o) != h % 180 && (h += h < 0 ? o : -360),
                            "cw" === s && h < 0
                                ? (h = ((h + 36e9) % o) - ~~(h / o) * o)
                                : "ccw" === s && h > 0 && (h = ((h - 36e9) % o) - ~~(h / o) * o)),
                        (t._pt = a = new ar(t._pt, e, r, i, h, Vr)),
                        (a.e = p),
                        (a.u = "deg"),
                        t._props.push(r),
                        a
                    );
                },
                Li = function (t, e) {
                    for (var r in e) t[r] = e[r];
                    return t;
                },
                Bi = function (t, e, r) {
                    var i,
                        n,
                        s,
                        a,
                        o,
                        l,
                        h,
                        p = Li({}, r._gsap),
                        c = r.style;
                    for (n in (p.svg
                        ? ((s = r.getAttribute("transform")),
                          r.setAttribute("transform", ""),
                          (c[Yr] = e),
                          (i = wi(r, 1)),
                          li(r, Yr),
                          r.setAttribute("transform", s))
                        : ((s = getComputedStyle(r)[Yr]), (c[Yr] = e), (i = wi(r, 1)), (c[Yr] = s)),
                    Cr))
                        (s = p[n]) !== (a = i[n]) &&
                            "perspective,force3D,transformOrigin,svgOrigin".indexOf(n) < 0 &&
                            ((o = Ut(s) !== (h = Ut(a)) ? di(r, n, s, h) : parseFloat(s)),
                            (l = parseFloat(a)),
                            (t._pt = new ar(t._pt, i, n, o, l - o, Br)),
                            (t._pt.u = h || 0),
                            t._props.push(n));
                    Li(i, p);
                };
            ct("padding,margin,Width,Radius", function (t, e) {
                var r = "Top",
                    i = "Right",
                    n = "Bottom",
                    s = "Left",
                    a = (e < 3 ? [r, i, n, s] : [r + s, r + i, n + i, n + s]).map(function (r) {
                        return e < 2 ? t + r : "border" + r + t;
                    });
                yi[e > 1 ? "border" + t : t] = function (t, e, r, i, n) {
                    var s, o;
                    if (arguments.length < 4)
                        return (
                            (s = a.map(function (e) {
                                return ui(t, e, r);
                            })),
                            5 === (o = s.join(" ")).split(s[0]).length ? s[0] : o
                        );
                    (s = (i + "").split(" ")),
                        (o = {}),
                        a.forEach(function (t, e) {
                            return (o[t] = s[e] = s[e] || s[((e - 1) / 2) | 0]);
                        }),
                        t.init(e, o, n);
                };
            });
            var Vi,
                Ri,
                Oi = {
                    name: "css",
                    register: ii,
                    targetTest: function (t) {
                        return t.style && t.nodeType;
                    },
                    init: function (t, e, r, i, n) {
                        var s,
                            a,
                            o,
                            l,
                            h,
                            p,
                            c,
                            d,
                            u,
                            f,
                            m,
                            g,
                            v,
                            b,
                            _,
                            x,
                            S,
                            E,
                            w,
                            P,
                            T = this._props,
                            A = t.style,
                            k = r.vars.startAt;
                        for (c in (Sr || ii(),
                        (this.styles = this.styles || Jr(t)),
                        (x = this.styles.props),
                        (this.tween = r),
                        e))
                            if ("autoRound" !== c && ((a = e[c]), !it[c] || !Ge(c, e, r, i, t, n)))
                                if (
                                    ((h = typeof a),
                                    (p = yi[c]),
                                    "function" === h && (h = typeof (a = a.call(r, i, t, n))),
                                    "string" === h && ~a.indexOf("random(") && (a = ae(a)),
                                    p)
                                )
                                    p(this, t, c, a, r) && (_ = 1);
                                else if ("--" === c.substr(0, 2))
                                    (s = (getComputedStyle(t).getPropertyValue(c) + "").trim()),
                                        (a += ""),
                                        (ye.lastIndex = 0),
                                        ye.test(s) || ((d = Ut(s)), (u = Ut(a))),
                                        u ? d !== u && (s = di(t, c, s, u) + u) : d && (a += d),
                                        this.add(A, "setProperty", s, a, i, n, 0, 0, c),
                                        T.push(c),
                                        x.push(c, 0, A[c]);
                                else if ("undefined" !== h) {
                                    if (
                                        (k && c in k
                                            ? ((s = "function" == typeof k[c] ? k[c].call(r, i, t, n) : k[c]),
                                              C(s) && ~s.indexOf("random(") && (s = ae(s)),
                                              Ut(s + "") || (s += y.units[c] || Ut(ui(t, c)) || ""),
                                              "=" === (s + "").charAt(1) && (s = ui(t, c)))
                                            : (s = ui(t, c)),
                                        (l = parseFloat(s)),
                                        (f = "string" === h && "=" === a.charAt(1) && a.substr(0, 2)) &&
                                            (a = a.substr(2)),
                                        (o = parseFloat(a)),
                                        c in Lr &&
                                            ("autoAlpha" === c &&
                                                (1 === l && "hidden" === ui(t, "visibility") && o && (l = 0),
                                                x.push("visibility", 0, A.visibility),
                                                hi(
                                                    this,
                                                    A,
                                                    "visibility",
                                                    l ? "inherit" : "hidden",
                                                    o ? "inherit" : "hidden",
                                                    !o
                                                )),
                                            "scale" !== c &&
                                                "transform" !== c &&
                                                ~(c = Lr[c]).indexOf(",") &&
                                                (c = c.split(",")[0])),
                                        (m = c in Cr))
                                    )
                                        if (
                                            (this.styles.save(c),
                                            g ||
                                                (((v = t._gsap).renderTransform && !e.parseTransform) ||
                                                    wi(t, e.parseTransform),
                                                (b = !1 !== e.smoothOrigin && v.smooth),
                                                ((g = this._pt =
                                                    new ar(this._pt, A, Yr, 0, 1, v.renderTransform, v, 0, -1)).dep =
                                                    1)),
                                            "scale" === c)
                                        )
                                            (this._pt = new ar(
                                                this._pt,
                                                v,
                                                "scaleY",
                                                v.scaleY,
                                                (f ? ft(v.scaleY, f + o) : o) - v.scaleY || 0,
                                                Br
                                            )),
                                                (this._pt.u = 0),
                                                T.push("scaleY", c),
                                                (c += "X");
                                        else {
                                            if ("transformOrigin" === c) {
                                                x.push(Xr, 0, A[Xr]),
                                                    (E = void 0),
                                                    (w = void 0),
                                                    (P = void 0),
                                                    (w = (E = (S = a).split(" "))[0]),
                                                    (P = E[1] || "50%"),
                                                    ("top" !== w && "bottom" !== w && "left" !== P && "right" !== P) ||
                                                        ((S = w), (w = P), (P = S)),
                                                    (E[0] = mi[w] || w),
                                                    (E[1] = mi[P] || P),
                                                    (a = E.join(" ")),
                                                    v.svg
                                                        ? Ei(t, a, 0, b, 0, this)
                                                        : ((u = parseFloat(a.split(" ")[2]) || 0) !== v.zOrigin &&
                                                              hi(this, v, "zOrigin", v.zOrigin, u),
                                                          hi(this, A, c, Pi(s), Pi(a)));
                                                continue;
                                            }
                                            if ("svgOrigin" === c) {
                                                Ei(t, a, 1, b, 0, this);
                                                continue;
                                            }
                                            if (c in bi) {
                                                Ii(this, v, c, l, f ? ft(l, f + a) : a);
                                                continue;
                                            }
                                            if ("smoothOrigin" === c) {
                                                hi(this, v, "smooth", v.smooth, a);
                                                continue;
                                            }
                                            if ("force3D" === c) {
                                                v[c] = a;
                                                continue;
                                            }
                                            if ("transform" === c) {
                                                Bi(this, a, t);
                                                continue;
                                            }
                                        }
                                    else c in A || (c = ri(c) || c);
                                    if (m || ((o || 0 === o) && (l || 0 === l) && !Ir.test(a) && c in A))
                                        o || (o = 0),
                                            (d = (s + "").substr((l + "").length)) !==
                                                (u = Ut(a) || (c in y.units ? y.units[c] : d)) && (l = di(t, c, s, u)),
                                            (this._pt = new ar(
                                                this._pt,
                                                m ? v : A,
                                                c,
                                                l,
                                                (f ? ft(l, f + o) : o) - l,
                                                m || ("px" !== u && "zIndex" !== c) || !1 === e.autoRound ? Br : Or
                                            )),
                                            (this._pt.u = u || 0),
                                            d !== u && "%" !== u && ((this._pt.b = s), (this._pt.r = Rr));
                                    else if (c in A) fi.call(this, t, c, s, f ? f + a : a);
                                    else if (c in t) this.add(t, c, s || t[c], f ? f + a : a, i, n);
                                    else if ("parseTransform" !== c) {
                                        Y(c, a);
                                        continue;
                                    }
                                    m || (c in A ? x.push(c, 0, A[c]) : x.push(c, 1, s || t[c])), T.push(c);
                                }
                        _ && sr(this);
                    },
                    render: function (t, e) {
                        if (e.tween._time || !Pr()) for (var r = e._pt; r; ) r.r(t, r.d), (r = r._next);
                        else e.styles.revert();
                    },
                    get: ui,
                    aliases: Lr,
                    getSetter: function (t, e, r) {
                        var i = Lr[e];
                        return (
                            i && i.indexOf(",") < 0 && (e = i),
                            e in Cr && e !== Xr && (t._gsap.x || ui(t, "x"))
                                ? r && wr === r
                                    ? "scale" === e
                                        ? $r
                                        : Hr
                                    : (wr = r || {}) && ("scale" === e ? jr : Wr)
                                : t.style && !M(t.style[e])
                                  ? Nr
                                  : ~e.indexOf("-")
                                    ? qr
                                    : Ke(t, e)
                        );
                    },
                    core: { _removeProperty: li, _getMatrix: Si },
                };
            (vr.utils.checkPrefix = ri),
                (vr.core.getStyleSaver = Jr),
                (Ri = ct(
                    "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," +
                        (Vi = "rotation,rotationX,rotationY,skewX,skewY") +
                        ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective",
                    function (t) {
                        Cr[t] = 1;
                    }
                )),
                ct(Vi, function (t) {
                    (y.units[t] = "deg"), (bi[t] = 1);
                }),
                (Lr[Ri[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + Vi),
                ct(
                    "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY",
                    function (t) {
                        var e = t.split(":");
                        Lr[e[1]] = Ri[e[0]];
                    }
                ),
                ct("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (t) {
                    y.units[t] = "px";
                }),
                vr.registerPlugin(Oi);
            var zi = vr.registerPlugin(Oi) || vr;
            function Gi(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for (var r = 0, i = new Array(e); r < e; r++) i[r] = t[r];
                return i;
            }
            zi.core.Tween;
            var Ni = document.querySelector("[page-transition]"),
                qi = document.querySelectorAll(
                    "a:not([no-link]):not(.spr-summary-actions-newreview):not(.spr-review-reportreview):not(.jdgm-write-rev-link)"
                ),
                Hi = function (t) {
                    Ni?.classList.remove("page-transition--loaded"),
                        setTimeout(function () {
                            return t();
                        }, 325);
                };
            function $i(t) {
                return null !== t && "object" == typeof t && "constructor" in t && t.constructor === Object;
            }
            function ji(t = {}, e = {}) {
                Object.keys(e).forEach((r) => {
                    void 0 === t[r]
                        ? (t[r] = e[r])
                        : $i(e[r]) && $i(t[r]) && Object.keys(e[r]).length > 0 && ji(t[r], e[r]);
                });
            }
            const Wi = {
                body: {},
                addEventListener() {},
                removeEventListener() {},
                activeElement: { blur() {}, nodeName: "" },
                querySelector: () => null,
                querySelectorAll: () => [],
                getElementById: () => null,
                createEvent: () => ({ initEvent() {} }),
                createElement: () => ({
                    children: [],
                    childNodes: [],
                    style: {},
                    setAttribute() {},
                    getElementsByTagName: () => [],
                }),
                createElementNS: () => ({}),
                importNode: () => null,
                location: {
                    hash: "",
                    host: "",
                    hostname: "",
                    href: "",
                    origin: "",
                    pathname: "",
                    protocol: "",
                    search: "",
                },
            };
            function Yi() {
                const t = "undefined" != typeof document ? document : {};
                return ji(t, Wi), t;
            }
            const Xi = {
                document: Wi,
                navigator: { userAgent: "" },
                location: {
                    hash: "",
                    host: "",
                    hostname: "",
                    href: "",
                    origin: "",
                    pathname: "",
                    protocol: "",
                    search: "",
                },
                history: { replaceState() {}, pushState() {}, go() {}, back() {} },
                CustomEvent: function () {
                    return this;
                },
                addEventListener() {},
                removeEventListener() {},
                getComputedStyle: () => ({ getPropertyValue: () => "" }),
                Image() {},
                Date() {},
                screen: {},
                setTimeout() {},
                clearTimeout() {},
                matchMedia: () => ({}),
                requestAnimationFrame: (t) => ("undefined" == typeof setTimeout ? (t(), null) : setTimeout(t, 0)),
                cancelAnimationFrame(t) {
                    "undefined" != typeof setTimeout && clearTimeout(t);
                },
            };
            function Ui() {
                const t = "undefined" != typeof window ? window : {};
                return ji(t, Xi), t;
            }
            class Zi extends Array {
                constructor(t) {
                    "number" == typeof t
                        ? super(t)
                        : (super(...(t || [])),
                          (function (t) {
                              const e = t.__proto__;
                              Object.defineProperty(t, "__proto__", {
                                  get: () => e,
                                  set(t) {
                                      e.__proto__ = t;
                                  },
                              });
                          })(this));
                }
            }
            function Ki(t = []) {
                const e = [];
                return (
                    t.forEach((t) => {
                        Array.isArray(t) ? e.push(...Ki(t)) : e.push(t);
                    }),
                    e
                );
            }
            function Ji(t, e) {
                return Array.prototype.filter.call(t, e);
            }
            function Qi(t, e) {
                const r = Ui(),
                    i = Yi();
                let n = [];
                if (!e && t instanceof Zi) return t;
                if (!t) return new Zi(n);
                if ("string" == typeof t) {
                    const r = t.trim();
                    if (r.indexOf("<") >= 0 && r.indexOf(">") >= 0) {
                        let t = "div";
                        0 === r.indexOf("<li") && (t = "ul"),
                            0 === r.indexOf("<tr") && (t = "tbody"),
                            (0 !== r.indexOf("<td") && 0 !== r.indexOf("<th")) || (t = "tr"),
                            0 === r.indexOf("<tbody") && (t = "table"),
                            0 === r.indexOf("<option") && (t = "select");
                        const e = i.createElement(t);
                        e.innerHTML = r;
                        for (let t = 0; t < e.childNodes.length; t += 1) n.push(e.childNodes[t]);
                    } else
                        n = (function (t, e) {
                            if ("string" != typeof t) return [t];
                            const r = [],
                                i = e.querySelectorAll(t);
                            for (let t = 0; t < i.length; t += 1) r.push(i[t]);
                            return r;
                        })(t.trim(), e || i);
                } else if (t.nodeType || t === r || t === i) n.push(t);
                else if (Array.isArray(t)) {
                    if (t instanceof Zi) return t;
                    n = t;
                }
                return new Zi(
                    (function (t) {
                        const e = [];
                        for (let r = 0; r < t.length; r += 1) -1 === e.indexOf(t[r]) && e.push(t[r]);
                        return e;
                    })(n)
                );
            }
            Qi.fn = Zi.prototype;
            const tn = "resize scroll".split(" ");
            function en(t) {
                return function (...e) {
                    if (void 0 === e[0]) {
                        for (let e = 0; e < this.length; e += 1)
                            tn.indexOf(t) < 0 && (t in this[e] ? this[e][t]() : Qi(this[e]).trigger(t));
                        return this;
                    }
                    return this.on(t, ...e);
                };
            }
            en("click"),
                en("blur"),
                en("focus"),
                en("focusin"),
                en("focusout"),
                en("keyup"),
                en("keydown"),
                en("keypress"),
                en("submit"),
                en("change"),
                en("mousedown"),
                en("mousemove"),
                en("mouseup"),
                en("mouseenter"),
                en("mouseleave"),
                en("mouseout"),
                en("mouseover"),
                en("touchstart"),
                en("touchend"),
                en("touchmove"),
                en("resize"),
                en("scroll");
            const rn = {
                addClass: function (...t) {
                    const e = Ki(t.map((t) => t.split(" ")));
                    return (
                        this.forEach((t) => {
                            t.classList.add(...e);
                        }),
                        this
                    );
                },
                removeClass: function (...t) {
                    const e = Ki(t.map((t) => t.split(" ")));
                    return (
                        this.forEach((t) => {
                            t.classList.remove(...e);
                        }),
                        this
                    );
                },
                hasClass: function (...t) {
                    const e = Ki(t.map((t) => t.split(" ")));
                    return Ji(this, (t) => e.filter((e) => t.classList.contains(e)).length > 0).length > 0;
                },
                toggleClass: function (...t) {
                    const e = Ki(t.map((t) => t.split(" ")));
                    this.forEach((t) => {
                        e.forEach((e) => {
                            t.classList.toggle(e);
                        });
                    });
                },
                attr: function (t, e) {
                    if (1 === arguments.length && "string" == typeof t)
                        return this[0] ? this[0].getAttribute(t) : void 0;
                    for (let r = 0; r < this.length; r += 1)
                        if (2 === arguments.length) this[r].setAttribute(t, e);
                        else for (const e in t) (this[r][e] = t[e]), this[r].setAttribute(e, t[e]);
                    return this;
                },
                removeAttr: function (t) {
                    for (let e = 0; e < this.length; e += 1) this[e].removeAttribute(t);
                    return this;
                },
                transform: function (t) {
                    for (let e = 0; e < this.length; e += 1) this[e].style.transform = t;
                    return this;
                },
                transition: function (t) {
                    for (let e = 0; e < this.length; e += 1)
                        this[e].style.transitionDuration = "string" != typeof t ? `${t}ms` : t;
                    return this;
                },
                on: function (...t) {
                    let [e, r, i, n] = t;
                    function s(t) {
                        const e = t.target;
                        if (!e) return;
                        const n = t.target.dom7EventData || [];
                        if ((n.indexOf(t) < 0 && n.unshift(t), Qi(e).is(r))) i.apply(e, n);
                        else {
                            const t = Qi(e).parents();
                            for (let e = 0; e < t.length; e += 1) Qi(t[e]).is(r) && i.apply(t[e], n);
                        }
                    }
                    function a(t) {
                        const e = (t && t.target && t.target.dom7EventData) || [];
                        e.indexOf(t) < 0 && e.unshift(t), i.apply(this, e);
                    }
                    "function" == typeof t[1] && (([e, i, n] = t), (r = void 0)), n || (n = !1);
                    const o = e.split(" ");
                    let l;
                    for (let t = 0; t < this.length; t += 1) {
                        const e = this[t];
                        if (r)
                            for (l = 0; l < o.length; l += 1) {
                                const t = o[l];
                                e.dom7LiveListeners || (e.dom7LiveListeners = {}),
                                    e.dom7LiveListeners[t] || (e.dom7LiveListeners[t] = []),
                                    e.dom7LiveListeners[t].push({ listener: i, proxyListener: s }),
                                    e.addEventListener(t, s, n);
                            }
                        else
                            for (l = 0; l < o.length; l += 1) {
                                const t = o[l];
                                e.dom7Listeners || (e.dom7Listeners = {}),
                                    e.dom7Listeners[t] || (e.dom7Listeners[t] = []),
                                    e.dom7Listeners[t].push({ listener: i, proxyListener: a }),
                                    e.addEventListener(t, a, n);
                            }
                    }
                    return this;
                },
                off: function (...t) {
                    let [e, r, i, n] = t;
                    "function" == typeof t[1] && (([e, i, n] = t), (r = void 0)), n || (n = !1);
                    const s = e.split(" ");
                    for (let t = 0; t < s.length; t += 1) {
                        const e = s[t];
                        for (let t = 0; t < this.length; t += 1) {
                            const s = this[t];
                            let a;
                            if (
                                (!r && s.dom7Listeners
                                    ? (a = s.dom7Listeners[e])
                                    : r && s.dom7LiveListeners && (a = s.dom7LiveListeners[e]),
                                a && a.length)
                            )
                                for (let t = a.length - 1; t >= 0; t -= 1) {
                                    const r = a[t];
                                    (i && r.listener === i) ||
                                    (i && r.listener && r.listener.dom7proxy && r.listener.dom7proxy === i)
                                        ? (s.removeEventListener(e, r.proxyListener, n), a.splice(t, 1))
                                        : i || (s.removeEventListener(e, r.proxyListener, n), a.splice(t, 1));
                                }
                        }
                    }
                    return this;
                },
                trigger: function (...t) {
                    const e = Ui(),
                        r = t[0].split(" "),
                        i = t[1];
                    for (let n = 0; n < r.length; n += 1) {
                        const s = r[n];
                        for (let r = 0; r < this.length; r += 1) {
                            const n = this[r];
                            if (e.CustomEvent) {
                                const r = new e.CustomEvent(s, { detail: i, bubbles: !0, cancelable: !0 });
                                (n.dom7EventData = t.filter((t, e) => e > 0)),
                                    n.dispatchEvent(r),
                                    (n.dom7EventData = []),
                                    delete n.dom7EventData;
                            }
                        }
                    }
                    return this;
                },
                transitionEnd: function (t) {
                    const e = this;
                    return (
                        t &&
                            e.on("transitionend", function r(i) {
                                i.target === this && (t.call(this, i), e.off("transitionend", r));
                            }),
                        this
                    );
                },
                outerWidth: function (t) {
                    if (this.length > 0) {
                        if (t) {
                            const t = this.styles();
                            return (
                                this[0].offsetWidth +
                                parseFloat(t.getPropertyValue("margin-right")) +
                                parseFloat(t.getPropertyValue("margin-left"))
                            );
                        }
                        return this[0].offsetWidth;
                    }
                    return null;
                },
                outerHeight: function (t) {
                    if (this.length > 0) {
                        if (t) {
                            const t = this.styles();
                            return (
                                this[0].offsetHeight +
                                parseFloat(t.getPropertyValue("margin-top")) +
                                parseFloat(t.getPropertyValue("margin-bottom"))
                            );
                        }
                        return this[0].offsetHeight;
                    }
                    return null;
                },
                styles: function () {
                    const t = Ui();
                    return this[0] ? t.getComputedStyle(this[0], null) : {};
                },
                offset: function () {
                    if (this.length > 0) {
                        const t = Ui(),
                            e = Yi(),
                            r = this[0],
                            i = r.getBoundingClientRect(),
                            n = e.body,
                            s = r.clientTop || n.clientTop || 0,
                            a = r.clientLeft || n.clientLeft || 0,
                            o = r === t ? t.scrollY : r.scrollTop,
                            l = r === t ? t.scrollX : r.scrollLeft;
                        return { top: i.top + o - s, left: i.left + l - a };
                    }
                    return null;
                },
                css: function (t, e) {
                    const r = Ui();
                    let i;
                    if (1 === arguments.length) {
                        if ("string" != typeof t) {
                            for (i = 0; i < this.length; i += 1) for (const e in t) this[i].style[e] = t[e];
                            return this;
                        }
                        if (this[0]) return r.getComputedStyle(this[0], null).getPropertyValue(t);
                    }
                    if (2 === arguments.length && "string" == typeof t) {
                        for (i = 0; i < this.length; i += 1) this[i].style[t] = e;
                        return this;
                    }
                    return this;
                },
                each: function (t) {
                    return t
                        ? (this.forEach((e, r) => {
                              t.apply(e, [e, r]);
                          }),
                          this)
                        : this;
                },
                html: function (t) {
                    if (void 0 === t) return this[0] ? this[0].innerHTML : null;
                    for (let e = 0; e < this.length; e += 1) this[e].innerHTML = t;
                    return this;
                },
                text: function (t) {
                    if (void 0 === t) return this[0] ? this[0].textContent.trim() : null;
                    for (let e = 0; e < this.length; e += 1) this[e].textContent = t;
                    return this;
                },
                is: function (t) {
                    const e = Ui(),
                        r = Yi(),
                        i = this[0];
                    let n, s;
                    if (!i || void 0 === t) return !1;
                    if ("string" == typeof t) {
                        if (i.matches) return i.matches(t);
                        if (i.webkitMatchesSelector) return i.webkitMatchesSelector(t);
                        if (i.msMatchesSelector) return i.msMatchesSelector(t);
                        for (n = Qi(t), s = 0; s < n.length; s += 1) if (n[s] === i) return !0;
                        return !1;
                    }
                    if (t === r) return i === r;
                    if (t === e) return i === e;
                    if (t.nodeType || t instanceof Zi) {
                        for (n = t.nodeType ? [t] : t, s = 0; s < n.length; s += 1) if (n[s] === i) return !0;
                        return !1;
                    }
                    return !1;
                },
                index: function () {
                    let t,
                        e = this[0];
                    if (e) {
                        for (t = 0; null !== (e = e.previousSibling); ) 1 === e.nodeType && (t += 1);
                        return t;
                    }
                },
                eq: function (t) {
                    if (void 0 === t) return this;
                    const e = this.length;
                    if (t > e - 1) return Qi([]);
                    if (t < 0) {
                        const r = e + t;
                        return Qi(r < 0 ? [] : [this[r]]);
                    }
                    return Qi([this[t]]);
                },
                append: function (...t) {
                    let e;
                    const r = Yi();
                    for (let i = 0; i < t.length; i += 1) {
                        e = t[i];
                        for (let t = 0; t < this.length; t += 1)
                            if ("string" == typeof e) {
                                const i = r.createElement("div");
                                for (i.innerHTML = e; i.firstChild; ) this[t].appendChild(i.firstChild);
                            } else if (e instanceof Zi) for (let r = 0; r < e.length; r += 1) this[t].appendChild(e[r]);
                            else this[t].appendChild(e);
                    }
                    return this;
                },
                prepend: function (t) {
                    const e = Yi();
                    let r, i;
                    for (r = 0; r < this.length; r += 1)
                        if ("string" == typeof t) {
                            const n = e.createElement("div");
                            for (n.innerHTML = t, i = n.childNodes.length - 1; i >= 0; i -= 1)
                                this[r].insertBefore(n.childNodes[i], this[r].childNodes[0]);
                        } else if (t instanceof Zi)
                            for (i = 0; i < t.length; i += 1) this[r].insertBefore(t[i], this[r].childNodes[0]);
                        else this[r].insertBefore(t, this[r].childNodes[0]);
                    return this;
                },
                next: function (t) {
                    return this.length > 0
                        ? t
                            ? this[0].nextElementSibling && Qi(this[0].nextElementSibling).is(t)
                                ? Qi([this[0].nextElementSibling])
                                : Qi([])
                            : this[0].nextElementSibling
                              ? Qi([this[0].nextElementSibling])
                              : Qi([])
                        : Qi([]);
                },
                nextAll: function (t) {
                    const e = [];
                    let r = this[0];
                    if (!r) return Qi([]);
                    for (; r.nextElementSibling; ) {
                        const i = r.nextElementSibling;
                        t ? Qi(i).is(t) && e.push(i) : e.push(i), (r = i);
                    }
                    return Qi(e);
                },
                prev: function (t) {
                    if (this.length > 0) {
                        const e = this[0];
                        return t
                            ? e.previousElementSibling && Qi(e.previousElementSibling).is(t)
                                ? Qi([e.previousElementSibling])
                                : Qi([])
                            : e.previousElementSibling
                              ? Qi([e.previousElementSibling])
                              : Qi([]);
                    }
                    return Qi([]);
                },
                prevAll: function (t) {
                    const e = [];
                    let r = this[0];
                    if (!r) return Qi([]);
                    for (; r.previousElementSibling; ) {
                        const i = r.previousElementSibling;
                        t ? Qi(i).is(t) && e.push(i) : e.push(i), (r = i);
                    }
                    return Qi(e);
                },
                parent: function (t) {
                    const e = [];
                    for (let r = 0; r < this.length; r += 1)
                        null !== this[r].parentNode &&
                            (t
                                ? Qi(this[r].parentNode).is(t) && e.push(this[r].parentNode)
                                : e.push(this[r].parentNode));
                    return Qi(e);
                },
                parents: function (t) {
                    const e = [];
                    for (let r = 0; r < this.length; r += 1) {
                        let i = this[r].parentNode;
                        for (; i; ) t ? Qi(i).is(t) && e.push(i) : e.push(i), (i = i.parentNode);
                    }
                    return Qi(e);
                },
                closest: function (t) {
                    let e = this;
                    return void 0 === t ? Qi([]) : (e.is(t) || (e = e.parents(t).eq(0)), e);
                },
                find: function (t) {
                    const e = [];
                    for (let r = 0; r < this.length; r += 1) {
                        const i = this[r].querySelectorAll(t);
                        for (let t = 0; t < i.length; t += 1) e.push(i[t]);
                    }
                    return Qi(e);
                },
                children: function (t) {
                    const e = [];
                    for (let r = 0; r < this.length; r += 1) {
                        const i = this[r].children;
                        for (let r = 0; r < i.length; r += 1) (t && !Qi(i[r]).is(t)) || e.push(i[r]);
                    }
                    return Qi(e);
                },
                filter: function (t) {
                    return Qi(Ji(this, t));
                },
                remove: function () {
                    for (let t = 0; t < this.length; t += 1)
                        this[t].parentNode && this[t].parentNode.removeChild(this[t]);
                    return this;
                },
            };
            Object.keys(rn).forEach((t) => {
                Object.defineProperty(Qi.fn, t, { value: rn[t], writable: !0 });
            });
            const nn = Qi;
            function sn(t, e = 0) {
                return setTimeout(t, e);
            }
            function an() {
                return Date.now();
            }
            function on(t) {
                return (
                    "object" == typeof t &&
                    null !== t &&
                    t.constructor &&
                    "Object" === Object.prototype.toString.call(t).slice(8, -1)
                );
            }
            function ln(...t) {
                const e = Object(t[0]),
                    r = ["__proto__", "constructor", "prototype"];
                for (let n = 1; n < t.length; n += 1) {
                    const s = t[n];
                    if (
                        null != s &&
                        ((i = s),
                        !("undefined" != typeof window && void 0 !== window.HTMLElement
                            ? i instanceof HTMLElement
                            : i && (1 === i.nodeType || 11 === i.nodeType)))
                    ) {
                        const t = Object.keys(Object(s)).filter((t) => r.indexOf(t) < 0);
                        for (let r = 0, i = t.length; r < i; r += 1) {
                            const i = t[r],
                                n = Object.getOwnPropertyDescriptor(s, i);
                            void 0 !== n &&
                                n.enumerable &&
                                (on(e[i]) && on(s[i])
                                    ? s[i].__swiper__
                                        ? (e[i] = s[i])
                                        : ln(e[i], s[i])
                                    : !on(e[i]) && on(s[i])
                                      ? ((e[i] = {}), s[i].__swiper__ ? (e[i] = s[i]) : ln(e[i], s[i]))
                                      : (e[i] = s[i]));
                        }
                    }
                }
                var i;
                return e;
            }
            function hn(t, e, r) {
                t.style.setProperty(e, r);
            }
            function pn({ swiper: t, targetPosition: e, side: r }) {
                const i = Ui(),
                    n = -t.translate;
                let s,
                    a = null;
                const o = t.params.speed;
                (t.wrapperEl.style.scrollSnapType = "none"), i.cancelAnimationFrame(t.cssModeFrameID);
                const l = e > n ? "next" : "prev",
                    h = (t, e) => ("next" === l && t >= e) || ("prev" === l && t <= e),
                    p = () => {
                        (s = new Date().getTime()), null === a && (a = s);
                        const l = Math.max(Math.min((s - a) / o, 1), 0),
                            c = 0.5 - Math.cos(l * Math.PI) / 2;
                        let d = n + c * (e - n);
                        if ((h(d, e) && (d = e), t.wrapperEl.scrollTo({ [r]: d }), h(d, e)))
                            return (
                                (t.wrapperEl.style.overflow = "hidden"),
                                (t.wrapperEl.style.scrollSnapType = ""),
                                setTimeout(() => {
                                    (t.wrapperEl.style.overflow = ""), t.wrapperEl.scrollTo({ [r]: d });
                                }),
                                void i.cancelAnimationFrame(t.cssModeFrameID)
                            );
                        t.cssModeFrameID = i.requestAnimationFrame(p);
                    };
                p();
            }
            let cn, dn, un;
            function fn() {
                return (
                    cn ||
                        (cn = (function () {
                            const t = Ui(),
                                e = Yi();
                            return {
                                smoothScroll: e.documentElement && "scrollBehavior" in e.documentElement.style,
                                touch: !!("ontouchstart" in t || (t.DocumentTouch && e instanceof t.DocumentTouch)),
                                passiveListener: (function () {
                                    let e = !1;
                                    try {
                                        const r = Object.defineProperty({}, "passive", {
                                            get() {
                                                e = !0;
                                            },
                                        });
                                        t.addEventListener("testPassiveListener", null, r);
                                    } catch (t) {}
                                    return e;
                                })(),
                                gestures: "ongesturestart" in t,
                            };
                        })()),
                    cn
                );
            }
            const mn = {
                on(t, e, r) {
                    const i = this;
                    if (!i.eventsListeners || i.destroyed) return i;
                    if ("function" != typeof e) return i;
                    const n = r ? "unshift" : "push";
                    return (
                        t.split(" ").forEach((t) => {
                            i.eventsListeners[t] || (i.eventsListeners[t] = []), i.eventsListeners[t][n](e);
                        }),
                        i
                    );
                },
                once(t, e, r) {
                    const i = this;
                    if (!i.eventsListeners || i.destroyed) return i;
                    if ("function" != typeof e) return i;
                    function n(...r) {
                        i.off(t, n), n.__emitterProxy && delete n.__emitterProxy, e.apply(i, r);
                    }
                    return (n.__emitterProxy = e), i.on(t, n, r);
                },
                onAny(t, e) {
                    const r = this;
                    if (!r.eventsListeners || r.destroyed) return r;
                    if ("function" != typeof t) return r;
                    const i = e ? "unshift" : "push";
                    return r.eventsAnyListeners.indexOf(t) < 0 && r.eventsAnyListeners[i](t), r;
                },
                offAny(t) {
                    const e = this;
                    if (!e.eventsListeners || e.destroyed) return e;
                    if (!e.eventsAnyListeners) return e;
                    const r = e.eventsAnyListeners.indexOf(t);
                    return r >= 0 && e.eventsAnyListeners.splice(r, 1), e;
                },
                off(t, e) {
                    const r = this;
                    return !r.eventsListeners || r.destroyed
                        ? r
                        : r.eventsListeners
                          ? (t.split(" ").forEach((t) => {
                                void 0 === e
                                    ? (r.eventsListeners[t] = [])
                                    : r.eventsListeners[t] &&
                                      r.eventsListeners[t].forEach((i, n) => {
                                          (i === e || (i.__emitterProxy && i.__emitterProxy === e)) &&
                                              r.eventsListeners[t].splice(n, 1);
                                      });
                            }),
                            r)
                          : r;
                },
                emit(...t) {
                    const e = this;
                    if (!e.eventsListeners || e.destroyed) return e;
                    if (!e.eventsListeners) return e;
                    let r, i, n;
                    return (
                        "string" == typeof t[0] || Array.isArray(t[0])
                            ? ((r = t[0]), (i = t.slice(1, t.length)), (n = e))
                            : ((r = t[0].events), (i = t[0].data), (n = t[0].context || e)),
                        i.unshift(n),
                        (Array.isArray(r) ? r : r.split(" ")).forEach((t) => {
                            e.eventsAnyListeners &&
                                e.eventsAnyListeners.length &&
                                e.eventsAnyListeners.forEach((e) => {
                                    e.apply(n, [t, ...i]);
                                }),
                                e.eventsListeners &&
                                    e.eventsListeners[t] &&
                                    e.eventsListeners[t].forEach((t) => {
                                        t.apply(n, i);
                                    });
                        }),
                        e
                    );
                },
            };
            function gn({ swiper: t, runCallbacks: e, direction: r, step: i }) {
                const { activeIndex: n, previousIndex: s } = t;
                let a = r;
                if ((a || (a = n > s ? "next" : n < s ? "prev" : "reset"), t.emit(`transition${i}`), e && n !== s)) {
                    if ("reset" === a) return void t.emit(`slideResetTransition${i}`);
                    t.emit(`slideChangeTransition${i}`),
                        "next" === a ? t.emit(`slideNextTransition${i}`) : t.emit(`slidePrevTransition${i}`);
                }
            }
            function yn(t) {
                const e = this,
                    r = Yi(),
                    i = Ui(),
                    n = e.touchEventsData,
                    { params: s, touches: a, enabled: o } = e;
                if (!o) return;
                if (e.animating && s.preventInteractionOnTransition) return;
                !e.animating && s.cssMode && s.loop && e.loopFix();
                let l = t;
                l.originalEvent && (l = l.originalEvent);
                let h = nn(l.target);
                if ("wrapper" === s.touchEventsTarget && !h.closest(e.wrapperEl).length) return;
                if (((n.isTouchEvent = "touchstart" === l.type), !n.isTouchEvent && "which" in l && 3 === l.which))
                    return;
                if (!n.isTouchEvent && "button" in l && l.button > 0) return;
                if (n.isTouched && n.isMoved) return;
                const p = !!s.noSwipingClass && "" !== s.noSwipingClass,
                    c = t.composedPath ? t.composedPath() : t.path;
                p && l.target && l.target.shadowRoot && c && (h = nn(c[0]));
                const d = s.noSwipingSelector ? s.noSwipingSelector : `.${s.noSwipingClass}`,
                    u = !(!l.target || !l.target.shadowRoot);
                if (
                    s.noSwiping &&
                    (u
                        ? (function (t, e = this) {
                              return (function e(r) {
                                  if (!r || r === Yi() || r === Ui()) return null;
                                  r.assignedSlot && (r = r.assignedSlot);
                                  const i = r.closest(t);
                                  return i || r.getRootNode ? i || e(r.getRootNode().host) : null;
                              })(e);
                          })(d, h[0])
                        : h.closest(d)[0])
                )
                    return void (e.allowClick = !0);
                if (s.swipeHandler && !h.closest(s.swipeHandler)[0]) return;
                (a.currentX = "touchstart" === l.type ? l.targetTouches[0].pageX : l.pageX),
                    (a.currentY = "touchstart" === l.type ? l.targetTouches[0].pageY : l.pageY);
                const f = a.currentX,
                    m = a.currentY,
                    g = s.edgeSwipeDetection || s.iOSEdgeSwipeDetection,
                    y = s.edgeSwipeThreshold || s.iOSEdgeSwipeThreshold;
                if (g && (f <= y || f >= i.innerWidth - y)) {
                    if ("prevent" !== g) return;
                    t.preventDefault();
                }
                if (
                    (Object.assign(n, {
                        isTouched: !0,
                        isMoved: !1,
                        allowTouchCallbacks: !0,
                        isScrolling: void 0,
                        startMoving: void 0,
                    }),
                    (a.startX = f),
                    (a.startY = m),
                    (n.touchStartTime = an()),
                    (e.allowClick = !0),
                    e.updateSize(),
                    (e.swipeDirection = void 0),
                    s.threshold > 0 && (n.allowThresholdMove = !1),
                    "touchstart" !== l.type)
                ) {
                    let t = !0;
                    h.is(n.focusableElements) && ((t = !1), "SELECT" === h[0].nodeName && (n.isTouched = !1)),
                        r.activeElement &&
                            nn(r.activeElement).is(n.focusableElements) &&
                            r.activeElement !== h[0] &&
                            r.activeElement.blur();
                    const i = t && e.allowTouchMove && s.touchStartPreventDefault;
                    (!s.touchStartForcePreventDefault && !i) || h[0].isContentEditable || l.preventDefault();
                }
                e.params.freeMode &&
                    e.params.freeMode.enabled &&
                    e.freeMode &&
                    e.animating &&
                    !s.cssMode &&
                    e.freeMode.onTouchStart(),
                    e.emit("touchStart", l);
            }
            function vn(t) {
                const e = Yi(),
                    r = this,
                    i = r.touchEventsData,
                    { params: n, touches: s, rtlTranslate: a, enabled: o } = r;
                if (!o) return;
                let l = t;
                if ((l.originalEvent && (l = l.originalEvent), !i.isTouched))
                    return void (i.startMoving && i.isScrolling && r.emit("touchMoveOpposite", l));
                if (i.isTouchEvent && "touchmove" !== l.type) return;
                const h = "touchmove" === l.type && l.targetTouches && (l.targetTouches[0] || l.changedTouches[0]),
                    p = "touchmove" === l.type ? h.pageX : l.pageX,
                    c = "touchmove" === l.type ? h.pageY : l.pageY;
                if (l.preventedByNestedSwiper) return (s.startX = p), void (s.startY = c);
                if (!r.allowTouchMove)
                    return (
                        nn(l.target).is(i.focusableElements) || (r.allowClick = !1),
                        void (
                            i.isTouched &&
                            (Object.assign(s, { startX: p, startY: c, currentX: p, currentY: c }),
                            (i.touchStartTime = an()))
                        )
                    );
                if (i.isTouchEvent && n.touchReleaseOnEdges && !n.loop)
                    if (r.isVertical()) {
                        if (
                            (c < s.startY && r.translate <= r.maxTranslate()) ||
                            (c > s.startY && r.translate >= r.minTranslate())
                        )
                            return (i.isTouched = !1), void (i.isMoved = !1);
                    } else if (
                        (p < s.startX && r.translate <= r.maxTranslate()) ||
                        (p > s.startX && r.translate >= r.minTranslate())
                    )
                        return;
                if (
                    i.isTouchEvent &&
                    e.activeElement &&
                    l.target === e.activeElement &&
                    nn(l.target).is(i.focusableElements)
                )
                    return (i.isMoved = !0), void (r.allowClick = !1);
                if ((i.allowTouchCallbacks && r.emit("touchMove", l), l.targetTouches && l.targetTouches.length > 1))
                    return;
                (s.currentX = p), (s.currentY = c);
                const d = s.currentX - s.startX,
                    u = s.currentY - s.startY;
                if (r.params.threshold && Math.sqrt(d ** 2 + u ** 2) < r.params.threshold) return;
                if (void 0 === i.isScrolling) {
                    let t;
                    (r.isHorizontal() && s.currentY === s.startY) || (r.isVertical() && s.currentX === s.startX)
                        ? (i.isScrolling = !1)
                        : d * d + u * u >= 25 &&
                          ((t = (180 * Math.atan2(Math.abs(u), Math.abs(d))) / Math.PI),
                          (i.isScrolling = r.isHorizontal() ? t > n.touchAngle : 90 - t > n.touchAngle));
                }
                if (
                    (i.isScrolling && r.emit("touchMoveOpposite", l),
                    void 0 === i.startMoving &&
                        ((s.currentX === s.startX && s.currentY === s.startY) || (i.startMoving = !0)),
                    i.isScrolling)
                )
                    return void (i.isTouched = !1);
                if (!i.startMoving) return;
                (r.allowClick = !1),
                    !n.cssMode && l.cancelable && l.preventDefault(),
                    n.touchMoveStopPropagation && !n.nested && l.stopPropagation(),
                    i.isMoved ||
                        (n.loop && !n.cssMode && r.loopFix(),
                        (i.startTranslate = r.getTranslate()),
                        r.setTransition(0),
                        r.animating && r.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
                        (i.allowMomentumBounce = !1),
                        !n.grabCursor || (!0 !== r.allowSlideNext && !0 !== r.allowSlidePrev) || r.setGrabCursor(!0),
                        r.emit("sliderFirstMove", l)),
                    r.emit("sliderMove", l),
                    (i.isMoved = !0);
                let f = r.isHorizontal() ? d : u;
                (s.diff = f),
                    (f *= n.touchRatio),
                    a && (f = -f),
                    (r.swipeDirection = f > 0 ? "prev" : "next"),
                    (i.currentTranslate = f + i.startTranslate);
                let m = !0,
                    g = n.resistanceRatio;
                if (
                    (n.touchReleaseOnEdges && (g = 0),
                    f > 0 && i.currentTranslate > r.minTranslate()
                        ? ((m = !1),
                          n.resistance &&
                              (i.currentTranslate =
                                  r.minTranslate() - 1 + (-r.minTranslate() + i.startTranslate + f) ** g))
                        : f < 0 &&
                          i.currentTranslate < r.maxTranslate() &&
                          ((m = !1),
                          n.resistance &&
                              (i.currentTranslate =
                                  r.maxTranslate() + 1 - (r.maxTranslate() - i.startTranslate - f) ** g)),
                    m && (l.preventedByNestedSwiper = !0),
                    !r.allowSlideNext &&
                        "next" === r.swipeDirection &&
                        i.currentTranslate < i.startTranslate &&
                        (i.currentTranslate = i.startTranslate),
                    !r.allowSlidePrev &&
                        "prev" === r.swipeDirection &&
                        i.currentTranslate > i.startTranslate &&
                        (i.currentTranslate = i.startTranslate),
                    r.allowSlidePrev || r.allowSlideNext || (i.currentTranslate = i.startTranslate),
                    n.threshold > 0)
                ) {
                    if (!(Math.abs(f) > n.threshold || i.allowThresholdMove))
                        return void (i.currentTranslate = i.startTranslate);
                    if (!i.allowThresholdMove)
                        return (
                            (i.allowThresholdMove = !0),
                            (s.startX = s.currentX),
                            (s.startY = s.currentY),
                            (i.currentTranslate = i.startTranslate),
                            void (s.diff = r.isHorizontal() ? s.currentX - s.startX : s.currentY - s.startY)
                        );
                }
                n.followFinger &&
                    !n.cssMode &&
                    (((n.freeMode && n.freeMode.enabled && r.freeMode) || n.watchSlidesProgress) &&
                        (r.updateActiveIndex(), r.updateSlidesClasses()),
                    r.params.freeMode && n.freeMode.enabled && r.freeMode && r.freeMode.onTouchMove(),
                    r.updateProgress(i.currentTranslate),
                    r.setTranslate(i.currentTranslate));
            }
            function bn(t) {
                const e = this,
                    r = e.touchEventsData,
                    { params: i, touches: n, rtlTranslate: s, slidesGrid: a, enabled: o } = e;
                if (!o) return;
                let l = t;
                if (
                    (l.originalEvent && (l = l.originalEvent),
                    r.allowTouchCallbacks && e.emit("touchEnd", l),
                    (r.allowTouchCallbacks = !1),
                    !r.isTouched)
                )
                    return (
                        r.isMoved && i.grabCursor && e.setGrabCursor(!1), (r.isMoved = !1), void (r.startMoving = !1)
                    );
                i.grabCursor &&
                    r.isMoved &&
                    r.isTouched &&
                    (!0 === e.allowSlideNext || !0 === e.allowSlidePrev) &&
                    e.setGrabCursor(!1);
                const h = an(),
                    p = h - r.touchStartTime;
                if (e.allowClick) {
                    const t = l.path || (l.composedPath && l.composedPath());
                    e.updateClickedSlide((t && t[0]) || l.target),
                        e.emit("tap click", l),
                        p < 300 && h - r.lastClickTime < 300 && e.emit("doubleTap doubleClick", l);
                }
                if (
                    ((r.lastClickTime = an()),
                    sn(() => {
                        e.destroyed || (e.allowClick = !0);
                    }),
                    !r.isTouched ||
                        !r.isMoved ||
                        !e.swipeDirection ||
                        0 === n.diff ||
                        r.currentTranslate === r.startTranslate)
                )
                    return (r.isTouched = !1), (r.isMoved = !1), void (r.startMoving = !1);
                let c;
                if (
                    ((r.isTouched = !1),
                    (r.isMoved = !1),
                    (r.startMoving = !1),
                    (c = i.followFinger ? (s ? e.translate : -e.translate) : -r.currentTranslate),
                    i.cssMode)
                )
                    return;
                if (e.params.freeMode && i.freeMode.enabled) return void e.freeMode.onTouchEnd({ currentPos: c });
                let d = 0,
                    u = e.slidesSizesGrid[0];
                for (let t = 0; t < a.length; t += t < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup) {
                    const e = t < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
                    void 0 !== a[t + e]
                        ? c >= a[t] && c < a[t + e] && ((d = t), (u = a[t + e] - a[t]))
                        : c >= a[t] && ((d = t), (u = a[a.length - 1] - a[a.length - 2]));
                }
                let f = null,
                    m = null;
                i.rewind &&
                    (e.isBeginning
                        ? (m =
                              e.params.virtual && e.params.virtual.enabled && e.virtual
                                  ? e.virtual.slides.length - 1
                                  : e.slides.length - 1)
                        : e.isEnd && (f = 0));
                const g = (c - a[d]) / u,
                    y = d < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
                if (p > i.longSwipesMs) {
                    if (!i.longSwipes) return void e.slideTo(e.activeIndex);
                    "next" === e.swipeDirection &&
                        (g >= i.longSwipesRatio ? e.slideTo(i.rewind && e.isEnd ? f : d + y) : e.slideTo(d)),
                        "prev" === e.swipeDirection &&
                            (g > 1 - i.longSwipesRatio
                                ? e.slideTo(d + y)
                                : null !== m && g < 0 && Math.abs(g) > i.longSwipesRatio
                                  ? e.slideTo(m)
                                  : e.slideTo(d));
                } else {
                    if (!i.shortSwipes) return void e.slideTo(e.activeIndex);
                    !e.navigation || (l.target !== e.navigation.nextEl && l.target !== e.navigation.prevEl)
                        ? ("next" === e.swipeDirection && e.slideTo(null !== f ? f : d + y),
                          "prev" === e.swipeDirection && e.slideTo(null !== m ? m : d))
                        : l.target === e.navigation.nextEl
                          ? e.slideTo(d + y)
                          : e.slideTo(d);
                }
            }
            function _n() {
                const t = this,
                    { params: e, el: r } = t;
                if (r && 0 === r.offsetWidth) return;
                e.breakpoints && t.setBreakpoint();
                const { allowSlideNext: i, allowSlidePrev: n, snapGrid: s } = t;
                (t.allowSlideNext = !0),
                    (t.allowSlidePrev = !0),
                    t.updateSize(),
                    t.updateSlides(),
                    t.updateSlidesClasses(),
                    ("auto" === e.slidesPerView || e.slidesPerView > 1) &&
                    t.isEnd &&
                    !t.isBeginning &&
                    !t.params.centeredSlides
                        ? t.slideTo(t.slides.length - 1, 0, !1, !0)
                        : t.slideTo(t.activeIndex, 0, !1, !0),
                    t.autoplay && t.autoplay.running && t.autoplay.paused && t.autoplay.run(),
                    (t.allowSlidePrev = n),
                    (t.allowSlideNext = i),
                    t.params.watchOverflow && s !== t.snapGrid && t.checkOverflow();
            }
            function xn(t) {
                const e = this;
                e.enabled &&
                    (e.allowClick ||
                        (e.params.preventClicks && t.preventDefault(),
                        e.params.preventClicksPropagation &&
                            e.animating &&
                            (t.stopPropagation(), t.stopImmediatePropagation())));
            }
            function Sn() {
                const t = this,
                    { wrapperEl: e, rtlTranslate: r, enabled: i } = t;
                if (!i) return;
                let n;
                (t.previousTranslate = t.translate),
                    t.isHorizontal() ? (t.translate = -e.scrollLeft) : (t.translate = -e.scrollTop),
                    0 === t.translate && (t.translate = 0),
                    t.updateActiveIndex(),
                    t.updateSlidesClasses();
                const s = t.maxTranslate() - t.minTranslate();
                (n = 0 === s ? 0 : (t.translate - t.minTranslate()) / s),
                    n !== t.progress && t.updateProgress(r ? -t.translate : t.translate),
                    t.emit("setTranslate", t.translate, !1);
            }
            let En = !1;
            function wn() {}
            const Pn = (t, e) => {
                    const r = Yi(),
                        { params: i, touchEvents: n, el: s, wrapperEl: a, device: o, support: l } = t,
                        h = !!i.nested,
                        p = "on" === e ? "addEventListener" : "removeEventListener",
                        c = e;
                    if (l.touch) {
                        const e = !("touchstart" !== n.start || !l.passiveListener || !i.passiveListeners) && {
                            passive: !0,
                            capture: !1,
                        };
                        s[p](n.start, t.onTouchStart, e),
                            s[p](n.move, t.onTouchMove, l.passiveListener ? { passive: !1, capture: h } : h),
                            s[p](n.end, t.onTouchEnd, e),
                            n.cancel && s[p](n.cancel, t.onTouchEnd, e);
                    } else
                        s[p](n.start, t.onTouchStart, !1),
                            r[p](n.move, t.onTouchMove, h),
                            r[p](n.end, t.onTouchEnd, !1);
                    (i.preventClicks || i.preventClicksPropagation) && s[p]("click", t.onClick, !0),
                        i.cssMode && a[p]("scroll", t.onScroll),
                        i.updateOnWindowResize
                            ? t[c](
                                  o.ios || o.android
                                      ? "resize orientationchange observerUpdate"
                                      : "resize observerUpdate",
                                  _n,
                                  !0
                              )
                            : t[c]("observerUpdate", _n, !0);
                },
                Tn = (t, e) => t.grid && e.grid && e.grid.rows > 1,
                Cn = {
                    init: !0,
                    direction: "horizontal",
                    touchEventsTarget: "wrapper",
                    initialSlide: 0,
                    speed: 300,
                    cssMode: !1,
                    updateOnWindowResize: !0,
                    resizeObserver: !0,
                    nested: !1,
                    createElements: !1,
                    enabled: !0,
                    focusableElements: "input, select, option, textarea, button, video, label",
                    width: null,
                    height: null,
                    preventInteractionOnTransition: !1,
                    userAgent: null,
                    url: null,
                    edgeSwipeDetection: !1,
                    edgeSwipeThreshold: 20,
                    autoHeight: !1,
                    setWrapperSize: !1,
                    virtualTranslate: !1,
                    effect: "slide",
                    breakpoints: void 0,
                    breakpointsBase: "window",
                    spaceBetween: 0,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    slidesPerGroupSkip: 0,
                    slidesPerGroupAuto: !1,
                    centeredSlides: !1,
                    centeredSlidesBounds: !1,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    normalizeSlideIndex: !0,
                    centerInsufficientSlides: !1,
                    watchOverflow: !0,
                    roundLengths: !1,
                    touchRatio: 1,
                    touchAngle: 45,
                    simulateTouch: !0,
                    shortSwipes: !0,
                    longSwipes: !0,
                    longSwipesRatio: 0.5,
                    longSwipesMs: 300,
                    followFinger: !0,
                    allowTouchMove: !0,
                    threshold: 0,
                    touchMoveStopPropagation: !1,
                    touchStartPreventDefault: !0,
                    touchStartForcePreventDefault: !1,
                    touchReleaseOnEdges: !1,
                    uniqueNavElements: !0,
                    resistance: !0,
                    resistanceRatio: 0.85,
                    watchSlidesProgress: !1,
                    grabCursor: !1,
                    preventClicks: !0,
                    preventClicksPropagation: !0,
                    slideToClickedSlide: !1,
                    preloadImages: !0,
                    updateOnImagesReady: !0,
                    loop: !1,
                    loopAdditionalSlides: 0,
                    loopedSlides: null,
                    loopedSlidesLimit: !0,
                    loopFillGroupWithBlank: !1,
                    loopPreventsSlide: !0,
                    rewind: !1,
                    allowSlidePrev: !0,
                    allowSlideNext: !0,
                    swipeHandler: null,
                    noSwiping: !0,
                    noSwipingClass: "swiper-no-swiping",
                    noSwipingSelector: null,
                    passiveListeners: !0,
                    maxBackfaceHiddenSlides: 10,
                    containerModifierClass: "swiper-",
                    slideClass: "swiper-slide",
                    slideBlankClass: "swiper-slide-invisible-blank",
                    slideActiveClass: "swiper-slide-active",
                    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
                    slideVisibleClass: "swiper-slide-visible",
                    slideDuplicateClass: "swiper-slide-duplicate",
                    slideNextClass: "swiper-slide-next",
                    slideDuplicateNextClass: "swiper-slide-duplicate-next",
                    slidePrevClass: "swiper-slide-prev",
                    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
                    wrapperClass: "swiper-wrapper",
                    runCallbacksOnInit: !0,
                    _emitClasses: !1,
                };
            function An(t, e) {
                return function (r = {}) {
                    const i = Object.keys(r)[0],
                        n = r[i];
                    "object" == typeof n && null !== n
                        ? (["navigation", "pagination", "scrollbar"].indexOf(i) >= 0 &&
                              !0 === t[i] &&
                              (t[i] = { auto: !0 }),
                          i in t && "enabled" in n
                              ? (!0 === t[i] && (t[i] = { enabled: !0 }),
                                "object" != typeof t[i] || "enabled" in t[i] || (t[i].enabled = !0),
                                t[i] || (t[i] = { enabled: !1 }),
                                ln(e, r))
                              : ln(e, r))
                        : ln(e, r);
                };
            }
            const kn = {
                    eventsEmitter: mn,
                    update: {
                        updateSize: function () {
                            const t = this;
                            let e, r;
                            const i = t.$el;
                            (e =
                                void 0 !== t.params.width && null !== t.params.width
                                    ? t.params.width
                                    : i[0].clientWidth),
                                (r =
                                    void 0 !== t.params.height && null !== t.params.height
                                        ? t.params.height
                                        : i[0].clientHeight),
                                (0 === e && t.isHorizontal()) ||
                                    (0 === r && t.isVertical()) ||
                                    ((e =
                                        e -
                                        parseInt(i.css("padding-left") || 0, 10) -
                                        parseInt(i.css("padding-right") || 0, 10)),
                                    (r =
                                        r -
                                        parseInt(i.css("padding-top") || 0, 10) -
                                        parseInt(i.css("padding-bottom") || 0, 10)),
                                    Number.isNaN(e) && (e = 0),
                                    Number.isNaN(r) && (r = 0),
                                    Object.assign(t, { width: e, height: r, size: t.isHorizontal() ? e : r }));
                        },
                        updateSlides: function () {
                            const t = this;
                            function e(e) {
                                return t.isHorizontal()
                                    ? e
                                    : {
                                          width: "height",
                                          "margin-top": "margin-left",
                                          "margin-bottom ": "margin-right",
                                          "margin-left": "margin-top",
                                          "margin-right": "margin-bottom",
                                          "padding-left": "padding-top",
                                          "padding-right": "padding-bottom",
                                          marginRight: "marginBottom",
                                      }[e];
                            }
                            function r(t, r) {
                                return parseFloat(t.getPropertyValue(e(r)) || 0);
                            }
                            const i = t.params,
                                { $wrapperEl: n, size: s, rtlTranslate: a, wrongRTL: o } = t,
                                l = t.virtual && i.virtual.enabled,
                                h = l ? t.virtual.slides.length : t.slides.length,
                                p = n.children(`.${t.params.slideClass}`),
                                c = l ? t.virtual.slides.length : p.length;
                            let d = [];
                            const u = [],
                                f = [];
                            let m = i.slidesOffsetBefore;
                            "function" == typeof m && (m = i.slidesOffsetBefore.call(t));
                            let g = i.slidesOffsetAfter;
                            "function" == typeof g && (g = i.slidesOffsetAfter.call(t));
                            const y = t.snapGrid.length,
                                v = t.slidesGrid.length;
                            let b = i.spaceBetween,
                                _ = -m,
                                x = 0,
                                S = 0;
                            if (void 0 === s) return;
                            "string" == typeof b &&
                                b.indexOf("%") >= 0 &&
                                (b = (parseFloat(b.replace("%", "")) / 100) * s),
                                (t.virtualSize = -b),
                                a
                                    ? p.css({ marginLeft: "", marginBottom: "", marginTop: "" })
                                    : p.css({ marginRight: "", marginBottom: "", marginTop: "" }),
                                i.centeredSlides &&
                                    i.cssMode &&
                                    (hn(t.wrapperEl, "--swiper-centered-offset-before", ""),
                                    hn(t.wrapperEl, "--swiper-centered-offset-after", ""));
                            const E = i.grid && i.grid.rows > 1 && t.grid;
                            let w;
                            E && t.grid.initSlides(c);
                            const P =
                                "auto" === i.slidesPerView &&
                                i.breakpoints &&
                                Object.keys(i.breakpoints).filter((t) => void 0 !== i.breakpoints[t].slidesPerView)
                                    .length > 0;
                            for (let n = 0; n < c; n += 1) {
                                w = 0;
                                const a = p.eq(n);
                                if ((E && t.grid.updateSlide(n, a, c, e), "none" !== a.css("display"))) {
                                    if ("auto" === i.slidesPerView) {
                                        P && (p[n].style[e("width")] = "");
                                        const s = getComputedStyle(a[0]),
                                            o = a[0].style.transform,
                                            l = a[0].style.webkitTransform;
                                        if (
                                            (o && (a[0].style.transform = "none"),
                                            l && (a[0].style.webkitTransform = "none"),
                                            i.roundLengths)
                                        )
                                            w = t.isHorizontal() ? a.outerWidth(!0) : a.outerHeight(!0);
                                        else {
                                            const t = r(s, "width"),
                                                e = r(s, "padding-left"),
                                                i = r(s, "padding-right"),
                                                n = r(s, "margin-left"),
                                                o = r(s, "margin-right"),
                                                l = s.getPropertyValue("box-sizing");
                                            if (l && "border-box" === l) w = t + n + o;
                                            else {
                                                const { clientWidth: r, offsetWidth: s } = a[0];
                                                w = t + e + i + n + o + (s - r);
                                            }
                                        }
                                        o && (a[0].style.transform = o),
                                            l && (a[0].style.webkitTransform = l),
                                            i.roundLengths && (w = Math.floor(w));
                                    } else
                                        (w = (s - (i.slidesPerView - 1) * b) / i.slidesPerView),
                                            i.roundLengths && (w = Math.floor(w)),
                                            p[n] && (p[n].style[e("width")] = `${w}px`);
                                    p[n] && (p[n].swiperSlideSize = w),
                                        f.push(w),
                                        i.centeredSlides
                                            ? ((_ = _ + w / 2 + x / 2 + b),
                                              0 === x && 0 !== n && (_ = _ - s / 2 - b),
                                              0 === n && (_ = _ - s / 2 - b),
                                              Math.abs(_) < 0.001 && (_ = 0),
                                              i.roundLengths && (_ = Math.floor(_)),
                                              S % i.slidesPerGroup == 0 && d.push(_),
                                              u.push(_))
                                            : (i.roundLengths && (_ = Math.floor(_)),
                                              (S - Math.min(t.params.slidesPerGroupSkip, S)) %
                                                  t.params.slidesPerGroup ==
                                                  0 && d.push(_),
                                              u.push(_),
                                              (_ = _ + w + b)),
                                        (t.virtualSize += w + b),
                                        (x = w),
                                        (S += 1);
                                }
                            }
                            if (
                                ((t.virtualSize = Math.max(t.virtualSize, s) + g),
                                a &&
                                    o &&
                                    ("slide" === i.effect || "coverflow" === i.effect) &&
                                    n.css({ width: `${t.virtualSize + i.spaceBetween}px` }),
                                i.setWrapperSize && n.css({ [e("width")]: `${t.virtualSize + i.spaceBetween}px` }),
                                E && t.grid.updateWrapperSize(w, d, e),
                                !i.centeredSlides)
                            ) {
                                const e = [];
                                for (let r = 0; r < d.length; r += 1) {
                                    let n = d[r];
                                    i.roundLengths && (n = Math.floor(n)), d[r] <= t.virtualSize - s && e.push(n);
                                }
                                (d = e),
                                    Math.floor(t.virtualSize - s) - Math.floor(d[d.length - 1]) > 1 &&
                                        d.push(t.virtualSize - s);
                            }
                            if ((0 === d.length && (d = [0]), 0 !== i.spaceBetween)) {
                                const r = t.isHorizontal() && a ? "marginLeft" : e("marginRight");
                                p.filter((t, e) => !i.cssMode || e !== p.length - 1).css({ [r]: `${b}px` });
                            }
                            if (i.centeredSlides && i.centeredSlidesBounds) {
                                let t = 0;
                                f.forEach((e) => {
                                    t += e + (i.spaceBetween ? i.spaceBetween : 0);
                                }),
                                    (t -= i.spaceBetween);
                                const e = t - s;
                                d = d.map((t) => (t < 0 ? -m : t > e ? e + g : t));
                            }
                            if (i.centerInsufficientSlides) {
                                let t = 0;
                                if (
                                    (f.forEach((e) => {
                                        t += e + (i.spaceBetween ? i.spaceBetween : 0);
                                    }),
                                    (t -= i.spaceBetween),
                                    t < s)
                                ) {
                                    const e = (s - t) / 2;
                                    d.forEach((t, r) => {
                                        d[r] = t - e;
                                    }),
                                        u.forEach((t, r) => {
                                            u[r] = t + e;
                                        });
                                }
                            }
                            if (
                                (Object.assign(t, { slides: p, snapGrid: d, slidesGrid: u, slidesSizesGrid: f }),
                                i.centeredSlides && i.cssMode && !i.centeredSlidesBounds)
                            ) {
                                hn(t.wrapperEl, "--swiper-centered-offset-before", -d[0] + "px"),
                                    hn(
                                        t.wrapperEl,
                                        "--swiper-centered-offset-after",
                                        t.size / 2 - f[f.length - 1] / 2 + "px"
                                    );
                                const e = -t.snapGrid[0],
                                    r = -t.slidesGrid[0];
                                (t.snapGrid = t.snapGrid.map((t) => t + e)),
                                    (t.slidesGrid = t.slidesGrid.map((t) => t + r));
                            }
                            if (
                                (c !== h && t.emit("slidesLengthChange"),
                                d.length !== y &&
                                    (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")),
                                u.length !== v && t.emit("slidesGridLengthChange"),
                                i.watchSlidesProgress && t.updateSlidesOffset(),
                                !(l || i.cssMode || ("slide" !== i.effect && "fade" !== i.effect)))
                            ) {
                                const e = `${i.containerModifierClass}backface-hidden`,
                                    r = t.$el.hasClass(e);
                                c <= i.maxBackfaceHiddenSlides ? r || t.$el.addClass(e) : r && t.$el.removeClass(e);
                            }
                        },
                        updateAutoHeight: function (t) {
                            const e = this,
                                r = [],
                                i = e.virtual && e.params.virtual.enabled;
                            let n,
                                s = 0;
                            "number" == typeof t ? e.setTransition(t) : !0 === t && e.setTransition(e.params.speed);
                            const a = (t) =>
                                i
                                    ? e.slides.filter(
                                          (e) => parseInt(e.getAttribute("data-swiper-slide-index"), 10) === t
                                      )[0]
                                    : e.slides.eq(t)[0];
                            if ("auto" !== e.params.slidesPerView && e.params.slidesPerView > 1)
                                if (e.params.centeredSlides)
                                    (e.visibleSlides || nn([])).each((t) => {
                                        r.push(t);
                                    });
                                else
                                    for (n = 0; n < Math.ceil(e.params.slidesPerView); n += 1) {
                                        const t = e.activeIndex + n;
                                        if (t > e.slides.length && !i) break;
                                        r.push(a(t));
                                    }
                            else r.push(a(e.activeIndex));
                            for (n = 0; n < r.length; n += 1)
                                if (void 0 !== r[n]) {
                                    const t = r[n].offsetHeight;
                                    s = t > s ? t : s;
                                }
                            (s || 0 === s) && e.$wrapperEl.css("height", `${s}px`);
                        },
                        updateSlidesOffset: function () {
                            const t = this,
                                e = t.slides;
                            for (let r = 0; r < e.length; r += 1)
                                e[r].swiperSlideOffset = t.isHorizontal() ? e[r].offsetLeft : e[r].offsetTop;
                        },
                        updateSlidesProgress: function (t = (this && this.translate) || 0) {
                            const e = this,
                                r = e.params,
                                { slides: i, rtlTranslate: n, snapGrid: s } = e;
                            if (0 === i.length) return;
                            void 0 === i[0].swiperSlideOffset && e.updateSlidesOffset();
                            let a = -t;
                            n && (a = t),
                                i.removeClass(r.slideVisibleClass),
                                (e.visibleSlidesIndexes = []),
                                (e.visibleSlides = []);
                            for (let t = 0; t < i.length; t += 1) {
                                const o = i[t];
                                let l = o.swiperSlideOffset;
                                r.cssMode && r.centeredSlides && (l -= i[0].swiperSlideOffset);
                                const h =
                                        (a + (r.centeredSlides ? e.minTranslate() : 0) - l) /
                                        (o.swiperSlideSize + r.spaceBetween),
                                    p =
                                        (a - s[0] + (r.centeredSlides ? e.minTranslate() : 0) - l) /
                                        (o.swiperSlideSize + r.spaceBetween),
                                    c = -(a - l),
                                    d = c + e.slidesSizesGrid[t];
                                ((c >= 0 && c < e.size - 1) || (d > 1 && d <= e.size) || (c <= 0 && d >= e.size)) &&
                                    (e.visibleSlides.push(o),
                                    e.visibleSlidesIndexes.push(t),
                                    i.eq(t).addClass(r.slideVisibleClass)),
                                    (o.progress = n ? -h : h),
                                    (o.originalProgress = n ? -p : p);
                            }
                            e.visibleSlides = nn(e.visibleSlides);
                        },
                        updateProgress: function (t) {
                            const e = this;
                            if (void 0 === t) {
                                const r = e.rtlTranslate ? -1 : 1;
                                t = (e && e.translate && e.translate * r) || 0;
                            }
                            const r = e.params,
                                i = e.maxTranslate() - e.minTranslate();
                            let { progress: n, isBeginning: s, isEnd: a } = e;
                            const o = s,
                                l = a;
                            0 === i
                                ? ((n = 0), (s = !0), (a = !0))
                                : ((n = (t - e.minTranslate()) / i), (s = n <= 0), (a = n >= 1)),
                                Object.assign(e, { progress: n, isBeginning: s, isEnd: a }),
                                (r.watchSlidesProgress || (r.centeredSlides && r.autoHeight)) &&
                                    e.updateSlidesProgress(t),
                                s && !o && e.emit("reachBeginning toEdge"),
                                a && !l && e.emit("reachEnd toEdge"),
                                ((o && !s) || (l && !a)) && e.emit("fromEdge"),
                                e.emit("progress", n);
                        },
                        updateSlidesClasses: function () {
                            const t = this,
                                { slides: e, params: r, $wrapperEl: i, activeIndex: n, realIndex: s } = t,
                                a = t.virtual && r.virtual.enabled;
                            let o;
                            e.removeClass(
                                `${r.slideActiveClass} ${r.slideNextClass} ${r.slidePrevClass} ${r.slideDuplicateActiveClass} ${r.slideDuplicateNextClass} ${r.slideDuplicatePrevClass}`
                            ),
                                (o = a
                                    ? t.$wrapperEl.find(`.${r.slideClass}[data-swiper-slide-index="${n}"]`)
                                    : e.eq(n)),
                                o.addClass(r.slideActiveClass),
                                r.loop &&
                                    (o.hasClass(r.slideDuplicateClass)
                                        ? i
                                              .children(
                                                  `.${r.slideClass}:not(.${r.slideDuplicateClass})[data-swiper-slide-index="${s}"]`
                                              )
                                              .addClass(r.slideDuplicateActiveClass)
                                        : i
                                              .children(
                                                  `.${r.slideClass}.${r.slideDuplicateClass}[data-swiper-slide-index="${s}"]`
                                              )
                                              .addClass(r.slideDuplicateActiveClass));
                            let l = o.nextAll(`.${r.slideClass}`).eq(0).addClass(r.slideNextClass);
                            r.loop && 0 === l.length && ((l = e.eq(0)), l.addClass(r.slideNextClass));
                            let h = o.prevAll(`.${r.slideClass}`).eq(0).addClass(r.slidePrevClass);
                            r.loop && 0 === h.length && ((h = e.eq(-1)), h.addClass(r.slidePrevClass)),
                                r.loop &&
                                    (l.hasClass(r.slideDuplicateClass)
                                        ? i
                                              .children(
                                                  `.${r.slideClass}:not(.${r.slideDuplicateClass})[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`
                                              )
                                              .addClass(r.slideDuplicateNextClass)
                                        : i
                                              .children(
                                                  `.${r.slideClass}.${r.slideDuplicateClass}[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`
                                              )
                                              .addClass(r.slideDuplicateNextClass),
                                    h.hasClass(r.slideDuplicateClass)
                                        ? i
                                              .children(
                                                  `.${r.slideClass}:not(.${r.slideDuplicateClass})[data-swiper-slide-index="${h.attr("data-swiper-slide-index")}"]`
                                              )
                                              .addClass(r.slideDuplicatePrevClass)
                                        : i
                                              .children(
                                                  `.${r.slideClass}.${r.slideDuplicateClass}[data-swiper-slide-index="${h.attr("data-swiper-slide-index")}"]`
                                              )
                                              .addClass(r.slideDuplicatePrevClass)),
                                t.emitSlidesClasses();
                        },
                        updateActiveIndex: function (t) {
                            const e = this,
                                r = e.rtlTranslate ? e.translate : -e.translate,
                                {
                                    slidesGrid: i,
                                    snapGrid: n,
                                    params: s,
                                    activeIndex: a,
                                    realIndex: o,
                                    snapIndex: l,
                                } = e;
                            let h,
                                p = t;
                            if (void 0 === p) {
                                for (let t = 0; t < i.length; t += 1)
                                    void 0 !== i[t + 1]
                                        ? r >= i[t] && r < i[t + 1] - (i[t + 1] - i[t]) / 2
                                            ? (p = t)
                                            : r >= i[t] && r < i[t + 1] && (p = t + 1)
                                        : r >= i[t] && (p = t);
                                s.normalizeSlideIndex && (p < 0 || void 0 === p) && (p = 0);
                            }
                            if (n.indexOf(r) >= 0) h = n.indexOf(r);
                            else {
                                const t = Math.min(s.slidesPerGroupSkip, p);
                                h = t + Math.floor((p - t) / s.slidesPerGroup);
                            }
                            if ((h >= n.length && (h = n.length - 1), p === a))
                                return void (h !== l && ((e.snapIndex = h), e.emit("snapIndexChange")));
                            const c = parseInt(e.slides.eq(p).attr("data-swiper-slide-index") || p, 10);
                            Object.assign(e, { snapIndex: h, realIndex: c, previousIndex: a, activeIndex: p }),
                                e.emit("activeIndexChange"),
                                e.emit("snapIndexChange"),
                                o !== c && e.emit("realIndexChange"),
                                (e.initialized || e.params.runCallbacksOnInit) && e.emit("slideChange");
                        },
                        updateClickedSlide: function (t) {
                            const e = this,
                                r = e.params,
                                i = nn(t).closest(`.${r.slideClass}`)[0];
                            let n,
                                s = !1;
                            if (i)
                                for (let t = 0; t < e.slides.length; t += 1)
                                    if (e.slides[t] === i) {
                                        (s = !0), (n = t);
                                        break;
                                    }
                            if (!i || !s) return (e.clickedSlide = void 0), void (e.clickedIndex = void 0);
                            (e.clickedSlide = i),
                                e.virtual && e.params.virtual.enabled
                                    ? (e.clickedIndex = parseInt(nn(i).attr("data-swiper-slide-index"), 10))
                                    : (e.clickedIndex = n),
                                r.slideToClickedSlide &&
                                    void 0 !== e.clickedIndex &&
                                    e.clickedIndex !== e.activeIndex &&
                                    e.slideToClickedSlide();
                        },
                    },
                    translate: {
                        getTranslate: function (t = this.isHorizontal() ? "x" : "y") {
                            const { params: e, rtlTranslate: r, translate: i, $wrapperEl: n } = this;
                            if (e.virtualTranslate) return r ? -i : i;
                            if (e.cssMode) return i;
                            let s = (function (t, e = "x") {
                                const r = Ui();
                                let i, n, s;
                                const a = (function (t) {
                                    const e = Ui();
                                    let r;
                                    return (
                                        e.getComputedStyle && (r = e.getComputedStyle(t, null)),
                                        !r && t.currentStyle && (r = t.currentStyle),
                                        r || (r = t.style),
                                        r
                                    );
                                })(t);
                                return (
                                    r.WebKitCSSMatrix
                                        ? ((n = a.transform || a.webkitTransform),
                                          n.split(",").length > 6 &&
                                              (n = n
                                                  .split(", ")
                                                  .map((t) => t.replace(",", "."))
                                                  .join(", ")),
                                          (s = new r.WebKitCSSMatrix("none" === n ? "" : n)))
                                        : ((s =
                                              a.MozTransform ||
                                              a.OTransform ||
                                              a.MsTransform ||
                                              a.msTransform ||
                                              a.transform ||
                                              a
                                                  .getPropertyValue("transform")
                                                  .replace("translate(", "matrix(1, 0, 0, 1,")),
                                          (i = s.toString().split(","))),
                                    "x" === e &&
                                        (n = r.WebKitCSSMatrix
                                            ? s.m41
                                            : 16 === i.length
                                              ? parseFloat(i[12])
                                              : parseFloat(i[4])),
                                    "y" === e &&
                                        (n = r.WebKitCSSMatrix
                                            ? s.m42
                                            : 16 === i.length
                                              ? parseFloat(i[13])
                                              : parseFloat(i[5])),
                                    n || 0
                                );
                            })(n[0], t);
                            return r && (s = -s), s || 0;
                        },
                        setTranslate: function (t, e) {
                            const r = this,
                                { rtlTranslate: i, params: n, $wrapperEl: s, wrapperEl: a, progress: o } = r;
                            let l,
                                h = 0,
                                p = 0;
                            r.isHorizontal() ? (h = i ? -t : t) : (p = t),
                                n.roundLengths && ((h = Math.floor(h)), (p = Math.floor(p))),
                                n.cssMode
                                    ? (a[r.isHorizontal() ? "scrollLeft" : "scrollTop"] = r.isHorizontal() ? -h : -p)
                                    : n.virtualTranslate || s.transform(`translate3d(${h}px, ${p}px, 0px)`),
                                (r.previousTranslate = r.translate),
                                (r.translate = r.isHorizontal() ? h : p);
                            const c = r.maxTranslate() - r.minTranslate();
                            (l = 0 === c ? 0 : (t - r.minTranslate()) / c),
                                l !== o && r.updateProgress(t),
                                r.emit("setTranslate", r.translate, e);
                        },
                        minTranslate: function () {
                            return -this.snapGrid[0];
                        },
                        maxTranslate: function () {
                            return -this.snapGrid[this.snapGrid.length - 1];
                        },
                        translateTo: function (t = 0, e = this.params.speed, r = !0, i = !0, n) {
                            const s = this,
                                { params: a, wrapperEl: o } = s;
                            if (s.animating && a.preventInteractionOnTransition) return !1;
                            const l = s.minTranslate(),
                                h = s.maxTranslate();
                            let p;
                            if (((p = i && t > l ? l : i && t < h ? h : t), s.updateProgress(p), a.cssMode)) {
                                const t = s.isHorizontal();
                                if (0 === e) o[t ? "scrollLeft" : "scrollTop"] = -p;
                                else {
                                    if (!s.support.smoothScroll)
                                        return pn({ swiper: s, targetPosition: -p, side: t ? "left" : "top" }), !0;
                                    o.scrollTo({ [t ? "left" : "top"]: -p, behavior: "smooth" });
                                }
                                return !0;
                            }
                            return (
                                0 === e
                                    ? (s.setTransition(0),
                                      s.setTranslate(p),
                                      r && (s.emit("beforeTransitionStart", e, n), s.emit("transitionEnd")))
                                    : (s.setTransition(e),
                                      s.setTranslate(p),
                                      r && (s.emit("beforeTransitionStart", e, n), s.emit("transitionStart")),
                                      s.animating ||
                                          ((s.animating = !0),
                                          s.onTranslateToWrapperTransitionEnd ||
                                              (s.onTranslateToWrapperTransitionEnd = function (t) {
                                                  s &&
                                                      !s.destroyed &&
                                                      t.target === this &&
                                                      (s.$wrapperEl[0].removeEventListener(
                                                          "transitionend",
                                                          s.onTranslateToWrapperTransitionEnd
                                                      ),
                                                      s.$wrapperEl[0].removeEventListener(
                                                          "webkitTransitionEnd",
                                                          s.onTranslateToWrapperTransitionEnd
                                                      ),
                                                      (s.onTranslateToWrapperTransitionEnd = null),
                                                      delete s.onTranslateToWrapperTransitionEnd,
                                                      r && s.emit("transitionEnd"));
                                              }),
                                          s.$wrapperEl[0].addEventListener(
                                              "transitionend",
                                              s.onTranslateToWrapperTransitionEnd
                                          ),
                                          s.$wrapperEl[0].addEventListener(
                                              "webkitTransitionEnd",
                                              s.onTranslateToWrapperTransitionEnd
                                          ))),
                                !0
                            );
                        },
                    },
                    transition: {
                        setTransition: function (t, e) {
                            const r = this;
                            r.params.cssMode || r.$wrapperEl.transition(t), r.emit("setTransition", t, e);
                        },
                        transitionStart: function (t = !0, e) {
                            const r = this,
                                { params: i } = r;
                            i.cssMode ||
                                (i.autoHeight && r.updateAutoHeight(),
                                gn({ swiper: r, runCallbacks: t, direction: e, step: "Start" }));
                        },
                        transitionEnd: function (t = !0, e) {
                            const r = this,
                                { params: i } = r;
                            (r.animating = !1),
                                i.cssMode ||
                                    (r.setTransition(0), gn({ swiper: r, runCallbacks: t, direction: e, step: "End" }));
                        },
                    },
                    slide: {
                        slideTo: function (t = 0, e = this.params.speed, r = !0, i, n) {
                            if ("number" != typeof t && "string" != typeof t)
                                throw new Error(
                                    `The 'index' argument cannot have type other than 'number' or 'string'. [${typeof t}] given.`
                                );
                            if ("string" == typeof t) {
                                const e = parseInt(t, 10);
                                if (!isFinite(e))
                                    throw new Error(
                                        `The passed-in 'index' (string) couldn't be converted to 'number'. [${t}] given.`
                                    );
                                t = e;
                            }
                            const s = this;
                            let a = t;
                            a < 0 && (a = 0);
                            const {
                                params: o,
                                snapGrid: l,
                                slidesGrid: h,
                                previousIndex: p,
                                activeIndex: c,
                                rtlTranslate: d,
                                wrapperEl: u,
                                enabled: f,
                            } = s;
                            if ((s.animating && o.preventInteractionOnTransition) || (!f && !i && !n)) return !1;
                            const m = Math.min(s.params.slidesPerGroupSkip, a);
                            let g = m + Math.floor((a - m) / s.params.slidesPerGroup);
                            g >= l.length && (g = l.length - 1);
                            const y = -l[g];
                            if (o.normalizeSlideIndex)
                                for (let t = 0; t < h.length; t += 1) {
                                    const e = -Math.floor(100 * y),
                                        r = Math.floor(100 * h[t]),
                                        i = Math.floor(100 * h[t + 1]);
                                    void 0 !== h[t + 1]
                                        ? e >= r && e < i - (i - r) / 2
                                            ? (a = t)
                                            : e >= r && e < i && (a = t + 1)
                                        : e >= r && (a = t);
                                }
                            if (s.initialized && a !== c) {
                                if (!s.allowSlideNext && y < s.translate && y < s.minTranslate()) return !1;
                                if (!s.allowSlidePrev && y > s.translate && y > s.maxTranslate() && (c || 0) !== a)
                                    return !1;
                            }
                            let v;
                            if (
                                (a !== (p || 0) && r && s.emit("beforeSlideChangeStart"),
                                s.updateProgress(y),
                                (v = a > c ? "next" : a < c ? "prev" : "reset"),
                                (d && -y === s.translate) || (!d && y === s.translate))
                            )
                                return (
                                    s.updateActiveIndex(a),
                                    o.autoHeight && s.updateAutoHeight(),
                                    s.updateSlidesClasses(),
                                    "slide" !== o.effect && s.setTranslate(y),
                                    "reset" !== v && (s.transitionStart(r, v), s.transitionEnd(r, v)),
                                    !1
                                );
                            if (o.cssMode) {
                                const t = s.isHorizontal(),
                                    r = d ? y : -y;
                                if (0 === e) {
                                    const e = s.virtual && s.params.virtual.enabled;
                                    e && ((s.wrapperEl.style.scrollSnapType = "none"), (s._immediateVirtual = !0)),
                                        (u[t ? "scrollLeft" : "scrollTop"] = r),
                                        e &&
                                            requestAnimationFrame(() => {
                                                (s.wrapperEl.style.scrollSnapType = ""),
                                                    (s._swiperImmediateVirtual = !1);
                                            });
                                } else {
                                    if (!s.support.smoothScroll)
                                        return pn({ swiper: s, targetPosition: r, side: t ? "left" : "top" }), !0;
                                    u.scrollTo({ [t ? "left" : "top"]: r, behavior: "smooth" });
                                }
                                return !0;
                            }
                            return (
                                s.setTransition(e),
                                s.setTranslate(y),
                                s.updateActiveIndex(a),
                                s.updateSlidesClasses(),
                                s.emit("beforeTransitionStart", e, i),
                                s.transitionStart(r, v),
                                0 === e
                                    ? s.transitionEnd(r, v)
                                    : s.animating ||
                                      ((s.animating = !0),
                                      s.onSlideToWrapperTransitionEnd ||
                                          (s.onSlideToWrapperTransitionEnd = function (t) {
                                              s &&
                                                  !s.destroyed &&
                                                  t.target === this &&
                                                  (s.$wrapperEl[0].removeEventListener(
                                                      "transitionend",
                                                      s.onSlideToWrapperTransitionEnd
                                                  ),
                                                  s.$wrapperEl[0].removeEventListener(
                                                      "webkitTransitionEnd",
                                                      s.onSlideToWrapperTransitionEnd
                                                  ),
                                                  (s.onSlideToWrapperTransitionEnd = null),
                                                  delete s.onSlideToWrapperTransitionEnd,
                                                  s.transitionEnd(r, v));
                                          }),
                                      s.$wrapperEl[0].addEventListener(
                                          "transitionend",
                                          s.onSlideToWrapperTransitionEnd
                                      ),
                                      s.$wrapperEl[0].addEventListener(
                                          "webkitTransitionEnd",
                                          s.onSlideToWrapperTransitionEnd
                                      )),
                                !0
                            );
                        },
                        slideToLoop: function (t = 0, e = this.params.speed, r = !0, i) {
                            if ("string" == typeof t) {
                                const e = parseInt(t, 10);
                                if (!isFinite(e))
                                    throw new Error(
                                        `The passed-in 'index' (string) couldn't be converted to 'number'. [${t}] given.`
                                    );
                                t = e;
                            }
                            const n = this;
                            let s = t;
                            return n.params.loop && (s += n.loopedSlides), n.slideTo(s, e, r, i);
                        },
                        slideNext: function (t = this.params.speed, e = !0, r) {
                            const i = this,
                                { animating: n, enabled: s, params: a } = i;
                            if (!s) return i;
                            let o = a.slidesPerGroup;
                            "auto" === a.slidesPerView &&
                                1 === a.slidesPerGroup &&
                                a.slidesPerGroupAuto &&
                                (o = Math.max(i.slidesPerViewDynamic("current", !0), 1));
                            const l = i.activeIndex < a.slidesPerGroupSkip ? 1 : o;
                            if (a.loop) {
                                if (n && a.loopPreventsSlide) return !1;
                                i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft);
                            }
                            return a.rewind && i.isEnd ? i.slideTo(0, t, e, r) : i.slideTo(i.activeIndex + l, t, e, r);
                        },
                        slidePrev: function (t = this.params.speed, e = !0, r) {
                            const i = this,
                                {
                                    params: n,
                                    animating: s,
                                    snapGrid: a,
                                    slidesGrid: o,
                                    rtlTranslate: l,
                                    enabled: h,
                                } = i;
                            if (!h) return i;
                            if (n.loop) {
                                if (s && n.loopPreventsSlide) return !1;
                                i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft);
                            }
                            function p(t) {
                                return t < 0 ? -Math.floor(Math.abs(t)) : Math.floor(t);
                            }
                            const c = p(l ? i.translate : -i.translate),
                                d = a.map((t) => p(t));
                            let u = a[d.indexOf(c) - 1];
                            if (void 0 === u && n.cssMode) {
                                let t;
                                a.forEach((e, r) => {
                                    c >= e && (t = r);
                                }),
                                    void 0 !== t && (u = a[t > 0 ? t - 1 : t]);
                            }
                            let f = 0;
                            if (
                                (void 0 !== u &&
                                    ((f = o.indexOf(u)),
                                    f < 0 && (f = i.activeIndex - 1),
                                    "auto" === n.slidesPerView &&
                                        1 === n.slidesPerGroup &&
                                        n.slidesPerGroupAuto &&
                                        ((f = f - i.slidesPerViewDynamic("previous", !0) + 1), (f = Math.max(f, 0)))),
                                n.rewind && i.isBeginning)
                            ) {
                                const n =
                                    i.params.virtual && i.params.virtual.enabled && i.virtual
                                        ? i.virtual.slides.length - 1
                                        : i.slides.length - 1;
                                return i.slideTo(n, t, e, r);
                            }
                            return i.slideTo(f, t, e, r);
                        },
                        slideReset: function (t = this.params.speed, e = !0, r) {
                            return this.slideTo(this.activeIndex, t, e, r);
                        },
                        slideToClosest: function (t = this.params.speed, e = !0, r, i = 0.5) {
                            const n = this;
                            let s = n.activeIndex;
                            const a = Math.min(n.params.slidesPerGroupSkip, s),
                                o = a + Math.floor((s - a) / n.params.slidesPerGroup),
                                l = n.rtlTranslate ? n.translate : -n.translate;
                            if (l >= n.snapGrid[o]) {
                                const t = n.snapGrid[o];
                                l - t > (n.snapGrid[o + 1] - t) * i && (s += n.params.slidesPerGroup);
                            } else {
                                const t = n.snapGrid[o - 1];
                                l - t <= (n.snapGrid[o] - t) * i && (s -= n.params.slidesPerGroup);
                            }
                            return (
                                (s = Math.max(s, 0)), (s = Math.min(s, n.slidesGrid.length - 1)), n.slideTo(s, t, e, r)
                            );
                        },
                        slideToClickedSlide: function () {
                            const t = this,
                                { params: e, $wrapperEl: r } = t,
                                i = "auto" === e.slidesPerView ? t.slidesPerViewDynamic() : e.slidesPerView;
                            let n,
                                s = t.clickedIndex;
                            if (e.loop) {
                                if (t.animating) return;
                                (n = parseInt(nn(t.clickedSlide).attr("data-swiper-slide-index"), 10)),
                                    e.centeredSlides
                                        ? s < t.loopedSlides - i / 2 || s > t.slides.length - t.loopedSlides + i / 2
                                            ? (t.loopFix(),
                                              (s = r
                                                  .children(
                                                      `.${e.slideClass}[data-swiper-slide-index="${n}"]:not(.${e.slideDuplicateClass})`
                                                  )
                                                  .eq(0)
                                                  .index()),
                                              sn(() => {
                                                  t.slideTo(s);
                                              }))
                                            : t.slideTo(s)
                                        : s > t.slides.length - i
                                          ? (t.loopFix(),
                                            (s = r
                                                .children(
                                                    `.${e.slideClass}[data-swiper-slide-index="${n}"]:not(.${e.slideDuplicateClass})`
                                                )
                                                .eq(0)
                                                .index()),
                                            sn(() => {
                                                t.slideTo(s);
                                            }))
                                          : t.slideTo(s);
                            } else t.slideTo(s);
                        },
                    },
                    loop: {
                        loopCreate: function () {
                            const t = this,
                                e = Yi(),
                                { params: r, $wrapperEl: i } = t,
                                n = i.children().length > 0 ? nn(i.children()[0].parentNode) : i;
                            n.children(`.${r.slideClass}.${r.slideDuplicateClass}`).remove();
                            let s = n.children(`.${r.slideClass}`);
                            if (r.loopFillGroupWithBlank) {
                                const t = r.slidesPerGroup - (s.length % r.slidesPerGroup);
                                if (t !== r.slidesPerGroup) {
                                    for (let i = 0; i < t; i += 1) {
                                        const t = nn(e.createElement("div")).addClass(
                                            `${r.slideClass} ${r.slideBlankClass}`
                                        );
                                        n.append(t);
                                    }
                                    s = n.children(`.${r.slideClass}`);
                                }
                            }
                            "auto" !== r.slidesPerView || r.loopedSlides || (r.loopedSlides = s.length),
                                (t.loopedSlides = Math.ceil(parseFloat(r.loopedSlides || r.slidesPerView, 10))),
                                (t.loopedSlides += r.loopAdditionalSlides),
                                t.loopedSlides > s.length && t.params.loopedSlidesLimit && (t.loopedSlides = s.length);
                            const a = [],
                                o = [];
                            s.each((t, e) => {
                                nn(t).attr("data-swiper-slide-index", e);
                            });
                            for (let e = 0; e < t.loopedSlides; e += 1) {
                                const t = e - Math.floor(e / s.length) * s.length;
                                o.push(s.eq(t)[0]), a.unshift(s.eq(s.length - t - 1)[0]);
                            }
                            for (let t = 0; t < o.length; t += 1)
                                n.append(nn(o[t].cloneNode(!0)).addClass(r.slideDuplicateClass));
                            for (let t = a.length - 1; t >= 0; t -= 1)
                                n.prepend(nn(a[t].cloneNode(!0)).addClass(r.slideDuplicateClass));
                        },
                        loopFix: function () {
                            const t = this;
                            t.emit("beforeLoopFix");
                            const {
                                activeIndex: e,
                                slides: r,
                                loopedSlides: i,
                                allowSlidePrev: n,
                                allowSlideNext: s,
                                snapGrid: a,
                                rtlTranslate: o,
                            } = t;
                            let l;
                            (t.allowSlidePrev = !0), (t.allowSlideNext = !0);
                            const h = -a[e] - t.getTranslate();
                            e < i
                                ? ((l = r.length - 3 * i + e),
                                  (l += i),
                                  t.slideTo(l, 0, !1, !0) &&
                                      0 !== h &&
                                      t.setTranslate((o ? -t.translate : t.translate) - h))
                                : e >= r.length - i &&
                                  ((l = -r.length + e + i),
                                  (l += i),
                                  t.slideTo(l, 0, !1, !0) &&
                                      0 !== h &&
                                      t.setTranslate((o ? -t.translate : t.translate) - h)),
                                (t.allowSlidePrev = n),
                                (t.allowSlideNext = s),
                                t.emit("loopFix");
                        },
                        loopDestroy: function () {
                            const { $wrapperEl: t, params: e, slides: r } = this;
                            t
                                .children(
                                    `.${e.slideClass}.${e.slideDuplicateClass},.${e.slideClass}.${e.slideBlankClass}`
                                )
                                .remove(),
                                r.removeAttr("data-swiper-slide-index");
                        },
                    },
                    grabCursor: {
                        setGrabCursor: function (t) {
                            const e = this;
                            if (
                                e.support.touch ||
                                !e.params.simulateTouch ||
                                (e.params.watchOverflow && e.isLocked) ||
                                e.params.cssMode
                            )
                                return;
                            const r = "container" === e.params.touchEventsTarget ? e.el : e.wrapperEl;
                            (r.style.cursor = "move"), (r.style.cursor = t ? "grabbing" : "grab");
                        },
                        unsetGrabCursor: function () {
                            const t = this;
                            t.support.touch ||
                                (t.params.watchOverflow && t.isLocked) ||
                                t.params.cssMode ||
                                (t["container" === t.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "");
                        },
                    },
                    events: {
                        attachEvents: function () {
                            const t = this,
                                e = Yi(),
                                { params: r, support: i } = t;
                            (t.onTouchStart = yn.bind(t)),
                                (t.onTouchMove = vn.bind(t)),
                                (t.onTouchEnd = bn.bind(t)),
                                r.cssMode && (t.onScroll = Sn.bind(t)),
                                (t.onClick = xn.bind(t)),
                                i.touch && !En && (e.addEventListener("touchstart", wn), (En = !0)),
                                Pn(t, "on");
                        },
                        detachEvents: function () {
                            Pn(this, "off");
                        },
                    },
                    breakpoints: {
                        setBreakpoint: function () {
                            const t = this,
                                { activeIndex: e, initialized: r, loopedSlides: i = 0, params: n, $el: s } = t,
                                a = n.breakpoints;
                            if (!a || (a && 0 === Object.keys(a).length)) return;
                            const o = t.getBreakpoint(a, t.params.breakpointsBase, t.el);
                            if (!o || t.currentBreakpoint === o) return;
                            const l = (o in a ? a[o] : void 0) || t.originalParams,
                                h = Tn(t, n),
                                p = Tn(t, l),
                                c = n.enabled;
                            h && !p
                                ? (s.removeClass(
                                      `${n.containerModifierClass}grid ${n.containerModifierClass}grid-column`
                                  ),
                                  t.emitContainerClasses())
                                : !h &&
                                  p &&
                                  (s.addClass(`${n.containerModifierClass}grid`),
                                  ((l.grid.fill && "column" === l.grid.fill) ||
                                      (!l.grid.fill && "column" === n.grid.fill)) &&
                                      s.addClass(`${n.containerModifierClass}grid-column`),
                                  t.emitContainerClasses()),
                                ["navigation", "pagination", "scrollbar"].forEach((e) => {
                                    const r = n[e] && n[e].enabled,
                                        i = l[e] && l[e].enabled;
                                    r && !i && t[e].disable(), !r && i && t[e].enable();
                                });
                            const d = l.direction && l.direction !== n.direction,
                                u = n.loop && (l.slidesPerView !== n.slidesPerView || d);
                            d && r && t.changeDirection(), ln(t.params, l);
                            const f = t.params.enabled;
                            Object.assign(t, {
                                allowTouchMove: t.params.allowTouchMove,
                                allowSlideNext: t.params.allowSlideNext,
                                allowSlidePrev: t.params.allowSlidePrev,
                            }),
                                c && !f ? t.disable() : !c && f && t.enable(),
                                (t.currentBreakpoint = o),
                                t.emit("_beforeBreakpoint", l),
                                u &&
                                    r &&
                                    (t.loopDestroy(),
                                    t.loopCreate(),
                                    t.updateSlides(),
                                    t.slideTo(e - i + t.loopedSlides, 0, !1)),
                                t.emit("breakpoint", l);
                        },
                        getBreakpoint: function (t, e = "window", r) {
                            if (!t || ("container" === e && !r)) return;
                            let i = !1;
                            const n = Ui(),
                                s = "window" === e ? n.innerHeight : r.clientHeight,
                                a = Object.keys(t).map((t) => {
                                    if ("string" == typeof t && 0 === t.indexOf("@")) {
                                        const e = parseFloat(t.substr(1));
                                        return { value: s * e, point: t };
                                    }
                                    return { value: t, point: t };
                                });
                            a.sort((t, e) => parseInt(t.value, 10) - parseInt(e.value, 10));
                            for (let t = 0; t < a.length; t += 1) {
                                const { point: s, value: o } = a[t];
                                "window" === e
                                    ? n.matchMedia(`(min-width: ${o}px)`).matches && (i = s)
                                    : o <= r.clientWidth && (i = s);
                            }
                            return i || "max";
                        },
                    },
                    checkOverflow: {
                        checkOverflow: function () {
                            const t = this,
                                { isLocked: e, params: r } = t,
                                { slidesOffsetBefore: i } = r;
                            if (i) {
                                const e = t.slides.length - 1,
                                    r = t.slidesGrid[e] + t.slidesSizesGrid[e] + 2 * i;
                                t.isLocked = t.size > r;
                            } else t.isLocked = 1 === t.snapGrid.length;
                            !0 === r.allowSlideNext && (t.allowSlideNext = !t.isLocked),
                                !0 === r.allowSlidePrev && (t.allowSlidePrev = !t.isLocked),
                                e && e !== t.isLocked && (t.isEnd = !1),
                                e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock");
                        },
                    },
                    classes: {
                        addClasses: function () {
                            const t = this,
                                { classNames: e, params: r, rtl: i, $el: n, device: s, support: a } = t,
                                o = (function (t, e) {
                                    const r = [];
                                    return (
                                        t.forEach((t) => {
                                            "object" == typeof t
                                                ? Object.keys(t).forEach((i) => {
                                                      t[i] && r.push(e + i);
                                                  })
                                                : "string" == typeof t && r.push(e + t);
                                        }),
                                        r
                                    );
                                })(
                                    [
                                        "initialized",
                                        r.direction,
                                        { "pointer-events": !a.touch },
                                        { "free-mode": t.params.freeMode && r.freeMode.enabled },
                                        { autoheight: r.autoHeight },
                                        { rtl: i },
                                        { grid: r.grid && r.grid.rows > 1 },
                                        { "grid-column": r.grid && r.grid.rows > 1 && "column" === r.grid.fill },
                                        { android: s.android },
                                        { ios: s.ios },
                                        { "css-mode": r.cssMode },
                                        { centered: r.cssMode && r.centeredSlides },
                                        { "watch-progress": r.watchSlidesProgress },
                                    ],
                                    r.containerModifierClass
                                );
                            e.push(...o), n.addClass([...e].join(" ")), t.emitContainerClasses();
                        },
                        removeClasses: function () {
                            const { $el: t, classNames: e } = this;
                            t.removeClass(e.join(" ")), this.emitContainerClasses();
                        },
                    },
                    images: {
                        loadImage: function (t, e, r, i, n, s) {
                            const a = Ui();
                            let o;
                            function l() {
                                s && s();
                            }
                            nn(t).parent("picture")[0] || (t.complete && n)
                                ? l()
                                : e
                                  ? ((o = new a.Image()),
                                    (o.onload = l),
                                    (o.onerror = l),
                                    i && (o.sizes = i),
                                    r && (o.srcset = r),
                                    e && (o.src = e))
                                  : l();
                        },
                        preloadImages: function () {
                            const t = this;
                            function e() {
                                null != t &&
                                    t &&
                                    !t.destroyed &&
                                    (void 0 !== t.imagesLoaded && (t.imagesLoaded += 1),
                                    t.imagesLoaded === t.imagesToLoad.length &&
                                        (t.params.updateOnImagesReady && t.update(), t.emit("imagesReady")));
                            }
                            t.imagesToLoad = t.$el.find("img");
                            for (let r = 0; r < t.imagesToLoad.length; r += 1) {
                                const i = t.imagesToLoad[r];
                                t.loadImage(
                                    i,
                                    i.currentSrc || i.getAttribute("src"),
                                    i.srcset || i.getAttribute("srcset"),
                                    i.sizes || i.getAttribute("sizes"),
                                    !0,
                                    e
                                );
                            }
                        },
                    },
                },
                Mn = {};
            class Dn {
                constructor(...t) {
                    let e, r;
                    if (
                        (1 === t.length &&
                        t[0].constructor &&
                        "Object" === Object.prototype.toString.call(t[0]).slice(8, -1)
                            ? (r = t[0])
                            : ([e, r] = t),
                        r || (r = {}),
                        (r = ln({}, r)),
                        e && !r.el && (r.el = e),
                        r.el && nn(r.el).length > 1)
                    ) {
                        const t = [];
                        return (
                            nn(r.el).each((e) => {
                                const i = ln({}, r, { el: e });
                                t.push(new Dn(i));
                            }),
                            t
                        );
                    }
                    const i = this;
                    (i.__swiper__ = !0),
                        (i.support = fn()),
                        (i.device = (function (t = {}) {
                            return (
                                dn ||
                                    (dn = (function ({ userAgent: t } = {}) {
                                        const e = fn(),
                                            r = Ui(),
                                            i = r.navigator.platform,
                                            n = t || r.navigator.userAgent,
                                            s = { ios: !1, android: !1 },
                                            a = r.screen.width,
                                            o = r.screen.height,
                                            l = n.match(/(Android);?[\s\/]+([\d.]+)?/);
                                        let h = n.match(/(iPad).*OS\s([\d_]+)/);
                                        const p = n.match(/(iPod)(.*OS\s([\d_]+))?/),
                                            c = !h && n.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                                            d = "Win32" === i;
                                        let u = "MacIntel" === i;
                                        return (
                                            !h &&
                                                u &&
                                                e.touch &&
                                                [
                                                    "1024x1366",
                                                    "1366x1024",
                                                    "834x1194",
                                                    "1194x834",
                                                    "834x1112",
                                                    "1112x834",
                                                    "768x1024",
                                                    "1024x768",
                                                    "820x1180",
                                                    "1180x820",
                                                    "810x1080",
                                                    "1080x810",
                                                ].indexOf(`${a}x${o}`) >= 0 &&
                                                ((h = n.match(/(Version)\/([\d.]+)/)),
                                                h || (h = [0, 1, "13_0_0"]),
                                                (u = !1)),
                                            l && !d && ((s.os = "android"), (s.android = !0)),
                                            (h || c || p) && ((s.os = "ios"), (s.ios = !0)),
                                            s
                                        );
                                    })(t)),
                                dn
                            );
                        })({ userAgent: r.userAgent })),
                        (i.browser =
                            (un ||
                                (un = (function () {
                                    const t = Ui();
                                    return {
                                        isSafari: (function () {
                                            const e = t.navigator.userAgent.toLowerCase();
                                            return (
                                                e.indexOf("safari") >= 0 &&
                                                e.indexOf("chrome") < 0 &&
                                                e.indexOf("android") < 0
                                            );
                                        })(),
                                        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
                                            t.navigator.userAgent
                                        ),
                                    };
                                })()),
                            un)),
                        (i.eventsListeners = {}),
                        (i.eventsAnyListeners = []),
                        (i.modules = [...i.__modules__]),
                        r.modules && Array.isArray(r.modules) && i.modules.push(...r.modules);
                    const n = {};
                    i.modules.forEach((t) => {
                        t({
                            swiper: i,
                            extendParams: An(r, n),
                            on: i.on.bind(i),
                            once: i.once.bind(i),
                            off: i.off.bind(i),
                            emit: i.emit.bind(i),
                        });
                    });
                    const s = ln({}, Cn, n);
                    return (
                        (i.params = ln({}, s, Mn, r)),
                        (i.originalParams = ln({}, i.params)),
                        (i.passedParams = ln({}, r)),
                        i.params &&
                            i.params.on &&
                            Object.keys(i.params.on).forEach((t) => {
                                i.on(t, i.params.on[t]);
                            }),
                        i.params && i.params.onAny && i.onAny(i.params.onAny),
                        (i.$ = nn),
                        Object.assign(i, {
                            enabled: i.params.enabled,
                            el: e,
                            classNames: [],
                            slides: nn(),
                            slidesGrid: [],
                            snapGrid: [],
                            slidesSizesGrid: [],
                            isHorizontal: () => "horizontal" === i.params.direction,
                            isVertical: () => "vertical" === i.params.direction,
                            activeIndex: 0,
                            realIndex: 0,
                            isBeginning: !0,
                            isEnd: !1,
                            translate: 0,
                            previousTranslate: 0,
                            progress: 0,
                            velocity: 0,
                            animating: !1,
                            allowSlideNext: i.params.allowSlideNext,
                            allowSlidePrev: i.params.allowSlidePrev,
                            touchEvents: (function () {
                                const t = ["touchstart", "touchmove", "touchend", "touchcancel"],
                                    e = ["pointerdown", "pointermove", "pointerup"];
                                return (
                                    (i.touchEventsTouch = { start: t[0], move: t[1], end: t[2], cancel: t[3] }),
                                    (i.touchEventsDesktop = { start: e[0], move: e[1], end: e[2] }),
                                    i.support.touch || !i.params.simulateTouch
                                        ? i.touchEventsTouch
                                        : i.touchEventsDesktop
                                );
                            })(),
                            touchEventsData: {
                                isTouched: void 0,
                                isMoved: void 0,
                                allowTouchCallbacks: void 0,
                                touchStartTime: void 0,
                                isScrolling: void 0,
                                currentTranslate: void 0,
                                startTranslate: void 0,
                                allowThresholdMove: void 0,
                                focusableElements: i.params.focusableElements,
                                lastClickTime: an(),
                                clickTimeout: void 0,
                                velocities: [],
                                allowMomentumBounce: void 0,
                                isTouchEvent: void 0,
                                startMoving: void 0,
                            },
                            allowClick: !0,
                            allowTouchMove: i.params.allowTouchMove,
                            touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
                            imagesToLoad: [],
                            imagesLoaded: 0,
                        }),
                        i.emit("_swiper"),
                        i.params.init && i.init(),
                        i
                    );
                }
                enable() {
                    const t = this;
                    t.enabled || ((t.enabled = !0), t.params.grabCursor && t.setGrabCursor(), t.emit("enable"));
                }
                disable() {
                    const t = this;
                    t.enabled && ((t.enabled = !1), t.params.grabCursor && t.unsetGrabCursor(), t.emit("disable"));
                }
                setProgress(t, e) {
                    const r = this;
                    t = Math.min(Math.max(t, 0), 1);
                    const i = r.minTranslate(),
                        n = (r.maxTranslate() - i) * t + i;
                    r.translateTo(n, void 0 === e ? 0 : e), r.updateActiveIndex(), r.updateSlidesClasses();
                }
                emitContainerClasses() {
                    const t = this;
                    if (!t.params._emitClasses || !t.el) return;
                    const e = t.el.className
                        .split(" ")
                        .filter((e) => 0 === e.indexOf("swiper") || 0 === e.indexOf(t.params.containerModifierClass));
                    t.emit("_containerClasses", e.join(" "));
                }
                getSlideClasses(t) {
                    const e = this;
                    return e.destroyed
                        ? ""
                        : t.className
                              .split(" ")
                              .filter((t) => 0 === t.indexOf("swiper-slide") || 0 === t.indexOf(e.params.slideClass))
                              .join(" ");
                }
                emitSlidesClasses() {
                    const t = this;
                    if (!t.params._emitClasses || !t.el) return;
                    const e = [];
                    t.slides.each((r) => {
                        const i = t.getSlideClasses(r);
                        e.push({ slideEl: r, classNames: i }), t.emit("_slideClass", r, i);
                    }),
                        t.emit("_slideClasses", e);
                }
                slidesPerViewDynamic(t = "current", e = !1) {
                    const { params: r, slides: i, slidesGrid: n, slidesSizesGrid: s, size: a, activeIndex: o } = this;
                    let l = 1;
                    if (r.centeredSlides) {
                        let t,
                            e = i[o].swiperSlideSize;
                        for (let r = o + 1; r < i.length; r += 1)
                            i[r] && !t && ((e += i[r].swiperSlideSize), (l += 1), e > a && (t = !0));
                        for (let r = o - 1; r >= 0; r -= 1)
                            i[r] && !t && ((e += i[r].swiperSlideSize), (l += 1), e > a && (t = !0));
                    } else if ("current" === t)
                        for (let t = o + 1; t < i.length; t += 1)
                            (e ? n[t] + s[t] - n[o] < a : n[t] - n[o] < a) && (l += 1);
                    else for (let t = o - 1; t >= 0; t -= 1) n[o] - n[t] < a && (l += 1);
                    return l;
                }
                update() {
                    const t = this;
                    if (!t || t.destroyed) return;
                    const { snapGrid: e, params: r } = t;
                    function i() {
                        const e = t.rtlTranslate ? -1 * t.translate : t.translate,
                            r = Math.min(Math.max(e, t.maxTranslate()), t.minTranslate());
                        t.setTranslate(r), t.updateActiveIndex(), t.updateSlidesClasses();
                    }
                    let n;
                    r.breakpoints && t.setBreakpoint(),
                        t.updateSize(),
                        t.updateSlides(),
                        t.updateProgress(),
                        t.updateSlidesClasses(),
                        t.params.freeMode && t.params.freeMode.enabled
                            ? (i(), t.params.autoHeight && t.updateAutoHeight())
                            : ((n =
                                  ("auto" === t.params.slidesPerView || t.params.slidesPerView > 1) &&
                                  t.isEnd &&
                                  !t.params.centeredSlides
                                      ? t.slideTo(t.slides.length - 1, 0, !1, !0)
                                      : t.slideTo(t.activeIndex, 0, !1, !0)),
                              n || i()),
                        r.watchOverflow && e !== t.snapGrid && t.checkOverflow(),
                        t.emit("update");
                }
                changeDirection(t, e = !0) {
                    const r = this,
                        i = r.params.direction;
                    return (
                        t || (t = "horizontal" === i ? "vertical" : "horizontal"),
                        t === i ||
                            ("horizontal" !== t && "vertical" !== t) ||
                            (r.$el
                                .removeClass(`${r.params.containerModifierClass}${i}`)
                                .addClass(`${r.params.containerModifierClass}${t}`),
                            r.emitContainerClasses(),
                            (r.params.direction = t),
                            r.slides.each((e) => {
                                "vertical" === t ? (e.style.width = "") : (e.style.height = "");
                            }),
                            r.emit("changeDirection"),
                            e && r.update()),
                        r
                    );
                }
                changeLanguageDirection(t) {
                    const e = this;
                    (e.rtl && "rtl" === t) ||
                        (!e.rtl && "ltr" === t) ||
                        ((e.rtl = "rtl" === t),
                        (e.rtlTranslate = "horizontal" === e.params.direction && e.rtl),
                        e.rtl
                            ? (e.$el.addClass(`${e.params.containerModifierClass}rtl`), (e.el.dir = "rtl"))
                            : (e.$el.removeClass(`${e.params.containerModifierClass}rtl`), (e.el.dir = "ltr")),
                        e.update());
                }
                mount(t) {
                    const e = this;
                    if (e.mounted) return !0;
                    const r = nn(t || e.params.el);
                    if (!(t = r[0])) return !1;
                    t.swiper = e;
                    const i = () => `.${(e.params.wrapperClass || "").trim().split(" ").join(".")}`;
                    let n = (() => {
                        if (t && t.shadowRoot && t.shadowRoot.querySelector) {
                            const e = nn(t.shadowRoot.querySelector(i()));
                            return (e.children = (t) => r.children(t)), e;
                        }
                        return r.children ? r.children(i()) : nn(r).children(i());
                    })();
                    if (0 === n.length && e.params.createElements) {
                        const t = Yi().createElement("div");
                        (n = nn(t)),
                            (t.className = e.params.wrapperClass),
                            r.append(t),
                            r.children(`.${e.params.slideClass}`).each((t) => {
                                n.append(t);
                            });
                    }
                    return (
                        Object.assign(e, {
                            $el: r,
                            el: t,
                            $wrapperEl: n,
                            wrapperEl: n[0],
                            mounted: !0,
                            rtl: "rtl" === t.dir.toLowerCase() || "rtl" === r.css("direction"),
                            rtlTranslate:
                                "horizontal" === e.params.direction &&
                                ("rtl" === t.dir.toLowerCase() || "rtl" === r.css("direction")),
                            wrongRTL: "-webkit-box" === n.css("display"),
                        }),
                        !0
                    );
                }
                init(t) {
                    const e = this;
                    return (
                        e.initialized ||
                            !1 === e.mount(t) ||
                            (e.emit("beforeInit"),
                            e.params.breakpoints && e.setBreakpoint(),
                            e.addClasses(),
                            e.params.loop && e.loopCreate(),
                            e.updateSize(),
                            e.updateSlides(),
                            e.params.watchOverflow && e.checkOverflow(),
                            e.params.grabCursor && e.enabled && e.setGrabCursor(),
                            e.params.preloadImages && e.preloadImages(),
                            e.params.loop
                                ? e.slideTo(
                                      e.params.initialSlide + e.loopedSlides,
                                      0,
                                      e.params.runCallbacksOnInit,
                                      !1,
                                      !0
                                  )
                                : e.slideTo(e.params.initialSlide, 0, e.params.runCallbacksOnInit, !1, !0),
                            e.attachEvents(),
                            (e.initialized = !0),
                            e.emit("init"),
                            e.emit("afterInit")),
                        e
                    );
                }
                destroy(t = !0, e = !0) {
                    const r = this,
                        { params: i, $el: n, $wrapperEl: s, slides: a } = r;
                    return (
                        void 0 === r.params ||
                            r.destroyed ||
                            (r.emit("beforeDestroy"),
                            (r.initialized = !1),
                            r.detachEvents(),
                            i.loop && r.loopDestroy(),
                            e &&
                                (r.removeClasses(),
                                n.removeAttr("style"),
                                s.removeAttr("style"),
                                a &&
                                    a.length &&
                                    a
                                        .removeClass(
                                            [
                                                i.slideVisibleClass,
                                                i.slideActiveClass,
                                                i.slideNextClass,
                                                i.slidePrevClass,
                                            ].join(" ")
                                        )
                                        .removeAttr("style")
                                        .removeAttr("data-swiper-slide-index")),
                            r.emit("destroy"),
                            Object.keys(r.eventsListeners).forEach((t) => {
                                r.off(t);
                            }),
                            !1 !== t &&
                                ((r.$el[0].swiper = null),
                                (function (t) {
                                    const e = t;
                                    Object.keys(e).forEach((t) => {
                                        try {
                                            e[t] = null;
                                        } catch (t) {}
                                        try {
                                            delete e[t];
                                        } catch (t) {}
                                    });
                                })(r)),
                            (r.destroyed = !0)),
                        null
                    );
                }
                static extendDefaults(t) {
                    ln(Mn, t);
                }
                static get extendedDefaults() {
                    return Mn;
                }
                static get defaults() {
                    return Cn;
                }
                static installModule(t) {
                    Dn.prototype.__modules__ || (Dn.prototype.__modules__ = []);
                    const e = Dn.prototype.__modules__;
                    "function" == typeof t && e.indexOf(t) < 0 && e.push(t);
                }
                static use(t) {
                    return Array.isArray(t) ? (t.forEach((t) => Dn.installModule(t)), Dn) : (Dn.installModule(t), Dn);
                }
            }
            Object.keys(kn).forEach((t) => {
                Object.keys(kn[t]).forEach((e) => {
                    Dn.prototype[e] = kn[t][e];
                });
            }),
                Dn.use([
                    function ({ swiper: t, on: e, emit: r }) {
                        const i = Ui();
                        let n = null,
                            s = null;
                        const a = () => {
                                t && !t.destroyed && t.initialized && (r("beforeResize"), r("resize"));
                            },
                            o = () => {
                                t && !t.destroyed && t.initialized && r("orientationchange");
                            };
                        e("init", () => {
                            t.params.resizeObserver && void 0 !== i.ResizeObserver
                                ? t &&
                                  !t.destroyed &&
                                  t.initialized &&
                                  ((n = new ResizeObserver((e) => {
                                      s = i.requestAnimationFrame(() => {
                                          const { width: r, height: i } = t;
                                          let n = r,
                                              s = i;
                                          e.forEach(({ contentBoxSize: e, contentRect: r, target: i }) => {
                                              (i && i !== t.el) ||
                                                  ((n = r ? r.width : (e[0] || e).inlineSize),
                                                  (s = r ? r.height : (e[0] || e).blockSize));
                                          }),
                                              (n === r && s === i) || a();
                                      });
                                  })),
                                  n.observe(t.el))
                                : (i.addEventListener("resize", a), i.addEventListener("orientationchange", o));
                        }),
                            e("destroy", () => {
                                s && i.cancelAnimationFrame(s),
                                    n && n.unobserve && t.el && (n.unobserve(t.el), (n = null)),
                                    i.removeEventListener("resize", a),
                                    i.removeEventListener("orientationchange", o);
                            });
                    },
                    function ({ swiper: t, extendParams: e, on: r, emit: i }) {
                        const n = [],
                            s = Ui(),
                            a = (t, e = {}) => {
                                const r = new (s.MutationObserver || s.WebkitMutationObserver)((t) => {
                                    if (1 === t.length) return void i("observerUpdate", t[0]);
                                    const e = function () {
                                        i("observerUpdate", t[0]);
                                    };
                                    s.requestAnimationFrame ? s.requestAnimationFrame(e) : s.setTimeout(e, 0);
                                });
                                r.observe(t, {
                                    attributes: void 0 === e.attributes || e.attributes,
                                    childList: void 0 === e.childList || e.childList,
                                    characterData: void 0 === e.characterData || e.characterData,
                                }),
                                    n.push(r);
                            };
                        e({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
                            r("init", () => {
                                if (t.params.observer) {
                                    if (t.params.observeParents) {
                                        const e = t.$el.parents();
                                        for (let t = 0; t < e.length; t += 1) a(e[t]);
                                    }
                                    a(t.$el[0], { childList: t.params.observeSlideChildren }),
                                        a(t.$wrapperEl[0], { attributes: !1 });
                                }
                            }),
                            r("destroy", () => {
                                n.forEach((t) => {
                                    t.disconnect();
                                }),
                                    n.splice(0, n.length);
                            });
                    },
                ]);
            const Fn = Dn;
            function In({ swiper: t, extendParams: e, on: r, emit: i }) {
                const n = Ui();
                let s;
                e({
                    mousewheel: {
                        enabled: !1,
                        releaseOnEdges: !1,
                        invert: !1,
                        forceToAxis: !1,
                        sensitivity: 1,
                        eventsTarget: "container",
                        thresholdDelta: null,
                        thresholdTime: null,
                    },
                }),
                    (t.mousewheel = { enabled: !1 });
                let a,
                    o = an();
                const l = [];
                function h() {
                    t.enabled && (t.mouseEntered = !0);
                }
                function p() {
                    t.enabled && (t.mouseEntered = !1);
                }
                function c(e) {
                    return !(
                        (t.params.mousewheel.thresholdDelta && e.delta < t.params.mousewheel.thresholdDelta) ||
                        (t.params.mousewheel.thresholdTime && an() - o < t.params.mousewheel.thresholdTime) ||
                        (!(e.delta >= 6 && an() - o < 60) &&
                            (e.direction < 0
                                ? (t.isEnd && !t.params.loop) || t.animating || (t.slideNext(), i("scroll", e.raw))
                                : (t.isBeginning && !t.params.loop) ||
                                  t.animating ||
                                  (t.slidePrev(), i("scroll", e.raw)),
                            (o = new n.Date().getTime()),
                            1))
                    );
                }
                function d(e) {
                    let r = e,
                        n = !0;
                    if (!t.enabled) return;
                    const o = t.params.mousewheel;
                    t.params.cssMode && r.preventDefault();
                    let h = t.$el;
                    if (
                        ("container" !== t.params.mousewheel.eventsTarget && (h = nn(t.params.mousewheel.eventsTarget)),
                        !t.mouseEntered && !h[0].contains(r.target) && !o.releaseOnEdges)
                    )
                        return !0;
                    r.originalEvent && (r = r.originalEvent);
                    let p = 0;
                    const d = t.rtlTranslate ? -1 : 1,
                        u = (function (t) {
                            let e = 0,
                                r = 0,
                                i = 0,
                                n = 0;
                            return (
                                "detail" in t && (r = t.detail),
                                "wheelDelta" in t && (r = -t.wheelDelta / 120),
                                "wheelDeltaY" in t && (r = -t.wheelDeltaY / 120),
                                "wheelDeltaX" in t && (e = -t.wheelDeltaX / 120),
                                "axis" in t && t.axis === t.HORIZONTAL_AXIS && ((e = r), (r = 0)),
                                (i = 10 * e),
                                (n = 10 * r),
                                "deltaY" in t && (n = t.deltaY),
                                "deltaX" in t && (i = t.deltaX),
                                t.shiftKey && !i && ((i = n), (n = 0)),
                                (i || n) &&
                                    t.deltaMode &&
                                    (1 === t.deltaMode ? ((i *= 40), (n *= 40)) : ((i *= 800), (n *= 800))),
                                i && !e && (e = i < 1 ? -1 : 1),
                                n && !r && (r = n < 1 ? -1 : 1),
                                { spinX: e, spinY: r, pixelX: i, pixelY: n }
                            );
                        })(r);
                    if (o.forceToAxis)
                        if (t.isHorizontal()) {
                            if (!(Math.abs(u.pixelX) > Math.abs(u.pixelY))) return !0;
                            p = -u.pixelX * d;
                        } else {
                            if (!(Math.abs(u.pixelY) > Math.abs(u.pixelX))) return !0;
                            p = -u.pixelY;
                        }
                    else p = Math.abs(u.pixelX) > Math.abs(u.pixelY) ? -u.pixelX * d : -u.pixelY;
                    if (0 === p) return !0;
                    o.invert && (p = -p);
                    let f = t.getTranslate() + p * o.sensitivity;
                    if (
                        (f >= t.minTranslate() && (f = t.minTranslate()),
                        f <= t.maxTranslate() && (f = t.maxTranslate()),
                        (n = !!t.params.loop || !(f === t.minTranslate() || f === t.maxTranslate())),
                        n && t.params.nested && r.stopPropagation(),
                        t.params.freeMode && t.params.freeMode.enabled)
                    ) {
                        const e = { time: an(), delta: Math.abs(p), direction: Math.sign(p) },
                            n = a && e.time < a.time + 500 && e.delta <= a.delta && e.direction === a.direction;
                        if (!n) {
                            (a = void 0), t.params.loop && t.loopFix();
                            let h = t.getTranslate() + p * o.sensitivity;
                            const c = t.isBeginning,
                                d = t.isEnd;
                            if (
                                (h >= t.minTranslate() && (h = t.minTranslate()),
                                h <= t.maxTranslate() && (h = t.maxTranslate()),
                                t.setTransition(0),
                                t.setTranslate(h),
                                t.updateProgress(),
                                t.updateActiveIndex(),
                                t.updateSlidesClasses(),
                                ((!c && t.isBeginning) || (!d && t.isEnd)) && t.updateSlidesClasses(),
                                t.params.freeMode.sticky)
                            ) {
                                clearTimeout(s), (s = void 0), l.length >= 15 && l.shift();
                                const r = l.length ? l[l.length - 1] : void 0,
                                    i = l[0];
                                if ((l.push(e), r && (e.delta > r.delta || e.direction !== r.direction))) l.splice(0);
                                else if (
                                    l.length >= 15 &&
                                    e.time - i.time < 500 &&
                                    i.delta - e.delta >= 1 &&
                                    e.delta <= 6
                                ) {
                                    const r = p > 0 ? 0.8 : 0.2;
                                    (a = e),
                                        l.splice(0),
                                        (s = sn(() => {
                                            t.slideToClosest(t.params.speed, !0, void 0, r);
                                        }, 0));
                                }
                                s ||
                                    (s = sn(() => {
                                        (a = e), l.splice(0), t.slideToClosest(t.params.speed, !0, void 0, 0.5);
                                    }, 500));
                            }
                            if (
                                (n || i("scroll", r),
                                t.params.autoplay && t.params.autoplayDisableOnInteraction && t.autoplay.stop(),
                                h === t.minTranslate() || h === t.maxTranslate())
                            )
                                return !0;
                        }
                    } else {
                        const r = { time: an(), delta: Math.abs(p), direction: Math.sign(p), raw: e };
                        l.length >= 2 && l.shift();
                        const i = l.length ? l[l.length - 1] : void 0;
                        if (
                            (l.push(r),
                            i
                                ? (r.direction !== i.direction || r.delta > i.delta || r.time > i.time + 150) && c(r)
                                : c(r),
                            (function (e) {
                                const r = t.params.mousewheel;
                                if (e.direction < 0) {
                                    if (t.isEnd && !t.params.loop && r.releaseOnEdges) return !0;
                                } else if (t.isBeginning && !t.params.loop && r.releaseOnEdges) return !0;
                                return !1;
                            })(r))
                        )
                            return !0;
                    }
                    return r.preventDefault ? r.preventDefault() : (r.returnValue = !1), !1;
                }
                function u(e) {
                    let r = t.$el;
                    "container" !== t.params.mousewheel.eventsTarget && (r = nn(t.params.mousewheel.eventsTarget)),
                        r[e]("mouseenter", h),
                        r[e]("mouseleave", p),
                        r[e]("wheel", d);
                }
                function f() {
                    return t.params.cssMode
                        ? (t.wrapperEl.removeEventListener("wheel", d), !0)
                        : !t.mousewheel.enabled && (u("on"), (t.mousewheel.enabled = !0), !0);
                }
                function m() {
                    return t.params.cssMode
                        ? (t.wrapperEl.addEventListener(event, d), !0)
                        : !!t.mousewheel.enabled && (u("off"), (t.mousewheel.enabled = !1), !0);
                }
                r("init", () => {
                    !t.params.mousewheel.enabled && t.params.cssMode && m(), t.params.mousewheel.enabled && f();
                }),
                    r("destroy", () => {
                        t.params.cssMode && f(), t.mousewheel.enabled && m();
                    }),
                    Object.assign(t.mousewheel, { enable: f, disable: m });
            }
            function Ln(t = "") {
                return `.${t
                    .trim()
                    .replace(/([\.:!\/])/g, "\\$1")
                    .replace(/ /g, ".")}`;
            }
            function Bn({ swiper: t, extendParams: e, on: r, emit: i }) {
                const n = "swiper-pagination";
                let s;
                e({
                    pagination: {
                        el: null,
                        bulletElement: "span",
                        clickable: !1,
                        hideOnClick: !1,
                        renderBullet: null,
                        renderProgressbar: null,
                        renderFraction: null,
                        renderCustom: null,
                        progressbarOpposite: !1,
                        type: "bullets",
                        dynamicBullets: !1,
                        dynamicMainBullets: 1,
                        formatFractionCurrent: (t) => t,
                        formatFractionTotal: (t) => t,
                        bulletClass: `${n}-bullet`,
                        bulletActiveClass: `${n}-bullet-active`,
                        modifierClass: `${n}-`,
                        currentClass: `${n}-current`,
                        totalClass: `${n}-total`,
                        hiddenClass: `${n}-hidden`,
                        progressbarFillClass: `${n}-progressbar-fill`,
                        progressbarOppositeClass: `${n}-progressbar-opposite`,
                        clickableClass: `${n}-clickable`,
                        lockClass: `${n}-lock`,
                        horizontalClass: `${n}-horizontal`,
                        verticalClass: `${n}-vertical`,
                        paginationDisabledClass: `${n}-disabled`,
                    },
                }),
                    (t.pagination = { el: null, $el: null, bullets: [] });
                let a = 0;
                function o() {
                    return (
                        !t.params.pagination.el ||
                        !t.pagination.el ||
                        !t.pagination.$el ||
                        0 === t.pagination.$el.length
                    );
                }
                function l(e, r) {
                    const { bulletActiveClass: i } = t.params.pagination;
                    e[r]().addClass(`${i}-${r}`)[r]().addClass(`${i}-${r}-${r}`);
                }
                function h() {
                    const e = t.rtl,
                        r = t.params.pagination;
                    if (o()) return;
                    const n = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length,
                        h = t.pagination.$el;
                    let p;
                    const c = t.params.loop
                        ? Math.ceil((n - 2 * t.loopedSlides) / t.params.slidesPerGroup)
                        : t.snapGrid.length;
                    if (
                        (t.params.loop
                            ? ((p = Math.ceil((t.activeIndex - t.loopedSlides) / t.params.slidesPerGroup)),
                              p > n - 1 - 2 * t.loopedSlides && (p -= n - 2 * t.loopedSlides),
                              p > c - 1 && (p -= c),
                              p < 0 && "bullets" !== t.params.paginationType && (p = c + p))
                            : (p = void 0 !== t.snapIndex ? t.snapIndex : t.activeIndex || 0),
                        "bullets" === r.type && t.pagination.bullets && t.pagination.bullets.length > 0)
                    ) {
                        const i = t.pagination.bullets;
                        let n, o, c;
                        if (
                            (r.dynamicBullets &&
                                ((s = i.eq(0)[t.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                                h.css(t.isHorizontal() ? "width" : "height", s * (r.dynamicMainBullets + 4) + "px"),
                                r.dynamicMainBullets > 1 &&
                                    void 0 !== t.previousIndex &&
                                    ((a += p - (t.previousIndex - t.loopedSlides || 0)),
                                    a > r.dynamicMainBullets - 1 ? (a = r.dynamicMainBullets - 1) : a < 0 && (a = 0)),
                                (n = Math.max(p - a, 0)),
                                (o = n + (Math.min(i.length, r.dynamicMainBullets) - 1)),
                                (c = (o + n) / 2)),
                            i.removeClass(
                                ["", "-next", "-next-next", "-prev", "-prev-prev", "-main"]
                                    .map((t) => `${r.bulletActiveClass}${t}`)
                                    .join(" ")
                            ),
                            h.length > 1)
                        )
                            i.each((t) => {
                                const e = nn(t),
                                    i = e.index();
                                i === p && e.addClass(r.bulletActiveClass),
                                    r.dynamicBullets &&
                                        (i >= n && i <= o && e.addClass(`${r.bulletActiveClass}-main`),
                                        i === n && l(e, "prev"),
                                        i === o && l(e, "next"));
                            });
                        else {
                            const e = i.eq(p),
                                s = e.index();
                            if ((e.addClass(r.bulletActiveClass), r.dynamicBullets)) {
                                const e = i.eq(n),
                                    a = i.eq(o);
                                for (let t = n; t <= o; t += 1) i.eq(t).addClass(`${r.bulletActiveClass}-main`);
                                if (t.params.loop)
                                    if (s >= i.length) {
                                        for (let t = r.dynamicMainBullets; t >= 0; t -= 1)
                                            i.eq(i.length - t).addClass(`${r.bulletActiveClass}-main`);
                                        i.eq(i.length - r.dynamicMainBullets - 1).addClass(
                                            `${r.bulletActiveClass}-prev`
                                        );
                                    } else l(e, "prev"), l(a, "next");
                                else l(e, "prev"), l(a, "next");
                            }
                        }
                        if (r.dynamicBullets) {
                            const n = Math.min(i.length, r.dynamicMainBullets + 4),
                                a = (s * n - s) / 2 - c * s,
                                o = e ? "right" : "left";
                            i.css(t.isHorizontal() ? o : "top", `${a}px`);
                        }
                    }
                    if (
                        ("fraction" === r.type &&
                            (h.find(Ln(r.currentClass)).text(r.formatFractionCurrent(p + 1)),
                            h.find(Ln(r.totalClass)).text(r.formatFractionTotal(c))),
                        "progressbar" === r.type)
                    ) {
                        let e;
                        e = r.progressbarOpposite
                            ? t.isHorizontal()
                                ? "vertical"
                                : "horizontal"
                            : t.isHorizontal()
                              ? "horizontal"
                              : "vertical";
                        const i = (p + 1) / c;
                        let n = 1,
                            s = 1;
                        "horizontal" === e ? (n = i) : (s = i),
                            h
                                .find(Ln(r.progressbarFillClass))
                                .transform(`translate3d(0,0,0) scaleX(${n}) scaleY(${s})`)
                                .transition(t.params.speed);
                    }
                    "custom" === r.type && r.renderCustom
                        ? (h.html(r.renderCustom(t, p + 1, c)), i("paginationRender", h[0]))
                        : i("paginationUpdate", h[0]),
                        t.params.watchOverflow && t.enabled && h[t.isLocked ? "addClass" : "removeClass"](r.lockClass);
                }
                function p() {
                    const e = t.params.pagination;
                    if (o()) return;
                    const r = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length,
                        n = t.pagination.$el;
                    let s = "";
                    if ("bullets" === e.type) {
                        let i = t.params.loop
                            ? Math.ceil((r - 2 * t.loopedSlides) / t.params.slidesPerGroup)
                            : t.snapGrid.length;
                        t.params.freeMode && t.params.freeMode.enabled && !t.params.loop && i > r && (i = r);
                        for (let r = 0; r < i; r += 1)
                            e.renderBullet
                                ? (s += e.renderBullet.call(t, r, e.bulletClass))
                                : (s += `<${e.bulletElement} class="${e.bulletClass}"></${e.bulletElement}>`);
                        n.html(s), (t.pagination.bullets = n.find(Ln(e.bulletClass)));
                    }
                    "fraction" === e.type &&
                        ((s = e.renderFraction
                            ? e.renderFraction.call(t, e.currentClass, e.totalClass)
                            : `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),
                        n.html(s)),
                        "progressbar" === e.type &&
                            ((s = e.renderProgressbar
                                ? e.renderProgressbar.call(t, e.progressbarFillClass)
                                : `<span class="${e.progressbarFillClass}"></span>`),
                            n.html(s)),
                        "custom" !== e.type && i("paginationRender", t.pagination.$el[0]);
                }
                function c() {
                    t.params.pagination = (function (t, e, r, i) {
                        const n = Yi();
                        return (
                            t.params.createElements &&
                                Object.keys(i).forEach((s) => {
                                    if (!r[s] && !0 === r.auto) {
                                        let a = t.$el.children(`.${i[s]}`)[0];
                                        a || ((a = n.createElement("div")), (a.className = i[s]), t.$el.append(a)),
                                            (r[s] = a),
                                            (e[s] = a);
                                    }
                                }),
                            r
                        );
                    })(t, t.originalParams.pagination, t.params.pagination, { el: "swiper-pagination" });
                    const e = t.params.pagination;
                    if (!e.el) return;
                    let r = nn(e.el);
                    0 !== r.length &&
                        (t.params.uniqueNavElements &&
                            "string" == typeof e.el &&
                            r.length > 1 &&
                            ((r = t.$el.find(e.el)),
                            r.length > 1 && (r = r.filter((e) => nn(e).parents(".swiper")[0] === t.el))),
                        "bullets" === e.type && e.clickable && r.addClass(e.clickableClass),
                        r.addClass(e.modifierClass + e.type),
                        r.addClass(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
                        "bullets" === e.type &&
                            e.dynamicBullets &&
                            (r.addClass(`${e.modifierClass}${e.type}-dynamic`),
                            (a = 0),
                            e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
                        "progressbar" === e.type && e.progressbarOpposite && r.addClass(e.progressbarOppositeClass),
                        e.clickable &&
                            r.on("click", Ln(e.bulletClass), function (e) {
                                e.preventDefault();
                                let r = nn(this).index() * t.params.slidesPerGroup;
                                t.params.loop && (r += t.loopedSlides), t.slideTo(r);
                            }),
                        Object.assign(t.pagination, { $el: r, el: r[0] }),
                        t.enabled || r.addClass(e.lockClass));
                }
                function d() {
                    const e = t.params.pagination;
                    if (o()) return;
                    const r = t.pagination.$el;
                    r.removeClass(e.hiddenClass),
                        r.removeClass(e.modifierClass + e.type),
                        r.removeClass(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
                        t.pagination.bullets &&
                            t.pagination.bullets.removeClass &&
                            t.pagination.bullets.removeClass(e.bulletActiveClass),
                        e.clickable && r.off("click", Ln(e.bulletClass));
                }
                r("init", () => {
                    !1 === t.params.pagination.enabled ? u() : (c(), p(), h());
                }),
                    r("activeIndexChange", () => {
                        (t.params.loop || void 0 === t.snapIndex) && h();
                    }),
                    r("snapIndexChange", () => {
                        t.params.loop || h();
                    }),
                    r("slidesLengthChange", () => {
                        t.params.loop && (p(), h());
                    }),
                    r("snapGridLengthChange", () => {
                        t.params.loop || (p(), h());
                    }),
                    r("destroy", () => {
                        d();
                    }),
                    r("enable disable", () => {
                        const { $el: e } = t.pagination;
                        e && e[t.enabled ? "removeClass" : "addClass"](t.params.pagination.lockClass);
                    }),
                    r("lock unlock", () => {
                        h();
                    }),
                    r("click", (e, r) => {
                        const n = r.target,
                            { $el: s } = t.pagination;
                        if (
                            t.params.pagination.el &&
                            t.params.pagination.hideOnClick &&
                            s &&
                            s.length > 0 &&
                            !nn(n).hasClass(t.params.pagination.bulletClass)
                        ) {
                            if (
                                t.navigation &&
                                ((t.navigation.nextEl && n === t.navigation.nextEl) ||
                                    (t.navigation.prevEl && n === t.navigation.prevEl))
                            )
                                return;
                            const e = s.hasClass(t.params.pagination.hiddenClass);
                            i(!0 === e ? "paginationShow" : "paginationHide"),
                                s.toggleClass(t.params.pagination.hiddenClass);
                        }
                    });
                const u = () => {
                    t.$el.addClass(t.params.pagination.paginationDisabledClass),
                        t.pagination.$el && t.pagination.$el.addClass(t.params.pagination.paginationDisabledClass),
                        d();
                };
                Object.assign(t.pagination, {
                    enable: () => {
                        t.$el.removeClass(t.params.pagination.paginationDisabledClass),
                            t.pagination.$el &&
                                t.pagination.$el.removeClass(t.params.pagination.paginationDisabledClass),
                            c(),
                            p(),
                            h();
                    },
                    disable: u,
                    render: p,
                    update: h,
                    init: c,
                    destroy: d,
                });
            }
            function Vn({ swiper: t, extendParams: e, on: r, emit: i }) {
                let n;
                function s() {
                    if (!t.size) return (t.autoplay.running = !1), void (t.autoplay.paused = !1);
                    const e = t.slides.eq(t.activeIndex);
                    let r = t.params.autoplay.delay;
                    e.attr("data-swiper-autoplay") && (r = e.attr("data-swiper-autoplay") || t.params.autoplay.delay),
                        clearTimeout(n),
                        (n = sn(() => {
                            let e;
                            t.params.autoplay.reverseDirection
                                ? t.params.loop
                                    ? (t.loopFix(), (e = t.slidePrev(t.params.speed, !0, !0)), i("autoplay"))
                                    : t.isBeginning
                                      ? t.params.autoplay.stopOnLastSlide
                                          ? o()
                                          : ((e = t.slideTo(t.slides.length - 1, t.params.speed, !0, !0)),
                                            i("autoplay"))
                                      : ((e = t.slidePrev(t.params.speed, !0, !0)), i("autoplay"))
                                : t.params.loop
                                  ? (t.loopFix(), (e = t.slideNext(t.params.speed, !0, !0)), i("autoplay"))
                                  : t.isEnd
                                    ? t.params.autoplay.stopOnLastSlide
                                        ? o()
                                        : ((e = t.slideTo(0, t.params.speed, !0, !0)), i("autoplay"))
                                    : ((e = t.slideNext(t.params.speed, !0, !0)), i("autoplay")),
                                ((t.params.cssMode && t.autoplay.running) || !1 === e) && s();
                        }, r));
                }
                function a() {
                    return (
                        void 0 === n && !t.autoplay.running && ((t.autoplay.running = !0), i("autoplayStart"), s(), !0)
                    );
                }
                function o() {
                    return (
                        !!t.autoplay.running &&
                        void 0 !== n &&
                        (n && (clearTimeout(n), (n = void 0)), (t.autoplay.running = !1), i("autoplayStop"), !0)
                    );
                }
                function l(e) {
                    t.autoplay.running &&
                        (t.autoplay.paused ||
                            (n && clearTimeout(n),
                            (t.autoplay.paused = !0),
                            0 !== e && t.params.autoplay.waitForTransition
                                ? ["transitionend", "webkitTransitionEnd"].forEach((e) => {
                                      t.$wrapperEl[0].addEventListener(e, p);
                                  })
                                : ((t.autoplay.paused = !1), s())));
                }
                function h() {
                    const e = Yi();
                    "hidden" === e.visibilityState && t.autoplay.running && l(),
                        "visible" === e.visibilityState && t.autoplay.paused && (s(), (t.autoplay.paused = !1));
                }
                function p(e) {
                    t &&
                        !t.destroyed &&
                        t.$wrapperEl &&
                        e.target === t.$wrapperEl[0] &&
                        (["transitionend", "webkitTransitionEnd"].forEach((e) => {
                            t.$wrapperEl[0].removeEventListener(e, p);
                        }),
                        (t.autoplay.paused = !1),
                        t.autoplay.running ? s() : o());
                }
                function c() {
                    t.params.autoplay.disableOnInteraction ? o() : (i("autoplayPause"), l()),
                        ["transitionend", "webkitTransitionEnd"].forEach((e) => {
                            t.$wrapperEl[0].removeEventListener(e, p);
                        });
                }
                function d() {
                    t.params.autoplay.disableOnInteraction || ((t.autoplay.paused = !1), i("autoplayResume"), s());
                }
                (t.autoplay = { running: !1, paused: !1 }),
                    e({
                        autoplay: {
                            enabled: !1,
                            delay: 3e3,
                            waitForTransition: !0,
                            disableOnInteraction: !0,
                            stopOnLastSlide: !1,
                            reverseDirection: !1,
                            pauseOnMouseEnter: !1,
                        },
                    }),
                    r("init", () => {
                        t.params.autoplay.enabled &&
                            (a(),
                            Yi().addEventListener("visibilitychange", h),
                            t.params.autoplay.pauseOnMouseEnter &&
                                (t.$el.on("mouseenter", c), t.$el.on("mouseleave", d)));
                    }),
                    r("beforeTransitionStart", (e, r, i) => {
                        t.autoplay.running &&
                            (i || !t.params.autoplay.disableOnInteraction ? t.autoplay.pause(r) : o());
                    }),
                    r("sliderFirstMove", () => {
                        t.autoplay.running && (t.params.autoplay.disableOnInteraction ? o() : l());
                    }),
                    r("touchEnd", () => {
                        t.params.cssMode && t.autoplay.paused && !t.params.autoplay.disableOnInteraction && s();
                    }),
                    r("destroy", () => {
                        t.$el.off("mouseenter", c),
                            t.$el.off("mouseleave", d),
                            t.autoplay.running && o(),
                            Yi().removeEventListener("visibilitychange", h);
                    }),
                    Object.assign(t.autoplay, { pause: l, run: s, start: a, stop: o });
            }
            function Rn({ swiper: t, extendParams: e, emit: r, once: i }) {
                e({
                    freeMode: {
                        enabled: !1,
                        momentum: !0,
                        momentumRatio: 1,
                        momentumBounce: !0,
                        momentumBounceRatio: 1,
                        momentumVelocityRatio: 1,
                        sticky: !1,
                        minimumVelocity: 0.02,
                    },
                }),
                    Object.assign(t, {
                        freeMode: {
                            onTouchStart: function () {
                                const e = t.getTranslate();
                                t.setTranslate(e),
                                    t.setTransition(0),
                                    (t.touchEventsData.velocities.length = 0),
                                    t.freeMode.onTouchEnd({ currentPos: t.rtl ? t.translate : -t.translate });
                            },
                            onTouchMove: function () {
                                const { touchEventsData: e, touches: r } = t;
                                0 === e.velocities.length &&
                                    e.velocities.push({
                                        position: r[t.isHorizontal() ? "startX" : "startY"],
                                        time: e.touchStartTime,
                                    }),
                                    e.velocities.push({
                                        position: r[t.isHorizontal() ? "currentX" : "currentY"],
                                        time: an(),
                                    });
                            },
                            onTouchEnd: function ({ currentPos: e }) {
                                const {
                                        params: n,
                                        $wrapperEl: s,
                                        rtlTranslate: a,
                                        snapGrid: o,
                                        touchEventsData: l,
                                    } = t,
                                    h = an() - l.touchStartTime;
                                if (e < -t.minTranslate()) t.slideTo(t.activeIndex);
                                else if (e > -t.maxTranslate())
                                    t.slides.length < o.length
                                        ? t.slideTo(o.length - 1)
                                        : t.slideTo(t.slides.length - 1);
                                else {
                                    if (n.freeMode.momentum) {
                                        if (l.velocities.length > 1) {
                                            const e = l.velocities.pop(),
                                                r = l.velocities.pop(),
                                                i = e.position - r.position,
                                                s = e.time - r.time;
                                            (t.velocity = i / s),
                                                (t.velocity /= 2),
                                                Math.abs(t.velocity) < n.freeMode.minimumVelocity && (t.velocity = 0),
                                                (s > 150 || an() - e.time > 300) && (t.velocity = 0);
                                        } else t.velocity = 0;
                                        (t.velocity *= n.freeMode.momentumVelocityRatio), (l.velocities.length = 0);
                                        let e = 1e3 * n.freeMode.momentumRatio;
                                        const h = t.velocity * e;
                                        let p = t.translate + h;
                                        a && (p = -p);
                                        let c,
                                            d = !1;
                                        const u = 20 * Math.abs(t.velocity) * n.freeMode.momentumBounceRatio;
                                        let f;
                                        if (p < t.maxTranslate())
                                            n.freeMode.momentumBounce
                                                ? (p + t.maxTranslate() < -u && (p = t.maxTranslate() - u),
                                                  (c = t.maxTranslate()),
                                                  (d = !0),
                                                  (l.allowMomentumBounce = !0))
                                                : (p = t.maxTranslate()),
                                                n.loop && n.centeredSlides && (f = !0);
                                        else if (p > t.minTranslate())
                                            n.freeMode.momentumBounce
                                                ? (p - t.minTranslate() > u && (p = t.minTranslate() + u),
                                                  (c = t.minTranslate()),
                                                  (d = !0),
                                                  (l.allowMomentumBounce = !0))
                                                : (p = t.minTranslate()),
                                                n.loop && n.centeredSlides && (f = !0);
                                        else if (n.freeMode.sticky) {
                                            let e;
                                            for (let t = 0; t < o.length; t += 1)
                                                if (o[t] > -p) {
                                                    e = t;
                                                    break;
                                                }
                                            (p =
                                                Math.abs(o[e] - p) < Math.abs(o[e - 1] - p) ||
                                                "next" === t.swipeDirection
                                                    ? o[e]
                                                    : o[e - 1]),
                                                (p = -p);
                                        }
                                        if (
                                            (f &&
                                                i("transitionEnd", () => {
                                                    t.loopFix();
                                                }),
                                            0 !== t.velocity)
                                        ) {
                                            if (
                                                ((e = a
                                                    ? Math.abs((-p - t.translate) / t.velocity)
                                                    : Math.abs((p - t.translate) / t.velocity)),
                                                n.freeMode.sticky)
                                            ) {
                                                const r = Math.abs((a ? -p : p) - t.translate),
                                                    i = t.slidesSizesGrid[t.activeIndex];
                                                e = r < i ? n.speed : r < 2 * i ? 1.5 * n.speed : 2.5 * n.speed;
                                            }
                                        } else if (n.freeMode.sticky) return void t.slideToClosest();
                                        n.freeMode.momentumBounce && d
                                            ? (t.updateProgress(c),
                                              t.setTransition(e),
                                              t.setTranslate(p),
                                              t.transitionStart(!0, t.swipeDirection),
                                              (t.animating = !0),
                                              s.transitionEnd(() => {
                                                  t &&
                                                      !t.destroyed &&
                                                      l.allowMomentumBounce &&
                                                      (r("momentumBounce"),
                                                      t.setTransition(n.speed),
                                                      setTimeout(() => {
                                                          t.setTranslate(c),
                                                              s.transitionEnd(() => {
                                                                  t && !t.destroyed && t.transitionEnd();
                                                              });
                                                      }, 0));
                                              }))
                                            : t.velocity
                                              ? (r("_freeModeNoMomentumRelease"),
                                                t.updateProgress(p),
                                                t.setTransition(e),
                                                t.setTranslate(p),
                                                t.transitionStart(!0, t.swipeDirection),
                                                t.animating ||
                                                    ((t.animating = !0),
                                                    s.transitionEnd(() => {
                                                        t && !t.destroyed && t.transitionEnd();
                                                    })))
                                              : t.updateProgress(p),
                                            t.updateActiveIndex(),
                                            t.updateSlidesClasses();
                                    } else {
                                        if (n.freeMode.sticky) return void t.slideToClosest();
                                        n.freeMode && r("_freeModeNoMomentumRelease");
                                    }
                                    (!n.freeMode.momentum || h >= n.longSwipesMs) &&
                                        (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
                                }
                            },
                        },
                    });
            }
            function On(t, e) {
                return t.transformEl
                    ? e
                          .find(t.transformEl)
                          .css({ "backface-visibility": "hidden", "-webkit-backface-visibility": "hidden" })
                    : e;
            }
            function zn({ swiper: t, extendParams: e, on: r }) {
                e({ fadeEffect: { crossFade: !1, transformEl: null } }),
                    (function (t) {
                        const {
                            effect: e,
                            swiper: r,
                            on: i,
                            setTranslate: n,
                            setTransition: s,
                            overwriteParams: a,
                            perspective: o,
                            recreateShadows: l,
                            getEffectParams: h,
                        } = t;
                        let p;
                        i("beforeInit", () => {
                            if (r.params.effect !== e) return;
                            r.classNames.push(`${r.params.containerModifierClass}${e}`),
                                o && o() && r.classNames.push(`${r.params.containerModifierClass}3d`);
                            const t = a ? a() : {};
                            Object.assign(r.params, t), Object.assign(r.originalParams, t);
                        }),
                            i("setTranslate", () => {
                                r.params.effect === e && n();
                            }),
                            i("setTransition", (t, i) => {
                                r.params.effect === e && s(i);
                            }),
                            i("transitionEnd", () => {
                                if (r.params.effect === e && l) {
                                    if (!h || !h().slideShadows) return;
                                    r.slides.each((t) => {
                                        r.$(t)
                                            .find(
                                                ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                                            )
                                            .remove();
                                    }),
                                        l();
                                }
                            }),
                            i("virtualUpdate", () => {
                                r.params.effect === e &&
                                    (r.slides.length || (p = !0),
                                    requestAnimationFrame(() => {
                                        p && r.slides && r.slides.length && (n(), (p = !1));
                                    }));
                            });
                    })({
                        effect: "fade",
                        swiper: t,
                        on: r,
                        setTranslate: () => {
                            const { slides: e } = t,
                                r = t.params.fadeEffect;
                            for (let i = 0; i < e.length; i += 1) {
                                const e = t.slides.eq(i);
                                let n = -e[0].swiperSlideOffset;
                                t.params.virtualTranslate || (n -= t.translate);
                                let s = 0;
                                t.isHorizontal() || ((s = n), (n = 0));
                                const a = t.params.fadeEffect.crossFade
                                    ? Math.max(1 - Math.abs(e[0].progress), 0)
                                    : 1 + Math.min(Math.max(e[0].progress, -1), 0);
                                On(r, e).css({ opacity: a }).transform(`translate3d(${n}px, ${s}px, 0px)`);
                            }
                        },
                        setTransition: (e) => {
                            const { transformEl: r } = t.params.fadeEffect;
                            (r ? t.slides.find(r) : t.slides).transition(e),
                                (function ({ swiper: t, duration: e, transformEl: r, allSlides: i }) {
                                    const { slides: n, activeIndex: s, $wrapperEl: a } = t;
                                    if (t.params.virtualTranslate && 0 !== e) {
                                        let e,
                                            o = !1;
                                        (e = i ? (r ? n.find(r) : n) : r ? n.eq(s).find(r) : n.eq(s)),
                                            e.transitionEnd(() => {
                                                if (o) return;
                                                if (!t || t.destroyed) return;
                                                (o = !0), (t.animating = !1);
                                                const e = ["webkitTransitionEnd", "transitionend"];
                                                for (let t = 0; t < e.length; t += 1) a.trigger(e[t]);
                                            });
                                    }
                                })({ swiper: t, duration: e, transformEl: r, allSlides: !0 });
                        },
                        overwriteParams: () => ({
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                            watchSlidesProgress: !0,
                            spaceBetween: 0,
                            virtualTranslate: !t.params.cssMode,
                        }),
                    });
            }
            var Gn = document.querySelector("[header-cart-toggle]"),
                Nn = document.querySelector("cart-drawer"),
                qn = document.querySelector(".cartx-drawer-wrap"),
                Hn = document.querySelector(".cartx-drawer-close"),
                $n = function () {
                    if (window.openDrawer) {
                        window.openDrawer({ preventDefault: function() {} });
                    } else {
                        Gn.setAttribute("aria-expanded", !0);
                        if (Nn) Nn.classList.add("drawer-open");
                        document.body.classList.add("cartx-open");
                    }
                },
                jn = function () {
                    if (window.closeDrawer) {
                        window.closeDrawer();
                    } else {
                        Gn.setAttribute("aria-expanded", !1);
                        if (Nn) Nn.classList.remove("drawer-open");
                        document.body.classList.remove("cartx-open");
                    }
                },
                Wn = function () {
                    var t = document.querySelectorAll("[cart-form-item]");
                    t.length &&
                        t.forEach(function (t, e) {
                            var r = e + 1;
                            t.querySelector("[cart-form-item-remove]").addEventListener("click", function () {
                                Yn({ line: r, quantity: 0, sections: "cart-drawer" });
                            });
                            var i = t.querySelector("[cart-drawer-item-qty-amount]"),
                                n = t.querySelector("[cart-drawer-item-qty-plus]"),
                                s = t.querySelector("[cart-drawer-item-qty-minus]");
                            i &&
                                (n.addEventListener("click", function () {
                                    var t = parseInt(i.textContent) + 1;
                                    (i.textContent = t), Yn({ line: r, quantity: t, sections: "cart-drawer" });
                                }),
                                s.addEventListener("click", function () {
                                    var t = parseInt(i.textContent) - 1;
                                    (i.textContent = t), Yn({ line: r, quantity: t, sections: "cart-drawer" });
                                }));
                        });
                },
                Yn = function (t) {
                    Nn.classList.add("cart-drawer--loading");
                    var e = document.querySelector("[cart-drawer-contents]");
                    zi.to(e, { duration: 0.25, opacity: 0 }),
                        fetch("/cart/change.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(t),
                        })
                            .then(function (t) {
                                return t.json();
                            })
                            .then(function (t) {
                                var r = document.querySelector("[header-cart-item-count]");
                                r.setAttribute("header-cart-item-count", t.item_count), (r.textContent = t.item_count);
                                var i = new DOMParser().parseFromString(t.sections["cart-drawer"], "text/html");
                                (e.innerHTML = i.querySelector("[cart-drawer-contents]").innerHTML),
                                    zi.to(e, { duration: 0.25, opacity: 1 }),
                                    Wn(),
                                    Nn.classList.remove("cart-drawer--loading"),
                                    (Shopify.cart = t);
                            });
                };
            function Xn(t, e) {
                var r = ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
                if (!r) {
                    if (
                        Array.isArray(t) ||
                        (r = (function (t, e) {
                            if (t) {
                                if ("string" == typeof t) return Un(t, e);
                                var r = Object.prototype.toString.call(t).slice(8, -1);
                                return (
                                    "Object" === r && t.constructor && (r = t.constructor.name),
                                    "Map" === r || "Set" === r
                                        ? Array.from(t)
                                        : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                                          ? Un(t, e)
                                          : void 0
                                );
                            }
                        })(t)) ||
                        (e && t && "number" == typeof t.length)
                    ) {
                        r && (t = r);
                        var i = 0,
                            n = function () {};
                        return {
                            s: n,
                            n: function () {
                                return i >= t.length ? { done: !0 } : { done: !1, value: t[i++] };
                            },
                            e: function (t) {
                                throw t;
                            },
                            f: n,
                        };
                    }
                    throw new TypeError(
                        "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                    );
                }
                var s,
                    a = !0,
                    o = !1;
                return {
                    s: function () {
                        r = r.call(t);
                    },
                    n: function () {
                        var t = r.next();
                        return (a = t.done), t;
                    },
                    e: function (t) {
                        (o = !0), (s = t);
                    },
                    f: function () {
                        try {
                            a || null == r.return || r.return();
                        } finally {
                            if (o) throw s;
                        }
                    },
                };
            }
            function Un(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for (var r = 0, i = new Array(e); r < e; r++) i[r] = t[r];
                return i;
            }
            window.$wc_item_added_to_cart = async (t) => {
                !(function () {
                    var t = document.querySelector("[cart-drawer]");
                    t.classList.add("cart-drawer--loading"),
                        fetch("/?sections=cart-drawer", {
                            method: "GET",
                            headers: { "Content-Type": "application/json" },
                        })
                            .then(function (t) {
                                return t.json();
                            })
                            .then(function (e) {
                                if (e || e.hasOwnProperty("cart-drawer"))
                                    try {
                                        var r = document.querySelector("[header-cart-item-count]"),
                                            i = new DOMParser().parseFromString(e["cart-drawer"], "text/html"),
                                            n = i.querySelector("[cart-drawer-contents]").innerHTML;
                                        i.querySelectorAll("#shopify-section-cart-drawer .cart-drawer__form-item"),
                                            fetch(window.Shopify.routes.root + "cart.js", {
                                                method: "GET",
                                                headers: { "Content-Type": "application/json" },
                                            })
                                                .then(async (t) => {
                                                    var e = await t.json();
                                                    r.setAttribute("header-cart-item-count", e.item_count),
                                                        (r.textContent = e.item_count);
                                                })
                                                .catch((t) => {
                                                    console.error("Error:", t);
                                                });
                                        var s = document.querySelector(
                                            "#shopify-section-cart-drawer [cart-drawer-contents]"
                                        );
                                        s && ((s.innerHTML = n), Wn(), t.classList.remove("cart-drawer--loading"));
                                    } catch (t) {}
                            });
                })(),
                    document
                        .querySelector(".header__actions-action[header-cart-toggle]")
                        .dispatchEvent(new Event("click"));
            };
            var Zn = document.querySelector("[product-single-media-slider]"),
                Kn = document.querySelector("[product-single-more-details]"),
                Jn = document.querySelector("[product-single-form-quantity]"),
                Qn = function () {
                    var t = document.querySelectorAll("[product-card-quick-purchase-btn]");
                    if (t) {
                        var e,
                            r = Xn(t);
                        try {
                            var i = function () {
                                var t = e.value;
                                t.addEventListener("click", function () {
                                    ss(t.dataset.variant, 1);
                                });
                            };
                            for (r.s(); !(e = r.n()).done; ) i();
                        } catch (t) {
                            r.e(t);
                        } finally {
                            r.f();
                        }
                    }
                },
                ts = document.querySelector("[product-single-form-quantity-value]"),
                es = document.querySelector("[product-single-form-quantity-increment]"),
                rs = document.querySelector("[product-single-form-quantity-decrement]"),
                is = document.querySelector("[product-single-form-submit]"),
                ns = function (t, e, r, i, n) {
                    var s,
                        a = [],
                        o = !1;
                    for (
                        i.forEach(function (t) {
                            a.push([t.dataset.index, t.value]);
                        }),
                            s = 0;
                        s < n.length;
                        s++
                    ) {
                        var l = n[s],
                            h = [],
                            p = void 0;
                        for (p = 0; p < a.length && a[p][1] == l[a[p][0]]; p++) h.push(1);
                        h.length == a.length && (o = l);
                    }
                    if (o) {
                        window.history.replaceState(
                            {},
                            "",
                            "".concat(window.location.pathname, "?variant=").concat(o.id)
                        ),
                            1 == o.available
                                ? ((r.disabled = !1), (r.innerHTML = r.dataset.addText))
                                : ((r.disabled = !0), (r.innerHTML = r.dataset.soldOutText)),
                            (ts.dataset.max = "continue" == o.inventory_policy ? 9999 : o.inventory_quantity),
                            parseInt(ts.value) > parseInt(ts.dataset.max)
                                ? ((ts.value = "0" == ts.dataset.max ? 1 : ts.dataset.max), (es.disabled = !0))
                                : (es.disabled = !1);
                        var c = o.price,
                            d = o.compare_at_price;
                        (e.innerHTML =
                            c < d
                                ? "<del>$" + (d / 100).toFixed(2) + "</del> $" + (c / 100).toFixed(2)
                                : "$" + (c / 100).toFixed(2)),
                            (t.value = o.id);
                    } else (r.disabled = !0), (r.innerHTML = r.dataset.soldOutText);
                },
                ss = function (t, e, r, i) {
                    $n(), r && (r.disabled = !0);
                    var n = document.querySelector("[cart-drawer]"),
                        s = document.querySelector("[cart-drawer-contents]");
                    n.classList.add("cart-drawer--loading"), zi.to(s, { duration: 0.25, opacity: 0 });
                    var a = { items: [{ id: t, quantity: e }], sections: "cart-drawer" };
                    i &&
                        ((a.items[0].properties = {}),
                        i.forEach(function (t) {
                            var e = t.name.match(/\[(.*?)\]/)[1];
                            a.items[0].properties[e.charAt(0).toUpperCase() + e.slice(1)] = t.value;
                        })),
                        fetch("/cart/add.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(a),
                        })
                            .then(function (t) {
                                return t.json();
                            })
                            .then(function (t) {
                                if (422 == t.status)
                                    r && (r.textContent = r.dataset.cartLimitText),
                                        n.classList.remove("cart-drawer--loading"),
                                        zi.to(s, { duration: 0.25, opacity: 1 });
                                else {
                                    r && (r.disabled = !1), n.classList.remove("cart-drawer--loading");
                                    var e = document.querySelector("[header-cart-item-count]");
                                    e.setAttribute(
                                        "header-cart-item-count",
                                        parseInt(e.textContent) + a.items[0].quantity
                                    ),
                                        (e.textContent = parseInt(e.textContent) + a.items[0].quantity);
                                    var i = new DOMParser().parseFromString(t.sections["cart-drawer"], "text/html");
                                    (s.innerHTML = i.querySelector("[cart-drawer-contents]").innerHTML),
                                        zi.to(s, { duration: 0.25, opacity: 1 }),
                                        Wn(),
                                        fetch("/cart.js", {
                                            method: "GET",
                                            headers: { "Content-Type": "application/json" },
                                        })
                                            .then(function (t) {
                                                return t.json();
                                            })
                                            .then(function (t) {
                                                Shopify.cart = t;
                                            });
                                }
                            })
                            .catch(function (t) {
                                console.error("Error:", t);
                            });
                },
                as = document.querySelector("[header-wrap]"),
                os = document.querySelector("[header-search-toggle]"),
                ls = document.querySelector("#".concat(os.getAttribute("aria-controls"))),
                hs = document.querySelector("[header-search-form-input]"),
                ps = document.querySelector("[search-section-form-input]"),
                cs = document.querySelector("[header-search-close-btn]"),
                /*
                 * Original predictive search. Waits for a pause in typing, cancels the previous request and
                 * ignores any response that no longer matches the field, so an older request arriving late
                 * can't replace the latest results (the Alpha/Beta search in search-alpha.js does the same).
                 */
                ds = function (t, e) {
                    clearTimeout(ds.timer);
                    if (ds.controller) ds.controller.abort();
                    if (e.trim().length > 2) {
                        ds.timer = setTimeout(function () {
                            var r = (ds.controller = new AbortController());
                            fetch(
                                "/search/suggest?q=".concat(
                                    encodeURIComponent(e),
                                    "&resources[type]=product&resources[limit]=4&section_id=predictive-search"
                                ),
                                { signal: r.signal }
                            )
                                .then(function (t) {
                                    if (!t.ok) throw new Error(t.status);
                                    return t.text();
                                })
                                .then(function (n) {
                                    if (r.signal.aborted || t.value !== e) return;
                                    var i = new DOMParser()
                                        .parseFromString(n, "text/html")
                                        .querySelector("#shopify-section-predictive-search").innerHTML;
                                    (t.closest("form").querySelector(".predictive-search").innerHTML = i),
                                        Qn(),
                                        $th_refreshWishlistItems(),
                                        $th_refreshBackInStockItems();
                                })
                                .catch(function (t) {
                                    if (20 !== (null == t ? void 0 : t.code)) throw t;
                                });
                        }, 250);
                    } else t.closest("form").querySelector(".predictive-search").innerHTML = "";
                },
                us = function () {
                    os &&
                        (as.parentNode.classList.remove("header--desktop-menu-active"),
                        gs(),
                        os.setAttribute("aria-expanded", !1),
                        ls.setAttribute("aria-expanded", !1));
                },
                fs = document.querySelector("[backdrop]"),
                ms = function () {
                    fs.classList.add("backdrop--active");
                },
                gs = function () {
                    fs.classList.remove("backdrop--active");
                };
            function ys(t, e) {
                var r = ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
                if (!r) {
                    if (
                        Array.isArray(t) ||
                        (r = (function (t, e) {
                            if (t) {
                                if ("string" == typeof t) return vs(t, e);
                                var r = Object.prototype.toString.call(t).slice(8, -1);
                                return (
                                    "Object" === r && t.constructor && (r = t.constructor.name),
                                    "Map" === r || "Set" === r
                                        ? Array.from(t)
                                        : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                                          ? vs(t, e)
                                          : void 0
                                );
                            }
                        })(t)) ||
                        (e && t && "number" == typeof t.length)
                    ) {
                        r && (t = r);
                        var i = 0,
                            n = function () {};
                        return {
                            s: n,
                            n: function () {
                                return i >= t.length ? { done: !0 } : { done: !1, value: t[i++] };
                            },
                            e: function (t) {
                                throw t;
                            },
                            f: n,
                        };
                    }
                    throw new TypeError(
                        "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                    );
                }
                var s,
                    a = !0,
                    o = !1;
                return {
                    s: function () {
                        r = r.call(t);
                    },
                    n: function () {
                        var t = r.next();
                        return (a = t.done), t;
                    },
                    e: function (t) {
                        (o = !0), (s = t);
                    },
                    f: function () {
                        try {
                            a || null == r.return || r.return();
                        } finally {
                            if (o) throw s;
                        }
                    },
                };
            }
            function vs(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for (var r = 0, i = new Array(e); r < e; r++) i[r] = t[r];
                return i;
            }
            var bs,
                _s = document.querySelector("[header-wrap]"),
                xs = document.querySelectorAll("[header-menu-item-link-top]"),
                Ss = document.querySelectorAll("[header-menu-item-link-second]"),
                Es = document.querySelector("[header-mob-menu-trigger]"),
                ws = document.querySelector("[header-mob-menu]"),
                Ps = document.querySelector("[header-mob-menu-wrap]"),
                Ts = document.querySelector("[header-mob-menu-close]"),
                Cs = document.querySelectorAll("[header-mob-menu-item-link-top]"),
                As = document.querySelectorAll("[header-mob-menu-item-link-second]"),
                ks = document.querySelectorAll("[header-mob-menu-item-link-top-back-btn]"),
                Ms = function (t, e) {
                    us(),
                        t.setAttribute("aria-expanded", !e),
                        t.nextElementSibling.setAttribute("aria-expanded", !e),
                        e
                            ? (_s.parentNode.classList.remove("header--desktop-menu-active"), gs())
                            : (_s.parentNode.classList.add("header--desktop-menu-active"), ms());
                },
                Ds = function () {
                    var t,
                        e = ys(xs);
                    try {
                        for (e.s(); !(t = e.n()).done; ) {
                            var r = t.value;
                            Ms(r, !0);
                        }
                    } catch (t) {
                        e.e(t);
                    } finally {
                        e.f();
                    }
                },
                Fs = function (t) {
                    Es.setAttribute("aria-expanded", !t),
                        document
                            .querySelector("#".concat(Es.getAttribute("aria-controls")))
                            .setAttribute("aria-expanded", !t),
                        t
                            ? (_s.parentNode.classList.remove("header--mobile-menu-active"),
                              document.documentElement.classList.remove("overflow-hidden"))
                            : (_s.parentNode.classList.add("header--mobile-menu-active"),
                              document.documentElement.classList.add("overflow-hidden"));
                },
                Is = function () {
                    var t = document.querySelectorAll("[header-action-dropdown]");
                    if (t) {
                        var e,
                            r = ys(t);
                        try {
                            for (r.s(); !(e = r.n()).done; ) {
                                var i = e.value;
                                i.setAttribute("aria-expanded", !1),
                                    i.nextElementSibling.setAttribute("aria-expanded", !1);
                            }
                        } catch (t) {
                            r.e(t);
                        } finally {
                            r.f();
                        }
                    }
                },
                Ls = (bs = {
                    callbacks: new Set(),
                    hasCallbacks: !1,
                    currentResults: [],
                    observer: void 0,
                    sizeRef: void 0,
                    start: function () {
                        if (bs.observer) bs.observer.observe(bs.sizeRef);
                        else {
                            var t = !1;
                            try {
                                t = !!ResizeObserver;
                            } catch (t) {}
                            if (t) {
                                var e = document.body,
                                    r = new ResizeObserver(function (t) {
                                        bs._update();
                                    });
                                (bs.sizeRef = e), (bs.observer = r), r.observe(e);
                            } else
                                window.addEventListener("DOMContentLoaded", bs._update, { passive: !0, once: !0 }),
                                    window.addEventListener("load", bs._update, { passive: !0, once: !0 }),
                                    window.addEventListener("resize", bs._update, { passive: !0 });
                        }
                    },
                    stop: function () {
                        bs.observer && bs.observer.unobserve(bs.sizeRef);
                    },
                    _measure: function () {
                        bs.hasCallbacks &&
                            (bs.currentResults = Array.from(bs.callbacks).map(function (t) {
                                return t();
                            }));
                    },
                    _applyMeasurements: function () {
                        var t = bs.currentResults;
                        t &&
                            t.length &&
                            t.flat().forEach(function (t) {
                                var e = t.prop,
                                    r = t.value;
                                e && (r || 0 === r) && document.documentElement.style.setProperty("--".concat(e), r);
                            });
                    },
                    forceImmediateUpdate: function () {
                        bs._measure();
                    },
                    _update: function () {
                        requestAnimationFrame(function () {
                            bs._measure(), bs._applyMeasurements();
                        });
                    },
                    add: function (t) {
                        t && (bs.callbacks.add(t), (bs.hasCallbacks = !!bs.callbacks.size));
                    },
                    remove: function (t) {
                        t && (bs.callbacks.delete(t), (bs.hasCallbacks = !!bs.callbacks.size));
                    },
                });
            Ls.add(function () {
                return [
                    { prop: "vp-height", value: document.documentElement.clientHeight + "px" },
                    { prop: "vp-width", value: document.documentElement.clientWidth + "px" },
                ];
            }),
                Ls.add(function () {
                    var t = document.body,
                        e = t.offsetWidth - t.clientWidth;
                    0 !== e && (e += "px");
                    var r = document.querySelector(".scrollbarRef");
                    if (!r) {
                        var i = document.createElement("div");
                        (i.style.width = "100px"),
                            (i.style.position = "absolute"),
                            (i.style.left = "-1000vw"),
                            (i.style.height = "1px"),
                            (i.style.overflow = "scroll"),
                            i.classList.add("scrollbarRef"),
                            document.body.appendChild(i),
                            (r = i);
                    }
                    var n = r.offsetWidth - r.clientWidth;
                    return (
                        n < 0 && (n = 0),
                        0 !== n && (n += "px"),
                        [
                            { prop: "scrollbar", value: n },
                            { prop: "body-scrollbar", value: e },
                        ]
                    );
                });
            const Bs = Ls;
            var Vs,
                Rs = "page-header-carousel",
                Os = "m-blog-carousel",
                zs = "m-brand-testimonials",
                Gs = "m-shop-features";
            const Ns = (Vs = {
                accordions: [],
                openSingleAccordion: function (t) {
                    var e = Vs.getAccordion(t.currentTarget),
                        r = Vs.getActiveAccordion();
                    e && (Vs.closeAllAccordions(), r !== e && e.setAttribute("aria-hidden", !1));
                },
                getAccordion: function (t) {
                    return Vs.accordions.find(function (e) {
                        var r = e.querySelector(".accordion__toggle");
                        return t === r;
                    });
                },
                getActiveAccordion: function () {
                    return Vs.accordions.find(function (t) {
                        return "false" === t.getAttribute("aria-hidden");
                    });
                },
                closeAllAccordions: function (t) {
                    Vs.accordions.forEach(function (t) {
                        t.setAttribute("aria-hidden", !0);
                    });
                },
                init: function () {
                    var t = document.querySelectorAll(".accordion__toggle"),
                        e = document.querySelectorAll(".accordion"),
                        r = !!e.length;
                    (Vs.accordions = []),
                        t &&
                            t.forEach(function (t) {
                                t.addEventListener("click", Vs.openSingleAccordion);
                            }),
                        r &&
                            e.forEach(function (t) {
                                var e = t.querySelector(".accordion__body"),
                                    r = "".concat(e.scrollHeight, "px");
                                e.style.setProperty("--accordion-scroll-height", r), Vs.accordions.push(t);
                            });
                },
            });
            var qs;
            const Hs = (qs = {
                videos: [],
                toggleMute: function (t) {
                    var e = qs.getVideo(t.currentTarget);
                    e && (e.muted = !e.muted);
                },
                getVideo: function (t) {
                    var e = qs.videos.find(function (e) {
                        var r = e.querySelector(".video-mute");
                        return t === r;
                    });
                    if (e) return e.querySelector("video");
                },
                init: function () {
                    var t = document.querySelectorAll(".video-lockup"),
                        e = !!t.length;
                    (qs.videos = []),
                        e &&
                            t.forEach(function (t) {
                                var e = t.querySelector(".video-mute");
                                e && e.addEventListener("click", qs.toggleMute), qs.videos.push(t);
                            });
                },
            });
            var $s = document.querySelector("[header-wrap]"),
                js = document.querySelector(
                    ".shopify-section:first-child .page-header--light, .shopify-section:first-child .collection-listing__banner-content--light"
                ),
                Ws = document.querySelector(
                    ".shopify-section:first-child .page-header, .shopify-section:first-child .collection-listing__banner--has-img"
                ),
                Ys = __webpack_require__(248),
                Xs = __webpack_require__.n(Ys),
                Us = document.querySelector("[site-loader-lottie]");
            function Zs(t, e) {
                var r = ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
                if (!r) {
                    if (
                        Array.isArray(t) ||
                        (r = (function (t, e) {
                            if (t) {
                                if ("string" == typeof t) return Ks(t, e);
                                var r = Object.prototype.toString.call(t).slice(8, -1);
                                return (
                                    "Object" === r && t.constructor && (r = t.constructor.name),
                                    "Map" === r || "Set" === r
                                        ? Array.from(t)
                                        : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                                          ? Ks(t, e)
                                          : void 0
                                );
                            }
                        })(t)) ||
                        (e && t && "number" == typeof t.length)
                    ) {
                        r && (t = r);
                        var i = 0,
                            n = function () {};
                        return {
                            s: n,
                            n: function () {
                                return i >= t.length ? { done: !0 } : { done: !1, value: t[i++] };
                            },
                            e: function (t) {
                                throw t;
                            },
                            f: n,
                        };
                    }
                    throw new TypeError(
                        "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                    );
                }
                var s,
                    a = !0,
                    o = !1;
                return {
                    s: function () {
                        r = r.call(t);
                    },
                    n: function () {
                        var t = r.next();
                        return (a = t.done), t;
                    },
                    e: function (t) {
                        (o = !0), (s = t);
                    },
                    f: function () {
                        try {
                            a || null == r.return || r.return();
                        } finally {
                            if (o) throw s;
                        }
                    },
                };
            }
            function Ks(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for (var r = 0, i = new Array(e); r < e; r++) i[r] = t[r];
                return i;
            }
            var Js = document.querySelectorAll("[store-carousel-wrap]"),
                Qs = function (t) {
                    if (t) {
                        var e = t.querySelector("[store-carousel-progressbar]");
                        new Fn(t, {
                            modules: [Bn, In],
                            speed: 1e3,
                            effect: "slide",
                            slidesPerView: parseInt(t.dataset.items),
                            spaceBetween: 50,
                            pagination: { el: e, type: "progressbar" },
                            mousewheel: { forceToAxis: !0 },
                            touchEventsTarget: "container",
                        });
                    }
                },
                ta = document.querySelector("[fof-lottie]");
            function ea(t, e) {
                var r = ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
                if (!r) {
                    if (Array.isArray(t) || (r = ra(t)) || (e && t && "number" == typeof t.length)) {
                        r && (t = r);
                        var i = 0,
                            n = function () {};
                        return {
                            s: n,
                            n: function () {
                                return i >= t.length ? { done: !0 } : { done: !1, value: t[i++] };
                            },
                            e: function (t) {
                                throw t;
                            },
                            f: n,
                        };
                    }
                    throw new TypeError(
                        "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                    );
                }
                var s,
                    a = !0,
                    o = !1;
                return {
                    s: function () {
                        r = r.call(t);
                    },
                    n: function () {
                        var t = r.next();
                        return (a = t.done), t;
                    },
                    e: function (t) {
                        (o = !0), (s = t);
                    },
                    f: function () {
                        try {
                            a || null == r.return || r.return();
                        } finally {
                            if (o) throw s;
                        }
                    },
                };
            }
            function ra(t, e) {
                if (t) {
                    if ("string" == typeof t) return ia(t, e);
                    var r = Object.prototype.toString.call(t).slice(8, -1);
                    return (
                        "Object" === r && t.constructor && (r = t.constructor.name),
                        "Map" === r || "Set" === r
                            ? Array.from(t)
                            : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                              ? ia(t, e)
                              : void 0
                    );
                }
            }
            function ia(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for (var r = 0, i = new Array(e); r < e; r++) i[r] = t[r];
                return i;
            }
            var na = function (t, e) {
                    var r = JSON.parse(t.getAttribute("aria-expanded")),
                        i = t.getAttribute("aria-controls"),
                        n = document.querySelector("#".concat(i));
                    t.setAttribute("aria-expanded", "boolean" == typeof e ? e : !r),
                        n.setAttribute("aria-expanded", "boolean" == typeof e ? e : !r);
                },
                sa = function () {
                    for (
                        var t = fbcFiltering.filterUrl, e = "", r = 0, i = Object.entries(fbcFiltering.currentFilters);
                        r < i.length;
                        r++
                    ) {
                        var n,
                            s,
                            a,
                            o =
                                (2,
                                (function (t) {
                                    if (Array.isArray(t)) return t;
                                })((d = i[r])) ||
                                    (function (t, e) {
                                        var r =
                                            null == t
                                                ? null
                                                : ("undefined" != typeof Symbol && t[Symbol.iterator]) ||
                                                  t["@@iterator"];
                                        if (null != r) {
                                            var i,
                                                n,
                                                s = [],
                                                a = !0,
                                                o = !1;
                                            try {
                                                for (
                                                    r = r.call(t);
                                                    !(a = (i = r.next()).done) && (s.push(i.value), 2 !== s.length);
                                                    a = !0
                                                );
                                            } catch (t) {
                                                (o = !0), (n = t);
                                            } finally {
                                                try {
                                                    a || null == r.return || r.return();
                                                } finally {
                                                    if (o) throw n;
                                                }
                                            }
                                            return s;
                                        }
                                    })(d) ||
                                    ra(d, 2) ||
                                    (function () {
                                        throw new TypeError(
                                            "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                                        );
                                    })()),
                            l = (o[0], o[1]);
                        if ((null === (n = l.tags) || void 0 === n ? void 0 : n.length) > 0) {
                            var h,
                                p = ea(l.tags);
                            try {
                                for (p.s(); !(h = p.n()).done; ) {
                                    var c = h.value;
                                    e += "&".concat(l.param, "=").concat(c);
                                }
                            } catch (t) {
                                p.e(t);
                            } finally {
                                p.f();
                            }
                        }
                        null !== (s = l.range) &&
                            void 0 !== s &&
                            s.gte &&
                            (e += "&".concat(l.param, ".gte=").concat(l.range.gte.toString())),
                            null !== (a = l.range) &&
                                void 0 !== a &&
                                a.lte &&
                                (e += "&".concat(l.param, ".lte=").concat(l.range.lte.toString()));
                    }
                    var d;
                    fbcFiltering.currentSort.value &&
                        (e += "&".concat(fbcFiltering.currentSort.param, "=").concat(fbcFiltering.currentSort.value)),
                        e && (t.includes("?") ? (t += e) : (t = t + "?" + e)),
                        (t = t.replace("?&", "?"));
                    var u = document.querySelector("[collection-items-wrapper]"),
                        f = document.querySelector("[collection-sortings-filter-count]"),
                        m = document.querySelector("[search-header-count]"),
                        g = zi.timeline();
                    g.to(u, { opacity: 0 }),
                        fetch(t)
                            .then(function (t) {
                                return t.text();
                            })
                            .then(function (e) {
                                e = new DOMParser().parseFromString(e, "text/html");
                                var r = getComputedStyle(document.querySelector("html")).getPropertyValue(
                                    "--total-header-height"
                                );
                                window.scroll({ top: u.offsetTop - parseInt(r) + 1, left: 0, behavior: "smooth" });
                                var i = e.querySelector("[collection-items-wrapper]"),
                                    n = e.querySelector("[collection-items-count]");
                                (u.innerHTML = i.innerHTML),
                                    (f.innerHTML = n.dataset.count),
                                    m && (m.innerHTML = n.dataset.count),
                                    Qn(),
                                    g.to(u, { opacity: 1 }),
                                    history.pushState({}, document.title, t);
                            });
                };
            function aa(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for (var r = 0, i = new Array(e); r < e; r++) i[r] = t[r];
                return i;
            }
            var oa = document.querySelectorAll("[feat-product-slider]"),
                la =
                    "undefined" != typeof window
                        ? window
                        : void 0 !== __webpack_require__.g
                          ? __webpack_require__.g
                          : "undefined" != typeof self
                            ? self
                            : {},
                ha = function (t, e, r, i, n, s, a, o, l, h) {
                    var p = this;
                    (p.numeralDecimalMark = t || "."),
                        (p.numeralIntegerScale = e > 0 ? e : 0),
                        (p.numeralDecimalScale = r >= 0 ? r : 2),
                        (p.numeralThousandsGroupStyle = i || ha.groupStyle.thousand),
                        (p.numeralPositiveOnly = !!n),
                        (p.stripLeadingZeroes = !1 !== s),
                        (p.prefix = a || "" === a ? a : ""),
                        (p.signBeforePrefix = !!o),
                        (p.tailPrefix = !!l),
                        (p.delimiter = h || "" === h ? h : ","),
                        (p.delimiterRE = h ? new RegExp("\\" + h, "g") : "");
                };
            (ha.groupStyle = { thousand: "thousand", lakh: "lakh", wan: "wan", none: "none" }),
                (ha.prototype = {
                    getRawValue: function (t) {
                        return t.replace(this.delimiterRE, "").replace(this.numeralDecimalMark, ".");
                    },
                    format: function (t) {
                        var e,
                            r,
                            i,
                            n,
                            s = this,
                            a = "";
                        switch (
                            ((t = t
                                .replace(/[A-Za-z]/g, "")
                                .replace(s.numeralDecimalMark, "M")
                                .replace(/[^\dM-]/g, "")
                                .replace(/^\-/, "N")
                                .replace(/\-/g, "")
                                .replace("N", s.numeralPositiveOnly ? "" : "-")
                                .replace("M", s.numeralDecimalMark)),
                            s.stripLeadingZeroes && (t = t.replace(/^(-)?0+(?=\d)/, "$1")),
                            (r = "-" === t.slice(0, 1) ? "-" : ""),
                            (i = void 0 !== s.prefix ? (s.signBeforePrefix ? r + s.prefix : s.prefix + r) : r),
                            (n = t),
                            t.indexOf(s.numeralDecimalMark) >= 0 &&
                                ((n = (e = t.split(s.numeralDecimalMark))[0]),
                                (a = s.numeralDecimalMark + e[1].slice(0, s.numeralDecimalScale))),
                            "-" === r && (n = n.slice(1)),
                            s.numeralIntegerScale > 0 && (n = n.slice(0, s.numeralIntegerScale)),
                            s.numeralThousandsGroupStyle)
                        ) {
                            case ha.groupStyle.lakh:
                                n = n.replace(/(\d)(?=(\d\d)+\d$)/g, "$1" + s.delimiter);
                                break;
                            case ha.groupStyle.wan:
                                n = n.replace(/(\d)(?=(\d{4})+$)/g, "$1" + s.delimiter);
                                break;
                            case ha.groupStyle.thousand:
                                n = n.replace(/(\d)(?=(\d{3})+$)/g, "$1" + s.delimiter);
                        }
                        return s.tailPrefix
                            ? r + n.toString() + (s.numeralDecimalScale > 0 ? a.toString() : "") + s.prefix
                            : i + n.toString() + (s.numeralDecimalScale > 0 ? a.toString() : "");
                    },
                });
            var pa = ha,
                ca = function (t, e, r) {
                    var i = this;
                    (i.date = []),
                        (i.blocks = []),
                        (i.datePattern = t),
                        (i.dateMin = e
                            .split("-")
                            .reverse()
                            .map(function (t) {
                                return parseInt(t, 10);
                            })),
                        2 === i.dateMin.length && i.dateMin.unshift(0),
                        (i.dateMax = r
                            .split("-")
                            .reverse()
                            .map(function (t) {
                                return parseInt(t, 10);
                            })),
                        2 === i.dateMax.length && i.dateMax.unshift(0),
                        i.initBlocks();
                };
            ca.prototype = {
                initBlocks: function () {
                    var t = this;
                    t.datePattern.forEach(function (e) {
                        "Y" === e ? t.blocks.push(4) : t.blocks.push(2);
                    });
                },
                getISOFormatDate: function () {
                    var t = this,
                        e = t.date;
                    return e[2] ? e[2] + "-" + t.addLeadingZero(e[1]) + "-" + t.addLeadingZero(e[0]) : "";
                },
                getBlocks: function () {
                    return this.blocks;
                },
                getValidatedDate: function (t) {
                    var e = this,
                        r = "";
                    return (
                        (t = t.replace(/[^\d]/g, "")),
                        e.blocks.forEach(function (i, n) {
                            if (t.length > 0) {
                                var s = t.slice(0, i),
                                    a = s.slice(0, 1),
                                    o = t.slice(i);
                                switch (e.datePattern[n]) {
                                    case "d":
                                        "00" === s
                                            ? (s = "01")
                                            : parseInt(a, 10) > 3
                                              ? (s = "0" + a)
                                              : parseInt(s, 10) > 31 && (s = "31");
                                        break;
                                    case "m":
                                        "00" === s
                                            ? (s = "01")
                                            : parseInt(a, 10) > 1
                                              ? (s = "0" + a)
                                              : parseInt(s, 10) > 12 && (s = "12");
                                }
                                (r += s), (t = o);
                            }
                        }),
                        this.getFixedDateString(r)
                    );
                },
                getFixedDateString: function (t) {
                    var e,
                        r,
                        i,
                        n = this,
                        s = n.datePattern,
                        a = [],
                        o = 0,
                        l = 0,
                        h = 0,
                        p = 0,
                        c = 0,
                        d = 0,
                        u = !1;
                    return (
                        4 === t.length &&
                            "y" !== s[0].toLowerCase() &&
                            "y" !== s[1].toLowerCase() &&
                            ((c = 2 - (p = "d" === s[0] ? 0 : 2)),
                            (e = parseInt(t.slice(p, p + 2), 10)),
                            (r = parseInt(t.slice(c, c + 2), 10)),
                            (a = this.getFixedDate(e, r, 0))),
                        8 === t.length &&
                            (s.forEach(function (t, e) {
                                switch (t) {
                                    case "d":
                                        o = e;
                                        break;
                                    case "m":
                                        l = e;
                                        break;
                                    default:
                                        h = e;
                                }
                            }),
                            (d = 2 * h),
                            (p = o <= h ? 2 * o : 2 * o + 2),
                            (c = l <= h ? 2 * l : 2 * l + 2),
                            (e = parseInt(t.slice(p, p + 2), 10)),
                            (r = parseInt(t.slice(c, c + 2), 10)),
                            (i = parseInt(t.slice(d, d + 4), 10)),
                            (u = 4 === t.slice(d, d + 4).length),
                            (a = this.getFixedDate(e, r, i))),
                        4 !== t.length ||
                            ("y" !== s[0] && "y" !== s[1]) ||
                            ((d = 2 - (c = "m" === s[0] ? 0 : 2)),
                            (r = parseInt(t.slice(c, c + 2), 10)),
                            (i = parseInt(t.slice(d, d + 2), 10)),
                            (u = 2 === t.slice(d, d + 2).length),
                            (a = [0, r, i])),
                        6 !== t.length ||
                            ("Y" !== s[0] && "Y" !== s[1]) ||
                            ((d = 2 - 0.5 * (c = "m" === s[0] ? 0 : 4)),
                            (r = parseInt(t.slice(c, c + 2), 10)),
                            (i = parseInt(t.slice(d, d + 4), 10)),
                            (u = 4 === t.slice(d, d + 4).length),
                            (a = [0, r, i])),
                        (a = n.getRangeFixedDate(a)),
                        (n.date = a),
                        0 === a.length
                            ? t
                            : s.reduce(function (t, e) {
                                  switch (e) {
                                      case "d":
                                          return t + (0 === a[0] ? "" : n.addLeadingZero(a[0]));
                                      case "m":
                                          return t + (0 === a[1] ? "" : n.addLeadingZero(a[1]));
                                      case "y":
                                          return t + (u ? n.addLeadingZeroForYear(a[2], !1) : "");
                                      case "Y":
                                          return t + (u ? n.addLeadingZeroForYear(a[2], !0) : "");
                                  }
                              }, "")
                    );
                },
                getRangeFixedDate: function (t) {
                    var e = this,
                        r = e.datePattern,
                        i = e.dateMin || [],
                        n = e.dateMax || [];
                    return !t.length ||
                        (i.length < 3 && n.length < 3) ||
                        (r.find(function (t) {
                            return "y" === t.toLowerCase();
                        }) &&
                            0 === t[2])
                        ? t
                        : n.length &&
                            (n[2] < t[2] || (n[2] === t[2] && (n[1] < t[1] || (n[1] === t[1] && n[0] < t[0]))))
                          ? n
                          : i.length &&
                              (i[2] > t[2] || (i[2] === t[2] && (i[1] > t[1] || (i[1] === t[1] && i[0] > t[0]))))
                            ? i
                            : t;
                },
                getFixedDate: function (t, e, r) {
                    return (
                        (t = Math.min(t, 31)),
                        (e = Math.min(e, 12)),
                        (r = parseInt(r || 0, 10)),
                        ((e < 7 && e % 2 == 0) || (e > 8 && e % 2 == 1)) &&
                            (t = Math.min(t, 2 === e ? (this.isLeapYear(r) ? 29 : 28) : 30)),
                        [t, e, r]
                    );
                },
                isLeapYear: function (t) {
                    return (t % 4 == 0 && t % 100 != 0) || t % 400 == 0;
                },
                addLeadingZero: function (t) {
                    return (t < 10 ? "0" : "") + t;
                },
                addLeadingZeroForYear: function (t, e) {
                    return e ? (t < 10 ? "000" : t < 100 ? "00" : t < 1e3 ? "0" : "") + t : (t < 10 ? "0" : "") + t;
                },
            };
            var da = ca,
                ua = function (t, e) {
                    var r = this;
                    (r.time = []), (r.blocks = []), (r.timePattern = t), (r.timeFormat = e), r.initBlocks();
                };
            ua.prototype = {
                initBlocks: function () {
                    var t = this;
                    t.timePattern.forEach(function () {
                        t.blocks.push(2);
                    });
                },
                getISOFormatTime: function () {
                    var t = this,
                        e = t.time;
                    return e[2]
                        ? t.addLeadingZero(e[0]) + ":" + t.addLeadingZero(e[1]) + ":" + t.addLeadingZero(e[2])
                        : "";
                },
                getBlocks: function () {
                    return this.blocks;
                },
                getTimeFormatOptions: function () {
                    return "12" === String(this.timeFormat)
                        ? { maxHourFirstDigit: 1, maxHours: 12, maxMinutesFirstDigit: 5, maxMinutes: 60 }
                        : { maxHourFirstDigit: 2, maxHours: 23, maxMinutesFirstDigit: 5, maxMinutes: 60 };
                },
                getValidatedTime: function (t) {
                    var e = this,
                        r = "";
                    t = t.replace(/[^\d]/g, "");
                    var i = e.getTimeFormatOptions();
                    return (
                        e.blocks.forEach(function (n, s) {
                            if (t.length > 0) {
                                var a = t.slice(0, n),
                                    o = a.slice(0, 1),
                                    l = t.slice(n);
                                switch (e.timePattern[s]) {
                                    case "h":
                                        parseInt(o, 10) > i.maxHourFirstDigit
                                            ? (a = "0" + o)
                                            : parseInt(a, 10) > i.maxHours && (a = i.maxHours + "");
                                        break;
                                    case "m":
                                    case "s":
                                        parseInt(o, 10) > i.maxMinutesFirstDigit
                                            ? (a = "0" + o)
                                            : parseInt(a, 10) > i.maxMinutes && (a = i.maxMinutes + "");
                                }
                                (r += a), (t = l);
                            }
                        }),
                        this.getFixedTimeString(r)
                    );
                },
                getFixedTimeString: function (t) {
                    var e,
                        r,
                        i,
                        n = this,
                        s = n.timePattern,
                        a = [],
                        o = 0,
                        l = 0,
                        h = 0,
                        p = 0,
                        c = 0,
                        d = 0;
                    return (
                        6 === t.length &&
                            (s.forEach(function (t, e) {
                                switch (t) {
                                    case "s":
                                        o = 2 * e;
                                        break;
                                    case "m":
                                        l = 2 * e;
                                        break;
                                    case "h":
                                        h = 2 * e;
                                }
                            }),
                            (d = h),
                            (c = l),
                            (p = o),
                            (e = parseInt(t.slice(p, p + 2), 10)),
                            (r = parseInt(t.slice(c, c + 2), 10)),
                            (i = parseInt(t.slice(d, d + 2), 10)),
                            (a = this.getFixedTime(i, r, e))),
                        4 === t.length &&
                            n.timePattern.indexOf("s") < 0 &&
                            (s.forEach(function (t, e) {
                                switch (t) {
                                    case "m":
                                        l = 2 * e;
                                        break;
                                    case "h":
                                        h = 2 * e;
                                }
                            }),
                            (d = h),
                            (c = l),
                            (e = 0),
                            (r = parseInt(t.slice(c, c + 2), 10)),
                            (i = parseInt(t.slice(d, d + 2), 10)),
                            (a = this.getFixedTime(i, r, e))),
                        (n.time = a),
                        0 === a.length
                            ? t
                            : s.reduce(function (t, e) {
                                  switch (e) {
                                      case "s":
                                          return t + n.addLeadingZero(a[2]);
                                      case "m":
                                          return t + n.addLeadingZero(a[1]);
                                      case "h":
                                          return t + n.addLeadingZero(a[0]);
                                  }
                              }, "")
                    );
                },
                getFixedTime: function (t, e, r) {
                    return (
                        (r = Math.min(parseInt(r || 0, 10), 60)), (e = Math.min(e, 60)), [(t = Math.min(t, 60)), e, r]
                    );
                },
                addLeadingZero: function (t) {
                    return (t < 10 ? "0" : "") + t;
                },
            };
            var fa = ua,
                ma = function (t, e) {
                    var r = this;
                    (r.delimiter = e || "" === e ? e : " "),
                        (r.delimiterRE = e ? new RegExp("\\" + e, "g") : ""),
                        (r.formatter = t);
                };
            ma.prototype = {
                setFormatter: function (t) {
                    this.formatter = t;
                },
                format: function (t) {
                    var e = this;
                    e.formatter.clear();
                    for (
                        var r,
                            i = "",
                            n = !1,
                            s = 0,
                            a = (t = (t = (t = t.replace(/[^\d+]/g, ""))
                                .replace(/^\+/, "B")
                                .replace(/\+/g, "")
                                .replace("B", "+")).replace(e.delimiterRE, "")).length;
                        s < a;
                        s++
                    )
                        (r = e.formatter.inputDigit(t.charAt(s))),
                            /[\s()-]/g.test(r) ? ((i = r), (n = !0)) : n || (i = r);
                    return (i = i.replace(/[()]/g, "")).replace(/[\s-]/g, e.delimiter);
                },
            };
            var ga = ma,
                ya = {
                    blocks: {
                        uatp: [4, 5, 6],
                        amex: [4, 6, 5],
                        diners: [4, 6, 4],
                        discover: [4, 4, 4, 4],
                        mastercard: [4, 4, 4, 4],
                        dankort: [4, 4, 4, 4],
                        instapayment: [4, 4, 4, 4],
                        jcb15: [4, 6, 5],
                        jcb: [4, 4, 4, 4],
                        maestro: [4, 4, 4, 4],
                        visa: [4, 4, 4, 4],
                        mir: [4, 4, 4, 4],
                        unionPay: [4, 4, 4, 4],
                        general: [4, 4, 4, 4],
                    },
                    re: {
                        uatp: /^(?!1800)1\d{0,14}/,
                        amex: /^3[47]\d{0,13}/,
                        discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,
                        diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,
                        mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,
                        dankort: /^(5019|4175|4571)\d{0,12}/,
                        instapayment: /^63[7-9]\d{0,13}/,
                        jcb15: /^(?:2131|1800)\d{0,11}/,
                        jcb: /^(?:35\d{0,2})\d{0,12}/,
                        maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,
                        mir: /^220[0-4]\d{0,12}/,
                        visa: /^4\d{0,15}/,
                        unionPay: /^(62|81)\d{0,14}/,
                    },
                    getStrictBlocks: function (t) {
                        var e = t.reduce(function (t, e) {
                            return t + e;
                        }, 0);
                        return t.concat(19 - e);
                    },
                    getInfo: function (t, e) {
                        var r = ya.blocks,
                            i = ya.re;
                        for (var n in ((e = !!e), i))
                            if (i[n].test(t)) {
                                var s = r[n];
                                return { type: n, blocks: e ? this.getStrictBlocks(s) : s };
                            }
                        return { type: "unknown", blocks: e ? this.getStrictBlocks(r.general) : r.general };
                    },
                },
                va = ya,
                ba = {
                    noop: function () {},
                    strip: function (t, e) {
                        return t.replace(e, "");
                    },
                    getPostDelimiter: function (t, e, r) {
                        if (0 === r.length) return t.slice(-e.length) === e ? e : "";
                        var i = "";
                        return (
                            r.forEach(function (e) {
                                t.slice(-e.length) === e && (i = e);
                            }),
                            i
                        );
                    },
                    getDelimiterREByDelimiter: function (t) {
                        return new RegExp(t.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"), "g");
                    },
                    getNextCursorPosition: function (t, e, r, i, n) {
                        return e.length === t ? r.length : t + this.getPositionOffset(t, e, r, i, n);
                    },
                    getPositionOffset: function (t, e, r, i, n) {
                        var s, a, o;
                        return (
                            (s = this.stripDelimiters(e.slice(0, t), i, n)),
                            (a = this.stripDelimiters(r.slice(0, t), i, n)),
                            0 != (o = s.length - a.length) ? o / Math.abs(o) : 0
                        );
                    },
                    stripDelimiters: function (t, e, r) {
                        var i = this;
                        if (0 === r.length) {
                            var n = e ? i.getDelimiterREByDelimiter(e) : "";
                            return t.replace(n, "");
                        }
                        return (
                            r.forEach(function (e) {
                                e.split("").forEach(function (e) {
                                    t = t.replace(i.getDelimiterREByDelimiter(e), "");
                                });
                            }),
                            t
                        );
                    },
                    headStr: function (t, e) {
                        return t.slice(0, e);
                    },
                    getMaxLength: function (t) {
                        return t.reduce(function (t, e) {
                            return t + e;
                        }, 0);
                    },
                    getPrefixStrippedValue: function (t, e, r, i, n, s, a, o, l) {
                        if (0 === r) return t;
                        if (t === e && "" !== t) return "";
                        if (l && "-" == t.slice(0, 1)) {
                            var h = "-" == i.slice(0, 1) ? i.slice(1) : i;
                            return "-" + this.getPrefixStrippedValue(t.slice(1), e, r, h, n, s, a, o, l);
                        }
                        if (i.slice(0, r) !== e && !o) return a && !i && t ? t : "";
                        if (i.slice(-r) !== e && o) return a && !i && t ? t : "";
                        var p = this.stripDelimiters(i, n, s);
                        return t.slice(0, r) === e || o
                            ? t.slice(-r) !== e && o
                                ? p.slice(0, -r - 1)
                                : o
                                  ? t.slice(0, -r)
                                  : t.slice(r)
                            : p.slice(r);
                    },
                    getFirstDiffIndex: function (t, e) {
                        for (var r = 0; t.charAt(r) === e.charAt(r); ) if ("" === t.charAt(r++)) return -1;
                        return r;
                    },
                    getFormattedValue: function (t, e, r, i, n, s) {
                        var a = "",
                            o = n.length > 0,
                            l = "";
                        return 0 === r
                            ? t
                            : (e.forEach(function (e, h) {
                                  if (t.length > 0) {
                                      var p = t.slice(0, e),
                                          c = t.slice(e);
                                      (l = o ? n[s ? h - 1 : h] || l : i),
                                          s
                                              ? (h > 0 && (a += l), (a += p))
                                              : ((a += p), p.length === e && h < r - 1 && (a += l)),
                                          (t = c);
                                  }
                              }),
                              a);
                    },
                    fixPrefixCursor: function (t, e, r, i) {
                        if (t) {
                            var n = t.value,
                                s = r || i[0] || " ";
                            if (t.setSelectionRange && e && !(e.length + s.length <= n.length)) {
                                var a = 2 * n.length;
                                setTimeout(function () {
                                    t.setSelectionRange(a, a);
                                }, 1);
                            }
                        }
                    },
                    checkFullSelection: function (t) {
                        try {
                            return (
                                (window.getSelection() || document.getSelection() || {}).toString().length === t.length
                            );
                        } catch (t) {}
                        return !1;
                    },
                    setSelection: function (t, e, r) {
                        if (t === this.getActiveElement(r) && !(t && t.value.length <= e))
                            if (t.createTextRange) {
                                var i = t.createTextRange();
                                i.move("character", e), i.select();
                            } else
                                try {
                                    t.setSelectionRange(e, e);
                                } catch (t) {
                                    console.warn("The input element type does not support selection");
                                }
                    },
                    getActiveElement: function (t) {
                        var e = t.activeElement;
                        return e && e.shadowRoot ? this.getActiveElement(e.shadowRoot) : e;
                    },
                    isAndroid: function () {
                        return navigator && /android/i.test(navigator.userAgent);
                    },
                    isAndroidBackspaceKeydown: function (t, e) {
                        return !!(this.isAndroid() && t && e) && e === t.slice(0, -1);
                    },
                },
                _a = {
                    assign: function (t, e) {
                        return (
                            (e = e || {}),
                            ((t = t || {}).creditCard = !!e.creditCard),
                            (t.creditCardStrictMode = !!e.creditCardStrictMode),
                            (t.creditCardType = ""),
                            (t.onCreditCardTypeChanged = e.onCreditCardTypeChanged || function () {}),
                            (t.phone = !!e.phone),
                            (t.phoneRegionCode = e.phoneRegionCode || "AU"),
                            (t.phoneFormatter = {}),
                            (t.time = !!e.time),
                            (t.timePattern = e.timePattern || ["h", "m", "s"]),
                            (t.timeFormat = e.timeFormat || "24"),
                            (t.timeFormatter = {}),
                            (t.date = !!e.date),
                            (t.datePattern = e.datePattern || ["d", "m", "Y"]),
                            (t.dateMin = e.dateMin || ""),
                            (t.dateMax = e.dateMax || ""),
                            (t.dateFormatter = {}),
                            (t.numeral = !!e.numeral),
                            (t.numeralIntegerScale = e.numeralIntegerScale > 0 ? e.numeralIntegerScale : 0),
                            (t.numeralDecimalScale = e.numeralDecimalScale >= 0 ? e.numeralDecimalScale : 2),
                            (t.numeralDecimalMark = e.numeralDecimalMark || "."),
                            (t.numeralThousandsGroupStyle = e.numeralThousandsGroupStyle || "thousand"),
                            (t.numeralPositiveOnly = !!e.numeralPositiveOnly),
                            (t.stripLeadingZeroes = !1 !== e.stripLeadingZeroes),
                            (t.signBeforePrefix = !!e.signBeforePrefix),
                            (t.tailPrefix = !!e.tailPrefix),
                            (t.swapHiddenInput = !!e.swapHiddenInput),
                            (t.numericOnly = t.creditCard || t.date || !!e.numericOnly),
                            (t.uppercase = !!e.uppercase),
                            (t.lowercase = !!e.lowercase),
                            (t.prefix = t.creditCard || t.date ? "" : e.prefix || ""),
                            (t.noImmediatePrefix = !!e.noImmediatePrefix),
                            (t.prefixLength = t.prefix.length),
                            (t.rawValueTrimPrefix = !!e.rawValueTrimPrefix),
                            (t.copyDelimiter = !!e.copyDelimiter),
                            (t.initValue =
                                void 0 !== e.initValue && null !== e.initValue ? e.initValue.toString() : ""),
                            (t.delimiter =
                                e.delimiter || "" === e.delimiter
                                    ? e.delimiter
                                    : e.date
                                      ? "/"
                                      : e.time
                                        ? ":"
                                        : e.numeral
                                          ? ","
                                          : (e.phone, " ")),
                            (t.delimiterLength = t.delimiter.length),
                            (t.delimiterLazyShow = !!e.delimiterLazyShow),
                            (t.delimiters = e.delimiters || []),
                            (t.blocks = e.blocks || []),
                            (t.blocksLength = t.blocks.length),
                            (t.root = "object" == typeof la && la ? la : window),
                            (t.document = e.document || t.root.document),
                            (t.maxLength = 0),
                            (t.backspace = !1),
                            (t.result = ""),
                            (t.onValueChanged = e.onValueChanged || function () {}),
                            t
                        );
                    },
                },
                xa = function (t, e) {
                    var r = this,
                        i = !1;
                    if (
                        ("string" == typeof t
                            ? ((r.element = document.querySelector(t)), (i = document.querySelectorAll(t).length > 1))
                            : void 0 !== t.length && t.length > 0
                              ? ((r.element = t[0]), (i = t.length > 1))
                              : (r.element = t),
                        !r.element)
                    )
                        throw new Error("[cleave.js] Please check the element");
                    if (i)
                        try {
                            console.warn(
                                "[cleave.js] Multiple input fields matched, cleave.js will only take the first one."
                            );
                        } catch (t) {}
                    (e.initValue = r.element.value), (r.properties = xa.DefaultProperties.assign({}, e)), r.init();
                };
            (xa.prototype = {
                init: function () {
                    var t = this,
                        e = t.properties;
                    e.numeral || e.phone || e.creditCard || e.time || e.date || 0 !== e.blocksLength || e.prefix
                        ? ((e.maxLength = xa.Util.getMaxLength(e.blocks)),
                          (t.isAndroid = xa.Util.isAndroid()),
                          (t.lastInputValue = ""),
                          (t.isBackward = ""),
                          (t.onChangeListener = t.onChange.bind(t)),
                          (t.onKeyDownListener = t.onKeyDown.bind(t)),
                          (t.onFocusListener = t.onFocus.bind(t)),
                          (t.onCutListener = t.onCut.bind(t)),
                          (t.onCopyListener = t.onCopy.bind(t)),
                          t.initSwapHiddenInput(),
                          t.element.addEventListener("input", t.onChangeListener),
                          t.element.addEventListener("keydown", t.onKeyDownListener),
                          t.element.addEventListener("focus", t.onFocusListener),
                          t.element.addEventListener("cut", t.onCutListener),
                          t.element.addEventListener("copy", t.onCopyListener),
                          t.initPhoneFormatter(),
                          t.initDateFormatter(),
                          t.initTimeFormatter(),
                          t.initNumeralFormatter(),
                          (e.initValue || (e.prefix && !e.noImmediatePrefix)) && t.onInput(e.initValue))
                        : t.onInput(e.initValue);
                },
                initSwapHiddenInput: function () {
                    var t = this;
                    if (t.properties.swapHiddenInput) {
                        var e = t.element.cloneNode(!0);
                        t.element.parentNode.insertBefore(e, t.element),
                            (t.elementSwapHidden = t.element),
                            (t.elementSwapHidden.type = "hidden"),
                            (t.element = e),
                            (t.element.id = "");
                    }
                },
                initNumeralFormatter: function () {
                    var t = this.properties;
                    t.numeral &&
                        (t.numeralFormatter = new xa.NumeralFormatter(
                            t.numeralDecimalMark,
                            t.numeralIntegerScale,
                            t.numeralDecimalScale,
                            t.numeralThousandsGroupStyle,
                            t.numeralPositiveOnly,
                            t.stripLeadingZeroes,
                            t.prefix,
                            t.signBeforePrefix,
                            t.tailPrefix,
                            t.delimiter
                        ));
                },
                initTimeFormatter: function () {
                    var t = this.properties;
                    t.time &&
                        ((t.timeFormatter = new xa.TimeFormatter(t.timePattern, t.timeFormat)),
                        (t.blocks = t.timeFormatter.getBlocks()),
                        (t.blocksLength = t.blocks.length),
                        (t.maxLength = xa.Util.getMaxLength(t.blocks)));
                },
                initDateFormatter: function () {
                    var t = this.properties;
                    t.date &&
                        ((t.dateFormatter = new xa.DateFormatter(t.datePattern, t.dateMin, t.dateMax)),
                        (t.blocks = t.dateFormatter.getBlocks()),
                        (t.blocksLength = t.blocks.length),
                        (t.maxLength = xa.Util.getMaxLength(t.blocks)));
                },
                initPhoneFormatter: function () {
                    var t = this.properties;
                    if (t.phone)
                        try {
                            t.phoneFormatter = new xa.PhoneFormatter(
                                new t.root.Cleave.AsYouTypeFormatter(t.phoneRegionCode),
                                t.delimiter
                            );
                        } catch (t) {
                            throw new Error("[cleave.js] Please include phone-type-formatter.{country}.js lib");
                        }
                },
                onKeyDown: function (t) {
                    var e = this,
                        r = t.which || t.keyCode;
                    (e.lastInputValue = e.element.value), (e.isBackward = 8 === r);
                },
                onChange: function (t) {
                    var e = this,
                        r = e.properties,
                        i = xa.Util;
                    e.isBackward = e.isBackward || "deleteContentBackward" === t.inputType;
                    var n = i.getPostDelimiter(e.lastInputValue, r.delimiter, r.delimiters);
                    e.isBackward && n ? (r.postDelimiterBackspace = n) : (r.postDelimiterBackspace = !1),
                        this.onInput(this.element.value);
                },
                onFocus: function () {
                    var t = this,
                        e = t.properties;
                    (t.lastInputValue = t.element.value),
                        e.prefix && e.noImmediatePrefix && !t.element.value && this.onInput(e.prefix),
                        xa.Util.fixPrefixCursor(t.element, e.prefix, e.delimiter, e.delimiters);
                },
                onCut: function (t) {
                    xa.Util.checkFullSelection(this.element.value) && (this.copyClipboardData(t), this.onInput(""));
                },
                onCopy: function (t) {
                    xa.Util.checkFullSelection(this.element.value) && this.copyClipboardData(t);
                },
                copyClipboardData: function (t) {
                    var e,
                        r = this.properties,
                        i = xa.Util,
                        n = this.element.value;
                    e = r.copyDelimiter ? n : i.stripDelimiters(n, r.delimiter, r.delimiters);
                    try {
                        t.clipboardData ? t.clipboardData.setData("Text", e) : window.clipboardData.setData("Text", e),
                            t.preventDefault();
                    } catch (t) {}
                },
                onInput: function (t) {
                    var e = this,
                        r = e.properties,
                        i = xa.Util,
                        n = i.getPostDelimiter(t, r.delimiter, r.delimiters);
                    return (
                        r.numeral ||
                            !r.postDelimiterBackspace ||
                            n ||
                            (t = i.headStr(t, t.length - r.postDelimiterBackspace.length)),
                        r.phone
                            ? (!r.prefix || (r.noImmediatePrefix && !t.length)
                                  ? (r.result = r.phoneFormatter.format(t))
                                  : (r.result = r.prefix + r.phoneFormatter.format(t).slice(r.prefix.length)),
                              void e.updateValueState())
                            : r.numeral
                              ? (r.prefix && r.noImmediatePrefix && 0 === t.length
                                    ? (r.result = "")
                                    : (r.result = r.numeralFormatter.format(t)),
                                void e.updateValueState())
                              : (r.date && (t = r.dateFormatter.getValidatedDate(t)),
                                r.time && (t = r.timeFormatter.getValidatedTime(t)),
                                (t = i.stripDelimiters(t, r.delimiter, r.delimiters)),
                                (t = i.getPrefixStrippedValue(
                                    t,
                                    r.prefix,
                                    r.prefixLength,
                                    r.result,
                                    r.delimiter,
                                    r.delimiters,
                                    r.noImmediatePrefix,
                                    r.tailPrefix,
                                    r.signBeforePrefix
                                )),
                                (t = r.numericOnly ? i.strip(t, /[^\d]/g) : t),
                                (t = r.uppercase ? t.toUpperCase() : t),
                                (t = r.lowercase ? t.toLowerCase() : t),
                                r.prefix && (r.tailPrefix ? (t += r.prefix) : (t = r.prefix + t), 0 === r.blocksLength)
                                    ? ((r.result = t), void e.updateValueState())
                                    : (r.creditCard && e.updateCreditCardPropsByValue(t),
                                      (t = i.headStr(t, r.maxLength)),
                                      (r.result = i.getFormattedValue(
                                          t,
                                          r.blocks,
                                          r.blocksLength,
                                          r.delimiter,
                                          r.delimiters,
                                          r.delimiterLazyShow
                                      )),
                                      void e.updateValueState()))
                    );
                },
                updateCreditCardPropsByValue: function (t) {
                    var e,
                        r = this.properties,
                        i = xa.Util;
                    i.headStr(r.result, 4) !== i.headStr(t, 4) &&
                        ((e = xa.CreditCardDetector.getInfo(t, r.creditCardStrictMode)),
                        (r.blocks = e.blocks),
                        (r.blocksLength = r.blocks.length),
                        (r.maxLength = i.getMaxLength(r.blocks)),
                        r.creditCardType !== e.type &&
                            ((r.creditCardType = e.type), r.onCreditCardTypeChanged.call(this, r.creditCardType)));
                },
                updateValueState: function () {
                    var t = this,
                        e = xa.Util,
                        r = t.properties;
                    if (t.element) {
                        var i = t.element.selectionEnd,
                            n = t.element.value,
                            s = r.result;
                        (i = e.getNextCursorPosition(i, n, s, r.delimiter, r.delimiters)),
                            t.isAndroid
                                ? window.setTimeout(function () {
                                      (t.element.value = s),
                                          e.setSelection(t.element, i, r.document, !1),
                                          t.callOnValueChanged();
                                  }, 1)
                                : ((t.element.value = s),
                                  r.swapHiddenInput && (t.elementSwapHidden.value = t.getRawValue()),
                                  e.setSelection(t.element, i, r.document, !1),
                                  t.callOnValueChanged());
                    }
                },
                callOnValueChanged: function () {
                    var t = this,
                        e = t.properties;
                    e.onValueChanged.call(t, {
                        target: { name: t.element.name, value: e.result, rawValue: t.getRawValue() },
                    });
                },
                setPhoneRegionCode: function (t) {
                    var e = this;
                    (e.properties.phoneRegionCode = t), e.initPhoneFormatter(), e.onChange();
                },
                setRawValue: function (t) {
                    var e = this,
                        r = e.properties;
                    (t = null != t ? t.toString() : ""),
                        r.numeral && (t = t.replace(".", r.numeralDecimalMark)),
                        (r.postDelimiterBackspace = !1),
                        (e.element.value = t),
                        e.onInput(t);
                },
                getRawValue: function () {
                    var t = this.properties,
                        e = xa.Util,
                        r = this.element.value;
                    return (
                        t.rawValueTrimPrefix &&
                            (r = e.getPrefixStrippedValue(
                                r,
                                t.prefix,
                                t.prefixLength,
                                t.result,
                                t.delimiter,
                                t.delimiters,
                                t.noImmediatePrefix,
                                t.tailPrefix,
                                t.signBeforePrefix
                            )),
                        t.numeral ? t.numeralFormatter.getRawValue(r) : e.stripDelimiters(r, t.delimiter, t.delimiters)
                    );
                },
                getISOFormatDate: function () {
                    var t = this.properties;
                    return t.date ? t.dateFormatter.getISOFormatDate() : "";
                },
                getISOFormatTime: function () {
                    var t = this.properties;
                    return t.time ? t.timeFormatter.getISOFormatTime() : "";
                },
                getFormattedValue: function () {
                    return this.element.value;
                },
                destroy: function () {
                    var t = this;
                    t.element.removeEventListener("input", t.onChangeListener),
                        t.element.removeEventListener("keydown", t.onKeyDownListener),
                        t.element.removeEventListener("focus", t.onFocusListener),
                        t.element.removeEventListener("cut", t.onCutListener),
                        t.element.removeEventListener("copy", t.onCopyListener);
                },
                toString: function () {
                    return "[Cleave Object]";
                },
            }),
                (xa.NumeralFormatter = pa),
                (xa.DateFormatter = da),
                (xa.TimeFormatter = fa),
                (xa.PhoneFormatter = ga),
                (xa.CreditCardDetector = va),
                (xa.Util = ba),
                (xa.DefaultProperties = _a),
                (("object" == typeof la && la ? la : window).Cleave = xa);
            const Sa = xa;
            function Ea(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for (var r = 0, i = new Array(e); r < e; r++) i[r] = t[r];
                return i;
            }
            var wa, Pa, Ta;
            !(function () {
                if (!sessionStorage.getItem("loaded")) {
                    (Us.parentNode.style.display = "flex"),
                        Xs().loadAnimation({
                            container: Us,
                            renderer: "svg",
                            loop: !0,
                            autoplay: !0,
                            path: loaderPath,
                        });
                    var t = getComputedStyle(document.documentElement).getPropertyValue("--colour-red");
                    setTimeout(function () {
                        zi.timeline()
                            .to(Us, { duration: 0.5, scale: 0, ease: "elastic.in(1, 0.8)" })
                            .to(Us.parentNode, { duration: 0.25, backgroundColor: t }, "-=.125")
                            .to(Us.parentNode, { duration: 0.3125, autoAlpha: 0 }, "+=.125");
                    }, 3500),
                        sessionStorage.setItem("loaded", "true");
                }
            })(),
                Bs.start(),
                (function () {
                    if (
                        (setTimeout(function () {
                            return Ni?.classList.add("page-transition--loaded");
                        }, 150),
                        qi.length > 0)
                    ) {
                        var t,
                            e = (function (t, e) {
                                var r = ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
                                if (!r) {
                                    if (
                                        Array.isArray(t) ||
                                        (r = (function (t, e) {
                                            if (t) {
                                                if ("string" == typeof t) return Gi(t, e);
                                                var r = Object.prototype.toString.call(t).slice(8, -1);
                                                return (
                                                    "Object" === r && t.constructor && (r = t.constructor.name),
                                                    "Map" === r || "Set" === r
                                                        ? Array.from(t)
                                                        : "Arguments" === r ||
                                                            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                                                          ? Gi(t, e)
                                                          : void 0
                                                );
                                            }
                                        })(t))
                                    ) {
                                        r && (t = r);
                                        var i = 0,
                                            n = function () {};
                                        return {
                                            s: n,
                                            n: function () {
                                                return i >= t.length ? { done: !0 } : { done: !1, value: t[i++] };
                                            },
                                            e: function (t) {
                                                throw t;
                                            },
                                            f: n,
                                        };
                                    }
                                    throw new TypeError(
                                        "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                                    );
                                }
                                var s,
                                    a = !0,
                                    o = !1;
                                return {
                                    s: function () {
                                        r = r.call(t);
                                    },
                                    n: function () {
                                        var t = r.next();
                                        return (a = t.done), t;
                                    },
                                    e: function (t) {
                                        (o = !0), (s = t);
                                    },
                                    f: function () {
                                        try {
                                            a || null == r.return || r.return();
                                        } finally {
                                            if (o) throw s;
                                        }
                                    },
                                };
                            })(qi);
                        try {
                            var r = function () {
                                var e = t.value;
                                e.addEventListener("click", function (t) {
                                    t.preventDefault(),
                                        Hi(function () {
                                            return (window.location = e.href);
                                        });
                                });
                            };
                            for (e.s(); !(t = e.n()).done; ) r();
                        } catch (t) {
                            e.e(t);
                        } finally {
                            e.f();
                        }
                    }
                })(),
                (function () {
                    if (xs.length) {
                        var t,
                            e = ys(xs);
                        try {
                            var r = function () {
                                var e = t.value;
                                e.parentNode.addEventListener("mouseover", function (t) {
                                    t.preventDefault();
                                    var r,
                                        i = ys(xs);
                                    try {
                                        for (i.s(); !(r = i.n()).done; ) {
                                            var n = r.value;
                                            n != e && Ms(n, !0);
                                        }
                                    } catch (t) {
                                        i.e(t);
                                    } finally {
                                        i.f();
                                    }
                                    Is(), Ms(e, !1);
                                }),
                                    e.parentNode.addEventListener("mouseout", function (t) {
                                        Ms(e, !0);
                                    });
                            };
                            for (e.s(); !(t = e.n()).done; ) r();
                        } catch (t) {
                            e.e(t);
                        } finally {
                            e.f();
                        }
                    }
                    if (Ss.length) {
                        var i,
                            n = ys(Ss);
                        try {
                            var s = function () {
                                var t = i.value;
                                t.addEventListener("mouseenter", function () {
                                    t.closest("[header-menu-sub-items-list]").classList.add(
                                        "header__menu-list-sub-col-items-list--sub-menu-active"
                                    );
                                    var e,
                                        r = ys(Ss);
                                    try {
                                        for (r.s(); !(e = r.n()).done; ) {
                                            var i = e.value;
                                            if (
                                                i.getAttribute("aria-expanded") &&
                                                "true" == i.getAttribute("aria-expanded") &&
                                                t != i
                                            ) {
                                                i.setAttribute("aria-expanded", !1);
                                                var n = document.querySelector(
                                                    "#".concat(i.getAttribute("aria-controls"))
                                                );
                                                n.setAttribute("aria-expanded", !1),
                                                    zi.to(n, { duration: 0.25, height: 0, autoAlpha: 0 }),
                                                    zi.set(n, { display: "none" });
                                            }
                                        }
                                    } catch (t) {
                                        r.e(t);
                                    } finally {
                                        r.f();
                                    }
                                    if (t.getAttribute("aria-expanded") && "false" == t.getAttribute("aria-expanded")) {
                                        t.setAttribute("aria-expanded", !0);
                                        var s = document.querySelector("#".concat(t.getAttribute("aria-controls")));
                                        s.setAttribute("aria-expanded", !0),
                                            zi.set(s, { display: "grid" }),
                                            zi.to(s, { duration: 0.25, height: "auto", autoAlpha: 1 });
                                    }
                                });
                            };
                            for (n.s(); !(i = n.n()).done; ) s();
                        } catch (t) {
                            n.e(t);
                        } finally {
                            n.f();
                        }
                    }
                    if (Cs.length) {
                        var a,
                            o = ys(Cs);
                        try {
                            var l = function () {
                                var t = a.value;
                                t.addEventListener("click", function (e) {
                                    e.preventDefault(),
                                        t.setAttribute("aria-expanded", !0),
                                        document
                                            .querySelector("#".concat(t.getAttribute("aria-controls")))
                                            .setAttribute("aria-expanded", !0);
                                });
                            };
                            for (o.s(); !(a = o.n()).done; ) l();
                        } catch (t) {
                            o.e(t);
                        } finally {
                            o.f();
                        }
                    }
                    if (As.length) {
                        var h,
                            p = ys(As);
                        try {
                            var c = function () {
                                var t = h.value;
                                t.addEventListener("click", function (e) {
                                    e.preventDefault(),
                                        t.setAttribute("aria-expanded", !0),
                                        document
                                            .querySelector("#".concat(t.getAttribute("aria-controls")))
                                            .setAttribute("aria-expanded", !0);
                                });
                            };
                            for (p.s(); !(h = p.n()).done; ) c();
                        } catch (t) {
                            p.e(t);
                        } finally {
                            p.f();
                        }
                    }
                    if (ks.length) {
                        var d,
                            u = ys(ks);
                        try {
                            var f = function () {
                                var t = d.value;
                                t.addEventListener("click", function () {
                                    document
                                        .querySelector("#".concat(t.getAttribute("aria-controls")))
                                        .setAttribute("aria-expanded", !1);
                                });
                            };
                            for (u.s(); !(d = u.n()).done; ) f();
                        } catch (t) {
                            u.e(t);
                        } finally {
                            u.f();
                        }
                    }
                })(),
                ws &&
                    (Es.addEventListener("click", function () {
                        var t = "true" === Es.getAttribute("aria-expanded");
                        Fs(t);
                    }),
                    Ts.addEventListener("click", function () {
                        var t = "true" === Es.getAttribute("aria-expanded");
                        Fs(t);
                    }),
                    ws.addEventListener("click", function () {
                        Fs(!0);
                    }),
                    Ps.addEventListener("click", function (t) {
                        t.stopPropagation();
                    })),
                (function () {
                    var t = document.querySelectorAll("[header-action-dropdown]");
                    if (t) {
                        var e,
                            r = ys(t);
                        try {
                            var i = function () {
                                var t = e.value;
                                t.addEventListener("click", function () {
                                    var e = JSON.parse(t.getAttribute("aria-expanded"));
                                    t.setAttribute("aria-expanded", !e),
                                        t.nextElementSibling.setAttribute("aria-expanded", !e);
                                });
                            };
                            for (r.s(); !(e = r.n()).done; ) i();
                        } catch (t) {
                            r.e(t);
                        } finally {
                            r.f();
                        }
                    }
                    window.addEventListener("click", function (e) {
                        var r,
                            i = ys(t);
                        try {
                            for (i.s(); !(r = i.n()).done; ) {
                                var n = r.value;
                                n.parentElement.contains(e.target) ||
                                    (n.setAttribute("aria-expanded", !1),
                                    n.nextElementSibling.setAttribute("aria-expanded", !1));
                            }
                        } catch (t) {
                            i.e(t);
                        } finally {
                            i.f();
                        }
                    });
                    var n = document.querySelectorAll("[trigger-rewards]");
                    if (n) {
                        var s,
                            a = ys(n);
                        try {
                            for (a.s(); !(s = a.n()).done; )
                                s.value.addEventListener("click", function () {
                                    document.querySelector("#open-sesame").click();
                                });
                        } catch (t) {
                            a.e(t);
                        } finally {
                            a.f();
                        }
                    }
                })(),
                window.addEventListener(
                    "scroll",
                    function () {
                        window.pageYOffset > 100
                            ? $s.parentNode.classList.add("header--scrolling")
                            : $s.parentNode.classList.remove("header--scrolling");
                    },
                    { passive: !0 }
                ),
                js && $s.parentNode.classList.add("header--light"),
                !Ws && $s.parentNode.classList.add("header--bg-white"),
                "/cart" == window.location.pathname && (window.location.href = "/?cart=true"),
                window.location.pathname.includes("/blogs/promotions/") && (window.location.href = "/blogs/promotions"),
                (function () {
                    var t = document.querySelector(".".concat(Rs, "__swiper"));
                    if (t) {
                        var e = new Fn(t, {
                                modules: [Vn, zn, Bn],
                                speed: 1e3,
                                touchEventsTarget: "container",
                                autoplay: { delay: 6e3 },
                                effect: "fade",
                                loop: !0,
                                fadeEffect: { crossFade: !0 },
                                pagination: { el: ".".concat(Rs, "__scrollbar"), type: "progressbar" },
                            }),
                            r = t.querySelector("[page-header-carousel-arrow-previous]"),
                            i = t.querySelector("[page-header-carousel-arrow-next]");
                        r.addEventListener("click", function () {
                            return e.slidePrev();
                        }),
                            i.addEventListener("click", function () {
                                return e.slideNext();
                            });
                    }
                    var n = document.querySelectorAll(".".concat(Os, "__swiper"));
                    n &&
                        n.forEach(function (t) {
                            return (function (t) {
                                var e = t.id;
                                new Fn("#".concat(e), {
                                    modules: [Bn, In],
                                    mousewheel: { forceToAxis: !0 },
                                    touchEventsTarget: "container",
                                    slidesPerView: 1.3,
                                    spaceBetween: 20,
                                    breakpoints: { 900: { slidesPerView: 3, spaceBetween: 50 } },
                                    pagination: { el: ".".concat(Os, "__scrollbar"), type: "progressbar" },
                                });
                            })(t);
                        });
                    var s = "blog-archive",
                        a = document.querySelector(".".concat(s, "__swiper"));
                    a &&
                        new Fn(a, {
                            modules: [Bn, In],
                            mousewheel: { forceToAxis: !0 },
                            touchEventsTarget: "container",
                            slidesPerView: 1.3,
                            spaceBetween: 20,
                            breakpoints: { 900: { slidesPerView: 3, spaceBetween: 50 } },
                            pagination: { el: ".".concat(s, "__scrollbar"), type: "progressbar" },
                        });
                    var o = document.querySelector(".".concat(zs, "__swiper"));
                    o &&
                        new Fn(o, {
                            modules: [Bn, In],
                            mousewheel: { forceToAxis: !0 },
                            touchEventsTarget: "container",
                            slidesPerView: 1.3,
                            spaceBetween: 20,
                            breakpoints: { 900: { slidesPerView: 4, spaceBetween: 40 } },
                            pagination: { el: ".".concat(zs, "__scrollbar"), type: "progressbar" },
                        });
                    var l = document.querySelector(".".concat(Gs, "__swiper"));
                    l &&
                        new Fn(l, {
                            modules: [Bn, In],
                            mousewheel: { forceToAxis: !0 },
                            touchEventsTarget: "container",
                            slidesPerView: 1,
                            spaceBetween: 40,
                            breakpoints: { 900: { slidesPerView: 4, spaceBetween: 40 } },
                            pagination: { el: ".".concat(Gs, "__bullets"), type: "bullets" },
                        });
                    var h = document.querySelectorAll(".".concat("m-table", "__swiper"));
                    h &&
                        h.forEach(function (t) {
                            return (function (t) {
                                var e = t.id;
                                new Fn("#".concat(e), {
                                    modules: [In, Rn],
                                    freeMode: !0,
                                    mousewheel: { forceToAxis: !1 },
                                    touchEventsTarget: "container",
                                    slidesPerView: 0.5,
                                    spaceBetween: 0,
                                    breakpoints: { 540: { slidesPerView: 1, spaceBetween: 10 } },
                                });
                            })(t);
                        });
                })(),
                (wa = Array.from(document.querySelectorAll(".has-reveal"))),
                (Pa = null),
                "IntersectionObserver" in window &&
                    ((Pa = new IntersectionObserver(
                        function (t, e) {
                            t.forEach(function (t) {
                                var e;
                                t.isIntersecting &&
                                    (e = t.target) &&
                                    (e.classList.remove("reveal-waiting"), e.classList.add("revealed"));
                            });
                        },
                        { root: null, rootMargin: "0px 0px -20% 0px" }
                    )),
                    wa.forEach(function (t) {
                        var e;
                        (e = t) && e.classList.add("reveal-waiting"), Pa.observe(t);
                    })),
                (function () {
                    var t = document.querySelectorAll(".m-instagram");
                    if (insta_token && t) {
                        var e =
                            "https://graph.instagram.com/me/media/?fields=media_url,permalink,media_type,thumbnail_url&access_token=" +
                            insta_token +
                            "&amp;count=5";
                        fetch(e)
                            .then(function (t) {
                                return t.json();
                            })
                            .then(function (e) {
                                e &&
                                    t &&
                                    t.forEach(function (t) {
                                        var r,
                                            i = t.querySelectorAll(".m-instagram__image");
                                        i.length &&
                                            (null == e ||
                                                null === (r = e.data) ||
                                                void 0 === r ||
                                                r.forEach(function (t, e) {
                                                    "VIDEO" == t.media_type
                                                        ? ((i[e].src = t.thumbnail_url), (i[e].style.display = "block"))
                                                        : ((i[e].src = t.media_url), (i[e].style.display = "block"));
                                                }));
                                    });
                            });
                    }
                })(),
                Ns.init(),
                Hs.init(),
                (Ta = document.querySelector(".header__announcement-bar-wrap--slider")) &&
                    new Fn(Ta, {
                        modules: [Vn, zn],
                        speed: 1e3,
                        loop: !0,
                        autoplay: { delay: parseInt(Ta.dataset.autoplay) },
                        effect: "fade",
                        fadeEffect: { crossFade: !0 },
                    }),
                hs.closest("form").addEventListener("submit", function (t) {
                    t.preventDefault(),
                        Hi(function () {
                            return hs.parentElement.submit();
                        });
                }),
                /*
                 * `input` rather than `keyup`, so autofill, predictive text, autocorrect and paste refresh the
                 * suggestions too. Fields run by the Alpha/Beta search (search-alpha.js) are left to it.
                 */
                hs.addEventListener("input", function (t) {
                    if (hs.closest("[search-alpha], .search-alpha-page-search")) return;
                    ds(hs, t.target.value);
                }),
                ps &&
                    ps.addEventListener("input", function (t) {
                        if (ps.closest("[search-alpha], .search-alpha-page-search")) return;
                        ds(ps, t.target.value);
                    }),
                os &&
                    (os.addEventListener("click", function () {
                        window.location.pathname.includes("/search")
                            ? window.scrollTo({ top: 0, behavior: "smooth" })
                            : "true" === os.getAttribute("aria-expanded")
                              ? us()
                              : os &&
                                (Ds(),
                                Is(),
                                as.parentNode.classList.add("header--desktop-menu-active"),
                                ms(),
                                os.setAttribute("aria-expanded", !0),
                                ls.setAttribute("aria-expanded", !0),
                                setTimeout(function () {
                                    return hs.focus();
                                }, 150));
                    }),
                    cs.addEventListener("click", function () {
                        us();
                    })),
                fs.addEventListener("click", function () {
                    us(), Ds();
                }),
                (function () {
                    Gn.addEventListener("click", function () {
                        $n();
                    });
                    if (Hn) {
                        Hn.addEventListener("click", function () {
                            jn();
                        });
                    }
                    if (Nn) {
                        Nn.addEventListener("click", function () {
                            jn();
                        });
                        qn.addEventListener("click", function (t) {
                            t.stopPropagation();
                        });
                    }
                    var t = new URLSearchParams(window.location.search);
                    Object.fromEntries(t.entries()).cart && $n();
                })(),
                Wn(),
                (function () {
                    if (Zn) {
                        var t = Zn.querySelector("[product-single-media-count]"),
                            e = Zn.querySelector("[product-single-media-progressbar]"),
                            r = new Fn(Zn, {
                                modules: [zn, Bn, In],
                                speed: 1e3,
                                effect: "fade",
                                fadeEffect: { crossFade: !0 },
                                loop: !0,
                                pagination: { el: e, type: "progressbar" },
                                touchEventsTarget: "container",
                            }),
                            i = Zn.querySelector("[product-single-media-arrow-previous]"),
                            n = Zn.querySelector("[product-single-media-arrow-next]");
                        i.addEventListener("click", function () {
                            r.slidePrev();
                        }),
                            n.addEventListener("click", function () {
                                r.slideNext();
                            }),
                            r.on("slideChange", function () {
                                t.textContent = r.realIndex + 1;
                            });
                    }
                })(),
                Kn &&
                    Kn.addEventListener("click", function () {
                        var t,
                            e = Xn(
                                document.querySelectorAll(
                                    "[aria-controls=".concat(Kn.getAttribute("aria-controls"), "]")
                                )
                            );
                        try {
                            for (e.s(); !(t = e.n()).done; ) t.value.setAttribute("aria-expanded", !0);
                        } catch (t) {
                            e.e(t);
                        } finally {
                            e.f();
                        }
                        var r = document.querySelector("#".concat(Kn.getAttribute("aria-controls"))),
                            i = r.getBoundingClientRect();
                        r.setAttribute("aria-expanded", !0),
                            zi.to(r, { duration: 0.25, height: "auto", autoAlpha: 1 }),
                            window.scroll({ top: i.top + window.scrollY - 130, behavior: "smooth" });
                    }),
                Jn &&
                    (es.addEventListener("click", function () {
                        var t = parseInt(ts.value),
                            e = parseInt(ts.dataset.max);
                        t < e && ((ts.value = t + 1), (rs.disabled = !1)), ts.value == e && (es.disabled = !0);
                    }),
                    rs.addEventListener("click", function () {
                        var t = parseInt(ts.value);
                        (es.disabled = !1), t > 0 && (ts.value = t - 1), 1 == ts.value && (rs.disabled = !0);
                    })),
                is &&
                    (function () {
                        var t = document.querySelector("[product-single-form-variants]"),
                            e = JSON.parse(t.innerHTML),
                            r = document.querySelectorAll("[product-single-form-price]"),
                            i = document.querySelector("[product-single-form-variant-id]"),
                            n = document.querySelectorAll("[product-single-form-option]");
                        // console.log("product-single-form-variant-id",i);
                        if (n.length) {
                            var s,
                                a = Xn(n);
                            try {
                                for (a.s(); !(s = a.n()).done; )
                                    s.value.addEventListener("change", function () {
                                        ns(i, r, is, n, e);
                                    });
                            } catch (t) {
                                a.e(t);
                            } finally {
                                a.f();
                            }
                        }
                        var o = is.closest("form");
                        o.addEventListener("submit", function (t) {
                            t.preventDefault();
                            var e = o.querySelectorAll("[name^=properties]");
                            ss(i.value, parseInt(ts.value), is, e);
                        });
                    })(),
                Qn(),
                (function () {
                    var t = document.querySelectorAll("[product-single-reviews-badge-anchor]");
                    if (t) {
                        var e,
                            r = Xn(t);
                        try {
                            for (r.s(); !(e = r.n()).done; )
                                e.value.addEventListener("click", function () {
                                    var t = document.querySelector(".jdgm-rev-widg__header");
                                    const e = window.innerWidth <= 991;
                                    let r = e ? 352 : 232;
                                    document.querySelector(".jdgm-histogram") || (r = e ? 219 : 182),
                                        window.scrollTo({
                                            top:
                                                t.closest(".shopify-section").offsetTop -
                                                document.querySelector("[header-wrap]").offsetHeight +
                                                r,
                                            behavior: "smooth",
                                        }),
                                        setTimeout(() => {
                                            const t = document.querySelector(".jdgm-write-rev-link");
                                            t &&
                                                (t.classList.add("close-form-btn"),
                                                t.setAttribute("aria-expanded", "true"),
                                                (t.textContent = "Cancel review"));
                                            const e = document.querySelector(".jdgm-form-wrapper");
                                            e && (e.style.display = "flex");
                                        }, 900);
                                });
                        } catch (t) {
                            r.e(t);
                        } finally {
                            r.f();
                        }
                    }
                    var i = document.querySelector(".product-single__details-reviews");
                    i &&
                        new MutationObserver(function (t, e) {
                            var r,
                                n = Xn(t);
                            try {
                                for (n.s(); !(r = n.n()).done; )
                                    "childList" === r.value.type &&
                                        ("0.0" == i.querySelector("[data-rating]").dataset.rating &&
                                            setTimeout(function () {
                                                document.querySelector(".spr-summary-actions-newreview").click();
                                            }, 250),
                                        e.disconnect());
                            } catch (t) {
                                n.e(t);
                            } finally {
                                n.f();
                            }
                        }).observe(i, { attributes: !0, childList: !0, subtree: !0 });
                })(),
                (function () {
                    var t = document.querySelectorAll("[product-single-afterpays-item]");
                    if (t) {
                        var e,
                            r = Xn(t);
                        try {
                            var i = function () {
                                var t = e.value;
                                t.addEventListener("click", function () {
                                    if ("afterpay" == t.dataset.type) {
                                        var e = document.querySelector("afterpay-placement");
                                        e && e.shadowRoot.querySelector(".afterpay-logo").click();
                                    }
                                    if ("klarna" == t.dataset.type) {
                                        var r = document.querySelector("klarna-placement div");
                                        r && r.shadowRoot.querySelector(".link").click();
                                    }
                                });
                            };
                            for (r.s(); !(e = r.n()).done; ) i();
                        } catch (t) {
                            r.e(t);
                        } finally {
                            r.f();
                        }
                    }
                })(),
                (function () {
                    if (Js) {
                        var t,
                            e = Zs(Js);
                        try {
                            var r = function () {
                                var e = t.value;
                                if (e.dataset.url)
                                    fetch(e.dataset.url)
                                        .then(function (t) {
                                            return t.text();
                                        })
                                        .then(function (t) {
                                            var r = document.createElement("div");
                                            r.innerHTML = t;
                                            var i = r.querySelector("[store-carousel-wrap]");
                                            i && i.innerHTML.trim().length && (e.innerHTML = i.innerHTML), Qn();
                                            var n,
                                                s = Zs(e.querySelectorAll("[store-carousel-slider]"));
                                            try {
                                                for (s.s(); !(n = s.n()).done; ) {
                                                    var a = n.value;
                                                    Qs(a);
                                                }
                                            } catch (t) {
                                                s.e(t);
                                            } finally {
                                                s.f();
                                            }
                                        })
                                        .catch(function (t) {
                                            console.error(t);
                                        });
                                else {
                                    var r,
                                        i = Zs(e.querySelectorAll("[store-carousel-slider]"));
                                    try {
                                        for (i.s(); !(r = i.n()).done; ) {
                                            var n = r.value;
                                            Qs(n);
                                        }
                                    } catch (t) {
                                        i.e(t);
                                    } finally {
                                        i.f();
                                    }
                                }
                            };
                            for (e.s(); !(t = e.n()).done; ) r();
                        } catch (t) {
                            e.e(t);
                        } finally {
                            e.f();
                        }
                    }
                })(),
                ta && Xs().loadAnimation({ container: ta, renderer: "svg", loop: !0, autoplay: !0, path: loaderPath }),
                (function () {
                    var t = document.querySelectorAll("[collection-listing-banner-more-excerpt-btn]");
                    if (t) {
                        var e,
                            r = ea(t);
                        try {
                            var i = function () {
                                var t = e.value;
                                t.addEventListener("click", function () {
                                    var e = JSON.parse(t.getAttribute("aria-expanded")),
                                        r = t.getAttribute("aria-controls"),
                                        i = document.querySelector("#".concat(r));
                                    if (
                                        (t.setAttribute("aria-expanded", !e),
                                        i.setAttribute("aria-expanded", !e),
                                        r.includes("more"))
                                    ) {
                                        var n = document.querySelector("[aria-controls='Collection-less-details']"),
                                            s = n.getAttribute("aria-controls"),
                                            a = document.querySelector("#".concat(s));
                                        n.setAttribute("aria-expanded", !0), a.setAttribute("aria-expanded", !0);
                                    }
                                    if (r.includes("less")) {
                                        var o = document.querySelector("[aria-controls='Collection-more-details']"),
                                            l = o.getAttribute("aria-controls"),
                                            h = document.querySelector("#".concat(l));
                                        o.setAttribute("aria-expanded", !0), h.setAttribute("aria-expanded", !0);
                                    }
                                });
                            };
                            for (r.s(); !(e = r.n()).done; ) i();
                        } catch (t) {
                            r.e(t);
                        } finally {
                            r.f();
                        }
                    }
                })(),
                (function () {
                    var t = document.querySelectorAll("[collection-sortings-toggle]");
                    if (t) {
                        var e,
                            r = ea(t);
                        try {
                            var i = function () {
                                var r = e.value;
                                "sorting" == r.getAttribute("aria-controls") &&
                                    ((function (t) {
                                        var e = document.querySelector("[collection-sortings-sort-close]"),
                                            r = document.querySelectorAll("[collection-sortings-sort-option]");
                                        if (r) {
                                            e.addEventListener("click", function () {
                                                na(t);
                                            });
                                            var i,
                                                n = ea(r);
                                            try {
                                                var s = function () {
                                                    var e = i.value;
                                                    e.addEventListener("click", function () {
                                                        (fbcFiltering.currentSort.value = e.dataset.value), sa(), na(t);
                                                        var i,
                                                            n = ea(r);
                                                        try {
                                                            for (n.s(); !(i = n.n()).done; )
                                                                i.value.classList.remove(
                                                                    "collection-listing__sortings-sort-option-btn--active"
                                                                );
                                                        } catch (t) {
                                                            n.e(t);
                                                        } finally {
                                                            n.f();
                                                        }
                                                        e.classList.add(
                                                            "collection-listing__sortings-sort-option-btn--active"
                                                        );
                                                    });
                                                };
                                                for (n.s(); !(i = n.n()).done; ) s();
                                            } catch (t) {
                                                n.e(t);
                                            } finally {
                                                n.f();
                                            }
                                        }
                                    })(r),
                                    window.addEventListener("click", function (t) {
                                        r.parentNode.contains(t.target) || na(r, !1);
                                    })),
                                    "filtering" == r.getAttribute("aria-controls") &&
                                        (function (t) {
                                            var e = document.querySelector("[collection-sortings-filter-container]"),
                                                r = document.querySelector("[collection-sortings-filter-wrap]"),
                                                i = document.querySelector("[collection-sortings-filter-close]"),
                                                n = document.querySelectorAll("[collection-sortings-filter-option]");
                                            if (n) {
                                                e.addEventListener("click", function () {
                                                    na(t);
                                                }),
                                                    r.addEventListener("click", function (t) {
                                                        t.stopPropagation();
                                                    }),
                                                    i.addEventListener("click", function () {
                                                        na(t);
                                                    });
                                                var s,
                                                    a = ea(n);
                                                try {
                                                    var o = function () {
                                                        var t = s.value;
                                                        t.addEventListener("click", function () {
                                                            var e = t.closest("[collection-sortings-filter-list-item]"),
                                                                r = e.querySelector(
                                                                    "[collection-sortings-filter-active-values]"
                                                                ),
                                                                i = r.textContent.trim().split(", "),
                                                                n = t.dataset.value,
                                                                s = t.dataset.filter,
                                                                a = t.dataset.label,
                                                                o = t.dataset.gte,
                                                                l = t.dataset.lte;
                                                            if (
                                                                t.classList.contains(
                                                                    "collection-listing__sortings-filtering-option-btn--active"
                                                                )
                                                            ) {
                                                                var h;
                                                                void 0 !==
                                                                (null === (h = fbcFiltering.currentFilters[s]) ||
                                                                void 0 === h
                                                                    ? void 0
                                                                    : h.tags)
                                                                    ? ((fbcFiltering.currentFilters[s].tags =
                                                                          fbcFiltering.currentFilters[s].tags.filter(
                                                                              function (t) {
                                                                                  return t != n;
                                                                              }
                                                                          )),
                                                                      (i = i.filter(function (t) {
                                                                          return t != a;
                                                                      })))
                                                                    : ((fbcFiltering.currentFilters[s].range = {}),
                                                                      (i = [])),
                                                                    t.classList.remove(
                                                                        "collection-listing__sortings-filtering-option-btn--active"
                                                                    );
                                                            } else {
                                                                var p;
                                                                if (
                                                                    void 0 !==
                                                                    (null === (p = fbcFiltering.currentFilters[s]) ||
                                                                    void 0 === p
                                                                        ? void 0
                                                                        : p.tags)
                                                                )
                                                                    fbcFiltering.currentFilters[s].tags.push(n),
                                                                        i.push(a);
                                                                else {
                                                                    (fbcFiltering.currentFilters[s].range.gte = o),
                                                                        (fbcFiltering.currentFilters[s].range.lte = l),
                                                                        (i = [n]);
                                                                    var c,
                                                                        d = ea(
                                                                            e.querySelectorAll(
                                                                                "[collection-sortings-filter-option]"
                                                                            )
                                                                        );
                                                                    try {
                                                                        for (d.s(); !(c = d.n()).done; )
                                                                            c.value.classList.remove(
                                                                                "collection-listing__sortings-filtering-option-btn--active"
                                                                            );
                                                                    } catch (t) {
                                                                        d.e(t);
                                                                    } finally {
                                                                        d.f();
                                                                    }
                                                                }
                                                                t.classList.add(
                                                                    "collection-listing__sortings-filtering-option-btn--active"
                                                                );
                                                            }
                                                            r &&
                                                                (0 == i.length
                                                                    ? (r.textContent = r.dataset.defaultText)
                                                                    : (r.textContent = i
                                                                          .join(", ")
                                                                          .replace(r.dataset.defaultText + ", ", ""))),
                                                                sa();
                                                        });
                                                    };
                                                    for (a.s(); !(s = a.n()).done; ) o();
                                                } catch (t) {
                                                    a.e(t);
                                                } finally {
                                                    a.f();
                                                }
                                            }
                                        })(r),
                                    r.addEventListener("click", function () {
                                        var e,
                                            i = ea(t);
                                        try {
                                            for (i.s(); !(e = i.n()).done; ) {
                                                var n = e.value;
                                                n != r && na(n, !1);
                                            }
                                        } catch (t) {
                                            i.e(t);
                                        } finally {
                                            i.f();
                                        }
                                        na(r);
                                    });
                            };
                            for (r.s(); !(e = r.n()).done; ) i();
                        } catch (t) {
                            r.e(t);
                        } finally {
                            r.f();
                        }
                    }
                })(),
                (function () {
                    var t = document.querySelectorAll("[collection-sortings-filter-item]");
                    if (t.length) {
                        var e,
                            r = ea(t);
                        try {
                            var i = function () {
                                var t = e.value;
                                t.addEventListener("click", function () {
                                    var e = JSON.parse(t.getAttribute("aria-expanded")),
                                        r = t.getAttribute("aria-controls"),
                                        i = document.querySelector("#".concat(r));
                                    t.setAttribute("aria-expanded", !e),
                                        i.setAttribute("aria-expanded", !e),
                                        t.parentNode.classList.contains(
                                            "collection-listing__sortings-filtering-item--active"
                                        )
                                            ? (t.parentNode.classList.remove(
                                                  "collection-listing__sortings-filtering-item--active"
                                              ),
                                              zi.to(i, { duration: 0.25, height: 0, opacity: 0 }))
                                            : (t.parentNode.classList.add(
                                                  "collection-listing__sortings-filtering-item--active"
                                              ),
                                              zi.to(i, { duration: 0.25, height: "auto", opacity: 1 }));
                                });
                            };
                            for (r.s(); !(e = r.n()).done; ) i();
                        } catch (t) {
                            r.e(t);
                        } finally {
                            r.f();
                        }
                    }
                })(),
                (function () {
                    if (oa.length) {
                        var t,
                            e = (function (t, e) {
                                var r = ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
                                if (!r) {
                                    if (
                                        Array.isArray(t) ||
                                        (r = (function (t, e) {
                                            if (t) {
                                                if ("string" == typeof t) return aa(t, e);
                                                var r = Object.prototype.toString.call(t).slice(8, -1);
                                                return (
                                                    "Object" === r && t.constructor && (r = t.constructor.name),
                                                    "Map" === r || "Set" === r
                                                        ? Array.from(t)
                                                        : "Arguments" === r ||
                                                            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                                                          ? aa(t, e)
                                                          : void 0
                                                );
                                            }
                                        })(t))
                                    ) {
                                        r && (t = r);
                                        var i = 0,
                                            n = function () {};
                                        return {
                                            s: n,
                                            n: function () {
                                                return i >= t.length ? { done: !0 } : { done: !1, value: t[i++] };
                                            },
                                            e: function (t) {
                                                throw t;
                                            },
                                            f: n,
                                        };
                                    }
                                    throw new TypeError(
                                        "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                                    );
                                }
                                var s,
                                    a = !0,
                                    o = !1;
                                return {
                                    s: function () {
                                        r = r.call(t);
                                    },
                                    n: function () {
                                        var t = r.next();
                                        return (a = t.done), t;
                                    },
                                    e: function (t) {
                                        (o = !0), (s = t);
                                    },
                                    f: function () {
                                        try {
                                            a || null == r.return || r.return();
                                        } finally {
                                            if (o) throw s;
                                        }
                                    },
                                };
                            })(oa);
                        try {
                            for (e.s(); !(t = e.n()).done; ) {
                                var r = t.value,
                                    i = r.querySelector("[feat-product-progressbar]");
                                new Fn(r, {
                                    modules: [Bn, In],
                                    speed: 1e3,
                                    effect: "slide",
                                    slidesPerView: parseInt(r.dataset.items),
                                    spaceBetween: 20,
                                    breakpoints: { 900: { spaceBetween: 50 } },
                                    pagination: { el: i, type: "progressbar" },
                                    mousewheel: { forceToAxis: !0 },
                                    touchEventsTarget: "container",
                                });
                            }
                        } catch (t) {
                            e.e(t);
                        } finally {
                            e.f();
                        }
                    }
                })(),
                (function () {
                    var t = document.querySelector(".login-register__input--date");
                    if (t) {
                        new Sa(t, { date: !0, delimiter: "/", datePattern: ["d", "m", "Y"] });
                        var e = document.querySelector(".login-register__input--date-val");
                        t.addEventListener("change", function () {
                            var r = t.value.split("/"),
                                i = new Date(+r[2], r[1] - 1, +r[0]),
                                n = String(i.getDate()).padStart(2, "0"),
                                s = String(i.getMonth() + 1).padStart(2, "0"),
                                a = i.getFullYear() + "/" + s + "/" + n;
                            e.value = a;
                        });
                    }
                })(),
                (function () {
                    var t = document.querySelectorAll("[data-recover-toggle]");
                    if (t) {
                        var e,
                            r = (function (t, e) {
                                var r = ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
                                if (!r) {
                                    if (
                                        Array.isArray(t) ||
                                        (r = (function (t, e) {
                                            if (t) {
                                                if ("string" == typeof t) return Ea(t, e);
                                                var r = Object.prototype.toString.call(t).slice(8, -1);
                                                return (
                                                    "Object" === r && t.constructor && (r = t.constructor.name),
                                                    "Map" === r || "Set" === r
                                                        ? Array.from(t)
                                                        : "Arguments" === r ||
                                                            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                                                          ? Ea(t, e)
                                                          : void 0
                                                );
                                            }
                                        })(t))
                                    ) {
                                        r && (t = r);
                                        var i = 0,
                                            n = function () {};
                                        return {
                                            s: n,
                                            n: function () {
                                                return i >= t.length ? { done: !0 } : { done: !1, value: t[i++] };
                                            },
                                            e: function (t) {
                                                throw t;
                                            },
                                            f: n,
                                        };
                                    }
                                    throw new TypeError(
                                        "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                                    );
                                }
                                var s,
                                    a = !0,
                                    o = !1;
                                return {
                                    s: function () {
                                        r = r.call(t);
                                    },
                                    n: function () {
                                        var t = r.next();
                                        return (a = t.done), t;
                                    },
                                    e: function (t) {
                                        (o = !0), (s = t);
                                    },
                                    f: function () {
                                        try {
                                            a || null == r.return || r.return();
                                        } finally {
                                            if (o) throw s;
                                        }
                                    },
                                };
                            })(t);
                        try {
                            for (r.s(); !(e = r.n()).done; )
                                e.value.addEventListener("click", function () {
                                    var t = document.querySelector("[data-login-login]"),
                                        e = document.querySelector("[data-login-create]"),
                                        r = document.querySelector("[data-login-reset]");
                                    t.classList.toggle("login-register__form-wrapper--hidden"),
                                        e.classList.toggle("login-register__form-wrapper--hidden"),
                                        r.classList.toggle("login-register__form-wrapper--hidden");
                                });
                        } catch (t) {
                            r.e(t);
                        } finally {
                            r.f();
                        }
                    }
                })(),
                (window.onpageshow = function (t) {
                    t.persisted && window.location.reload();
                });
        })();
    })(),
    "/cart" === window.location.pathname)
) {
    // const t = document.referrer || "/",
    //     e = t.includes("cart=true"),
    //     r = e ? t : t.includes("?") ? `${t}&cart=true` : `${t}?cart=true`;
    // window.location.href = r;
}
